/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 371);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(30);
var hide = __webpack_require__(19);
var redefine = __webpack_require__(20);
var ctx = __webpack_require__(31);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aggregate_errors_js__ = __webpack_require__(617);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_0__aggregate_errors_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_js__ = __webpack_require__(282);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_1__browser_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_1__browser_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_1__browser_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_1__browser_js__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dsn_js__ = __webpack_require__(283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_2__dsn_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_2__dsn_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_2__dsn_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_js__ = __webpack_require__(284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__error_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__worldwide_js__ = __webpack_require__(18);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__worldwide_js__["a"]; });
/* unused harmony reexport getGlobalObject */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_4__worldwide_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__instrument_index_js__ = __webpack_require__(618);
/* unused harmony reexport addInstrumentationHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__is_js__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["b"]; });
/* unused harmony reexport isElement */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["m"]; });
/* unused harmony reexport isSyntheticEvent */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_6__is_js__["o"]; });
/* unused harmony reexport isVueViewModel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isBrowser_js__ = __webpack_require__(619);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_7__isBrowser_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logger_js__ = __webpack_require__(44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__logger_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_8__logger_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_8__logger_js__["c"]; });
/* unused harmony reexport originalConsoleMethods */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__memo_js__ = __webpack_require__(289);
/* unused harmony reexport memoBuilder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__misc_js__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__misc_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__misc_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__misc_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_10__misc_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_10__misc_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_10__misc_js__["f"]; });
/* unused harmony reexport parseSemver */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return __WEBPACK_IMPORTED_MODULE_10__misc_js__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node_js__ = __webpack_require__(287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_11__node_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_11__node_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_11__node_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__normalize_js__ = __webpack_require__(132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_12__normalize_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_12__normalize_js__["b"]; });
/* unused harmony reexport normalizeUrlToBase */
/* unused harmony reexport walk */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__object_js__ = __webpack_require__(36);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_13__object_js__["a"]; });
/* unused harmony reexport convertToPlainObject */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_13__object_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_13__object_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_13__object_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_13__object_js__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_13__object_js__["g"]; });
/* unused harmony reexport objectify */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return __WEBPACK_IMPORTED_MODULE_13__object_js__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__path_js__ = __webpack_require__(621);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_14__path_js__["a"]; });
/* unused harmony reexport dirname */
/* unused harmony reexport isAbsolute */
/* unused harmony reexport join */
/* unused harmony reexport normalizePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return __WEBPACK_IMPORTED_MODULE_14__path_js__["b"]; });
/* unused harmony reexport resolve */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__promisebuffer_js__ = __webpack_require__(622);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_15__promisebuffer_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__requestdata_js__ = __webpack_require__(623);
/* unused harmony reexport DEFAULT_USER_INCLUDES */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_16__requestdata_js__["a"]; });
/* unused harmony reexport addRequestDataToTransaction */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_16__requestdata_js__["b"]; });
/* unused harmony reexport extractRequestData */
/* unused harmony reexport winterCGHeadersToDict */
/* unused harmony reexport winterCGRequestToRequestData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__severity_js__ = __webpack_require__(625);
/* unused harmony reexport severityFromString */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return __WEBPACK_IMPORTED_MODULE_17__severity_js__["a"]; });
/* unused harmony reexport validSeverityLevels */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__stacktrace_js__ = __webpack_require__(185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_18__stacktrace_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_18__stacktrace_js__["b"]; });
/* unused harmony reexport nodeStackLineParser */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return __WEBPACK_IMPORTED_MODULE_18__stacktrace_js__["c"]; });
/* unused harmony reexport stripSentryFramesAndReverse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__string_js__ = __webpack_require__(129);
/* unused harmony reexport isMatchingPattern */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return __WEBPACK_IMPORTED_MODULE_19__string_js__["a"]; });
/* unused harmony reexport snipLine */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return __WEBPACK_IMPORTED_MODULE_19__string_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return __WEBPACK_IMPORTED_MODULE_19__string_js__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__supports_js__ = __webpack_require__(285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_20__supports_js__["a"]; });
/* unused harmony reexport supportsDOMError */
/* unused harmony reexport supportsDOMException */
/* unused harmony reexport supportsErrorEvent */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return __WEBPACK_IMPORTED_MODULE_20__supports_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return __WEBPACK_IMPORTED_MODULE_20__supports_js__["c"]; });
/* unused harmony reexport supportsReferrerPolicy */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return __WEBPACK_IMPORTED_MODULE_20__supports_js__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__syncpromise_js__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_21__syncpromise_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return __WEBPACK_IMPORTED_MODULE_21__syncpromise_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return __WEBPACK_IMPORTED_MODULE_21__syncpromise_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__time_js__ = __webpack_require__(292);
/* unused harmony reexport _browserPerformanceTimeOriginMode */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_22__time_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_22__time_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return __WEBPACK_IMPORTED_MODULE_22__time_js__["c"]; });
/* unused harmony reexport timestampWithMs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__tracing_js__ = __webpack_require__(626);
/* unused harmony reexport TRACEPARENT_REGEXP */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_23__tracing_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_23__tracing_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_23__tracing_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return __WEBPACK_IMPORTED_MODULE_23__tracing_js__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__env_js__ = __webpack_require__(288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_24__env_js__["a"]; });
/* unused harmony reexport isBrowserBundle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__envelope_js__ = __webpack_require__(294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_25__envelope_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_25__envelope_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_25__envelope_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_25__envelope_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_25__envelope_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_25__envelope_js__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_25__envelope_js__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_25__envelope_js__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_25__envelope_js__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return __WEBPACK_IMPORTED_MODULE_25__envelope_js__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__clientreport_js__ = __webpack_require__(627);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_26__clientreport_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ratelimit_js__ = __webpack_require__(628);
/* unused harmony reexport DEFAULT_RETRY_AFTER */
/* unused harmony reexport disabledUntil */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_27__ratelimit_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_27__ratelimit_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return __WEBPACK_IMPORTED_MODULE_27__ratelimit_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__baggage_js__ = __webpack_require__(293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_28__baggage_js__["a"]; });
/* unused harmony reexport MAX_BAGGAGE_STRING_LENGTH */
/* unused harmony reexport SENTRY_BAGGAGE_KEY_PREFIX */
/* unused harmony reexport SENTRY_BAGGAGE_KEY_PREFIX_REGEX */
/* unused harmony reexport baggageHeaderToDynamicSamplingContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_28__baggage_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__url_js__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_29__url_js__["a"]; });
/* unused harmony reexport getSanitizedUrlString */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_29__url_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return __WEBPACK_IMPORTED_MODULE_29__url_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__userIntegrations_js__ = __webpack_require__(629);
/* unused harmony reexport addOrUpdateIntegration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__cache_js__ = __webpack_require__(630);
/* unused harmony reexport makeFifoCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__eventbuilder_js__ = __webpack_require__(631);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_32__eventbuilder_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_32__eventbuilder_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_32__eventbuilder_js__["c"]; });
/* unused harmony reexport parseStackFrames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__anr_js__ = __webpack_require__(632);
/* unused harmony reexport callFrameToStackFrame */
/* unused harmony reexport watchdogTimer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__lru_js__ = __webpack_require__(633);
/* unused harmony reexport LRUMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__buildPolyfills_asyncNullishCoalesce_js__ = __webpack_require__(634);
/* unused harmony reexport _asyncNullishCoalesce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__buildPolyfills_asyncOptionalChain_js__ = __webpack_require__(296);
/* unused harmony reexport _asyncOptionalChain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__buildPolyfills_asyncOptionalChainDelete_js__ = __webpack_require__(635);
/* unused harmony reexport _asyncOptionalChainDelete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__buildPolyfills_nullishCoalesce_js__ = __webpack_require__(295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_38__buildPolyfills_nullishCoalesce_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__buildPolyfills_optionalChain_js__ = __webpack_require__(297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_39__buildPolyfills_optionalChain_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__buildPolyfills_optionalChainDelete_js__ = __webpack_require__(636);
/* unused harmony reexport _optionalChainDelete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__instrument_console_js__ = __webpack_require__(184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_41__instrument_console_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__instrument_dom_js__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_42__instrument_dom_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__instrument_xhr_js__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_43__instrument_xhr_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_43__instrument_xhr_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__instrument_fetch_js__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_44__instrument_fetch_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__instrument_history_js__ = __webpack_require__(190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_45__instrument_history_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__instrument_globalError_js__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_46__instrument_globalError_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__instrument_globalUnhandledRejection_js__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_47__instrument_globalUnhandledRejection_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__instrument_handlers_js__ = __webpack_require__(57);
/* unused harmony reexport resetInstrumentationHandlers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__node_stack_trace_js__ = __webpack_require__(130);
/* unused harmony reexport filenameIsInApp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__vendor_escapeStringForRegex_js__ = __webpack_require__(637);
/* unused harmony reexport escapeStringForRegex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__vendor_supportsHistory_js__ = __webpack_require__(286);
/* unused harmony reexport supportsHistory */


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(580);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Integrations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracing_hubextensions_js__ = __webpack_require__(281);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_0__tracing_hubextensions_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_0__tracing_hubextensions_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracing_idletransaction_js__ = __webpack_require__(298);
/* unused harmony reexport IdleTransaction */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__tracing_idletransaction_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracing_span_js__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__tracing_span_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracing_transaction_js__ = __webpack_require__(202);
/* unused harmony reexport Transaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracing_utils_js__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_4__tracing_utils_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_4__tracing_utils_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracing_spanstatus_js__ = __webpack_require__(104);
/* unused harmony reexport SpanStatus */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_5__tracing_spanstatus_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_5__tracing_spanstatus_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_5__tracing_spanstatus_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tracing_trace_js__ = __webpack_require__(200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_6__tracing_trace_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_6__tracing_trace_js__["b"]; });
/* unused harmony reexport startActiveSpan */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_6__tracing_trace_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_6__tracing_trace_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_6__tracing_trace_js__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_6__tracing_trace_js__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tracing_dynamicSamplingContext_js__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_7__tracing_dynamicSamplingContext_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_7__tracing_dynamicSamplingContext_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tracing_measurement_js__ = __webpack_require__(638);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_8__tracing_measurement_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tracing_sampling_js__ = __webpack_require__(300);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_9__tracing_sampling_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__semanticAttributes_js__ = __webpack_require__(135);
/* unused harmony reexport SEMANTIC_ATTRIBUTE_PROFILE_ID */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_10__semanticAttributes_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__semanticAttributes_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__semanticAttributes_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__semanticAttributes_js__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__envelope_js__ = __webpack_require__(301);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_11__envelope_js__["a"]; });
/* unused harmony reexport createSessionEnvelope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__exports_js__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["a"]; });
/* unused harmony reexport captureCheckIn */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["w"]; });
/* unused harmony reexport withMonitor */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_js__["x"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hub_js__ = __webpack_require__(50);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_13__hub_js__["a"]; });
/* unused harmony reexport ensureHubOnCarrier */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_13__hub_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_13__hub_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_13__hub_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_13__hub_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_13__hub_js__["f"]; });
/* unused harmony reexport runWithAsyncContext */
/* unused harmony reexport setAsyncContextStrategy */
/* unused harmony reexport setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__session_js__ = __webpack_require__(102);
/* unused harmony reexport closeSession */
/* unused harmony reexport makeSession */
/* unused harmony reexport updateSession */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__sessionflusher_js__ = __webpack_require__(302);
/* unused harmony reexport SessionFlusher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__scope_js__ = __webpack_require__(193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_16__scope_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_16__scope_js__["b"]; });
/* unused harmony reexport setGlobalScope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__eventProcessors_js__ = __webpack_require__(133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_17__eventProcessors_js__["a"]; });
/* unused harmony reexport notifyEventProcessors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_js__ = __webpack_require__(203);
/* unused harmony reexport getEnvelopeEndpointWithUrlEncodedAuth */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_18__api_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__baseclient_js__ = __webpack_require__(303);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_19__baseclient_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_19__baseclient_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__server_runtime_client_js__ = __webpack_require__(640);
/* unused harmony reexport ServerRuntimeClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__sdk_js__ = __webpack_require__(642);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_21__sdk_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_21__sdk_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__transports_base_js__ = __webpack_require__(643);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_22__transports_base_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__transports_offline_js__ = __webpack_require__(644);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_23__transports_offline_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__transports_multiplexed_js__ = __webpack_require__(645);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_24__transports_multiplexed_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__version_js__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_25__version_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__integration_js__ = __webpack_require__(58);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_26__integration_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_26__integration_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_26__integration_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_26__integration_js__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_applyScopeDataToEvent_js__ = __webpack_require__(194);
/* unused harmony reexport applyScopeDataToEvent */
/* unused harmony reexport mergeScopeData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_prepareEvent_js__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_28__utils_prepareEvent_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__checkin_js__ = __webpack_require__(304);
/* unused harmony reexport createCheckInEnvelope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__span_js__ = __webpack_require__(646);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_30__span_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_hasTracingEnabled_js__ = __webpack_require__(201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_31__utils_hasTracingEnabled_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_isSentryRequestUrl_js__ = __webpack_require__(647);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_32__utils_isSentryRequestUrl_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_handleCallbackErrors_js__ = __webpack_require__(299);
/* unused harmony reexport handleCallbackErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_parameterize_js__ = __webpack_require__(648);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_34__utils_parameterize_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_spanUtils_js__ = __webpack_require__(23);
/* unused harmony reexport spanIsSampled */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_35__utils_spanUtils_js__["e"]; });
/* unused harmony reexport spanToTraceContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_35__utils_spanUtils_js__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__utils_getRootSpan_js__ = __webpack_require__(103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_36__utils_getRootSpan_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__utils_sdkMetadata_js__ = __webpack_require__(649);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_37__utils_sdkMetadata_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__constants_js__ = __webpack_require__(101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_38__constants_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__integrations_metadata_js__ = __webpack_require__(650);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_39__integrations_metadata_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_39__integrations_metadata_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__integrations_requestdata_js__ = __webpack_require__(652);
/* unused harmony reexport RequestData */
/* unused harmony reexport requestDataIntegration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__integrations_inboundfilters_js__ = __webpack_require__(306);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_41__integrations_inboundfilters_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_41__integrations_inboundfilters_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__integrations_functiontostring_js__ = __webpack_require__(307);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_42__integrations_functiontostring_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_42__integrations_functiontostring_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__integrations_linkederrors_js__ = __webpack_require__(308);
/* unused harmony reexport LinkedErrors */
/* unused harmony reexport linkedErrorsIntegration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__integrations_index_js__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__metrics_exports_js__ = __webpack_require__(654);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_45__metrics_exports_js__["a"]; });
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */var Integrations=__WEBPACK_IMPORTED_MODULE_44__integrations_index_js__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = I18nProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = useI18n;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_flattenMessages__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_localePath__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_messages_en__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18n_messages_nl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_trackEvent__ = __webpack_require__(87);
var enFlat=Object(__WEBPACK_IMPORTED_MODULE_1_i18n_flattenMessages__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_i18n_messages_en__["a" /* default */]);var nlFlat=Object(__WEBPACK_IMPORTED_MODULE_1_i18n_flattenMessages__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_i18n_messages_nl__["a" /* default */]);var I18nContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(null);function interpolate(template,vars){if(!vars)return template;return template.replace(/\{(\w+)\}/g,function(_,name){return vars[name]!==undefined?vars[name]:"{".concat(name,"}");});}function I18nProvider(_ref){var locale=_ref.locale,strippedPath=_ref.strippedPath,history=_ref.history,children=_ref.children;var messages=locale==='nl'?nlFlat:enFlat;var t=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(key,vars){var _messages$key;return interpolate((_messages$key=messages[key])!==null&&_messages$key!==void 0?_messages$key:key,vars);},[messages]);var localizePath=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(path){return Object(__WEBPACK_IMPORTED_MODULE_2_i18n_localePath__["b" /* withLocalePrefix */])(locale,path);},[locale]);var switchLocale=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(next){if(next===locale)return;Object(__WEBPACK_IMPORTED_MODULE_5_utils_trackEvent__["a" /* default */])('locale_switch',{from:locale,to:next,path:strippedPath});history.push(Object(__WEBPACK_IMPORTED_MODULE_2_i18n_localePath__["b" /* withLocalePrefix */])(next,strippedPath));},[history,locale,strippedPath]);var value=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return{locale:locale,strippedPath:strippedPath,t:t,localizePath:localizePath,switchLocale:switchLocale};},[locale,strippedPath,t,localizePath,switchLocale]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){document.documentElement.lang=locale==='nl'?'nl':'en';},[locale]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(I18nContext.Provider,{value:value},children);}function useI18n(){var ctx=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(I18nContext);if(!ctx){throw new Error('useI18n must be used within I18nProvider');}return ctx;}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(95)('wks');
var uid = __webpack_require__(63);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(33);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(7)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var IE8_DOM_DEFINE = __webpack_require__(240);
var toPrimitive = __webpack_require__(40);
var dP = Object.defineProperty;

exports.f = __webpack_require__(11) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(41);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEBUG_BUILD; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */var DEBUG_BUILD=typeof __SENTRY_DEBUG__==='undefined'||__SENTRY_DEBUG__;

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_RouterLink__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_I18nContext__ = __webpack_require__(6);
function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _objectWithoutProperties(source,excluded){if(source==null)return{};var target=_objectWithoutPropertiesLoose(source,excluded);var key,i;if(Object.getOwnPropertySymbols){var sourceSymbolKeys=Object.getOwnPropertySymbols(source);for(i=0;i<sourceSymbolKeys.length;i++){key=sourceSymbolKeys[i];if(excluded.indexOf(key)>=0)continue;if(!Object.prototype.propertyIsEnumerable.call(source,key))continue;target[key]=source[key];}}return target;}function _objectWithoutPropertiesLoose(source,excluded){if(source==null)return{};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}/**
 * Same as react-router Link but prefixes `/nl` when the active locale is Dutch.
 */var LocalizedLink=function LocalizedLink(_ref){var to=_ref.to,rest=_objectWithoutProperties(_ref,["to"]);var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_2_i18n_I18nContext__["b" /* useI18n */])(),localizePath=_useI18n.localizePath;var localizedTo=typeof to==='string'?localizePath(to):to;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_RouterLink__["a" /* Link */],_extends({to:localizedTo},rest));};/* harmony default export */ __webpack_exports__["a"] = (LocalizedLink);

/***/ }),
/* 16 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GLOBAL_OBJ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGlobalObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getGlobalSingleton; });
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}/** Internal global with common properties and Sentry extensions  */// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */function isGlobalObj(obj){return obj&&obj.Math==Math?obj:undefined;}/** Get's the global object for the current JavaScript runtime */var GLOBAL_OBJ=(typeof globalThis==="undefined"?"undefined":_typeof(globalThis))=='object'&&isGlobalObj(globalThis)||// eslint-disable-next-line no-restricted-globals
(typeof window==="undefined"?"undefined":_typeof(window))=='object'&&isGlobalObj(window)||(typeof self==="undefined"?"undefined":_typeof(self))=='object'&&isGlobalObj(self)||(typeof global==="undefined"?"undefined":_typeof(global))=='object'&&isGlobalObj(global)||function(){return this;}()||{};/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */function getGlobalObject(){return GLOBAL_OBJ;}/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */function getGlobalSingleton(name,creator,obj){var gbl=obj||GLOBAL_OBJ;var __SENTRY__=gbl.__SENTRY__=gbl.__SENTRY__||{};var singleton=__SENTRY__[name]||(__SENTRY__[name]=creator());return singleton;}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(52)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(12);
var createDesc = __webpack_require__(62);
module.exports = __webpack_require__(11) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(19);
var has = __webpack_require__(25);
var SRC = __webpack_require__(63)('src');
var $toString = __webpack_require__(381);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(30).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(7);
var defined = __webpack_require__(41);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(586)();
}


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACE_FLAG_NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRACE_FLAG_SAMPLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return spanIsSampled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return spanTimeInputToSeconds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return spanToJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return spanToTraceContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return spanToTraceHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
// These are aligned with OpenTelemetry trace flags
var TRACE_FLAG_NONE=0x0;var TRACE_FLAG_SAMPLED=0x1;/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */function spanToTraceContext(span){var _span$spanContext=span.spanContext(),span_id=_span$spanContext.spanId,trace_id=_span$spanContext.traceId;var _spanToJSON=spanToJSON(span),data=_spanToJSON.data,op=_spanToJSON.op,parent_span_id=_spanToJSON.parent_span_id,status=_spanToJSON.status,tags=_spanToJSON.tags,origin=_spanToJSON.origin;return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])({data:data,op:op,parent_span_id:parent_span_id,span_id:span_id,status:status,tags:tags,trace_id:trace_id,origin:origin});}/**
 * Convert a Span to a Sentry trace header.
 */function spanToTraceHeader(span){var _span$spanContext2=span.spanContext(),traceId=_span$spanContext2.traceId,spanId=_span$spanContext2.spanId;var sampled=spanIsSampled(span);return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["W" /* generateSentryTraceHeader */])(traceId,spanId,sampled);}/**
 * Convert a span time input intp a timestamp in seconds.
 */function spanTimeInputToSeconds(input){if(typeof input==='number'){return ensureTimestampInSeconds(input);}if(Array.isArray(input)){// See {@link HrTime} for the array-based time format
return input[0]+input[1]/1e9;}if(input instanceof Date){return ensureTimestampInSeconds(input.getTime());}return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_48" /* timestampInSeconds */])();}/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */function ensureTimestampInSeconds(timestamp){var isMs=timestamp>9999999999;return isMs?timestamp/1000:timestamp;}/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */function spanToJSON(span){if(spanIsSpanClass(span)){return span.getSpanJSON();}// Fallback: We also check for `.toJSON()` here...
// eslint-disable-next-line deprecation/deprecation
if(typeof span.toJSON==='function'){// eslint-disable-next-line deprecation/deprecation
return span.toJSON();}return{};}/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */function spanIsSpanClass(span){return typeof span.getSpanJSON==='function';}/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */function spanIsSampled(span){// We align our trace flags with the ones OpenTelemetry use
// So we also check for sampled the same way they do.
var _span$spanContext3=span.spanContext(),traceFlags=_span$spanContext3.traceFlags;// eslint-disable-next-line no-bitwise
return Boolean(traceFlags&TRACE_FLAG_SAMPLED);}

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEBUG_BUILD; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */var DEBUG_BUILD=typeof __SENTRY_DEBUG__==='undefined'||__SENTRY_DEBUG__;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(96);
var defined = __webpack_require__(41);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(97);
var createDesc = __webpack_require__(62);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(40);
var has = __webpack_require__(25);
var IE8_DOM_DEFINE = __webpack_require__(240);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(11) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(25);
var toObject = __webpack_require__(13);
var IE_PROTO = __webpack_require__(156)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WINDOW; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
var WINDOW=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */];

/***/ }),
/* 30 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(17);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isDOMError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isDOMException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isErrorEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isInstanceOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isNaN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isParameterizedString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isPlainObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isPrimitive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isRegExp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isSyntheticEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isThenable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isVueViewModel; });
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}// eslint-disable-next-line @typescript-eslint/unbound-method
var objectToString=Object.prototype.toString;/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isError(wat){switch(objectToString.call(wat)){case'[object Error]':case'[object Exception]':case'[object DOMException]':return true;default:return isInstanceOf(wat,Error);}}/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */function isBuiltin(wat,className){return objectToString.call(wat)==="[object ".concat(className,"]");}/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isErrorEvent(wat){return isBuiltin(wat,'ErrorEvent');}/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isDOMError(wat){return isBuiltin(wat,'DOMError');}/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isDOMException(wat){return isBuiltin(wat,'DOMException');}/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isString(wat){return isBuiltin(wat,'String');}/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isParameterizedString(wat){return _typeof(wat)==='object'&&wat!==null&&'__sentry_template_string__'in wat&&'__sentry_template_values__'in wat;}/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isPrimitive(wat){return wat===null||isParameterizedString(wat)||_typeof(wat)!=='object'&&typeof wat!=='function';}/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isPlainObject(wat){return isBuiltin(wat,'Object');}/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isEvent(wat){return typeof Event!=='undefined'&&isInstanceOf(wat,Event);}/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isElement(wat){return typeof Element!=='undefined'&&isInstanceOf(wat,Element);}/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isRegExp(wat){return isBuiltin(wat,'RegExp');}/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */function isThenable(wat){// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
return Boolean(wat&&wat.then&&typeof wat.then==='function');}/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isSyntheticEvent(wat){return isPlainObject(wat)&&'nativeEvent'in wat&&'preventDefault'in wat&&'stopPropagation'in wat;}/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isNaN(wat){return typeof wat==='number'&&wat!==wat;}/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */function isInstanceOf(wat,base){try{return wat instanceof base;}catch(_e){return false;}}/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */function isVueViewModel(wat){// Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
return!!(_typeof(wat)==='object'&&wat!==null&&(wat.__isVue||wat._isVue));}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addNonEnumerableProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertToPlainObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dropUndefinedKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return extractExceptionKeysForMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOriginalFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return markFunctionWrapped; });
/* unused harmony export objectify */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return urlEncode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser_js__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__string_js__ = __webpack_require__(129);
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */function fill(source,name,replacementFactory){if(!(name in source)){return;}var original=source[name];var wrapped=replacementFactory(original);// Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
// otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
if(typeof wrapped==='function'){markFunctionWrapped(wrapped,original);}source[name]=wrapped;}/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */function addNonEnumerableProperty(obj,name,value){try{Object.defineProperty(obj,name,{// enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
value:value,writable:true,configurable:true});}catch(o_O){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_3__logger_js__["c" /* logger */].log("Failed to add non-enumerable property \"".concat(name,"\" to object"),obj);}}/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */function markFunctionWrapped(wrapped,original){try{var proto=original.prototype||{};wrapped.prototype=original.prototype=proto;addNonEnumerableProperty(wrapped,'__sentry_original__',original);}catch(o_O){}// eslint-disable-line no-empty
}/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */function getOriginalFunction(func){return func.__sentry_original__;}/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */function urlEncode(object){return Object.keys(object).map(function(key){return"".concat(encodeURIComponent(key),"=").concat(encodeURIComponent(object[key]));}).join('&');}/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */function convertToPlainObject(value){if(Object(__WEBPACK_IMPORTED_MODULE_2__is_js__["d" /* isError */])(value)){return _objectSpread({message:value.message,name:value.name,stack:value.stack},getOwnProperties(value));}else if(Object(__WEBPACK_IMPORTED_MODULE_2__is_js__["f" /* isEvent */])(value)){var newObj=_objectSpread({type:value.type,target:serializeEventTarget(value.target),currentTarget:serializeEventTarget(value.currentTarget)},getOwnProperties(value));if(typeof CustomEvent!=='undefined'&&Object(__WEBPACK_IMPORTED_MODULE_2__is_js__["g" /* isInstanceOf */])(value,CustomEvent)){newObj.detail=value.detail;}return newObj;}else{return value;}}/** Creates a string representation of the target of an `Event` object */function serializeEventTarget(target){try{return Object(__WEBPACK_IMPORTED_MODULE_2__is_js__["c" /* isElement */])(target)?Object(__WEBPACK_IMPORTED_MODULE_0__browser_js__["d" /* htmlTreeAsString */])(target):Object.prototype.toString.call(target);}catch(_oO){return'<unknown>';}}/** Filters out all but an object's own properties */function getOwnProperties(obj){if(_typeof(obj)==='object'&&obj!==null){var extractedProps={};for(var property in obj){if(Object.prototype.hasOwnProperty.call(obj,property)){extractedProps[property]=obj[property];}}return extractedProps;}else{return{};}}/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */function extractExceptionKeysForMessage(exception){var maxLength=arguments.length>1&&arguments[1]!==undefined?arguments[1]:40;var keys=Object.keys(convertToPlainObject(exception));keys.sort();if(!keys.length){return'[object has no keys]';}if(keys[0].length>=maxLength){return Object(__WEBPACK_IMPORTED_MODULE_4__string_js__["d" /* truncate */])(keys[0],maxLength);}for(var includedKeys=keys.length;includedKeys>0;includedKeys--){var serialized=keys.slice(0,includedKeys).join(', ');if(serialized.length>maxLength){continue;}if(includedKeys===keys.length){return serialized;}return Object(__WEBPACK_IMPORTED_MODULE_4__string_js__["d" /* truncate */])(serialized,maxLength);}return'';}/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */function dropUndefinedKeys(inputValue){// This map keeps track of what already visited nodes map to.
// Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
// references as the input object.
var memoizationMap=new Map();// This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
return _dropUndefinedKeys(inputValue,memoizationMap);}function _dropUndefinedKeys(inputValue,memoizationMap){if(isPojo(inputValue)){// If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
var memoVal=memoizationMap.get(inputValue);if(memoVal!==undefined){return memoVal;}var returnValue={};// Store the mapping of this value in case we visit it again, in case of circular data
memoizationMap.set(inputValue,returnValue);for(var _i=0,_Object$keys=Object.keys(inputValue);_i<_Object$keys.length;_i++){var key=_Object$keys[_i];if(typeof inputValue[key]!=='undefined'){returnValue[key]=_dropUndefinedKeys(inputValue[key],memoizationMap);}}return returnValue;}if(Array.isArray(inputValue)){// If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
var _memoVal=memoizationMap.get(inputValue);if(_memoVal!==undefined){return _memoVal;}var _returnValue=[];// Store the mapping of this value in case we visit it again, in case of circular data
memoizationMap.set(inputValue,_returnValue);inputValue.forEach(function(item){_returnValue.push(_dropUndefinedKeys(item,memoizationMap));});return _returnValue;}return inputValue;}function isPojo(input){if(!Object(__WEBPACK_IMPORTED_MODULE_2__is_js__["j" /* isPlainObject */])(input)){return false;}try{var name=Object.getPrototypeOf(input).constructor.name;return!name||name==='Object';}catch(e){return true;}}/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */function objectify(wat){var objectified;switch(true){case wat===undefined||wat===null:objectified=new String(wat);break;// Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
// those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
// an object in order to wrap it.
case _typeof(wat)==='symbol'||typeof wat==='bigint':objectified=Object(wat);break;// this will catch the remaining primitives: `String`, `Number`, and `Boolean`
case Object(__WEBPACK_IMPORTED_MODULE_2__is_js__["k" /* isPrimitive */])(wat):// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
objectified=new wat.constructor(wat);break;// by process of elimination, at this point we know that `wat` must already be an object
default:objectified=wat;break;}return objectified;}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addBreadcrumb; });
/* unused harmony export captureCheckIn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return captureEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return captureException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return captureMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return captureSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return close; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return configureScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return endSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return flush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCurrentScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isInitialized; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return lastEventId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setExtra; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setExtras; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return startSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return startTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return withActiveSpan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return withIsolationScope; });
/* unused harmony export withMonitor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return withScope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hub_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_prepareEvent_js__ = __webpack_require__(195);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */function captureException(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception,hint){// eslint-disable-next-line deprecation/deprecation
return Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().captureException(exception,Object(__WEBPACK_IMPORTED_MODULE_5__utils_prepareEvent_js__["a" /* parseEventHintOrCaptureContext */])(hint));}/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */function captureMessage(message,// eslint-disable-next-line deprecation/deprecation
captureContext){// This is necessary to provide explicit scopes upgrade, without changing the original
// arity of the `captureMessage(message, level)` method.
var level=typeof captureContext==='string'?captureContext:undefined;var context=typeof captureContext!=='string'?{captureContext:captureContext}:undefined;// eslint-disable-next-line deprecation/deprecation
return Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().captureMessage(message,level,context);}/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */function captureEvent(event,hint){// eslint-disable-next-line deprecation/deprecation
return Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().captureEvent(event,hint);}/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */// eslint-disable-next-line deprecation/deprecation
function configureScope(callback){// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().configureScope(callback);}/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */// eslint-disable-next-line deprecation/deprecation
function addBreadcrumb(breadcrumb,hint){// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().addBreadcrumb(breadcrumb,hint);}/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */// eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function setContext(name,context){// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().setContext(name,context);}/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */// eslint-disable-next-line deprecation/deprecation
function setExtras(extras){// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().setExtras(extras);}/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */// eslint-disable-next-line deprecation/deprecation
function setExtra(key,extra){// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().setExtra(key,extra);}/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */// eslint-disable-next-line deprecation/deprecation
function setTags(tags){// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().setTags(tags);}/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */// eslint-disable-next-line deprecation/deprecation
function setTag(key,value){// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().setTag(key,value);}/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */// eslint-disable-next-line deprecation/deprecation
function setUser(user){// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().setUser(user);}/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *//**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */function withScope(){// eslint-disable-next-line deprecation/deprecation
var hub=Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])();// If a scope is defined, we want to make this the active scope instead of the default one
for(var _len=arguments.length,rest=new Array(_len),_key=0;_key<_len;_key++){rest[_key]=arguments[_key];}if(rest.length===2){var scope=rest[0],callback=rest[1];if(!scope){// eslint-disable-next-line deprecation/deprecation
return hub.withScope(callback);}// eslint-disable-next-line deprecation/deprecation
return hub.withScope(function(){// eslint-disable-next-line deprecation/deprecation
hub.getStackTop().scope=scope;return callback(scope);});}// eslint-disable-next-line deprecation/deprecation
return hub.withScope(rest[0]);}/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */function withIsolationScope(callback){return Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["g" /* runWithAsyncContext */])(function(){return callback(Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["d" /* getIsolationScope */])());});}/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */function withActiveSpan(span,callback){return withScope(function(scope){// eslint-disable-next-line deprecation/deprecation
scope.setSpan(span);return callback(scope);});}/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */function startTransaction(context,customSamplingContext// eslint-disable-next-line deprecation/deprecation
){// eslint-disable-next-line deprecation/deprecation
return Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().startTransaction(_objectSpread({},context),customSamplingContext);}/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */function captureCheckIn(checkIn,upsertMonitorConfig){var scope=getCurrentScope();var client=getClient();if(!client){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Cannot capture check-in. No client defined.');}else if(!client.captureCheckIn){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Cannot capture check-in. Client does not support sending check-ins.');}else{return client.captureCheckIn(checkIn,upsertMonitorConfig,scope);}return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])();}/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */function withMonitor(monitorSlug,callback,upsertMonitorConfig){var checkInId=captureCheckIn({monitorSlug:monitorSlug,status:'in_progress'},upsertMonitorConfig);var now=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_48" /* timestampInSeconds */])();function finishCheckIn(status){captureCheckIn({monitorSlug:monitorSlug,status:status,checkInId:checkInId,duration:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_48" /* timestampInSeconds */])()-now});}var maybePromiseResult;try{maybePromiseResult=callback();}catch(e){finishCheckIn('error');throw e;}if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_24" /* isThenable */])(maybePromiseResult)){Promise.resolve(maybePromiseResult).then(function(){finishCheckIn('ok');},function(){finishCheckIn('error');});}else{finishCheckIn('ok');}return maybePromiseResult;}/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */function flush(_x){return _flush.apply(this,arguments);}/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */function _flush(){_flush=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(timeout){var client;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:client=getClient();if(!client){_context.next=3;break;}return _context.abrupt("return",client.flush(timeout));case 3:__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Cannot flush events. No client defined.');return _context.abrupt("return",Promise.resolve(false));case 5:case"end":return _context.stop();}}},_callee);}));return _flush.apply(this,arguments);}function close(_x2){return _close.apply(this,arguments);}/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */function _close(){_close=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(timeout){var client;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:client=getClient();if(!client){_context2.next=3;break;}return _context2.abrupt("return",client.close(timeout));case 3:__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Cannot flush events and disable SDK. No client defined.');return _context2.abrupt("return",Promise.resolve(false));case 5:case"end":return _context2.stop();}}},_callee2);}));return _close.apply(this,arguments);}function lastEventId(){// eslint-disable-next-line deprecation/deprecation
return Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().lastEventId();}/**
 * Get the currently active client.
 */function getClient(){// eslint-disable-next-line deprecation/deprecation
return Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().getClient();}/**
 * Returns true if Sentry has been properly initialized.
 */function isInitialized(){return!!getClient();}/**
 * Get the currently active scope.
 */function getCurrentScope(){// eslint-disable-next-line deprecation/deprecation
return Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])().getScope();}/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */function startSession(context){var client=getClient();var isolationScope=Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["d" /* getIsolationScope */])();var currentScope=getCurrentScope();var _ref=client&&client.getOptions()||{},release=_ref.release,_ref$environment=_ref.environment,environment=_ref$environment===void 0?__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* DEFAULT_ENVIRONMENT */]:_ref$environment;// Will fetch userAgent if called from browser sdk
var _ref2=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */].navigator||{},userAgent=_ref2.userAgent;var session=Object(__WEBPACK_IMPORTED_MODULE_4__session_js__["b" /* makeSession */])(_objectSpread({release:release,environment:environment,user:currentScope.getUser()||isolationScope.getUser()},userAgent&&{userAgent:userAgent},{},context));// End existing session if there's one
var currentSession=isolationScope.getSession();if(currentSession&&currentSession.status==='ok'){Object(__WEBPACK_IMPORTED_MODULE_4__session_js__["c" /* updateSession */])(currentSession,{status:'exited'});}endSession();// Afterwards we set the new session on the scope
isolationScope.setSession(session);// TODO (v8): Remove this and only use the isolation scope(?).
// For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
currentScope.setSession(session);return session;}/**
 * End the session on the current isolation scope.
 */function endSession(){var isolationScope=Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["d" /* getIsolationScope */])();var currentScope=getCurrentScope();var session=currentScope.getSession()||isolationScope.getSession();if(session){Object(__WEBPACK_IMPORTED_MODULE_4__session_js__["a" /* closeSession */])(session);}_sendSessionUpdate();// the session is over; take it off of the scope
isolationScope.setSession();// TODO (v8): Remove this and only use the isolation scope(?).
// For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
currentScope.setSession();}/**
 * Sends the current Session on the scope
 */function _sendSessionUpdate(){var isolationScope=Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["d" /* getIsolationScope */])();var currentScope=getCurrentScope();var client=getClient();// TODO (v8): Remove currentScope and only use the isolation scope(?).
// For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
var session=currentScope.getSession()||isolationScope.getSession();if(session&&client&&client.captureSession){client.captureSession(session);}}/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */function captureSession(){var end=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;// both send the update and pull the session from the scope
if(end){endSession();return;}// only send the update
_sendSessionUpdate();}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WINDOW; });
/* unused harmony export ignoreNextOnError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return shouldIgnoreOnError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return wrap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_internal_tracing__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(1);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var WINDOW=__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["c" /* GLOBAL_OBJ */];var ignoreOnError=0;/**
 * @hidden
 */function shouldIgnoreOnError(){return ignoreOnError>0;}/**
 * @hidden
 */function ignoreNextOnError(){// onerror should trigger before setTimeout
ignoreOnError++;setTimeout(function(){ignoreOnError--;});}/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */function wrap(fn){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var before// eslint-disable-next-line @typescript-eslint/no-explicit-any
=arguments.length>2?arguments[2]:undefined;// for future readers what this does is wrap a function and then create
// a bi-directional wrapping between them.
//
// example: wrapped = wrap(original);
//  original.__sentry_wrapped__ -> wrapped
//  wrapped.__sentry_original__ -> original
if(typeof fn!=='function'){return fn;}try{// if we're dealing with a function that was previously wrapped, return
// the original wrapper.
var wrapper=fn.__sentry_wrapped__;if(wrapper){if(typeof wrapper==='function'){return wrapper;}else{// If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
// that something messed with it. In that case we want to return the originally passed function.
return fn;}}// We don't wanna wrap it twice
if(Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["_4" /* getOriginalFunction */])(fn)){return fn;}}catch(e){// Just accessing custom props in some Selenium environments
// can cause a "Permission denied" exception (see raven-js#495).
// Bail on wrapping and return the function as-is (defers to window.onerror).
return fn;}/* eslint-disable prefer-rest-params */// It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
var sentryWrapped=function sentryWrapped(){var args=Array.prototype.slice.call(arguments);try{if(before&&typeof before==='function'){before.apply(this,arguments);}// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
var wrappedArguments=args.map(function(arg){return wrap(arg,options);});// Attempt to invoke user-land function
// NOTE: If you are a Sentry user, and you are seeing this stack frame, it
//       means the sentry.javascript SDK caught an error invoking your application code. This
//       is expected behavior and NOT indicative of a bug with sentry.javascript.
return fn.apply(this,wrappedArguments);}catch(ex){ignoreNextOnError();Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_35" /* withScope */])(function(scope){scope.addEventProcessor(function(event){if(options.mechanism){Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["m" /* addExceptionTypeValue */])(event,undefined,undefined);Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* addExceptionMechanism */])(event,options.mechanism);}event.extra=_objectSpread({},event.extra,{arguments:args});return event;});Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["w" /* captureException */])(ex);});throw ex;}};/* eslint-enable prefer-rest-params */// Accessing some objects may throw
// ref: https://github.com/getsentry/sentry-javascript/issues/1168
try{for(var property in fn){if(Object.prototype.hasOwnProperty.call(fn,property)){sentryWrapped[property]=fn[property];}}}catch(_oO){}// eslint-disable-line no-empty
// Signal that this function has been wrapped/filled already
// for both debugging and to prevent it to being wrapped/filled twice
Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["_29" /* markFunctionWrapped */])(sentryWrapped,fn);Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["s" /* addNonEnumerableProperty */])(fn,'__sentry_wrapped__',sentryWrapped);// Restore original function name (not all browsers allow that)
try{var descriptor=Object.getOwnPropertyDescriptor(sentryWrapped,'name');if(descriptor.configurable){Object.defineProperty(sentryWrapped,'name',{get:function get(){return fn.name;}});}// eslint-disable-next-line no-empty
}catch(_oO){}return sentryWrapped;}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Hero__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_SiteFooter__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_SiteHeader__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_static_images_background_2x_jpg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_static_images_background_2x_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_static_images_background_2x_jpg__);
var LegalPageLayout=function LegalPageLayout(_ref){var title=_ref.title,children=_ref.children,_ref$wide=_ref.wide,wide=_ref$wide===void 0?false:_ref$wide,lede=_ref.lede,_ref$variant=_ref.variant,variant=_ref$variant===void 0?'plain':_ref$variant,_ref$extraWide=_ref.extraWide,extraWide=_ref$extraWide===void 0?false:_ref$extraWide;var shellClass=extraWide?'gb-page-shell--extra-wide mx-auto':wide?'max-w-4xl mx-auto':'max-w-2xl mx-auto';if(variant==='marketing'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"min-h-screen flex flex-col bg-white text-black"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Hero__["a" /* default */],{as:"div",background:__WEBPACK_IMPORTED_MODULE_4_static_images_background_2x_jpg___default.a,className:"gb-page-hero text-white"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_SiteHeader__["a" /* default */],{variant:"onHero",showHome:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container gb-page-hero__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"gb-page-hero__title m-0"},title),lede?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-page-hero__lede m-0 gb-form-lede"},lede):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("main",{className:"container flex-1 gb-page-main px-15 md:px-25"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:shellClass},children)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_SiteFooter__["a" /* default */],null));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"min-h-screen flex flex-col bg-white text-black"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_SiteHeader__["a" /* default */],{variant:"onGreen",showHome:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("main",{className:"container flex-1 py-75 px-15 md:px-25"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:shellClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"text-2xl font-bold mb-35 text-black"},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-base leading-normal text-black"},children))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_SiteFooter__["a" /* default */],null));};/* harmony default export */ __webpack_exports__["a"] = (LegalPageLayout);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(8);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(30);
var fails = __webpack_require__(7);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(31);
var IObject = __webpack_require__(96);
var toObject = __webpack_require__(13);
var toLength = __webpack_require__(10);
var asc = __webpack_require__(172);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONSOLE_LEVELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consoleSandbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return logger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return originalConsoleMethods; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__debug_build_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__worldwide_js__ = __webpack_require__(18);
/** Prefix for logging strings */var PREFIX='Sentry Logger ';var CONSOLE_LEVELS=['debug','info','warn','error','log','assert','trace'];/** This may be mutated by the console instrumentation. */var originalConsoleMethods={};/** JSDoc *//**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */function consoleSandbox(callback){if(!('console'in __WEBPACK_IMPORTED_MODULE_1__worldwide_js__["a" /* GLOBAL_OBJ */])){return callback();}var console=__WEBPACK_IMPORTED_MODULE_1__worldwide_js__["a" /* GLOBAL_OBJ */].console;var wrappedFuncs={};var wrappedLevels=Object.keys(originalConsoleMethods);// Restore all wrapped console methods
wrappedLevels.forEach(function(level){var originalConsoleMethod=originalConsoleMethods[level];wrappedFuncs[level]=console[level];console[level]=originalConsoleMethod;});try{return callback();}finally{// Revert restoration to wrapped state
wrappedLevels.forEach(function(level){console[level]=wrappedFuncs[level];});}}function makeLogger(){var enabled=false;var logger={enable:function enable(){enabled=true;},disable:function disable(){enabled=false;},isEnabled:function isEnabled(){return enabled;}};if(__WEBPACK_IMPORTED_MODULE_0__debug_build_js__["a" /* DEBUG_BUILD */]){CONSOLE_LEVELS.forEach(function(name){// eslint-disable-next-line @typescript-eslint/no-explicit-any
logger[name]=function(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}if(enabled){consoleSandbox(function(){var _GLOBAL_OBJ$console;(_GLOBAL_OBJ$console=__WEBPACK_IMPORTED_MODULE_1__worldwide_js__["a" /* GLOBAL_OBJ */].console)[name].apply(_GLOBAL_OBJ$console,["".concat(PREFIX,"[").concat(name,"]:")].concat(args));});}};});}else{CONSOLE_LEVELS.forEach(function(name){logger[name]=function(){return undefined;};});}return logger;}var logger=makeLogger();

/***/ }),
/* 45 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(329);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(11)) {
  var LIBRARY = __webpack_require__(53);
  var global = __webpack_require__(5);
  var fails = __webpack_require__(7);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(125);
  var $buffer = __webpack_require__(180);
  var ctx = __webpack_require__(31);
  var anInstance = __webpack_require__(69);
  var propertyDesc = __webpack_require__(62);
  var hide = __webpack_require__(19);
  var redefineAll = __webpack_require__(71);
  var toInteger = __webpack_require__(33);
  var toLength = __webpack_require__(10);
  var toIndex = __webpack_require__(268);
  var toAbsoluteIndex = __webpack_require__(65);
  var toPrimitive = __webpack_require__(40);
  var has = __webpack_require__(25);
  var classof = __webpack_require__(80);
  var isObject = __webpack_require__(8);
  var toObject = __webpack_require__(13);
  var isArrayIter = __webpack_require__(169);
  var create = __webpack_require__(66);
  var getPrototypeOf = __webpack_require__(28);
  var gOPN = __webpack_require__(67).f;
  var getIterFn = __webpack_require__(171);
  var uid = __webpack_require__(63);
  var wks = __webpack_require__(9);
  var createArrayMethod = __webpack_require__(43);
  var createArrayIncludes = __webpack_require__(115);
  var speciesConstructor = __webpack_require__(99);
  var ArrayIterators = __webpack_require__(174);
  var Iterators = __webpack_require__(82);
  var $iterDetect = __webpack_require__(120);
  var setSpecies = __webpack_require__(68);
  var arrayFill = __webpack_require__(173);
  var arrayCopyWithin = __webpack_require__(257);
  var $DP = __webpack_require__(12);
  var $GOPD = __webpack_require__(27);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(263);
var $export = __webpack_require__(0);
var shared = __webpack_require__(95)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(266))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEBUG_BUILD; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */var DEBUG_BUILD=typeof __SENTRY_DEBUG__==='undefined'||__SENTRY_DEBUG__;

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hub; });
/* unused harmony export ensureHubOnCarrier */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentHub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getHubFromCarrier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getIsolationScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMainCarrier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return makeMain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return runWithAsyncContext; });
/* unused harmony export setAsyncContextStrategy */
/* unused harmony export setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scope_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version_js__ = __webpack_require__(196);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */var API_VERSION=parseFloat(__WEBPACK_IMPORTED_MODULE_5__version_js__["a" /* SDK_VERSION */]);/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */var DEFAULT_BREADCRUMBS=100;/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */// eslint-disable-next-line deprecation/deprecation
var Hub=/*#__PURE__*/function(){/** Is a {@link Layer}[] containing the client and scope *//** Contains the last event id of a captured event.  *//**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */function Hub(client,scope,isolationScope){var _version=arguments.length>3&&arguments[3]!==undefined?arguments[3]:API_VERSION;_classCallCheck(this,Hub);this._version=_version;var assignedScope;if(!scope){assignedScope=new __WEBPACK_IMPORTED_MODULE_3__scope_js__["a" /* Scope */]();assignedScope.setClient(client);}else{assignedScope=scope;}var assignedIsolationScope;if(!isolationScope){assignedIsolationScope=new __WEBPACK_IMPORTED_MODULE_3__scope_js__["a" /* Scope */]();assignedIsolationScope.setClient(client);}else{assignedIsolationScope=isolationScope;}this._stack=[{scope:assignedScope}];if(client){// eslint-disable-next-line deprecation/deprecation
this.bindClient(client);}this._isolationScope=assignedIsolationScope;}/**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */_createClass(Hub,[{key:"isOlderThan",value:function isOlderThan(version){return this._version<version;}/**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */},{key:"bindClient",value:function bindClient(client){// eslint-disable-next-line deprecation/deprecation
var top=this.getStackTop();top.client=client;top.scope.setClient(client);// eslint-disable-next-line deprecation/deprecation
if(client&&client.setupIntegrations){// eslint-disable-next-line deprecation/deprecation
client.setupIntegrations();}}/**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */},{key:"pushScope",value:function pushScope(){// We want to clone the content of prev scope
// eslint-disable-next-line deprecation/deprecation
var scope=this.getScope().clone();// eslint-disable-next-line deprecation/deprecation
this.getStack().push({// eslint-disable-next-line deprecation/deprecation
client:this.getClient(),scope:scope});return scope;}/**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */},{key:"popScope",value:function popScope(){// eslint-disable-next-line deprecation/deprecation
if(this.getStack().length<=1)return false;// eslint-disable-next-line deprecation/deprecation
return!!this.getStack().pop();}/**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */},{key:"withScope",value:function withScope(callback){var _this=this;// eslint-disable-next-line deprecation/deprecation
var scope=this.pushScope();var maybePromiseResult;try{maybePromiseResult=callback(scope);}catch(e){// eslint-disable-next-line deprecation/deprecation
this.popScope();throw e;}if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_24" /* isThenable */])(maybePromiseResult)){// @ts-expect-error - isThenable returns the wrong type
return maybePromiseResult.then(function(res){// eslint-disable-next-line deprecation/deprecation
_this.popScope();return res;},function(e){// eslint-disable-next-line deprecation/deprecation
_this.popScope();throw e;});}// eslint-disable-next-line deprecation/deprecation
this.popScope();return maybePromiseResult;}/**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */},{key:"getClient",value:function getClient(){// eslint-disable-next-line deprecation/deprecation
return this.getStackTop().client;}/**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */},{key:"getScope",value:function getScope(){// eslint-disable-next-line deprecation/deprecation
return this.getStackTop().scope;}/**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */},{key:"getIsolationScope",value:function getIsolationScope(){return this._isolationScope;}/**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */},{key:"getStack",value:function getStack(){return this._stack;}/**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */},{key:"getStackTop",value:function getStackTop(){return this._stack[this._stack.length-1];}/**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */},{key:"captureException",value:function captureException(exception,hint){var eventId=this._lastEventId=hint&&hint.event_id?hint.event_id:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])();var syntheticException=new Error('Sentry syntheticException');// eslint-disable-next-line deprecation/deprecation
this.getScope().captureException(exception,_objectSpread({originalException:exception,syntheticException:syntheticException},hint,{event_id:eventId}));return eventId;}/**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */},{key:"captureMessage",value:function captureMessage(message,// eslint-disable-next-line deprecation/deprecation
level,hint){var eventId=this._lastEventId=hint&&hint.event_id?hint.event_id:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])();var syntheticException=new Error(message);// eslint-disable-next-line deprecation/deprecation
this.getScope().captureMessage(message,level,_objectSpread({originalException:message,syntheticException:syntheticException},hint,{event_id:eventId}));return eventId;}/**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */},{key:"captureEvent",value:function captureEvent(event,hint){var eventId=hint&&hint.event_id?hint.event_id:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])();if(!event.type){this._lastEventId=eventId;}// eslint-disable-next-line deprecation/deprecation
this.getScope().captureEvent(event,_objectSpread({},hint,{event_id:eventId}));return eventId;}/**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */},{key:"lastEventId",value:function lastEventId(){return this._lastEventId;}/**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */},{key:"addBreadcrumb",value:function addBreadcrumb(breadcrumb,hint){// eslint-disable-next-line deprecation/deprecation
var _this$getStackTop=this.getStackTop(),scope=_this$getStackTop.scope,client=_this$getStackTop.client;if(!client)return;var _ref=client.getOptions&&client.getOptions()||{},_ref$beforeBreadcrumb=_ref.beforeBreadcrumb,beforeBreadcrumb=_ref$beforeBreadcrumb===void 0?null:_ref$beforeBreadcrumb,_ref$maxBreadcrumbs=_ref.maxBreadcrumbs,maxBreadcrumbs=_ref$maxBreadcrumbs===void 0?DEFAULT_BREADCRUMBS:_ref$maxBreadcrumbs;if(maxBreadcrumbs<=0)return;var timestamp=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["G" /* dateTimestampInSeconds */])();var mergedBreadcrumb=_objectSpread({timestamp:timestamp},breadcrumb);var finalBreadcrumb=beforeBreadcrumb?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["A" /* consoleSandbox */])(function(){return beforeBreadcrumb(mergedBreadcrumb,hint);}):mergedBreadcrumb;if(finalBreadcrumb===null)return;if(client.emit){client.emit('beforeAddBreadcrumb',finalBreadcrumb,hint);}// TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
// write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
// duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
// and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
// have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
// the event processing pipeline.
// In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
scope.addBreadcrumb(finalBreadcrumb,maxBreadcrumbs);}/**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */},{key:"setUser",value:function setUser(user){// TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
// eslint-disable-next-line deprecation/deprecation
this.getScope().setUser(user);// eslint-disable-next-line deprecation/deprecation
this.getIsolationScope().setUser(user);}/**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */},{key:"setTags",value:function setTags(tags){// TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
// eslint-disable-next-line deprecation/deprecation
this.getScope().setTags(tags);// eslint-disable-next-line deprecation/deprecation
this.getIsolationScope().setTags(tags);}/**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */},{key:"setExtras",value:function setExtras(extras){// TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
// eslint-disable-next-line deprecation/deprecation
this.getScope().setExtras(extras);// eslint-disable-next-line deprecation/deprecation
this.getIsolationScope().setExtras(extras);}/**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */},{key:"setTag",value:function setTag(key,value){// TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
// eslint-disable-next-line deprecation/deprecation
this.getScope().setTag(key,value);// eslint-disable-next-line deprecation/deprecation
this.getIsolationScope().setTag(key,value);}/**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */},{key:"setExtra",value:function setExtra(key,extra){// TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
// eslint-disable-next-line deprecation/deprecation
this.getScope().setExtra(key,extra);// eslint-disable-next-line deprecation/deprecation
this.getIsolationScope().setExtra(key,extra);}/**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */// eslint-disable-next-line @typescript-eslint/no-explicit-any
},{key:"setContext",value:function setContext(name,context){// TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
// eslint-disable-next-line deprecation/deprecation
this.getScope().setContext(name,context);// eslint-disable-next-line deprecation/deprecation
this.getIsolationScope().setContext(name,context);}/**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */},{key:"configureScope",value:function configureScope(callback){// eslint-disable-next-line deprecation/deprecation
var _this$getStackTop2=this.getStackTop(),scope=_this$getStackTop2.scope,client=_this$getStackTop2.client;if(client){callback(scope);}}/**
   * @inheritDoc
   */// eslint-disable-next-line deprecation/deprecation
},{key:"run",value:function run(callback){// eslint-disable-next-line deprecation/deprecation
var oldHub=makeMain(this);try{callback(this);}finally{// eslint-disable-next-line deprecation/deprecation
makeMain(oldHub);}}/**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */},{key:"getIntegration",value:function getIntegration(integration){// eslint-disable-next-line deprecation/deprecation
var client=this.getClient();if(!client)return null;try{// eslint-disable-next-line deprecation/deprecation
return client.getIntegration(integration);}catch(_oO){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("Cannot retrieve integration ".concat(integration.id," from the current Hub"));return null;}}/**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */},{key:"startTransaction",value:function startTransaction(context,customSamplingContext){var result=this._callExtensionMethod('startTransaction',context,customSamplingContext);if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&!result){// eslint-disable-next-line deprecation/deprecation
var client=this.getClient();if(!client){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");}else{__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':\nSentry.addTracingExtensions();\nSentry.init({...});\n");}}return result;}/**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */},{key:"traceHeaders",value:function traceHeaders(){return this._callExtensionMethod('traceHeaders');}/**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */},{key:"captureSession",value:function captureSession(){var endSession=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;// both send the update and pull the session from the scope
if(endSession){// eslint-disable-next-line deprecation/deprecation
return this.endSession();}// only send the update
this._sendSessionUpdate();}/**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */},{key:"endSession",value:function endSession(){// eslint-disable-next-line deprecation/deprecation
var layer=this.getStackTop();var scope=layer.scope;var session=scope.getSession();if(session){Object(__WEBPACK_IMPORTED_MODULE_4__session_js__["a" /* closeSession */])(session);}this._sendSessionUpdate();// the session is over; take it off of the scope
scope.setSession();}/**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */},{key:"startSession",value:function startSession(context){// eslint-disable-next-line deprecation/deprecation
var _this$getStackTop3=this.getStackTop(),scope=_this$getStackTop3.scope,client=_this$getStackTop3.client;var _ref2=client&&client.getOptions()||{},release=_ref2.release,_ref2$environment=_ref2.environment,environment=_ref2$environment===void 0?__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* DEFAULT_ENVIRONMENT */]:_ref2$environment;// Will fetch userAgent if called from browser sdk
var _ref3=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */].navigator||{},userAgent=_ref3.userAgent;var session=Object(__WEBPACK_IMPORTED_MODULE_4__session_js__["b" /* makeSession */])(_objectSpread({release:release,environment:environment,user:scope.getUser()},userAgent&&{userAgent:userAgent},{},context));// End existing session if there's one
var currentSession=scope.getSession&&scope.getSession();if(currentSession&&currentSession.status==='ok'){Object(__WEBPACK_IMPORTED_MODULE_4__session_js__["c" /* updateSession */])(currentSession,{status:'exited'});}// eslint-disable-next-line deprecation/deprecation
this.endSession();// Afterwards we set the new session on the scope
scope.setSession(session);return session;}/**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */},{key:"shouldSendDefaultPii",value:function shouldSendDefaultPii(){// eslint-disable-next-line deprecation/deprecation
var client=this.getClient();var options=client&&client.getOptions();return Boolean(options&&options.sendDefaultPii);}/**
   * Sends the current Session on the scope
   */},{key:"_sendSessionUpdate",value:function _sendSessionUpdate(){// eslint-disable-next-line deprecation/deprecation
var _this$getStackTop4=this.getStackTop(),scope=_this$getStackTop4.scope,client=_this$getStackTop4.client;var session=scope.getSession();if(session&&client&&client.captureSession){client.captureSession(session);}}/**
   * Calls global extension method and binding current instance to the function call
   */// @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
},{key:"_callExtensionMethod",value:function _callExtensionMethod(method){var carrier=getMainCarrier();var sentry=carrier.__SENTRY__;if(sentry&&sentry.extensions&&typeof sentry.extensions[method]==='function'){for(var _len=arguments.length,args=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}return sentry.extensions[method].apply(this,args);}__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("Extension method ".concat(method," couldn't be found, doing nothing."));}}]);return Hub;}();/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/function getMainCarrier(){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */].__SENTRY__=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */].__SENTRY__||{extensions:{},hub:undefined};return __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */];}/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */// eslint-disable-next-line deprecation/deprecation
function makeMain(hub){var registry=getMainCarrier();var oldHub=getHubFromCarrier(registry);setHubOnCarrier(registry,hub);return oldHub;}/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */// eslint-disable-next-line deprecation/deprecation
function getCurrentHub(){// Get main carrier (global for every environment)
var registry=getMainCarrier();if(registry.__SENTRY__&&registry.__SENTRY__.acs){var hub=registry.__SENTRY__.acs.getCurrentHub();if(hub){return hub;}}// Return hub that lives on a global object
return getGlobalHub(registry);}/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */function getIsolationScope(){// eslint-disable-next-line deprecation/deprecation
return getCurrentHub().getIsolationScope();}// eslint-disable-next-line deprecation/deprecation
function getGlobalHub(){var registry=arguments.length>0&&arguments[0]!==undefined?arguments[0]:getMainCarrier();// If there's no hub, or its an old API, assign a new one
if(!hasHubOnCarrier(registry)||// eslint-disable-next-line deprecation/deprecation
getHubFromCarrier(registry).isOlderThan(API_VERSION)){// eslint-disable-next-line deprecation/deprecation
setHubOnCarrier(registry,new Hub());}// Return hub that lives on a global object
return getHubFromCarrier(registry);}/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */// eslint-disable-next-line deprecation/deprecation
function ensureHubOnCarrier(carrier){var parent=arguments.length>1&&arguments[1]!==undefined?arguments[1]:getGlobalHub();// If there's no hub on current domain, or it's an old API, assign a new one
if(!hasHubOnCarrier(carrier)||// eslint-disable-next-line deprecation/deprecation
getHubFromCarrier(carrier).isOlderThan(API_VERSION)){// eslint-disable-next-line deprecation/deprecation
var client=parent.getClient();// eslint-disable-next-line deprecation/deprecation
var scope=parent.getScope();// eslint-disable-next-line deprecation/deprecation
var isolationScope=parent.getIsolationScope();// eslint-disable-next-line deprecation/deprecation
setHubOnCarrier(carrier,new Hub(client,scope.clone(),isolationScope.clone()));}}/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */function setAsyncContextStrategy(strategy){// Get main carrier (global for every environment)
var registry=getMainCarrier();registry.__SENTRY__=registry.__SENTRY__||{};registry.__SENTRY__.acs=strategy;}/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */function runWithAsyncContext(callback){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var registry=getMainCarrier();if(registry.__SENTRY__&&registry.__SENTRY__.acs){return registry.__SENTRY__.acs.runWithAsyncContext(callback,options);}// if there was no strategy, fallback to just calling the callback
return callback();}/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */function hasHubOnCarrier(carrier){return!!(carrier&&carrier.__SENTRY__&&carrier.__SENTRY__.hub);}/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */// eslint-disable-next-line deprecation/deprecation
function getHubFromCarrier(carrier){// eslint-disable-next-line deprecation/deprecation
return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_1" /* getGlobalSingleton */])('hub',function(){return new Hub();},carrier);}/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */// eslint-disable-next-line deprecation/deprecation
function setHubOnCarrier(carrier,hub){if(!carrier)return false;var __SENTRY__=carrier.__SENTRY__=carrier.__SENTRY__||{};__SENTRY__.hub=hub;return true;}

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEBUG_BUILD; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */var DEBUG_BUILD=typeof __SENTRY_DEBUG__==='undefined'||__SENTRY_DEBUG__;

/***/ }),
/* 52 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(63)('meta');
var isObject = __webpack_require__(8);
var has = __webpack_require__(25);
var setDesc = __webpack_require__(12).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(7)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(9)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(19)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return maybeInstrument; });
/* unused harmony export resetInstrumentationHandlers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return triggerHandlers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__debug_build_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stacktrace_js__ = __webpack_require__(185);
// We keep the handlers globally
var handlers={};var instrumented={};/** Add a handler function. */function addHandler(type,handler){handlers[type]=handlers[type]||[];handlers[type].push(handler);}/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */function resetInstrumentationHandlers(){Object.keys(handlers).forEach(function(key){handlers[key]=undefined;});}/** Maybe run an instrumentation function, unless it was already called. */function maybeInstrument(type,instrumentFn){if(!instrumented[type]){instrumentFn();instrumented[type]=true;}}/** Trigger handlers for a given instrumentation type. */function triggerHandlers(type,data){var typeHandlers=type&&handlers[type];if(!typeHandlers){return;}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=typeHandlers[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var handler=_step.value;try{handler(data);}catch(e){__WEBPACK_IMPORTED_MODULE_0__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__logger_js__["c" /* logger */].error("Error while triggering instrumentation handler.\nType: ".concat(type,"\nName: ").concat(Object(__WEBPACK_IMPORTED_MODULE_2__stacktrace_js__["b" /* getFunctionName */])(handler),"\nError:"),e);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addIntegration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return afterSetupIntegrations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertIntegrationFnToClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return defineIntegration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getIntegrationsToSetup; });
/* unused harmony export installedIntegrations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setupIntegration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setupIntegrations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventProcessors_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__exports_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hub_js__ = __webpack_require__(50);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}var installedIntegrations=[];/** Map of integrations assigned to a client *//**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */function filterDuplicates(integrations){var integrationsByName={};integrations.forEach(function(currentInstance){var name=currentInstance.name;var existingInstance=integrationsByName[name];// We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
// default instance to overwrite an existing user instance
if(existingInstance&&!existingInstance.isDefaultInstance&&currentInstance.isDefaultInstance){return;}integrationsByName[name]=currentInstance;});return Object.keys(integrationsByName).map(function(k){return integrationsByName[k];});}/** Gets integrations to install */function getIntegrationsToSetup(options){var defaultIntegrations=options.defaultIntegrations||[];var userIntegrations=options.integrations;// We flag default instances, so that later we can tell them apart from any user-created instances of the same class
defaultIntegrations.forEach(function(integration){integration.isDefaultInstance=true;});var integrations;if(Array.isArray(userIntegrations)){integrations=[].concat(_toConsumableArray(defaultIntegrations),_toConsumableArray(userIntegrations));}else if(typeof userIntegrations==='function'){integrations=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["w" /* arrayify */])(userIntegrations(defaultIntegrations));}else{integrations=defaultIntegrations;}var finalIntegrations=filterDuplicates(integrations);// The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
// `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
// processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
// locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
var debugIndex=findIndex(finalIntegrations,function(integration){return integration.name==='Debug';});if(debugIndex!==-1){var _finalIntegrations$sp=finalIntegrations.splice(debugIndex,1),_finalIntegrations$sp2=_slicedToArray(_finalIntegrations$sp,1),debugInstance=_finalIntegrations$sp2[0];finalIntegrations.push(debugInstance);}return finalIntegrations;}/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */function setupIntegrations(client,integrations){var integrationIndex={};integrations.forEach(function(integration){// guard against empty provided integrations
if(integration){setupIntegration(client,integration,integrationIndex);}});return integrationIndex;}/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */function afterSetupIntegrations(client,integrations){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=integrations[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var integration=_step.value;// guard against empty provided integrations
if(integration&&integration.afterAllSetup){integration.afterAllSetup(client);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}/** Setup a single integration.  */function setupIntegration(client,integration,integrationIndex){if(integrationIndex[integration.name]){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("Integration skipped because it was already installed: ".concat(integration.name));return;}integrationIndex[integration.name]=integration;// `setupOnce` is only called the first time
if(installedIntegrations.indexOf(integration.name)===-1){// eslint-disable-next-line deprecation/deprecation
integration.setupOnce(__WEBPACK_IMPORTED_MODULE_2__eventProcessors_js__["a" /* addGlobalEventProcessor */],__WEBPACK_IMPORTED_MODULE_4__hub_js__["b" /* getCurrentHub */]);installedIntegrations.push(integration.name);}// `setup` is run for each client
if(integration.setup&&typeof integration.setup==='function'){integration.setup(client);}if(client.on&&typeof integration.preprocessEvent==='function'){var callback=integration.preprocessEvent.bind(integration);client.on('preprocessEvent',function(event,hint){return callback(event,hint,client);});}if(client.addEventProcessor&&typeof integration.processEvent==='function'){var _callback=integration.processEvent.bind(integration);var processor=Object.assign(function(event,hint){return _callback(event,hint,client);},{id:integration.name});client.addEventProcessor(processor);}__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("Integration installed: ".concat(integration.name));}/** Add an integration to the current hub's client. */function addIntegration(integration){var client=Object(__WEBPACK_IMPORTED_MODULE_3__exports_js__["j" /* getClient */])();if(!client||!client.addIntegration){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("Cannot add integration \"".concat(integration.name,"\" because no SDK Client is available."));return;}client.addIntegration(integration);}// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr,callback){for(var i=0;i<arr.length;i++){if(callback(arr[i])===true){return i;}}return-1;}/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */function convertIntegrationFnToClass(name,fn){return Object.assign(function ConvertedIntegration(){return fn.apply(void 0,arguments);},{id:name});}/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */function defineIntegration(fn){return fn;}

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_trackEvent__ = __webpack_require__(87);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CTA_CLASS='gb-btn bg-green shadow text-white text-lg font-bold px-25 py-20 rounded-lg inline-block no-underline';var CtaWithHint=function CtaWithHint(_ref){var href=_ref.href,buttonLabel=_ref.buttonLabel,hint=_ref.hint,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,_ref$onDark=_ref.onDark,onDark=_ref$onDark===void 0?false:_ref$onDark,_ref$trackName=_ref.trackName,trackName=_ref$trackName===void 0?'cta_click':_ref$trackName,trackProps=_ref.trackProps;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_1_i18n_I18nContext__["b" /* useI18n */])(),localizePath=_useI18n.localizePath,locale=_useI18n.locale;var localizedHref=localizePath(href);var hintClass=onDark?'gb-cta-hint gb-cta-hint--on-dark':'gb-cta-hint';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-cta-stack ".concat(className).trim()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:localizedHref,className:CTA_CLASS,onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_2_utils_trackEvent__["a" /* default */])(trackName,_objectSpread({href:href,locale:locale},trackProps||{}));}},buttonLabel),hint?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"".concat(hintClass," text-sm mt-15 leading-normal m-0")},hint):null);};/* harmony default export */ __webpack_exports__["a"] = (CtaWithHint);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_I18nContext__ = __webpack_require__(6);
var TrustProof=function TrustProof(_ref){var _ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,_ref$onDark=_ref.onDark,onDark=_ref$onDark===void 0?false:_ref$onDark;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_1_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;var items=[t('home.trustFreeMonth'),t('home.trustSetup'),t('home.trustApps'),t('home.trustTeam')];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"gb-trust-proof ".concat(onDark?'gb-trust-proof--on-dark':''," ").concat(className).trim(),"aria-label":t('home.trustLabel')},items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:item},index>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-trust-proof__sep","aria-hidden":"true"},"\xB7"):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,item));}));};/* harmony default export */ __webpack_exports__["a"] = (TrustProof);

/***/ }),
/* 61 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(242);
var enumBugKeys = __webpack_require__(157);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(33);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(4);
var dPs = __webpack_require__(243);
var enumBugKeys = __webpack_require__(157);
var IE_PROTO = __webpack_require__(156)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(154)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(158).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(242);
var hiddenKeys = __webpack_require__(157).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var dP = __webpack_require__(12);
var DESCRIPTORS = __webpack_require__(11);
var SPECIES = __webpack_require__(9)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(31);
var call = __webpack_require__(255);
var isArrayIter = __webpack_require__(169);
var anObject = __webpack_require__(4);
var toLength = __webpack_require__(10);
var getIterFn = __webpack_require__(171);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(20);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return INTEGRATIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["x"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["y"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["z"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["A"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["B"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["F"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["H"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["I"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["J"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["K"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["L"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["M"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["N"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["O"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["P"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["T"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["Z"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_1"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_3"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_6"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_7"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_8"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_10"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_11"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_12"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_14"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_15"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_16"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_17"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_18"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_19"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_20"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_21"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_22"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_23"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_27"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_28"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_29"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_30"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_31"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_32"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_33"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_34"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_core__["_35"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_1__helpers_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client_js__ = __webpack_require__(312);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__client_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transports_fetch_js__ = __webpack_require__(314);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_3__transports_fetch_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__transports_xhr_js__ = __webpack_require__(315);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_4__transports_xhr_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stack_parsers_js__ = __webpack_require__(316);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_5__stack_parsers_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_5__stack_parsers_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_5__stack_parsers_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_5__stack_parsers_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return __WEBPACK_IMPORTED_MODULE_5__stack_parsers_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return __WEBPACK_IMPORTED_MODULE_5__stack_parsers_js__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return __WEBPACK_IMPORTED_MODULE_5__stack_parsers_js__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__eventbuilder_js__ = __webpack_require__(139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_6__eventbuilder_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_6__eventbuilder_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_6__eventbuilder_js__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__userfeedback_js__ = __webpack_require__(313);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_7__userfeedback_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sdk_js__ = __webpack_require__(678);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_8__sdk_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_8__sdk_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_8__sdk_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_8__sdk_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_8__sdk_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return __WEBPACK_IMPORTED_MODULE_8__sdk_js__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return __WEBPACK_IMPORTED_MODULE_8__sdk_js__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return __WEBPACK_IMPORTED_MODULE_8__sdk_js__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__integrations_breadcrumbs_js__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__integrations_breadcrumbs_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_9__integrations_breadcrumbs_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__integrations_dedupe_js__ = __webpack_require__(209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__integrations_dedupe_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__integrations_globalhandlers_js__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__integrations_globalhandlers_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_11__integrations_globalhandlers_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__integrations_httpcontext_js__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__integrations_httpcontext_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_12__integrations_httpcontext_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__integrations_linkederrors_js__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_13__integrations_linkederrors_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_13__integrations_linkederrors_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__integrations_trycatch_js__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_14__integrations_trycatch_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_14__integrations_trycatch_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__integrations_index_js__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sentry_replay__ = __webpack_require__(680);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_16__sentry_replay__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_16__sentry_replay__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return __WEBPACK_IMPORTED_MODULE_16__sentry_replay__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sentry_internal_replay_canvas__ = __webpack_require__(681);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_17__sentry_internal_replay_canvas__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return __WEBPACK_IMPORTED_MODULE_17__sentry_internal_replay_canvas__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__sentry_internal_feedback__ = __webpack_require__(682);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_18__sentry_internal_feedback__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_18__sentry_internal_feedback__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return __WEBPACK_IMPORTED_MODULE_18__sentry_internal_feedback__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sentry_integrations__ = __webpack_require__(683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_19__sentry_integrations__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_19__sentry_integrations__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_19__sentry_integrations__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_19__sentry_integrations__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_19__sentry_integrations__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_19__sentry_integrations__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return __WEBPACK_IMPORTED_MODULE_19__sentry_integrations__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return __WEBPACK_IMPORTED_MODULE_19__sentry_integrations__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return __WEBPACK_IMPORTED_MODULE_19__sentry_integrations__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__sentry_internal_tracing__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_20__sentry_internal_tracing__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_20__sentry_internal_tracing__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_20__sentry_internal_tracing__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_20__sentry_internal_tracing__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return __WEBPACK_IMPORTED_MODULE_20__sentry_internal_tracing__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return __WEBPACK_IMPORTED_MODULE_20__sentry_internal_tracing__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__transports_offline_js__ = __webpack_require__(696);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_21__transports_offline_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__profiling_hubextensions_js__ = __webpack_require__(317);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return __WEBPACK_IMPORTED_MODULE_22__profiling_hubextensions_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__profiling_integration_js__ = __webpack_require__(697);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_23__profiling_integration_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_23__profiling_integration_js__["b"]; });
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var windowIntegrations={};// This block is needed to add compatibility with the integrations packages when used with a CDN
if(__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* WINDOW */].Sentry&&__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* WINDOW */].Sentry.Integrations){windowIntegrations=__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* WINDOW */].Sentry.Integrations;}/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */var INTEGRATIONS=_objectSpread({},windowIntegrations,{},__WEBPACK_IMPORTED_MODULE_0__sentry_core__["f" /* Integrations */],{},__WEBPACK_IMPORTED_MODULE_15__integrations_index_js__);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shouldDisableAutoInstrumentation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */// eslint-disable-next-line deprecation/deprecation
function shouldDisableAutoInstrumentation(getCurrentHub){// eslint-disable-next-line deprecation/deprecation
var clientOptions=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([getCurrentHub,'call',function(_){return _();},'access',function(_2){return _2.getClient;},'call',function(_3){return _3();},'optionalAccess',function(_4){return _4.getOptions;},'call',function(_5){return _5();}]);var instrumenter=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([clientOptions,'optionalAccess',function(_6){return _6.instrumenter;}])||'sentry';return instrumenter!=='sentry';}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = SchemaType;

var _extends2 = _interopRequireDefault(__webpack_require__(110));

var _has = _interopRequireDefault(__webpack_require__(88));

var _cloneDeepWith = _interopRequireDefault(__webpack_require__(781));

var _toArray2 = _interopRequireDefault(__webpack_require__(820));

var _locale = __webpack_require__(93);

var _Condition = _interopRequireDefault(__webpack_require__(827));

var _runValidations = _interopRequireDefault(__webpack_require__(234));

var _merge = _interopRequireDefault(__webpack_require__(829));

var _isSchema = _interopRequireDefault(__webpack_require__(78));

var _isAbsent = _interopRequireDefault(__webpack_require__(113));

var _createValidation = _interopRequireDefault(__webpack_require__(830));

var _printValue = _interopRequireDefault(__webpack_require__(151));

var _Reference = _interopRequireDefault(__webpack_require__(114));

var notEmpty = function notEmpty(value) {
  return !(0, _isAbsent.default)(value);
};

var RefSet =
/*#__PURE__*/
function () {
  function RefSet() {
    this.list = new Set();
    this.refs = new Map();
  }

  var _proto = RefSet.prototype;

  _proto.toArray = function toArray() {
    return (0, _toArray2.default)(this.list).concat((0, _toArray2.default)(this.refs.values()));
  };

  _proto.add = function add(value) {
    _Reference.default.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  };

  _proto.delete = function _delete(value) {
    _Reference.default.isRef(value) ? this.refs.delete(value.key, value) : this.list.delete(value);
  };

  _proto.has = function has(value, resolve) {
    if (this.list.has(value)) return true;
    var item,
        values = this.refs.values();

    while (item = values.next(), !item.done) {
      if (resolve(item.value) === value) return true;
    }

    return false;
  };

  return RefSet;
}();

function SchemaType(options) {
  var _this = this;

  if (options === void 0) {
    options = {};
  }

  if (!(this instanceof SchemaType)) return new SchemaType();
  this._deps = [];
  this._conditions = [];
  this._options = {
    abortEarly: true,
    recursive: true
  };
  this._exclusive = Object.create(null);
  this._whitelist = new RefSet();
  this._blacklist = new RefSet();
  this.tests = [];
  this.transforms = [];
  this.withMutation(function () {
    _this.typeError(_locale.mixed.notType);
  });
  if ((0, _has.default)(options, 'default')) this._defaultDefault = options.default;
  this._type = options.type || 'mixed';
}

SchemaType.prototype = {
  __isYupSchema__: true,
  constructor: SchemaType,
  clone: function clone() {
    var _this2 = this;

    if (this._mutate) return this; // if the nested value is a schema we can skip cloning, since
    // they are already immutable

    return (0, _cloneDeepWith.default)(this, function (value) {
      if ((0, _isSchema.default)(value) && value !== _this2) return value;
    });
  },
  label: function label(_label) {
    var next = this.clone();
    next._label = _label;
    return next;
  },
  meta: function meta(obj) {
    if (arguments.length === 0) return this._meta;
    var next = this.clone();
    next._meta = (0, _extends2.default)(next._meta || {}, obj);
    return next;
  },
  withMutation: function withMutation(fn) {
    this._mutate = true;
    var result = fn(this);
    this._mutate = false;
    return result;
  },
  concat: function concat(schema) {
    if (!schema) return this;
    if (schema._type !== this._type && this._type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: " + this._type + " and " + schema._type);
    var cloned = this.clone();
    var next = (0, _merge.default)(this.clone(), schema.clone()); // undefined isn't merged over, but is a valid value for default

    if ((0, _has.default)(schema, '_default')) next._default = schema._default;
    next.tests = cloned.tests;
    next._exclusive = cloned._exclusive; // manually add the new tests to ensure
    // the deduping logic is consistent

    schema.tests.forEach(function (fn) {
      next = next.test(fn.TEST);
    });
    next._type = schema._type;
    return next;
  },
  isType: function isType(v) {
    if (this._nullable && v === null) return true;
    return !this._typeCheck || this._typeCheck(v);
  },
  resolve: function resolve(_ref) {
    var context = _ref.context,
        parent = _ref.parent;

    if (this._conditions.length) {
      return this._conditions.reduce(function (schema, match) {
        return match.resolve(schema, match.getValue(parent, context));
      }, this);
    }

    return this;
  },
  cast: function cast(value, options) {
    if (options === void 0) {
      options = {};
    }

    var resolvedSchema = this.resolve(options);

    var result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      var formattedValue = (0, _printValue.default)(value);
      var formattedResult = (0, _printValue.default)(result);
      throw new TypeError("The value of " + (options.path || 'field') + " could not be cast to a value " + ("that satisfies the schema type: \"" + resolvedSchema._type + "\". \n\n") + ("attempted value: " + formattedValue + " \n") + (formattedResult !== formattedValue ? "result of cast: " + formattedResult : ''));
    }

    return result;
  },
  _cast: function _cast(rawValue) {
    var _this3 = this;

    var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (value, fn) {
      return fn.call(_this3, value, rawValue);
    }, rawValue);

    if (value === undefined && (0, _has.default)(this, '_default')) {
      value = this.default();
    }

    return value;
  },
  _validate: function _validate(_value, options) {
    var _this4 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _value;
    var originalValue = options.originalValue != null ? options.originalValue : _value;

    var isStrict = this._option('strict', options);

    var endEarly = this._option('abortEarly', options);

    var sync = options.sync;
    var path = options.path;
    var label = this._label;

    if (!isStrict) {
      value = this._cast(value, (0, _extends2.default)({
        assert: false
      }, options));
    } // value is cast, we can check if it meets type requirements


    var validationParams = {
      value: value,
      path: path,
      schema: this,
      options: options,
      label: label,
      originalValue: originalValue,
      sync: sync
    };
    var initialTests = [];
    if (this._typeError) initialTests.push(this._typeError(validationParams));
    if (this._whitelistError) initialTests.push(this._whitelistError(validationParams));
    if (this._blacklistError) initialTests.push(this._blacklistError(validationParams));
    return (0, _runValidations.default)({
      validations: initialTests,
      endEarly: endEarly,
      value: value,
      path: path,
      sync: sync
    }).then(function (value) {
      return (0, _runValidations.default)({
        path: path,
        sync: sync,
        value: value,
        endEarly: endEarly,
        validations: _this4.tests.map(function (fn) {
          return fn(validationParams);
        })
      });
    });
  },
  validate: function validate(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(options);
    return schema._validate(value, options);
  },
  validateSync: function validateSync(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(options);
    var result, err;

    schema._validate(value, (0, _extends2.default)({}, options, {
      sync: true
    })).then(function (r) {
      return result = r;
    }).catch(function (e) {
      return err = e;
    });

    if (err) throw err;
    return result;
  },
  isValid: function isValid(value, options) {
    return this.validate(value, options).then(function () {
      return true;
    }).catch(function (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    });
  },
  isValidSync: function isValidSync(value, options) {
    try {
      this.validateSync(value, (0, _extends2.default)({}, options));
      return true;
    } catch (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    }
  },
  getDefault: function getDefault(options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(options);
    return schema.default();
  },
  default: function _default(def) {
    if (arguments.length === 0) {
      var defaultValue = (0, _has.default)(this, '_default') ? this._default : this._defaultDefault;
      return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, _cloneDeepWith.default)(defaultValue);
    }

    var next = this.clone();
    next._default = def;
    return next;
  },
  strict: function strict() {
    var next = this.clone();
    next._options.strict = true;
    return next;
  },
  required: function required(message) {
    if (message === void 0) {
      message = _locale.mixed.required;
    }

    return this.test({
      message: message,
      name: 'required',
      test: notEmpty
    });
  },
  notRequired: function notRequired() {
    var next = this.clone();
    next.tests = next.tests.filter(function (test) {
      return test.TEST_NAME !== 'required';
    });
    return next;
  },
  nullable: function nullable(value) {
    var next = this.clone();
    next._nullable = value === false ? false : true;
    return next;
  },
  transform: function transform(fn) {
    var next = this.clone();
    next.transforms.push(fn);
    return next;
  },

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test: function test() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var opts = args[0];

    if (args.length > 1) {
      var name = args[0],
          message = args[1],
          test = args[2];

      if (test == null) {
        test = message;
        message = _locale.mixed.default;
      }

      opts = {
        name: name,
        test: test,
        message: message,
        exclusive: false
      };
    }

    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    var next = this.clone();
    var validate = (0, _createValidation.default)(opts);
    var isExclusive = opts.exclusive || opts.name && next._exclusive[opts.name] === true;

    if (opts.exclusive && !opts.name) {
      throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    next._exclusive[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(function (fn) {
      if (fn.TEST_NAME === opts.name) {
        if (isExclusive) return false;
        if (fn.TEST.test === validate.TEST.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  },
  when: function when(keys, options) {
    var next = this.clone(),
        deps = [].concat(keys).map(function (key) {
      return new _Reference.default(key);
    });
    deps.forEach(function (dep) {
      if (!dep.isContext) next._deps.push(dep.key);
    });

    next._conditions.push(new _Condition.default(deps, options));

    return next;
  },
  typeError: function typeError(message) {
    var next = this.clone();
    next._typeError = (0, _createValidation.default)({
      message: message,
      name: 'typeError',
      test: function test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }
    });
    return next;
  },
  oneOf: function oneOf(enums, message) {
    if (message === void 0) {
      message = _locale.mixed.oneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = (0, _createValidation.default)({
      message: message,
      name: 'oneOf',
      test: function test(value) {
        if (value === undefined) return true;
        var valids = this.schema._whitelist;
        return valids.has(value, this.resolve) ? true : this.createError({
          params: {
            values: valids.toArray().join(', ')
          }
        });
      }
    });
    return next;
  },
  notOneOf: function notOneOf(enums, message) {
    if (message === void 0) {
      message = _locale.mixed.notOneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = (0, _createValidation.default)({
      message: message,
      name: 'notOneOf',
      test: function test(value) {
        var invalids = this.schema._blacklist;
        if (invalids.has(value, this.resolve)) return this.createError({
          params: {
            values: invalids.toArray().join(', ')
          }
        });
        return true;
      }
    });
    return next;
  },
  strip: function strip(_strip) {
    if (_strip === void 0) {
      _strip = true;
    }

    var next = this.clone();
    next._strip = _strip;
    return next;
  },
  _option: function _option(key, overrides) {
    return (0, _has.default)(overrides, key) ? overrides[key] : this._options[key];
  },
  describe: function describe() {
    var next = this.clone();
    return {
      type: next._type,
      meta: next._meta,
      label: next._label,
      tests: next.tests.map(function (fn) {
        return fn.TEST_NAME;
      }, {}).filter(function (n, idx, list) {
        return list.indexOf(n) === idx;
      })
    };
  }
};
var aliases = {
  oneOf: ['equals', 'is'],
  notOneOf: ['not', 'nope']
};
Object.keys(aliases).forEach(function (method) {
  aliases[method].forEach(function (alias) {
    return SchemaType.prototype[alias] = SchemaType.prototype[method];
  });
});
module.exports = exports["default"];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(761),
    getValue = __webpack_require__(764);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = function _default(obj) {
  return obj && obj.__isYupSchema__;
};

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(12).f;
var has = __webpack_require__(25);
var TAG = __webpack_require__(9)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(32);
var TAG = __webpack_require__(9)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(41);
var fails = __webpack_require__(7);
var spaces = __webpack_require__(160);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(592);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDynamicSamplingContextFromClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDynamicSamplingContextFromSpan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exports_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_getRootSpan_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_spanUtils_js__ = __webpack_require__(23);
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */function getDynamicSamplingContextFromClient(trace_id,client,scope){var options=client.getOptions();var _ref=client.getDsn()||{},public_key=_ref.publicKey;// TODO(v8): Remove segment from User
// eslint-disable-next-line deprecation/deprecation
var _ref2=scope&&scope.getUser()||{},user_segment=_ref2.segment;var dsc=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])({environment:options.environment||__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* DEFAULT_ENVIRONMENT */],release:options.release,user_segment:user_segment,public_key:public_key,trace_id:trace_id});client.emit&&client.emit('createDsc',dsc);return dsc;}/**
 * A Span with a frozen dynamic sampling context.
 *//**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */function getDynamicSamplingContextFromSpan(span){var client=Object(__WEBPACK_IMPORTED_MODULE_2__exports_js__["j" /* getClient */])();if(!client){return{};}// passing emit=false here to only emit later once the DSC is actually populated
var dsc=getDynamicSamplingContextFromClient(Object(__WEBPACK_IMPORTED_MODULE_4__utils_spanUtils_js__["e" /* spanToJSON */])(span).trace_id||'',client,Object(__WEBPACK_IMPORTED_MODULE_2__exports_js__["k" /* getCurrentScope */])());// TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
var txn=Object(__WEBPACK_IMPORTED_MODULE_3__utils_getRootSpan_js__["a" /* getRootSpan */])(span);if(!txn){return dsc;}// TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
// For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
// @see Transaction class constructor
var v7FrozenDsc=txn&&txn._frozenDynamicSamplingContext;if(v7FrozenDsc){return v7FrozenDsc;}// TODO (v8): Replace txn.metadata with txn.attributes[]
// We can't do this yet because attributes aren't always set yet.
// eslint-disable-next-line deprecation/deprecation
var _txn$metadata=txn.metadata,maybeSampleRate=_txn$metadata.sampleRate,source=_txn$metadata.source;if(maybeSampleRate!=null){dsc.sample_rate="".concat(maybeSampleRate);}// We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
var jsonSpan=Object(__WEBPACK_IMPORTED_MODULE_4__utils_spanUtils_js__["e" /* spanToJSON */])(txn);// after JSON conversion, txn.name becomes jsonSpan.description
if(source&&source!=='url'){dsc.transaction=jsonSpan.description;}dsc.sampled=String(Object(__WEBPACK_IMPORTED_MODULE_4__utils_spanUtils_js__["c" /* spanIsSampled */])(txn));client.emit&&client.emit('createDsc',dsc);return dsc;}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return observe; });
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */var observe=function observe(type,callback,opts){try{if(PerformanceObserver.supportedEntryTypes.includes(type)){var po=new PerformanceObserver(function(list){callback(list.getEntries());});po.observe(Object.assign({type:type,buffered:true},opts||{}));return po;}}catch(e){// Do nothing.
}return;};

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VERTICAL_SLUGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GUIDE_SLUGS; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isVerticalSlug;
/* harmony export (immutable) */ __webpack_exports__["c"] = isGuideSlug;
/* unused harmony export marketingContentPaths */
function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}/** Vertical landing pages: /for/:slug */var VERTICAL_SLUGS=['restaurants','hotels','bars','cafes','catering'];/** Guide articles: /guides/:slug */var GUIDE_SLUGS=['open-close','staff-onboarding','haccp-checks','cash-closing','mise-en-place','multi-location'];function isVerticalSlug(value){return VERTICAL_SLUGS.includes(value);}function isGuideSlug(value){return GUIDE_SLUGS.includes(value);}/** Paths to include in sitemap (locale prefix applied separately). */function marketingContentPaths(){return['/for'].concat(_toConsumableArray(VERTICAL_SLUGS.map(function(slug){return"/for/".concat(slug);})),['/guides'],_toConsumableArray(GUIDE_SLUGS.map(function(slug){return"/guides/".concat(slug);})));}

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trackEvent;
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Light funnel instrumentation. No-ops unless a host analytics bridge exists
 * (GTM dataLayer and/or Plausible). Never throws into product UI.
 */function trackEvent(name,payload){if(typeof window==='undefined')return;try{var w=window;if(Array.isArray(w.dataLayer)){w.dataLayer.push(_objectSpread({event:name},payload||{}));}if(typeof w.plausible==='function'){w.plausible(name,payload?{props:payload}:undefined);}}catch(_unused){// Ignore analytics failures
}}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(752),
    hasPath = __webpack_require__(327);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(90),
    getRawTag = __webpack_require__(753),
    objectToString = __webpack_require__(754);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(46);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 91 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(336),
    baseKeys = __webpack_require__(794),
    isArrayLike = __webpack_require__(231);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = exports.array = exports.object = exports.boolean = exports.date = exports.number = exports.string = exports.mixed = void 0;

var _printValue = _interopRequireDefault(__webpack_require__(151));

var mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " must be a `" + type + "` type, " + ("but the final value was: `" + (0, _printValue.default)(value, true) + "`") + (isCast ? " (cast from the value `" + (0, _printValue.default)(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
    }

    return msg;
  }
};
exports.mixed = mixed;
var string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
exports.string = string;
var number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  less: '${path} must be less than ${less}',
  more: '${path} must be greater than ${more}',
  notEqual: '${path} must be not equal to ${notEqual}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
exports.number = number;
var date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
exports.date = date;
var boolean = {};
exports.boolean = boolean;
var object = {
  noUnknown: '${path} field cannot have keys not specified in the object shape'
};
exports.object = object;
var array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items'
};
exports.array = array;
var _default = {
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  object: object,
  array: array,
  boolean: boolean
};
exports.default = _default;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = inherits;

var _extends2 = _interopRequireDefault(__webpack_require__(110));

function inherits(ctor, superCtor, spec) {
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  (0, _extends2.default)(ctor.prototype, spec);
}

module.exports = exports["default"];

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(30);
var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(53) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(32);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(4);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(4);
var aFunction = __webpack_require__(17);
var SPECIES = __webpack_require__(9)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(585);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(593);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(594);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(596);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(598);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(600);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(277);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(181);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(602);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(604);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(606);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(607);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(608);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ENVIRONMENT; });
var DEFAULT_ENVIRONMENT='production';

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateSession; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */function makeSession(context){// Both timestamp and started are in seconds since the UNIX epoch.
var startingTime=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_48" /* timestampInSeconds */])();var session={sid:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])(),init:true,timestamp:startingTime,started:startingTime,duration:0,status:'ok',errors:0,ignoreDuration:false,toJSON:function toJSON(){return sessionToJSON(session);}};if(context){updateSession(session,context);}return session;}/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */// eslint-disable-next-line complexity
function updateSession(session){var context=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(context.user){if(!session.ipAddress&&context.user.ip_address){session.ipAddress=context.user.ip_address;}if(!session.did&&!context.did){session.did=context.user.id||context.user.email||context.user.username;}}session.timestamp=context.timestamp||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_48" /* timestampInSeconds */])();if(context.abnormal_mechanism){session.abnormal_mechanism=context.abnormal_mechanism;}if(context.ignoreDuration){session.ignoreDuration=context.ignoreDuration;}if(context.sid){// Good enough uuid validation. — Kamil
session.sid=context.sid.length===32?context.sid:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])();}if(context.init!==undefined){session.init=context.init;}if(!session.did&&context.did){session.did="".concat(context.did);}if(typeof context.started==='number'){session.started=context.started;}if(session.ignoreDuration){session.duration=undefined;}else if(typeof context.duration==='number'){session.duration=context.duration;}else{var duration=session.timestamp-session.started;session.duration=duration>=0?duration:0;}if(context.release){session.release=context.release;}if(context.environment){session.environment=context.environment;}if(!session.ipAddress&&context.ipAddress){session.ipAddress=context.ipAddress;}if(!session.userAgent&&context.userAgent){session.userAgent=context.userAgent;}if(typeof context.errors==='number'){session.errors=context.errors;}if(context.status){session.status=context.status;}}/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */function closeSession(session,status){var context={};if(status){context={status:status};}else if(session.status==='ok'){context={status:'exited'};}updateSession(session,context);}/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */function sessionToJSON(session){return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])({sid:"".concat(session.sid),init:session.init,// Make sure that sec is converted to ms for date constructor
started:new Date(session.started*1000).toISOString(),timestamp:new Date(session.timestamp*1000).toISOString(),status:session.status,errors:session.errors,did:typeof session.did==='number'||typeof session.did==='string'?"".concat(session.did):undefined,duration:session.duration,abnormal_mechanism:session.abnormal_mechanism,attrs:{release:session.release,environment:session.environment,ip_address:session.ipAddress,user_agent:session.userAgent}});}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRootSpan; });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */function getRootSpan(span){// TODO (v8): Remove this check and just return span
// eslint-disable-next-line deprecation/deprecation
return span.transaction;}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SpanStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSpanStatusFromHttpCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setHttpStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return spanStatusfromHttpCode; });
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */var SpanStatus;(function(SpanStatus){/** The operation completed successfully. */var Ok='ok';SpanStatus["Ok"]=Ok;/** Deadline expired before operation could complete. */var DeadlineExceeded='deadline_exceeded';SpanStatus["DeadlineExceeded"]=DeadlineExceeded;/** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */var Unauthenticated='unauthenticated';SpanStatus["Unauthenticated"]=Unauthenticated;/** 403 Forbidden */var PermissionDenied='permission_denied';SpanStatus["PermissionDenied"]=PermissionDenied;/** 404 Not Found. Some requested entity (file or directory) was not found. */var NotFound='not_found';SpanStatus["NotFound"]=NotFound;/** 429 Too Many Requests */var ResourceExhausted='resource_exhausted';SpanStatus["ResourceExhausted"]=ResourceExhausted;/** Client specified an invalid argument. 4xx. */var InvalidArgument='invalid_argument';SpanStatus["InvalidArgument"]=InvalidArgument;/** 501 Not Implemented */var Unimplemented='unimplemented';SpanStatus["Unimplemented"]=Unimplemented;/** 503 Service Unavailable */var Unavailable='unavailable';SpanStatus["Unavailable"]=Unavailable;/** Other/generic 5xx. */var InternalError='internal_error';SpanStatus["InternalError"]=InternalError;/** Unknown. Any non-standard HTTP status code. */var UnknownError='unknown_error';SpanStatus["UnknownError"]=UnknownError;/** The operation was cancelled (typically by the user). */var Cancelled='cancelled';SpanStatus["Cancelled"]=Cancelled;/** Already exists (409) */var AlreadyExists='already_exists';SpanStatus["AlreadyExists"]=AlreadyExists;/** Operation was rejected because the system is not in a state required for the operation's */var FailedPrecondition='failed_precondition';SpanStatus["FailedPrecondition"]=FailedPrecondition;/** The operation was aborted, typically due to a concurrency issue. */var Aborted='aborted';SpanStatus["Aborted"]=Aborted;/** Operation was attempted past the valid range. */var OutOfRange='out_of_range';SpanStatus["OutOfRange"]=OutOfRange;/** Unrecoverable data loss or corruption */var DataLoss='data_loss';SpanStatus["DataLoss"]=DataLoss;})(SpanStatus||(SpanStatus={}));/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */function getSpanStatusFromHttpCode(httpStatus){if(httpStatus<400&&httpStatus>=100){return'ok';}if(httpStatus>=400&&httpStatus<500){switch(httpStatus){case 401:return'unauthenticated';case 403:return'permission_denied';case 404:return'not_found';case 409:return'already_exists';case 413:return'failed_precondition';case 429:return'resource_exhausted';default:return'invalid_argument';}}if(httpStatus>=500&&httpStatus<600){switch(httpStatus){case 501:return'unimplemented';case 503:return'unavailable';case 504:return'deadline_exceeded';default:return'internal_error';}}return'unknown_error';}/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */var spanStatusfromHttpCode=getSpanStatusFromHttpCode;/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */function setHttpStatus(span,httpStatus){// TODO (v8): Remove these calls
// Relay does not require us to send the status code as a tag
// For now, just because users might expect it to land as a tag we keep sending it.
// Same with data.
// In v8, we replace both, simply with
// span.setAttribute('http.response.status_code', httpStatus);
// eslint-disable-next-line deprecation/deprecation
span.setTag('http.status_code',String(httpStatus));// eslint-disable-next-line deprecation/deprecation
span.setData('http.response.status_code',httpStatus);var spanStatus=getSpanStatusFromHttpCode(httpStatus);if(spanStatus!=='unknown_error'){span.setStatus(spanStatus);}}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addClsInstrumentationHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addFidInstrumentationHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addInpInstrumentationHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addLcpInstrumentationHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addPerformanceInstrumentationHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addTtfbInstrumentationHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__web_vitals_getCLS_js__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__web_vitals_getFID_js__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__web_vitals_getINP_js__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__web_vitals_getLCP_js__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__web_vitals_lib_observe_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__web_vitals_onTTFB_js__ = __webpack_require__(672);
var handlers={};var instrumented={};var _previousCls;var _previousFid;var _previousLcp;var _previousTtfb;var _previousInp;/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */function addClsInstrumentationHandler(callback){var stopOnCallback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return addMetricObserver('cls',callback,instrumentCls,_previousCls,stopOnCallback);}/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */function addLcpInstrumentationHandler(callback){var stopOnCallback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return addMetricObserver('lcp',callback,instrumentLcp,_previousLcp,stopOnCallback);}/**
 * Add a callback that will be triggered when a FID metric is available.
 */function addTtfbInstrumentationHandler(callback){return addMetricObserver('ttfb',callback,instrumentTtfb,_previousTtfb);}/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */function addFidInstrumentationHandler(callback){return addMetricObserver('fid',callback,instrumentFid,_previousFid);}/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */function addInpInstrumentationHandler(callback){return addMetricObserver('inp',callback,instrumentInp,_previousInp);}/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */function addPerformanceInstrumentationHandler(type,callback){addHandler(type,callback);if(!instrumented[type]){instrumentPerformanceObserver(type);instrumented[type]=true;}return getCleanupCallback(type,callback);}/** Trigger all handlers of a given type. */function triggerHandlers(type,data){var typeHandlers=handlers[type];if(!typeHandlers||!typeHandlers.length){return;}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=typeHandlers[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var handler=_step.value;try{handler(data);}catch(e){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error("Error while triggering instrumentation handler.\nType: ".concat(type,"\nName: ").concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_0" /* getFunctionName */])(handler),"\nError:"),e);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}function instrumentCls(){return Object(__WEBPACK_IMPORTED_MODULE_2__web_vitals_getCLS_js__["a" /* onCLS */])(function(metric){triggerHandlers('cls',{metric:metric});_previousCls=metric;},{reportAllChanges:true});}function instrumentFid(){return Object(__WEBPACK_IMPORTED_MODULE_3__web_vitals_getFID_js__["a" /* onFID */])(function(metric){triggerHandlers('fid',{metric:metric});_previousFid=metric;});}function instrumentLcp(){return Object(__WEBPACK_IMPORTED_MODULE_5__web_vitals_getLCP_js__["a" /* onLCP */])(function(metric){triggerHandlers('lcp',{metric:metric});_previousLcp=metric;});}function instrumentTtfb(){return Object(__WEBPACK_IMPORTED_MODULE_7__web_vitals_onTTFB_js__["a" /* onTTFB */])(function(metric){triggerHandlers('ttfb',{metric:metric});_previousTtfb=metric;});}function instrumentInp(){return Object(__WEBPACK_IMPORTED_MODULE_4__web_vitals_getINP_js__["a" /* onINP */])(function(metric){triggerHandlers('inp',{metric:metric});_previousInp=metric;});}function addMetricObserver(type,callback,instrumentFn,previousValue){var stopOnCallback=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;addHandler(type,callback);var stopListening;if(!instrumented[type]){stopListening=instrumentFn();instrumented[type]=true;}if(previousValue){callback({metric:previousValue});}return getCleanupCallback(type,callback,stopOnCallback?stopListening:undefined);}function instrumentPerformanceObserver(type){var options={};// Special per-type options we want to use
if(type==='event'){options.durationThreshold=0;}Object(__WEBPACK_IMPORTED_MODULE_6__web_vitals_lib_observe_js__["a" /* observe */])(type,function(entries){triggerHandlers(type,{entries:entries});},options);}function addHandler(type,handler){handlers[type]=handlers[type]||[];handlers[type].push(handler);}// Get a callback which can be called to remove the instrumentation handler
function getCleanupCallback(type,callback,stopListening){return function(){if(stopListening){stopListening();}var typeHandlers=handlers[type];if(!typeHandlers){return;}var index=typeHandlers.indexOf(callback);if(index!==-1){typeHandlers.splice(index,1);}};}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindReporter; });
var bindReporter=function bindReporter(callback,metric,reportAllChanges){var prevValue;var delta;return function(forceReport){if(metric.value>=0){if(forceReport||reportAllChanges){delta=metric.value-(prevValue||0);// Report the metric if there's a non-zero delta or if no previous
// value exists (which can happen in the case of the document becoming
// hidden when the metric value is 0).
// See: https://github.com/GoogleChrome/web-vitals/issues/14
if(delta||prevValue===undefined){prevValue=metric.value;metric.delta=delta;callback(metric);}}}};};

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initMetric; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateUniqueID_js__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getActivationStart_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getNavigationEntry_js__ = __webpack_require__(138);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var initMetric=function initMetric(name,value){var navEntry=Object(__WEBPACK_IMPORTED_MODULE_3__getNavigationEntry_js__["a" /* getNavigationEntry */])();var navigationType='navigate';if(navEntry){if(__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].document&&__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].document.prerendering||Object(__WEBPACK_IMPORTED_MODULE_2__getActivationStart_js__["a" /* getActivationStart */])()>0){navigationType='prerender';}else{navigationType=navEntry.type.replace(/_/g,'-');}}return{name:name,value:typeof value==='undefined'?-1:value,rating:'good',// Will be updated if the value changes.
delta:0,entries:[],id:Object(__WEBPACK_IMPORTED_MODULE_1__generateUniqueID_js__["a" /* generateUniqueID */])(),navigationType:navigationType};};

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onHidden; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_js__ = __webpack_require__(29);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var onHidden=function onHidden(cb,once){var onHiddenOrPageHide=function onHiddenOrPageHide(event){if(event.type==='pagehide'||__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].document.visibilityState==='hidden'){cb(event);if(once){removeEventListener('visibilitychange',onHiddenOrPageHide,true);removeEventListener('pagehide',onHiddenOrPageHide,true);}}};if(__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].document){addEventListener('visibilitychange',onHiddenOrPageHide,true);// Some browsers have buggy implementations of visibilitychange,
// so we use pagehide in addition, just to be safe.
addEventListener('pagehide',onHiddenOrPageHide,true);}};

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_LOCALE */
/* harmony export (immutable) */ __webpack_exports__["a"] = parseLocale;
/* harmony export (immutable) */ __webpack_exports__["b"] = withLocalePrefix;
var DEFAULT_LOCALE='en';/**
 * English routes use no prefix; Dutch uses `/nl` (e.g. `/nl/onboard`).
 */function parseLocale(pathname){var raw=pathname.split('?')[0]||'/';var p=raw;if(p.length>1&&p.endsWith('/')){p=p.slice(0,-1);}if(p==='/nl'){return{locale:'nl',strippedPath:'/'};}if(p.startsWith('/nl/')){var rest=p.slice('/nl'.length);return{locale:'nl',strippedPath:rest||'/'};}return{locale:'en',strippedPath:p||'/'};}function withLocalePrefix(locale,path){var normalized=path.startsWith('/')?path:"/".concat(path);if(locale==='en'){return normalized==='/'?'/':normalized;}if(normalized==='/'){return'/nl';}return"/nl".concat(normalized);}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(779);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(804),
    Map = __webpack_require__(223),
    Promise = __webpack_require__(805),
    Set = __webpack_require__(806),
    WeakMap = __webpack_require__(807),
    baseGetTag = __webpack_require__(89),
    toSource = __webpack_require__(331);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value == null;
};

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propertyExpr = __webpack_require__(152);

var validateName = function validateName(d) {
  if (typeof d !== 'string') throw new TypeError("ref's must be strings, got: " + d);
};

var Reference =
/*#__PURE__*/
function () {
  Reference.isRef = function isRef(value) {
    return !!(value && (value.__isYupRef || value instanceof Reference));
  };

  var _proto = Reference.prototype;

  _proto.toString = function toString() {
    return "Ref(" + this.key + ")";
  };

  function Reference(key, mapFn, options) {
    if (options === void 0) {
      options = {};
    }

    validateName(key);
    var prefix = options.contextPrefix || '$';

    if (typeof key === 'function') {
      key = '.';
    }

    this.key = key.trim();
    this.prefix = prefix;
    this.isContext = this.key.indexOf(prefix) === 0;
    this.isSelf = this.key === '.';
    this.path = this.isContext ? this.key.slice(this.prefix.length) : this.key;
    this._get = (0, _propertyExpr.getter)(this.path, true);

    this.map = mapFn || function (value) {
      return value;
    };
  }

  _proto.resolve = function resolve() {
    return this;
  };

  _proto.cast = function cast(value, _ref) {
    var parent = _ref.parent,
        context = _ref.context;
    return this.getValue(parent, context);
  };

  _proto.getValue = function getValue(parent, context) {
    var isContext = this.isContext;

    var value = this._get(isContext ? context : parent || context || {});

    return this.map(value);
  };

  return Reference;
}();

exports.default = Reference;
Reference.prototype.__isYupRef = true;
module.exports = exports["default"];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(65);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 116 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(32);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(33);
var defined = __webpack_require__(41);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(8);
var cof = __webpack_require__(32);
var MATCH = __webpack_require__(9)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(9)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(80);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(259);
var redefine = __webpack_require__(20);
var hide = __webpack_require__(19);
var fails = __webpack_require__(7);
var defined = __webpack_require__(41);
var wks = __webpack_require__(9);
var regexpExec = __webpack_require__(175);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(20);
var redefineAll = __webpack_require__(71);
var meta = __webpack_require__(54);
var forOf = __webpack_require__(70);
var anInstance = __webpack_require__(69);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var $iterDetect = __webpack_require__(120);
var setToStringTag = __webpack_require__(79);
var inheritIfRequired = __webpack_require__(161);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(19);
var uid = __webpack_require__(63);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(53) || !__webpack_require__(7)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(5)[K];
});


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(17);
var ctx = __webpack_require__(31);
var forOf = __webpack_require__(70);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isMatchingPattern */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeJoin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return snipLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return stringMatchesSomePattern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return truncate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_js__ = __webpack_require__(35);
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */function truncate(str){var max=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;if(typeof str!=='string'||max===0){return str;}return str.length<=max?str:"".concat(str.slice(0,max),"...");}/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */function snipLine(line,colno){var newLine=line;var lineLength=newLine.length;if(lineLength<=150){return newLine;}if(colno>lineLength){// eslint-disable-next-line no-param-reassign
colno=lineLength;}var start=Math.max(colno-60,0);if(start<5){start=0;}var end=Math.min(start+140,lineLength);if(end>lineLength-5){end=lineLength;}if(end===lineLength){start=Math.max(end-140,0);}newLine=newLine.slice(start,end);if(start>0){newLine="'{snip} ".concat(newLine);}if(end<lineLength){newLine+=' {snip}';}return newLine;}/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input,delimiter){if(!Array.isArray(input)){return'';}var output=[];// eslint-disable-next-line @typescript-eslint/prefer-for-of
for(var i=0;i<input.length;i++){var value=input[i];try{// This is a hack to fix a Vue3-specific bug that causes an infinite loop of
// console warnings. This happens when a Vue template is rendered with
// an undeclared variable, which we try to stringify, ultimately causing
// Vue to issue another warning which repeats indefinitely.
// see: https://github.com/getsentry/sentry-javascript/pull/8981
if(Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["p" /* isVueViewModel */])(value)){output.push('[VueViewModel]');}else{output.push(String(value));}}catch(e){output.push('[value cannot be serialized]');}}return output.join(delimiter);}/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */function isMatchingPattern(value,pattern){var requireExactStringMatch=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;if(!Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["m" /* isString */])(value)){return false;}if(Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["l" /* isRegExp */])(pattern)){return pattern.test(value);}if(Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["m" /* isString */])(pattern)){return requireExactStringMatch?value===pattern:value.includes(pattern);}return false;}/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */function stringMatchesSomePattern(testString){var patterns=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var requireExactStringMatch=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return patterns.some(function(pattern){return isMatchingPattern(testString,pattern,requireExactStringMatch);});}

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filenameIsInApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return node; });
/**
 * Does this filename look like it's part of the app code?
 */function filenameIsInApp(filename){var isNative=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var isInternal=isNative||filename&&// It's not internal if it's an absolute linux path
!filename.startsWith('/')&&// It's not internal if it's an absolute windows path
!filename.match(/^[A-Z]:/)&&// It's not internal if the path is starting with a dot
!filename.startsWith('.')&&// It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
!filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//);// Schema from: https://stackoverflow.com/a/3641782
// in_app is all that's not an internal Node function or a module within node_modules
// note that isNative appears to return true even for node core libraries
// see https://github.com/getsentry/raven-node/issues/176
return!isInternal&&filename!==undefined&&!filename.includes('node_modules/');}/** Node Stack line parser */// eslint-disable-next-line complexity
function node(getModule){var FILENAME_MATCH=/^\s*[-]{4,}$/;var FULL_MATCH=/at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;// eslint-disable-next-line complexity
return function(line){var lineMatch=line.match(FULL_MATCH);if(lineMatch){var object;var method;var functionName;var typeName;var methodName;if(lineMatch[1]){functionName=lineMatch[1];var methodStart=functionName.lastIndexOf('.');if(functionName[methodStart-1]==='.'){methodStart--;}if(methodStart>0){object=functionName.slice(0,methodStart);method=functionName.slice(methodStart+1);var objectEnd=object.indexOf('.Module');if(objectEnd>0){functionName=functionName.slice(objectEnd+1);object=object.slice(0,objectEnd);}}typeName=undefined;}if(method){typeName=object;methodName=method;}if(method==='<anonymous>'){methodName=undefined;functionName=undefined;}if(functionName===undefined){methodName=methodName||'<anonymous>';functionName=typeName?"".concat(typeName,".").concat(methodName):methodName;}var filename=lineMatch[2]&&lineMatch[2].startsWith('file://')?lineMatch[2].slice(7):lineMatch[2];var isNative=lineMatch[5]==='native';// If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
if(filename&&filename.match(/\/[A-Z]:/)){filename=filename.slice(1);}if(!filename&&lineMatch[5]&&!isNative){filename=lineMatch[5];}return{filename:filename,module:getModule?getModule(filename):undefined,function:functionName,lineno:parseInt(lineMatch[3],10)||undefined,colno:parseInt(lineMatch[4],10)||undefined,in_app:filenameIsInApp(filename,isNative)};}if(line.match(FILENAME_MATCH)){return{filename:line};}return undefined;};}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addContextToFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addExceptionMechanism; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addExceptionTypeValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return arrayify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return checkOrSetAlreadyCaught; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getEventDescription; });
/* unused harmony export parseSemver */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return uuid4; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__string_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__worldwide_js__ = __webpack_require__(18);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */function uuid4(){var gbl=__WEBPACK_IMPORTED_MODULE_2__worldwide_js__["a" /* GLOBAL_OBJ */];var crypto=gbl.crypto||gbl.msCrypto;var getRandomByte=function getRandomByte(){return Math.random()*16;};try{if(crypto&&crypto.randomUUID){return crypto.randomUUID().replace(/-/g,'');}if(crypto&&crypto.getRandomValues){getRandomByte=function getRandomByte(){// crypto.getRandomValues might return undefined instead of the typed array
// in old Chromium versions (e.g. 23.0.1235.0 (151422))
// However, `typedArray` is still filled in-place.
// @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
var typedArray=new Uint8Array(1);crypto.getRandomValues(typedArray);return typedArray[0];};}}catch(_){// some runtimes can crash invoking crypto
// https://github.com/getsentry/sentry-javascript/issues/8935
}// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
// Concatenating the following numbers as strings results in '10000000100040008000100000000000'
return([1e7]+1e3+4e3+8e3+1e11).replace(/[018]/g,function(c){return(// eslint-disable-next-line no-bitwise
(c^(getRandomByte()&15)>>c/4).toString(16));});}function getFirstException(event){return event.exception&&event.exception.values?event.exception.values[0]:undefined;}/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */function getEventDescription(event){var message=event.message,eventId=event.event_id;if(message){return message;}var firstException=getFirstException(event);if(firstException){if(firstException.type&&firstException.value){return"".concat(firstException.type,": ").concat(firstException.value);}return firstException.type||firstException.value||eventId||'<unknown>';}return eventId||'<unknown>';}/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */function addExceptionTypeValue(event,value,type){var exception=event.exception=event.exception||{};var values=exception.values=exception.values||[];var firstException=values[0]=values[0]||{};if(!firstException.value){firstException.value=value||'';}if(!firstException.type){firstException.type=type||'Error';}}/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */function addExceptionMechanism(event,newMechanism){var firstException=getFirstException(event);if(!firstException){return;}var defaultMechanism={type:'generic',handled:true};var currentMechanism=firstException.mechanism;firstException.mechanism=_objectSpread({},defaultMechanism,{},currentMechanism,{},newMechanism);if(newMechanism&&'data'in newMechanism){var mergedData=_objectSpread({},currentMechanism&&currentMechanism.data,{},newMechanism.data);firstException.mechanism.data=mergedData;}}// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP=/^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;/**
 * Represents Semantic Versioning object
 *//**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */function parseSemver(input){var match=input.match(SEMVER_REGEXP)||[];var major=parseInt(match[1],10);var minor=parseInt(match[2],10);var patch=parseInt(match[3],10);return{buildmetadata:match[5],major:isNaN(major)?undefined:major,minor:isNaN(minor)?undefined:minor,patch:isNaN(patch)?undefined:patch,prerelease:match[4]};}/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */function addContextToFrame(lines,frame){var linesOfContext=arguments.length>2&&arguments[2]!==undefined?arguments[2]:5;// When there is no line number in the frame, attaching context is nonsensical and will even break grouping
if(frame.lineno===undefined){return;}var maxLines=lines.length;var sourceLine=Math.max(Math.min(maxLines-1,frame.lineno-1),0);frame.pre_context=lines.slice(Math.max(0,sourceLine-linesOfContext),sourceLine).map(function(line){return Object(__WEBPACK_IMPORTED_MODULE_1__string_js__["b" /* snipLine */])(line,0);});frame.context_line=Object(__WEBPACK_IMPORTED_MODULE_1__string_js__["b" /* snipLine */])(lines[Math.min(maxLines-1,sourceLine)],frame.colno||0);frame.post_context=lines.slice(Math.min(sourceLine+1,maxLines),sourceLine+1+linesOfContext).map(function(line){return Object(__WEBPACK_IMPORTED_MODULE_1__string_js__["b" /* snipLine */])(line,0);});}/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */function checkOrSetAlreadyCaught(exception){// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
if(exception&&exception.__sentry_captured__){return true;}try{// set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
// `ExtraErrorData` integration
Object(__WEBPACK_IMPORTED_MODULE_0__object_js__["a" /* addNonEnumerableProperty */])(exception,'__sentry_captured__',true);}catch(err){// `exception` is a primitive, so we can't mark it seen
}return false;}/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */function arrayify(maybeArray){return Array.isArray(maybeArray)?maybeArray:[maybeArray];}

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizeToSize; });
/* unused harmony export normalizeUrlToBase */
/* unused harmony export walk */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__memo_js__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__object_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stacktrace_js__ = __webpack_require__(185);
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input){var depth=arguments.length>1&&arguments[1]!==undefined?arguments[1]:100;var maxProperties=arguments.length>2&&arguments[2]!==undefined?arguments[2]:+Infinity;try{// since we're at the outermost level, we don't provide a key
return visit('',input,depth,maxProperties);}catch(err){return{ERROR:"**non-serializable** (".concat(err,")")};}}/** JSDoc */function normalizeToSize(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object){var depth=arguments.length>1&&arguments[1]!==undefined?arguments[1]:3;var maxSize=arguments.length>2&&arguments[2]!==undefined?arguments[2]:100*1024;var normalized=normalize(object,depth);if(jsonSize(normalized)>maxSize){return normalizeToSize(object,depth-1,maxSize);}return normalized;}/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */function visit(key,value){var depth=arguments.length>2&&arguments[2]!==undefined?arguments[2]:+Infinity;var maxProperties=arguments.length>3&&arguments[3]!==undefined?arguments[3]:+Infinity;var memo=arguments.length>4&&arguments[4]!==undefined?arguments[4]:Object(__WEBPACK_IMPORTED_MODULE_1__memo_js__["a" /* memoBuilder */])();var _memo=_slicedToArray(memo,2),memoize=_memo[0],unmemoize=_memo[1];// Get the simple cases out of the way first
if(value==null||// this matches null and undefined -> eqeq not eqeqeq
['number','boolean','string'].includes(_typeof(value))&&!Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["h" /* isNaN */])(value)){return value;}var stringified=stringifyValue(key,value);// Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
// Everything else will have already been serialized, so if we don't see that pattern, we're done.
if(!stringified.startsWith('[object ')){return stringified;}// From here on, we can assert that `value` is either an object or an array.
// Do not normalize objects that we know have already been normalized. As a general rule, the
// "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
// have already been normalized.
if(value['__sentry_skip_normalization__']){return value;}// We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
// We keep a certain amount of depth.
// This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
var remainingDepth=typeof value['__sentry_override_normalization_depth__']==='number'?value['__sentry_override_normalization_depth__']:depth;// We're also done if we've reached the max depth
if(remainingDepth===0){// At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
return stringified.replace('object ','');}// If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
if(memoize(value)){return'[Circular ~]';}// If the value has a `toJSON` method, we call it to extract more information
var valueWithToJSON=value;if(valueWithToJSON&&typeof valueWithToJSON.toJSON==='function'){try{var jsonValue=valueWithToJSON.toJSON();// We need to normalize the return value of `.toJSON()` in case it has circular references
return visit('',jsonValue,remainingDepth-1,maxProperties,memo);}catch(err){// pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
}}// At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
// because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
// property/entry, and keep track of the number of items we add to it.
var normalized=Array.isArray(value)?[]:{};var numAdded=0;// Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
// properties are non-enumerable and otherwise would get missed.
var visitable=Object(__WEBPACK_IMPORTED_MODULE_2__object_js__["b" /* convertToPlainObject */])(value);for(var visitKey in visitable){// Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
if(!Object.prototype.hasOwnProperty.call(visitable,visitKey)){continue;}if(numAdded>=maxProperties){normalized[visitKey]='[MaxProperties ~]';break;}// Recursively visit all the child nodes
var visitValue=visitable[visitKey];normalized[visitKey]=visit(visitKey,visitValue,remainingDepth-1,maxProperties,memo);numAdded++;}// Once we've visited all the branches, remove the parent from memo storage
unmemoize(value);// Return accumulated values
return normalized;}/* eslint-disable complexity *//**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */function stringifyValue(key,// this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value){try{if(key==='domain'&&value&&_typeof(value)==='object'&&value._events){return'[Domain]';}if(key==='domainEmitter'){return'[DomainEmitter]';}// It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
// which won't throw if they are not present.
if(typeof global!=='undefined'&&value===global){return'[Global]';}// eslint-disable-next-line no-restricted-globals
if(typeof window!=='undefined'&&value===window){return'[Window]';}// eslint-disable-next-line no-restricted-globals
if(typeof document!=='undefined'&&value===document){return'[Document]';}if(Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["p" /* isVueViewModel */])(value)){return'[VueViewModel]';}// React's SyntheticEvent thingy
if(Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["n" /* isSyntheticEvent */])(value)){return'[SyntheticEvent]';}if(typeof value==='number'&&value!==value){return'[NaN]';}if(typeof value==='function'){return"[Function: ".concat(Object(__WEBPACK_IMPORTED_MODULE_3__stacktrace_js__["b" /* getFunctionName */])(value),"]");}if(_typeof(value)==='symbol'){return"[".concat(String(value),"]");}// stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
if(typeof value==='bigint'){return"[BigInt: ".concat(String(value),"]");}// Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
// them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
// `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
// we can make sure that only plain objects come out that way.
var objName=getConstructorName(value);// Handle HTML Elements
if(/^HTML(\w*)Element$/.test(objName)){return"[HTMLElement: ".concat(objName,"]");}return"[object ".concat(objName,"]");}catch(err){return"**non-serializable** (".concat(err,")");}}/* eslint-enable complexity */function getConstructorName(value){var prototype=Object.getPrototypeOf(value);return prototype?prototype.constructor.name:'null prototype';}/** Calculates bytes size of input string */function utf8Length(value){// eslint-disable-next-line no-bitwise
return~-encodeURI(value).split(/%..|./).length;}/** Calculates bytes size of input object */// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value){return utf8Length(JSON.stringify(value));}/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */function normalizeUrlToBase(url,basePath){var escapedBase=basePath// Backslash to forward
.replace(/\\/g,'/')// Escape RegExp special characters
.replace(/[|\\{}()[\]^$+*?.]/g,'\\$&');var newUrl=url;try{newUrl=decodeURI(url);}catch(_Oo){// Sometime this breaks
}return newUrl.replace(/\\/g,'/').replace(/webpack:\/?/g,'')// Remove intermediate base path
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
.replace(new RegExp("(file://)?/*".concat(escapedBase,"/*"),'ig'),'app:///');}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(52)))

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addGlobalEventProcessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGlobalEventProcessors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return notifyEventProcessors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */function getGlobalEventProcessors(){return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_1" /* getGlobalSingleton */])('globalEventProcessors',function(){return[];});}/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */function addGlobalEventProcessor(callback){// eslint-disable-next-line deprecation/deprecation
getGlobalEventProcessors().push(callback);}/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */function notifyEventProcessors(processors,event,hint){var index=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;return new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["f" /* SyncPromise */](function(resolve,reject){var processor=processors[index];if(event===null||typeof processor!=='function'){resolve(event);}else{var result=processor(_objectSpread({},event),hint);__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&processor.id&&result===null&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("Event processor \"".concat(processor.id,"\" dropped event"));if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_24" /* isThenable */])(result)){void result.then(function(final){return notifyEventProcessors(processors,final,hint,index+1).then(resolve);}).then(null,reject);}else{void notifyEventProcessors(processors,result,hint,index+1).then(resolve).then(null,reject);}}});}

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMetricSummaryJsonForSpan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateMetricSummaryOnActiveSpan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracing_errors_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracing_spanstatus_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracing_trace_js__ = __webpack_require__(200);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */var SPAN_METRIC_SUMMARY;function getMetricStorageForSpan(span){return SPAN_METRIC_SUMMARY?SPAN_METRIC_SUMMARY.get(span):undefined;}/**
 * Fetches the metric summary if it exists for the passed span
 */function getMetricSummaryJsonForSpan(span){var storage=getMetricStorageForSpan(span);if(!storage){return undefined;}var output={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=storage[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _step$value=_slicedToArray(_step.value,2),_step$value$=_slicedToArray(_step$value[1],2),exportKey=_step$value$[0],summary=_step$value$[1];if(!output[exportKey]){output[exportKey]=[];}output[exportKey].push(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])(summary));}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return output;}/**
 * Updates the metric summary on the currently active span
 */function updateMetricSummaryOnActiveSpan(metricType,sanitizedName,value,unit,tags,bucketKey){var span=Object(__WEBPACK_IMPORTED_MODULE_4__tracing_trace_js__["b" /* getActiveSpan */])();if(span){var storage=getMetricStorageForSpan(span)||new Map();var exportKey="".concat(metricType,":").concat(sanitizedName,"@").concat(unit);var bucketItem=storage.get(bucketKey);if(bucketItem){var _bucketItem=_slicedToArray(bucketItem,2),summary=_bucketItem[1];storage.set(bucketKey,[exportKey,{min:Math.min(summary.min,value),max:Math.max(summary.max,value),count:summary.count+=1,sum:summary.sum+=value,tags:summary.tags}]);}else{storage.set(bucketKey,[exportKey,{min:value,max:value,count:1,sum:value,tags:tags}]);}if(!SPAN_METRIC_SUMMARY){SPAN_METRIC_SUMMARY=new WeakMap();}SPAN_METRIC_SUMMARY.set(span,storage);}}

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEMANTIC_ATTRIBUTE_PROFILE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SEMANTIC_ATTRIBUTE_SENTRY_OP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEMANTIC_ATTRIBUTE_SENTRY_SOURCE; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */var SEMANTIC_ATTRIBUTE_SENTRY_SOURCE='sentry.source';/**
 * Use this attribute to represent the sample rate used for a span.
 */var SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE='sentry.sample_rate';/**
 * Use this attribute to represent the operation of a span.
 */var SEMANTIC_ATTRIBUTE_SENTRY_OP='sentry.op';/**
 * Use this attribute to represent the origin of a span.
 */var SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN='sentry.origin';/**
 * The id of the profile that this span occured in.
 */var SEMANTIC_ATTRIBUTE_PROFILE_ID='profile_id';

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBucketKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sanitizeMetricKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sanitizeTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sanitizeUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return serializeMetricBuckets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return simpleHash; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}/**
 * Generate bucket key from metric properties.
 */function getBucketKey(metricType,name,unit,tags){var stringifiedTags=Object.entries(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])(tags)).sort(function(a,b){return a[0].localeCompare(b[0]);});return"".concat(metricType).concat(name).concat(unit).concat(stringifiedTags);}/* eslint-disable no-bitwise *//**
 * Simple hash function for strings.
 */function simpleHash(s){var rv=0;for(var i=0;i<s.length;i++){var c=s.charCodeAt(i);rv=(rv<<5)-rv+c;rv&=rv;}return rv>>>0;}/* eslint-enable no-bitwise *//**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */function serializeMetricBuckets(metricBucketItems){var out='';var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=metricBucketItems[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var item=_step.value;var tagEntries=Object.entries(item.tags);var maybeTags=tagEntries.length>0?"|#".concat(tagEntries.map(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return"".concat(key,":").concat(value);}).join(',')):'';out+="".concat(item.name,"@").concat(item.unit,":").concat(item.metric,"|").concat(item.metricType).concat(maybeTags,"|T").concat(item.timestamp,"\n");}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return out;}/** Sanitizes units */function sanitizeUnit(unit){return unit.replace(/[^\w]+/gi,'_');}/** Sanitizes metric keys */function sanitizeMetricKey(key){return key.replace(/[^\w\-.]+/gi,'_');}function sanitizeTagKey(key){return key.replace(/[^\w\-./]+/gi,'');}var tagValueReplacements=[['\n','\\n'],['\r','\\r'],['\t','\\t'],['\\','\\\\'],['|',"\\u{7c}"],[',',"\\u{2c}"]];function getCharOrReplacement(input){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=tagValueReplacements[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _step2$value=_slicedToArray(_step2.value,2),search=_step2$value[0],replacement=_step2$value[1];if(input===search){return replacement;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return!=null){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return input;}function sanitizeTagValue(value){return _toConsumableArray(value).reduce(function(acc,char){return acc+getCharOrReplacement(char);},'');}/**
 * Sanitizes tags.
 */function sanitizeTags(unsanitizedTags){var tags={};for(var key in unsanitizedTags){if(Object.prototype.hasOwnProperty.call(unsanitizedTags,key)){var sanitizedKey=sanitizeTagKey(key);tags[sanitizedKey]=sanitizeTagValue(String(unsanitizedTags[key]));}}return tags;}

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COUNTER_METRIC_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_BROWSER_FLUSH_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_FLUSH_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISTRIBUTION_METRIC_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GAUGE_METRIC_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MAX_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_METRIC_TYPE; });
var COUNTER_METRIC_TYPE='c';var GAUGE_METRIC_TYPE='g';var SET_METRIC_TYPE='s';var DISTRIBUTION_METRIC_TYPE='d';/**
 * This does not match spec in https://develop.sentry.dev/sdk/metrics
 * but was chosen to optimize for the most common case in browser environments.
 */var DEFAULT_BROWSER_FLUSH_INTERVAL=5000;/**
 * SDKs are required to bucket into 10 second intervals (rollup in seconds)
 * which is the current lower bound of metric accuracy.
 */var DEFAULT_FLUSH_INTERVAL=10000;/**
 * The maximum number of metrics that should be stored in memory.
 */var MAX_WEIGHT=10000;

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNavigationEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_js__ = __webpack_require__(29);
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var getNavigationEntryFromPerformanceTiming=function getNavigationEntryFromPerformanceTiming(){// eslint-disable-next-line deprecation/deprecation
var timing=__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].performance.timing;// eslint-disable-next-line deprecation/deprecation
var type=__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].performance.navigation.type;var navigationEntry={entryType:'navigation',startTime:0,type:type==2?'back_forward':type===1?'reload':'navigate'};for(var key in timing){if(key!=='navigationStart'&&key!=='toJSON'){// eslint-disable-next-line deprecation/deprecation
navigationEntry[key]=Math.max(timing[key]-timing.navigationStart,0);}}return navigationEntry;};var getNavigationEntry=function getNavigationEntry(){if(__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].__WEB_VITALS_POLYFILL__){return __WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].performance&&(performance.getEntriesByType&&performance.getEntriesByType('navigation')[0]||getNavigationEntryFromPerformanceTiming());}else{return __WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].performance&&performance.getEntriesByType&&performance.getEntriesByType('navigation')[0];}};

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export eventFromError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventFromException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eventFromMessage; });
/* unused harmony export eventFromPlainObject */
/* unused harmony export eventFromString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return eventFromUnknownInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return exceptionFromError; });
/* unused harmony export parseStackFrames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * This function creates an exception from a JavaScript Error
 */function exceptionFromError(stackParser,ex){// Get the frames first since Opera can lose the stack if we touch anything else first
var frames=parseStackFrames(stackParser,ex);var exception={type:ex&&ex.name,value:extractMessage(ex)};if(frames.length){exception.stacktrace={frames:frames};}if(exception.type===undefined&&exception.value===''){exception.value='Unrecoverable error caught';}return exception;}/**
 * @hidden
 */function eventFromPlainObject(stackParser,exception,syntheticException,isUnhandledRejection){var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])();var normalizeDepth=client&&client.getOptions().normalizeDepth;var event={exception:{values:[{type:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_13" /* isEvent */])(exception)?exception.constructor.name:isUnhandledRejection?'UnhandledRejection':'Error',value:getNonErrorObjectExceptionValue(exception,{isUnhandledRejection:isUnhandledRejection})}]},extra:{__serialized__:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_31" /* normalizeToSize */])(exception,normalizeDepth)}};if(syntheticException){var frames=parseStackFrames(stackParser,syntheticException);if(frames.length){// event.exception.values[0] has been set above
event.exception.values[0].stacktrace={frames:frames};}}return event;}/**
 * @hidden
 */function eventFromError(stackParser,ex){return{exception:{values:[exceptionFromError(stackParser,ex)]}};}/** Parses stack frames from an error */function parseStackFrames(stackParser,ex){// Access and store the stacktrace property before doing ANYTHING
// else to it because Opera is not very good at providing it
// reliably in other circumstances.
var stacktrace=ex.stacktrace||ex.stack||'';var popSize=getPopSize(ex);try{return stackParser(stacktrace,popSize);}catch(e){// no-empty
}return[];}// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp=/Minified React error #\d+;/i;function getPopSize(ex){if(ex){if(typeof ex.framesToPop==='number'){return ex.framesToPop;}if(reactMinifiedRegexp.test(ex.message)){return 1;}}return 0;}/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */function extractMessage(ex){var message=ex&&ex.message;if(!message){return'No error message';}if(message.error&&typeof message.error.message==='string'){return message.error.message;}return message;}/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */function eventFromException(stackParser,exception,hint,attachStacktrace){var syntheticException=hint&&hint.syntheticException||undefined;var event=eventFromUnknownInput(stackParser,exception,syntheticException,attachStacktrace);Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* addExceptionMechanism */])(event);// defaults to { type: 'generic', handled: true }
event.level='error';if(hint&&hint.event_id){event.event_id=hint.event_id;}return Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_38" /* resolvedSyncPromise */])(event);}/**
 * Builds and Event from a Message
 * @hidden
 */function eventFromMessage(stackParser,message){var level=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'info';var hint=arguments.length>3?arguments[3]:undefined;var attachStacktrace=arguments.length>4?arguments[4]:undefined;var syntheticException=hint&&hint.syntheticException||undefined;var event=eventFromString(stackParser,message,syntheticException,attachStacktrace);event.level=level;if(hint&&hint.event_id){event.event_id=hint.event_id;}return Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_38" /* resolvedSyncPromise */])(event);}/**
 * @hidden
 */function eventFromUnknownInput(stackParser,exception,syntheticException,attachStacktrace,isUnhandledRejection){var event;if(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_12" /* isErrorEvent */])(exception)&&exception.error){// If it is an ErrorEvent with `error` property, extract it to get actual Error
var errorEvent=exception;return eventFromError(stackParser,errorEvent.error);}// If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
// and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
// `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
//
// https://developer.mozilla.org/en-US/docs/Web/API/DOMError
// https://developer.mozilla.org/en-US/docs/Web/API/DOMException
// https://webidl.spec.whatwg.org/#es-DOMException-specialness
if(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_9" /* isDOMError */])(exception)||Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_10" /* isDOMException */])(exception)){var domException=exception;if('stack'in exception){event=eventFromError(stackParser,exception);}else{var name=domException.name||(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_9" /* isDOMError */])(domException)?'DOMError':'DOMException');var message=domException.message?"".concat(name,": ").concat(domException.message):name;event=eventFromString(stackParser,message,syntheticException,attachStacktrace);Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* addExceptionTypeValue */])(event,message);}if('code'in domException){// eslint-disable-next-line deprecation/deprecation
event.tags=_objectSpread({},event.tags,{'DOMException.code':"".concat(domException.code)});}return event;}if(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_11" /* isError */])(exception)){// we have a real Error object, do nothing
return eventFromError(stackParser,exception);}if(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_19" /* isPlainObject */])(exception)||Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_13" /* isEvent */])(exception)){// If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
// it manually. This will allow us to group events based on top-level keys which is much better than creating a new
// group on any key/value change.
var objectException=exception;event=eventFromPlainObject(stackParser,objectException,syntheticException,isUnhandledRejection);Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* addExceptionMechanism */])(event,{synthetic:true});return event;}// If none of previous checks were valid, then it means that it's not:
// - an instance of DOMError
// - an instance of DOMException
// - an instance of Event
// - an instance of Error
// - a valid ErrorEvent (one with an error property)
// - a plain Object
//
// So bail out and capture it as a simple message:
event=eventFromString(stackParser,exception,syntheticException,attachStacktrace);Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* addExceptionTypeValue */])(event,"".concat(exception),undefined);Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* addExceptionMechanism */])(event,{synthetic:true});return event;}/**
 * @hidden
 */function eventFromString(stackParser,message,syntheticException,attachStacktrace){var event={};if(attachStacktrace&&syntheticException){var frames=parseStackFrames(stackParser,syntheticException);if(frames.length){event.exception={values:[{value:message,stacktrace:{frames:frames}}]};}}if(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_18" /* isParameterizedString */])(message)){var __sentry_template_string__=message.__sentry_template_string__,__sentry_template_values__=message.__sentry_template_values__;event.logentry={message:__sentry_template_string__,params:__sentry_template_values__};return event;}event.message=message;return event;}function getNonErrorObjectExceptionValue(exception,_ref){var isUnhandledRejection=_ref.isUnhandledRejection;var keys=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["R" /* extractExceptionKeysForMessage */])(exception);var captureType=isUnhandledRejection?'promise rejection':'exception';// Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
// We still want to try to get a decent message for these cases
if(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_12" /* isErrorEvent */])(exception)){return"Event `ErrorEvent` captured as ".concat(captureType," with message `").concat(exception.message,"`");}if(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_13" /* isEvent */])(exception)){var className=getObjectClassName(exception);return"Event `".concat(className,"` (type=").concat(exception.type,") captured as ").concat(captureType);}return"Object captured as ".concat(captureType," with keys: ").concat(keys);}function getObjectClassName(obj){try{var prototype=Object.getPrototypeOf(obj);return prototype?prototype.constructor.name:undefined;}catch(e){// ignore errors here
}}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEBUG_BUILD; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */var DEBUG_BUILD=typeof __SENTRY_DEBUG__==='undefined'||__SENTRY_DEBUG__;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(700);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LanguageSwitcher__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__ = __webpack_require__(6);
var SiteFooter=function SiteFooter(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("footer",{id:"gb-site-footer",className:"gb-site-footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-site-footer__inner container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-site-footer__top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-site-footer__brand m-0"},t('footer.copyright',{year:String(new Date().getFullYear())})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LanguageSwitcher__["a" /* default */],{variant:"onDark",className:"gb-site-footer__lang"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav",{className:"gb-site-footer__nav","aria-label":t('footer.nav')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"gb-site-footer__link",to:"/for"},t('footer.forVenues')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"gb-site-footer__link",to:"/guides"},t('footer.guides')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"gb-site-footer__link",to:"/compare"},t('footer.compare')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"gb-site-footer__link",to:"/checklist"},t('footer.checklist')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"gb-site-footer__link",to:"/pricing"},t('footer.pricing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"gb-site-footer__link",to:"/terms"},t('footer.terms')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"gb-site-footer__link",to:"/privacy"},t('footer.privacy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"gb-site-footer__link",to:"/cookies"},t('footer.cookies')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"gb-site-footer__link",to:"/contact"},t('footer.contact')))));};/* harmony default export */ __webpack_exports__["a"] = (SiteFooter);

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/background@2x.c4d97277.jpg";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(769),
    listCacheDelete = __webpack_require__(770),
    listCacheGet = __webpack_require__(771),
    listCacheHas = __webpack_require__(772),
    listCacheSet = __webpack_require__(773);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(222);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(775);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(220);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(789);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(335),
    baseAssignValue = __webpack_require__(149);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = printValue;
var toString = Object.prototype.toString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
  return '';
};
var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  var isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings) {
  if (quoteStrings === void 0) {
    quoteStrings = false;
  }

  if (val == null || val === true || val === false) return '' + val;
  var typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"" + val + "\"" : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  var tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  var result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    var result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

module.exports = exports["default"];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */


function Cache(maxSize) {
  this._maxSize = maxSize
  this.clear()
}
Cache.prototype.clear = function() {
  this._size = 0
  this._values = {}
}
Cache.prototype.get = function(key) {
  return this._values[key]
}
Cache.prototype.set = function(key, value) {
  this._size >= this._maxSize && this.clear()
  if (!this._values.hasOwnProperty(key)) {
    this._size++
  }
  return this._values[key] = value
}

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512

var contentSecurityPolicy = false,
  pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE)

try {
  new Function('')
} catch (error) {
  contentSecurityPolicy = true
}

module.exports = {
  Cache: Cache,

  expr: expr,

  split: split,

  normalizePath: normalizePath,

  setter: contentSecurityPolicy
    ? function(path) {
      var parts = normalizePath(path)
      return function(data, value) {
        return setterFallback(parts, data, value)
      }
    }
    : function(path) {
      return setCache.get(path) || setCache.set(
        path,
        new Function(
          'data, value',
          expr(path, 'data') + ' = value'
        )
      )
    },

  getter: contentSecurityPolicy
    ? function(path, safe) {
      var parts = normalizePath(path)
      return function(data) {
        return getterFallback(parts, safe, data)
      }
    }
    : function(path, safe) {
      var key = path + '_' + safe
      return getCache.get(key) || getCache.set(
        key,
        new Function('data', 'return ' + expr(path, safe, 'data'))
      )
    },

  join: function(segments) {
    return segments.reduce(function(path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function(path, cb, thisArg) {
    forEach(split(path), cb, thisArg)
  }
}

function setterFallback(parts, data, value) {
  var index = 0,
    len = parts.length
  while (index < len - 1) {
    data = data[parts[index++]]
  }
  data[parts[index]] = value
}

function getterFallback(parts, safe, data) {
  var index = 0,
    len = parts.length
  while (index < len) {
    if (data != null || !safe) {
      data = data[parts[index++]]
    } else {
      return
    }
  }
  return data
}

function normalizePath(path) {
  return pathCache.get(path) || pathCache.set(
    path,
    split(path).map(function(part) {
      return part.replace(CLEAN_QUOTES_REGEX, '$2')
    })
  )
}

function split(path) {
  return path.match(SPLIT_REGEX)
}

function expr(expression, safe, param) {
  expression = expression || ''

  if (typeof safe === 'string') {
    param = safe
    safe = false
  }

  param = param || 'data'

  if (expression && expression.charAt(0) !== '[') expression = '.' + expression

  return safe ? makeSafe(expression, param) : param + expression
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket

  for (idx = 0; idx < len; idx++) {
    part = parts[idx]

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"'
      }

      isBracket = isQuoted(part)
      isArray = !isBracket && /^\d+$/.test(part)

      iter.call(thisArg, part, isBracket, isArray, idx, parts)
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function makeSafe(path, param) {
  var result = param,
    parts = split(path),
    isLast

  forEach(parts, function(part, isBracket, isArray, idx, parts) {
    isLast = idx === parts.length - 1

    part = isBracket || isArray ? '[' + part + ']' : '.' + part

    result += part + (!isLast ? ' || {})' : ')')
  })

  return new Array(parts.length + 1).join('(') + result
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(30);
var LIBRARY = __webpack_require__(53);
var wksExt = __webpack_require__(241);
var defineProperty = __webpack_require__(12).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(95)('keys');
var uid = __webpack_require__(63);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 157 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(4);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(31)(Function.call, __webpack_require__(27).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var setPrototypeOf = __webpack_require__(159).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(33);
var defined = __webpack_require__(41);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 163 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 164 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(53);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(20);
var hide = __webpack_require__(19);
var Iterators = __webpack_require__(82);
var $iterCreate = __webpack_require__(166);
var setToStringTag = __webpack_require__(79);
var getPrototypeOf = __webpack_require__(28);
var ITERATOR = __webpack_require__(9)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(66);
var descriptor = __webpack_require__(62);
var setToStringTag = __webpack_require__(79);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(19)(IteratorPrototype, __webpack_require__(9)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(119);
var defined = __webpack_require__(41);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(9)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(82);
var ITERATOR = __webpack_require__(9)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(12);
var createDesc = __webpack_require__(62);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(80);
var ITERATOR = __webpack_require__(9)('iterator');
var Iterators = __webpack_require__(82);
module.exports = __webpack_require__(30).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(470);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(65);
var toLength = __webpack_require__(10);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(55);
var step = __webpack_require__(258);
var Iterators = __webpack_require__(82);
var toIObject = __webpack_require__(26);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(165)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(98);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(118)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(31);
var invoke = __webpack_require__(248);
var html = __webpack_require__(158);
var cel = __webpack_require__(154);
var global = __webpack_require__(5);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(32)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var macrotask = __webpack_require__(177).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(32)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(17);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(11);
var LIBRARY = __webpack_require__(53);
var $typed = __webpack_require__(125);
var hide = __webpack_require__(19);
var redefineAll = __webpack_require__(71);
var fails = __webpack_require__(7);
var anInstance = __webpack_require__(69);
var toInteger = __webpack_require__(33);
var toLength = __webpack_require__(10);
var toIndex = __webpack_require__(268);
var gOPN = __webpack_require__(67).f;
var dP = __webpack_require__(12).f;
var arrayFill = __webpack_require__(173);
var setToStringTag = __webpack_require__(79);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(182);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addConsoleInstrumentationHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__object_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__worldwide_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handlers_js__ = __webpack_require__(57);
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */function addConsoleInstrumentationHandler(handler){var type='console';Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["a" /* addHandler */])(type,handler);Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["b" /* maybeInstrument */])(type,instrumentConsole);}function instrumentConsole(){if(!('console'in __WEBPACK_IMPORTED_MODULE_2__worldwide_js__["a" /* GLOBAL_OBJ */])){return;}__WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* CONSOLE_LEVELS */].forEach(function(level){if(!(level in __WEBPACK_IMPORTED_MODULE_2__worldwide_js__["a" /* GLOBAL_OBJ */].console)){return;}Object(__WEBPACK_IMPORTED_MODULE_1__object_js__["e" /* fill */])(__WEBPACK_IMPORTED_MODULE_2__worldwide_js__["a" /* GLOBAL_OBJ */].console,level,function(originalConsoleMethod){__WEBPACK_IMPORTED_MODULE_0__logger_js__["d" /* originalConsoleMethods */][level]=originalConsoleMethod;return function(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var handlerData={args:args,level:level};Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["c" /* triggerHandlers */])('console',handlerData);var log=__WEBPACK_IMPORTED_MODULE_0__logger_js__["d" /* originalConsoleMethods */][level];log&&log.apply(__WEBPACK_IMPORTED_MODULE_2__worldwide_js__["a" /* GLOBAL_OBJ */].console,args);};});});}

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createStackParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFunctionName; });
/* unused harmony export nodeStackLineParser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return stackParserFromStackParserOptions; });
/* unused harmony export stripSentryFramesAndReverse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_stack_trace_js__ = __webpack_require__(130);
/* unused harmony reexport filenameIsInApp */
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}var STACKTRACE_FRAME_LIMIT=50;// Used to sanitize webpack (error: *) wrapped stack errors
var WEBPACK_ERROR_REGEXP=/\(error: (.*)\)/;var STRIP_FRAME_REGEXP=/captureMessage|captureException/;/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */function createStackParser(){for(var _len=arguments.length,parsers=new Array(_len),_key=0;_key<_len;_key++){parsers[_key]=arguments[_key];}var sortedParsers=parsers.sort(function(a,b){return a[0]-b[0];}).map(function(p){return p[1];});return function(stack){var skipFirst=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var frames=[];var lines=stack.split('\n');for(var i=skipFirst;i<lines.length;i++){var line=lines[i];// Ignore lines over 1kb as they are unlikely to be stack frames.
// Many of the regular expressions use backtracking which results in run time that increases exponentially with
// input size. Huge strings can result in hangs/Denial of Service:
// https://github.com/getsentry/sentry-javascript/issues/2286
if(line.length>1024){continue;}// https://github.com/getsentry/sentry-javascript/issues/5459
// Remove webpack (error: *) wrappers
var cleanedLine=WEBPACK_ERROR_REGEXP.test(line)?line.replace(WEBPACK_ERROR_REGEXP,'$1'):line;// https://github.com/getsentry/sentry-javascript/issues/7813
// Skip Error: lines
if(cleanedLine.match(/\S*Error: /)){continue;}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=sortedParsers[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var parser=_step.value;var frame=parser(cleanedLine);if(frame){frames.push(frame);break;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(frames.length>=STACKTRACE_FRAME_LIMIT){break;}}return stripSentryFramesAndReverse(frames);};}/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */function stackParserFromStackParserOptions(stackParser){if(Array.isArray(stackParser)){return createStackParser.apply(void 0,_toConsumableArray(stackParser));}return stackParser;}/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */function stripSentryFramesAndReverse(stack){if(!stack.length){return[];}var localStack=Array.from(stack);// If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
if(/sentryWrapped/.test(localStack[localStack.length-1].function||'')){localStack.pop();}// Reversing in the middle of the procedure allows us to just pop the values off the stack
localStack.reverse();// If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
if(STRIP_FRAME_REGEXP.test(localStack[localStack.length-1].function||'')){localStack.pop();// When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
// is produced within the hub itself, making it:
//
//   Sentry.captureException()
//   getCurrentHub().captureException()
//
// instead of just the top `Sentry` call itself.
// This forces us to possibly strip an additional frame in the exact same was as above.
if(STRIP_FRAME_REGEXP.test(localStack[localStack.length-1].function||'')){localStack.pop();}}return localStack.slice(0,STACKTRACE_FRAME_LIMIT).map(function(frame){return _objectSpread({},frame,{filename:frame.filename||localStack[localStack.length-1].filename,function:frame.function||'?'});});}var defaultFunctionName='<anonymous>';/**
 * Safely extract function name from itself
 */function getFunctionName(fn){try{if(!fn||typeof fn!=='function'){return defaultFunctionName;}return fn.name||defaultFunctionName;}catch(e){// Just accessing custom props in some Selenium environments
// can cause a "Permission denied" exception (see raven-js#495).
return defaultFunctionName;}}/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */function nodeStackLineParser(getModule){return[90,Object(__WEBPACK_IMPORTED_MODULE_0__node_stack_trace_js__["b" /* node */])(getModule)];}

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addClickKeypressInstrumentationHandler; });
/* unused harmony export instrumentDOM */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__object_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__worldwide_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handlers_js__ = __webpack_require__(57);
var WINDOW=__WEBPACK_IMPORTED_MODULE_2__worldwide_js__["a" /* GLOBAL_OBJ */];var DEBOUNCE_DURATION=1000;var debounceTimerID;var lastCapturedEventType;var lastCapturedEventTargetId;/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */function addClickKeypressInstrumentationHandler(handler){var type='dom';Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["a" /* addHandler */])(type,handler);Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["b" /* maybeInstrument */])(type,instrumentDOM);}/** Exported for tests only. */function instrumentDOM(){if(!WINDOW.document){return;}// Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
// handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
// we instrument `addEventListener` so that we don't end up attaching this handler twice.
var triggerDOMHandler=__WEBPACK_IMPORTED_MODULE_3__handlers_js__["c" /* triggerHandlers */].bind(null,'dom');var globalDOMEventHandler=makeDOMEventHandler(triggerDOMHandler,true);WINDOW.document.addEventListener('click',globalDOMEventHandler,false);WINDOW.document.addEventListener('keypress',globalDOMEventHandler,false);// After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
// clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
// way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
// could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
// guaranteed to fire at least once.)
['EventTarget','Node'].forEach(function(target){// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
var proto=WINDOW[target]&&WINDOW[target].prototype;// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
if(!proto||!proto.hasOwnProperty||!proto.hasOwnProperty('addEventListener')){return;}Object(__WEBPACK_IMPORTED_MODULE_1__object_js__["e" /* fill */])(proto,'addEventListener',function(originalAddEventListener){return function(type,listener,options){if(type==='click'||type=='keypress'){try{var el=this;var handlers=el.__sentry_instrumentation_handlers__=el.__sentry_instrumentation_handlers__||{};var handlerForType=handlers[type]=handlers[type]||{refCount:0};if(!handlerForType.handler){var handler=makeDOMEventHandler(triggerDOMHandler);handlerForType.handler=handler;originalAddEventListener.call(this,type,handler,options);}handlerForType.refCount++;}catch(e){// Accessing dom properties is always fragile.
// Also allows us to skip `addEventListenrs` calls with no proper `this` context.
}}return originalAddEventListener.call(this,type,listener,options);};});Object(__WEBPACK_IMPORTED_MODULE_1__object_js__["e" /* fill */])(proto,'removeEventListener',function(originalRemoveEventListener){return function(type,listener,options){if(type==='click'||type=='keypress'){try{var el=this;var handlers=el.__sentry_instrumentation_handlers__||{};var handlerForType=handlers[type];if(handlerForType){handlerForType.refCount--;// If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
if(handlerForType.refCount<=0){originalRemoveEventListener.call(this,type,handlerForType.handler,options);handlerForType.handler=undefined;delete handlers[type];// eslint-disable-line @typescript-eslint/no-dynamic-delete
}// If there are no longer any custom handlers of any type on this element, cleanup everything.
if(Object.keys(handlers).length===0){delete el.__sentry_instrumentation_handlers__;}}}catch(e){// Accessing dom properties is always fragile.
// Also allows us to skip `addEventListenrs` calls with no proper `this` context.
}}return originalRemoveEventListener.call(this,type,listener,options);};});});}/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */function isSimilarToLastCapturedEvent(event){// If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
if(event.type!==lastCapturedEventType){return false;}try{// If both events have the same type, it's still possible that actions were performed on different targets.
// e.g. 2 clicks on different buttons.
if(!event.target||event.target._sentryId!==lastCapturedEventTargetId){return false;}}catch(e){// just accessing `target` property can throw an exception in some rare circumstances
// see: https://github.com/getsentry/sentry-javascript/issues/838
}// If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
// to which an event listener was attached), we treat them as the same action, as we want to capture
// only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
return true;}/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */function shouldSkipDOMEvent(eventType,target){// We are only interested in filtering `keypress` events for now.
if(eventType!=='keypress'){return false;}if(!target||!target.tagName){return true;}// Only consider keypress events on actual input elements. This will disregard keypresses targeting body
// e.g.tabbing through elements, hotkeys, etc.
if(target.tagName==='INPUT'||target.tagName==='TEXTAREA'||target.isContentEditable){return false;}return true;}/**
 * Wraps addEventListener to capture UI breadcrumbs
 */function makeDOMEventHandler(handler){var globalListener=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return function(event){// It's possible this handler might trigger multiple times for the same
// event (e.g. event propagation through node ancestors).
// Ignore if we've already captured that event.
if(!event||event['_sentryCaptured']){return;}var target=getEventTarget(event);// We always want to skip _some_ events.
if(shouldSkipDOMEvent(event.type,target)){return;}// Mark event as "seen"
Object(__WEBPACK_IMPORTED_MODULE_1__object_js__["a" /* addNonEnumerableProperty */])(event,'_sentryCaptured',true);if(target&&!target._sentryId){// Add UUID to event target so we can identify if
Object(__WEBPACK_IMPORTED_MODULE_1__object_js__["a" /* addNonEnumerableProperty */])(target,'_sentryId',Object(__WEBPACK_IMPORTED_MODULE_0__misc_js__["g" /* uuid4 */])());}var name=event.type==='keypress'?'input':event.type;// If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
// If there is a last captured event, see if the new event is different enough to treat it as a unique one.
// If that's the case, emit the previous event and store locally the newly-captured DOM event.
if(!isSimilarToLastCapturedEvent(event)){var handlerData={event:event,name:name,global:globalListener};handler(handlerData);lastCapturedEventType=event.type;lastCapturedEventTargetId=target?target._sentryId:undefined;}// Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
clearTimeout(debounceTimerID);debounceTimerID=WINDOW.setTimeout(function(){lastCapturedEventTargetId=undefined;lastCapturedEventType=undefined;},DEBOUNCE_DURATION);};}function getEventTarget(event){try{return event.target;}catch(e){// just accessing `target` property can throw an exception in some rare circumstances
// see: https://github.com/getsentry/sentry-javascript/issues/838
return null;}}

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addFetchInstrumentationHandler; });
/* unused harmony export parseFetchArgs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__supports_js__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__worldwide_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handlers_js__ = __webpack_require__(57);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */function addFetchInstrumentationHandler(handler){var type='fetch';Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["a" /* addHandler */])(type,handler);Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["b" /* maybeInstrument */])(type,instrumentFetch);}function instrumentFetch(){if(!Object(__WEBPACK_IMPORTED_MODULE_1__supports_js__["c" /* supportsNativeFetch */])()){return;}Object(__WEBPACK_IMPORTED_MODULE_0__object_js__["e" /* fill */])(__WEBPACK_IMPORTED_MODULE_2__worldwide_js__["a" /* GLOBAL_OBJ */],'fetch',function(originalFetch){return function(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var _parseFetchArgs=parseFetchArgs(args),method=_parseFetchArgs.method,url=_parseFetchArgs.url;var handlerData={args:args,fetchData:{method:method,url:url},startTimestamp:Date.now()};Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["c" /* triggerHandlers */])('fetch',_objectSpread({},handlerData));// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
return originalFetch.apply(__WEBPACK_IMPORTED_MODULE_2__worldwide_js__["a" /* GLOBAL_OBJ */],args).then(function(response){var finishedHandlerData=_objectSpread({},handlerData,{endTimestamp:Date.now(),response:response});Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["c" /* triggerHandlers */])('fetch',finishedHandlerData);return response;},function(error){var erroredHandlerData=_objectSpread({},handlerData,{endTimestamp:Date.now(),error:error});Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["c" /* triggerHandlers */])('fetch',erroredHandlerData);// NOTE: If you are a Sentry user, and you are seeing this stack frame,
//       it means the sentry.javascript SDK caught an error invoking your application code.
//       This is expected behavior and NOT indicative of a bug with sentry.javascript.
throw error;});};});}function hasProp(obj,prop){return!!obj&&_typeof(obj)==='object'&&!!obj[prop];}function getUrlFromResource(resource){if(typeof resource==='string'){return resource;}if(!resource){return'';}if(hasProp(resource,'url')){return resource.url;}if(resource.toString){return resource.toString();}return'';}/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */function parseFetchArgs(fetchArgs){if(fetchArgs.length===0){return{method:'GET',url:''};}if(fetchArgs.length===2){var _fetchArgs=_slicedToArray(fetchArgs,2),url=_fetchArgs[0],options=_fetchArgs[1];return{url:getUrlFromResource(url),method:hasProp(options,'method')?String(options.method).toUpperCase():'GET'};}var arg=fetchArgs[0];return{url:getUrlFromResource(arg),method:hasProp(arg,'method')?String(arg.method).toUpperCase():'GET'};}

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addGlobalErrorInstrumentationHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__worldwide_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handlers_js__ = __webpack_require__(57);
var _oldOnErrorHandler=null;/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */function addGlobalErrorInstrumentationHandler(handler){var type='error';Object(__WEBPACK_IMPORTED_MODULE_1__handlers_js__["a" /* addHandler */])(type,handler);Object(__WEBPACK_IMPORTED_MODULE_1__handlers_js__["b" /* maybeInstrument */])(type,instrumentError);}function instrumentError(){_oldOnErrorHandler=__WEBPACK_IMPORTED_MODULE_0__worldwide_js__["a" /* GLOBAL_OBJ */].onerror;__WEBPACK_IMPORTED_MODULE_0__worldwide_js__["a" /* GLOBAL_OBJ */].onerror=function(msg,url,line,column,error){var handlerData={column:column,error:error,line:line,msg:msg,url:url};Object(__WEBPACK_IMPORTED_MODULE_1__handlers_js__["c" /* triggerHandlers */])('error',handlerData);if(_oldOnErrorHandler&&!_oldOnErrorHandler.__SENTRY_LOADER__){// eslint-disable-next-line prefer-rest-params
return _oldOnErrorHandler.apply(this,arguments);}return false;};__WEBPACK_IMPORTED_MODULE_0__worldwide_js__["a" /* GLOBAL_OBJ */].onerror.__SENTRY_INSTRUMENTED__=true;}

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addGlobalUnhandledRejectionInstrumentationHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__worldwide_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handlers_js__ = __webpack_require__(57);
var _oldOnUnhandledRejectionHandler=null;/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */function addGlobalUnhandledRejectionInstrumentationHandler(handler){var type='unhandledrejection';Object(__WEBPACK_IMPORTED_MODULE_1__handlers_js__["a" /* addHandler */])(type,handler);Object(__WEBPACK_IMPORTED_MODULE_1__handlers_js__["b" /* maybeInstrument */])(type,instrumentUnhandledRejection);}function instrumentUnhandledRejection(){_oldOnUnhandledRejectionHandler=__WEBPACK_IMPORTED_MODULE_0__worldwide_js__["a" /* GLOBAL_OBJ */].onunhandledrejection;__WEBPACK_IMPORTED_MODULE_0__worldwide_js__["a" /* GLOBAL_OBJ */].onunhandledrejection=function(e){var handlerData=e;Object(__WEBPACK_IMPORTED_MODULE_1__handlers_js__["c" /* triggerHandlers */])('unhandledrejection',handlerData);if(_oldOnUnhandledRejectionHandler&&!_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__){// eslint-disable-next-line prefer-rest-params
return _oldOnUnhandledRejectionHandler.apply(this,arguments);}return true;};__WEBPACK_IMPORTED_MODULE_0__worldwide_js__["a" /* GLOBAL_OBJ */].onunhandledrejection.__SENTRY_INSTRUMENTED__=true;}

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addHistoryInstrumentationHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__worldwide_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vendor_supportsHistory_js__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handlers_js__ = __webpack_require__(57);
var WINDOW=__WEBPACK_IMPORTED_MODULE_3__worldwide_js__["a" /* GLOBAL_OBJ */];var lastHref;/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */function addHistoryInstrumentationHandler(handler){var type='history';Object(__WEBPACK_IMPORTED_MODULE_5__handlers_js__["a" /* addHandler */])(type,handler);Object(__WEBPACK_IMPORTED_MODULE_5__handlers_js__["b" /* maybeInstrument */])(type,instrumentHistory);}function instrumentHistory(){if(!Object(__WEBPACK_IMPORTED_MODULE_4__vendor_supportsHistory_js__["a" /* supportsHistory */])()){return;}var oldOnPopState=WINDOW.onpopstate;WINDOW.onpopstate=function(){var to=WINDOW.location.href;// keep track of the current URL state, as we always receive only the updated state
var from=lastHref;lastHref=to;var handlerData={from:from,to:to};Object(__WEBPACK_IMPORTED_MODULE_5__handlers_js__["c" /* triggerHandlers */])('history',handlerData);if(oldOnPopState){// Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
// https://github.com/getsentry/sentry-javascript/issues/3344
// https://github.com/bugsnag/bugsnag-js/issues/469
try{for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return oldOnPopState.apply(this,args);}catch(_oO){// no-empty
}}};function historyReplacementFunction(originalHistoryFunction){return function(){for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}var url=args.length>2?args[2]:undefined;if(url){// coerce to string (this is what pushState does)
var from=lastHref;var to=String(url);// keep track of the current URL state, as we always receive only the updated state
lastHref=to;var handlerData={from:from,to:to};Object(__WEBPACK_IMPORTED_MODULE_5__handlers_js__["c" /* triggerHandlers */])('history',handlerData);}return originalHistoryFunction.apply(this,args);};}Object(__WEBPACK_IMPORTED_MODULE_0__object_js__["e" /* fill */])(WINDOW.history,'pushState',historyReplacementFunction);Object(__WEBPACK_IMPORTED_MODULE_0__object_js__["e" /* fill */])(WINDOW.history,'replaceState',historyReplacementFunction);}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SENTRY_XHR_DATA_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addXhrInstrumentationHandler; });
/* unused harmony export instrumentXHR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__object_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__worldwide_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handlers_js__ = __webpack_require__(57);
var WINDOW=__WEBPACK_IMPORTED_MODULE_2__worldwide_js__["a" /* GLOBAL_OBJ */];var SENTRY_XHR_DATA_KEY='__sentry_xhr_v3__';/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */function addXhrInstrumentationHandler(handler){var type='xhr';Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["a" /* addHandler */])(type,handler);Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["b" /* maybeInstrument */])(type,instrumentXHR);}/** Exported only for tests. */function instrumentXHR(){// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
if(!WINDOW.XMLHttpRequest){return;}var xhrproto=XMLHttpRequest.prototype;Object(__WEBPACK_IMPORTED_MODULE_1__object_js__["e" /* fill */])(xhrproto,'open',function(originalOpen){return function(){var _this=this;var startTimestamp=Date.now();// open() should always be called with two or more arguments
// But to be on the safe side, we actually validate this and bail out if we don't have a method & url
for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var method=Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["m" /* isString */])(args[0])?args[0].toUpperCase():undefined;var url=parseUrl(args[1]);if(!method||!url){return originalOpen.apply(this,args);}this[SENTRY_XHR_DATA_KEY]={method:method,url:url,request_headers:{}};// if Sentry key appears in URL, don't capture it as a request
if(method==='POST'&&url.match(/sentry_key/)){this.__sentry_own_request__=true;}var onreadystatechangeHandler=function onreadystatechangeHandler(){// For whatever reason, this is not the same instance here as from the outer method
var xhrInfo=_this[SENTRY_XHR_DATA_KEY];if(!xhrInfo){return;}if(_this.readyState===4){try{// touching statusCode in some platforms throws
// an exception
xhrInfo.status_code=_this.status;}catch(e){/* do nothing */}var handlerData={args:[method,url],endTimestamp:Date.now(),startTimestamp:startTimestamp,xhr:_this};Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["c" /* triggerHandlers */])('xhr',handlerData);}};if('onreadystatechange'in this&&typeof this.onreadystatechange==='function'){Object(__WEBPACK_IMPORTED_MODULE_1__object_js__["e" /* fill */])(this,'onreadystatechange',function(original){return function(){onreadystatechangeHandler();for(var _len2=arguments.length,readyStateArgs=new Array(_len2),_key2=0;_key2<_len2;_key2++){readyStateArgs[_key2]=arguments[_key2];}return original.apply(this,readyStateArgs);};});}else{this.addEventListener('readystatechange',onreadystatechangeHandler);}// Intercepting `setRequestHeader` to access the request headers of XHR instance.
// This will only work for user/library defined headers, not for the default/browser-assigned headers.
// Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
Object(__WEBPACK_IMPORTED_MODULE_1__object_js__["e" /* fill */])(this,'setRequestHeader',function(original){return function(){for(var _len3=arguments.length,setRequestHeaderArgs=new Array(_len3),_key3=0;_key3<_len3;_key3++){setRequestHeaderArgs[_key3]=arguments[_key3];}var header=setRequestHeaderArgs[0],value=setRequestHeaderArgs[1];var xhrInfo=this[SENTRY_XHR_DATA_KEY];if(xhrInfo&&Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["m" /* isString */])(header)&&Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["m" /* isString */])(value)){xhrInfo.request_headers[header.toLowerCase()]=value;}return original.apply(this,setRequestHeaderArgs);};});return originalOpen.apply(this,args);};});Object(__WEBPACK_IMPORTED_MODULE_1__object_js__["e" /* fill */])(xhrproto,'send',function(originalSend){return function(){var sentryXhrData=this[SENTRY_XHR_DATA_KEY];for(var _len4=arguments.length,args=new Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}if(!sentryXhrData){return originalSend.apply(this,args);}if(args[0]!==undefined){sentryXhrData.body=args[0];}var handlerData={args:[sentryXhrData.method,sentryXhrData.url],startTimestamp:Date.now(),xhr:this};Object(__WEBPACK_IMPORTED_MODULE_3__handlers_js__["c" /* triggerHandlers */])('xhr',handlerData);return originalSend.apply(this,args);};});}function parseUrl(url){if(Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["m" /* isString */])(url)){return url;}try{// url can be a string or URL
// but since URL is not available in IE11, we do not check for it,
// but simply assume it is an URL and return `toString()` from it (which returns the full URL)
// If that fails, we just return undefined
return url.toString();}catch(e2){}// eslint-disable-line no-empty
return undefined;}

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGlobalScope; });
/* unused harmony export setGlobalScope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventProcessors_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__session_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_applyScopeDataToEvent_js__ = __webpack_require__(194);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/**
 * Default value for maximum number of breadcrumbs added to an event.
 */var DEFAULT_MAX_BREADCRUMBS=100;/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */var globalScope;/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */var Scope=/*#__PURE__*/function(){/** Flag if notifying is happening. *//** Callback for client to receive scope changes. *//** Callback list that will be called after {@link applyToEvent}. *//** Array of breadcrumbs. *//** User *//** Tags *//** Extra *//** Contexts *//** Attachments *//** Propagation Context for distributed tracing *//**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   *//** Fingerprint *//** Severity */// eslint-disable-next-line deprecation/deprecation
/**
   * Transaction Name
   *//** Span *//** Session *//** Request Mode Session Status *//** The client on this scope */// NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
function Scope(){_classCallCheck(this,Scope);this._notifyingListeners=false;this._scopeListeners=[];this._eventProcessors=[];this._breadcrumbs=[];this._attachments=[];this._user={};this._tags={};this._extra={};this._contexts={};this._sdkProcessingMetadata={};this._propagationContext=generatePropagationContext();}/**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */_createClass(Scope,[{key:"clone",/**
   * Clone this scope instance.
   */value:function clone(){var newScope=new Scope();newScope._breadcrumbs=_toConsumableArray(this._breadcrumbs);newScope._tags=_objectSpread({},this._tags);newScope._extra=_objectSpread({},this._extra);newScope._contexts=_objectSpread({},this._contexts);newScope._user=this._user;newScope._level=this._level;newScope._span=this._span;newScope._session=this._session;newScope._transactionName=this._transactionName;newScope._fingerprint=this._fingerprint;newScope._eventProcessors=_toConsumableArray(this._eventProcessors);newScope._requestSession=this._requestSession;newScope._attachments=_toConsumableArray(this._attachments);newScope._sdkProcessingMetadata=_objectSpread({},this._sdkProcessingMetadata);newScope._propagationContext=_objectSpread({},this._propagationContext);newScope._client=this._client;return newScope;}/** Update the client on the scope. */},{key:"setClient",value:function setClient(client){this._client=client;}/**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */},{key:"getClient",value:function getClient(){return this._client;}/**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */},{key:"addScopeListener",value:function addScopeListener(callback){this._scopeListeners.push(callback);}/**
   * @inheritDoc
   */},{key:"addEventProcessor",value:function addEventProcessor(callback){this._eventProcessors.push(callback);return this;}/**
   * @inheritDoc
   */},{key:"setUser",value:function setUser(user){// If null is passed we want to unset everything, but still define keys,
// so that later down in the pipeline any existing values are cleared.
this._user=user||{email:undefined,id:undefined,ip_address:undefined,segment:undefined,username:undefined};if(this._session){Object(__WEBPACK_IMPORTED_MODULE_2__session_js__["c" /* updateSession */])(this._session,{user:user});}this._notifyScopeListeners();return this;}/**
   * @inheritDoc
   */},{key:"getUser",value:function getUser(){return this._user;}/**
   * @inheritDoc
   */},{key:"getRequestSession",value:function getRequestSession(){return this._requestSession;}/**
   * @inheritDoc
   */},{key:"setRequestSession",value:function setRequestSession(requestSession){this._requestSession=requestSession;return this;}/**
   * @inheritDoc
   */},{key:"setTags",value:function setTags(tags){this._tags=_objectSpread({},this._tags,{},tags);this._notifyScopeListeners();return this;}/**
   * @inheritDoc
   */},{key:"setTag",value:function setTag(key,value){this._tags=_objectSpread({},this._tags,_defineProperty({},key,value));this._notifyScopeListeners();return this;}/**
   * @inheritDoc
   */},{key:"setExtras",value:function setExtras(extras){this._extra=_objectSpread({},this._extra,{},extras);this._notifyScopeListeners();return this;}/**
   * @inheritDoc
   */},{key:"setExtra",value:function setExtra(key,extra){this._extra=_objectSpread({},this._extra,_defineProperty({},key,extra));this._notifyScopeListeners();return this;}/**
   * @inheritDoc
   */},{key:"setFingerprint",value:function setFingerprint(fingerprint){this._fingerprint=fingerprint;this._notifyScopeListeners();return this;}/**
   * @inheritDoc
   */},{key:"setLevel",value:function setLevel(// eslint-disable-next-line deprecation/deprecation
level){this._level=level;this._notifyScopeListeners();return this;}/**
   * Sets the transaction name on the scope for future events.
   */},{key:"setTransactionName",value:function setTransactionName(name){this._transactionName=name;this._notifyScopeListeners();return this;}/**
   * @inheritDoc
   */},{key:"setContext",value:function setContext(key,context){if(context===null){// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
delete this._contexts[key];}else{this._contexts[key]=context;}this._notifyScopeListeners();return this;}/**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */},{key:"setSpan",value:function setSpan(span){this._span=span;this._notifyScopeListeners();return this;}/**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */},{key:"getSpan",value:function getSpan(){return this._span;}/**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */},{key:"getTransaction",value:function getTransaction(){// Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
// have a pointer to the currently-active transaction.
var span=this._span;// Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
// Also, this method will be removed anyway.
// eslint-disable-next-line deprecation/deprecation
return span&&span.transaction;}/**
   * @inheritDoc
   */},{key:"setSession",value:function setSession(session){if(!session){delete this._session;}else{this._session=session;}this._notifyScopeListeners();return this;}/**
   * @inheritDoc
   */},{key:"getSession",value:function getSession(){return this._session;}/**
   * @inheritDoc
   */},{key:"update",value:function update(captureContext){if(!captureContext){return this;}var scopeToMerge=typeof captureContext==='function'?captureContext(this):captureContext;if(scopeToMerge instanceof Scope){var scopeData=scopeToMerge.getScopeData();this._tags=_objectSpread({},this._tags,{},scopeData.tags);this._extra=_objectSpread({},this._extra,{},scopeData.extra);this._contexts=_objectSpread({},this._contexts,{},scopeData.contexts);if(scopeData.user&&Object.keys(scopeData.user).length){this._user=scopeData.user;}if(scopeData.level){this._level=scopeData.level;}if(scopeData.fingerprint.length){this._fingerprint=scopeData.fingerprint;}if(scopeToMerge.getRequestSession()){this._requestSession=scopeToMerge.getRequestSession();}if(scopeData.propagationContext){this._propagationContext=scopeData.propagationContext;}}else if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_19" /* isPlainObject */])(scopeToMerge)){var scopeContext=captureContext;this._tags=_objectSpread({},this._tags,{},scopeContext.tags);this._extra=_objectSpread({},this._extra,{},scopeContext.extra);this._contexts=_objectSpread({},this._contexts,{},scopeContext.contexts);if(scopeContext.user){this._user=scopeContext.user;}if(scopeContext.level){this._level=scopeContext.level;}if(scopeContext.fingerprint){this._fingerprint=scopeContext.fingerprint;}if(scopeContext.requestSession){this._requestSession=scopeContext.requestSession;}if(scopeContext.propagationContext){this._propagationContext=scopeContext.propagationContext;}}return this;}/**
   * @inheritDoc
   */},{key:"clear",value:function clear(){this._breadcrumbs=[];this._tags={};this._extra={};this._user={};this._contexts={};this._level=undefined;this._transactionName=undefined;this._fingerprint=undefined;this._requestSession=undefined;this._span=undefined;this._session=undefined;this._notifyScopeListeners();this._attachments=[];this._propagationContext=generatePropagationContext();return this;}/**
   * @inheritDoc
   */},{key:"addBreadcrumb",value:function addBreadcrumb(breadcrumb,maxBreadcrumbs){var maxCrumbs=typeof maxBreadcrumbs==='number'?maxBreadcrumbs:DEFAULT_MAX_BREADCRUMBS;// No data has been changed, so don't notify scope listeners
if(maxCrumbs<=0){return this;}var mergedBreadcrumb=_objectSpread({timestamp:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["G" /* dateTimestampInSeconds */])()},breadcrumb);var breadcrumbs=this._breadcrumbs;breadcrumbs.push(mergedBreadcrumb);this._breadcrumbs=breadcrumbs.length>maxCrumbs?breadcrumbs.slice(-maxCrumbs):breadcrumbs;this._notifyScopeListeners();return this;}/**
   * @inheritDoc
   */},{key:"getLastBreadcrumb",value:function getLastBreadcrumb(){return this._breadcrumbs[this._breadcrumbs.length-1];}/**
   * @inheritDoc
   */},{key:"clearBreadcrumbs",value:function clearBreadcrumbs(){this._breadcrumbs=[];this._notifyScopeListeners();return this;}/**
   * @inheritDoc
   */},{key:"addAttachment",value:function addAttachment(attachment){this._attachments.push(attachment);return this;}/**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */},{key:"getAttachments",value:function getAttachments(){var data=this.getScopeData();return data.attachments;}/**
   * @inheritDoc
   */},{key:"clearAttachments",value:function clearAttachments(){this._attachments=[];return this;}/** @inheritDoc */},{key:"getScopeData",value:function getScopeData(){var _breadcrumbs=this._breadcrumbs,_attachments=this._attachments,_contexts=this._contexts,_tags=this._tags,_extra=this._extra,_user=this._user,_level=this._level,_fingerprint=this._fingerprint,_eventProcessors=this._eventProcessors,_propagationContext=this._propagationContext,_sdkProcessingMetadata=this._sdkProcessingMetadata,_transactionName=this._transactionName,_span=this._span;return{breadcrumbs:_breadcrumbs,attachments:_attachments,contexts:_contexts,tags:_tags,extra:_extra,user:_user,level:_level,fingerprint:_fingerprint||[],eventProcessors:_eventProcessors,propagationContext:_propagationContext,sdkProcessingMetadata:_sdkProcessingMetadata,transactionName:_transactionName,span:_span};}/**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */},{key:"applyToEvent",value:function applyToEvent(event){var hint=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var additionalEventProcessors=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];Object(__WEBPACK_IMPORTED_MODULE_3__utils_applyScopeDataToEvent_js__["a" /* applyScopeDataToEvent */])(event,this.getScopeData());// TODO (v8): Update this order to be: Global > Client > Scope
var eventProcessors=[].concat(_toConsumableArray(additionalEventProcessors),_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_1__eventProcessors_js__["b" /* getGlobalEventProcessors */])()),_toConsumableArray(this._eventProcessors));return Object(__WEBPACK_IMPORTED_MODULE_1__eventProcessors_js__["c" /* notifyEventProcessors */])(eventProcessors,event,hint);}/**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */},{key:"setSDKProcessingMetadata",value:function setSDKProcessingMetadata(newData){this._sdkProcessingMetadata=_objectSpread({},this._sdkProcessingMetadata,{},newData);return this;}/**
   * @inheritDoc
   */},{key:"setPropagationContext",value:function setPropagationContext(context){this._propagationContext=context;return this;}/**
   * @inheritDoc
   */},{key:"getPropagationContext",value:function getPropagationContext(){return this._propagationContext;}/**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */},{key:"captureException",value:function captureException(exception,hint){var eventId=hint&&hint.event_id?hint.event_id:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])();if(!this._client){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('No client configured on scope - will not capture exception!');return eventId;}var syntheticException=new Error('Sentry syntheticException');this._client.captureException(exception,_objectSpread({originalException:exception,syntheticException:syntheticException},hint,{event_id:eventId}),this);return eventId;}/**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */},{key:"captureMessage",value:function captureMessage(message,level,hint){var eventId=hint&&hint.event_id?hint.event_id:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])();if(!this._client){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('No client configured on scope - will not capture message!');return eventId;}var syntheticException=new Error(message);this._client.captureMessage(message,level,_objectSpread({originalException:message,syntheticException:syntheticException},hint,{event_id:eventId}),this);return eventId;}/**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */},{key:"captureEvent",value:function captureEvent(event,hint){var eventId=hint&&hint.event_id?hint.event_id:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])();if(!this._client){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('No client configured on scope - will not capture event!');return eventId;}this._client.captureEvent(event,_objectSpread({},hint,{event_id:eventId}),this);return eventId;}/**
   * This will be called on every set call.
   */},{key:"_notifyScopeListeners",value:function _notifyScopeListeners(){var _this=this;// We need this check for this._notifyingListeners to be able to work on scope during updates
// If this check is not here we'll produce endless recursion when something is done with the scope
// during the callback.
if(!this._notifyingListeners){this._notifyingListeners=true;this._scopeListeners.forEach(function(callback){callback(_this);});this._notifyingListeners=false;}}}],[{key:"clone",value:function clone(scope){return scope?scope.clone():new Scope();}}]);return Scope;}();/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */function getGlobalScope(){if(!globalScope){globalScope=new Scope();}return globalScope;}/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */function setGlobalScope(scope){globalScope=scope;}function generatePropagationContext(){return{traceId:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])(),spanId:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])().substring(16)};}

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyScopeDataToEvent; });
/* unused harmony export mergeAndOverwriteScopeData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mergeScopeData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracing_dynamicSamplingContext_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getRootSpan_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spanUtils_js__ = __webpack_require__(23);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}/**
 * Applies data from the scope to the event and runs all event processors on it.
 */function applyScopeDataToEvent(event,data){var fingerprint=data.fingerprint,span=data.span,breadcrumbs=data.breadcrumbs,sdkProcessingMetadata=data.sdkProcessingMetadata;// Apply general data
applyDataToEvent(event,data);// We want to set the trace context for normal events only if there isn't already
// a trace context on the event. There is a product feature in place where we link
// errors with transaction and it relies on that.
if(span){applySpanToEvent(event,span);}applyFingerprintToEvent(event,fingerprint);applyBreadcrumbsToEvent(event,breadcrumbs);applySdkMetadataToEvent(event,sdkProcessingMetadata);}/** Merge data of two scopes together. */function mergeScopeData(data,mergeData){var extra=mergeData.extra,tags=mergeData.tags,user=mergeData.user,contexts=mergeData.contexts,level=mergeData.level,sdkProcessingMetadata=mergeData.sdkProcessingMetadata,breadcrumbs=mergeData.breadcrumbs,fingerprint=mergeData.fingerprint,eventProcessors=mergeData.eventProcessors,attachments=mergeData.attachments,propagationContext=mergeData.propagationContext,transactionName=mergeData.transactionName,span=mergeData.span;mergeAndOverwriteScopeData(data,'extra',extra);mergeAndOverwriteScopeData(data,'tags',tags);mergeAndOverwriteScopeData(data,'user',user);mergeAndOverwriteScopeData(data,'contexts',contexts);mergeAndOverwriteScopeData(data,'sdkProcessingMetadata',sdkProcessingMetadata);if(level){data.level=level;}if(transactionName){// eslint-disable-next-line deprecation/deprecation
data.transactionName=transactionName;}if(span){data.span=span;}if(breadcrumbs.length){data.breadcrumbs=[].concat(_toConsumableArray(data.breadcrumbs),_toConsumableArray(breadcrumbs));}if(fingerprint.length){data.fingerprint=[].concat(_toConsumableArray(data.fingerprint),_toConsumableArray(fingerprint));}if(eventProcessors.length){data.eventProcessors=[].concat(_toConsumableArray(data.eventProcessors),_toConsumableArray(eventProcessors));}if(attachments.length){data.attachments=[].concat(_toConsumableArray(data.attachments),_toConsumableArray(attachments));}data.propagationContext=_objectSpread({},data.propagationContext,{},propagationContext);}/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */function mergeAndOverwriteScopeData(data,prop,mergeVal){if(mergeVal&&Object.keys(mergeVal).length){// Clone object
data[prop]=_objectSpread({},data[prop]);for(var key in mergeVal){if(Object.prototype.hasOwnProperty.call(mergeVal,key)){data[prop][key]=mergeVal[key];}}}}function applyDataToEvent(event,data){var extra=data.extra,tags=data.tags,user=data.user,contexts=data.contexts,level=data.level,transactionName=data.transactionName;var cleanedExtra=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])(extra);if(cleanedExtra&&Object.keys(cleanedExtra).length){event.extra=_objectSpread({},cleanedExtra,{},event.extra);}var cleanedTags=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])(tags);if(cleanedTags&&Object.keys(cleanedTags).length){event.tags=_objectSpread({},cleanedTags,{},event.tags);}var cleanedUser=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])(user);if(cleanedUser&&Object.keys(cleanedUser).length){event.user=_objectSpread({},cleanedUser,{},event.user);}var cleanedContexts=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])(contexts);if(cleanedContexts&&Object.keys(cleanedContexts).length){event.contexts=_objectSpread({},cleanedContexts,{},event.contexts);}if(level){event.level=level;}if(transactionName){event.transaction=transactionName;}}function applyBreadcrumbsToEvent(event,breadcrumbs){var mergedBreadcrumbs=[].concat(_toConsumableArray(event.breadcrumbs||[]),_toConsumableArray(breadcrumbs));event.breadcrumbs=mergedBreadcrumbs.length?mergedBreadcrumbs:undefined;}function applySdkMetadataToEvent(event,sdkProcessingMetadata){event.sdkProcessingMetadata=_objectSpread({},event.sdkProcessingMetadata,{},sdkProcessingMetadata);}function applySpanToEvent(event,span){event.contexts=_objectSpread({trace:Object(__WEBPACK_IMPORTED_MODULE_3__spanUtils_js__["f" /* spanToTraceContext */])(span)},event.contexts);var rootSpan=Object(__WEBPACK_IMPORTED_MODULE_2__getRootSpan_js__["a" /* getRootSpan */])(span);if(rootSpan){event.sdkProcessingMetadata=_objectSpread({dynamicSamplingContext:Object(__WEBPACK_IMPORTED_MODULE_1__tracing_dynamicSamplingContext_js__["b" /* getDynamicSamplingContextFromSpan */])(span)},event.sdkProcessingMetadata);var transactionName=Object(__WEBPACK_IMPORTED_MODULE_3__spanUtils_js__["e" /* spanToJSON */])(rootSpan).description;if(transactionName){event.tags=_objectSpread({transaction:transactionName},event.tags);}}}/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */function applyFingerprintToEvent(event,fingerprint){// Make sure it's an array first and we actually have something in place
event.fingerprint=event.fingerprint?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["w" /* arrayify */])(event.fingerprint):[];// If we have something on the scope, then merge it with event
if(fingerprint){event.fingerprint=event.fingerprint.concat(fingerprint);}// If we have no data at all, remove empty array default
if(event.fingerprint&&!event.fingerprint.length){delete event.fingerprint;}}

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export applyDebugIds */
/* unused harmony export applyDebugMeta */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseEventHintOrCaptureContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prepareEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventProcessors_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scope_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__applyScopeDataToEvent_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spanUtils_js__ = __webpack_require__(23);
function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 *//**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */function prepareEvent(options,event,hint,scope,client,isolationScope){var _options$normalizeDep=options.normalizeDepth,normalizeDepth=_options$normalizeDep===void 0?3:_options$normalizeDep,_options$normalizeMax=options.normalizeMaxBreadth,normalizeMaxBreadth=_options$normalizeMax===void 0?1000:_options$normalizeMax;var prepared=_objectSpread({},event,{event_id:event.event_id||hint.event_id||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])(),timestamp:event.timestamp||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["G" /* dateTimestampInSeconds */])()});var integrations=hint.integrations||options.integrations.map(function(i){return i.name;});applyClientOptions(prepared,options);applyIntegrationsMetadata(prepared,integrations);// Only put debug IDs onto frames for error events.
if(event.type===undefined){applyDebugIds(prepared,options.stackParser);}// If we have scope given to us, use it as the base for further modifications.
// This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
var finalScope=getFinalScope(scope,hint.captureContext);if(hint.mechanism){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["l" /* addExceptionMechanism */])(prepared,hint.mechanism);}var clientEventProcessors=client&&client.getEventProcessors?client.getEventProcessors():[];// This should be the last thing called, since we want that
// {@link Hub.addEventProcessor} gets the finished prepared event.
// Merge scope data together
var data=Object(__WEBPACK_IMPORTED_MODULE_3__scope_js__["b" /* getGlobalScope */])().getScopeData();if(isolationScope){var isolationData=isolationScope.getScopeData();Object(__WEBPACK_IMPORTED_MODULE_4__applyScopeDataToEvent_js__["b" /* mergeScopeData */])(data,isolationData);}if(finalScope){var finalScopeData=finalScope.getScopeData();Object(__WEBPACK_IMPORTED_MODULE_4__applyScopeDataToEvent_js__["b" /* mergeScopeData */])(data,finalScopeData);}var attachments=[].concat(_toConsumableArray(hint.attachments||[]),_toConsumableArray(data.attachments));if(attachments.length){hint.attachments=attachments;}Object(__WEBPACK_IMPORTED_MODULE_4__applyScopeDataToEvent_js__["a" /* applyScopeDataToEvent */])(prepared,data);// TODO (v8): Update this order to be: Global > Client > Scope
var eventProcessors=[].concat(_toConsumableArray(clientEventProcessors),_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_2__eventProcessors_js__["b" /* getGlobalEventProcessors */])()),_toConsumableArray(data.eventProcessors));var result=Object(__WEBPACK_IMPORTED_MODULE_2__eventProcessors_js__["c" /* notifyEventProcessors */])(eventProcessors,prepared,hint);return result.then(function(evt){if(evt){// We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
// file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
// This should not cause any PII issues, since we're only moving data that is already on the event and not adding
// any new data
applyDebugMeta(evt);}if(typeof normalizeDepth==='number'&&normalizeDepth>0){return normalizeEvent(evt,normalizeDepth,normalizeMaxBreadth);}return evt;});}/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */function applyClientOptions(event,options){var environment=options.environment,release=options.release,dist=options.dist,_options$maxValueLeng=options.maxValueLength,maxValueLength=_options$maxValueLeng===void 0?250:_options$maxValueLeng;if(!('environment'in event)){event.environment='environment'in options?environment:__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* DEFAULT_ENVIRONMENT */];}if(event.release===undefined&&release!==undefined){event.release=release;}if(event.dist===undefined&&dist!==undefined){event.dist=dist;}if(event.message){event.message=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_50" /* truncate */])(event.message,maxValueLength);}var exception=event.exception&&event.exception.values&&event.exception.values[0];if(exception&&exception.value){exception.value=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_50" /* truncate */])(exception.value,maxValueLength);}var request=event.request;if(request&&request.url){request.url=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_50" /* truncate */])(request.url,maxValueLength);}}var debugIdStackParserCache=new WeakMap();/**
 * Puts debug IDs into the stack frames of an error event.
 */function applyDebugIds(event,stackParser){var debugIdMap=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */]._sentryDebugIds;if(!debugIdMap){return;}var debugIdStackFramesCache;var cachedDebugIdStackFrameCache=debugIdStackParserCache.get(stackParser);if(cachedDebugIdStackFrameCache){debugIdStackFramesCache=cachedDebugIdStackFrameCache;}else{debugIdStackFramesCache=new Map();debugIdStackParserCache.set(stackParser,debugIdStackFramesCache);}// Build a map of filename -> debug_id
var filenameDebugIdMap=Object.keys(debugIdMap).reduce(function(acc,debugIdStackTrace){var parsedStack;var cachedParsedStack=debugIdStackFramesCache.get(debugIdStackTrace);if(cachedParsedStack){parsedStack=cachedParsedStack;}else{parsedStack=stackParser(debugIdStackTrace);debugIdStackFramesCache.set(debugIdStackTrace,parsedStack);}for(var i=parsedStack.length-1;i>=0;i--){var stackFrame=parsedStack[i];if(stackFrame.filename){acc[stackFrame.filename]=debugIdMap[debugIdStackTrace];break;}}return acc;},{});try{// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
event.exception.values.forEach(function(exception){// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
exception.stacktrace.frames.forEach(function(frame){if(frame.filename){frame.debug_id=filenameDebugIdMap[frame.filename];}});});}catch(e){// To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
}}/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */function applyDebugMeta(event){// Extract debug IDs and filenames from the stack frames on the event.
var filenameDebugIdMap={};try{// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
event.exception.values.forEach(function(exception){// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
exception.stacktrace.frames.forEach(function(frame){if(frame.debug_id){if(frame.abs_path){filenameDebugIdMap[frame.abs_path]=frame.debug_id;}else if(frame.filename){filenameDebugIdMap[frame.filename]=frame.debug_id;}delete frame.debug_id;}});});}catch(e){// To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
}if(Object.keys(filenameDebugIdMap).length===0){return;}// Fill debug_meta information
event.debug_meta=event.debug_meta||{};event.debug_meta.images=event.debug_meta.images||[];var images=event.debug_meta.images;Object.keys(filenameDebugIdMap).forEach(function(filename){images.push({type:'sourcemap',code_file:filename,debug_id:filenameDebugIdMap[filename]});});}/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */function applyIntegrationsMetadata(event,integrationNames){if(integrationNames.length>0){event.sdk=event.sdk||{};event.sdk.integrations=[].concat(_toConsumableArray(event.sdk.integrations||[]),_toConsumableArray(integrationNames));}}/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */function normalizeEvent(event,depth,maxBreadth){if(!event){return null;}var normalized=_objectSpread({},event,{},event.breadcrumbs&&{breadcrumbs:event.breadcrumbs.map(function(b){return _objectSpread({},b,{},b.data&&{data:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_30" /* normalize */])(b.data,depth,maxBreadth)});})},{},event.user&&{user:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_30" /* normalize */])(event.user,depth,maxBreadth)},{},event.contexts&&{contexts:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_30" /* normalize */])(event.contexts,depth,maxBreadth)},{},event.extra&&{extra:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_30" /* normalize */])(event.extra,depth,maxBreadth)});// event.contexts.trace stores information about a Transaction. Similarly,
// event.spans[] stores information about child Spans. Given that a
// Transaction is conceptually a Span, normalization should apply to both
// Transactions and Spans consistently.
// For now the decision is to skip normalization of Transactions and Spans,
// so this block overwrites the normalized event to add back the original
// Transaction information prior to normalization.
if(event.contexts&&event.contexts.trace&&normalized.contexts){normalized.contexts.trace=event.contexts.trace;// event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
if(event.contexts.trace.data){normalized.contexts.trace.data=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_30" /* normalize */])(event.contexts.trace.data,depth,maxBreadth);}}// event.spans[].data may contain circular/dangerous data so we need to normalize it
if(event.spans){normalized.spans=event.spans.map(function(span){var data=Object(__WEBPACK_IMPORTED_MODULE_5__spanUtils_js__["e" /* spanToJSON */])(span).data;if(data){// This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
// eslint-disable-next-line deprecation/deprecation
span.data=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_30" /* normalize */])(data,depth,maxBreadth);}return span;});}return normalized;}function getFinalScope(scope,captureContext){if(!captureContext){return scope;}var finalScope=scope?scope.clone():new __WEBPACK_IMPORTED_MODULE_3__scope_js__["a" /* Scope */]();finalScope.update(captureContext);return finalScope;}/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */function parseEventHintOrCaptureContext(hint){if(!hint){return undefined;}// If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
if(hintIsScopeOrFunction(hint)){return{captureContext:hint};}if(hintIsScopeContext(hint)){return{captureContext:hint};}return hint;}function hintIsScopeOrFunction(hint){return hint instanceof __WEBPACK_IMPORTED_MODULE_3__scope_js__["a" /* Scope */]||typeof hint==='function';}var captureContextKeys=['user','level','extra','contexts','tags','fingerprint','requestSession','propagationContext'];function hintIsScopeContext(hint){return Object.keys(hint).some(function(key){return captureContextKeys.includes(key);});}

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDK_VERSION; });
var SDK_VERSION='7.120.3';

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return registerErrorInstrumentation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(198);
var errorsInstrumented=false;/**
 * Configures global error listeners
 */function registerErrorInstrumentation(){if(errorsInstrumented){return;}errorsInstrumented=true;Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["o" /* addGlobalErrorInstrumentationHandler */])(errorCallback);Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["p" /* addGlobalUnhandledRejectionInstrumentationHandler */])(errorCallback);}/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */function errorCallback(){// eslint-disable-next-line deprecation/deprecation
var activeTransaction=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["b" /* getActiveTransaction */])();if(activeTransaction){var status='internal_error';__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("[Tracing] Transaction: ".concat(status," -> Global error occured"));activeTransaction.setStatus(status);}}// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag='sentry_tracingErrorCallback';

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return extractTraceparentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getActiveTransaction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* unused harmony reexport stripUrlQueryAndFragment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hub_js__ = __webpack_require__(50);
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */// eslint-disable-next-line deprecation/deprecation
function getActiveTransaction(maybeHub){// eslint-disable-next-line deprecation/deprecation
var hub=maybeHub||Object(__WEBPACK_IMPORTED_MODULE_1__hub_js__["b" /* getCurrentHub */])();// eslint-disable-next-line deprecation/deprecation
var scope=hub.getScope();// eslint-disable-next-line deprecation/deprecation
return scope.getTransaction();}/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */var extractTraceparentData=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["T" /* extractTraceparentData */];

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Span; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SpanRecorder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metrics_metric_summary_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__semanticAttributes_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getRootSpan_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_spanUtils_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__spanstatus_js__ = __webpack_require__(104);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */var SpanRecorder=/*#__PURE__*/function(){function SpanRecorder(){var maxlen=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1000;_classCallCheck(this,SpanRecorder);this._maxlen=maxlen;this.spans=[];}/**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */_createClass(SpanRecorder,[{key:"add",value:function add(span){if(this.spans.length>this._maxlen){// eslint-disable-next-line deprecation/deprecation
span.spanRecorder=undefined;}else{this.spans.push(span);}}}]);return SpanRecorder;}();/**
 * Span contains all data about a span
 */var Span=/*#__PURE__*/function(){/**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   *//**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */// eslint-disable-next-line @typescript-eslint/no-explicit-any
/**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   *//**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   *//**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   *//** Epoch timestamp in seconds when the span started. *//** Epoch timestamp in seconds when the span ended. *//** Internal keeper of the status *//**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */function Span(){var _objectSpread2;var spanContext=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_classCallCheck(this,Span);this._traceId=spanContext.traceId||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])();this._spanId=spanContext.spanId||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])().substring(16);this._startTime=spanContext.startTimestamp||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_48" /* timestampInSeconds */])();// eslint-disable-next-line deprecation/deprecation
this.tags=spanContext.tags?_objectSpread({},spanContext.tags):{};// eslint-disable-next-line deprecation/deprecation
this.data=spanContext.data?_objectSpread({},spanContext.data):{};// eslint-disable-next-line deprecation/deprecation
this.instrumenter=spanContext.instrumenter||'sentry';this._attributes={};this.setAttributes(_objectSpread((_objectSpread2={},_defineProperty(_objectSpread2,__WEBPACK_IMPORTED_MODULE_3__semanticAttributes_js__["c" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */],spanContext.origin||'manual'),_defineProperty(_objectSpread2,__WEBPACK_IMPORTED_MODULE_3__semanticAttributes_js__["b" /* SEMANTIC_ATTRIBUTE_SENTRY_OP */],spanContext.op),_objectSpread2),spanContext.attributes));// eslint-disable-next-line deprecation/deprecation
this._name=spanContext.name||spanContext.description;if(spanContext.parentSpanId){this._parentSpanId=spanContext.parentSpanId;}// We want to include booleans as well here
if('sampled'in spanContext){this._sampled=spanContext.sampled;}if(spanContext.status){this._status=spanContext.status;}if(spanContext.endTimestamp){this._endTime=spanContext.endTimestamp;}if(spanContext.exclusiveTime!==undefined){this._exclusiveTime=spanContext.exclusiveTime;}this._measurements=spanContext.measurements?_objectSpread({},spanContext.measurements):{};}// This rule conflicts with another eslint rule :(
/* eslint-disable @typescript-eslint/member-ordering *//**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */_createClass(Span,[{key:"spanContext",/* eslint-enable @typescript-eslint/member-ordering *//** @inheritdoc */value:function spanContext(){var spanId=this._spanId,traceId=this._traceId,sampled=this._sampled;return{spanId:spanId,traceId:traceId,traceFlags:sampled?__WEBPACK_IMPORTED_MODULE_5__utils_spanUtils_js__["b" /* TRACE_FLAG_SAMPLED */]:__WEBPACK_IMPORTED_MODULE_5__utils_spanUtils_js__["a" /* TRACE_FLAG_NONE */]};}/**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */},{key:"startChild",value:function startChild(spanContext){var childSpan=new Span(_objectSpread({},spanContext,{parentSpanId:this._spanId,sampled:this._sampled,traceId:this._traceId}));// eslint-disable-next-line deprecation/deprecation
childSpan.spanRecorder=this.spanRecorder;// eslint-disable-next-line deprecation/deprecation
if(childSpan.spanRecorder){// eslint-disable-next-line deprecation/deprecation
childSpan.spanRecorder.add(childSpan);}var rootSpan=Object(__WEBPACK_IMPORTED_MODULE_4__utils_getRootSpan_js__["a" /* getRootSpan */])(this);// TODO: still set span.transaction here until we have a more permanent solution
// Probably similarly to the weakmap we hold in node-experimental
// eslint-disable-next-line deprecation/deprecation
childSpan.transaction=rootSpan;if(__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&rootSpan){var opStr=spanContext&&spanContext.op||'< unknown op >';var nameStr=Object(__WEBPACK_IMPORTED_MODULE_5__utils_spanUtils_js__["e" /* spanToJSON */])(childSpan).description||'< unknown name >';var idStr=rootSpan.spanContext().spanId;var logMessage="[Tracing] Starting '".concat(opStr,"' span on transaction '").concat(nameStr,"' (").concat(idStr,").");__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log(logMessage);this._logMessage=logMessage;}return childSpan;}/**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */},{key:"setTag",value:function setTag(key,value){// eslint-disable-next-line deprecation/deprecation
this.tags=_objectSpread({},this.tags,_defineProperty({},key,value));return this;}/**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */// eslint-disable-next-line @typescript-eslint/no-explicit-any
},{key:"setData",value:function setData(key,value){// eslint-disable-next-line deprecation/deprecation
this.data=_objectSpread({},this.data,_defineProperty({},key,value));return this;}/** @inheritdoc */},{key:"setAttribute",value:function setAttribute(key,value){if(value===undefined){// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
delete this._attributes[key];}else{this._attributes[key]=value;}}/** @inheritdoc */},{key:"setAttributes",value:function setAttributes(attributes){var _this=this;Object.keys(attributes).forEach(function(key){return _this.setAttribute(key,attributes[key]);});}/**
   * @inheritDoc
   */},{key:"setStatus",value:function setStatus(value){this._status=value;return this;}/**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */},{key:"setHttpStatus",value:function setHttpStatus(httpStatus){Object(__WEBPACK_IMPORTED_MODULE_6__spanstatus_js__["b" /* setHttpStatus */])(this,httpStatus);return this;}/**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */},{key:"setName",value:function setName(name){this.updateName(name);}/**
   * @inheritDoc
   */},{key:"updateName",value:function updateName(name){this._name=name;return this;}/**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */},{key:"isSuccess",value:function isSuccess(){return this._status==='ok';}/**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */},{key:"finish",value:function finish(endTimestamp){return this.end(endTimestamp);}/** @inheritdoc */},{key:"end",value:function end(endTimestamp){// If already ended, skip
if(this._endTime){return;}var rootSpan=Object(__WEBPACK_IMPORTED_MODULE_4__utils_getRootSpan_js__["a" /* getRootSpan */])(this);if(__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&// Don't call this for transactions
rootSpan&&rootSpan.spanContext().spanId!==this._spanId){var logMessage=this._logMessage;if(logMessage){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log(logMessage.replace('Starting','Finishing'));}}this._endTime=Object(__WEBPACK_IMPORTED_MODULE_5__utils_spanUtils_js__["d" /* spanTimeInputToSeconds */])(endTimestamp);}/**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */},{key:"toTraceparent",value:function toTraceparent(){return Object(__WEBPACK_IMPORTED_MODULE_5__utils_spanUtils_js__["g" /* spanToTraceHeader */])(this);}/**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */},{key:"toContext",value:function toContext(){return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])({data:this._getData(),description:this._name,endTimestamp:this._endTime,// eslint-disable-next-line deprecation/deprecation
op:this.op,parentSpanId:this._parentSpanId,sampled:this._sampled,spanId:this._spanId,startTimestamp:this._startTime,status:this._status,// eslint-disable-next-line deprecation/deprecation
tags:this.tags,traceId:this._traceId});}/**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */},{key:"updateWithContext",value:function updateWithContext(spanContext){// eslint-disable-next-line deprecation/deprecation
this.data=spanContext.data||{};// eslint-disable-next-line deprecation/deprecation
this._name=spanContext.name||spanContext.description;this._endTime=spanContext.endTimestamp;// eslint-disable-next-line deprecation/deprecation
this.op=spanContext.op;this._parentSpanId=spanContext.parentSpanId;this._sampled=spanContext.sampled;this._spanId=spanContext.spanId||this._spanId;this._startTime=spanContext.startTimestamp||this._startTime;this._status=spanContext.status;// eslint-disable-next-line deprecation/deprecation
this.tags=spanContext.tags||{};this._traceId=spanContext.traceId||this._traceId;return this;}/**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */},{key:"getTraceContext",value:function getTraceContext(){return Object(__WEBPACK_IMPORTED_MODULE_5__utils_spanUtils_js__["f" /* spanToTraceContext */])(this);}/**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */},{key:"getSpanJSON",value:function getSpanJSON(){return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])({data:this._getData(),description:this._name,op:this._attributes[__WEBPACK_IMPORTED_MODULE_3__semanticAttributes_js__["b" /* SEMANTIC_ATTRIBUTE_SENTRY_OP */]],parent_span_id:this._parentSpanId,span_id:this._spanId,start_timestamp:this._startTime,status:this._status,// eslint-disable-next-line deprecation/deprecation
tags:Object.keys(this.tags).length>0?this.tags:undefined,timestamp:this._endTime,trace_id:this._traceId,origin:this._attributes[__WEBPACK_IMPORTED_MODULE_3__semanticAttributes_js__["c" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */]],_metrics_summary:Object(__WEBPACK_IMPORTED_MODULE_2__metrics_metric_summary_js__["a" /* getMetricSummaryJsonForSpan */])(this),profile_id:this._attributes[__WEBPACK_IMPORTED_MODULE_3__semanticAttributes_js__["a" /* SEMANTIC_ATTRIBUTE_PROFILE_ID */]],exclusive_time:this._exclusiveTime,measurements:Object.keys(this._measurements).length>0?this._measurements:undefined});}/** @inheritdoc */},{key:"isRecording",value:function isRecording(){return!this._endTime&&!!this._sampled;}/**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */},{key:"toJSON",value:function toJSON(){return this.getSpanJSON();}/**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */},{key:"_getData",value:function _getData(){// eslint-disable-next-line deprecation/deprecation
var data=this.data,attributes=this._attributes;var hasData=Object.keys(data).length>0;var hasAttributes=Object.keys(attributes).length>0;if(!hasData&&!hasAttributes){return undefined;}if(hasData&&hasAttributes){return _objectSpread({},data,{},attributes);}return hasData?data:attributes;}},{key:"name",get:function get(){return this._name||'';}/**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */,set:function set(name){this.updateName(name);}/**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */},{key:"description",get:function get(){return this._name;}/**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */,set:function set(description){this._name=description;}/**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */},{key:"traceId",get:function get(){return this._traceId;}/**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */,set:function set(traceId){this._traceId=traceId;}/**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */},{key:"spanId",get:function get(){return this._spanId;}/**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */,set:function set(spanId){this._spanId=spanId;}/**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */},{key:"parentSpanId",set:function set(string){this._parentSpanId=string;}/**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */,get:function get(){return this._parentSpanId;}/**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */},{key:"sampled",get:function get(){return this._sampled;}/**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */,set:function set(sampled){this._sampled=sampled;}/**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */},{key:"attributes",get:function get(){return this._attributes;}/**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */,set:function set(attributes){this._attributes=attributes;}/**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */},{key:"startTimestamp",get:function get(){return this._startTime;}/**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */,set:function set(startTime){this._startTime=startTime;}/**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */},{key:"endTimestamp",get:function get(){return this._endTime;}/**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */,set:function set(endTime){this._endTime=endTime;}/**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */},{key:"status",get:function get(){return this._status;}/**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */,set:function set(status){this._status=status;}/**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */},{key:"op",get:function get(){return this._attributes[__WEBPACK_IMPORTED_MODULE_3__semanticAttributes_js__["b" /* SEMANTIC_ATTRIBUTE_SENTRY_OP */]];}/**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */,set:function set(op){this.setAttribute(__WEBPACK_IMPORTED_MODULE_3__semanticAttributes_js__["b" /* SEMANTIC_ATTRIBUTE_SENTRY_OP */],op);}/**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */},{key:"origin",get:function get(){return this._attributes[__WEBPACK_IMPORTED_MODULE_3__semanticAttributes_js__["c" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */]];}/**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */,set:function set(origin){this.setAttribute(__WEBPACK_IMPORTED_MODULE_3__semanticAttributes_js__["c" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */],origin);}}]);return Span;}();

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return continueTrace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getActiveSpan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCapturedScopesOnSpan; });
/* unused harmony export startActiveSpan */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startInactiveSpan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return startSpan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return startSpanManual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return trace; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hub_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_spanUtils_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spanstatus_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dynamicSamplingContext_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__exports_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_handleCallbackErrors_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_hasTracingEnabled_js__ = __webpack_require__(201);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */function trace(context,callback){var onError=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(){};var afterFinish=arguments.length>3&&arguments[3]!==undefined?arguments[3]:function(){};// eslint-disable-next-line deprecation/deprecation
var hub=Object(__WEBPACK_IMPORTED_MODULE_2__hub_js__["b" /* getCurrentHub */])();var scope=Object(__WEBPACK_IMPORTED_MODULE_7__exports_js__["k" /* getCurrentScope */])();// eslint-disable-next-line deprecation/deprecation
var parentSpan=scope.getSpan();var spanContext=normalizeContext(context);var activeSpan=createChildSpanOrTransaction(hub,{parentSpan:parentSpan,spanContext:spanContext,forceTransaction:false,scope:scope});// eslint-disable-next-line deprecation/deprecation
scope.setSpan(activeSpan);return Object(__WEBPACK_IMPORTED_MODULE_8__utils_handleCallbackErrors_js__["a" /* handleCallbackErrors */])(function(){return callback(activeSpan);},function(error){activeSpan&&activeSpan.setStatus('internal_error');onError(error,activeSpan);},function(){activeSpan&&activeSpan.end();// eslint-disable-next-line deprecation/deprecation
scope.setSpan(parentSpan);afterFinish();});}/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */function startSpan(context,callback){var spanContext=normalizeContext(context);return Object(__WEBPACK_IMPORTED_MODULE_2__hub_js__["g" /* runWithAsyncContext */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_7__exports_js__["x" /* withScope */])(context.scope,function(scope){// eslint-disable-next-line deprecation/deprecation
var hub=Object(__WEBPACK_IMPORTED_MODULE_2__hub_js__["b" /* getCurrentHub */])();// eslint-disable-next-line deprecation/deprecation
var parentSpan=scope.getSpan();var shouldSkipSpan=context.onlyIfParent&&!parentSpan;var activeSpan=shouldSkipSpan?undefined:createChildSpanOrTransaction(hub,{parentSpan:parentSpan,spanContext:spanContext,forceTransaction:context.forceTransaction,scope:scope});return Object(__WEBPACK_IMPORTED_MODULE_8__utils_handleCallbackErrors_js__["a" /* handleCallbackErrors */])(function(){return callback(activeSpan);},function(){// Only update the span status if it hasn't been changed yet
if(activeSpan){var _spanToJSON=Object(__WEBPACK_IMPORTED_MODULE_3__utils_spanUtils_js__["e" /* spanToJSON */])(activeSpan),status=_spanToJSON.status;if(!status||status==='ok'){activeSpan.setStatus('internal_error');}}},function(){return activeSpan&&activeSpan.end();});});});}/**
 * @deprecated Use {@link startSpan} instead.
 */var startActiveSpan=startSpan;/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */function startSpanManual(context,callback){var spanContext=normalizeContext(context);return Object(__WEBPACK_IMPORTED_MODULE_2__hub_js__["g" /* runWithAsyncContext */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_7__exports_js__["x" /* withScope */])(context.scope,function(scope){// eslint-disable-next-line deprecation/deprecation
var hub=Object(__WEBPACK_IMPORTED_MODULE_2__hub_js__["b" /* getCurrentHub */])();// eslint-disable-next-line deprecation/deprecation
var parentSpan=scope.getSpan();var shouldSkipSpan=context.onlyIfParent&&!parentSpan;var activeSpan=shouldSkipSpan?undefined:createChildSpanOrTransaction(hub,{parentSpan:parentSpan,spanContext:spanContext,forceTransaction:context.forceTransaction,scope:scope});function finishAndSetSpan(){activeSpan&&activeSpan.end();}return Object(__WEBPACK_IMPORTED_MODULE_8__utils_handleCallbackErrors_js__["a" /* handleCallbackErrors */])(function(){return callback(activeSpan,finishAndSetSpan);},function(){// Only update the span status if it hasn't been changed yet, and the span is not yet finished
if(activeSpan&&activeSpan.isRecording()){var _spanToJSON2=Object(__WEBPACK_IMPORTED_MODULE_3__utils_spanUtils_js__["e" /* spanToJSON */])(activeSpan),status=_spanToJSON2.status;if(!status||status==='ok'){activeSpan.setStatus('internal_error');}}});});});}/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */function startInactiveSpan(context){if(!Object(__WEBPACK_IMPORTED_MODULE_9__utils_hasTracingEnabled_js__["a" /* hasTracingEnabled */])()){return undefined;}var spanContext=normalizeContext(context);// eslint-disable-next-line deprecation/deprecation
var hub=Object(__WEBPACK_IMPORTED_MODULE_2__hub_js__["b" /* getCurrentHub */])();var parentSpan=context.scope?// eslint-disable-next-line deprecation/deprecation
context.scope.getSpan():getActiveSpan();var shouldSkipSpan=context.onlyIfParent&&!parentSpan;if(shouldSkipSpan){return undefined;}var scope=context.scope||Object(__WEBPACK_IMPORTED_MODULE_7__exports_js__["k" /* getCurrentScope */])();// Even though we don't actually want to make this span active on the current scope,
// we need to make it active on a temporary scope that we use for event processing
// as otherwise, it won't pick the correct span for the event when processing it
var temporaryScope=scope.clone();return createChildSpanOrTransaction(hub,{parentSpan:parentSpan,spanContext:spanContext,forceTransaction:context.forceTransaction,scope:temporaryScope});}/**
 * Returns the currently active span.
 */function getActiveSpan(){// eslint-disable-next-line deprecation/deprecation
return Object(__WEBPACK_IMPORTED_MODULE_7__exports_js__["k" /* getCurrentScope */])().getSpan();}var continueTrace=function continueTrace(_ref,callback){var sentryTrace=_ref.sentryTrace,baggage=_ref.baggage;// TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
/*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */var currentScope=Object(__WEBPACK_IMPORTED_MODULE_7__exports_js__["k" /* getCurrentScope */])();// eslint-disable-next-line deprecation/deprecation
var _tracingContextFromHe=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_49" /* tracingContextFromHeaders */])(sentryTrace,baggage),traceparentData=_tracingContextFromHe.traceparentData,dynamicSamplingContext=_tracingContextFromHe.dynamicSamplingContext,propagationContext=_tracingContextFromHe.propagationContext;currentScope.setPropagationContext(propagationContext);if(__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&traceparentData){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("[Tracing] Continuing trace ".concat(traceparentData.traceId,"."));}var transactionContext=_objectSpread({},traceparentData,{metadata:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])({dynamicSamplingContext:dynamicSamplingContext})});if(!callback){return transactionContext;}return Object(__WEBPACK_IMPORTED_MODULE_2__hub_js__["g" /* runWithAsyncContext */])(function(){return callback(transactionContext);});};function createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub,_ref2){var parentSpan=_ref2.parentSpan,spanContext=_ref2.spanContext,forceTransaction=_ref2.forceTransaction,scope=_ref2.scope;if(!Object(__WEBPACK_IMPORTED_MODULE_9__utils_hasTracingEnabled_js__["a" /* hasTracingEnabled */])()){return undefined;}var isolationScope=Object(__WEBPACK_IMPORTED_MODULE_2__hub_js__["d" /* getIsolationScope */])();var span;if(parentSpan&&!forceTransaction){// eslint-disable-next-line deprecation/deprecation
span=parentSpan.startChild(spanContext);}else if(parentSpan){// If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
var dsc=Object(__WEBPACK_IMPORTED_MODULE_6__dynamicSamplingContext_js__["b" /* getDynamicSamplingContextFromSpan */])(parentSpan);var _parentSpan$spanConte=parentSpan.spanContext(),traceId=_parentSpan$spanConte.traceId,parentSpanId=_parentSpan$spanConte.spanId;var sampled=Object(__WEBPACK_IMPORTED_MODULE_3__utils_spanUtils_js__["c" /* spanIsSampled */])(parentSpan);// eslint-disable-next-line deprecation/deprecation
span=hub.startTransaction(_objectSpread({traceId:traceId,parentSpanId:parentSpanId,parentSampled:sampled},spanContext,{metadata:_objectSpread({dynamicSamplingContext:dsc},spanContext.metadata)}));}else{var _isolationScope$getPr=_objectSpread({},isolationScope.getPropagationContext(),{},scope.getPropagationContext()),_traceId=_isolationScope$getPr.traceId,_dsc=_isolationScope$getPr.dsc,_parentSpanId=_isolationScope$getPr.parentSpanId,_sampled=_isolationScope$getPr.sampled;// eslint-disable-next-line deprecation/deprecation
span=hub.startTransaction(_objectSpread({traceId:_traceId,parentSpanId:_parentSpanId,parentSampled:_sampled},spanContext,{metadata:_objectSpread({dynamicSamplingContext:_dsc},spanContext.metadata)}));}// We always set this as active span on the scope
// In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
// But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
// eslint-disable-next-line deprecation/deprecation
scope.setSpan(span);setCapturedScopesOnSpan(span,scope,isolationScope);return span;}/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */function normalizeContext(context){if(context.startTime){var ctx=_objectSpread({},context);ctx.startTimestamp=Object(__WEBPACK_IMPORTED_MODULE_3__utils_spanUtils_js__["d" /* spanTimeInputToSeconds */])(context.startTime);delete ctx.startTime;return ctx;}return context;}var SCOPE_ON_START_SPAN_FIELD='_sentryScope';var ISOLATION_SCOPE_ON_START_SPAN_FIELD='_sentryIsolationScope';function setCapturedScopesOnSpan(span,scope,isolationScope){if(span){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["s" /* addNonEnumerableProperty */])(span,ISOLATION_SCOPE_ON_START_SPAN_FIELD,isolationScope);Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["s" /* addNonEnumerableProperty */])(span,SCOPE_ON_START_SPAN_FIELD,scope);}}/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */function getCapturedScopesOnSpan(span){return{scope:span[SCOPE_ON_START_SPAN_FIELD],isolationScope:span[ISOLATION_SCOPE_ON_START_SPAN_FIELD]};}

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasTracingEnabled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_js__ = __webpack_require__(37);
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */function hasTracingEnabled(maybeOptions){if(typeof __SENTRY_TRACING__==='boolean'&&!__SENTRY_TRACING__){return false;}var client=Object(__WEBPACK_IMPORTED_MODULE_0__exports_js__["j" /* getClient */])();var options=maybeOptions||client&&client.getOptions();return!!options&&(options.enableTracing||'tracesSampleRate'in options||'tracesSampler'in options);}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Transaction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hub_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metrics_metric_summary_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__semanticAttributes_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_spanUtils_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dynamicSamplingContext_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__span_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__trace_js__ = __webpack_require__(200);
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _get(target,property,receiver){if(typeof Reflect!=="undefined"&&Reflect.get){_get=Reflect.get;}else{_get=function _get(target,property,receiver){var base=_superPropBase(target,property);if(!base)return;var desc=Object.getOwnPropertyDescriptor(base,property);if(desc.get){return desc.get.call(receiver);}return desc.value;};}return _get(target,property,receiver||target);}function _superPropBase(object,property){while(!Object.prototype.hasOwnProperty.call(object,property)){object=_getPrototypeOf(object);if(object===null)break;}return object;}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}/** JSDoc */var Transaction=/*#__PURE__*/function(_Span){_inherits(Transaction,_Span);/**
   * The reference to the current hub.
   */// eslint-disable-next-line deprecation/deprecation
// DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
/**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */// eslint-disable-next-line deprecation/deprecation
function Transaction(transactionContext,hub){var _this;_classCallCheck(this,Transaction);_this=_possibleConstructorReturn(this,_getPrototypeOf(Transaction).call(this,transactionContext));_this._contexts={};// eslint-disable-next-line deprecation/deprecation
_this._hub=hub||Object(__WEBPACK_IMPORTED_MODULE_2__hub_js__["b" /* getCurrentHub */])();_this._name=transactionContext.name||'';_this._metadata=_objectSpread({},transactionContext.metadata);_this._trimEnd=transactionContext.trimEnd;// this is because transactions are also spans, and spans have a transaction pointer
// TODO (v8): Replace this with another way to set the root span
// eslint-disable-next-line deprecation/deprecation
_this.transaction=_assertThisInitialized(_this);// If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
// there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
var incomingDynamicSamplingContext=_this._metadata.dynamicSamplingContext;if(incomingDynamicSamplingContext){// We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
_this._frozenDynamicSamplingContext=_objectSpread({},incomingDynamicSamplingContext);}return _this;}// This sadly conflicts with the getter/setter ordering :(
/* eslint-disable @typescript-eslint/member-ordering *//**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */_createClass(Transaction,[{key:"setName",/* eslint-enable @typescript-eslint/member-ordering *//**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */value:function setName(name){var source=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'custom';this._name=name;this.setAttribute(__WEBPACK_IMPORTED_MODULE_4__semanticAttributes_js__["e" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],source);}/** @inheritdoc */},{key:"updateName",value:function updateName(name){this._name=name;return this;}/**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */},{key:"initSpanRecorder",value:function initSpanRecorder(){var maxlen=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1000;// eslint-disable-next-line deprecation/deprecation
if(!this.spanRecorder){// eslint-disable-next-line deprecation/deprecation
this.spanRecorder=new __WEBPACK_IMPORTED_MODULE_7__span_js__["b" /* SpanRecorder */](maxlen);}// eslint-disable-next-line deprecation/deprecation
this.spanRecorder.add(this);}/**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */},{key:"setContext",value:function setContext(key,context){if(context===null){// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
delete this._contexts[key];}else{this._contexts[key]=context;}}/**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */},{key:"setMeasurement",value:function setMeasurement(name,value){var unit=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';this._measurements[name]={value:value,unit:unit};}/**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */},{key:"setMetadata",value:function setMetadata(newMetadata){this._metadata=_objectSpread({},this._metadata,{},newMetadata);}/**
   * @inheritDoc
   */},{key:"end",value:function end(endTimestamp){var timestampInS=Object(__WEBPACK_IMPORTED_MODULE_5__utils_spanUtils_js__["d" /* spanTimeInputToSeconds */])(endTimestamp);var transaction=this._finishTransaction(timestampInS);if(!transaction){return undefined;}// eslint-disable-next-line deprecation/deprecation
return this._hub.captureEvent(transaction);}/**
   * @inheritDoc
   */},{key:"toContext",value:function toContext(){// eslint-disable-next-line deprecation/deprecation
var spanContext=_get(_getPrototypeOf(Transaction.prototype),"toContext",this).call(this);return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])(_objectSpread({},spanContext,{name:this._name,trimEnd:this._trimEnd}));}/**
   * @inheritDoc
   */},{key:"updateWithContext",value:function updateWithContext(transactionContext){// eslint-disable-next-line deprecation/deprecation
_get(_getPrototypeOf(Transaction.prototype),"updateWithContext",this).call(this,transactionContext);this._name=transactionContext.name||'';this._trimEnd=transactionContext.trimEnd;return this;}/**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */},{key:"getDynamicSamplingContext",value:function getDynamicSamplingContext(){return Object(__WEBPACK_IMPORTED_MODULE_6__dynamicSamplingContext_js__["b" /* getDynamicSamplingContextFromSpan */])(this);}/**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */// eslint-disable-next-line deprecation/deprecation
},{key:"setHub",value:function setHub(hub){this._hub=hub;}/**
   * Get the profile id of the transaction.
   */},{key:"getProfileId",value:function getProfileId(){if(this._contexts!==undefined&&this._contexts['profile']!==undefined){return this._contexts['profile'].profile_id;}return undefined;}/**
   * Finish the transaction & prepare the event to send to Sentry.
   */},{key:"_finishTransaction",value:function _finishTransaction(endTimestamp){var _this2=this;// This transaction is already finished, so we should not flush it again.
if(this._endTime!==undefined){return undefined;}if(!this._name){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Transaction has no name, falling back to `<unlabeled transaction>`.');this._name='<unlabeled transaction>';}// just sets the end timestamp
_get(_getPrototypeOf(Transaction.prototype),"end",this).call(this,endTimestamp);// eslint-disable-next-line deprecation/deprecation
var client=this._hub.getClient();if(client&&client.emit){client.emit('finishTransaction',this);}if(this._sampled!==true){// At this point if `sampled !== true` we want to discard the transaction.
__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');if(client){client.recordDroppedEvent('sample_rate','transaction');}return undefined;}// eslint-disable-next-line deprecation/deprecation
var finishedSpans=this.spanRecorder?// eslint-disable-next-line deprecation/deprecation
this.spanRecorder.spans.filter(function(span){return span!==_this2&&Object(__WEBPACK_IMPORTED_MODULE_5__utils_spanUtils_js__["e" /* spanToJSON */])(span).timestamp;}):[];if(this._trimEnd&&finishedSpans.length>0){var endTimes=finishedSpans.map(function(span){return Object(__WEBPACK_IMPORTED_MODULE_5__utils_spanUtils_js__["e" /* spanToJSON */])(span).timestamp;}).filter(Boolean);this._endTime=endTimes.reduce(function(prev,current){return prev>current?prev:current;});}var _getCapturedScopesOnS=Object(__WEBPACK_IMPORTED_MODULE_8__trace_js__["c" /* getCapturedScopesOnSpan */])(this),capturedSpanScope=_getCapturedScopesOnS.scope,capturedSpanIsolationScope=_getCapturedScopesOnS.isolationScope;// eslint-disable-next-line deprecation/deprecation
var metadata=this.metadata;// eslint-disable-next-line deprecation/deprecation
var source=metadata.source;var transaction=_objectSpread({contexts:_objectSpread({},this._contexts,{// We don't want to override trace context
trace:Object(__WEBPACK_IMPORTED_MODULE_5__utils_spanUtils_js__["f" /* spanToTraceContext */])(this)}),// TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
spans:finishedSpans,start_timestamp:this._startTime,// eslint-disable-next-line deprecation/deprecation
tags:this.tags,timestamp:this._endTime,transaction:this._name,type:'transaction',sdkProcessingMetadata:_objectSpread({},metadata,{capturedSpanScope:capturedSpanScope,capturedSpanIsolationScope:capturedSpanIsolationScope},Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])({dynamicSamplingContext:Object(__WEBPACK_IMPORTED_MODULE_6__dynamicSamplingContext_js__["b" /* getDynamicSamplingContextFromSpan */])(this)})),_metrics_summary:Object(__WEBPACK_IMPORTED_MODULE_3__metrics_metric_summary_js__["a" /* getMetricSummaryJsonForSpan */])(this)},source&&{transaction_info:{source:source}});var hasMeasurements=Object.keys(this._measurements).length>0;if(hasMeasurements){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Measurements] Adding measurements to transaction',JSON.stringify(this._measurements,undefined,2));transaction.measurements=this._measurements;}// eslint-disable-next-line deprecation/deprecation
__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("[Tracing] Finishing ".concat(this.op," transaction: ").concat(this._name,"."));return transaction;}},{key:"name",get:function get(){return this._name;}/**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */,set:function set(newName){// eslint-disable-next-line deprecation/deprecation
this.setName(newName);}/**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */},{key:"metadata",get:function get(){// We merge attributes in for backwards compatibility
return _objectSpread({// Defaults
// eslint-disable-next-line deprecation/deprecation
source:'custom',spanMetadata:{}},this._metadata,{},this._attributes[__WEBPACK_IMPORTED_MODULE_4__semanticAttributes_js__["e" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */]]&&{source:this._attributes[__WEBPACK_IMPORTED_MODULE_4__semanticAttributes_js__["e" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */]]},{},this._attributes[__WEBPACK_IMPORTED_MODULE_4__semanticAttributes_js__["d" /* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */]]&&{sampleRate:this._attributes[__WEBPACK_IMPORTED_MODULE_4__semanticAttributes_js__["d" /* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */]]});}/**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */,set:function set(metadata){this._metadata=metadata;}}]);return Transaction;}(__WEBPACK_IMPORTED_MODULE_7__span_js__["a" /* Span */]);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEnvelopeEndpointWithUrlEncodedAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getReportDialogEndpoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var SENTRY_API_VERSION='7';/** Returns the prefix to construct Sentry ingestion API endpoints. */function getBaseApiEndpoint(dsn){var protocol=dsn.protocol?"".concat(dsn.protocol,":"):'';var port=dsn.port?":".concat(dsn.port):'';return"".concat(protocol,"//").concat(dsn.host).concat(port).concat(dsn.path?"/".concat(dsn.path):'',"/api/");}/** Returns the ingest API endpoint for target. */function _getIngestEndpoint(dsn){return"".concat(getBaseApiEndpoint(dsn)).concat(dsn.projectId,"/envelope/");}/** Returns a URL-encoded string with auth config suitable for a query string. */function _encodedAuth(dsn,sdkInfo){return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_52" /* urlEncode */])(_objectSpread({// We send only the minimum set of required information. See
// https://github.com/getsentry/sentry-javascript/issues/2572.
sentry_key:dsn.publicKey,sentry_version:SENTRY_API_VERSION},sdkInfo&&{sentry_client:"".concat(sdkInfo.name,"/").concat(sdkInfo.version)}));}/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */function getEnvelopeEndpointWithUrlEncodedAuth(dsn){var tunnelOrOptions=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};// TODO (v8): Use this code instead
// const { tunnel, _metadata = {} } = options;
// return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
var tunnel=typeof tunnelOrOptions==='string'?tunnelOrOptions:tunnelOrOptions.tunnel;var sdkInfo=typeof tunnelOrOptions==='string'||!tunnelOrOptions._metadata?undefined:tunnelOrOptions._metadata.sdk;return tunnel?tunnel:"".concat(_getIngestEndpoint(dsn),"?").concat(_encodedAuth(dsn,sdkInfo));}/** Returns the url to the report dialog endpoint. */function getReportDialogEndpoint(dsnLike,dialogOptions){var dsn=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_27" /* makeDsn */])(dsnLike);if(!dsn){return'';}var endpoint="".concat(getBaseApiEndpoint(dsn),"embed/error-page/");var encodedOptions="dsn=".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["J" /* dsnToString */])(dsn));for(var key in dialogOptions){if(key==='dsn'){continue;}if(key==='onClose'){continue;}if(key==='user'){var user=dialogOptions.user;if(!user){continue;}if(user.name){encodedOptions+="&name=".concat(encodeURIComponent(user.name));}if(user.email){encodedOptions+="&email=".concat(encodeURIComponent(user.email));}}else{encodedOptions+="&".concat(encodeURIComponent(key),"=").concat(encodeURIComponent(dialogOptions[key]));}}return"".concat(endpoint,"?").concat(encodedOptions);}

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* unused harmony reexport IdleTransaction */
/* unused harmony reexport Span */
/* unused harmony reexport SpanStatus */
/* unused harmony reexport Transaction */
/* unused harmony reexport extractTraceparentData */
/* unused harmony reexport getActiveTransaction */
/* unused harmony reexport hasTracingEnabled */
/* unused harmony reexport spanStatusfromHttpCode */
/* unused harmony reexport startIdleTransaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* unused harmony reexport TRACEPARENT_REGEXP */
/* unused harmony reexport stripUrlQueryAndFragment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_integrations_express_js__ = __webpack_require__(657);
/* unused harmony reexport Express */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_integrations_postgres_js__ = __webpack_require__(658);
/* unused harmony reexport Postgres */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_integrations_mysql_js__ = __webpack_require__(659);
/* unused harmony reexport Mysql */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_integrations_mongo_js__ = __webpack_require__(660);
/* unused harmony reexport Mongo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_integrations_prisma_js__ = __webpack_require__(661);
/* unused harmony reexport Prisma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_integrations_graphql_js__ = __webpack_require__(662);
/* unused harmony reexport GraphQL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_integrations_apollo_js__ = __webpack_require__(663);
/* unused harmony reexport Apollo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node_integrations_lazy_js__ = __webpack_require__(664);
/* unused harmony reexport lazyLoadedNodePerformanceMonitoringIntegrations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__browser_browsertracing_js__ = __webpack_require__(665);
/* unused harmony reexport BROWSER_TRACING_INTEGRATION_ID */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_10__browser_browsertracing_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__browser_browserTracingIntegration_js__ = __webpack_require__(675);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__browser_browserTracingIntegration_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_11__browser_browserTracingIntegration_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__browser_browserTracingIntegration_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__browser_request_js__ = __webpack_require__(207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_12__browser_request_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_12__browser_request_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__browser_instrument_js__ = __webpack_require__(105);
/* unused harmony reexport addClsInstrumentationHandler */
/* unused harmony reexport addFidInstrumentationHandler */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__browser_instrument_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_13__browser_instrument_js__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_fetch_js__ = __webpack_require__(311);
/* unused harmony reexport addTracingHeadersToFetchRequest */
/* unused harmony reexport instrumentFetchRequest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__extensions_js__ = __webpack_require__(676);
/* unused harmony reexport addExtensionMethods */


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getActivationStart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNavigationEntry_js__ = __webpack_require__(138);
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var getActivationStart=function getActivationStart(){var navEntry=Object(__WEBPACK_IMPORTED_MODULE_0__getNavigationEntry_js__["a" /* getNavigationEntry */])();return navEntry&&navEntry.activationStart||0;};

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVisibilityWatcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__onHidden_js__ = __webpack_require__(108);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var firstHiddenTime=-1;var initHiddenTime=function initHiddenTime(){// If the document is hidden and not prerendering, assume it was always
// hidden and the page was loaded in the background.
if(__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].document&&__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].document.visibilityState){firstHiddenTime=__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].document.visibilityState==='hidden'&&!__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].document.prerendering?0:Infinity;}};var trackChanges=function trackChanges(){// Update the time if/when the document becomes hidden.
Object(__WEBPACK_IMPORTED_MODULE_1__onHidden_js__["a" /* onHidden */])(function(_ref){var timeStamp=_ref.timeStamp;firstHiddenTime=timeStamp;},true);};var getVisibilityWatcher=function getVisibilityWatcher(){if(firstHiddenTime<0){// If the document is hidden when this code runs, assume it was hidden
// since navigation start. This isn't a perfect heuristic, but it's the
// best we can do until an API is available to support querying past
// visibilityState.
initHiddenTime();trackChanges();}return{get firstHiddenTime(){return firstHiddenTime;}};};

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_TRACE_PROPAGATION_TARGETS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultRequestInstrumentationOptions; });
/* unused harmony export extractNetworkProtocol */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return instrumentOutgoingRequests; });
/* unused harmony export shouldAttachHeaders */
/* unused harmony export xhrCallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_fetch_js__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instrument_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(29);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* eslint-disable max-lines */var DEFAULT_TRACE_PROPAGATION_TARGETS=['localhost',/^\/(?!\/)/];/** Options for Request Instrumentation */var defaultRequestInstrumentationOptions={traceFetch:true,traceXHR:true,enableHTTPTimings:true,// TODO (v8): Remove this property
tracingOrigins:DEFAULT_TRACE_PROPAGATION_TARGETS,tracePropagationTargets:DEFAULT_TRACE_PROPAGATION_TARGETS};/** Registers span creators for xhr and fetch requests  */function instrumentOutgoingRequests(_options){var _traceFetch$traceXHR$=_objectSpread({traceFetch:defaultRequestInstrumentationOptions.traceFetch,traceXHR:defaultRequestInstrumentationOptions.traceXHR},_options),traceFetch=_traceFetch$traceXHR$.traceFetch,traceXHR=_traceFetch$traceXHR$.traceXHR,tracePropagationTargets=_traceFetch$traceXHR$.tracePropagationTargets,tracingOrigins=_traceFetch$traceXHR$.tracingOrigins,shouldCreateSpanForRequest=_traceFetch$traceXHR$.shouldCreateSpanForRequest,enableHTTPTimings=_traceFetch$traceXHR$.enableHTTPTimings;var shouldCreateSpan=typeof shouldCreateSpanForRequest==='function'?shouldCreateSpanForRequest:function(_){return true;};// TODO(v8) Remove tracingOrigins here
// The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
// and we don't want to break the API. We can remove it in v8.
var shouldAttachHeadersWithTargets=function shouldAttachHeadersWithTargets(url){return shouldAttachHeaders(url,tracePropagationTargets||tracingOrigins);};var spans={};if(traceFetch){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* addFetchInstrumentationHandler */])(function(handlerData){var createdSpan=Object(__WEBPACK_IMPORTED_MODULE_2__common_fetch_js__["a" /* instrumentFetchRequest */])(handlerData,shouldCreateSpan,shouldAttachHeadersWithTargets,spans);// We cannot use `window.location` in the generic fetch instrumentation,
// but we need it for reliable `server.address` attribute.
// so we extend this in here
if(createdSpan){var fullUrl=getFullURL(handlerData.fetchData.url);var host=fullUrl?Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_34" /* parseUrl */])(fullUrl).host:undefined;createdSpan.setAttributes({'http.url':fullUrl,'server.address':host});}if(enableHTTPTimings&&createdSpan){addHTTPTimings(createdSpan);}});}if(traceXHR){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* addXhrInstrumentationHandler */])(function(handlerData){var createdSpan=xhrCallback(handlerData,shouldCreateSpan,shouldAttachHeadersWithTargets,spans);if(enableHTTPTimings&&createdSpan){addHTTPTimings(createdSpan);}});}}function isPerformanceResourceTiming(entry){return entry.entryType==='resource'&&'initiatorType'in entry&&typeof entry.nextHopProtocol==='string'&&(entry.initiatorType==='fetch'||entry.initiatorType==='xmlhttprequest');}/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */function addHTTPTimings(span){var _ref=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_24" /* spanToJSON */])(span).data||{},url=_ref.url;if(!url||typeof url!=='string'){return;}var cleanup=Object(__WEBPACK_IMPORTED_MODULE_3__instrument_js__["e" /* addPerformanceInstrumentationHandler */])('resource',function(_ref2){var entries=_ref2.entries;entries.forEach(function(entry){if(isPerformanceResourceTiming(entry)&&entry.name.endsWith(url)){var spanData=resourceTimingEntryToSpanData(entry);spanData.forEach(function(data){return span.setAttribute.apply(span,_toConsumableArray(data));});// In the next tick, clean this handler up
// We have to wait here because otherwise this cleans itself up before it is fully done
setTimeout(cleanup);}});});}/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */function extractNetworkProtocol(nextHopProtocol){var name='unknown';var version='unknown';var _name='';var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=nextHopProtocol[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var char=_step.value;// http/1.1 etc.
if(char==='/'){var _nextHopProtocol$spli=nextHopProtocol.split('/');var _nextHopProtocol$spli2=_slicedToArray(_nextHopProtocol$spli,2);name=_nextHopProtocol$spli2[0];version=_nextHopProtocol$spli2[1];break;}// h2, h3 etc.
if(!isNaN(Number(char))){name=_name==='h'?'http':_name;version=nextHopProtocol.split(_name)[1];break;}_name+=char;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(_name===nextHopProtocol){// webrtc, ftp, etc.
name=_name;}return{name:name,version:version};}function getAbsoluteTime(){var time=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;return((__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]||performance.timeOrigin)+time)/1000;}function resourceTimingEntryToSpanData(resourceTiming){var _extractNetworkProtoc=extractNetworkProtocol(resourceTiming.nextHopProtocol),name=_extractNetworkProtoc.name,version=_extractNetworkProtoc.version;var timingSpanData=[];timingSpanData.push(['network.protocol.version',version],['network.protocol.name',name]);if(!__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]){return timingSpanData;}return[].concat(timingSpanData,[['http.request.redirect_start',getAbsoluteTime(resourceTiming.redirectStart)],['http.request.fetch_start',getAbsoluteTime(resourceTiming.fetchStart)],['http.request.domain_lookup_start',getAbsoluteTime(resourceTiming.domainLookupStart)],['http.request.domain_lookup_end',getAbsoluteTime(resourceTiming.domainLookupEnd)],['http.request.connect_start',getAbsoluteTime(resourceTiming.connectStart)],['http.request.secure_connection_start',getAbsoluteTime(resourceTiming.secureConnectionStart)],['http.request.connection_end',getAbsoluteTime(resourceTiming.connectEnd)],['http.request.request_start',getAbsoluteTime(resourceTiming.requestStart)],['http.request.response_start',getAbsoluteTime(resourceTiming.responseStart)],['http.request.response_end',getAbsoluteTime(resourceTiming.responseEnd)]]);}/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */function shouldAttachHeaders(url,tracePropagationTargets){return Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_43" /* stringMatchesSomePattern */])(url,tracePropagationTargets||DEFAULT_TRACE_PROPAGATION_TARGETS);}/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */// eslint-disable-next-line complexity
function xhrCallback(handlerData,shouldCreateSpan,shouldAttachHeaders,spans){var xhr=handlerData.xhr;var sentryXhrData=xhr&&xhr[__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SENTRY_XHR_DATA_KEY */]];if(!Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_0" /* hasTracingEnabled */])()||!xhr||xhr.__sentry_own_request__||!sentryXhrData){return undefined;}var shouldCreateSpanResult=shouldCreateSpan(sentryXhrData.url);// check first if the request has finished and is tracked by an existing span which should now end
if(handlerData.endTimestamp&&shouldCreateSpanResult){var spanId=xhr.__sentry_xhr_span_id__;if(!spanId)return;var _span=spans[spanId];if(_span&&sentryXhrData.status_code!==undefined){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_18" /* setHttpStatus */])(_span,sentryXhrData.status_code);_span.end();// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
delete spans[spanId];}return undefined;}var scope=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["P" /* getCurrentScope */])();var isolationScope=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["V" /* getIsolationScope */])();var fullUrl=getFullURL(sentryXhrData.url);var host=fullUrl?Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_34" /* parseUrl */])(fullUrl).host:undefined;var span=shouldCreateSpanResult?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_27" /* startInactiveSpan */])({name:"".concat(sentryXhrData.method," ").concat(sentryXhrData.url),onlyIfParent:true,attributes:_defineProperty({type:'xhr','http.method':sentryXhrData.method,'http.url':fullUrl,url:sentryXhrData.url,'server.address':host},__WEBPACK_IMPORTED_MODULE_0__sentry_core__["j" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */],'auto.http.browser'),op:'http.client'}):undefined;if(span){xhr.__sentry_xhr_span_id__=span.spanContext().spanId;spans[xhr.__sentry_xhr_span_id__]=span;}var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])();if(xhr.setRequestHeader&&shouldAttachHeaders(sentryXhrData.url)&&client){var _isolationScope$getPr=_objectSpread({},isolationScope.getPropagationContext(),{},scope.getPropagationContext()),traceId=_isolationScope$getPr.traceId,_spanId=_isolationScope$getPr.spanId,sampled=_isolationScope$getPr.sampled,dsc=_isolationScope$getPr.dsc;var sentryTraceHeader=span?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_25" /* spanToTraceHeader */])(span):Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["W" /* generateSentryTraceHeader */])(traceId,_spanId,sampled);var sentryBaggageHeader=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["L" /* dynamicSamplingContextToSentryBaggageHeader */])(dsc||(span?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["R" /* getDynamicSamplingContextFromSpan */])(span):Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["Q" /* getDynamicSamplingContextFromClient */])(traceId,client,scope)));setHeaderOnXhr(xhr,sentryTraceHeader,sentryBaggageHeader);}return span;}function setHeaderOnXhr(xhr,sentryTraceHeader,sentryBaggageHeader){try{// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
xhr.setRequestHeader('sentry-trace',sentryTraceHeader);if(sentryBaggageHeader){// From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
// We can therefore simply set a baggage header without checking what was there before
// https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
xhr.setRequestHeader(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["a" /* BAGGAGE_HEADER_NAME */],sentryBaggageHeader);}}catch(_){// Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
}}function getFullURL(url){try{// By adding a base URL to new URL(), this will also work for relative urls
// If `url` is a full URL, the base URL is ignored anyhow
var parsed=new URL(url,__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* WINDOW */].location.origin);return parsed.href;}catch(e){return undefined;}}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumbs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return breadcrumbsIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_js__ = __webpack_require__(38);
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* eslint-disable max-lines *//** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */var MAX_ALLOWED_STRING_LENGTH=1024;var INTEGRATION_NAME='Breadcrumbs';var _breadcrumbsIntegration=function _breadcrumbsIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _options=_objectSpread({console:true,dom:true,fetch:true,history:true,sentry:true,xhr:true},options);return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
setup:function setup(client){if(_options.console){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* addConsoleInstrumentationHandler */])(_getConsoleBreadcrumbHandler(client));}if(_options.dom){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* addClickKeypressInstrumentationHandler */])(_getDomBreadcrumbHandler(client,_options.dom));}if(_options.xhr){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* addXhrInstrumentationHandler */])(_getXhrBreadcrumbHandler(client));}if(_options.fetch){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* addFetchInstrumentationHandler */])(_getFetchBreadcrumbHandler(client));}if(_options.history){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["q" /* addHistoryInstrumentationHandler */])(_getHistoryBreadcrumbHandler(client));}if(_options.sentry&&client.on){client.on('beforeSendEvent',_getSentryBreadcrumbHandler(client));}}};};var breadcrumbsIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_breadcrumbsIntegration);/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var Breadcrumbs=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,breadcrumbsIntegration);/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */function _getSentryBreadcrumbHandler(client){return function addSentryBreadcrumb(event){if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])()!==client){return;}Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["p" /* addBreadcrumb */])({category:"sentry.".concat(event.type==='transaction'?'transaction':'event'),event_id:event.event_id,level:event.level,message:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["Z" /* getEventDescription */])(event)},{event:event});};}/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */function _getDomBreadcrumbHandler(client,dom){return function _innerDomBreadcrumb(handlerData){if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])()!==client){return;}var target;var componentName;var keyAttrs=_typeof(dom)==='object'?dom.serializeAttribute:undefined;var maxStringLength=_typeof(dom)==='object'&&typeof dom.maxStringLength==='number'?dom.maxStringLength:undefined;if(maxStringLength&&maxStringLength>MAX_ALLOWED_STRING_LENGTH){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn("`dom.maxStringLength` cannot exceed ".concat(MAX_ALLOWED_STRING_LENGTH,", but a value of ").concat(maxStringLength," was configured. Sentry will use ").concat(MAX_ALLOWED_STRING_LENGTH," instead."));maxStringLength=MAX_ALLOWED_STRING_LENGTH;}if(typeof keyAttrs==='string'){keyAttrs=[keyAttrs];}// Accessing event.target can throw (see getsentry/raven-js#838, #768)
try{var event=handlerData.event;var element=_isEvent(event)?event.target:event;target=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_7" /* htmlTreeAsString */])(element,{keyAttrs:keyAttrs,maxStringLength:maxStringLength});componentName=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["X" /* getComponentName */])(element);}catch(e){target='<unknown>';}if(target.length===0){return;}var breadcrumb={category:"ui.".concat(handlerData.name),message:target};if(componentName){breadcrumb.data={'ui.component_name':componentName};}Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["p" /* addBreadcrumb */])(breadcrumb,{event:handlerData.event,name:handlerData.name,global:handlerData.global});};}/**
 * Creates breadcrumbs from console API calls
 */function _getConsoleBreadcrumbHandler(client){return function _consoleBreadcrumb(handlerData){if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])()!==client){return;}var breadcrumb={category:'console',data:{arguments:handlerData.args,logger:'console'},level:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_41" /* severityLevelFromString */])(handlerData.level),message:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_39" /* safeJoin */])(handlerData.args,' ')};if(handlerData.level==='assert'){if(handlerData.args[0]===false){breadcrumb.message="Assertion failed: ".concat(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_39" /* safeJoin */])(handlerData.args.slice(1),' ')||'console.assert');breadcrumb.data.arguments=handlerData.args.slice(1);}else{// Don't capture a breadcrumb for passed assertions
return;}}Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["p" /* addBreadcrumb */])(breadcrumb,{input:handlerData.args,level:handlerData.level});};}/**
 * Creates breadcrumbs from XHR API calls
 */function _getXhrBreadcrumbHandler(client){return function _xhrBreadcrumb(handlerData){if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])()!==client){return;}var startTimestamp=handlerData.startTimestamp,endTimestamp=handlerData.endTimestamp;var sentryXhrData=handlerData.xhr[__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SENTRY_XHR_DATA_KEY */]];// We only capture complete, non-sentry requests
if(!startTimestamp||!endTimestamp||!sentryXhrData){return;}var method=sentryXhrData.method,url=sentryXhrData.url,status_code=sentryXhrData.status_code,body=sentryXhrData.body;var data={method:method,url:url,status_code:status_code};var hint={xhr:handlerData.xhr,input:body,startTimestamp:startTimestamp,endTimestamp:endTimestamp};Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["p" /* addBreadcrumb */])({category:'xhr',data:data,type:'http'},hint);};}/**
 * Creates breadcrumbs from fetch API calls
 */function _getFetchBreadcrumbHandler(client){return function _fetchBreadcrumb(handlerData){if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])()!==client){return;}var startTimestamp=handlerData.startTimestamp,endTimestamp=handlerData.endTimestamp;// We only capture complete fetch requests
if(!endTimestamp){return;}if(handlerData.fetchData.url.match(/sentry_key/)&&handlerData.fetchData.method==='POST'){// We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
return;}if(handlerData.error){var data=handlerData.fetchData;var hint={data:handlerData.error,input:handlerData.args,startTimestamp:startTimestamp,endTimestamp:endTimestamp};Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["p" /* addBreadcrumb */])({category:'fetch',data:data,level:'error',type:'http'},hint);}else{var response=handlerData.response;var _data=_objectSpread({},handlerData.fetchData,{status_code:response&&response.status});var _hint={input:handlerData.args,response:response,startTimestamp:startTimestamp,endTimestamp:endTimestamp};Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["p" /* addBreadcrumb */])({category:'fetch',data:_data,type:'http'},_hint);}};}/**
 * Creates breadcrumbs from history API calls
 */function _getHistoryBreadcrumbHandler(client){return function _historyBreadcrumb(handlerData){if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])()!==client){return;}var from=handlerData.from;var to=handlerData.to;var parsedLoc=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_34" /* parseUrl */])(__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].location.href);var parsedFrom=from?Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_34" /* parseUrl */])(from):undefined;var parsedTo=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_34" /* parseUrl */])(to);// Initial pushState doesn't provide `from` information
if(!parsedFrom||!parsedFrom.path){parsedFrom=parsedLoc;}// Use only the path component of the URL if the URL matches the current
// document (almost all the time when using pushState)
if(parsedLoc.protocol===parsedTo.protocol&&parsedLoc.host===parsedTo.host){to=parsedTo.relative;}if(parsedLoc.protocol===parsedFrom.protocol&&parsedLoc.host===parsedFrom.host){from=parsedFrom.relative;}Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["p" /* addBreadcrumb */])({category:'navigation',data:{from:from,to:to}});};}function _isEvent(event){return!!event&&!!event.target;}

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dedupe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dedupeIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(51);
var INTEGRATION_NAME='Dedupe';var _dedupeIntegration=function _dedupeIntegration(){var previousEvent;return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
processEvent:function processEvent(currentEvent){// We want to ignore any non-error type events, e.g. transactions or replays
// These should never be deduped, and also not be compared against as _previousEvent.
if(currentEvent.type){return currentEvent;}// Juuust in case something goes wrong
try{if(_shouldDropEvent(currentEvent,previousEvent)){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('Event dropped due to being a duplicate of previously captured event.');return null;}}catch(_oO){}// eslint-disable-line no-empty
return previousEvent=currentEvent;}};};var dedupeIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_dedupeIntegration);/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var Dedupe=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,dedupeIntegration);function _shouldDropEvent(currentEvent,previousEvent){if(!previousEvent){return false;}if(_isSameMessageEvent(currentEvent,previousEvent)){return true;}if(_isSameExceptionEvent(currentEvent,previousEvent)){return true;}return false;}function _isSameMessageEvent(currentEvent,previousEvent){var currentMessage=currentEvent.message;var previousMessage=previousEvent.message;// If neither event has a message property, they were both exceptions, so bail out
if(!currentMessage&&!previousMessage){return false;}// If only one event has a stacktrace, but not the other one, they are not the same
if(currentMessage&&!previousMessage||!currentMessage&&previousMessage){return false;}if(currentMessage!==previousMessage){return false;}if(!_isSameFingerprint(currentEvent,previousEvent)){return false;}if(!_isSameStacktrace(currentEvent,previousEvent)){return false;}return true;}function _isSameExceptionEvent(currentEvent,previousEvent){var previousException=_getExceptionFromEvent(previousEvent);var currentException=_getExceptionFromEvent(currentEvent);if(!previousException||!currentException){return false;}if(previousException.type!==currentException.type||previousException.value!==currentException.value){return false;}if(!_isSameFingerprint(currentEvent,previousEvent)){return false;}if(!_isSameStacktrace(currentEvent,previousEvent)){return false;}return true;}function _isSameStacktrace(currentEvent,previousEvent){var currentFrames=_getFramesFromEvent(currentEvent);var previousFrames=_getFramesFromEvent(previousEvent);// If neither event has a stacktrace, they are assumed to be the same
if(!currentFrames&&!previousFrames){return true;}// If only one event has a stacktrace, but not the other one, they are not the same
if(currentFrames&&!previousFrames||!currentFrames&&previousFrames){return false;}currentFrames=currentFrames;previousFrames=previousFrames;// If number of frames differ, they are not the same
if(previousFrames.length!==currentFrames.length){return false;}// Otherwise, compare the two
for(var i=0;i<previousFrames.length;i++){var frameA=previousFrames[i];var frameB=currentFrames[i];if(frameA.filename!==frameB.filename||frameA.lineno!==frameB.lineno||frameA.colno!==frameB.colno||frameA.function!==frameB.function){return false;}}return true;}function _isSameFingerprint(currentEvent,previousEvent){var currentFingerprint=currentEvent.fingerprint;var previousFingerprint=previousEvent.fingerprint;// If neither event has a fingerprint, they are assumed to be the same
if(!currentFingerprint&&!previousFingerprint){return true;}// If only one event has a fingerprint, but not the other one, they are not the same
if(currentFingerprint&&!previousFingerprint||!currentFingerprint&&previousFingerprint){return false;}currentFingerprint=currentFingerprint;previousFingerprint=previousFingerprint;// Otherwise, compare the two
try{return!!(currentFingerprint.join('')===previousFingerprint.join(''));}catch(_oO){return false;}}function _getExceptionFromEvent(event){return event.exception&&event.exception.values&&event.exception.values[0];}function _getFramesFromEvent(event){var exception=event.exception;if(exception){try{// @ts-expect-error Object could be undefined
return exception.values[0].stacktrace.frames;}catch(_oO){return undefined;}}return undefined;}

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return globalHandlersIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventbuilder_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_js__ = __webpack_require__(38);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* eslint-disable @typescript-eslint/no-unsafe-member-access */var INTEGRATION_NAME='GlobalHandlers';var _globalHandlersIntegration=function _globalHandlersIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _options=_objectSpread({onerror:true,onunhandledrejection:true},options);return{name:INTEGRATION_NAME,setupOnce:function setupOnce(){Error.stackTraceLimit=50;},setup:function setup(client){if(_options.onerror){_installGlobalOnErrorHandler(client);globalHandlerLog('onerror');}if(_options.onunhandledrejection){_installGlobalOnUnhandledRejectionHandler(client);globalHandlerLog('onunhandledrejection');}}};};var globalHandlersIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_globalHandlersIntegration);/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var GlobalHandlers=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,globalHandlersIntegration);function _installGlobalOnErrorHandler(client){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* addGlobalErrorInstrumentationHandler */])(function(data){var _getOptions=getOptions(),stackParser=_getOptions.stackParser,attachStacktrace=_getOptions.attachStacktrace;if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])()!==client||Object(__WEBPACK_IMPORTED_MODULE_4__helpers_js__["b" /* shouldIgnoreOnError */])()){return;}var msg=data.msg,url=data.url,line=data.line,column=data.column,error=data.error;var event=error===undefined&&Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_23" /* isString */])(msg)?_eventFromIncompleteOnError(msg,url,line,column):_enhanceEventWithInitialFrame(Object(__WEBPACK_IMPORTED_MODULE_3__eventbuilder_js__["c" /* eventFromUnknownInput */])(stackParser,error||msg,undefined,attachStacktrace,false),url,line,column);event.level='error';Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["v" /* captureEvent */])(event,{originalException:error,mechanism:{handled:false,type:'onerror'}});});}function _installGlobalOnUnhandledRejectionHandler(client){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* addGlobalUnhandledRejectionInstrumentationHandler */])(function(e){var _getOptions2=getOptions(),stackParser=_getOptions2.stackParser,attachStacktrace=_getOptions2.attachStacktrace;if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])()!==client||Object(__WEBPACK_IMPORTED_MODULE_4__helpers_js__["b" /* shouldIgnoreOnError */])()){return;}var error=_getUnhandledRejectionError(e);var event=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_20" /* isPrimitive */])(error)?_eventFromRejectionWithPrimitive(error):Object(__WEBPACK_IMPORTED_MODULE_3__eventbuilder_js__["c" /* eventFromUnknownInput */])(stackParser,error,undefined,attachStacktrace,true);event.level='error';Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["v" /* captureEvent */])(event,{originalException:error,mechanism:{handled:false,type:'onunhandledrejection'}});});}function _getUnhandledRejectionError(error){if(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_20" /* isPrimitive */])(error)){return error;}// eslint-disable-next-line @typescript-eslint/no-explicit-any
var e=error;// dig the object of the rejection out of known event types
try{// PromiseRejectionEvents store the object of the rejection under 'reason'
// see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
if('reason'in e){return e.reason;}// something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
// to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
// the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
// see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
// https://github.com/getsentry/sentry-javascript/issues/2380
else if('detail'in e&&'reason'in e.detail){return e.detail.reason;}}catch(e2){}// eslint-disable-line no-empty
return error;}/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */function _eventFromRejectionWithPrimitive(reason){return{exception:{values:[{type:'UnhandledRejection',// String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
value:"Non-Error promise rejection captured with value: ".concat(String(reason))}]}};}/**
 * This function creates a stack from an old, error-less onerror handler.
 */// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg,url,line,column){var ERROR_TYPES_RE=/^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;// If 'message' is ErrorEvent, get real message from inside
var message=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_12" /* isErrorEvent */])(msg)?msg.message:msg;var name='Error';var groups=message.match(ERROR_TYPES_RE);if(groups){name=groups[1];message=groups[2];}var event={exception:{values:[{type:name,value:message}]}};return _enhanceEventWithInitialFrame(event,url,line,column);}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event,url,line,column){// event.exception
var e=event.exception=event.exception||{};// event.exception.values
var ev=e.values=e.values||[];// event.exception.values[0]
var ev0=ev[0]=ev[0]||{};// event.exception.values[0].stacktrace
var ev0s=ev0.stacktrace=ev0.stacktrace||{};// event.exception.values[0].stacktrace.frames
var ev0sf=ev0s.frames=ev0s.frames||[];var colno=isNaN(parseInt(column,10))?undefined:column;var lineno=isNaN(parseInt(line,10))?undefined:line;var filename=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_23" /* isString */])(url)&&url.length>0?url:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_2" /* getLocationHref */])();// event.exception.values[0].stacktrace.frames
if(ev0sf.length===0){ev0sf.push({colno:colno,filename:filename,function:'?',in_app:true,lineno:lineno});}return event;}function globalHandlerLog(type){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("Global Handler attached: ".concat(type));}function getOptions(){var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])();var options=client&&client.getOptions()||{stackParser:function stackParser(){return[];},attachStacktrace:false};return options;}

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return httpContextIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__(38);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INTEGRATION_NAME='HttpContext';var _httpContextIntegration=function _httpContextIntegration(){return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
preprocessEvent:function preprocessEvent(event){// if none of the information we want exists, don't bother
if(!__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* WINDOW */].navigator&&!__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* WINDOW */].location&&!__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* WINDOW */].document){return;}// grab as much info as exists and add it to the event
var url=event.request&&event.request.url||__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* WINDOW */].location&&__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* WINDOW */].location.href;var _ref=__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* WINDOW */].document||{},referrer=_ref.referrer;var _ref2=__WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* WINDOW */].navigator||{},userAgent=_ref2.userAgent;var headers=_objectSpread({},event.request&&event.request.headers,{},referrer&&{Referer:referrer},{},userAgent&&{'User-Agent':userAgent});var request=_objectSpread({},event.request,{},url&&{url:url},{headers:headers});event.request=request;}};};var httpContextIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_httpContextIntegration);/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var HttpContext=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,httpContextIntegration);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return linkedErrorsIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventbuilder_js__ = __webpack_require__(139);
var DEFAULT_KEY='cause';var DEFAULT_LIMIT=5;var INTEGRATION_NAME='LinkedErrors';var _linkedErrorsIntegration=function _linkedErrorsIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var limit=options.limit||DEFAULT_LIMIT;var key=options.key||DEFAULT_KEY;return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
preprocessEvent:function preprocessEvent(event,hint,client){var options=client.getOptions();Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["v" /* applyAggregateErrorsToEvent */])(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
__WEBPACK_IMPORTED_MODULE_2__eventbuilder_js__["d" /* exceptionFromError */],options.stackParser,options.maxValueLength,key,limit,event,hint);}};};var linkedErrorsIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_linkedErrorsIntegration);/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var LinkedErrors=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,linkedErrorsIntegration);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TryCatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return browserApiErrorsIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_js__ = __webpack_require__(38);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var DEFAULT_EVENT_TARGET=['EventTarget','Window','Node','ApplicationCache','AudioTrackList','BroadcastChannel','ChannelMergerNode','CryptoOperation','EventSource','FileReader','HTMLUnknownElement','IDBDatabase','IDBRequest','IDBTransaction','KeyOperation','MediaController','MessagePort','ModalWindow','Notification','SVGElementInstance','Screen','SharedWorker','TextTrack','TextTrackCue','TextTrackList','WebSocket','WebSocketWorker','Worker','XMLHttpRequest','XMLHttpRequestEventTarget','XMLHttpRequestUpload'];var INTEGRATION_NAME='TryCatch';var _browserApiErrorsIntegration=function _browserApiErrorsIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _options=_objectSpread({XMLHttpRequest:true,eventTarget:true,requestAnimationFrame:true,setInterval:true,setTimeout:true},options);return{name:INTEGRATION_NAME,// TODO: This currently only works for the first client this is setup
// We may want to adjust this to check for client etc.
setupOnce:function setupOnce(){if(_options.setTimeout){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["U" /* fill */])(__WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* WINDOW */],'setTimeout',_wrapTimeFunction);}if(_options.setInterval){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["U" /* fill */])(__WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* WINDOW */],'setInterval',_wrapTimeFunction);}if(_options.requestAnimationFrame){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["U" /* fill */])(__WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* WINDOW */],'requestAnimationFrame',_wrapRAF);}if(_options.XMLHttpRequest&&'XMLHttpRequest'in __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* WINDOW */]){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["U" /* fill */])(XMLHttpRequest.prototype,'send',_wrapXHR);}var eventTargetOption=_options.eventTarget;if(eventTargetOption){var eventTarget=Array.isArray(eventTargetOption)?eventTargetOption:DEFAULT_EVENT_TARGET;eventTarget.forEach(_wrapEventTarget);}}};};var browserApiErrorsIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_browserApiErrorsIntegration);/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var TryCatch=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,browserApiErrorsIntegration);function _wrapTimeFunction(original){// eslint-disable-next-line @typescript-eslint/no-explicit-any
return function(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var originalCallback=args[0];args[0]=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_js__["c" /* wrap */])(originalCallback,{mechanism:{data:{function:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_0" /* getFunctionName */])(original)},handled:false,type:'instrument'}});return original.apply(this,args);};}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original){// eslint-disable-next-line @typescript-eslint/no-explicit-any
return function(callback){// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
return original.apply(this,[Object(__WEBPACK_IMPORTED_MODULE_2__helpers_js__["c" /* wrap */])(callback,{mechanism:{data:{function:'requestAnimationFrame',handler:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_0" /* getFunctionName */])(original)},handled:false,type:'instrument'}})]);};}function _wrapXHR(originalSend){// eslint-disable-next-line @typescript-eslint/no-explicit-any
return function(){// eslint-disable-next-line @typescript-eslint/no-this-alias
var xhr=this;var xmlHttpRequestProps=['onload','onerror','onprogress','onreadystatechange'];xmlHttpRequestProps.forEach(function(prop){if(prop in xhr&&typeof xhr[prop]==='function'){// eslint-disable-next-line @typescript-eslint/no-explicit-any
Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["U" /* fill */])(xhr,prop,function(original){var wrapOptions={mechanism:{data:{function:prop,handler:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_0" /* getFunctionName */])(original)},handled:false,type:'instrument'}};// If Instrument integration has been called before TryCatch, get the name of original function
var originalFunction=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_4" /* getOriginalFunction */])(original);if(originalFunction){wrapOptions.mechanism.data.handler=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_0" /* getFunctionName */])(originalFunction);}// Otherwise wrap directly
return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_js__["c" /* wrap */])(original,wrapOptions);});}});for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return originalSend.apply(this,args);};}function _wrapEventTarget(target){// eslint-disable-next-line @typescript-eslint/no-explicit-any
var globalObject=__WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* WINDOW */];// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
var proto=globalObject[target]&&globalObject[target].prototype;// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
if(!proto||!proto.hasOwnProperty||!proto.hasOwnProperty('addEventListener')){return;}Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["U" /* fill */])(proto,'addEventListener',function(original){return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
eventName,fn,options){try{if(typeof fn.handleEvent==='function'){// ESlint disable explanation:
//  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
//  introduce a bug here, because bind returns a new function that doesn't have our
//  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
//  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
// eslint-disable-next-line @typescript-eslint/unbound-method
fn.handleEvent=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_js__["c" /* wrap */])(fn.handleEvent,{mechanism:{data:{function:'handleEvent',handler:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_0" /* getFunctionName */])(fn),target:target},handled:false,type:'instrument'}});}}catch(err){// can sometimes get 'Permission denied to access property "handle Event'
}return original.apply(this,[eventName,// eslint-disable-next-line @typescript-eslint/no-explicit-any
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_js__["c" /* wrap */])(fn,{mechanism:{data:{function:'addEventListener',handler:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_0" /* getFunctionName */])(fn),target:target},handled:false,type:'instrument'}}),options]);};});Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["U" /* fill */])(proto,'removeEventListener',function(originalRemoveEventListener// eslint-disable-next-line @typescript-eslint/no-explicit-any
){return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
eventName,fn,options){/**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */var wrappedEventHandler=fn;try{var originalEventHandler=wrappedEventHandler&&wrappedEventHandler.__sentry_wrapped__;if(originalEventHandler){originalRemoveEventListener.call(this,eventName,originalEventHandler,options);}}catch(e){// ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
}return originalRemoveEventListener.call(this,eventName,wrappedEventHandler,options);};});}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18n_messages_segments_verticals_en__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_messages_segments_guides_en__ = __webpack_require__(716);
/* eslint-disable max-len */var en={meta:{home:{title:'GastroBuddy — One app for your floor + AI assistant (free month)',description:'Start your free month. Checklists, cash, recipes, time tracking, web dashboard — plus an AI assistant for owners. Setup takes minutes.'},onboard:{title:'Sign up — GastroBuddy | Free trial',description:'Create your GastroBuddy account and start your free trial. Manage locations, enable modules, and invite your team.'},terms:{title:'Terms of Service — GastroBuddy',description:'Terms of Service for using GastroBuddy software and hospitality operations tools.'},privacy:{title:'Privacy Policy — GastroBuddy',description:'How GastroBuddy processes personal data for our website, dashboard, and mobile apps.'},cookies:{title:'Cookies — GastroBuddy',description:'Information about cookies and similar technologies on gastrobuddy.nl and related sites.'},contact:{title:'Contact — GastroBuddy',description:'Contact GastroBuddy for support, sales, and privacy questions.'},compare:{title:'GastroBuddy vs paper & generic tools',description:'See how GastroBuddy compares to paper binders, spreadsheets, and generic task apps for restaurant floor operations.'},checklist:{title:'Free open/close checklist for restaurants — GastroBuddy',description:'A practical opening and closing checklist for hospitality teams. Use it as-is, then run it in GastroBuddy with your team.'},pricing:{title:'Pricing — GastroBuddy plans & modules',description:'Choose a team-size plan and optional per-location modules. Checkout on the web, then unlock the app with your account.'},forIndex:{title:'GastroBuddy for restaurants, hotels, bars & more',description:'See how GastroBuddy fits restaurants, hotels, bars, cafés, and catering — then start a free month.'},guidesIndex:{title:'Hospitality ops guides — GastroBuddy',description:'Practical guides for open/close, staff onboarding, HACCP-style checks, cash closing, MEP, and multi-location ops.'},notFound:{title:'Page not found — GastroBuddy',description:'This page does not exist. Return to the GastroBuddy homepage.'}},nav:{home:'Home',login:'Log in',signup:'Sign up free',language:'Language',primary:'Primary'},footer:{copyright:'© {year} GastroBuddy',terms:'Terms of Service',privacy:'Privacy',cookies:'Cookies',contact:'Contact',compare:'Compare',checklist:'Free checklist',pricing:'Pricing',forVenues:'For your venue',guides:'Guides',language:'Language',nav:'Footer'},home:{heroTitle:'One app for your floor: checklists, cash, recipes, and an AI assistant',heroSubtitle:'Cut busywork: create lists and recipes from chat, manage locations from the browser, and leave ring binders behind.',ctaPrimary:'Start my free month',ctaPrimaryHint:'First month free · Setup takes minutes',trustLabel:'Why operators start here',trustFreeMonth:'First month free',trustSetup:'Setup in minutes',trustApps:'iOS, Android & web',trustTeam:'Invite staff when you are ready',stickyCtaLabel:'Start free trial',stickyCta:'Start free month',stickyCtaHint:'No credit card to explore',compareLink:'Compare options',checklistLink:'Free open/close checklist',forLink:'For restaurants, hotels & more',guidesLink:'Ops guides',sectionReadyTitle:'Ready to try it with your team?',sectionReadyBody:'Create an account in minutes and turn on the modules you need: task lists, cash, recipes, and more.',ctaSecondary:'Create my free account',ctaSecondaryHint:'Free trial · Invite staff when you are ready',downloadTitle:'Also on iOS and Android',heroHomeAlt:'GastroBuddy mobile home screen with daily operations overview',heroTasklistAlt:'GastroBuddy task list screen for floor checklists',videoTitle:'GastroBuddy product overview video',videoHeading:'See it on the floor',videoLede:'A short look at how GastroBuddy runs open, close, and daily ops with your team.',outcomesTitle:'What changes on shift',outcomesLede:'Less chasing, clearer ownership, faster onboarding for new staff.',outcomes:{oneTitle:'One place for the floor',oneBody:'Task progress in real time so everyone sees what is done and what is next.',twoTitle:'Clear ownership',twoBody:'Quality and accountability stay visible across shifts, not buried in chat.',threeTitle:'Faster onboarding',threeBody:'Step-by-step plans from open to close, so new staff start useful sooner.'},modulesTitle:'Modules you turn on when you need them',modulesLede:'Start with checklists. Add cash, recipes, and the rest as your venue needs them.',modules:{aiTitle:'AI assistant',aiBody:'Create lists and recipes from chat, pull locations, and draft reports.',tasklistTitle:'Task lists',tasklistBody:'Open/close and daily checklists with shared progress.',cashTitle:'Cash closing',cashBody:'Register tracking and day closings without spreadsheet chaos.',recipesTitle:'Recipes',recipesBody:'Ingredients and specs for kitchen and bar.',dashboardTitle:'Web dashboard',dashboardBody:'Manage locations, lists, and recipes from the browser.',mepTitle:'Mise en place',mepBody:'Prep lists that match how your stations actually run.',facilityTitle:'Facility',facilityBody:'Cleaning, maintenance, and floor ops lists your team can run daily.',whiteboardTitle:'Team whiteboard',whiteboardBody:'Shared notes for the floor, visible to the whole team.'}},onboard:{thankYouTitle:'Thank you for signing up',thankYouBodyBefore:'Log in on the dashboard to finish setting up your location.',thankYouLink:'Open GastroBuddy dashboard'},forms:{signupTitle:'Sign up',signupBullet1:'Create an account in three quick steps. No strings attached.',signupBullet2:'Add task lists and team members in the GastroBuddy Manager',signupBullet3:'Your team can start using GastroBuddy right away',fullName:'Full name',email:'Email',password:'Password',passwordTitle:'Choose a password',passwordLede:'Use at least 8 characters. You can show it while typing.',businessTitle:'Business details',businessLede:'Tell us about your venue so we can set up your location.',businessName:'Business name',address:'Address',city:'City',postalCode:'Postal code',phone:'Phone number',next:'Next',back:'Back',createAccount:'Create account',creatingAccount:'Creating account…',stepProgress:'Step {current} of {total}',checkoutClaimNote:'Your checkout plan will be linked to this account after signup. No extra payment in the app.',passwordHint:'At least 8 characters',showPassword:'Show',hidePassword:'Hide',googleContinue:'Continue with Google',googleContinueLoading:'Opening Google…',googleFailed:'Google sign-in did not finish. Try again or use email.',googleSessionExpired:'Your Google session expired. Continue with Google again.',orEmail:'Or continue with email',postalHint:'Dutch format, e.g. 1234 AB',phoneHint:'Include country or area code if needed',valNameRequired:'Enter your full name',valEmailRequired:'Enter your email address',valEmailInvalid:'Enter a valid email address',valPasswordMin:'Password must be at least 8 characters',valPasswordRequired:'Choose a password',valBusinessRequired:'Enter your business name',valAddressRequired:'Enter the street address',valCityRequired:'Enter the city',valZipFormat:'Use format 1234 AB',valZipRequired:'Enter the postal code',valPhoneRequired:'Enter a phone number',valPhoneMin:'Phone number must be at least 8 characters',requestFailed:'We could not create your account. Check your details and try again.',networkError:'Connection failed. Check your network and try again.'},notFound:{title:'Page not found',backHome:'Back to home'},terms:{title:'Terms of Service',intro:'These Terms of Service ("Terms") govern your use of GastroBuddy software and related services offered by us ("GastroBuddy", "we", "us"). By creating an account or using the service, you agree to these Terms.',notice:'This is a general website notice. Have your legal counsel review and replace this text for your entity and jurisdiction.',s1:'1. The service',s1Body:'GastroBuddy provides tools for hospitality operations (including but not limited to checklists, cash tracking, recipes, time registration, and related features). Features may vary by plan, location, and configuration.',s2:'2. Accounts and eligibility',s2Body:'You must provide accurate registration information and keep credentials secure. You are responsible for activity under your account. You must have authority to bind your business if you register on behalf of an organisation.',s3:'3. Acceptable use',s3Body:'You will not misuse the service, attempt unauthorised access, interfere with other users, or use GastroBuddy in violation of applicable law. We may suspend or terminate access for breach of these Terms or risk to the platform.',s4:'4. Subscriptions and fees',s4Body:'Paid plans, trials, and billing terms are presented at purchase or in your account. Unless stated otherwise, fees are non-refundable except where required by law. We may change pricing with reasonable notice.',s5:'5. Data and privacy',s5Before:'Our processing of personal data is described in our',s5After:'. You are responsible for your own compliance with laws applicable to your business and staff data.',s6:'6. Disclaimer and limitation of liability',s6Body:'The service is provided "as is" to the extent permitted by law. We do not guarantee uninterrupted or error-free operation. Our total liability for claims arising from these Terms or the service is limited as permitted by applicable law.',s7:'7. Changes',s7Body:'We may update these Terms from time to time. Continued use after changes constitutes acceptance of the revised Terms where permitted by law.',s8:'8. Contact',s8Before:'Questions about these Terms: see our',s8After:'page.'},privacy:{title:'Privacy Policy',intro:'This Privacy Policy explains how GastroBuddy ("we", "us") processes personal data when you use our website, web dashboard, and mobile applications.',notice:'Replace this text with a version reviewed by your Data Protection Officer or legal counsel, especially if you operate in the EU/UK (GDPR) or other regulated regions.',h1:'1. Who is responsible?',p1Before:'The controller of personal data for the service is the business entity operating GastroBuddy for your contract. For questions, use the details on our',p1After:'page.',h2:'2. What data we process',p2Before:'Depending on how you use GastroBuddy, this may include: account and contact details (e.g. name, email), organisation and location information, usage and log data, content you enter (e.g. task lists, recipes, operational records), and technical data (e.g. device, IP address, cookies — see our',p2After:').',cookieLink:'Cookie notice',h3:'3. Purposes and legal bases',p3:'We process data to provide and improve the service, authenticate users, bill subscriptions, communicate with you, ensure security, and comply with legal obligations. Where GDPR applies, we rely on contract, legitimate interests, consent (where required), and legal obligation as appropriate.',h4:'4. Processors and transfers',p4:'We use infrastructure and subprocessors (e.g. hosting, authentication, analytics) who process data on our instructions. Data may be processed in the European Economic Area and other countries with appropriate safeguards where required.',h5:'5. Retention',p5:'We keep data only as long as needed for the purposes above, including legal, accounting, and dispute resolution requirements, unless a longer period is required by law.',h6:'6. Your rights',p6:'Where applicable, you may have rights to access, rectify, erase, restrict, or object to processing, data portability, and to lodge a complaint with a supervisory authority. Contact us to exercise your rights.',h7:'7. Changes',p7:'We may update this policy from time to time. We will post the updated version on this page and, if appropriate, notify you through the service.'},cookies:{title:'Cookies & similar technologies',intro:'This page describes how we use cookies and similar technologies on gastrobuddy.nl and related web properties.',h1:'1. What are cookies?',p1:'Cookies are small files stored on your device. We also use similar technologies (e.g. local storage) where needed for the service to function.',h2:'2. How we use them',essential:'Essential: required for security, load balancing, and core site functionality.',preferences:'Preferences: remember choices such as language where applicable.',analytics:'Analytics / marketing: we may use tools (e.g. Google Tag Manager) to understand traffic and campaigns, subject to your consent where required.',h3:'3. Managing cookies',p3:'You can control cookies through your browser settings. Blocking some cookies may limit site functionality.',h4:'4. More information',p4Before:'Personal data related to cookies is covered in our',p4After:'.'},contact:{title:'Contact',intro:'We are happy to help with questions about GastroBuddy, your account, or partnerships.',customers:'Existing customers',customersBody:'Log in to the web dashboard for account and location management: use Log in from the header of this site, or go directly to your manager URL provided during onboarding.',legal:'Legal & privacy',legalBefore:'For privacy requests or legal notices, please contact us using the same channels above and include "Privacy" in the subject line. See also our',legalMid:'and',legalAfter:'.'},pricing:{title:'GastroBuddy pricing',intro:'Pick a base plan by team size, add modules per location, then continue to secure checkout. Or start a free trial first.',cancelled:'Checkout was cancelled. Adjust your plan below when you are ready.',tiersHeading:'Organization plan',tiersHint:'Staff limits apply per location.',staffStarter:'Up to 5 team members',staffPro:'6–20 team members',staffEnterprise:'Unlimited team members',tiers:{starter:{name:'Starter'},pro:{name:'Pro'},enterprise:{name:'Enterprise'}},modulesHeading:'Location modules',modulesHint:'Priced per location / month. Task lists and recipes are included in every plan.',included:'Included: task lists + recipes',modules:{modCash:'Cash register',modTimesheet:'Timesheet',modReservations:'Reservations',modMep:'Mise en place',modFacility:'Facility'},summaryHeading:'Your monthly total',summaryNote:'Add-ons assume one location. Extra locations are managed after signup.',total:'Total',perMonth:'/mo',perLocationMonth:'/loc/mo',checkoutCta:'Continue to checkout',checkoutLoading:'Opening checkout…',trialCta:'Start free trial instead',enterpriseContact:'Prefer to talk? Contact us',footnote:'Subscriptions are billed on the web via Stripe. The app unlocks after you sign in with an active account. Prices exclude VAT where applicable.',errors:{apiMissing:'Billing is not configured on this site. Try again later or contact us.',checkoutFailed:'Could not start checkout. Check your connection and try again.',network:'Network error. Check your connection and try again.'}},compare:{title:'How GastroBuddy compares',intro:'Operators usually start with paper, spreadsheets, WhatsApp, or a POS that was never built for floor checklists. Here is an honest category comparison — not a vendor hit list.',tableCaption:'Comparison of paper, generic tools, and GastroBuddy for hospitality operations',colTopic:'Need',colPaper:'Paper / binders',colGeneric:'Spreadsheets & chat',colGastro:'GastroBuddy',rows:{progress:{topic:'Live task progress',paper:'No shared status; managers chase updates',generic:'Messages get buried; hard to see what is done',gastro:'Real-time progress per task for the whole team'},cash:{topic:'Cash & day closings',paper:'Separate notebook or till sheet',generic:'Ad-hoc sheets; easy to lose history',gastro:'Cash register tracking and day closings in one place'},recipes:{topic:'Recipes & mise en place',paper:'Printed folders go out of date',generic:'Docs scattered across drives',gastro:'Recipes and MEP lists with kitchen and bar context'},ai:{topic:'Creating lists & recipes',paper:'Rewrite by hand',generic:'Copy-paste templates',gastro:'AI assistant can draft lists and recipes from chat'},team:{topic:'Onboarding new staff',paper:'Shadow shifts and tribal knowledge',generic:'Long message threads',gastro:'Step-by-step plans your team can follow on phone or tablet'},paper:{topic:'Leaving the binder behind',paper:'Still carrying it',generic:'Still printing “just in case”',gastro:'Same account on mobile apps and web dashboard'}},disclaimer:'We do not claim every venue needs every module. Start with the free month, turn on what you use, and invite staff when you are ready.',cta:'Start my free month',ctaHint:'First month free · Setup takes minutes',checklistLink:'Prefer a printable starter? Get the free open/close checklist →'},checklist:{title:'Free open/close checklist',intro:'A practical starting point for hospitality floor routines. Adapt it to your venue, then run the same flow in GastroBuddy so the whole team sees progress.',openTitle:'Opening',closeTitle:'Closing',open:{o1:'Unlock, lights, music, and climate as needed',o2:'Check toilets, floors, and guest-facing areas',o3:'Stock stations, ice, garnishes, and to-go supplies',o4:'Confirm tills / floats and card terminals are ready',o5:'Brief the team on reservations, 86s, and allergens',o6:'Verify fridge temps and critical food-safety checks'},close:{c1:'Clear, reset, and restock stations for the next shift',c2:'Run final cash / tip reconciliation and day closing',c3:'Clean guest areas, toilets, and high-touch surfaces',c4:'Secure inventory, fridges, and alcohol storage',c5:'Complete closing checklist items assigned to the shift',c6:'Lock up, alarms, and note anything for the next open'},adaptNote:'Treat this as a template. Your venue may need HACCP-specific steps, bar-only items, or multi-location variants — GastroBuddy is built for that structure.',formTitle:'Email me this checklist',formIntro:'Optional: leave your work email and we send the checklist to your inbox. No spam.',formEmail:'Work email',formBusiness:'Business name (optional)',formSubmit:'Send me the checklist',formSubmitting:'Sending…',formError:'Something went wrong. Try again, or start your free account instead.',formEmailRequired:'Enter a work email so we can send the checklist.',formEmailInvalid:'Enter a valid email address (for example name@restaurant.nl).',formSuccessTitle:'Thanks — check your inbox',formSuccessBody:'The checklist is on its way. You can also start your free month now.',formPrivacyBefore:'We only use your details to email this resource and relevant GastroBuddy tips. See',formPrivacyAfter:' for details.',nextTitle:'Ready to run this with your team?',nextBody:'Turn the same open/close flow into live task lists with progress everyone can see.',cta:'Start my free month',ctaHint:'Free trial · Invite staff when you are ready',compareLink:'See how GastroBuddy compares to paper and spreadsheets →'},jsonLd:{orgDescription:'GastroBuddy helps restaurants and bars run daily operations: checklists, cash register, recipes, time tracking, and an AI assistant for owners.',siteDescription:'Hospitality operations platform: task lists, cash, mise en place, recipes with kitchen and bar contexts, web dashboard, and AI assistant.'},verticals:__WEBPACK_IMPORTED_MODULE_0_i18n_messages_segments_verticals_en__["a" /* default */],guides:__WEBPACK_IMPORTED_MODULE_1_i18n_messages_segments_guides_en__["a" /* default */]};/* harmony default export */ __webpack_exports__["a"] = (en);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18n_messages_segments_verticals_nl__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_messages_segments_guides_nl__ = __webpack_require__(718);
/* eslint-disable max-len */var nl={meta:{home:{title:'GastroBuddy — één app voor de vloer + AI-assistent (gratis maand)',description:'Start je gratis maand. Checklists, kas, recepten, tijdregistratie, webdashboard en een AI-assistent voor eigenaren. Klaar in een paar minuten.'},onboard:{title:'Aanmelden — GastroBuddy | gratis proefperiode',description:'Maak je GastroBuddy-account aan en start je proefperiode. Beheer locaties, schakel modules in en nodig je team uit.'},terms:{title:'Algemene voorwaarden — GastroBuddy',description:'Algemene voorwaarden voor het gebruik van GastroBuddy en horeca-tools.'},privacy:{title:'Privacybeleid — GastroBuddy',description:'Hoe GastroBuddy persoonsgegevens verwerkt voor website, dashboard en mobiele apps.'},cookies:{title:'Cookies — GastroBuddy',description:'Informatie over cookies en vergelijkbare technieken op gastrobuddy.nl en gerelateerde sites.'},contact:{title:'Contact — GastroBuddy',description:'Neem contact op met GastroBuddy voor support, sales en privacy.'},compare:{title:'GastroBuddy vs papier & generieke tools',description:'Bekijk hoe GastroBuddy zich verhoudt tot ringbanden, spreadsheets en generieke taken-apps voor de horecavloer.'},checklist:{title:'Gratis open/sluit-checklist voor de horeca — GastroBuddy',description:'Een praktische open- en sluitchecklist voor horecateams. Gebruik hem zo, en draai hem daarna in GastroBuddy met je team.'},pricing:{title:'Prijzen — GastroBuddy plannen & modules',description:'Kies een plan op teamgrootte en optionele modules per locatie. Betaal op het web; de app ontgrendelt met je account.'},forIndex:{title:'GastroBuddy voor restaurants, hotels, bars en meer',description:'Zie hoe GastroBuddy past bij restaurants, hotels, bars, cafés en catering. Start daarna je gratis maand.'},guidesIndex:{title:'Horeca-gidsen — GastroBuddy',description:'Praktische gidsen over openen en sluiten, inwerken, HACCP-achtige checks, kasafsluiting, mise en place en multi-locatie.'},notFound:{title:'Pagina niet gevonden — GastroBuddy',description:'Deze pagina bestaat niet. Ga terug naar de homepage van GastroBuddy.'}},nav:{home:'Home',login:'Inloggen',signup:'Gratis aanmelden',language:'Taal',primary:'Hoofdnavigatie'},footer:{copyright:'© {year} GastroBuddy',terms:'Algemene voorwaarden',privacy:'Privacy',cookies:'Cookies',contact:'Contact',compare:'Vergelijken',checklist:'Gratis checklist',pricing:'Prijzen',forVenues:'Voor jouw zaak',guides:'Gidsen',language:'Taal',nav:'Voettekst'},home:{heroTitle:'Één app voor je vloer: checklists, kas, recepten en een AI-assistent',heroSubtitle:'Minder gedoe op de dienst. Maak lijsten en recepten via chat, beheer locaties in de browser, en laat de ringband staan.',ctaPrimary:'Start mijn gratis maand',ctaPrimaryHint:'Eerste maand gratis · Klaar in een paar minuten',trustLabel:'Waarom ondernemers hier starten',trustFreeMonth:'Eerste maand gratis',trustSetup:'Klaar in een paar minuten',trustApps:'iOS, Android en web',trustTeam:'Nodig personeel uit wanneer jij wilt',stickyCtaLabel:'Start gratis proefperiode',stickyCta:'Start gratis maand',stickyCtaHint:'Geen creditcard nodig om te kijken',compareLink:'Vergelijk opties',checklistLink:'Gratis open/sluit-checklist',forLink:'Voor restaurants, hotels en meer',guidesLink:'Horeca-gidsen',sectionReadyTitle:'Klaar om het met je team te proberen?',sectionReadyBody:'Maak in een paar minuten een account en zet alleen de modules aan die je nodig hebt: takenlijsten, kas, recepten en meer.',ctaSecondary:'Maak mijn gratis account',ctaSecondaryHint:'Gratis proefperiode · Nodig personeel uit wanneer jij wilt',downloadTitle:'Ook op iOS en Android',heroHomeAlt:'GastroBuddy-app: startscherm met dagelijkse werkzaamheden',heroTasklistAlt:'GastroBuddy-app: takenlijst voor checklists op de vloer',videoTitle:'GastroBuddy productvideo',videoHeading:'Zo ziet het eruit op de vloer',videoLede:'Kort beeld van openen, sluiten en dagelijkse ops met GastroBuddy en je team.',outcomesTitle:'Wat er verandert op de dienst',outcomesLede:'Minder nachecken. Duidelijker wie wat doet. Sneller inwerken.',outcomes:{oneTitle:'Alles op één plek',oneBody:'Realtime voortgang per taak. Iedereen ziet wat klaar is en wat nog moet.',twoTitle:'Duidelijk wie wat doet',twoBody:'Kwaliteit en verantwoordelijkheid blijven zichtbaar over diensten. Niet in de chat.',threeTitle:'Sneller inwerken',threeBody:'Stappenplannen van openen tot sluiten. Nieuw personeel draait sneller mee.'},modulesTitle:'Modules die je aanzet wanneer jij wilt',modulesLede:'Begin met checklists. Voeg kas, recepten en de rest toe zodra jouw zaak dat nodig heeft.',modules:{aiTitle:'AI-assistent',aiBody:'Maak lijsten en recepten via chat, haal locaties op en stel rapporten op.',tasklistTitle:'Takenlijsten',tasklistBody:'Openen, sluiten en dagelijkse checklists met gedeelde voortgang.',cashTitle:'Kasafsluiting',cashBody:'Kasregistratie en dagafsluitingen, zonder spreadsheet-chaos.',recipesTitle:'Recepten',recipesBody:'Ingrediënten en recepten voor keuken en bar.',dashboardTitle:'Webdashboard',dashboardBody:'Beheer locaties, lijsten en recepten in de browser.',mepTitle:'Mise en place',mepBody:'Preplijsten die aansluiten op hoe jouw stations echt draaien.',facilityTitle:'Facilitair',facilityBody:'Schoonmaak, onderhoud en vloerlijsten die je team elke dag kan afvinken.',whiteboardTitle:'Team-whiteboard',whiteboardBody:'Gedeelde notities voor de vloer, zichtbaar voor het hele team.'}},onboard:{thankYouTitle:'Bedankt voor je aanmelding',thankYouBodyBefore:'Log in op het dashboard om je locatie af te ronden.',thankYouLink:'Open GastroBuddy-dashboard'},forms:{signupTitle:'Aanmelden',signupBullet1:'Maak in drie stappen een account. Geen verplichtingen.',signupBullet2:'Voeg takenlijsten en teamleden toe in de GastroBuddy Manager',signupBullet3:'Je team kan meteen aan de slag met GastroBuddy',fullName:'Volledige naam',email:'E-mail',password:'Wachtwoord',passwordTitle:'Kies een wachtwoord',passwordLede:'Gebruik minimaal 8 tekens. Je kunt het tonen tijdens het typen.',businessTitle:'Bedrijfsgegevens',businessLede:'Vertel over je zaak zodat we je locatie kunnen klaarzetten.',businessName:'Bedrijfsnaam',address:'Adres',city:'Plaats',postalCode:'Postcode',phone:'Telefoonnummer',next:'Volgende',back:'Terug',createAccount:'Account aanmaken',creatingAccount:'Account aanmaken…',stepProgress:'Stap {current} van {total}',checkoutClaimNote:'Je plan uit checkout wordt na aanmelden aan dit account gekoppeld. Geen extra betaling in de app.',passwordHint:'Minimaal 8 tekens',showPassword:'Toon',hidePassword:'Verberg',googleContinue:'Doorgaan met Google',googleContinueLoading:'Google openen…',googleFailed:'Google-aanmelden is niet gelukt. Probeer opnieuw of gebruik e-mail.',googleSessionExpired:'Je Google-sessie is verlopen. Ga opnieuw door met Google.',orEmail:'Of ga verder met e-mail',postalHint:'Nederlands formaat, bijv. 1234 AB',phoneHint:'Voeg indien nodig land- of netnummer toe',valNameRequired:'Vul je volledige naam in',valEmailRequired:'Vul je e-mailadres in',valEmailInvalid:'Vul een geldig e-mailadres in',valPasswordMin:'Wachtwoord moet minimaal 8 tekens zijn',valPasswordRequired:'Kies een wachtwoord',valBusinessRequired:'Vul je bedrijfsnaam in',valAddressRequired:'Vul het straatadres in',valCityRequired:'Vul de plaats in',valZipFormat:'Gebruik formaat 1234 AB',valZipRequired:'Vul de postcode in',valPhoneRequired:'Vul een telefoonnummer in',valPhoneMin:'Telefoonnummer moet minimaal 8 tekens zijn',requestFailed:'We konden je account niet aanmaken. Controleer je gegevens en probeer opnieuw.',networkError:'Verbinding mislukt. Controleer je netwerk en probeer opnieuw.'},notFound:{title:'Pagina niet gevonden',backHome:'Terug naar home'},terms:{title:'Algemene voorwaarden',intro:'Deze algemene voorwaarden ("Voorwaarden") zijn van toepassing op je gebruik van GastroBuddy-software en gerelateerde diensten van ons ("GastroBuddy", "wij", "ons"). Door een account aan te maken of de dienst te gebruiken, ga je akkoord met deze Voorwaarden.',notice:'Dit is een algemene websitetekst. Laat je tekst beoordelen door je juridisch adviseur en pas aan voor jouw entiteit en rechtsgebied.',s1:'1. De dienst',s1Body:'GastroBuddy biedt tools voor horeca-operatie (o.a. checklists, kas, recepten, tijdregistratie en gerelateerde functies). Functies kunnen verschillen per plan, locatie en configuratie.',s2:'2. Accounts en geschiktheid',s2Body:'Je verstrekt juiste registratiegegevens en bewaart inloggegevens veilig. Je bent verantwoordelijk voor activiteit onder je account. Je moet bevoegd zijn je bedrijf te binden als je namens een organisatie registreert.',s3:'3. Aanvaardbaar gebruik',s3Body:'Je misbruikt de dienst niet, probeert geen ongeautoriseerde toegang, verstoort andere gebruikers niet en gebruikt GastroBuddy niet in strijd met de wet. We kunnen toegang opschorten of beëindigen bij overtreding of risico voor het platform.',s4:'4. Abonnementen en kosten',s4Body:'Betaalde plannen, proefperiodes en facturatie worden getoond bij aankoop of in je account. Tenzij anders vermeld, zijn kosten niet terugbetaalbaar behalve waar de wet dat vereist. We kunnen prijzen wijzigen met redelijke termijn.',s5:'5. Gegevens en privacy',s5Before:'Onze verwerking van persoonsgegevens staat in ons',s5After:'. Je bent zelf verantwoordelijk voor naleving van wetten voor jouw bedrijf en personeelsgegevens.',s6:'6. Disclaimer en aansprakelijkheid',s6Body:'De dienst wordt geleverd "zoals ze is" voor zover de wet dat toestaat. We garanderen geen ononderbroken of foutloze werking. Onze totale aansprakelijkheid voor claims uit deze Voorwaarden of de dienst is beperkt tot wat de wet toestaat.',s7:'7. Wijzigingen',s7Body:'We kunnen deze Voorwaarden van tijd tot tijd bijwerken. Verder gebruik na wijzigingen betekent akkoord met de gewijzigde Voorwaarden, voor zover de wet dat toestaat.',s8:'8. Contact',s8Before:'Vragen over deze Voorwaarden: zie onze',s8After:'pagina.'},privacy:{title:'Privacybeleid',intro:'Dit privacybeleid legt uit hoe GastroBuddy ("wij", "ons") persoonsgegevens verwerkt wanneer je onze website, het webdashboard en mobiele apps gebruikt.',notice:"Vervang deze tekst door een versie die beoordeeld is door je FG of juridisch adviseur, vooral bij EU/UK (AVG) of andere regio's.",h1:'1. Wie is verantwoordelijk?',p1Before:'De verwerkingsverantwoordelijke voor de dienst is de bedrijfsentiteit die GastroBuddy voor jouw contract levert. Voor vragen: contact op de',p1After:'pagina.',h2:'2. Welke gegevens verwerken we',p2Before:'Afhankelijk van je gebruik kan dit onder meer zijn: account- en contactgegevens (bijv. naam, e-mail), organisatie- en locatie-informatie, gebruiks- en loggegevens, door jou ingevoerde inhoud (bijv. takenlijsten, recepten, operationele gegevens), en technische gegevens (bijv. apparaat, IP-adres, cookies — zie onze',p2After:').',cookieLink:'Cookie-informatie',h3:'3. Doelen en grondslagen',p3:'We verwerken gegevens om de dienst te leveren en te verbeteren, gebruikers te authenticeren, abonnementen te factureren, met je te communiceren, veiligheid te waarborgen en wettelijke verplichtingen na te komen. Bij AVG gebruiken we o.a. overeenkomst, gerechtvaardigd belang, toestemming (waar nodig) en wettelijke verplichting.',h4:'4. Verwerkers en doorgifte',p4:'We gebruiken infrastructuur en subprocessors (bijv. hosting, authenticatie, analytics) die gegevens verwerken volgens onze instructies. Gegevens kunnen in de EER en andere landen met passende waarborgen worden verwerkt.',h5:'5. Bewaartermijn',p5:'We bewaren gegevens alleen zolang nodig voor bovenstaande doelen, inclusief juridische, fiscale en geschilvereisten, tenzij de wet langer vereist.',h6:'6. Jouw rechten',p6:'Waar van toepassing heb je rechten op inzage, rectificatie, wissing, beperking, bezwaar, en gegevensoverdracht, en kun je een klacht indienen bij een toezichthouder. Neem contact op om rechten uit te oefenen.',h7:'7. Wijzigingen',p7:'We kunnen dit beleid van tijd tot tijd bijwerken. We plaatsen de gewijzigde versie op deze pagina en, indien passend, informeren we je via de dienst.'},cookies:{title:'Cookies & vergelijkbare technieken',intro:'Deze pagina beschrijft hoe we cookies en vergelijkbare technieken gebruiken op gastrobuddy.nl en gerelateerde sites.',h1:'1. Wat zijn cookies?',p1:'Cookies zijn kleine bestanden op je apparaat. We gebruiken ook vergelijkbare technieken (bijv. local storage) waar nodig voor de dienst.',h2:'2. Hoe we ze gebruiken',essential:'Essentieel: nodig voor beveiliging, load balancing en kernfunctionaliteit van de site.',preferences:'Voorkeuren: onthouden van keuzes zoals taal waar van toepassing.',analytics:'Analytics / marketing: we kunnen tools (bijv. Google Tag Manager) gebruiken voor inzicht in verkeer en campagnes, met toestemming waar nodig.',h3:'3. Cookies beheren',p3:'Je kunt cookies beheren via je browserinstellingen. Het blokkeren van sommige cookies kan de functionaliteit beperken.',h4:'4. Meer informatie',p4Before:'Persoonsgegevens met betrekking tot cookies vallen onder ons',p4After:'.'},contact:{title:'Contact',intro:'Vragen over GastroBuddy, je account of een samenwerking? We helpen je graag.',customers:'Bestaande klanten',customersBody:'Log in op het webdashboard voor account- en locatiebeheer. Gebruik Inloggen in de header, of ga naar de manager-URL uit je onboarding.',legal:'Juridisch & privacy',legalBefore:'Voor privacyverzoeken of juridische kennisgevingen: neem contact op via dezelfde kanalen en vermeld "Privacy" in het onderwerp. Zie ook ons',legalMid:'en',legalAfter:'.'},pricing:{title:'GastroBuddy prijzen',intro:'Kies een basisplan op teamgrootte, voeg modules per locatie toe, en ga door naar veilige checkout. Of start eerst een gratis proefperiode.',cancelled:'Checkout is geannuleerd. Pas je plan hieronder aan wanneer je klaar bent.',tiersHeading:'Organisatieplan',tiersHint:'Teamlimieten gelden per locatie.',staffStarter:'Tot 5 teamleden',staffPro:'6–20 teamleden',staffEnterprise:'Onbeperkt teamleden',tiers:{starter:{name:'Starter'},pro:{name:'Pro'},enterprise:{name:'Enterprise'}},modulesHeading:'Locatiemodules',modulesHint:'Prijzen per locatie / maand. Takenlijsten en recepten zitten in elk plan.',included:'Inbegrepen: takenlijsten + recepten',modules:{modCash:'Kassa',modTimesheet:'Urenregistratie',modReservations:'Reserveringen',modMep:'Mise en place',modFacility:'Facility'},summaryHeading:'Je maandelijkse totaal',summaryNote:'Add-ons gaan uit van één locatie. Extra locaties regel je na aanmelden.',total:'Totaal',perMonth:'/mnd',perLocationMonth:'/loc/mnd',checkoutCta:'Door naar checkout',checkoutLoading:'Checkout openen…',trialCta:'Liever gratis proefperiode',enterpriseContact:'Liever overleg? Neem contact op',footnote:'Abonnementen worden via Stripe op het web gefactureerd. De app ontgrendelt na inloggen met een actief account. Prijzen exclusief btw waar van toepassing.',errors:{apiMissing:'Facturatie is hier niet geconfigureerd. Probeer later opnieuw of neem contact op.',checkoutFailed:'Checkout starten mislukt. Controleer je verbinding en probeer opnieuw.',network:'Netwerkfout. Controleer je verbinding en probeer opnieuw.'}},compare:{title:'Hoe GastroBuddy zich verhoudt',intro:'Ondernemers beginnen vaak met papier, spreadsheets, WhatsApp of een kassa die nooit voor checklists is gemaakt. Hier een eerlijke categorievergelijking. Geen concurrentenlijst.',tableCaption:'Vergelijking van papier, generieke tools en GastroBuddy voor horeca-operaties',colTopic:'Behoefte',colPaper:'Papier / ringband',colGeneric:'Spreadsheets en chat',colGastro:'GastroBuddy',rows:{progress:{topic:'Live taakvoortgang',paper:'Geen gedeelde status. Managers achtervolgen updates.',generic:'Berichten verdwijnen. Lastig te zien wat klaar is.',gastro:'Realtime voortgang per taak voor het hele team'},cash:{topic:'Kas en dagafsluiting',paper:'Apart schrift of kassablad',generic:'Ad-hoc sheets. Historie raakt zoek.',gastro:'Kasregistratie en dagafsluitingen op één plek'},recipes:{topic:'Recepten en mise en place',paper:'Gedrukte mappen raken verouderd',generic:'Documenten verspreid over drives',gastro:'Recepten en mise en place met keuken- en barcontext'},ai:{topic:'Lijsten en recepten maken',paper:'Met de hand herschrijven',generic:'Sjablonen kopiëren',gastro:'AI-assistent kan lijsten en recepten uit chat opstellen'},team:{topic:'Nieuw personeel inwerken',paper:'Meelopen en mondelinge kennis',generic:'Lange chatthreads',gastro:'Stappenplannen op telefoon of tablet'},paper:{topic:'De ringband achterlaten',paper:'Nog steeds meenemen',generic:'Nog steeds “voor de zekerheid” printen',gastro:'Hetzelfde account in apps en webdashboard'}},disclaimer:'Niet elke zaak heeft elke module nodig. Start met de gratis maand, zet aan wat je gebruikt, en nodig personeel uit wanneer jij wilt.',cta:'Start mijn gratis maand',ctaHint:'Eerste maand gratis · Klaar in een paar minuten',checklistLink:'Liever iets printbaars? Pak de gratis open/sluit-checklist →'},checklist:{title:'Gratis open/sluit-checklist',intro:'Een praktisch startpunt voor routines op de vloer. Pas hem aan je zaak aan. Draai dezelfde aanpak daarna in GastroBuddy, zodat iedereen de voortgang ziet.',openTitle:'Openen',closeTitle:'Sluiten',open:{o1:'Openen, licht, muziek en klimaat naar wens',o2:'Toiletten, vloeren en gastgerichte ruimtes checken',o3:'Stations, ijs, garnish en to-go-voorraden bijvullen',o4:'Kassas, wisselgeld en pinapparaten gereed melden',o5:'Team briefen over reserveringen, 86’s en allergenen',o6:'Koelkasttemperaturen en kritieke voedselveiligheid checken'},close:{c1:'Stations opruimen, resetten en bijvullen voor de volgende dienst',c2:'Eindafrekening kas, fooien en dagafsluiting',c3:'Gastgebieden, toiletten en contactpunten schoonmaken',c4:'Voorraad, koeling en drank veilig afsluiten',c5:'Sluitchecklist-items van de dienst afronden',c6:'Afsluiten, alarm, en notities voor de volgende open'},adaptNote:'Gebruik dit als voorbeeld. Jouw zaak heeft misschien HACCP-stappen, alleen-bar items of meerdere locaties. Daar is GastroBuddy voor gebouwd.',formTitle:'Mail mij deze checklist',formIntro:'Optioneel: laat je zakelijke e-mail achter, dan sturen we de checklist naar je inbox. Geen spam.',formEmail:'Zakelijke e-mail',formBusiness:'Bedrijfsnaam (optioneel)',formSubmit:'Stuur mij de checklist',formSubmitting:'Versturen…',formError:'Er ging iets mis. Probeer opnieuw, of start direct je gratis account.',formEmailRequired:'Vul een zakelijke e-mail in, dan sturen we de checklist.',formEmailInvalid:'Vul een geldig e-mailadres in (bijvoorbeeld naam@restaurant.nl).',formSuccessTitle:'Bedankt. Check je inbox.',formSuccessBody:'De checklist is onderweg. Je kunt ook nu je gratis maand starten.',formPrivacyBefore:'We gebruiken je gegevens alleen om deze checklist te mailen en relevante GastroBuddy-tips. Zie',formPrivacyAfter:' voor details.',nextTitle:'Klaar om dit met je team te draaien?',nextBody:'Zet dezelfde open- en sluitaanpak om in live takenlijsten. Met voortgang die iedereen ziet.',cta:'Start mijn gratis maand',ctaHint:'Gratis proefperiode · Nodig personeel uit wanneer jij wilt',compareLink:'Bekijk hoe GastroBuddy zich verhoudt tot papier en spreadsheets →'},jsonLd:{orgDescription:'GastroBuddy helpt restaurants en bars bij dagelijkse operatie: checklists, kas, recepten, tijdregistratie en een AI-assistent voor eigenaren.',siteDescription:'Horeca-platform: takenlijsten, kas, mise en place, recepten voor keuken en bar, webdashboard en AI-assistent.'},verticals:__WEBPACK_IMPORTED_MODULE_0_i18n_messages_segments_verticals_nl__["a" /* default */],guides:__WEBPACK_IMPORTED_MODULE_1_i18n_messages_segments_guides_nl__["a" /* default */]};/* harmony default export */ __webpack_exports__["a"] = (nl);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var Hero=function Hero(_ref){var background=_ref.background,_ref$children=_ref.children,children=_ref$children===void 0?null:_ref$children,_ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,_ref$style=_ref.style,style=_ref$style===void 0?undefined:_ref$style,_ref$as=_ref.as,Tag=_ref$as===void 0?'section':_ref$as;var backgroundImage=background&&"url(".concat(background,") no-repeat");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag,{className:className,style:_objectSpread({background:backgroundImage,backgroundSize:'cover'},style)},children);};/* harmony default export */ __webpack_exports__["a"] = (Hero);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_dashboard__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LanguageSwitcher__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Logo__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_i18n_I18nContext__ = __webpack_require__(6);
var SiteHeader=function SiteHeader(_ref){var _ref$variant=_ref.variant,variant=_ref$variant===void 0?'onHero':_ref$variant,_ref$showHome=_ref.showHome,showHome=_ref$showHome===void 0?false:_ref$showHome;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_5_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;var dashboardUrl=Object(__WEBPACK_IMPORTED_MODULE_0_constants_dashboard__["a" /* default */])();var shellClass=variant==='onGreen'?'gb-site-header gb-site-header--green':'gb-site-header';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("header",{className:shellClass},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"gb-site-header__inner container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"gb-site-header__brand"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Logo__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"gb-site-header__actions"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LanguageSwitcher__["a" /* default */],{variant:"onDark"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("nav",{className:"gb-site-header__nav","aria-label":t('nav.primary')},showHome?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{to:"/",className:"gb-site-header__link"},t('nav.home')):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:dashboardUrl,className:"gb-site-header__link",rel:"noopener noreferrer",target:"_blank"},t('nav.login')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{to:"/onboard",className:"gb-site-header__cta"},t('nav.signup'))))));};/* harmony default export */ __webpack_exports__["a"] = (SiteHeader);

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.addMethod = addMethod;
exports.lazy = exports.ref = exports.boolean = void 0;

var _mixed = _interopRequireDefault(__webpack_require__(76));

exports.mixed = _mixed.default;

var _boolean = _interopRequireDefault(__webpack_require__(852));

exports.bool = _boolean.default;

var _string = _interopRequireDefault(__webpack_require__(853));

exports.string = _string.default;

var _number = _interopRequireDefault(__webpack_require__(854));

exports.number = _number.default;

var _date = _interopRequireDefault(__webpack_require__(855));

exports.date = _date.default;

var _object = _interopRequireDefault(__webpack_require__(857));

exports.object = _object.default;

var _array = _interopRequireDefault(__webpack_require__(877));

exports.array = _array.default;

var _Reference = _interopRequireDefault(__webpack_require__(114));

var _Lazy = _interopRequireDefault(__webpack_require__(878));

var _ValidationError = _interopRequireDefault(__webpack_require__(236));

exports.ValidationError = _ValidationError.default;

var _reach = _interopRequireDefault(__webpack_require__(879));

exports.reach = _reach.default;

var _isSchema = _interopRequireDefault(__webpack_require__(78));

exports.isSchema = _isSchema.default;
var boolean = _boolean.default;
exports.boolean = boolean;

var ref = function ref(key, options) {
  return new _Reference.default(key, options);
};

exports.ref = ref;

var lazy = function lazy(fn) {
  return new _Lazy.default(fn);
};

exports.lazy = lazy;

function addMethod(schemaType, name, fn) {
  if (!schemaType || !(0, _isSchema.default)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(45),
    isSymbol = __webpack_require__(220);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(89),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(758),
    mapCacheDelete = __webpack_require__(774),
    mapCacheGet = __webpack_require__(776),
    mapCacheHas = __webpack_require__(777),
    mapCacheSet = __webpack_require__(778);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 222 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77),
    root = __webpack_require__(46);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(145),
    stackClear = __webpack_require__(783),
    stackDelete = __webpack_require__(784),
    stackGet = __webpack_require__(785),
    stackHas = __webpack_require__(786),
    stackSet = __webpack_require__(787);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(46),
    stubFalse = __webpack_require__(792);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(227)(module)))

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(329);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(227)(module)))

/***/ }),
/* 230 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(330),
    isLength = __webpack_require__(224);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(801),
    stubArray = __webpack_require__(341);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(347);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.propagateErrors = propagateErrors;
exports.settled = settled;
exports.collectErrors = collectErrors;
exports.default = runValidations;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(235));

var _synchronousPromise = __webpack_require__(352);

var _ValidationError = _interopRequireDefault(__webpack_require__(236));

var promise = function promise(sync) {
  return sync ? _synchronousPromise.SynchronousPromise : Promise;
};

var unwrapError = function unwrapError(errors) {
  if (errors === void 0) {
    errors = [];
  }

  return errors.inner && errors.inner.length ? errors.inner : [].concat(errors);
};

function scopeToValue(promises, value, sync) {
  //console.log('scopeToValue', promises, value)
  var p = promise(sync).all(promises); //console.log('scopeToValue B', p)

  var b = p.catch(function (err) {
    if (err.name === 'ValidationError') err.value = value;
    throw err;
  }); //console.log('scopeToValue c', b)

  var c = b.then(function () {
    return value;
  }); //console.log('scopeToValue d', c)

  return c;
}
/**
 * If not failing on the first error, catch the errors
 * and collect them in an array
 */


function propagateErrors(endEarly, errors) {
  return endEarly ? null : function (err) {
    errors.push(err);
    return err.value;
  };
}

function settled(promises, sync) {
  var settle = function settle(promise) {
    return promise.then(function (value) {
      return {
        fulfilled: true,
        value: value
      };
    }, function (value) {
      return {
        fulfilled: false,
        value: value
      };
    });
  };

  return promise(sync).all(promises.map(settle));
}

function collectErrors(_ref) {
  var validations = _ref.validations,
      value = _ref.value,
      path = _ref.path,
      sync = _ref.sync,
      errors = _ref.errors,
      sort = _ref.sort;
  errors = unwrapError(errors);
  return settled(validations, sync).then(function (results) {
    var nestedErrors = results.filter(function (r) {
      return !r.fulfilled;
    }).reduce(function (arr, _ref2) {
      var error = _ref2.value;

      // we are only collecting validation errors
      if (!_ValidationError.default.isError(error)) {
        throw error;
      }

      return arr.concat(error);
    }, []);
    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

    errors = nestedErrors.concat(errors);
    if (errors.length) throw new _ValidationError.default(errors, value, path);
    return value;
  });
}

function runValidations(_ref3) {
  var endEarly = _ref3.endEarly,
      options = (0, _objectWithoutProperties2.default)(_ref3, ["endEarly"]);
  if (endEarly) return scopeToValue(options.validations, options.value, options.sync);
  return collectErrors(options);
}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(828);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = ValidationError;

var _printValue = _interopRequireDefault(__webpack_require__(151));

var strReg = /\$\{\s*(\w+)\s*\}/g;

var replace = function replace(str) {
  return function (params) {
    return str.replace(strReg, function (_, key) {
      return (0, _printValue.default)(params[key]);
    });
  };
};

function ValidationError(errors, value, field, type) {
  var _this = this;

  this.name = 'ValidationError';
  this.value = value;
  this.path = field;
  this.type = type;
  this.errors = [];
  this.inner = [];
  if (errors) [].concat(errors).forEach(function (err) {
    _this.errors = _this.errors.concat(err.errors || err);
    if (err.inner) _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
  });
  this.message = this.errors.length > 1 ? this.errors.length + " errors occurred" : this.errors[0];
  if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
}

ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;

ValidationError.isError = function (err) {
  return err && err.name === 'ValidationError';
};

ValidationError.formatError = function (message, params) {
  if (typeof message === 'string') message = replace(message);

  var fn = function fn(params) {
    params.path = params.label || params.path || 'this';
    return typeof message === 'function' ? message(params) : message;
  };

  return arguments.length === 1 ? fn : fn(params);
};

module.exports = exports["default"];

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formik__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_I18nContext__ = __webpack_require__(6);
function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}var Input=function Input(_ref){var label=_ref.label,name=_ref.name,type=_ref.type,validate=_ref.validate,_ref$error=_ref.error,error=_ref$error===void 0?false:_ref$error,hint=_ref.hint,autoComplete=_ref.autoComplete,inputMode=_ref.inputMode,_ref$revealToggle=_ref.revealToggle,revealToggle=_ref$revealToggle===void 0?false:_ref$revealToggle;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_2_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),revealed=_useState2[0],setRevealed=_useState2[1];var errorId="".concat(name,"-error");var hintId="".concat(name,"-hint");var hasErrorMessage=Boolean(error&&typeof error==='string');var describedBy=[hint?hintId:null,hasErrorMessage?errorId:null].filter(Boolean).join(' ');var isPassword=type==='password';var showToggle=revealToggle&&isPassword;var inputType=showToggle&&revealed?'text':type;var baseClass='py-10 bg-transparent border-b border-grey font-light text-white focus:border-b-2 gb-input ';var errorClass=error?'border-red':'';var inputWithToggleClass=showToggle?'gb-input--with-toggle ':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:name,className:"text-sm font-normal gb-form-label"},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:showToggle?'gb-onboard-field__control':undefined},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_formik__["a" /* Field */],{name:name,validate:validate,render:function render(_ref2){var field=_ref2.field;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",_extends({},field,{id:name,type:inputType,className:"".concat(inputWithToggleClass).concat(baseClass).concat(errorClass).trim(),autoComplete:autoComplete,inputMode:inputMode,"aria-invalid":error?true:undefined,"aria-describedby":describedBy||undefined}));}}),showToggle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"gb-onboard-field__reveal","aria-pressed":revealed,"aria-controls":name,onClick:function onClick(){return setRevealed(function(v){return!v;});}},revealed?t('forms.hidePassword'):t('forms.showPassword')):null),hint&&!hasErrorMessage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{id:hintId,className:"gb-form-hint text-xs m-0"},hint):null,hasErrorMessage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:errorId,className:"text-red text-xs",role:"alert"},error):null);};/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ONBOARD_FORM_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ONBOARD_PASSWORD_MIN_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ONBOARD_OAUTH_STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ONBOARD_TOKENS_STORAGE_KEY; });
var DEFAULT_ONBOARD_FORM_VALUES={name:'',email:'',password:'',locationName:'',address:'',city:'',zip:'',phone:''};var ONBOARD_PASSWORD_MIN_LENGTH=8;var ONBOARD_OAUTH_STORAGE_KEY='gb_onboard_oauth';var ONBOARD_TOKENS_STORAGE_KEY='gb_onboard_tokens';

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(374);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._h = 0;
  this._i = 0;
  this._j = null;
  this._k = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._l = null;
Promise._m = null;
Promise._n = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._i === 3) {
    self = self._j;
  }
  if (Promise._l) {
    Promise._l(self);
  }
  if (self._i === 0) {
    if (self._h === 0) {
      self._h = 1;
      self._k = deferred;
      return;
    }
    if (self._h === 1) {
      self._h = 2;
      self._k = [self._k, deferred];
      return;
    }
    self._k.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._i === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._i === 1) {
        resolve(deferred.promise, self._j);
      } else {
        reject(deferred.promise, self._j);
      }
      return;
    }
    var ret = tryCallOne(cb, self._j);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._i = 3;
      self._j = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._i = 1;
  self._j = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._i = 2;
  self._j = newValue;
  if (Promise._m) {
    Promise._m(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._h === 1) {
    handle(self, self._k);
    self._k = null;
  }
  if (self._h === 2) {
    for (var i = 0; i < self._k.length; i++) {
      handle(self, self._k[i]);
    }
    self._k = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(11) && !__webpack_require__(7)(function () {
  return Object.defineProperty(__webpack_require__(154)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(9);


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(25);
var toIObject = __webpack_require__(26);
var arrayIndexOf = __webpack_require__(115)(false);
var IE_PROTO = __webpack_require__(156)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(12);
var anObject = __webpack_require__(4);
var getKeys = __webpack_require__(64);

module.exports = __webpack_require__(11) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(26);
var gOPN = __webpack_require__(67).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(11);
var getKeys = __webpack_require__(64);
var gOPS = __webpack_require__(116);
var pIE = __webpack_require__(97);
var toObject = __webpack_require__(13);
var IObject = __webpack_require__(96);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(7)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 246 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(17);
var isObject = __webpack_require__(8);
var invoke = __webpack_require__(248);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 248 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(5).parseInt;
var $trim = __webpack_require__(81).trim;
var ws = __webpack_require__(160);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(5).parseFloat;
var $trim = __webpack_require__(81).trim;

module.exports = 1 / $parseFloat(__webpack_require__(160) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(32);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(8);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(163);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(4);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(17);
var toObject = __webpack_require__(13);
var IObject = __webpack_require__(96);
var toLength = __webpack_require__(10);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(65);
var toLength = __webpack_require__(10);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(175);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(11) && /./g.flags != 'g') __webpack_require__(12).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(98)
});


/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(179);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(264);
var validate = __webpack_require__(72);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(124)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(12).f;
var create = __webpack_require__(66);
var redefineAll = __webpack_require__(71);
var ctx = __webpack_require__(31);
var anInstance = __webpack_require__(69);
var forOf = __webpack_require__(70);
var $iterDefine = __webpack_require__(165);
var step = __webpack_require__(258);
var setSpecies = __webpack_require__(68);
var DESCRIPTORS = __webpack_require__(11);
var fastKey = __webpack_require__(54).fastKey;
var validate = __webpack_require__(72);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(264);
var validate = __webpack_require__(72);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(124)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var each = __webpack_require__(43)(0);
var redefine = __webpack_require__(20);
var meta = __webpack_require__(54);
var assign = __webpack_require__(245);
var weak = __webpack_require__(267);
var isObject = __webpack_require__(8);
var validate = __webpack_require__(72);
var NATIVE_WEAK_MAP = __webpack_require__(72);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(124)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(71);
var getWeak = __webpack_require__(54).getWeak;
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var anInstance = __webpack_require__(69);
var forOf = __webpack_require__(70);
var createArrayMethod = __webpack_require__(43);
var $has = __webpack_require__(25);
var validate = __webpack_require__(72);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(33);
var toLength = __webpack_require__(10);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(67);
var gOPS = __webpack_require__(116);
var anObject = __webpack_require__(4);
var Reflect = __webpack_require__(5).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(117);
var isObject = __webpack_require__(8);
var toLength = __webpack_require__(10);
var ctx = __webpack_require__(31);
var IS_CONCAT_SPREADABLE = __webpack_require__(9)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(10);
var repeat = __webpack_require__(162);
var defined = __webpack_require__(41);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(11);
var getKeys = __webpack_require__(64);
var toIObject = __webpack_require__(26);
var isEnum = __webpack_require__(97).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(80);
var from = __webpack_require__(274);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(70);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 275 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(83);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(278);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(183);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(597)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addTracingExtensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return startIdleTransaction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hub_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_spanUtils_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__idletransaction_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sampling_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transaction_js__ = __webpack_require__(202);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/** Returns all trace headers that are currently on the top scope. */// eslint-disable-next-line deprecation/deprecation
function traceHeaders(){// eslint-disable-next-line deprecation/deprecation
var scope=this.getScope();// eslint-disable-next-line deprecation/deprecation
var span=scope.getSpan();return span?{'sentry-trace':Object(__WEBPACK_IMPORTED_MODULE_3__utils_spanUtils_js__["g" /* spanToTraceHeader */])(span)}:{};}/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */function _startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext,customSamplingContext){// eslint-disable-next-line deprecation/deprecation
var client=this.getClient();var options=client&&client.getOptions()||{};var configInstrumenter=options.instrumenter||'sentry';var transactionInstrumenter=transactionContext.instrumenter||'sentry';if(configInstrumenter!==transactionInstrumenter){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error("A transaction was started with instrumenter=`".concat(transactionInstrumenter,"`, but the SDK is configured with the `").concat(configInstrumenter,"` instrumenter.\nThe transaction will not be sampled. Please use the ").concat(configInstrumenter," instrumentation to start transactions."));// eslint-disable-next-line deprecation/deprecation
transactionContext.sampled=false;}// eslint-disable-next-line deprecation/deprecation
var transaction=new __WEBPACK_IMPORTED_MODULE_7__transaction_js__["a" /* Transaction */](transactionContext,this);transaction=Object(__WEBPACK_IMPORTED_MODULE_6__sampling_js__["b" /* sampleTransaction */])(transaction,options,_objectSpread({name:transactionContext.name,parentSampled:transactionContext.parentSampled,transactionContext:transactionContext,attributes:_objectSpread({},transactionContext.data,{},transactionContext.attributes)},customSamplingContext));if(transaction.isRecording()){transaction.initSpanRecorder(options._experiments&&options._experiments.maxSpans);}if(client&&client.emit){client.emit('startTransaction',transaction);}return transaction;}/**
 * Create new idle transaction.
 */function startIdleTransaction(// eslint-disable-next-line deprecation/deprecation
hub,transactionContext,idleTimeout,finalTimeout,onScope,customSamplingContext,heartbeatInterval){var delayAutoFinishUntilSignal=arguments.length>7&&arguments[7]!==undefined?arguments[7]:false;// eslint-disable-next-line deprecation/deprecation
var client=hub.getClient();var options=client&&client.getOptions()||{};// eslint-disable-next-line deprecation/deprecation
var transaction=new __WEBPACK_IMPORTED_MODULE_5__idletransaction_js__["a" /* IdleTransaction */](transactionContext,hub,idleTimeout,finalTimeout,heartbeatInterval,onScope,delayAutoFinishUntilSignal);transaction=Object(__WEBPACK_IMPORTED_MODULE_6__sampling_js__["b" /* sampleTransaction */])(transaction,options,_objectSpread({name:transactionContext.name,parentSampled:transactionContext.parentSampled,transactionContext:transactionContext,attributes:_objectSpread({},transactionContext.data,{},transactionContext.attributes)},customSamplingContext));if(transaction.isRecording()){transaction.initSpanRecorder(options._experiments&&options._experiments.maxSpans);}if(client&&client.emit){client.emit('startTransaction',transaction);}return transaction;}/**
 * Adds tracing extensions to the global hub.
 */function addTracingExtensions(){var carrier=Object(__WEBPACK_IMPORTED_MODULE_2__hub_js__["e" /* getMainCarrier */])();if(!carrier.__SENTRY__){return;}carrier.__SENTRY__.extensions=carrier.__SENTRY__.extensions||{};if(!carrier.__SENTRY__.extensions.startTransaction){carrier.__SENTRY__.extensions.startTransaction=_startTransaction;}if(!carrier.__SENTRY__.extensions.traceHeaders){carrier.__SENTRY__.extensions.traceHeaders=traceHeaders;}Object(__WEBPACK_IMPORTED_MODULE_4__errors_js__["a" /* registerErrorInstrumentation */])();}

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getComponentName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDomElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLocationHref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return htmlTreeAsString; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__worldwide_js__ = __webpack_require__(18);
// eslint-disable-next-line deprecation/deprecation
var WINDOW=Object(__WEBPACK_IMPORTED_MODULE_1__worldwide_js__["b" /* getGlobalObject */])();var DEFAULT_MAX_STRING_LENGTH=80;/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */function htmlTreeAsString(elem){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!elem){return'<unknown>';}// try/catch both:
// - accessing event.target (see getsentry/raven-js#838, #768)
// - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
// - can throw an exception in some circumstances.
try{var currentElem=elem;var MAX_TRAVERSE_HEIGHT=5;var out=[];var height=0;var len=0;var separator=' > ';var sepLength=separator.length;var nextStr;var keyAttrs=Array.isArray(options)?options:options.keyAttrs;var maxStringLength=!Array.isArray(options)&&options.maxStringLength||DEFAULT_MAX_STRING_LENGTH;while(currentElem&&height++<MAX_TRAVERSE_HEIGHT){nextStr=_htmlElementAsString(currentElem,keyAttrs);// bail out if
// - nextStr is the 'html' element
// - the length of the string that would be created exceeds maxStringLength
//   (ignore this limit if we are on the first iteration)
if(nextStr==='html'||height>1&&len+out.length*sepLength+nextStr.length>=maxStringLength){break;}out.push(nextStr);len+=nextStr.length;currentElem=currentElem.parentNode;}return out.reverse().join(separator);}catch(_oO){return'<unknown>';}}/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */function _htmlElementAsString(el,keyAttrs){var elem=el;var out=[];var className;var classes;var key;var attr;var i;if(!elem||!elem.tagName){return'';}// @ts-expect-error WINDOW has HTMLElement
if(WINDOW.HTMLElement){// If using the component name annotation plugin, this value may be available on the DOM node
if(elem instanceof HTMLElement&&elem.dataset&&elem.dataset['sentryComponent']){return elem.dataset['sentryComponent'];}}out.push(elem.tagName.toLowerCase());// Pairs of attribute keys defined in `serializeAttribute` and their values on element.
var keyAttrPairs=keyAttrs&&keyAttrs.length?keyAttrs.filter(function(keyAttr){return elem.getAttribute(keyAttr);}).map(function(keyAttr){return[keyAttr,elem.getAttribute(keyAttr)];}):null;if(keyAttrPairs&&keyAttrPairs.length){keyAttrPairs.forEach(function(keyAttrPair){out.push("[".concat(keyAttrPair[0],"=\"").concat(keyAttrPair[1],"\"]"));});}else{if(elem.id){out.push("#".concat(elem.id));}// eslint-disable-next-line prefer-const
className=elem.className;if(className&&Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["m" /* isString */])(className)){classes=className.split(/\s+/);for(i=0;i<classes.length;i++){out.push(".".concat(classes[i]));}}}var allowedAttrs=['aria-label','type','name','title','alt'];for(i=0;i<allowedAttrs.length;i++){key=allowedAttrs[i];attr=elem.getAttribute(key);if(attr){out.push("[".concat(key,"=\"").concat(attr,"\"]"));}}return out.join('');}/**
 * A safe form of location.href
 */function getLocationHref(){try{return WINDOW.document.location.href;}catch(oO){return'';}}/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector){if(WINDOW.document&&WINDOW.document.querySelector){return WINDOW.document.querySelector(selector);}return null;}/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */function getComponentName(elem){// @ts-expect-error WINDOW has HTMLElement
if(!WINDOW.HTMLElement){return null;}var currentElem=elem;var MAX_TRAVERSE_HEIGHT=5;for(var i=0;i<MAX_TRAVERSE_HEIGHT;i++){if(!currentElem){return null;}if(currentElem instanceof HTMLElement&&currentElem.dataset['sentryComponent']){return currentElem.dataset['sentryComponent'];}currentElem=currentElem.parentNode;}return null;}

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dsnFromString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dsnToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return makeDsn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__debug_build_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(44);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}/** Regular expression used to parse a Dsn. */var DSN_REGEX=/^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;function isValidProtocol(protocol){return protocol==='http'||protocol==='https';}/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */function dsnToString(dsn){var withPassword=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var host=dsn.host,path=dsn.path,pass=dsn.pass,port=dsn.port,projectId=dsn.projectId,protocol=dsn.protocol,publicKey=dsn.publicKey;return"".concat(protocol,"://").concat(publicKey).concat(withPassword&&pass?":".concat(pass):'')+"@".concat(host).concat(port?":".concat(port):'',"/").concat(path?"".concat(path,"/"):path).concat(projectId);}/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */function dsnFromString(str){var match=DSN_REGEX.exec(str);if(!match){// This should be logged to the console
Object(__WEBPACK_IMPORTED_MODULE_1__logger_js__["b" /* consoleSandbox */])(function(){// eslint-disable-next-line no-console
console.error("Invalid Sentry Dsn: ".concat(str));});return undefined;}var _match$slice=match.slice(1),_match$slice2=_slicedToArray(_match$slice,6),protocol=_match$slice2[0],publicKey=_match$slice2[1],_match$slice2$=_match$slice2[2],pass=_match$slice2$===void 0?'':_match$slice2$,host=_match$slice2[3],_match$slice2$2=_match$slice2[4],port=_match$slice2$2===void 0?'':_match$slice2$2,lastPath=_match$slice2[5];var path='';var projectId=lastPath;var split=projectId.split('/');if(split.length>1){path=split.slice(0,-1).join('/');projectId=split.pop();}if(projectId){var projectMatch=projectId.match(/^\d+/);if(projectMatch){projectId=projectMatch[0];}}return dsnFromComponents({host:host,pass:pass,path:path,projectId:projectId,port:port,protocol:protocol,publicKey:publicKey});}function dsnFromComponents(components){return{protocol:components.protocol,publicKey:components.publicKey||'',pass:components.pass||'',host:components.host,port:components.port||'',path:components.path||'',projectId:components.projectId};}function validateDsn(dsn){if(!__WEBPACK_IMPORTED_MODULE_0__debug_build_js__["a" /* DEBUG_BUILD */]){return true;}var port=dsn.port,projectId=dsn.projectId,protocol=dsn.protocol;var requiredComponents=['protocol','publicKey','host','projectId'];var hasMissingRequiredComponent=requiredComponents.find(function(component){if(!dsn[component]){__WEBPACK_IMPORTED_MODULE_1__logger_js__["c" /* logger */].error("Invalid Sentry Dsn: ".concat(component," missing"));return true;}return false;});if(hasMissingRequiredComponent){return false;}if(!projectId.match(/^\d+$/)){__WEBPACK_IMPORTED_MODULE_1__logger_js__["c" /* logger */].error("Invalid Sentry Dsn: Invalid projectId ".concat(projectId));return false;}if(!isValidProtocol(protocol)){__WEBPACK_IMPORTED_MODULE_1__logger_js__["c" /* logger */].error("Invalid Sentry Dsn: Invalid protocol ".concat(protocol));return false;}if(port&&isNaN(parseInt(port,10))){__WEBPACK_IMPORTED_MODULE_1__logger_js__["c" /* logger */].error("Invalid Sentry Dsn: Invalid port ".concat(port));return false;}return true;}/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */function makeDsn(from){var components=typeof from==='string'?dsnFromString(from):dsnFromComponents(from);if(!components||!validateDsn(components)){return undefined;}return components;}

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentryError; });
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf(subClass,superClass);}function _wrapNativeSuper(Class){var _cache=typeof Map==="function"?new Map():undefined;_wrapNativeSuper=function _wrapNativeSuper(Class){if(Class===null||!_isNativeFunction(Class))return Class;if(typeof Class!=="function"){throw new TypeError("Super expression must either be null or a function");}if(typeof _cache!=="undefined"){if(_cache.has(Class))return _cache.get(Class);_cache.set(Class,Wrapper);}function Wrapper(){return _construct(Class,arguments,_getPrototypeOf(this).constructor);}Wrapper.prototype=Object.create(Class.prototype,{constructor:{value:Wrapper,enumerable:false,writable:true,configurable:true}});return _setPrototypeOf(Wrapper,Class);};return _wrapNativeSuper(Class);}function isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Date.prototype.toString.call(Reflect.construct(Date,[],function(){}));return true;}catch(e){return false;}}function _construct(Parent,args,Class){if(isNativeReflectConstruct()){_construct=Reflect.construct;}else{_construct=function _construct(Parent,args,Class){var a=[null];a.push.apply(a,args);var Constructor=Function.bind.apply(Parent,a);var instance=new Constructor();if(Class)_setPrototypeOf(instance,Class.prototype);return instance;};}return _construct.apply(null,arguments);}function _isNativeFunction(fn){return Function.toString.call(fn).indexOf("[native code]")!==-1;}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}/** An error emitted by Sentry SDKs and related utilities. */var SentryError=/*#__PURE__*/function(_Error){_inherits(SentryError,_Error);/** Display name of this error instance. */function SentryError(message){var _this;var logLevel=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'warn';_classCallCheck(this,SentryError);_this=_possibleConstructorReturn(this,_getPrototypeOf(SentryError).call(this,message));_this.message=message;_this.name=(this instanceof SentryError?this.constructor:void 0).prototype.constructor.name;// This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
// out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
// instances of `SentryError` fail `obj instanceof SentryError` checks.
Object.setPrototypeOf(_assertThisInitialized(_this),(this instanceof SentryError?this.constructor:void 0).prototype);_this.logLevel=logLevel;return _this;}return SentryError;}(_wrapNativeSuper(Error));

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isNativeFetch; });
/* unused harmony export supportsDOMError */
/* unused harmony export supportsDOMException */
/* unused harmony export supportsErrorEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportsFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportsNativeFetch; });
/* unused harmony export supportsReferrerPolicy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return supportsReportingObserver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__debug_build_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__worldwide_js__ = __webpack_require__(18);
// eslint-disable-next-line deprecation/deprecation
var WINDOW=Object(__WEBPACK_IMPORTED_MODULE_2__worldwide_js__["b" /* getGlobalObject */])();/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */function supportsErrorEvent(){try{new ErrorEvent('');return true;}catch(e){return false;}}/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */function supportsDOMError(){try{// Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
// 1 argument required, but only 0 present.
// @ts-expect-error It really needs 1 argument, not 0.
new DOMError('');return true;}catch(e){return false;}}/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */function supportsDOMException(){try{new DOMException('');return true;}catch(e){return false;}}/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */function supportsFetch(){if(!('fetch'in WINDOW)){return false;}try{new Headers();new Request('http://www.example.com');new Response();return true;}catch(e){return false;}}/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func){return func&&/^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());}/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */function supportsNativeFetch(){if(typeof EdgeRuntime==='string'){return true;}if(!supportsFetch()){return false;}// Fast path to avoid DOM I/O
// eslint-disable-next-line @typescript-eslint/unbound-method
if(isNativeFetch(WINDOW.fetch)){return true;}// window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
// so create a "pure" iframe to see if that has native fetch
var result=false;var doc=WINDOW.document;// eslint-disable-next-line deprecation/deprecation
if(doc&&typeof doc.createElement==='function'){try{var sandbox=doc.createElement('iframe');sandbox.hidden=true;doc.head.appendChild(sandbox);if(sandbox.contentWindow&&sandbox.contentWindow.fetch){// eslint-disable-next-line @typescript-eslint/unbound-method
result=isNativeFetch(sandbox.contentWindow.fetch);}doc.head.removeChild(sandbox);}catch(err){__WEBPACK_IMPORTED_MODULE_0__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__logger_js__["c" /* logger */].warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ',err);}}return result;}/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */function supportsReportingObserver(){return'ReportingObserver'in WINDOW;}/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */function supportsReferrerPolicy(){// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
// (see https://caniuse.com/#feat=referrer-policy),
// it doesn't. And it throws an exception instead of ignoring this parameter...
// REF: https://github.com/getsentry/raven-js/issues/1233
if(!supportsFetch()){return false;}try{new Request('_',{referrerPolicy:'origin'});return true;}catch(e){return false;}}

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportsHistory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__worldwide_js__ = __webpack_require__(18);
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
var WINDOW=Object(__WEBPACK_IMPORTED_MODULE_0__worldwide_js__["b" /* getGlobalObject */])();/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */function supportsHistory(){// NOTE: in Chrome App environment, touching history.pushState, *even inside
//       a try/catch block*, will cause Chrome to output an error to console.error
// borrowed from: https://github.com/angular/angular.js/pull/13945/files
/* eslint-disable @typescript-eslint/no-unsafe-member-access */// eslint-disable-next-line @typescript-eslint/no-explicit-any
var chromeVar=WINDOW.chrome;var isChromePackagedApp=chromeVar&&chromeVar.app&&chromeVar.app.runtime;/* eslint-enable @typescript-eslint/no-unsafe-member-access */var hasHistoryApi='history'in WINDOW&&!!WINDOW.history.pushState&&!!WINDOW.history.replaceState;return!isChromePackagedApp&&hasHistoryApi;}

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dynamicRequire; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isNodeEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env_js__ = __webpack_require__(288);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 *//**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */function isNodeEnv(){// explicitly check for browser bundles as those can be optimized statically
// by terser/rollup.
return!Object(__WEBPACK_IMPORTED_MODULE_0__env_js__["b" /* isBrowserBundle */])()&&Object.prototype.toString.call(typeof process!=='undefined'?process:0)==='[object process]';}/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod,request){// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
return mod.require(request);}/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */function loadModule(moduleName){var mod;try{mod=dynamicRequire(module,moduleName);}catch(e){// no-empty
}try{var _dynamicRequire=dynamicRequire(module,'process'),cwd=_dynamicRequire.cwd;mod=dynamicRequire(module,"".concat(cwd(),"/node_modules/").concat(moduleName));}catch(e){// no-empty
}return mod;}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(620), __webpack_require__(192)(module)))

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSDKSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isBrowserBundle; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 *//**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */function isBrowserBundle(){return typeof __SENTRY_BROWSER_BUNDLE__!=='undefined'&&!!__SENTRY_BROWSER_BUNDLE__;}/**
 * Get source of SDK.
 */function getSDKSource(){// @ts-expect-error "npm" is injected by rollup during build process
return"npm";}

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return memoBuilder; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access *//* eslint-disable @typescript-eslint/no-explicit-any *//**
 * Helper to decycle json objects
 */function memoBuilder(){var hasWeakSet=typeof WeakSet==='function';var inner=hasWeakSet?new WeakSet():[];function memoize(obj){if(hasWeakSet){if(inner.has(obj)){return true;}inner.add(obj);return false;}// eslint-disable-next-line @typescript-eslint/prefer-for-of
for(var i=0;i<inner.length;i++){var value=inner[i];if(value===obj){return true;}}inner.push(obj);return false;}function unmemoize(obj){if(hasWeakSet){inner.delete(obj);}else{for(var i=0;i<inner.length;i++){if(inner[i]===obj){inner.splice(i,1);break;}}}}return[memoize,unmemoize];}

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyncPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rejectedSyncPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resolvedSyncPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_js__ = __webpack_require__(35);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/* eslint-disable @typescript-eslint/explicit-function-return-type *//** SyncPromise internal states */var States;(function(States){/** Pending */var PENDING=0;States[States["PENDING"]=PENDING]="PENDING";/** Resolved / OK */var RESOLVED=1;States[States["RESOLVED"]=RESOLVED]="RESOLVED";/** Rejected / Error */var REJECTED=2;States[States["REJECTED"]=REJECTED]="REJECTED";})(States||(States={}));// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */function resolvedSyncPromise(value){return new SyncPromise(function(resolve){resolve(value);});}/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */function rejectedSyncPromise(reason){return new SyncPromise(function(_,reject){reject(reason);});}/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */var SyncPromise=/*#__PURE__*/function(){function SyncPromise(executor){_classCallCheck(this,SyncPromise);SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);this._state=States.PENDING;this._handlers=[];try{executor(this._resolve,this._reject);}catch(e){this._reject(e);}}/** JSDoc */_createClass(SyncPromise,[{key:"then",value:function then(onfulfilled,onrejected){var _this=this;return new SyncPromise(function(resolve,reject){_this._handlers.push([false,function(result){if(!onfulfilled){// TODO: ¯\_(ツ)_/¯
// TODO: FIXME
resolve(result);}else{try{resolve(onfulfilled(result));}catch(e){reject(e);}}},function(reason){if(!onrejected){reject(reason);}else{try{resolve(onrejected(reason));}catch(e){reject(e);}}}]);_this._executeHandlers();});}/** JSDoc */},{key:"catch",value:function _catch(onrejected){return this.then(function(val){return val;},onrejected);}/** JSDoc */},{key:"finally",value:function _finally(onfinally){var _this2=this;return new SyncPromise(function(resolve,reject){var val;var isRejected;return _this2.then(function(value){isRejected=false;val=value;if(onfinally){onfinally();}},function(reason){isRejected=true;val=reason;if(onfinally){onfinally();}}).then(function(){if(isRejected){reject(val);return;}resolve(val);});});}/** JSDoc */},{key:"__init",value:function __init(){var _this3=this;this._resolve=function(value){_this3._setResult(States.RESOLVED,value);};}/** JSDoc */},{key:"__init2",value:function __init2(){var _this4=this;this._reject=function(reason){_this4._setResult(States.REJECTED,reason);};}/** JSDoc */},{key:"__init3",value:function __init3(){var _this5=this;this._setResult=function(state,value){if(_this5._state!==States.PENDING){return;}if(Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["o" /* isThenable */])(value)){void value.then(_this5._resolve,_this5._reject);return;}_this5._state=state;_this5._value=value;_this5._executeHandlers();};}/** JSDoc */},{key:"__init4",value:function __init4(){var _this6=this;this._executeHandlers=function(){if(_this6._state===States.PENDING){return;}var cachedHandlers=_this6._handlers.slice();_this6._handlers=[];cachedHandlers.forEach(function(handler){if(handler[0]){return;}if(_this6._state===States.RESOLVED){// eslint-disable-next-line @typescript-eslint/no-floating-promises
handler[1](_this6._value);}if(_this6._state===States.REJECTED){handler[2](_this6._value);}handler[0]=true;});};}}]);return SyncPromise;}();

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNumberOfUrlSegments; });
/* unused harmony export getSanitizedUrlString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return stripUrlQueryAndFragment; });
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */function parseUrl(url){if(!url){return{};}var match=url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);if(!match){return{};}// coerce to undefined values to empty string so we don't get 'undefined'
var query=match[6]||'';var fragment=match[8]||'';return{host:match[4],path:match[5],protocol:match[2],search:query,hash:fragment,relative:match[5]+query+fragment// everything minus origin
};}/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */function stripUrlQueryAndFragment(urlPath){// eslint-disable-next-line no-useless-escape
return urlPath.split(/[\?#]/,1)[0];}/**
 * Returns number of URL segments of a passed string URL.
 */function getNumberOfUrlSegments(url){// split at '/' or at '\/' to split regex urls correctly
return url.split(/\\?\//).filter(function(s){return s.length>0&&s!==',';}).length;}/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */function getSanitizedUrlString(url){var protocol=url.protocol,host=url.host,path=url.path;var filteredHost=host&&host// Always filter out authority
.replace(/^.*@/,'[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
// TODO: Use new URL global if it exists
.replace(/(:80)$/,'').replace(/(:443)$/,'')||'';return"".concat(protocol?"".concat(protocol,"://"):'').concat(filteredHost).concat(path);}

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _browserPerformanceTimeOriginMode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return browserPerformanceTimeOrigin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dateTimestampInSeconds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timestampInSeconds; });
/* unused harmony export timestampWithMs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__worldwide_js__ = __webpack_require__(18);
var ONE_SECOND_IN_MS=1000;/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 *//**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */function dateTimestampInSeconds(){return Date.now()/ONE_SECOND_IN_MS;}/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */function createUnixTimestampInSecondsFunc(){var performance=__WEBPACK_IMPORTED_MODULE_0__worldwide_js__["a" /* GLOBAL_OBJ */].performance;if(!performance||!performance.now){return dateTimestampInSeconds;}// Some browser and environments don't have a timeOrigin, so we fallback to
// using Date.now() to compute the starting time.
var approxStartingTimeOrigin=Date.now()-performance.now();var timeOrigin=performance.timeOrigin==undefined?approxStartingTimeOrigin:performance.timeOrigin;// performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
// wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
//
// TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
// wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
// correct for this.
// See: https://github.com/getsentry/sentry-javascript/issues/2590
// See: https://github.com/mdn/content/issues/4713
// See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
return function(){return(timeOrigin+performance.now())/ONE_SECOND_IN_MS;};}/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */var timestampInSeconds=createUnixTimestampInSecondsFunc();/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */var timestampWithMs=timestampInSeconds;/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */var _browserPerformanceTimeOriginMode;/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */var browserPerformanceTimeOrigin=function(){// Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
// performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
// data as reliable if they are within a reasonable threshold of the current time.
var performance=__WEBPACK_IMPORTED_MODULE_0__worldwide_js__["a" /* GLOBAL_OBJ */].performance;if(!performance||!performance.now){_browserPerformanceTimeOriginMode='none';return undefined;}var threshold=3600*1000;var performanceNow=performance.now();var dateNow=Date.now();// if timeOrigin isn't available set delta to threshold so it isn't used
var timeOriginDelta=performance.timeOrigin?Math.abs(performance.timeOrigin+performanceNow-dateNow):threshold;var timeOriginIsReliable=timeOriginDelta<threshold;// While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
// is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
// Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
// a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
// Date API.
// eslint-disable-next-line deprecation/deprecation
var navigationStart=performance.timing&&performance.timing.navigationStart;var hasNavigationStart=typeof navigationStart==='number';// if navigationStart isn't available set delta to threshold so it isn't used
var navigationStartDelta=hasNavigationStart?Math.abs(navigationStart+performanceNow-dateNow):threshold;var navigationStartIsReliable=navigationStartDelta<threshold;if(timeOriginIsReliable||navigationStartIsReliable){// Use the more reliable time origin
if(timeOriginDelta<=navigationStartDelta){_browserPerformanceTimeOriginMode='timeOrigin';return performance.timeOrigin;}else{_browserPerformanceTimeOriginMode='navigationStart';return navigationStart;}}// Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
_browserPerformanceTimeOriginMode='dateNow';return dateNow;}();

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BAGGAGE_HEADER_NAME; });
/* unused harmony export MAX_BAGGAGE_STRING_LENGTH */
/* unused harmony export SENTRY_BAGGAGE_KEY_PREFIX */
/* unused harmony export SENTRY_BAGGAGE_KEY_PREFIX_REGEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return baggageHeaderToDynamicSamplingContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dynamicSamplingContextToSentryBaggageHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__debug_build_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger_js__ = __webpack_require__(44);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}var BAGGAGE_HEADER_NAME='baggage';var SENTRY_BAGGAGE_KEY_PREFIX='sentry-';var SENTRY_BAGGAGE_KEY_PREFIX_REGEX=/^sentry-/;/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */var MAX_BAGGAGE_STRING_LENGTH=8192;/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */function baggageHeaderToDynamicSamplingContext(// Very liberal definition of what any incoming header might look like
baggageHeader){if(!Object(__WEBPACK_IMPORTED_MODULE_1__is_js__["m" /* isString */])(baggageHeader)&&!Array.isArray(baggageHeader)){return undefined;}// Intermediary object to store baggage key value pairs of incoming baggage headers on.
// It is later used to read Sentry-DSC-values from.
var baggageObject={};if(Array.isArray(baggageHeader)){// Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
baggageObject=baggageHeader.reduce(function(acc,curr){var currBaggageObject=baggageHeaderToObject(curr);for(var _i=0,_Object$keys=Object.keys(currBaggageObject);_i<_Object$keys.length;_i++){var key=_Object$keys[_i];acc[key]=currBaggageObject[key];}return acc;},{});}else{// Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
// this is how we choose to handle it)
if(!baggageHeader){return undefined;}baggageObject=baggageHeaderToObject(baggageHeader);}// Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
var dynamicSamplingContext=Object.entries(baggageObject).reduce(function(acc,_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];if(key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)){var nonPrefixedKey=key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);acc[nonPrefixedKey]=value;}return acc;},{});// Only return a dynamic sampling context object if there are keys in it.
// A keyless object means there were no sentry values on the header, which means that there is no DSC.
if(Object.keys(dynamicSamplingContext).length>0){return dynamicSamplingContext;}else{return undefined;}}/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */function dynamicSamplingContextToSentryBaggageHeader(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext){if(!dynamicSamplingContext){return undefined;}// Prefix all DSC keys with "sentry-" and put them into a new object
var sentryPrefixedDSC=Object.entries(dynamicSamplingContext).reduce(function(acc,_ref3){var _ref4=_slicedToArray(_ref3,2),dscKey=_ref4[0],dscValue=_ref4[1];if(dscValue){acc["".concat(SENTRY_BAGGAGE_KEY_PREFIX).concat(dscKey)]=dscValue;}return acc;},{});return objectToBaggageHeader(sentryPrefixedDSC);}/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */function baggageHeaderToObject(baggageHeader){return baggageHeader.split(',').map(function(baggageEntry){return baggageEntry.split('=').map(function(keyOrValue){return decodeURIComponent(keyOrValue.trim());});}).reduce(function(acc,_ref5){var _ref6=_slicedToArray(_ref5,2),key=_ref6[0],value=_ref6[1];acc[key]=value;return acc;},{});}/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */function objectToBaggageHeader(object){if(Object.keys(object).length===0){// An empty baggage header is not spec compliant: We return undefined.
return undefined;}return Object.entries(object).reduce(function(baggageHeader,_ref7,currentIndex){var _ref8=_slicedToArray(_ref7,2),objectKey=_ref8[0],objectValue=_ref8[1];var baggageEntry="".concat(encodeURIComponent(objectKey),"=").concat(encodeURIComponent(objectValue));var newBaggageHeader=currentIndex===0?baggageEntry:"".concat(baggageHeader,",").concat(baggageEntry);if(newBaggageHeader.length>MAX_BAGGAGE_STRING_LENGTH){__WEBPACK_IMPORTED_MODULE_0__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_2__logger_js__["c" /* logger */].warn("Not adding key: ".concat(objectKey," with val: ").concat(objectValue," to baggage header due to exceeding baggage size limits."));return baggageHeader;}else{return newBaggageHeader;}},'');}

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addItemToEnvelope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createAttachmentEnvelopeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createEnvelope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createEventEnvelopeHeaders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return envelopeContainsItemType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return envelopeItemTypeToDataCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return forEachEnvelopeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSdkMetadataForEnvelopeHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return parseEnvelope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return serializeEnvelope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dsn_js__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normalize_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__object_js__ = __webpack_require__(36);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */function createEnvelope(headers){var items=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return[headers,items];}/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */function addItemToEnvelope(envelope,newItem){var _envelope=_slicedToArray(envelope,2),headers=_envelope[0],items=_envelope[1];return[headers,[].concat(_toConsumableArray(items),[newItem])];}/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */function forEachEnvelopeItem(envelope,callback){var envelopeItems=envelope[1];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=envelopeItems[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var envelopeItem=_step.value;var envelopeItemType=envelopeItem[0].type;var result=callback(envelopeItem,envelopeItemType);if(result){return true;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return false;}/**
 * Returns true if the envelope contains any of the given envelope item types
 */function envelopeContainsItemType(envelope,types){return forEachEnvelopeItem(envelope,function(_,type){return types.includes(type);});}/**
 * Encode a string to UTF8.
 */function encodeUTF8(input,textEncoder){var utf8=textEncoder||new TextEncoder();return utf8.encode(input);}/**
 * Serializes an envelope.
 */function serializeEnvelope(envelope,textEncoder){var _envelope2=_slicedToArray(envelope,2),envHeaders=_envelope2[0],items=_envelope2[1];// Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
var parts=JSON.stringify(envHeaders);function append(next){if(typeof parts==='string'){parts=typeof next==='string'?parts+next:[encodeUTF8(parts,textEncoder),next];}else{parts.push(typeof next==='string'?encodeUTF8(next,textEncoder):next);}}var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=items[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var item=_step2.value;var _item=_slicedToArray(item,2),itemHeaders=_item[0],payload=_item[1];append("\n".concat(JSON.stringify(itemHeaders),"\n"));if(typeof payload==='string'||payload instanceof Uint8Array){append(payload);}else{var stringifiedPayload=void 0;try{stringifiedPayload=JSON.stringify(payload);}catch(e){// In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
// fails, we try again after normalizing it again with infinite normalization depth. This of course has a
// performance impact but in this case a performance hit is better than throwing.
stringifiedPayload=JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_1__normalize_js__["a" /* normalize */])(payload));}append(stringifiedPayload);}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return!=null){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return typeof parts==='string'?parts:concatBuffers(parts);}function concatBuffers(buffers){var totalLength=buffers.reduce(function(acc,buf){return acc+buf.length;},0);var merged=new Uint8Array(totalLength);var offset=0;var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=buffers[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var buffer=_step3.value;merged.set(buffer,offset);offset+=buffer.length;}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return!=null){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}return merged;}/**
 * Parses an envelope
 */function parseEnvelope(env,textEncoder,textDecoder){var buffer=typeof env==='string'?textEncoder.encode(env):env;function readBinary(length){var bin=buffer.subarray(0,length);// Replace the buffer with the remaining data excluding trailing newline
buffer=buffer.subarray(length+1);return bin;}function readJson(){var i=buffer.indexOf(0xa);// If we couldn't find a newline, we must have found the end of the buffer
if(i<0){i=buffer.length;}return JSON.parse(textDecoder.decode(readBinary(i)));}var envelopeHeader=readJson();// eslint-disable-next-line @typescript-eslint/no-explicit-any
var items=[];while(buffer.length){var itemHeader=readJson();var binaryLength=typeof itemHeader.length==='number'?itemHeader.length:undefined;items.push([itemHeader,binaryLength?readBinary(binaryLength):readJson()]);}return[envelopeHeader,items];}/**
 * Creates attachment envelope items
 */function createAttachmentEnvelopeItem(attachment,textEncoder){var buffer=typeof attachment.data==='string'?encodeUTF8(attachment.data,textEncoder):attachment.data;return[Object(__WEBPACK_IMPORTED_MODULE_2__object_js__["c" /* dropUndefinedKeys */])({type:'attachment',length:buffer.length,filename:attachment.filename,content_type:attachment.contentType,attachment_type:attachment.attachmentType}),buffer];}var ITEM_TYPE_TO_DATA_CATEGORY_MAP={session:'session',sessions:'session',attachment:'attachment',transaction:'transaction',event:'error',client_report:'internal',user_report:'default',profile:'profile',replay_event:'replay',replay_recording:'replay',check_in:'monitor',feedback:'feedback',span:'span',statsd:'metric_bucket'};/**
 * Maps the type of an envelope item to a data category.
 */function envelopeItemTypeToDataCategory(type){return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];}/** Extracts the minimal SDK info from the metadata or an events */function getSdkMetadataForEnvelopeHeader(metadataOrEvent){if(!metadataOrEvent||!metadataOrEvent.sdk){return;}var _metadataOrEvent$sdk=metadataOrEvent.sdk,name=_metadataOrEvent$sdk.name,version=_metadataOrEvent$sdk.version;return{name:name,version:version};}/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */function createEventEnvelopeHeaders(event,sdkInfo,tunnel,dsn){var dynamicSamplingContext=event.sdkProcessingMetadata&&event.sdkProcessingMetadata.dynamicSamplingContext;return _objectSpread({event_id:event.event_id,sent_at:new Date().toISOString()},sdkInfo&&{sdk:sdkInfo},{},!!tunnel&&dsn&&{dsn:Object(__WEBPACK_IMPORTED_MODULE_0__dsn_js__["b" /* dsnToString */])(dsn)},{},dynamicSamplingContext&&{trace:Object(__WEBPACK_IMPORTED_MODULE_2__object_js__["c" /* dropUndefinedKeys */])(_objectSpread({},dynamicSamplingContext))});}

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _nullishCoalesce; });
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */function _nullishCoalesce(lhs,rhsFn){// by checking for loose equality to `null`, we catch both `null` and `undefined`
return lhs!=null?lhs:rhsFn();}// Sucrase version:
// function _nullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return rhsFn();
//   }
// }


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _asyncOptionalChain; });
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions, for situations in which at least one part of the expression is async.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase) See
 * https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */function _asyncOptionalChain(_x){return _asyncOptionalChain2.apply(this,arguments);}// Sucrase version:
// async function _asyncOptionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = await fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = await fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }
function _asyncOptionalChain2(){_asyncOptionalChain2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(ops){var lastAccessLHS,value,i,op,fn;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:lastAccessLHS=undefined;value=ops[0];i=1;case 3:if(!(i<ops.length)){_context.next=23;break;}op=ops[i];fn=ops[i+1];i+=2;// by checking for loose equality to `null`, we catch both `null` and `undefined`
if(!((op==='optionalAccess'||op==='optionalCall')&&value==null)){_context.next=9;break;}return _context.abrupt("return");case 9:if(!(op==='access'||op==='optionalAccess')){_context.next=16;break;}lastAccessLHS=value;_context.next=13;return fn(value);case 13:value=_context.sent;_context.next=21;break;case 16:if(!(op==='call'||op==='optionalCall')){_context.next=21;break;}_context.next=19;return fn(function(){var _value;for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return(_value=value).call.apply(_value,[lastAccessLHS].concat(args));});case 19:value=_context.sent;lastAccessLHS=undefined;case 21:_context.next=3;break;case 23:return _context.abrupt("return",value);case 24:case"end":return _context.stop();}}},_callee);}));return _asyncOptionalChain2.apply(this,arguments);}

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _optionalChain; });
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */function _optionalChain(ops){var lastAccessLHS=undefined;var value=ops[0];var i=1;while(i<ops.length){var op=ops[i];var fn=ops[i+1];i+=2;// by checking for loose equality to `null`, we catch both `null` and `undefined`
if((op==='optionalAccess'||op==='optionalCall')&&value==null){// really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
return;}if(op==='access'||op==='optionalAccess'){lastAccessLHS=value;value=fn(value);}else if(op==='call'||op==='optionalCall'){value=fn(function(){var _value;for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return(_value=value).call.apply(_value,[lastAccessLHS].concat(args));});lastAccessLHS=undefined;}}return value;}// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IdleTransaction; });
/* unused harmony export IdleTransactionSpanRecorder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRACING_DEFAULTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_spanUtils_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__span_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__transaction_js__ = __webpack_require__(202);
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _get(target,property,receiver){if(typeof Reflect!=="undefined"&&Reflect.get){_get=Reflect.get;}else{_get=function _get(target,property,receiver){var base=_superPropBase(target,property);if(!base)return;var desc=Object.getOwnPropertyDescriptor(base,property);if(desc.get){return desc.get.call(receiver);}return desc.value;};}return _get(target,property,receiver||target);}function _superPropBase(object,property){while(!Object.prototype.hasOwnProperty.call(object,property)){object=_getPrototypeOf(object);if(object===null)break;}return object;}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}var TRACING_DEFAULTS={idleTimeout:1000,finalTimeout:30000,heartbeatInterval:5000};var FINISH_REASON_TAG='finishReason';var IDLE_TRANSACTION_FINISH_REASONS=['heartbeatFailed','idleTimeout','documentHidden','finalTimeout','externalFinish','cancelled'];/**
 * @inheritDoc
 */var IdleTransactionSpanRecorder=/*#__PURE__*/function(_SpanRecorder){_inherits(IdleTransactionSpanRecorder,_SpanRecorder);function IdleTransactionSpanRecorder(_pushActivity,_popActivity,transactionSpanId,maxlen){var _this;_classCallCheck(this,IdleTransactionSpanRecorder);_this=_possibleConstructorReturn(this,_getPrototypeOf(IdleTransactionSpanRecorder).call(this,maxlen));_this._pushActivity=_pushActivity;_this._popActivity=_popActivity;_this.transactionSpanId=transactionSpanId;return _this;}/**
   * @inheritDoc
   */_createClass(IdleTransactionSpanRecorder,[{key:"add",value:function add(span){var _this2=this;// We should make sure we do not push and pop activities for
// the transaction that this span recorder belongs to.
if(span.spanContext().spanId!==this.transactionSpanId){// We patch span.end() to pop an activity after setting an endTimestamp.
// eslint-disable-next-line @typescript-eslint/unbound-method
var originalEnd=span.end;span.end=function(){_this2._popActivity(span.spanContext().spanId);for(var _len=arguments.length,rest=new Array(_len),_key=0;_key<_len;_key++){rest[_key]=arguments[_key];}return originalEnd.apply(span,rest);};// We should only push new activities if the span does not have an end timestamp.
if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_spanUtils_js__["e" /* spanToJSON */])(span).timestamp===undefined){this._pushActivity(span.spanContext().spanId);}}_get(_getPrototypeOf(IdleTransactionSpanRecorder.prototype),"add",this).call(this,span);}}]);return IdleTransactionSpanRecorder;}(__WEBPACK_IMPORTED_MODULE_3__span_js__["b" /* SpanRecorder */]);/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */var IdleTransaction=/*#__PURE__*/function(_Transaction){_inherits(IdleTransaction,_Transaction);// Activities store a list of active spans
// Track state of activities in previous heartbeat
// Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
// We should not use heartbeat if we finished a transaction
// Idle timeout was canceled and we should finish the transaction with the last span end.
/**
   * Timer that tracks Transaction idleTimeout
   *//**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */function IdleTransaction(transactionContext,// eslint-disable-next-line deprecation/deprecation
_idleHub){var _this3;var _idleTimeout=arguments.length>2&&arguments[2]!==undefined?arguments[2]:TRACING_DEFAULTS.idleTimeout;var _finalTimeout=arguments.length>3&&arguments[3]!==undefined?arguments[3]:TRACING_DEFAULTS.finalTimeout;var _heartbeatInterval=arguments.length>4&&arguments[4]!==undefined?arguments[4]:TRACING_DEFAULTS.heartbeatInterval;var _onScope=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;var delayAutoFinishUntilSignal=arguments.length>6&&arguments[6]!==undefined?arguments[6]:false;_classCallCheck(this,IdleTransaction);_this3=_possibleConstructorReturn(this,_getPrototypeOf(IdleTransaction).call(this,transactionContext,_idleHub));_this3._idleHub=_idleHub;_this3._idleTimeout=_idleTimeout;_this3._finalTimeout=_finalTimeout;_this3._heartbeatInterval=_heartbeatInterval;_this3._onScope=_onScope;_this3.activities={};_this3._heartbeatCounter=0;_this3._finished=false;_this3._idleTimeoutCanceledPermanently=false;_this3._beforeFinishCallbacks=[];_this3._finishReason=IDLE_TRANSACTION_FINISH_REASONS[4];_this3._autoFinishAllowed=!delayAutoFinishUntilSignal;if(_onScope){// We set the transaction here on the scope so error events pick up the trace
// context and attach it to the error.
__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("Setting idle transaction on scope. Span ID: ".concat(_this3.spanContext().spanId));// eslint-disable-next-line deprecation/deprecation
_idleHub.getScope().setSpan(_assertThisInitialized(_this3));}if(!delayAutoFinishUntilSignal){_this3._restartIdleTimeout();}setTimeout(function(){if(!_this3._finished){_this3.setStatus('deadline_exceeded');_this3._finishReason=IDLE_TRANSACTION_FINISH_REASONS[3];_this3.end();}},_this3._finalTimeout);return _this3;}/** {@inheritDoc} */_createClass(IdleTransaction,[{key:"end",value:function end(endTimestamp){var _this4=this;var endTimestampInS=Object(__WEBPACK_IMPORTED_MODULE_2__utils_spanUtils_js__["d" /* spanTimeInputToSeconds */])(endTimestamp);this._finished=true;this.activities={};// eslint-disable-next-line deprecation/deprecation
if(this.op==='ui.action.click'){this.setAttribute(FINISH_REASON_TAG,this._finishReason);}// eslint-disable-next-line deprecation/deprecation
if(this.spanRecorder){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&// eslint-disable-next-line deprecation/deprecation
__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Tracing] finishing IdleTransaction',new Date(endTimestampInS*1000).toISOString(),this.op);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=this._beforeFinishCallbacks[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var callback=_step.value;callback(this,endTimestampInS);}// eslint-disable-next-line deprecation/deprecation
}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}this.spanRecorder.spans=this.spanRecorder.spans.filter(function(span){// If we are dealing with the transaction itself, we just return it
if(span.spanContext().spanId===_this4.spanContext().spanId){return true;}// We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
if(!Object(__WEBPACK_IMPORTED_MODULE_2__utils_spanUtils_js__["e" /* spanToJSON */])(span).timestamp){span.setStatus('cancelled');span.end(endTimestampInS);__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Tracing] cancelling span since transaction ended early',JSON.stringify(span,undefined,2));}var _spanToJSON=Object(__WEBPACK_IMPORTED_MODULE_2__utils_spanUtils_js__["e" /* spanToJSON */])(span),startTime=_spanToJSON.start_timestamp,endTime=_spanToJSON.timestamp;var spanStartedBeforeTransactionFinish=startTime&&startTime<endTimestampInS;// Add a delta with idle timeout so that we prevent false positives
var timeoutWithMarginOfError=(_this4._finalTimeout+_this4._idleTimeout)/1000;var spanEndedBeforeFinalTimeout=endTime&&startTime&&endTime-startTime<timeoutWithMarginOfError;if(__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]){var stringifiedSpan=JSON.stringify(span,undefined,2);if(!spanStartedBeforeTransactionFinish){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Tracing] discarding Span since it happened after Transaction was finished',stringifiedSpan);}else if(!spanEndedBeforeFinalTimeout){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Tracing] discarding Span since it finished after Transaction final timeout',stringifiedSpan);}}return spanStartedBeforeTransactionFinish&&spanEndedBeforeFinalTimeout;});__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Tracing] flushing IdleTransaction');}else{__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Tracing] No active IdleTransaction');}// if `this._onScope` is `true`, the transaction put itself on the scope when it started
if(this._onScope){// eslint-disable-next-line deprecation/deprecation
var scope=this._idleHub.getScope();// eslint-disable-next-line deprecation/deprecation
if(scope.getTransaction()===this){// eslint-disable-next-line deprecation/deprecation
scope.setSpan(undefined);}}return _get(_getPrototypeOf(IdleTransaction.prototype),"end",this).call(this,endTimestamp);}/**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */},{key:"registerBeforeFinishCallback",value:function registerBeforeFinishCallback(callback){this._beforeFinishCallbacks.push(callback);}/**
   * @inheritDoc
   */},{key:"initSpanRecorder",value:function initSpanRecorder(maxlen){var _this5=this;// eslint-disable-next-line deprecation/deprecation
if(!this.spanRecorder){var pushActivity=function pushActivity(id){if(_this5._finished){return;}_this5._pushActivity(id);};var popActivity=function popActivity(id){if(_this5._finished){return;}_this5._popActivity(id);};// eslint-disable-next-line deprecation/deprecation
this.spanRecorder=new IdleTransactionSpanRecorder(pushActivity,popActivity,this.spanContext().spanId,maxlen);// Start heartbeat so that transactions do not run forever.
__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('Starting heartbeat');this._pingHeartbeat();}// eslint-disable-next-line deprecation/deprecation
this.spanRecorder.add(this);}/**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */},{key:"cancelIdleTimeout",value:function cancelIdleTimeout(endTimestamp){var _ref=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{restartOnChildSpanChange:true},restartOnChildSpanChange=_ref.restartOnChildSpanChange;this._idleTimeoutCanceledPermanently=restartOnChildSpanChange===false;if(this._idleTimeoutID){clearTimeout(this._idleTimeoutID);this._idleTimeoutID=undefined;if(Object.keys(this.activities).length===0&&this._idleTimeoutCanceledPermanently){this._finishReason=IDLE_TRANSACTION_FINISH_REASONS[5];this.end(endTimestamp);}}}/**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */},{key:"setFinishReason",value:function setFinishReason(reason){this._finishReason=reason;}/**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */},{key:"sendAutoFinishSignal",value:function sendAutoFinishSignal(){if(!this._autoFinishAllowed){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Tracing] Received finish signal for idle transaction.');this._restartIdleTimeout();this._autoFinishAllowed=true;}}/**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */},{key:"_restartIdleTimeout",value:function _restartIdleTimeout(endTimestamp){var _this6=this;this.cancelIdleTimeout();this._idleTimeoutID=setTimeout(function(){if(!_this6._finished&&Object.keys(_this6.activities).length===0){_this6._finishReason=IDLE_TRANSACTION_FINISH_REASONS[1];_this6.end(endTimestamp);}},this._idleTimeout);}/**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */},{key:"_pushActivity",value:function _pushActivity(spanId){this.cancelIdleTimeout(undefined,{restartOnChildSpanChange:!this._idleTimeoutCanceledPermanently});__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("[Tracing] pushActivity: ".concat(spanId));this.activities[spanId]=true;__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Tracing] new activities count',Object.keys(this.activities).length);}/**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */},{key:"_popActivity",value:function _popActivity(spanId){if(this.activities[spanId]){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("[Tracing] popActivity ".concat(spanId));// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
delete this.activities[spanId];__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Tracing] new activities count',Object.keys(this.activities).length);}if(Object.keys(this.activities).length===0){var endTimestamp=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_48" /* timestampInSeconds */])();if(this._idleTimeoutCanceledPermanently){if(this._autoFinishAllowed){this._finishReason=IDLE_TRANSACTION_FINISH_REASONS[5];this.end(endTimestamp);}}else{// We need to add the timeout here to have the real endtimestamp of the transaction
// Remember timestampInSeconds is in seconds, timeout is in ms
this._restartIdleTimeout(endTimestamp+this._idleTimeout/1000);}}}/**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */},{key:"_beat",value:function _beat(){// We should not be running heartbeat if the idle transaction is finished.
if(this._finished){return;}var heartbeatString=Object.keys(this.activities).join('');if(heartbeatString===this._prevHeartbeatString){this._heartbeatCounter++;}else{this._heartbeatCounter=1;}this._prevHeartbeatString=heartbeatString;if(this._heartbeatCounter>=3){if(this._autoFinishAllowed){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Tracing] Transaction finished because of no change for 3 heart beats');this.setStatus('deadline_exceeded');this._finishReason=IDLE_TRANSACTION_FINISH_REASONS[0];this.end();}}else{this._pingHeartbeat();}}/**
   * Pings the heartbeat
   */},{key:"_pingHeartbeat",value:function _pingHeartbeat(){var _this7=this;__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("pinging Heartbeat -> current counter: ".concat(this._heartbeatCounter));setTimeout(function(){_this7._beat();},this._heartbeatInterval);}}]);return IdleTransaction;}(__WEBPACK_IMPORTED_MODULE_4__transaction_js__["a" /* Transaction */]);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleCallbackErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */function handleCallbackErrors(fn,onError){var onFinally=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(){};var maybePromiseResult;try{maybePromiseResult=fn();}catch(e){onError(e);onFinally();throw e;}return maybeHandlePromiseRejection(maybePromiseResult,onError,onFinally);}/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */function maybeHandlePromiseRejection(value,onError,onFinally){if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_24" /* isThenable */])(value)){// @ts-expect-error - the isThenable check returns the "wrong" type here
return value.then(function(res){onFinally();return res;},function(e){onError(e);onFinally();throw e;});}onFinally();return value;}

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isValidSampleRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sampleTransaction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semanticAttributes_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_hasTracingEnabled_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_spanUtils_js__ = __webpack_require__(23);
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */function sampleTransaction(transaction,options,samplingContext){// nothing to do if tracing is not enabled
if(!Object(__WEBPACK_IMPORTED_MODULE_3__utils_hasTracingEnabled_js__["a" /* hasTracingEnabled */])(options)){// eslint-disable-next-line deprecation/deprecation
transaction.sampled=false;return transaction;}// if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
// eslint-disable-next-line deprecation/deprecation
if(transaction.sampled!==undefined){// eslint-disable-next-line deprecation/deprecation
transaction.setAttribute(__WEBPACK_IMPORTED_MODULE_2__semanticAttributes_js__["d" /* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */],Number(transaction.sampled));return transaction;}// we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
// work; prefer the hook if so
var sampleRate;if(typeof options.tracesSampler==='function'){sampleRate=options.tracesSampler(samplingContext);transaction.setAttribute(__WEBPACK_IMPORTED_MODULE_2__semanticAttributes_js__["d" /* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */],Number(sampleRate));}else if(samplingContext.parentSampled!==undefined){sampleRate=samplingContext.parentSampled;}else if(typeof options.tracesSampleRate!=='undefined'){sampleRate=options.tracesSampleRate;transaction.setAttribute(__WEBPACK_IMPORTED_MODULE_2__semanticAttributes_js__["d" /* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */],Number(sampleRate));}else{// When `enableTracing === true`, we use a sample rate of 100%
sampleRate=1;transaction.setAttribute(__WEBPACK_IMPORTED_MODULE_2__semanticAttributes_js__["d" /* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */],sampleRate);}// Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
// only valid values are booleans or numbers between 0 and 1.)
if(!isValidSampleRate(sampleRate)){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('[Tracing] Discarding transaction because of invalid sample rate.');// eslint-disable-next-line deprecation/deprecation
transaction.sampled=false;return transaction;}// if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
if(!sampleRate){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("[Tracing] Discarding transaction because ".concat(typeof options.tracesSampler==='function'?'tracesSampler returned 0 or false':'a negative sampling decision was inherited or tracesSampleRate is set to 0'));// eslint-disable-next-line deprecation/deprecation
transaction.sampled=false;return transaction;}// Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
// a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
// eslint-disable-next-line deprecation/deprecation
transaction.sampled=Math.random()<sampleRate;// if we're not going to keep it, we're done
// eslint-disable-next-line deprecation/deprecation
if(!transaction.sampled){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ".concat(Number(sampleRate),")"));return transaction;}__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&// eslint-disable-next-line deprecation/deprecation
__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("[Tracing] starting ".concat(transaction.op," transaction - ").concat(Object(__WEBPACK_IMPORTED_MODULE_4__utils_spanUtils_js__["e" /* spanToJSON */])(transaction).description));return transaction;}/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */function isValidSampleRate(rate){// we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_15" /* isNaN */])(rate)||!(typeof rate==='number'||typeof rate==='boolean')){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ".concat(JSON.stringify(rate)," of type ").concat(JSON.stringify(_typeof(rate)),"."));return false;}// in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
if(rate<0||rate>1){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ".concat(rate,"."));return false;}return true;}

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createEventEnvelope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createSessionEnvelope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/function enhanceEventWithSdkInfo(event,sdkInfo){if(!sdkInfo){return event;}event.sdk=event.sdk||{};event.sdk.name=event.sdk.name||sdkInfo.name;event.sdk.version=event.sdk.version||sdkInfo.version;event.sdk.integrations=[].concat(_toConsumableArray(event.sdk.integrations||[]),_toConsumableArray(sdkInfo.integrations||[]));event.sdk.packages=[].concat(_toConsumableArray(event.sdk.packages||[]),_toConsumableArray(sdkInfo.packages||[]));return event;}/** Creates an envelope from a Session */function createSessionEnvelope(session,dsn,metadata,tunnel){var sdkInfo=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_6" /* getSdkMetadataForEnvelopeHeader */])(metadata);var envelopeHeaders=_objectSpread({sent_at:new Date().toISOString()},sdkInfo&&{sdk:sdkInfo},{},!!tunnel&&dsn&&{dsn:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["J" /* dsnToString */])(dsn)});var envelopeItem='aggregates'in session?[{type:'sessions'},session]:[{type:'session'},session.toJSON()];return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* createEnvelope */])(envelopeHeaders,[envelopeItem]);}/**
 * Create an Envelope from an event.
 */function createEventEnvelope(event,dsn,metadata,tunnel){var sdkInfo=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_6" /* getSdkMetadataForEnvelopeHeader */])(metadata);/*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */var eventType=event.type&&event.type!=='replay_event'?event.type:'event';enhanceEventWithSdkInfo(event,metadata&&metadata.sdk);var envelopeHeaders=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* createEventEnvelopeHeaders */])(event,sdkInfo,tunnel,dsn);// Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
// sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
// have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
// of this `delete`, lest we miss putting it back in the next time the property is in use.)
delete event.sdkProcessingMetadata;var eventItem=[{type:eventType},event];return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* createEnvelope */])(envelopeHeaders,[eventItem]);}

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SessionFlusher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_js__ = __webpack_require__(37);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/**
 * @inheritdoc
 */var SessionFlusher=/*#__PURE__*/function(){// Cast to any so that it can use Node.js timeout
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function SessionFlusher(client,attrs){var _this=this;_classCallCheck(this,SessionFlusher);this._client=client;this.flushTimeout=60;this._pendingAggregates={};this._isEnabled=true;// Call to setInterval, so that flush is called every 60 seconds.
this._intervalId=setInterval(function(){return _this.flush();},this.flushTimeout*1000);// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
if(this._intervalId.unref){// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
this._intervalId.unref();}this._sessionAttrs=attrs;}/** Checks if `pendingAggregates` has entries, and if it does flushes them by calling `sendSession` */_createClass(SessionFlusher,[{key:"flush",value:function flush(){var sessionAggregates=this.getSessionAggregates();if(sessionAggregates.aggregates.length===0){return;}this._pendingAggregates={};this._client.sendSession(sessionAggregates);}/** Massages the entries in `pendingAggregates` and returns aggregated sessions */},{key:"getSessionAggregates",value:function getSessionAggregates(){var _this2=this;var aggregates=Object.keys(this._pendingAggregates).map(function(key){return _this2._pendingAggregates[parseInt(key)];});var sessionAggregates={attrs:this._sessionAttrs,aggregates:aggregates};return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])(sessionAggregates);}/** JSDoc */},{key:"close",value:function close(){clearInterval(this._intervalId);this._isEnabled=false;this.flush();}/**
   * Wrapper function for _incrementSessionStatusCount that checks if the instance of SessionFlusher is enabled then
   * fetches the session status of the request from `Scope.getRequestSession().status` on the scope and passes them to
   * `_incrementSessionStatusCount` along with the start date
   */},{key:"incrementSessionStatusCount",value:function incrementSessionStatusCount(){if(!this._isEnabled){return;}var scope=Object(__WEBPACK_IMPORTED_MODULE_1__exports_js__["k" /* getCurrentScope */])();var requestSession=scope.getRequestSession();if(requestSession&&requestSession.status){this._incrementSessionStatusCount(requestSession.status,new Date());// This is not entirely necessarily but is added as a safe guard to indicate the bounds of a request and so in
// case captureRequestSession is called more than once to prevent double count
scope.setRequestSession(undefined);/* eslint-enable @typescript-eslint/no-unsafe-member-access */}}/**
   * Increments status bucket in pendingAggregates buffer (internal state) corresponding to status of
   * the session received
   */},{key:"_incrementSessionStatusCount",value:function _incrementSessionStatusCount(status,date){// Truncate minutes and seconds on Session Started attribute to have one minute bucket keys
var sessionStartedTrunc=new Date(date).setSeconds(0,0);this._pendingAggregates[sessionStartedTrunc]=this._pendingAggregates[sessionStartedTrunc]||{};// corresponds to aggregated sessions in one specific minute bucket
// for example, {"started":"2021-03-16T08:00:00.000Z","exited":4, "errored": 1}
var aggregationCounts=this._pendingAggregates[sessionStartedTrunc];if(!aggregationCounts.started){aggregationCounts.started=new Date(sessionStartedTrunc).toISOString();}switch(status){case'errored':aggregationCounts.errored=(aggregationCounts.errored||0)+1;return aggregationCounts.errored;case'ok':aggregationCounts.exited=(aggregationCounts.exited||0)+1;return aggregationCounts.exited;default:aggregationCounts.crashed=(aggregationCounts.crashed||0)+1;return aggregationCounts.crashed;}}}]);return SessionFlusher;}();

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addEventProcessor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__envelope_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exports_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hub_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__integration_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__metrics_envelope_js__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__session_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tracing_dynamicSamplingContext_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_prepareEvent_js__ = __webpack_require__(195);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}var ALREADY_SEEN_ERROR="Not capturing exception because it's already been captured.";/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */var BaseClient=/*#__PURE__*/function(){/**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   *//** Options passed to the SDK. *//** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. *//** Array of set up integrations. *//** Indicates whether this client's integrations have been set up. *//** Number of calls being processed *//** Holds flushable  */// eslint-disable-next-line @typescript-eslint/ban-types
/**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */function BaseClient(options){_classCallCheck(this,BaseClient);this._options=options;this._integrations={};this._integrationsInitialized=false;this._numProcessing=0;this._outcomes={};this._hooks={};this._eventProcessors=[];if(options.dsn){this._dsn=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_27" /* makeDsn */])(options.dsn);}else{__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('No DSN provided, client will not send events.');}if(this._dsn){var url=Object(__WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* getEnvelopeEndpointWithUrlEncodedAuth */])(this._dsn,options);this._transport=options.transport(_objectSpread({tunnel:this._options.tunnel,recordDroppedEvent:this.recordDroppedEvent.bind(this)},options.transportOptions,{url:url}));}}/**
   * @inheritDoc
   */// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
_createClass(BaseClient,[{key:"captureException",value:function captureException(exception,hint,scope){var _this=this;// ensure we haven't captured this very object before
if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["z" /* checkOrSetAlreadyCaught */])(exception)){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log(ALREADY_SEEN_ERROR);return;}var eventId=hint&&hint.event_id;this._process(this.eventFromException(exception,hint).then(function(event){return _this._captureEvent(event,hint,scope);}).then(function(result){eventId=result;}));return eventId;}/**
   * @inheritDoc
   */},{key:"captureMessage",value:function captureMessage(message,// eslint-disable-next-line deprecation/deprecation
level,hint,scope){var _this2=this;var eventId=hint&&hint.event_id;var eventMessage=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_18" /* isParameterizedString */])(message)?message:String(message);var promisedEvent=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_20" /* isPrimitive */])(message)?this.eventFromMessage(eventMessage,level,hint):this.eventFromException(message,hint);this._process(promisedEvent.then(function(event){return _this2._captureEvent(event,hint,scope);}).then(function(result){eventId=result;}));return eventId;}/**
   * @inheritDoc
   */},{key:"captureEvent",value:function captureEvent(event,hint,scope){// ensure we haven't captured this very object before
if(hint&&hint.originalException&&Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["z" /* checkOrSetAlreadyCaught */])(hint.originalException)){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log(ALREADY_SEEN_ERROR);return;}var eventId=hint&&hint.event_id;var sdkProcessingMetadata=event.sdkProcessingMetadata||{};var capturedSpanScope=sdkProcessingMetadata.capturedSpanScope;this._process(this._captureEvent(event,hint,capturedSpanScope||scope).then(function(result){eventId=result;}));return eventId;}/**
   * @inheritDoc
   */},{key:"captureSession",value:function captureSession(session){if(!(typeof session.release==='string')){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Discarded session because of missing or non-string release');}else{this.sendSession(session);// After sending, we set init false to indicate it's not the first occurrence
Object(__WEBPACK_IMPORTED_MODULE_8__session_js__["c" /* updateSession */])(session,{init:false});}}/**
   * @inheritDoc
   */},{key:"getDsn",value:function getDsn(){return this._dsn;}/**
   * @inheritDoc
   */},{key:"getOptions",value:function getOptions(){return this._options;}/**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */},{key:"getSdkMetadata",value:function getSdkMetadata(){return this._options._metadata;}/**
   * @inheritDoc
   */},{key:"getTransport",value:function getTransport(){return this._transport;}/**
   * @inheritDoc
   */},{key:"flush",value:function flush(timeout){var transport=this._transport;if(transport){if(this.metricsAggregator){this.metricsAggregator.flush();}return this._isClientDoneProcessing(timeout).then(function(clientFinished){return transport.flush(timeout).then(function(transportFlushed){return clientFinished&&transportFlushed;});});}else{return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_38" /* resolvedSyncPromise */])(true);}}/**
   * @inheritDoc
   */},{key:"close",value:function close(timeout){var _this3=this;return this.flush(timeout).then(function(result){_this3.getOptions().enabled=false;if(_this3.metricsAggregator){_this3.metricsAggregator.close();}return result;});}/** Get all installed event processors. */},{key:"getEventProcessors",value:function getEventProcessors(){return this._eventProcessors;}/** @inheritDoc */},{key:"addEventProcessor",value:function addEventProcessor(eventProcessor){this._eventProcessors.push(eventProcessor);}/**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */},{key:"setupIntegrations",value:function setupIntegrations(forceInitialize){if(forceInitialize&&!this._integrationsInitialized||this._isEnabled()&&!this._integrationsInitialized){this._setupIntegrations();}}/** @inheritdoc */},{key:"init",value:function init(){if(this._isEnabled()){this._setupIntegrations();}}/**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */},{key:"getIntegrationById",value:function getIntegrationById(integrationId){return this.getIntegrationByName(integrationId);}/**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */},{key:"getIntegrationByName",value:function getIntegrationByName(integrationName){return this._integrations[integrationName];}/**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */},{key:"getIntegration",value:function getIntegration(integration){try{return this._integrations[integration.id]||null;}catch(_oO){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("Cannot retrieve integration ".concat(integration.id," from the current Client"));return null;}}/**
   * @inheritDoc
   */},{key:"addIntegration",value:function addIntegration(integration){var isAlreadyInstalled=this._integrations[integration.name];// This hook takes care of only installing if not already installed
Object(__WEBPACK_IMPORTED_MODULE_6__integration_js__["f" /* setupIntegration */])(this,integration,this._integrations);// Here we need to check manually to make sure to not run this multiple times
if(!isAlreadyInstalled){Object(__WEBPACK_IMPORTED_MODULE_6__integration_js__["b" /* afterSetupIntegrations */])(this,[integration]);}}/**
   * @inheritDoc
   */},{key:"sendEvent",value:function sendEvent(event){var _this4=this;var hint=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};this.emit('beforeSendEvent',event,hint);var env=Object(__WEBPACK_IMPORTED_MODULE_3__envelope_js__["a" /* createEventEnvelope */])(event,this._dsn,this._options._metadata,this._options.tunnel);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=(hint.attachments||[])[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var attachment=_step.value;env=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["r" /* addItemToEnvelope */])(env,Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["B" /* createAttachmentEnvelopeItem */])(attachment,this._options.transportOptions&&this._options.transportOptions.textEncoder));}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}var promise=this._sendEnvelope(env);if(promise){promise.then(function(sendResponse){return _this4.emit('afterSendEvent',event,sendResponse);},null);}}/**
   * @inheritDoc
   */},{key:"sendSession",value:function sendSession(session){var env=Object(__WEBPACK_IMPORTED_MODULE_3__envelope_js__["b" /* createSessionEnvelope */])(session,this._dsn,this._options._metadata,this._options.tunnel);// _sendEnvelope should not throw
// eslint-disable-next-line @typescript-eslint/no-floating-promises
this._sendEnvelope(env);}/**
   * @inheritDoc
   */},{key:"recordDroppedEvent",value:function recordDroppedEvent(reason,category,eventOrCount){if(this._options.sendClientReports){// TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
// If event is passed as third argument, we assume this is a count of 1
var count=typeof eventOrCount==='number'?eventOrCount:1;// We want to track each category (error, transaction, session, replay_event) separately
// but still keep the distinction between different type of outcomes.
// We could use nested maps, but it's much easier to read and type this way.
// A correct type for map-based implementation if we want to go that route
// would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
// With typescript 4.1 we could even use template literal types
var key="".concat(reason,":").concat(category);__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("Recording outcome: \"".concat(key,"\"").concat(count>1?" (".concat(count," times)"):''));this._outcomes[key]=(this._outcomes[key]||0)+count;}}/**
   * @inheritDoc
   */},{key:"captureAggregateMetrics",value:function captureAggregateMetrics(metricBucketItems){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("Flushing aggregated metrics, number of metrics: ".concat(metricBucketItems.length));var metricsEnvelope=Object(__WEBPACK_IMPORTED_MODULE_7__metrics_envelope_js__["a" /* createMetricEnvelope */])(metricBucketItems,this._dsn,this._options._metadata,this._options.tunnel);// _sendEnvelope should not throw
// eslint-disable-next-line @typescript-eslint/no-floating-promises
this._sendEnvelope(metricsEnvelope);}// Keep on() & emit() signatures in sync with types' client.ts interface
/* eslint-disable @typescript-eslint/unified-signatures *//** @inheritdoc *//** @inheritdoc */},{key:"on",value:function on(hook,callback){if(!this._hooks[hook]){this._hooks[hook]=[];}// @ts-expect-error We assue the types are correct
this._hooks[hook].push(callback);}/** @inheritdoc *//** @inheritdoc */},{key:"emit",value:function emit(hook){for(var _len=arguments.length,rest=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){rest[_key-1]=arguments[_key];}if(this._hooks[hook]){this._hooks[hook].forEach(function(callback){return callback.apply(void 0,rest);});}}/* eslint-enable @typescript-eslint/unified-signatures *//** Setup integrations for this client. */},{key:"_setupIntegrations",value:function _setupIntegrations(){var integrations=this._options.integrations;this._integrations=Object(__WEBPACK_IMPORTED_MODULE_6__integration_js__["g" /* setupIntegrations */])(this,integrations);Object(__WEBPACK_IMPORTED_MODULE_6__integration_js__["b" /* afterSetupIntegrations */])(this,integrations);// TODO v8: We don't need this flag anymore
this._integrationsInitialized=true;}/** Updates existing session based on the provided event */},{key:"_updateSessionFromEvent",value:function _updateSessionFromEvent(session,event){var crashed=false;var errored=false;var exceptions=event.exception&&event.exception.values;if(exceptions){errored=true;var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=exceptions[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var ex=_step2.value;var mechanism=ex.mechanism;if(mechanism&&mechanism.handled===false){crashed=true;break;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return!=null){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}// A session is updated and that session update is sent in only one of the two following scenarios:
// 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
// 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
var sessionNonTerminal=session.status==='ok';var shouldUpdateAndSend=sessionNonTerminal&&session.errors===0||sessionNonTerminal&&crashed;if(shouldUpdateAndSend){Object(__WEBPACK_IMPORTED_MODULE_8__session_js__["c" /* updateSession */])(session,_objectSpread({},crashed&&{status:'crashed'},{errors:session.errors||Number(errored||crashed)}));this.captureSession(session);}}/**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */},{key:"_isClientDoneProcessing",value:function _isClientDoneProcessing(timeout){var _this5=this;return new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["f" /* SyncPromise */](function(resolve){var ticked=0;var tick=1;var interval=setInterval(function(){if(_this5._numProcessing==0){clearInterval(interval);resolve(true);}else{ticked+=tick;if(timeout&&ticked>=timeout){clearInterval(interval);resolve(false);}}},tick);});}/** Determines whether this SDK is enabled and a transport is present. */},{key:"_isEnabled",value:function _isEnabled(){return this.getOptions().enabled!==false&&this._transport!==undefined;}/**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */},{key:"_prepareEvent",value:function _prepareEvent(event,hint,scope){var _this6=this;var isolationScope=arguments.length>3&&arguments[3]!==undefined?arguments[3]:Object(__WEBPACK_IMPORTED_MODULE_5__hub_js__["d" /* getIsolationScope */])();var options=this.getOptions();var integrations=Object.keys(this._integrations);if(!hint.integrations&&integrations.length>0){hint.integrations=integrations;}this.emit('preprocessEvent',event,hint);return Object(__WEBPACK_IMPORTED_MODULE_10__utils_prepareEvent_js__["b" /* prepareEvent */])(options,event,hint,scope,this,isolationScope).then(function(evt){if(evt===null){return evt;}var propagationContext=_objectSpread({},isolationScope.getPropagationContext(),{},scope?scope.getPropagationContext():undefined);var trace=evt.contexts&&evt.contexts.trace;if(!trace&&propagationContext){var trace_id=propagationContext.traceId,spanId=propagationContext.spanId,parentSpanId=propagationContext.parentSpanId,dsc=propagationContext.dsc;evt.contexts=_objectSpread({trace:{trace_id:trace_id,span_id:spanId,parent_span_id:parentSpanId}},evt.contexts);var dynamicSamplingContext=dsc?dsc:Object(__WEBPACK_IMPORTED_MODULE_9__tracing_dynamicSamplingContext_js__["a" /* getDynamicSamplingContextFromClient */])(trace_id,_this6,scope);evt.sdkProcessingMetadata=_objectSpread({dynamicSamplingContext:dynamicSamplingContext},evt.sdkProcessingMetadata);}return evt;});}/**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */},{key:"_captureEvent",value:function _captureEvent(event){var hint=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var scope=arguments.length>2?arguments[2]:undefined;return this._processEvent(event,hint,scope).then(function(finalEvent){return finalEvent.event_id;},function(reason){if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){// If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
// control flow, log just the message (no stack) as a log-level log.
var sentryError=reason;if(sentryError.logLevel==='log'){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log(sentryError.message);}else{__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn(sentryError);}}return undefined;});}/**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */},{key:"_processEvent",value:function _processEvent(event,hint,scope){var _this7=this;var options=this.getOptions();var sampleRate=options.sampleRate;var isTransaction=isTransactionEvent(event);var isError=isErrorEvent(event);var eventType=event.type||'error';var beforeSendLabel="before send for type `".concat(eventType,"`");// 1.0 === 100% events are sent
// 0.0 === 0% events are sent
// Sampling for transaction happens somewhere else
if(isError&&typeof sampleRate==='number'&&Math.random()>sampleRate){this.recordDroppedEvent('sample_rate','error',event);return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_36" /* rejectedSyncPromise */])(new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* SentryError */]("Discarding event because it's not included in the random sample (sampling rate = ".concat(sampleRate,")"),'log'));}var dataCategory=eventType==='replay_event'?'replay':eventType;var sdkProcessingMetadata=event.sdkProcessingMetadata||{};var capturedSpanIsolationScope=sdkProcessingMetadata.capturedSpanIsolationScope;return this._prepareEvent(event,hint,scope,capturedSpanIsolationScope).then(function(prepared){if(prepared===null){_this7.recordDroppedEvent('event_processor',dataCategory,event);throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* SentryError */]('An event processor returned `null`, will not send event.','log');}var isInternalException=hint.data&&hint.data.__sentry__===true;if(isInternalException){return prepared;}var result=processBeforeSend(options,prepared,hint);return _validateBeforeSendResult(result,beforeSendLabel);}).then(function(processedEvent){if(processedEvent===null){_this7.recordDroppedEvent('before_send',dataCategory,event);if(isTransaction){var spans=event.spans||[];// the transaction itself counts as one span, plus all the child spans that are added
var spanCount=1+spans.length;_this7.recordDroppedEvent('before_send','span',spanCount);}throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* SentryError */]("".concat(beforeSendLabel," returned `null`, will not send event."),'log');}var session=scope&&scope.getSession();if(!isTransaction&&session){_this7._updateSessionFromEvent(session,processedEvent);}if(isTransaction){var spanCountBefore=processedEvent.sdkProcessingMetadata&&processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing||0;var spanCountAfter=processedEvent.spans?processedEvent.spans.length:0;var droppedSpanCount=spanCountBefore-spanCountAfter;if(droppedSpanCount>0){_this7.recordDroppedEvent('before_send','span',droppedSpanCount);}}// None of the Sentry built event processor will update transaction name,
// so if the transaction name has been changed by an event processor, we know
// it has to come from custom event processor added by a user
var transactionInfo=processedEvent.transaction_info;if(isTransaction&&transactionInfo&&processedEvent.transaction!==event.transaction){var source='custom';processedEvent.transaction_info=_objectSpread({},transactionInfo,{source:source});}_this7.sendEvent(processedEvent,hint);return processedEvent;}).then(null,function(reason){if(reason instanceof __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* SentryError */]){throw reason;}_this7.captureException(reason,{data:{__sentry__:true},originalException:reason});throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* SentryError */]("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ".concat(reason));});}/**
   * Occupies the client with processing and event
   */},{key:"_process",value:function _process(promise){var _this8=this;this._numProcessing++;void promise.then(function(value){_this8._numProcessing--;return value;},function(reason){_this8._numProcessing--;return reason;});}/**
   * @inheritdoc
   */},{key:"_sendEnvelope",value:function _sendEnvelope(envelope){this.emit('beforeEnvelope',envelope);if(this._isEnabled()&&this._transport){return this._transport.send(envelope).then(null,function(reason){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('Error while sending event:',reason);});}else{__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('Transport disabled');}}/**
   * Clears outcomes on this client and returns them.
   */},{key:"_clearOutcomes",value:function _clearOutcomes(){var outcomes=this._outcomes;this._outcomes={};return Object.keys(outcomes).map(function(key){var _key$split=key.split(':'),_key$split2=_slicedToArray(_key$split,2),reason=_key$split2[0],category=_key$split2[1];return{reason:reason,category:category,quantity:outcomes[key]};});}/**
   * @inheritDoc
   */// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
}]);return BaseClient;}();/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */function _validateBeforeSendResult(beforeSendResult,beforeSendLabel){var invalidValueError="".concat(beforeSendLabel," must return `null` or a valid event.");if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_24" /* isThenable */])(beforeSendResult)){return beforeSendResult.then(function(event){if(!Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_19" /* isPlainObject */])(event)&&event!==null){throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* SentryError */](invalidValueError);}return event;},function(e){throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* SentryError */]("".concat(beforeSendLabel," rejected with ").concat(e));});}else if(!Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_19" /* isPlainObject */])(beforeSendResult)&&beforeSendResult!==null){throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* SentryError */](invalidValueError);}return beforeSendResult;}/**
 * Process the matching `beforeSendXXX` callback.
 */function processBeforeSend(options,event,hint){var beforeSend=options.beforeSend,beforeSendTransaction=options.beforeSendTransaction;if(isErrorEvent(event)&&beforeSend){return beforeSend(event,hint);}if(isTransactionEvent(event)&&beforeSendTransaction){if(event.spans){// We store the # of spans before processing in SDK metadata,
// so we can compare it afterwards to determine how many spans were dropped
var spanCountBefore=event.spans.length;event.sdkProcessingMetadata=_objectSpread({},event.sdkProcessingMetadata,{spanCountBeforeProcessing:spanCountBefore});}return beforeSendTransaction(event,hint);}return event;}function isErrorEvent(event){return event.type===undefined;}function isTransactionEvent(event){return event.type==='transaction';}/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */function addEventProcessor(callback){var client=Object(__WEBPACK_IMPORTED_MODULE_4__exports_js__["j" /* getClient */])();if(!client||!client.addEventProcessor){return;}client.addEventProcessor(callback);}

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createCheckInEnvelope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/**
 * Create envelope from check in item.
 */function createCheckInEnvelope(checkIn,dynamicSamplingContext,metadata,tunnel,dsn){var headers={sent_at:new Date().toISOString()};if(metadata&&metadata.sdk){headers.sdk={name:metadata.sdk.name,version:metadata.sdk.version};}if(!!tunnel&&!!dsn){headers.dsn=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["J" /* dsnToString */])(dsn);}if(dynamicSamplingContext){headers.trace=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])(dynamicSamplingContext);}var item=createCheckInEnvelopeItem(checkIn);return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* createEnvelope */])(headers,[item]);}function createCheckInEnvelopeItem(checkIn){var checkInHeaders={type:'check_in'};return[checkInHeaders,checkIn];}

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CounterMetric */
/* unused harmony export DistributionMetric */
/* unused harmony export GaugeMetric */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return METRIC_MAP; });
/* unused harmony export SetMetric */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(136);
var _METRIC_MAP;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/**
 * A metric instance representing a counter.
 */var CounterMetric=/*#__PURE__*/function(){function CounterMetric(_value){_classCallCheck(this,CounterMetric);this._value=_value;}/** @inheritDoc */_createClass(CounterMetric,[{key:"add",/** @inheritdoc */value:function add(value){this._value+=value;}/** @inheritdoc */},{key:"toString",value:function toString(){return"".concat(this._value);}},{key:"weight",get:function get(){return 1;}}]);return CounterMetric;}();/**
 * A metric instance representing a gauge.
 */var GaugeMetric=/*#__PURE__*/function(){function GaugeMetric(value){_classCallCheck(this,GaugeMetric);this._last=value;this._min=value;this._max=value;this._sum=value;this._count=1;}/** @inheritDoc */_createClass(GaugeMetric,[{key:"add",/** @inheritdoc */value:function add(value){this._last=value;if(value<this._min){this._min=value;}if(value>this._max){this._max=value;}this._sum+=value;this._count++;}/** @inheritdoc */},{key:"toString",value:function toString(){return"".concat(this._last,":").concat(this._min,":").concat(this._max,":").concat(this._sum,":").concat(this._count);}},{key:"weight",get:function get(){return 5;}}]);return GaugeMetric;}();/**
 * A metric instance representing a distribution.
 */var DistributionMetric=/*#__PURE__*/function(){function DistributionMetric(first){_classCallCheck(this,DistributionMetric);this._value=[first];}/** @inheritDoc */_createClass(DistributionMetric,[{key:"add",/** @inheritdoc */value:function add(value){this._value.push(value);}/** @inheritdoc */},{key:"toString",value:function toString(){return this._value.join(':');}},{key:"weight",get:function get(){return this._value.length;}}]);return DistributionMetric;}();/**
 * A metric instance representing a set.
 */var SetMetric=/*#__PURE__*/function(){function SetMetric(first){_classCallCheck(this,SetMetric);this.first=first;this._value=new Set([first]);}/** @inheritDoc */_createClass(SetMetric,[{key:"add",/** @inheritdoc */value:function add(value){this._value.add(value);}/** @inheritdoc */},{key:"toString",value:function toString(){return Array.from(this._value).map(function(val){return typeof val==='string'?Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["f" /* simpleHash */])(val):val;}).join(':');}},{key:"weight",get:function get(){return this._value.size;}}]);return SetMetric;}();var METRIC_MAP=(_METRIC_MAP={},_defineProperty(_METRIC_MAP,__WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* COUNTER_METRIC_TYPE */],CounterMetric),_defineProperty(_METRIC_MAP,__WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* GAUGE_METRIC_TYPE */],GaugeMetric),_defineProperty(_METRIC_MAP,__WEBPACK_IMPORTED_MODULE_0__constants_js__["d" /* DISTRIBUTION_METRIC_TYPE */],DistributionMetric),_defineProperty(_METRIC_MAP,__WEBPACK_IMPORTED_MODULE_0__constants_js__["g" /* SET_METRIC_TYPE */],SetMetric),_METRIC_MAP);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InboundFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inboundFiltersIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__integration_js__ = __webpack_require__(58);
function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS=[/^Script error\.?$/,/^Javascript error: Script error\.? on line 0$/,/^ResizeObserver loop completed with undelivered notifications.$/,/^Cannot redefine property: googletag$/];var DEFAULT_IGNORE_TRANSACTIONS=[/^.*\/healthcheck$/,/^.*\/healthy$/,/^.*\/live$/,/^.*\/ready$/,/^.*\/heartbeat$/,/^.*\/health$/,/^.*\/healthz$/];/** Options for the InboundFilters integration */var INTEGRATION_NAME='InboundFilters';var _inboundFiltersIntegration=function _inboundFiltersIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
processEvent:function processEvent(event,_hint,client){var clientOptions=client.getOptions();var mergedOptions=_mergeOptions(options,clientOptions);return _shouldDropEvent(event,mergedOptions)?null:event;}};};var inboundFiltersIntegration=Object(__WEBPACK_IMPORTED_MODULE_2__integration_js__["d" /* defineIntegration */])(_inboundFiltersIntegration);/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var InboundFilters=Object(__WEBPACK_IMPORTED_MODULE_2__integration_js__["c" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,inboundFiltersIntegration);function _mergeOptions(){var internalOptions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var clientOptions=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return{allowUrls:[].concat(_toConsumableArray(internalOptions.allowUrls||[]),_toConsumableArray(clientOptions.allowUrls||[])),denyUrls:[].concat(_toConsumableArray(internalOptions.denyUrls||[]),_toConsumableArray(clientOptions.denyUrls||[])),ignoreErrors:[].concat(_toConsumableArray(internalOptions.ignoreErrors||[]),_toConsumableArray(clientOptions.ignoreErrors||[]),_toConsumableArray(internalOptions.disableErrorDefaults?[]:DEFAULT_IGNORE_ERRORS)),ignoreTransactions:[].concat(_toConsumableArray(internalOptions.ignoreTransactions||[]),_toConsumableArray(clientOptions.ignoreTransactions||[]),_toConsumableArray(internalOptions.disableTransactionDefaults?[]:DEFAULT_IGNORE_TRANSACTIONS)),ignoreInternal:internalOptions.ignoreInternal!==undefined?internalOptions.ignoreInternal:true};}function _shouldDropEvent(event,options){if(options.ignoreInternal&&_isSentryError(event)){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("Event dropped due to being internal Sentry Error.\nEvent: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["Z" /* getEventDescription */])(event)));return true;}if(_isIgnoredError(event,options.ignoreErrors)){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["Z" /* getEventDescription */])(event)));return true;}if(_isIgnoredTransaction(event,options.ignoreTransactions)){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("Event dropped due to being matched by `ignoreTransactions` option.\nEvent: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["Z" /* getEventDescription */])(event)));return true;}if(_isDeniedUrl(event,options.denyUrls)){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("Event dropped due to being matched by `denyUrls` option.\nEvent: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["Z" /* getEventDescription */])(event),".\nUrl: ").concat(_getEventFilterUrl(event)));return true;}if(!_isAllowedUrl(event,options.allowUrls)){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["Z" /* getEventDescription */])(event),".\nUrl: ").concat(_getEventFilterUrl(event)));return true;}return false;}function _isIgnoredError(event,ignoreErrors){// If event.type, this is not an error
if(event.type||!ignoreErrors||!ignoreErrors.length){return false;}return _getPossibleEventMessages(event).some(function(message){return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_43" /* stringMatchesSomePattern */])(message,ignoreErrors);});}function _isIgnoredTransaction(event,ignoreTransactions){if(event.type!=='transaction'||!ignoreTransactions||!ignoreTransactions.length){return false;}var name=event.transaction;return name?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_43" /* stringMatchesSomePattern */])(name,ignoreTransactions):false;}function _isDeniedUrl(event,denyUrls){// TODO: Use Glob instead?
if(!denyUrls||!denyUrls.length){return false;}var url=_getEventFilterUrl(event);return!url?false:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_43" /* stringMatchesSomePattern */])(url,denyUrls);}function _isAllowedUrl(event,allowUrls){// TODO: Use Glob instead?
if(!allowUrls||!allowUrls.length){return true;}var url=_getEventFilterUrl(event);return!url?true:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_43" /* stringMatchesSomePattern */])(url,allowUrls);}function _getPossibleEventMessages(event){var possibleMessages=[];if(event.message){possibleMessages.push(event.message);}var lastException;try{// @ts-expect-error Try catching to save bundle size
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
lastException=event.exception.values[event.exception.values.length-1];}catch(e){// try catching to save bundle size checking existence of variables
}if(lastException){if(lastException.value){possibleMessages.push(lastException.value);if(lastException.type){possibleMessages.push("".concat(lastException.type,": ").concat(lastException.value));}}}if(__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&possibleMessages.length===0){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error("Could not extract message for event ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["Z" /* getEventDescription */])(event)));}return possibleMessages;}function _isSentryError(event){try{// @ts-expect-error can't be a sentry error if undefined
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
return event.exception.values[0].type==='SentryError';}catch(e){// ignore
}return false;}function _getLastValidUrl(){var frames=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];for(var i=frames.length-1;i>=0;i--){var frame=frames[i];if(frame&&frame.filename!=='<anonymous>'&&frame.filename!=='[native code]'){return frame.filename||null;}}return null;}function _getEventFilterUrl(event){try{var frames;try{// @ts-expect-error we only care about frames if the whole thing here is defined
frames=event.exception.values[0].stacktrace.frames;}catch(e){// ignore
}return frames?_getLastValidUrl(frames):null;}catch(oO){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error("Cannot extract url for event ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["Z" /* getEventDescription */])(event)));return null;}}

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FunctionToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return functionToStringIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__integration_js__ = __webpack_require__(58);
var originalFunctionToString;var INTEGRATION_NAME='FunctionToString';var SETUP_CLIENTS=new WeakMap();var _functionToStringIntegration=function _functionToStringIntegration(){return{name:INTEGRATION_NAME,setupOnce:function setupOnce(){// eslint-disable-next-line @typescript-eslint/unbound-method
originalFunctionToString=Function.prototype.toString;// intrinsics (like Function.prototype) might be immutable in some environments
// e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
try{// eslint-disable-next-line @typescript-eslint/no-explicit-any
Function.prototype.toString=function(){var originalFunction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_4" /* getOriginalFunction */])(this);var context=SETUP_CLIENTS.has(Object(__WEBPACK_IMPORTED_MODULE_1__exports_js__["j" /* getClient */])())&&originalFunction!==undefined?originalFunction:this;for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return originalFunctionToString.apply(context,args);};}catch(e){// ignore errors here, just don't patch this
}},setup:function setup(client){SETUP_CLIENTS.set(client,true);}};};/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */var functionToStringIntegration=Object(__WEBPACK_IMPORTED_MODULE_2__integration_js__["d" /* defineIntegration */])(_functionToStringIntegration);/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var FunctionToString=Object(__WEBPACK_IMPORTED_MODULE_2__integration_js__["c" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,functionToStringIntegration);// eslint-disable-next-line deprecation/deprecation


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedErrors; });
/* unused harmony export linkedErrorsIntegration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__integration_js__ = __webpack_require__(58);
var DEFAULT_KEY='cause';var DEFAULT_LIMIT=5;var INTEGRATION_NAME='LinkedErrors';var _linkedErrorsIntegration=function _linkedErrorsIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var limit=options.limit||DEFAULT_LIMIT;var key=options.key||DEFAULT_KEY;return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
preprocessEvent:function preprocessEvent(event,hint,client){var options=client.getOptions();Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["v" /* applyAggregateErrorsToEvent */])(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["Q" /* exceptionFromError */],options.stackParser,options.maxValueLength,key,limit,event,hint);}};};var linkedErrorsIntegration=Object(__WEBPACK_IMPORTED_MODULE_1__integration_js__["d" /* defineIntegration */])(_linkedErrorsIntegration);/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var LinkedErrors=Object(__WEBPACK_IMPORTED_MODULE_1__integration_js__["c" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,linkedErrorsIntegration);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return registerBackgroundTabDetection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_js__ = __webpack_require__(29);
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */function registerBackgroundTabDetection(){if(__WEBPACK_IMPORTED_MODULE_3__types_js__["a" /* WINDOW */].document){__WEBPACK_IMPORTED_MODULE_3__types_js__["a" /* WINDOW */].document.addEventListener('visibilitychange',function(){// eslint-disable-next-line deprecation/deprecation
var activeTransaction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["M" /* getActiveTransaction */])();if(__WEBPACK_IMPORTED_MODULE_3__types_js__["a" /* WINDOW */].document.hidden&&activeTransaction){var statusType='cancelled';var _spanToJSON=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_24" /* spanToJSON */])(activeTransaction),op=_spanToJSON.op,status=_spanToJSON.status;__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Tracing] Transaction: ".concat(statusType," -> since tab moved to the background, op: ").concat(op));// We should not set status if it is already set, this prevent important statuses like
// error or data loss from being overwritten on transaction.
if(!status){activeTransaction.setStatus(statusType);}// TODO: Can we rewrite this to an attribute?
// eslint-disable-next-line deprecation/deprecation
activeTransaction.setTag('visibilitychange','document.hidden');activeTransaction.end();}});}else{__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('[Tracing] Could not set up background tab detection due to lack of global document');}}

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _addMeasureSpans */
/* unused harmony export _addResourceSpans */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addPerformanceEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return startTrackingINP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return startTrackingInteractions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startTrackingLongTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return startTrackingWebVitals; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instrument_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__web_vitals_lib_getVisibilityWatcher_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_js__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__web_vitals_lib_getNavigationEntry_js__ = __webpack_require__(138);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var MAX_INT_AS_BYTES=2147483647;/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */function msToSec(time){return time/1000;}function getBrowserPerformanceAPI(){// @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
return __WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* WINDOW */]&&__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* WINDOW */].addEventListener&&__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* WINDOW */].performance;}var _performanceCursor=0;var _measurements={};var _lcpEntry;var _clsEntry;/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */function startTrackingWebVitals(){var performance=getBrowserPerformanceAPI();if(performance&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]){// @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
if(performance.mark){__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* WINDOW */].performance.mark('sentry-tracing-init');}var fidCallback=_trackFID();var clsCallback=_trackCLS();var lcpCallback=_trackLCP();var ttfbCallback=_trackTtfb();return function(){fidCallback();clsCallback();lcpCallback();ttfbCallback();};}return function(){return undefined;};}/**
 * Start tracking long tasks.
 */function startTrackingLongTasks(){Object(__WEBPACK_IMPORTED_MODULE_3__instrument_js__["e" /* addPerformanceInstrumentationHandler */])('longtask',function(_ref){var entries=_ref.entries;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=entries[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var entry=_step.value;// eslint-disable-next-line deprecation/deprecation
var transaction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["M" /* getActiveTransaction */])();if(!transaction){return;}var startTime=msToSec(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]+entry.startTime);var duration=msToSec(entry.duration);// eslint-disable-next-line deprecation/deprecation
transaction.startChild({description:'Main UI thread blocked',op:'ui.long-task',origin:'auto.ui.browser.metrics',startTimestamp:startTime,endTimestamp:startTime+duration});}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}});}/**
 * Start tracking interaction events.
 */function startTrackingInteractions(){Object(__WEBPACK_IMPORTED_MODULE_3__instrument_js__["e" /* addPerformanceInstrumentationHandler */])('event',function(_ref2){var entries=_ref2.entries;var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=entries[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var entry=_step2.value;// eslint-disable-next-line deprecation/deprecation
var transaction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["M" /* getActiveTransaction */])();if(!transaction){return;}if(entry.name==='click'){var startTime=msToSec(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]+entry.startTime);var duration=msToSec(entry.duration);var span={description:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_7" /* htmlTreeAsString */])(entry.target),op:"ui.interaction.".concat(entry.name),origin:'auto.ui.browser.metrics',startTimestamp:startTime,endTimestamp:startTime+duration};var componentName=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["X" /* getComponentName */])(entry.target);if(componentName){span.attributes={'ui.component_name':componentName};}// eslint-disable-next-line deprecation/deprecation
transaction.startChild(span);}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return!=null){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}});}/**
 * Start tracking INP webvital events.
 */function startTrackingINP(interactionIdtoRouteNameMapping,interactionsSampleRate){var performance=getBrowserPerformanceAPI();if(performance&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]){var inpCallback=_trackINP(interactionIdtoRouteNameMapping,interactionsSampleRate);return function(){inpCallback();};}return function(){return undefined;};}/** Starts tracking the Cumulative Layout Shift on the current page. */function _trackCLS(){return Object(__WEBPACK_IMPORTED_MODULE_3__instrument_js__["a" /* addClsInstrumentationHandler */])(function(_ref3){var metric=_ref3.metric;var entry=metric.entries[metric.entries.length-1];if(!entry){return;}__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Measurements] Adding CLS');_measurements['cls']={value:metric.value,unit:''};_clsEntry=entry;},true);}/** Starts tracking the Largest Contentful Paint on the current page. */function _trackLCP(){return Object(__WEBPACK_IMPORTED_MODULE_3__instrument_js__["d" /* addLcpInstrumentationHandler */])(function(_ref4){var metric=_ref4.metric;var entry=metric.entries[metric.entries.length-1];if(!entry){return;}__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Measurements] Adding LCP');_measurements['lcp']={value:metric.value,unit:'millisecond'};_lcpEntry=entry;},true);}/** Starts tracking the First Input Delay on the current page. */function _trackFID(){return Object(__WEBPACK_IMPORTED_MODULE_3__instrument_js__["b" /* addFidInstrumentationHandler */])(function(_ref5){var metric=_ref5.metric;var entry=metric.entries[metric.entries.length-1];if(!entry){return;}var timeOrigin=msToSec(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]);var startTime=msToSec(entry.startTime);__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Measurements] Adding FID');_measurements['fid']={value:metric.value,unit:'millisecond'};_measurements['mark.fid']={value:timeOrigin+startTime,unit:'second'};});}function _trackTtfb(){return Object(__WEBPACK_IMPORTED_MODULE_3__instrument_js__["f" /* addTtfbInstrumentationHandler */])(function(_ref6){var metric=_ref6.metric;var entry=metric.entries[metric.entries.length-1];if(!entry){return;}__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Measurements] Adding TTFB');_measurements['ttfb']={value:metric.value,unit:'millisecond'};});}var INP_ENTRY_MAP={click:'click',pointerdown:'click',pointerup:'click',mousedown:'click',mouseup:'click',touchstart:'click',touchend:'click',mouseover:'hover',mouseout:'hover',mouseenter:'hover',mouseleave:'hover',pointerover:'hover',pointerout:'hover',pointerenter:'hover',pointerleave:'hover',dragstart:'drag',dragend:'drag',drag:'drag',dragenter:'drag',dragleave:'drag',dragover:'drag',drop:'drag',keydown:'press',keyup:'press',keypress:'press',input:'press'};/** Starts tracking the Interaction to Next Paint on the current page. */function _trackINP(interactionIdToRouteNameMapping,interactionsSampleRate){return Object(__WEBPACK_IMPORTED_MODULE_3__instrument_js__["c" /* addInpInstrumentationHandler */])(function(_ref7){var metric=_ref7.metric;if(metric.value===undefined){return;}var entry=metric.entries.find(function(entry){return entry.duration===metric.value&&INP_ENTRY_MAP[entry.name]!==undefined;});var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])();if(!entry||!client){return;}var interactionType=INP_ENTRY_MAP[entry.name];var options=client.getOptions();/** Build the INP span, create an envelope from the span, and then send the envelope */var startTime=msToSec(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]+entry.startTime);var duration=msToSec(metric.value);var interaction=entry.interactionId!==undefined?interactionIdToRouteNameMapping[entry.interactionId]:undefined;if(interaction===undefined){return;}var routeName=interaction.routeName,parentContext=interaction.parentContext,activeTransaction=interaction.activeTransaction,user=interaction.user,replayId=interaction.replayId;var userDisplay=user!==undefined?user.email||user.id||user.ip_address:undefined;// eslint-disable-next-line deprecation/deprecation
var profileId=activeTransaction!==undefined?activeTransaction.getProfileId():undefined;var span=new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["n" /* Span */]({startTimestamp:startTime,endTimestamp:startTime+duration,op:"ui.interaction.".concat(interactionType),name:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_7" /* htmlTreeAsString */])(entry.target),attributes:_objectSpread({release:options.release,environment:options.environment,transaction:routeName},userDisplay!==undefined&&userDisplay!==''?{user:userDisplay}:{},{},profileId!==undefined?{profile_id:profileId}:{},{},replayId!==undefined?{replay_id:replayId}:{}),exclusiveTime:metric.value,measurements:{inp:{value:metric.value,unit:'millisecond'}}});/** Check to see if the span should be sampled */var sampleRate=getSampleRate(parentContext,options,interactionsSampleRate);if(!sampleRate){return;}if(Math.random()<sampleRate){var envelope=span?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["E" /* createSpanEnvelope */])([span],client.getDsn()):undefined;var transport=client&&client.getTransport();if(transport&&envelope){transport.send(envelope).then(null,function(reason){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].error('Error while sending interaction:',reason);});}return;}});}/** Add performance related spans to a transaction */function addPerformanceEntries(transaction){var performance=getBrowserPerformanceAPI();if(!performance||!__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* WINDOW */].performance.getEntries||!__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]){// Gatekeeper if performance API not available
return;}__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Tracing] Adding & adjusting spans using Performance API');var timeOrigin=msToSec(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]);var performanceEntries=performance.getEntries();var _spanToJSON=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_24" /* spanToJSON */])(transaction),op=_spanToJSON.op,transactionStartTime=_spanToJSON.start_timestamp;// eslint-disable-next-line @typescript-eslint/no-explicit-any
performanceEntries.slice(_performanceCursor).forEach(function(entry){var startTime=msToSec(entry.startTime);var duration=msToSec(entry.duration);// eslint-disable-next-line deprecation/deprecation
if(transaction.op==='navigation'&&transactionStartTime&&timeOrigin+startTime<transactionStartTime){return;}switch(entry.entryType){case'navigation':{_addNavigationSpans(transaction,entry,timeOrigin);break;}case'mark':case'paint':case'measure':{_addMeasureSpans(transaction,entry,startTime,duration,timeOrigin);// capture web vitals
var firstHidden=Object(__WEBPACK_IMPORTED_MODULE_5__web_vitals_lib_getVisibilityWatcher_js__["a" /* getVisibilityWatcher */])();// Only report if the page wasn't hidden prior to the web vital.
var shouldRecord=entry.startTime<firstHidden.firstHiddenTime;if(entry.name==='first-paint'&&shouldRecord){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Measurements] Adding FP');_measurements['fp']={value:entry.startTime,unit:'millisecond'};}if(entry.name==='first-contentful-paint'&&shouldRecord){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Measurements] Adding FCP');_measurements['fcp']={value:entry.startTime,unit:'millisecond'};}break;}case'resource':{_addResourceSpans(transaction,entry,entry.name,startTime,duration,timeOrigin);break;}// Ignore other entry types.
}});_performanceCursor=Math.max(performanceEntries.length-1,0);_trackNavigator(transaction);// Measurements are only available for pageload transactions
if(op==='pageload'){_addTtfbRequestTimeToMeasurements(_measurements);['fcp','fp','lcp'].forEach(function(name){if(!_measurements[name]||!transactionStartTime||timeOrigin>=transactionStartTime){return;}// The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
// Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
// to be adjusted to be relative to transaction.startTimestamp.
var oldValue=_measurements[name].value;var measurementTimestamp=timeOrigin+msToSec(oldValue);// normalizedValue should be in milliseconds
var normalizedValue=Math.abs((measurementTimestamp-transactionStartTime)*1000);var delta=normalizedValue-oldValue;__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Measurements] Normalized ".concat(name," from ").concat(oldValue," to ").concat(normalizedValue," (").concat(delta,")"));_measurements[name].value=normalizedValue;});var fidMark=_measurements['mark.fid'];if(fidMark&&_measurements['fid']){// create span for FID
Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["a" /* _startChild */])(transaction,{description:'first input delay',endTimestamp:fidMark.value+msToSec(_measurements['fid'].value),op:'ui.action',origin:'auto.ui.browser.metrics',startTimestamp:fidMark.value});// Delete mark.fid as we don't want it to be part of final payload
delete _measurements['mark.fid'];}// If FCP is not recorded we should not record the cls value
// according to the new definition of CLS.
if(!('fcp'in _measurements)){delete _measurements.cls;}Object.keys(_measurements).forEach(function(measurementName){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_19" /* setMeasurement */])(measurementName,_measurements[measurementName].value,_measurements[measurementName].unit);});_tagMetricInfo(transaction);}_lcpEntry=undefined;_clsEntry=undefined;_measurements={};}/** Create measure related spans */function _addMeasureSpans(transaction,// eslint-disable-next-line @typescript-eslint/no-explicit-any
entry,startTime,duration,timeOrigin){var measureStartTimestamp=timeOrigin+startTime;var measureEndTimestamp=measureStartTimestamp+duration;Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["a" /* _startChild */])(transaction,{description:entry.name,endTimestamp:measureEndTimestamp,op:entry.entryType,origin:'auto.resource.browser.metrics',startTimestamp:measureStartTimestamp});return measureStartTimestamp;}/** Instrument navigation entries */// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction,entry,timeOrigin){['unloadEvent','redirect','domContentLoadedEvent','loadEvent','connect'].forEach(function(event){_addPerformanceNavigationTiming(transaction,entry,event,timeOrigin);});_addPerformanceNavigationTiming(transaction,entry,'secureConnection',timeOrigin,'TLS/SSL','connectEnd');_addPerformanceNavigationTiming(transaction,entry,'fetch',timeOrigin,'cache','domainLookupStart');_addPerformanceNavigationTiming(transaction,entry,'domainLookup',timeOrigin,'DNS');_addRequest(transaction,entry,timeOrigin);}/** Create performance navigation related spans */function _addPerformanceNavigationTiming(transaction,// eslint-disable-next-line @typescript-eslint/no-explicit-any
entry,event,timeOrigin,description,eventEnd){var end=eventEnd?entry[eventEnd]:entry["".concat(event,"End")];var start=entry["".concat(event,"Start")];if(!start||!end){return;}Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["a" /* _startChild */])(transaction,{op:'browser',origin:'auto.browser.browser.metrics',description:description||event,startTimestamp:timeOrigin+msToSec(start),endTimestamp:timeOrigin+msToSec(end)});}/** Create request and response related spans */// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction,entry,timeOrigin){if(entry.responseEnd){// It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
// In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
// In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
// these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["a" /* _startChild */])(transaction,{op:'browser',origin:'auto.browser.browser.metrics',description:'request',startTimestamp:timeOrigin+msToSec(entry.requestStart),endTimestamp:timeOrigin+msToSec(entry.responseEnd)});Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["a" /* _startChild */])(transaction,{op:'browser',origin:'auto.browser.browser.metrics',description:'response',startTimestamp:timeOrigin+msToSec(entry.responseStart),endTimestamp:timeOrigin+msToSec(entry.responseEnd)});}}/** Create resource-related spans */function _addResourceSpans(transaction,entry,resourceUrl,startTime,duration,timeOrigin){// we already instrument based on fetch and xhr, so we don't need to
// duplicate spans here.
if(entry.initiatorType==='xmlhttprequest'||entry.initiatorType==='fetch'){return;}var parsedUrl=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_34" /* parseUrl */])(resourceUrl);// eslint-disable-next-line @typescript-eslint/no-explicit-any
var data={};setResourceEntrySizeData(data,entry,'transferSize','http.response_transfer_size');setResourceEntrySizeData(data,entry,'encodedBodySize','http.response_content_length');setResourceEntrySizeData(data,entry,'decodedBodySize','http.decoded_response_content_length');if('renderBlockingStatus'in entry){data['resource.render_blocking_status']=entry.renderBlockingStatus;}if(parsedUrl.protocol){data['url.scheme']=parsedUrl.protocol.split(':').pop();// the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
}if(parsedUrl.host){data['server.address']=parsedUrl.host;}data['url.same_origin']=resourceUrl.includes(__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* WINDOW */].location.origin);var startTimestamp=timeOrigin+startTime;var endTimestamp=startTimestamp+duration;Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["a" /* _startChild */])(transaction,{description:resourceUrl.replace(__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* WINDOW */].location.origin,''),endTimestamp:endTimestamp,op:entry.initiatorType?"resource.".concat(entry.initiatorType):'resource.other',origin:'auto.resource.browser.metrics',startTimestamp:startTimestamp,data:data});}/**
 * Capture the information of the user agent.
 */function _trackNavigator(transaction){var navigator=__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* WINDOW */].navigator;if(!navigator){return;}// track network connectivity
var connection=navigator.connection;if(connection){if(connection.effectiveType){// TODO: Can we rewrite this to an attribute?
// eslint-disable-next-line deprecation/deprecation
transaction.setTag('effectiveConnectionType',connection.effectiveType);}if(connection.type){// TODO: Can we rewrite this to an attribute?
// eslint-disable-next-line deprecation/deprecation
transaction.setTag('connectionType',connection.type);}if(Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["b" /* isMeasurementValue */])(connection.rtt)){_measurements['connection.rtt']={value:connection.rtt,unit:'millisecond'};}}if(Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["b" /* isMeasurementValue */])(navigator.deviceMemory)){// TODO: Can we rewrite this to an attribute?
// eslint-disable-next-line deprecation/deprecation
transaction.setTag('deviceMemory',"".concat(navigator.deviceMemory," GB"));}if(Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["b" /* isMeasurementValue */])(navigator.hardwareConcurrency)){// TODO: Can we rewrite this to an attribute?
// eslint-disable-next-line deprecation/deprecation
transaction.setTag('hardwareConcurrency',String(navigator.hardwareConcurrency));}}/** Add LCP / CLS data to transaction to allow debugging */function _tagMetricInfo(transaction){if(_lcpEntry){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Measurements] Adding LCP Data');// Capture Properties of the LCP element that contributes to the LCP.
if(_lcpEntry.element){// TODO: Can we rewrite this to an attribute?
// eslint-disable-next-line deprecation/deprecation
transaction.setTag('lcp.element',Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_7" /* htmlTreeAsString */])(_lcpEntry.element));}if(_lcpEntry.id){// TODO: Can we rewrite this to an attribute?
// eslint-disable-next-line deprecation/deprecation
transaction.setTag('lcp.id',_lcpEntry.id);}if(_lcpEntry.url){// Trim URL to the first 200 characters.
// TODO: Can we rewrite this to an attribute?
// eslint-disable-next-line deprecation/deprecation
transaction.setTag('lcp.url',_lcpEntry.url.trim().slice(0,200));}// TODO: Can we rewrite this to an attribute?
// eslint-disable-next-line deprecation/deprecation
transaction.setTag('lcp.size',_lcpEntry.size);}// See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
if(_clsEntry&&_clsEntry.sources){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Measurements] Adding CLS Data');_clsEntry.sources.forEach(function(source,index){return(// TODO: Can we rewrite this to an attribute?
// eslint-disable-next-line deprecation/deprecation
transaction.setTag("cls.source.".concat(index+1),Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_7" /* htmlTreeAsString */])(source.node)));});}}function setResourceEntrySizeData(data,entry,key,dataKey){var entryVal=entry[key];if(entryVal!=null&&entryVal<MAX_INT_AS_BYTES){data[dataKey]=entryVal;}}/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */function _addTtfbRequestTimeToMeasurements(_measurements){var navEntry=Object(__WEBPACK_IMPORTED_MODULE_7__web_vitals_lib_getNavigationEntry_js__["a" /* getNavigationEntry */])();if(!navEntry){return;}var responseStart=navEntry.responseStart,requestStart=navEntry.requestStart;if(requestStart<=responseStart){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Measurements] Adding TTFB Request Time');_measurements['ttfb.requestTime']={value:responseStart-requestStart,unit:'millisecond'};}}/** Taken from @sentry/core sampling.ts */function getSampleRate(transactionContext,options,interactionsSampleRate){if(!Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_0" /* hasTracingEnabled */])(options)){return false;}var sampleRate;if(transactionContext!==undefined&&typeof options.tracesSampler==='function'){sampleRate=options.tracesSampler({transactionContext:transactionContext,name:transactionContext.name,parentSampled:transactionContext.parentSampled,attributes:_objectSpread({},transactionContext.data,{},transactionContext.attributes),location:__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* WINDOW */].location});}else if(transactionContext!==undefined&&transactionContext.sampled!==undefined){sampleRate=transactionContext.sampled;}else if(typeof options.tracesSampleRate!=='undefined'){sampleRate=options.tracesSampleRate;}else{sampleRate=1;}if(!Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_5" /* isValidSampleRate */])(sampleRate)){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('[Tracing] Discarding interaction span because of invalid sample rate.');return false;}if(sampleRate===true){return interactionsSampleRate;}else if(sampleRate===false){return 0;}return sampleRate*interactionsSampleRate;}

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addTracingHeadersToFetchRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instrumentFetchRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */function instrumentFetchRequest(handlerData,shouldCreateSpan,shouldAttachHeaders,spans){var spanOrigin=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'auto.http.browser';if(!Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_0" /* hasTracingEnabled */])()||!handlerData.fetchData){return undefined;}var shouldCreateSpanResult=shouldCreateSpan(handlerData.fetchData.url);if(handlerData.endTimestamp&&shouldCreateSpanResult){var spanId=handlerData.fetchData.__span;if(!spanId)return;var _span=spans[spanId];if(_span){endSpan(_span,handlerData);// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
delete spans[spanId];}return undefined;}var scope=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["P" /* getCurrentScope */])();var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])();var _handlerData$fetchDat=handlerData.fetchData,method=_handlerData$fetchDat.method,url=_handlerData$fetchDat.url;var fullUrl=getFullURL(url);var host=fullUrl?Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_34" /* parseUrl */])(fullUrl).host:undefined;var span=shouldCreateSpanResult?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_27" /* startInactiveSpan */])({name:"".concat(method," ").concat(url),onlyIfParent:true,attributes:_defineProperty({url:url,type:'fetch','http.method':method,'http.url':fullUrl,'server.address':host},__WEBPACK_IMPORTED_MODULE_0__sentry_core__["j" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */],spanOrigin),op:'http.client'}):undefined;if(span){handlerData.fetchData.__span=span.spanContext().spanId;spans[span.spanContext().spanId]=span;}if(shouldAttachHeaders(handlerData.fetchData.url)&&client){var request=handlerData.args[0];// In case the user hasn't set the second argument of a fetch call we default it to `{}`.
handlerData.args[1]=handlerData.args[1]||{};// eslint-disable-next-line @typescript-eslint/no-explicit-any
var options=handlerData.args[1];// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
options.headers=addTracingHeadersToFetchRequest(request,client,scope,options,span);}return span;}/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */function addTracingHeadersToFetchRequest(request,// unknown is actually type Request but we can't export DOM types from this package,
client,scope,options,requestSpan){// eslint-disable-next-line deprecation/deprecation
var span=requestSpan||scope.getSpan();var isolationScope=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["V" /* getIsolationScope */])();var _isolationScope$getPr=_objectSpread({},isolationScope.getPropagationContext(),{},scope.getPropagationContext()),traceId=_isolationScope$getPr.traceId,spanId=_isolationScope$getPr.spanId,sampled=_isolationScope$getPr.sampled,dsc=_isolationScope$getPr.dsc;var sentryTraceHeader=span?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_25" /* spanToTraceHeader */])(span):Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["W" /* generateSentryTraceHeader */])(traceId,spanId,sampled);var sentryBaggageHeader=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["L" /* dynamicSamplingContextToSentryBaggageHeader */])(dsc||(span?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["R" /* getDynamicSamplingContextFromSpan */])(span):Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["Q" /* getDynamicSamplingContextFromClient */])(traceId,client,scope)));var headers=options.headers||(typeof Request!=='undefined'&&Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_14" /* isInstanceOf */])(request,Request)?request.headers:undefined);if(!headers){return{'sentry-trace':sentryTraceHeader,baggage:sentryBaggageHeader};}else if(typeof Headers!=='undefined'&&Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_14" /* isInstanceOf */])(headers,Headers)){var newHeaders=new Headers(headers);newHeaders.append('sentry-trace',sentryTraceHeader);if(sentryBaggageHeader){// If the same header is appended multiple times the browser will merge the values into a single request header.
// Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
newHeaders.append(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["a" /* BAGGAGE_HEADER_NAME */],sentryBaggageHeader);}return newHeaders;}else if(Array.isArray(headers)){var _newHeaders=[].concat(_toConsumableArray(headers),[['sentry-trace',sentryTraceHeader]]);if(sentryBaggageHeader){// If there are multiple entries with the same key, the browser will merge the values into a single request header.
// Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
_newHeaders.push([__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["a" /* BAGGAGE_HEADER_NAME */],sentryBaggageHeader]);}return _newHeaders;}else{var existingBaggageHeader='baggage'in headers?headers.baggage:undefined;var newBaggageHeaders=[];if(Array.isArray(existingBaggageHeader)){newBaggageHeaders.push.apply(newBaggageHeaders,_toConsumableArray(existingBaggageHeader));}else if(existingBaggageHeader){newBaggageHeaders.push(existingBaggageHeader);}if(sentryBaggageHeader){newBaggageHeaders.push(sentryBaggageHeader);}return _objectSpread({},headers,{'sentry-trace':sentryTraceHeader,baggage:newBaggageHeaders.length>0?newBaggageHeaders.join(','):undefined});}}function getFullURL(url){try{var parsed=new URL(url);return parsed.href;}catch(e){return undefined;}}function endSpan(span,handlerData){if(handlerData.response){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_18" /* setHttpStatus */])(span,handlerData.response.status);var contentLength=handlerData.response&&handlerData.response.headers&&handlerData.response.headers.get('content-length');if(contentLength){var contentLengthNum=parseInt(contentLength);if(contentLengthNum>0){span.setAttribute('http.response_content_length',contentLengthNum);}}}else if(handlerData.error){span.setStatus('internal_error');}span.end();}

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventbuilder_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__userfeedback_js__ = __webpack_require__(313);
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _get(target,property,receiver){if(typeof Reflect!=="undefined"&&Reflect.get){_get=Reflect.get;}else{_get=function _get(target,property,receiver){var base=_superPropBase(target,property);if(!base)return;var desc=Object.getOwnPropertyDescriptor(base,property);if(desc.get){return desc.get.call(receiver);}return desc.value;};}return _get(target,property,receiver||target);}function _superPropBase(object,property){while(!Object.prototype.hasOwnProperty.call(object,property)){object=_getPrototypeOf(object);if(object===null)break;}return object;}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 *//**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */var BrowserClient=/*#__PURE__*/function(_BaseClient){_inherits(BrowserClient,_BaseClient);/**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */function BrowserClient(options){var _this;_classCallCheck(this,BrowserClient);var sdkSource=__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].SENTRY_SDK_SOURCE||Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_5" /* getSDKSource */])();Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["u" /* applySdkMetadata */])(options,'browser',['browser'],sdkSource);_this=_possibleConstructorReturn(this,_getPrototypeOf(BrowserClient).call(this,options));if(options.sendClientReports&&__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].document){__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].document.addEventListener('visibilitychange',function(){if(__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].document.visibilityState==='hidden'){_this._flushOutcomes();}});}return _this;}/**
   * @inheritDoc
   */_createClass(BrowserClient,[{key:"eventFromException",value:function eventFromException(exception,hint){return Object(__WEBPACK_IMPORTED_MODULE_3__eventbuilder_js__["a" /* eventFromException */])(this._options.stackParser,exception,hint,this._options.attachStacktrace);}/**
   * @inheritDoc
   */},{key:"eventFromMessage",value:function eventFromMessage(message){var level=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'info';var hint=arguments.length>2?arguments[2]:undefined;return Object(__WEBPACK_IMPORTED_MODULE_3__eventbuilder_js__["b" /* eventFromMessage */])(this._options.stackParser,message,level,hint,this._options.attachStacktrace);}/**
   * Sends user feedback to Sentry.
   */},{key:"captureUserFeedback",value:function captureUserFeedback(feedback){if(!this._isEnabled()){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('SDK not enabled, will not capture user feedback.');return;}var envelope=Object(__WEBPACK_IMPORTED_MODULE_5__userfeedback_js__["a" /* createUserFeedbackEnvelope */])(feedback,{metadata:this.getSdkMetadata(),dsn:this.getDsn(),tunnel:this.getOptions().tunnel});// _sendEnvelope should not throw
// eslint-disable-next-line @typescript-eslint/no-floating-promises
this._sendEnvelope(envelope);}/**
   * @inheritDoc
   */},{key:"_prepareEvent",value:function _prepareEvent(event,hint,scope){event.platform=event.platform||'javascript';return _get(_getPrototypeOf(BrowserClient.prototype),"_prepareEvent",this).call(this,event,hint,scope);}/**
   * Sends client reports as an envelope.
   */},{key:"_flushOutcomes",value:function _flushOutcomes(){var outcomes=this._clearOutcomes();if(outcomes.length===0){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('No outcomes to send');return;}// This is really the only place where we want to check for a DSN and only send outcomes then
if(!this._dsn){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('No dsn provided, will not send outcomes');return;}__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('Sending outcomes:',outcomes);var envelope=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* createClientReportEnvelope */])(outcomes,this._options.tunnel&&Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["J" /* dsnToString */])(this._dsn));// _sendEnvelope should not throw
// eslint-disable-next-line @typescript-eslint/no-floating-promises
this._sendEnvelope(envelope);}}]);return BrowserClient;}(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["a" /* BaseClient */]);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createUserFeedbackEnvelope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Creates an envelope from a user feedback.
 */function createUserFeedbackEnvelope(feedback,_ref){var metadata=_ref.metadata,tunnel=_ref.tunnel,dsn=_ref.dsn;var headers=_objectSpread({event_id:feedback.event_id,sent_at:new Date().toISOString()},metadata&&metadata.sdk&&{sdk:{name:metadata.sdk.name,version:metadata.sdk.version}},{},!!tunnel&&!!dsn&&{dsn:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["J" /* dsnToString */])(dsn)});var item=createUserFeedbackEnvelopeItem(feedback);return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* createEnvelope */])(headers,[item]);}function createUserFeedbackEnvelopeItem(feedback){var feedbackHeaders={type:'user_report'};return[feedbackHeaders,feedback];}

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeFetchTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(677);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */function makeFetchTransport(options){var nativeFetch=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["b" /* getNativeFetchImplementation */])();var pendingBodySize=0;var pendingCount=0;function makeRequest(request){var requestSize=request.body.length;pendingBodySize+=requestSize;pendingCount++;var requestOptions=_objectSpread({body:request.body,method:'POST',referrerPolicy:'origin',headers:options.headers,// Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
// fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
// The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
// frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
// Gotchas:
// - `keepalive` isn't supported by Firefox
// - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
//   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
//   We will therefore only activate the flag when we're below that limit.
// There is also a limit of requests that can be open at the same time, so we also limit this to 15
// See https://github.com/getsentry/sentry-javascript/pull/7553 for details
keepalive:pendingBodySize<=60000&&pendingCount<15},options.fetchOptions);try{return nativeFetch(options.url,requestOptions).then(function(response){pendingBodySize-=requestSize;pendingCount--;return{statusCode:response.status,headers:{'x-sentry-rate-limits':response.headers.get('X-Sentry-Rate-Limits'),'retry-after':response.headers.get('Retry-After')}};});}catch(e){Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["a" /* clearCachedFetchImplementation */])();pendingBodySize-=requestSize;pendingCount--;return Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_36" /* rejectedSyncPromise */])(e);}}return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["F" /* createTransport */])(options,makeRequest);}

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeXHRTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */var XHR_READYSTATE_DONE=4;/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */function makeXHRTransport(options){function makeRequest(request){return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["f" /* SyncPromise */](function(resolve,reject){var xhr=new XMLHttpRequest();xhr.onerror=reject;xhr.onreadystatechange=function(){if(xhr.readyState===XHR_READYSTATE_DONE){resolve({statusCode:xhr.status,headers:{'x-sentry-rate-limits':xhr.getResponseHeader('X-Sentry-Rate-Limits'),'retry-after':xhr.getResponseHeader('Retry-After')}});}};xhr.open('POST',options.url);for(var header in options.headers){if(Object.prototype.hasOwnProperty.call(options.headers,header)){xhr.setRequestHeader(header,options.headers[header]);}}xhr.send(request.body);});}return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["F" /* createTransport */])(options,makeRequest);}

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chromeStackLineParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultStackLineParsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultStackParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return geckoStackLineParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return opera10StackLineParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return opera11StackLineParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return winjsStackLineParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}// global reference to slice
var UNKNOWN_FUNCTION='?';var OPERA10_PRIORITY=10;var OPERA11_PRIORITY=20;var CHROME_PRIORITY=30;var WINJS_PRIORITY=40;var GECKO_PRIORITY=50;function createFrame(filename,func,lineno,colno){var frame={filename:filename,function:func,in_app:true// All browser frames are considered in_app
};if(lineno!==undefined){frame.lineno=lineno;}if(colno!==undefined){frame.colno=colno;}return frame;}// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex=/^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;var chromeEvalRegex=/\((\S*)(?::(\d+))(?::(\d+))\)/;// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
var chromeStackParserFn=function chromeStackParserFn(line){var parts=chromeRegex.exec(line);if(parts){var isEval=parts[2]&&parts[2].indexOf('eval')===0;// start of line
if(isEval){var subMatch=chromeEvalRegex.exec(parts[2]);if(subMatch){// throw out eval line/column and use top-most line/column number
parts[2]=subMatch[1];// url
parts[3]=subMatch[2];// line
parts[4]=subMatch[3];// column
}}// Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
// would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
var _extractSafariExtensi=extractSafariExtensionDetails(parts[1]||UNKNOWN_FUNCTION,parts[2]),_extractSafariExtensi2=_slicedToArray(_extractSafariExtensi,2),func=_extractSafariExtensi2[0],filename=_extractSafariExtensi2[1];return createFrame(filename,func,parts[3]?+parts[3]:undefined,parts[4]?+parts[4]:undefined);}return;};var chromeStackLineParser=[CHROME_PRIORITY,chromeStackParserFn];// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex=/^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;var geckoEvalRegex=/(\S+) line (\d+)(?: > eval line \d+)* > eval/i;var gecko=function gecko(line){var parts=geckoREgex.exec(line);if(parts){var isEval=parts[3]&&parts[3].indexOf(' > eval')>-1;if(isEval){var subMatch=geckoEvalRegex.exec(parts[3]);if(subMatch){// throw out eval line/column and use top-most line number
parts[1]=parts[1]||'eval';parts[3]=subMatch[1];parts[4]=subMatch[2];parts[5]='';// no column when eval
}}var filename=parts[3];var func=parts[1]||UNKNOWN_FUNCTION;var _extractSafariExtensi3=extractSafariExtensionDetails(func,filename);var _extractSafariExtensi4=_slicedToArray(_extractSafariExtensi3,2);func=_extractSafariExtensi4[0];filename=_extractSafariExtensi4[1];return createFrame(filename,func,parts[4]?+parts[4]:undefined,parts[5]?+parts[5]:undefined);}return;};var geckoStackLineParser=[GECKO_PRIORITY,gecko];var winjsRegex=/^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;var winjs=function winjs(line){var parts=winjsRegex.exec(line);return parts?createFrame(parts[2],parts[1]||UNKNOWN_FUNCTION,+parts[3],parts[4]?+parts[4]:undefined):undefined;};var winjsStackLineParser=[WINJS_PRIORITY,winjs];var opera10Regex=/ line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;var opera10=function opera10(line){var parts=opera10Regex.exec(line);return parts?createFrame(parts[2],parts[3]||UNKNOWN_FUNCTION,+parts[1]):undefined;};var opera10StackLineParser=[OPERA10_PRIORITY,opera10];var opera11Regex=/ line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;var opera11=function opera11(line){var parts=opera11Regex.exec(line);return parts?createFrame(parts[5],parts[3]||parts[4]||UNKNOWN_FUNCTION,+parts[1],+parts[2]):undefined;};var opera11StackLineParser=[OPERA11_PRIORITY,opera11];var defaultStackLineParsers=[chromeStackLineParser,geckoStackLineParser,winjsStackLineParser];var defaultStackParser=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["F" /* createStackParser */].apply(void 0,defaultStackLineParsers);/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */var extractSafariExtensionDetails=function extractSafariExtensionDetails(func,filename){var isSafariExtension=func.indexOf('safari-extension')!==-1;var isSafariWebExtension=func.indexOf('safari-web-extension')!==-1;return isSafariExtension||isSafariWebExtension?[func.indexOf('@')!==-1?func.split('@')[0]:UNKNOWN_FUNCTION,isSafariExtension?"safari-extension:".concat(filename):"safari-web-extension:".concat(filename)]:[func,filename];};

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onProfilingStartRouteTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return startProfileForTransaction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_js__ = __webpack_require__(318);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}/* eslint-disable complexity *//**
 * Safety wrapper for startTransaction for the unlikely case that transaction starts before tracing is imported -
 * if that happens we want to avoid throwing an error from profiling code.
 * see https://github.com/getsentry/sentry-javascript/issues/4731.
 *
 * @experimental
 */function onProfilingStartRouteTransaction(transaction){if(!transaction){if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] Transaction is undefined, skipping profiling');}return transaction;}if(Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["h" /* shouldProfileTransaction */])(transaction)){return startProfileForTransaction(transaction);}return transaction;}/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */function startProfileForTransaction(transaction){// Start the profiler and get the profiler instance.
var startTimestamp;if(Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["g" /* isAutomatedPageLoadTransaction */])(transaction)){startTimestamp=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_48" /* timestampInSeconds */])()*1000;}var profiler=Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["i" /* startJSSelfProfile */])();// We failed to construct the profiler, fallback to original transaction.
// No need to log anything as this has already been logged in startProfile.
if(!profiler){return transaction;}if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Profiling] started profiling transaction: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_24" /* spanToJSON */])(transaction).description));}// We create "unique" transaction names to avoid concurrent transactions with same names
// from being ignored by the profiler. From here on, only this transaction name should be used when
// calling the profiler methods. Note: we log the original name to the user to avoid confusion.
var profileId=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_53" /* uuid4 */])();/**
   * Idempotent handler for profile stop
   */function onProfileHandler(){return _onProfileHandler.apply(this,arguments);}// Enqueue a timeout to prevent profiles from running over max duration.
function _onProfileHandler(){_onProfileHandler=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(transaction){_context.next=2;break;}return _context.abrupt("return",null);case 2:if(profiler){_context.next=4;break;}return _context.abrupt("return",null);case 4:return _context.abrupt("return",profiler.stop().then(function(profile){if(maxDurationTimeoutID){__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].clearTimeout(maxDurationTimeoutID);maxDurationTimeoutID=undefined;}if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Profiling] stopped profiling of transaction: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_24" /* spanToJSON */])(transaction).description));}// In case of an overlapping transaction, stopProfiling may return null and silently ignore the overlapping profile.
if(!profile){if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Profiling] profiler returned null profile for: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_24" /* spanToJSON */])(transaction).description),'this may indicate an overlapping transaction or a call to stopProfiling with a profile title that was never started');}return null;}Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["b" /* addProfileToGlobalCache */])(profileId,profile);return null;}).catch(function(error){if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] error while stopping profiler:',error);}return null;}));case 5:case"end":return _context.stop();}}},_callee);}));return _onProfileHandler.apply(this,arguments);}var maxDurationTimeoutID=__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].setTimeout(function(){if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] max profile duration elapsed, stopping profiling for:',Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_24" /* spanToJSON */])(transaction).description);}// If the timeout exceeds, we want to stop profiling, but not finish the transaction
// eslint-disable-next-line @typescript-eslint/no-floating-promises
onProfileHandler();},__WEBPACK_IMPORTED_MODULE_4__utils_js__["a" /* MAX_PROFILE_DURATION_MS */]);// We need to reference the original end call to avoid creating an infinite loop
var originalEnd=transaction.end.bind(transaction);/**
   * Wraps startTransaction and stopTransaction with profiling related logic.
   * startProfiling is called after the call to startTransaction in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
   */function profilingWrappedTransactionEnd(){if(!transaction){return originalEnd();}// onProfileHandler should always return the same profile even if this is called multiple times.
// Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
void onProfileHandler().then(function(){// TODO: Can we rewrite this to use attributes?
// eslint-disable-next-line deprecation/deprecation
transaction.setContext('profile',{profile_id:profileId,start_timestamp:startTimestamp});originalEnd();},function(){// If onProfileHandler fails, we still want to call the original finish method.
originalEnd();});return transaction;}transaction.end=profilingWrappedTransactionEnd;return transaction;}

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_PROFILE_DURATION_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addProfileToGlobalCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addProfilesToEnvelope; });
/* unused harmony export applyDebugMetadata */
/* unused harmony export convertJSSelfProfileToSampledFormat */
/* unused harmony export createProfilePayload */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createProfilingEvent; });
/* unused harmony export enrichWithThreadInformation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return findProfiledTransactionsFromEnvelope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getActiveProfilesCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isAutomatedPageLoadTransaction; });
/* unused harmony export isValidSampleRate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return shouldProfileTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return startJSSelfProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return takeProfileFromGlobalCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_js__ = __webpack_require__(38);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}/* eslint-disable max-lines */var MS_TO_NS=1e6;// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
var THREAD_ID_STRING=String(0);var THREAD_NAME='main';// Machine properties (eval only once)
var OS_PLATFORM='';var OS_PLATFORM_VERSION='';var OS_ARCH='';var OS_BROWSER=__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].navigator&&__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].navigator.userAgent||'';var OS_MODEL='';var OS_LOCALE=__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].navigator&&__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].navigator.language||__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].navigator&&__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].navigator.languages&&__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].navigator.languages[0]||'';function isUserAgentData(data){return _typeof(data)==='object'&&data!==null&&'getHighEntropyValues'in data;}// @ts-expect-error userAgentData is not part of the navigator interface yet
var userAgentData=__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].navigator&&__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].navigator.userAgentData;if(isUserAgentData(userAgentData)){userAgentData.getHighEntropyValues(['architecture','model','platform','platformVersion','fullVersionList']).then(function(ua){OS_PLATFORM=ua.platform||'';OS_ARCH=ua.architecture||'';OS_MODEL=ua.model||'';OS_PLATFORM_VERSION=ua.platformVersion||'';if(ua.fullVersionList&&ua.fullVersionList.length>0){var firstUa=ua.fullVersionList[ua.fullVersionList.length-1];OS_BROWSER="".concat(firstUa.brand," ").concat(firstUa.version);}}).catch(function(e){return void e;});}function isProcessedJSSelfProfile(profile){return!('thread_metadata'in profile);}// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */function enrichWithThreadInformation(profile){if(!isProcessedJSSelfProfile(profile)){return profile;}return convertJSSelfProfileToSampledFormat(profile);}// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function getTraceId(event){var traceId=event&&event.contexts&&event.contexts['trace']&&event.contexts['trace']['trace_id'];// Log a warning if the profile has an invalid traceId (should be uuidv4).
// All profiles and transactions are rejected if this is the case and we want to
// warn users that this is happening if they enable debug flag
if(typeof traceId==='string'&&traceId.length!==32){if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Profiling] Invalid traceId: ".concat(traceId," on profiled event"));}}if(typeof traceId!=='string'){return'';}return traceId;}/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 *//**
 * Creates a profiling event envelope from a Sentry event.
 */function createProfilePayload(profile_id,start_timestamp,processed_profile,event){if(event.type!=='transaction'){// createProfilingEventEnvelope should only be called for transactions,
// we type guard this behavior with isProfiledTransactionEvent.
throw new TypeError('Profiling events may only be attached to transactions, this should never occur.');}if(processed_profile===undefined||processed_profile===null){throw new TypeError("Cannot construct profiling event envelope without a valid profile. Got ".concat(processed_profile," instead."));}var traceId=getTraceId(event);var enrichedThreadProfile=enrichWithThreadInformation(processed_profile);var transactionStartMs=start_timestamp?start_timestamp:typeof event.start_timestamp==='number'?event.start_timestamp*1000:Date.now();var transactionEndMs=typeof event.timestamp==='number'?event.timestamp*1000:Date.now();var profile={event_id:profile_id,timestamp:new Date(transactionStartMs).toISOString(),platform:'javascript',version:'1',release:event.release||'',environment:event.environment||__WEBPACK_IMPORTED_MODULE_0__sentry_core__["b" /* DEFAULT_ENVIRONMENT */],runtime:{name:'javascript',version:__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].navigator.userAgent},os:{name:OS_PLATFORM,version:OS_PLATFORM_VERSION,build_number:OS_BROWSER},device:{locale:OS_LOCALE,model:OS_MODEL,manufacturer:OS_BROWSER,architecture:OS_ARCH,is_emulator:false},debug_meta:{images:applyDebugMetadata(processed_profile.resources)},profile:enrichedThreadProfile,transactions:[{name:event.transaction||'',id:event.event_id||Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_53" /* uuid4 */])(),trace_id:traceId,active_thread_id:THREAD_ID_STRING,relative_start_ns:'0',relative_end_ns:((transactionEndMs-transactionStartMs)*1e6).toFixed(0)}]};return profile;}/*
  See packages/tracing-internal/src/browser/router.ts
*//**
 *
 */function isAutomatedPageLoadTransaction(transaction){return transaction.op==='pageload';}/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */function convertJSSelfProfileToSampledFormat(input){var EMPTY_STACK_ID=undefined;var STACK_ID=0;// Initialize the profile that we will fill with data
var profile={samples:[],stacks:[],frames:[],thread_metadata:_defineProperty({},THREAD_ID_STRING,{name:THREAD_NAME})};if(!input.samples.length){return profile;}// We assert samples.length > 0 above and timestamp should always be present
var start=input.samples[0].timestamp;// The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
// when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
// Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
// the drift between the SDK selected value and our profile time origin.
var origin=typeof performance.timeOrigin==='number'?performance.timeOrigin:__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]||0;var adjustForOriginChange=origin-(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]||origin);for(var i=0;i<input.samples.length;i++){var jsSample=input.samples[i];// If sample has no stack, add an empty sample
if(jsSample.stackId===undefined){if(EMPTY_STACK_ID===undefined){EMPTY_STACK_ID=STACK_ID;profile.stacks[EMPTY_STACK_ID]=[];STACK_ID++;}profile['samples'][i]={// convert ms timestamp to ns
elapsed_since_start_ns:((jsSample.timestamp+adjustForOriginChange-start)*MS_TO_NS).toFixed(0),stack_id:EMPTY_STACK_ID,thread_id:THREAD_ID_STRING};continue;}var stackTop=input.stacks[jsSample.stackId];// Functions in top->down order (root is last)
// We follow the stackTop.parentId trail and collect each visited frameId
var stack=[];while(stackTop){stack.push(stackTop.frameId);var frame=input.frames[stackTop.frameId];// If our frame has not been indexed yet, index it
if(profile.frames[stackTop.frameId]===undefined){profile.frames[stackTop.frameId]={function:frame.name,abs_path:typeof frame.resourceId==='number'?input.resources[frame.resourceId]:undefined,lineno:frame.line,colno:frame.column};}stackTop=stackTop.parentId===undefined?undefined:input.stacks[stackTop.parentId];}var sample={// convert ms timestamp to ns
elapsed_since_start_ns:((jsSample.timestamp+adjustForOriginChange-start)*MS_TO_NS).toFixed(0),stack_id:STACK_ID,thread_id:THREAD_ID_STRING};profile['stacks'][STACK_ID]=stack;profile['samples'][i]=sample;STACK_ID++;}return profile;}/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */function addProfilesToEnvelope(envelope,profiles){if(!profiles.length){return envelope;}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=profiles[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var profile=_step.value;envelope[1].push([{type:'profile'},profile]);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return envelope;}/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */function findProfiledTransactionsFromEnvelope(envelope){var events=[];Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["V" /* forEachEnvelopeItem */])(envelope,function(item,type){if(type!=='transaction'){return;}for(var j=1;j<item.length;j++){var event=item[j];if(event&&event.contexts&&event.contexts['profile']&&event.contexts['profile']['profile_id']){events.push(item[j]);}}});return events;}var debugIdStackParserCache=new WeakMap();/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */function applyDebugMetadata(resource_paths){var debugIdMap=__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* GLOBAL_OBJ */]._sentryDebugIds;if(!debugIdMap){return[];}var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])();var options=client&&client.getOptions();var stackParser=options&&options.stackParser;if(!stackParser){return[];}var debugIdStackFramesCache;var cachedDebugIdStackFrameCache=debugIdStackParserCache.get(stackParser);if(cachedDebugIdStackFrameCache){debugIdStackFramesCache=cachedDebugIdStackFrameCache;}else{debugIdStackFramesCache=new Map();debugIdStackParserCache.set(stackParser,debugIdStackFramesCache);}// Build a map of filename -> debug_id
var filenameDebugIdMap=Object.keys(debugIdMap).reduce(function(acc,debugIdStackTrace){var parsedStack;var cachedParsedStack=debugIdStackFramesCache.get(debugIdStackTrace);if(cachedParsedStack){parsedStack=cachedParsedStack;}else{parsedStack=stackParser(debugIdStackTrace);debugIdStackFramesCache.set(debugIdStackTrace,parsedStack);}for(var i=parsedStack.length-1;i>=0;i--){var stackFrame=parsedStack[i];var file=stackFrame&&stackFrame.filename;if(stackFrame&&file){acc[file]=debugIdMap[debugIdStackTrace];break;}}return acc;},{});var images=[];var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=resource_paths[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var path=_step2.value;if(path&&filenameDebugIdMap[path]){images.push({type:'sourcemap',code_file:path,debug_id:filenameDebugIdMap[path]});}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return!=null){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return images;}/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */function isValidSampleRate(rate){// we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
if(typeof rate!=='number'&&typeof rate!=='boolean'||typeof rate==='number'&&isNaN(rate)){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn("[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ".concat(JSON.stringify(rate)," of type ").concat(JSON.stringify(_typeof(rate)),"."));return false;}// Boolean sample rates are always valid
if(rate===true||rate===false){return true;}// in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
if(rate<0||rate>1){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn("[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ".concat(rate,"."));return false;}return true;}function isValidProfile(profile){if(profile.samples.length<2){if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){// Log a warning if the profile has less than 2 samples so users can know why
// they are not seeing any profiling data and we cant avoid the back and forth
// of asking them to provide us with a dump of the profile data.
__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] Discarding profile because it contains less than 2 samples');}return false;}if(!profile.frames.length){if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] Discarding profile because it contains no frames');}return false;}return true;}// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
var PROFILING_CONSTRUCTOR_FAILED=false;var MAX_PROFILE_DURATION_MS=30000;/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */function isJSProfilerSupported(maybeProfiler){return typeof maybeProfiler==='function';}/**
 * Starts the profiler and returns the profiler instance.
 */function startJSSelfProfile(){// Feature support check first
var JSProfilerConstructor=__WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* WINDOW */].Profiler;if(!isJSProfilerSupported(JSProfilerConstructor)){if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.');}return;}// From initial testing, it seems that the minimum value for sampleInterval is 10ms.
var samplingIntervalMS=10;// Start the profiler
var maxSamples=Math.floor(MAX_PROFILE_DURATION_MS/samplingIntervalMS);// Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
// This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
// as we risk breaking the user's application, so just disable profiling and log an error.
try{return new JSProfilerConstructor({sampleInterval:samplingIntervalMS,maxBufferSize:maxSamples});}catch(e){if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] Disabling profiling for current user session.');}PROFILING_CONSTRUCTOR_FAILED=true;}return;}/**
 * Determine if a profile should be profiled.
 */function shouldProfileTransaction(transaction){// If constructor failed once, it will always fail, so we can early return.
if(PROFILING_CONSTRUCTOR_FAILED){if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] Profiling has been disabled for the duration of the current user session.');}return false;}if(!transaction.isRecording()){if(__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] Discarding profile because transaction was not sampled.');}return false;}var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])();var options=client&&client.getOptions();if(!options){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] Profiling disabled, no options found.');return false;}// @ts-expect-error profilesSampleRate is not part of the browser options yet
var profilesSampleRate=options.profilesSampleRate;// Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
// only valid values are booleans or numbers between 0 and 1.)
if(!isValidSampleRate(profilesSampleRate)){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('[Profiling] Discarding profile because of invalid sample rate.');return false;}// if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
if(!profilesSampleRate){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0');return false;}// Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
// a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
var sampled=profilesSampleRate===true?true:Math.random()<profilesSampleRate;// Check if we should sample this profile
if(!sampled){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ".concat(Number(profilesSampleRate),")"));return false;}return true;}/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */function createProfilingEvent(profile_id,start_timestamp,profile,event){if(!isValidProfile(profile)){return null;}return createProfilePayload(profile_id,start_timestamp,profile,event);}// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependancy. We need to resolve this in v8.
var PROFILE_MAP=new Map();/**
 *
 */function getActiveProfilesCount(){return PROFILE_MAP.size;}/**
 * Retrieves profile from global cache and removes it.
 */function takeProfileFromGlobalCache(profile_id){var profile=PROFILE_MAP.get(profile_id);if(profile){PROFILE_MAP.delete(profile_id);}return profile;}/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */function addProfileToGlobalCache(profile_id,profile){PROFILE_MAP.set(profile_id,profile);if(PROFILE_MAP.size>30){var last=PROFILE_MAP.keys().next().value;PROFILE_MAP.delete(last);}}

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEBUG_BUILD; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */var DEBUG_BUILD=typeof __SENTRY_DEBUG__==='undefined'||__SENTRY_DEBUG__;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.clone = clone;
exports.defaults = defaults;
exports.forEach = forEach;
function clone(_ref) {
  var title = _ref.title,
      description = _ref.description,
      base = _ref.base,
      canonical = _ref.canonical,
      meta = _ref.meta,
      link = _ref.link,
      auto = _ref.auto;

  try {
    return JSON.parse(JSON.stringify({ title: title, description: description, base: base, canonical: canonical, meta: meta, link: link, auto: auto }));
  } catch (x) {
    return {};
  }
}

function defaults(target, source) {
  return Object.keys(source).reduce(function (acc, key) {
    if (!target.hasOwnProperty(key)) {
      target[key] = source[key];
    } else if (_typeof(target[key]) === 'object' && !Array.isArray(target[key]) && target[key]) {
      defaults(target[key], source[key]);
    }

    return target;
  }, target);
}

// This is needed as not all browsers,
// including Edge and IE has not implemented .forEach() on NodeList
function forEach(nodes, fn) {
  if (nodes && nodes.length) {
    Array.prototype.slice.call(nodes).forEach(fn);
  }
}


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_I18nContext__ = __webpack_require__(6);
var LanguageSwitcher=function LanguageSwitcher(_ref){var _ref$className=_ref.className,className=_ref$className===void 0?'':_ref$className,_ref$variant=_ref.variant,variant=_ref$variant===void 0?'default':_ref$variant;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_1_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t,locale=_useI18n.locale,switchLocale=_useI18n.switchLocale;var rootClass=['gb-lang',variant==='onDark'?'gb-lang--on-dark':'gb-lang--default',className].filter(Boolean).join(' ');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:rootClass,role:"group","aria-label":t('footer.language')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:locale==='en'?'gb-lang__btn is-active':'gb-lang__btn',onClick:function onClick(){return switchLocale('en');},"aria-pressed":locale==='en'},"EN"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:locale==='nl'?'gb-lang__btn is-active':'gb-lang__btn',onClick:function onClick(){return switchLocale('nl');},"aria-pressed":locale==='nl'},"NL"));};/* harmony default export */ __webpack_exports__["a"] = (LanguageSwitcher);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDashboardUrl;
/** Web dashboard / manager login URL (separate from this marketing site). */function getDashboardUrl(){return Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SENTRY_DSN":"https://27a1e003a249b09583f1b35346a157be@o4506479248474112.ingest.us.sentry.io/4511757032161280"}).REACT_APP_DASHBOARD_URL||'https://manager.gastrobuddy.nl';}

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_static_images_logo_png__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_static_images_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_static_images_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_static_images_logo_2x_png__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_static_images_logo_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_static_images_logo_2x_png__);
var Logo=function Logo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{to:"/",className:"gb-logo-link"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_2_static_images_logo_png___default.a,srcSet:"".concat(__WEBPACK_IMPORTED_MODULE_3_static_images_logo_2x_png___default.a," 2x"),alt:"GastroBuddy"}));};/* harmony default export */ __webpack_exports__["a"] = (Logo);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo@2x.a6cefff3.png";

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return eyeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return tabletIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return quickerIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cashregisterIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dishIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MEPIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return tasklistIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return whiteboardIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eye_png__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eye_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__eye_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eye_2x_png__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eye_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__eye_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tablet_png__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tablet_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tablet_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tablet_2x_png__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tablet_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tablet_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__quicker_png__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__quicker_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__quicker_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__quicker_2x_png__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__quicker_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__quicker_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cashregister_png__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cashregister_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__cashregister_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cashregister_2x_png__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cashregister_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__cashregister_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dish_png__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dish_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__dish_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dish_2x_png__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dish_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__dish_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MEP_png__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MEP_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__MEP_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MEP_2x_png__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MEP_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__MEP_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__tasklist_png__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__tasklist_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__tasklist_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tasklist_2x_png__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tasklist_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__tasklist_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__whiteboard_png__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__whiteboard_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__whiteboard_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__whiteboard_2x_png__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__whiteboard_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__whiteboard_2x_png__);
function imgElement(icon,icon2x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:icon,srcSet:"".concat(icon2x," 2x"),alt:""});}var eyeIcon=imgElement(__WEBPACK_IMPORTED_MODULE_1__eye_png___default.a,__WEBPACK_IMPORTED_MODULE_2__eye_2x_png___default.a);var tabletIcon=imgElement(__WEBPACK_IMPORTED_MODULE_3__tablet_png___default.a,__WEBPACK_IMPORTED_MODULE_4__tablet_2x_png___default.a);var quickerIcon=imgElement(__WEBPACK_IMPORTED_MODULE_5__quicker_png___default.a,__WEBPACK_IMPORTED_MODULE_6__quicker_2x_png___default.a);var cashregisterIcon=imgElement(__WEBPACK_IMPORTED_MODULE_7__cashregister_png___default.a,__WEBPACK_IMPORTED_MODULE_8__cashregister_2x_png___default.a);var dishIcon=imgElement(__WEBPACK_IMPORTED_MODULE_9__dish_png___default.a,__WEBPACK_IMPORTED_MODULE_10__dish_2x_png___default.a);var MEPIcon=imgElement(__WEBPACK_IMPORTED_MODULE_11__MEP_png___default.a,__WEBPACK_IMPORTED_MODULE_12__MEP_2x_png___default.a);var tasklistIcon=imgElement(__WEBPACK_IMPORTED_MODULE_13__tasklist_png___default.a,__WEBPACK_IMPORTED_MODULE_14__tasklist_2x_png___default.a);var whiteboardIcon=imgElement(__WEBPACK_IMPORTED_MODULE_15__whiteboard_png___default.a,__WEBPACK_IMPORTED_MODULE_16__whiteboard_2x_png___default.a);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_yup__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_yup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Input__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__ = __webpack_require__(6);
var AccountForm=function AccountForm(_ref){var _tProp;var errors=_ref.errors,tProp=_ref.t,onGoogleClick=_ref.onGoogleClick,_ref$googleEnabled=_ref.googleEnabled,googleEnabled=_ref$googleEnabled===void 0?false:_ref$googleEnabled,_ref$googleLoading=_ref.googleLoading,googleLoading=_ref$googleLoading===void 0?false:_ref$googleLoading;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__["b" /* useI18n */])(),tCtx=_useI18n.t;var t=(_tProp=tProp)!==null&&_tProp!==void 0?_tProp:tCtx;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-step"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header",{className:"gb-onboard-intro"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"gb-onboard-panel__title"},t('forms.signupTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"gb-onboard-panel__lede"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,t('forms.signupBullet1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,t('forms.signupBullet2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,t('forms.signupBullet3')))),googleEnabled&&onGoogleClick?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-oauth"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"gb-onboard-oauth__google",onClick:onGoogleClick,disabled:googleLoading},googleLoading?t('forms.googleContinueLoading'):t('forms.googleContinue')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-onboard-oauth__divider"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,t('forms.orEmail')))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-fields"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Input__["a" /* default */],{label:t('forms.fullName'),type:"text",name:"name",autoComplete:"name",error:errors===null||errors===void 0?void 0:errors.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Input__["a" /* default */],{label:t('forms.email'),type:"email",name:"email",autoComplete:"email",inputMode:"email",error:errors===null||errors===void 0?void 0:errors.email})));};function validationSchema(_values,t){return __WEBPACK_IMPORTED_MODULE_1_yup__["object"]().shape({name:__WEBPACK_IMPORTED_MODULE_1_yup__["string"]().required(t('forms.valNameRequired')),email:__WEBPACK_IMPORTED_MODULE_1_yup__["string"]().required(t('forms.valEmailRequired')).email(t('forms.valEmailInvalid'))});}var AccountFormExport=AccountForm;AccountFormExport.validationSchema=validationSchema;/* harmony default export */ __webpack_exports__["a"] = (AccountFormExport);

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(328),
    isArguments = __webpack_require__(333),
    isArray = __webpack_require__(45),
    isIndex = __webpack_require__(334),
    isLength = __webpack_require__(224),
    toKey = __webpack_require__(148);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(45),
    isKey = __webpack_require__(219),
    stringToPath = __webpack_require__(755),
    toString = __webpack_require__(111);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(89),
    isObject = __webpack_require__(91);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 332 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(780),
    isObjectLike = __webpack_require__(61);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(149),
    eq = __webpack_require__(222);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(791),
    isArguments = __webpack_require__(333),
    isArray = __webpack_require__(45),
    isBuffer = __webpack_require__(226),
    isIndex = __webpack_require__(334),
    isTypedArray = __webpack_require__(337);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(793),
    baseUnary = __webpack_require__(228),
    nodeUtil = __webpack_require__(229);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 338 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(336),
    baseKeysIn = __webpack_require__(797),
    isArrayLike = __webpack_require__(231);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(343),
    getPrototype = __webpack_require__(344),
    getSymbols = __webpack_require__(232),
    stubArray = __webpack_require__(341);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(338);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(346),
    getSymbols = __webpack_require__(232),
    keys = __webpack_require__(92);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(343),
    isArray = __webpack_require__(45);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(46);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(823),
    hasUnicode = __webpack_require__(351),
    unicodeToArray = __webpack_require__(824);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function argumentsToArray(args) {
  return Array.prototype.slice.apply(args);
}

function looksLikePromise(thing) {
  return thing &&
    thing.then &&
    typeof (thing.then) === "function" &&
    typeof (thing.catch) === "function";
}

function SynchronousPromise(ctorFunction) {
  this.status = "pending";
  this._paused = false;
  this._next = [];
  this._data = [];
  this._runConstructorFunction(ctorFunction);
}

SynchronousPromise.prototype = {
  then: function (next, fail) {
    this._next.push([next, fail]);

    if (this._isPendingResolutionOrRejection()) {
      return this;
    }

    return this._applyNext();
  },
  catch: function (fn) {
    this._next.push([undefined, fn]);

    if (this._isPendingResolutionOrRejection()) {
      return this;
    }

    return this._applyNext();
  },
  pause: function () {
    this._paused = true;
    return this;
  },
  resume: function () {
    this._paused = false;
    return this._applyNext();
  },
  _runConstructorFunction: function (ctorFunction) {
    var self = this;

    this._next.push([
      function (r) { return r; },
      function (err) { throw err; }
    ]);

    var isRun = false;
    ctorFunction(function (result) {
      if (isRun) {
        return;
      }

      isRun = true;
      self._setResolved();
      self._data = [result];
      self._applyNext();
    }, function (err) {
      if (isRun) {
        return;
      }

      isRun = true;
      self._setRejected();
      self._data = [err];
      self._applyNext();
    });
  },
  _setRejected: function () {
    this.status = "rejected";
  },
  _setResolved: function () {
    this.status = "resolved";
  },
  _setPending: function () {
    this.status = "pending";
  },
  _applyNext: function () {
    if (this._next.length === 0 || this._paused) {
      return this;
    }

    var next = this._findNext();
    if (!next) {
      return this;
    }
    return this._applyNextHandler(next);
  },
  _applyNextHandler: function (handler) {
    try {
      var data = handler.apply(null, this._data);

      if (looksLikePromise(data)) {
        this._handleNestedPromise(data);
        return this;
      }

      this._setResolved();
      this._data = [data];
      return this._applyNext();
    } catch (e) {
      this._setRejected();
      this._data = [e];
      return this._applyNext();
    }
  },
  _findNext: function () {
    if (this._isPendingResolutionOrRejection()) {
      return undefined;
    }
    var handler = this.status === "resolved"
          ? this._findFirstResolutionHandler
          : this._findFirstRejectionHandler;
    return handler ? handler.apply(this) : undefined;
  },
  _handleNestedPromise: function (promise) {
    this._setPending();
    var self = this;
    promise.then(function (d) {
      self._setResolved();
      self._data = [d];
      self._applyNext();
    }).catch(function (e) {
      self._setRejected();
      self._data = [e];
      self._applyNext();
    });
  },
  _isPendingResolutionOrRejection: function () {
    return this.status === "pending";
  },
  _findFirstResolutionHandler: function () {
    var next;
    while (!next && this._next.length > 0) {
      next = this._next.shift()[0];
    }

    return next;
  },
  _findFirstRejectionHandler: function () {
    var next;
    while (!next && this._next.length > 0) {
      next = this._next.shift()[1];
    }

    return next;
  }
};
SynchronousPromise.resolve = function (data) {
  if (looksLikePromise(data)) {
    return data;
  }

  return new SynchronousPromise(function (resolve) {
    resolve(data);
  });
};
SynchronousPromise.reject = function (error) {
  if (looksLikePromise(error)) {
    return error;
  }

  return new SynchronousPromise(function (resolve, reject) {
    reject(error);
  });
};
SynchronousPromise.all = function () {
  var args = argumentsToArray(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allData = [],
      numResolved = 0,
      doResolve = function () {
        if (numResolved === args.length) {
          resolve(allData);
        }
      },
      rejected = false,
      doReject = function (err) {
        if (rejected) {
          return;
        }
        rejected = true;
        reject(err);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = thisResult;
        numResolved += 1;
        doResolve();
      }).catch(function (err) {
        doReject(err);
      });
    });
  });
};
SynchronousPromise.unresolved = function () {
  var stash = {};
  var result = new SynchronousPromise(function (resolve, reject) {
    stash.resolve = resolve;
    stash.reject = reject;
  });
  result.resolve = stash.resolve;
  result.reject = stash.reject;
  return result;
};

module.exports = {
  SynchronousPromise: SynchronousPromise
};



/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(149),
    baseForOwn = __webpack_require__(354),
    baseIteratee = __webpack_require__(355);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(831),
    keys = __webpack_require__(92);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(833),
    baseMatchesProperty = __webpack_require__(844),
    identity = __webpack_require__(848),
    isArray = __webpack_require__(45),
    property = __webpack_require__(849);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(835),
    isObjectLike = __webpack_require__(61);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(836),
    arraySome = __webpack_require__(839),
    cacheHas = __webpack_require__(840);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(91);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(328),
    toKey = __webpack_require__(148);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 361 */
/***/ (function(module, exports) {

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 362 */
/***/ (function(module, exports) {

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

module.exports = _taggedTemplateLiteralLoose;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(859),
    deburr = __webpack_require__(860),
    words = __webpack_require__(863);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = makePath;

function makePath(strings) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  var path = strings.reduce(function (str, next) {
    var value = values.shift();
    return str + (value == null ? '' : value) + next;
  });
  return path.replace(/^\./, '');
}

module.exports = exports["default"];

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Formik; });
/* unused harmony export yupToFormErrors */
/* unused harmony export validateYupSchema */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Field; });
/* unused harmony export Form */
/* unused harmony export withFormik */
/* unused harmony export move */
/* unused harmony export swap */
/* unused harmony export insert */
/* unused harmony export FieldArray */
/* unused harmony export getIn */
/* unused harmony export setIn */
/* unused harmony export setNestedObjectValues */
/* unused harmony export isReactNative */
/* unused harmony export isFunction */
/* unused harmony export isObject */
/* unused harmony export isInteger */
/* unused harmony export isEmptyChildren */
/* unused harmony export isPromise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var invariant_1 = invariant;

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction_1;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var warning_1 = warning;

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var index = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

if (false) {
  var invariant$2 = invariant_1;
  var warning$1 = warning_1;
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant$2(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

var checkPropTypes_1 = checkPropTypes;

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant_1(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning_1(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning_1(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction_1.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = index({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    invariant_1(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var index$2 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var index_1 = index$2.object;
var index_2 = index$2.oneOfType;
var index_3 = index$2.string;
var index_4 = index$2.node;
var index_5 = index$2.func;
var index_6 = index$2.bool;
var index_7 = index$2.element;

var index$4 = createCommonjsModule(function (module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;
});

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning$2 = function() {};

if (__DEV__) {
  warning$2 = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

var warning_1$2 = warning$2;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]';
var genTag = '[object GeneratorFunction]';
var symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reLeadingDot = /^\./;
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;
var funcProto = Function.prototype;
var objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol$1 = root.Symbol;
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');
var nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined;
var symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$1.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(value));
}

var index$5 = toPath;

var index$6 = createCommonjsModule(function (module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;
});

function getIn(obj, key, def, p) {
    if (p === void 0) { p = 0; }
    var path = index$5(key);
    while (obj && p < path.length) {
        obj = obj[path[p++]];
    }
    return obj === undefined ? def : obj;
}
function setIn(obj, path, value) {
    var res = {};
    var resVal = res;
    var i = 0;
    var pathArray = index$5(path);
    for (; i < pathArray.length - 1; i++) {
        var currentPath = pathArray[i];
        var currentObj = obj[currentPath];
        if (resVal[currentPath]) {
            resVal = resVal[currentPath];
        }
        else if (currentObj) {
            resVal = resVal[currentPath] = index$6(currentObj);
        }
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] =
                isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    }
    resVal[pathArray[i]] = value;
    return __assign({}, obj, res);
}
function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) { visited = new WeakMap(); }
    if (response === void 0) { response = {}; }
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var k = _a[_i];
        var val = object[k];
        if (isObject$1(val)) {
            if (!visited.get(val)) {
                visited.set(val, true);
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        }
        else {
            response[k] = value;
        }
    }
    return response;
}
var isReactNative = typeof window !== 'undefined' &&
    window.navigator &&
    window.navigator.product &&
    window.navigator.product === 'ReactNative';
var isFunction$1 = function (obj) { return 'function' === typeof obj; };
var isObject$1 = function (obj) { return obj !== null && typeof obj === 'object'; };
var isInteger = function (obj) { return String(Math.floor(Number(obj))) === obj; };
var isEmptyChildren = function (children) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children) === 0;
};
function isPromise(value) {
    if (value !== null && typeof value === 'object') {
        return value && typeof value.then === 'function';
    }
    return false;
}

var Field = (function (_super) {
    __extends(Field, _super);
    function Field() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (e) {
            var _a = _this.context.formik, handleChange = _a.handleChange, validateOnChange = _a.validateOnChange;
            handleChange(e);
            if (!!validateOnChange && !!_this.props.validate) {
                _this.runFieldValidations(e.target.value);
            }
        };
        _this.handleBlur = function (e) {
            var _a = _this.context.formik, handleBlur = _a.handleBlur, validateOnBlur = _a.validateOnBlur;
            handleBlur(e);
            if (validateOnBlur && _this.props.validate) {
                _this.runFieldValidations(e.target.value);
            }
        };
        _this.runFieldValidations = function (value) {
            var setFieldError = _this.context.formik.setFieldError;
            var _a = _this.props, name = _a.name, validate = _a.validate;
            var maybePromise = validate(value);
            if (isPromise(maybePromise)) {
                maybePromise.then(function () { return setFieldError(name, undefined); }, function (error) { return setFieldError(name, error); });
            }
            else {
                setFieldError(name, maybePromise);
            }
        };
        return _this;
    }
    Field.prototype.componentWillMount = function () {
        var _a = this.props, render = _a.render, children = _a.children, component = _a.component;
        warning_1$2(!(component && render), 'You should not use <Field component> and <Field render> in the same <Field> component; <Field component> will be ignored');
        warning_1$2(!(this.props.component && children && isFunction$1(children)), 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.');
        warning_1$2(!(render && children && !isEmptyChildren(children)), 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored');
    };
    Field.prototype.render = function () {
        var _a = this.props, validate = _a.validate, name = _a.name, render = _a.render, children = _a.children, _b = _a.component, component = _b === void 0 ? 'input' : _b, props = __rest(_a, ["validate", "name", "render", "children", "component"]);
        var formik = this.context.formik;
        var field = {
            value: props.type === 'radio' || props.type === 'checkbox'
                ? props.value
                : getIn(formik.values, name),
            name: name,
            onChange: validate ? this.handleChange : formik.handleChange,
            onBlur: validate ? this.handleBlur : formik.handleBlur,
        };
        var bag = { field: field, form: formik };
        if (render) {
            return render(bag);
        }
        if (isFunction$1(children)) {
            return children(bag);
        }
        if (typeof component === 'string') {
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, __assign({}, field, props, { children: children }));
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, __assign({}, bag, props, { children: children }));
    };
    Field.contextTypes = {
        formik: index_1,
    };
    Field.propTypes = {
        name: index_3.isRequired,
        component: index_2([index_3, index_5]),
        render: index_5,
        children: index_2([index_5, index_4]),
        validate: index_5,
    };
    return Field;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var Form = function (props, context) { return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("form", __assign({ onSubmit: context.formik.handleSubmit }, props))); };
Form.contextTypes = {
    formik: index_1,
};

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true,
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true,
};
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var propIsEnumerable$1 = Object.prototype.propertyIsEnumerable;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
var getOwnPropertyNames = Object.getOwnPropertyNames;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols$1) {
            keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
        }
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] &&
                !KNOWN_STATICS[key] &&
                (!blacklist || !blacklist[key])) {
                if (propIsEnumerable$1.call(sourceComponent, key) ||
                    typeof sourceComponent[key] === 'function') {
                    try {
                        targetComponent[key] = sourceComponent[key];
                    }
                    catch (e) { }
                }
            }
        }
        return targetComponent;
    }
    return targetComponent;
}

function withFormik(_a) {
    var _b = _a.mapPropsToValues, mapPropsToValues = _b === void 0 ? function (vanillaProps) {
        var val = {};
        for (var k in vanillaProps) {
            if (vanillaProps.hasOwnProperty(k) &&
                typeof vanillaProps[k] !== 'function') {
                val[k] = vanillaProps[k];
            }
        }
        return val;
    } : _b, config = __rest(_a, ["mapPropsToValues"]);
    return function createFormik(Component$$1) {
        var C = (function (_super) {
            __extends(C, _super);
            function C() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.validate = function (values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function () {
                    return isFunction$1(config.validationSchema)
                        ? config.validationSchema(_this.props)
                        : config.validationSchema;
                };
                _this.handleSubmit = function (values, actions) {
                    return config.handleSubmit(values, __assign({}, actions, { props: _this.props }));
                };
                _this.renderFormComponent = function (formikProps) {
                    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Component$$1, __assign({}, _this.props, formikProps));
                };
                return _this;
            }
            C.prototype.render = function () {
                return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Formik, __assign({}, this.props, config, { validate: config.validate && this.validate, validationSchema: config.validationSchema && this.validationSchema, initialValues: mapPropsToValues(this.props), onSubmit: this.handleSubmit, render: this.renderFormComponent })));
            };
            return C;
        }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
        return hoistNonReactStatics(C, Component$$1);
    };
}

var move = function (array, from, to) {
    var copy = (array || []).slice();
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function (array, indexA, indexB) {
    var copy = (array || []).slice();
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function (array, index, value) {
    var copy = (array || []).slice();
    copy.splice(index, 0, value);
    return copy;
};
var FieldArray = (function (_super) {
    __extends(FieldArray, _super);
    function FieldArray(props) {
        var _this = _super.call(this, props) || this;
        _this.updateArrayField = function (fn, alterTouched, alterErrors) {
            var _a = _this.context.formik, setFormikState = _a.setFormikState, validateForm = _a.validateForm, values = _a.values, touched = _a.touched, errors = _a.errors;
            var _b = _this.props, name = _b.name, validateOnChange = _b.validateOnChange;
            setFormikState(function (prevState) { return (__assign({}, prevState, { values: setIn(prevState.values, name, fn(getIn(values, name))), errors: alterErrors
                    ? setIn(prevState.errors, name, fn(getIn(errors, name)))
                    : prevState.errors, touched: alterTouched
                    ? setIn(prevState.touched, name, fn(getIn(touched, name)))
                    : prevState.touched })); }, function () {
                if (validateOnChange) {
                    validateForm();
                }
            });
        };
        _this.push = function (value) {
            return _this.updateArrayField(function (array) { return (array || []).concat([value]); }, false, false);
        };
        _this.swap = function (indexA, indexB) {
            return _this.updateArrayField(function (array) { return swap(array, indexA, indexB); }, false, false);
        };
        _this.move = function (from, to) {
            return _this.updateArrayField(function (array) { return move(array, from, to); }, false, false);
        };
        _this.insert = function (index, value) {
            return _this.updateArrayField(function (array) { return insert(array, index, value); }, false, false);
        };
        _this.unshift = function (value) {
            var arr = [];
            _this.updateArrayField(function (array) {
                arr = array ? [value].concat(array) : [value];
                return arr;
            }, false, false);
            return arr.length;
        };
        _this.remove = _this.remove.bind(_this);
        _this.pop = _this.pop.bind(_this);
        return _this;
    }
    FieldArray.prototype.remove = function (index) {
        var result;
        this.updateArrayField(function (array) {
            var copy = array ? array.slice() : [];
            if (!result) {
                result = copy[index];
            }
            if (isFunction$1(copy.splice)) {
                copy.splice(index, 1);
            }
            return copy;
        }, true, true);
        return result;
    };
    FieldArray.prototype.pop = function () {
        var result;
        this.updateArrayField(function (array) {
            var tmp = array;
            if (!result) {
                result = tmp && tmp.pop && tmp.pop();
            }
            return tmp;
        }, true, true);
        return result;
    };
    FieldArray.prototype.render = function () {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            unshift: this.unshift,
            remove: this.remove,
        };
        var _a = this.props, component = _a.component, render = _a.render, children = _a.children, name = _a.name;
        var props = __assign({}, arrayHelpers, { form: this.context.formik, name: name });
        return component
            ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, props)
            : render
                ? render(props)
                : children
                    ? typeof children === 'function'
                        ? children(props)
                        : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children) : null
                    : null;
    };
    FieldArray.defaultProps = {
        validateOnChange: true,
    };
    FieldArray.contextTypes = {
        formik: index_1,
    };
    return FieldArray;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var Formik = (function (_super) {
    __extends(Formik, _super);
    function Formik(props) {
        var _this = _super.call(this, props) || this;
        _this.setErrors = function (errors) {
            _this.setState({ errors: errors });
        };
        _this.setTouched = function (touched) {
            _this.setState({ touched: touched }, function () {
                if (_this.props.validateOnBlur) {
                    _this.runValidations(_this.state.values);
                }
            });
        };
        _this.setValues = function (values) {
            _this.setState({ values: values }, function () {
                if (_this.props.validateOnChange) {
                    _this.runValidations(values);
                }
            });
        };
        _this.setStatus = function (status) {
            _this.setState({ status: status });
        };
        _this.setError = function (error) {
            if (false) {
                console.warn("Warning: Formik's setError(error) is deprecated and may be removed in future releases. Please use Formik's setStatus(status) instead. It works identically. For more info see https://github.com/jaredpalmer/formik#setstatus-status-any--void");
            }
            _this.setState({ error: error });
        };
        _this.setSubmitting = function (isSubmitting) {
            _this.setState({ isSubmitting: isSubmitting });
        };
        _this.runValidationSchema = function (values, onSuccess) {
            var validationSchema = _this.props.validationSchema;
            var schema = isFunction$1(validationSchema)
                ? validationSchema()
                : validationSchema;
            validateYupSchema(values, schema).then(function () {
                _this.setState({ errors: {} });
                if (onSuccess) {
                    onSuccess();
                }
            }, function (err) {
                return _this.setState({ errors: yupToFormErrors(err), isSubmitting: false });
            });
        };
        _this.runValidations = function (values) {
            if (values === void 0) { values = _this.state.values; }
            if (_this.props.validationSchema) {
                _this.runValidationSchema(values);
            }
            if (_this.props.validate) {
                var maybePromisedErrors = _this.props.validate(values);
                if (isPromise(maybePromisedErrors)) {
                    maybePromisedErrors.then(function () {
                        _this.setState({ errors: {} });
                    }, function (errors) { return _this.setState({ errors: errors, isSubmitting: false }); });
                }
                else {
                    _this.setErrors(maybePromisedErrors);
                }
            }
        };
        _this.handleChange = function (e) {
            if (isReactNative) {
                if (false) {
                    console.error("Warning: Formik's handleChange does not work with React Native. Use setFieldValue and within a callback instead. For more info see https://github.com/jaredpalmer/formik#react-native");
                }
                return;
            }
            e.persist();
            var _a = e.target, type = _a.type, name = _a.name, id = _a.id, value = _a.value, checked = _a.checked, outerHTML = _a.outerHTML;
            var field = name ? name : id;
            var parsed;
            var val = /number|range/.test(type)
                ? (parsed = parseFloat(value), Number.isNaN(parsed) ? '' : parsed)
                : /checkbox/.test(type) ? checked : value;
            if (!field && "production" !== 'production') {
                warnAboutMissingIdentifier({
                    htmlContent: outerHTML,
                    documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
                    handlerName: 'handleChange',
                });
            }
            _this.setState(function (prevState) { return (__assign({}, prevState, { values: setIn(prevState.values, field, val) })); });
            if (_this.props.validateOnChange) {
                _this.runValidations(setIn(_this.state.values, field, val));
            }
        };
        _this.setFieldValue = function (field, value, shouldValidate) {
            if (shouldValidate === void 0) { shouldValidate = true; }
            _this.setState(function (prevState) { return (__assign({}, prevState, { values: setIn(prevState.values, field, value) })); }, function () {
                if (_this.props.validateOnChange && shouldValidate) {
                    _this.runValidations(_this.state.values);
                }
            });
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.submitForm();
        };
        _this.submitForm = function () {
            _this.setState({
                touched: setNestedObjectValues(_this.state.values, true),
                isSubmitting: true,
            });
            if (_this.props.validate) {
                var maybePromisedErrors = _this.props.validate(_this.state.values) || {};
                if (isPromise(maybePromisedErrors)) {
                    maybePromisedErrors.then(function () {
                        _this.setState({ errors: {} });
                        _this.executeSubmit();
                    }, function (errors) { return _this.setState({ errors: errors, isSubmitting: false }); });
                    return;
                }
                else {
                    var isValid = Object.keys(maybePromisedErrors).length === 0;
                    _this.setState({
                        errors: maybePromisedErrors,
                        isSubmitting: isValid,
                    });
                    if (isValid) {
                        _this.executeSubmit();
                    }
                }
            }
            else if (_this.props.validationSchema) {
                _this.runValidationSchema(_this.state.values, _this.executeSubmit);
            }
            else {
                _this.executeSubmit();
            }
        };
        _this.executeSubmit = function () {
            _this.props.onSubmit(_this.state.values, _this.getFormikActions());
        };
        _this.handleBlur = function (e) {
            if (isReactNative) {
                if (false) {
                    console.error("Warning: Formik's handleBlur does not work with React Native. Use setFieldTouched(field, isTouched) within a callback instead. For more info see https://github.com/jaredpalmer/formik#setfieldtouched-field-string-istouched-boolean--void");
                }
                return;
            }
            e.persist();
            var _a = e.target, name = _a.name, id = _a.id, outerHTML = _a.outerHTML;
            var field = name ? name : id;
            if (!field && "production" !== 'production') {
                warnAboutMissingIdentifier({
                    htmlContent: outerHTML,
                    documentationAnchorLink: 'handleblur-e-any--void',
                    handlerName: 'handleBlur',
                });
            }
            _this.setState(function (prevState) { return ({
                touched: setIn(prevState.touched, field, true),
            }); });
            if (_this.props.validateOnBlur) {
                _this.runValidations(_this.state.values);
            }
        };
        _this.setFieldTouched = function (field, touched, shouldValidate) {
            if (touched === void 0) { touched = true; }
            if (shouldValidate === void 0) { shouldValidate = true; }
            _this.setState(function (prevState) { return (__assign({}, prevState, { touched: setIn(prevState.touched, field, touched) })); }, function () {
                if (_this.props.validateOnBlur && shouldValidate) {
                    _this.runValidations(_this.state.values);
                }
            });
        };
        _this.setFieldError = function (field, message) {
            _this.setState(function (prevState) { return (__assign({}, prevState, { errors: setIn(prevState.errors, field, message) })); });
        };
        _this.resetForm = function (nextValues) {
            var values = nextValues ? nextValues : _this.props.initialValues;
            _this.initialValues = values;
            _this.setState({
                isSubmitting: false,
                errors: {},
                touched: {},
                error: undefined,
                status: undefined,
                values: values,
            });
        };
        _this.handleReset = function () {
            if (_this.props.onReset) {
                var maybePromisedOnReset = _this.props.onReset(_this.state.values, _this.getFormikActions());
                if (isPromise(maybePromisedOnReset)) {
                    maybePromisedOnReset.then(_this.resetForm);
                }
                else {
                    _this.resetForm();
                }
            }
            else {
                _this.resetForm();
            }
        };
        _this.setFormikState = function (s, callback) {
            return _this.setState(s, callback);
        };
        _this.getFormikActions = function () {
            return {
                resetForm: _this.resetForm,
                submitForm: _this.submitForm,
                validateForm: _this.runValidations,
                setError: _this.setError,
                setErrors: _this.setErrors,
                setFieldError: _this.setFieldError,
                setFieldTouched: _this.setFieldTouched,
                setFieldValue: _this.setFieldValue,
                setStatus: _this.setStatus,
                setSubmitting: _this.setSubmitting,
                setTouched: _this.setTouched,
                setValues: _this.setValues,
                setFormikState: _this.setFormikState,
            };
        };
        _this.getFormikComputedProps = function () {
            var isInitialValid = _this.props.isInitialValid;
            var dirty = !index$4(_this.initialValues, _this.state.values);
            return {
                dirty: dirty,
                isValid: dirty
                    ? _this.state.errors && Object.keys(_this.state.errors).length === 0
                    : isInitialValid !== false && isFunction$1(isInitialValid)
                        ? isInitialValid(_this.props)
                        : isInitialValid,
                initialValues: _this.initialValues,
            };
        };
        _this.getFormikBag = function () {
            return __assign({}, _this.state, _this.getFormikActions(), _this.getFormikComputedProps(), { handleBlur: _this.handleBlur, handleChange: _this.handleChange, handleReset: _this.handleReset, handleSubmit: _this.handleSubmit, validateOnChange: _this.props.validateOnChange, validateOnBlur: _this.props.validateOnBlur });
        };
        _this.state = {
            values: props.initialValues || {},
            errors: {},
            touched: {},
            isSubmitting: false,
        };
        _this.initialValues = props.initialValues || {};
        return _this;
    }
    Formik.prototype.getChildContext = function () {
        return {
            formik: this.getFormikBag(),
        };
    };
    Formik.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.enableReinitialize &&
            !index$4(nextProps.initialValues, this.props.initialValues)) {
            this.initialValues = nextProps.initialValues;
            this.resetForm(nextProps.initialValues);
        }
    };
    Formik.prototype.componentWillMount = function () {
        warning_1$2(!(this.props.component && this.props.render), 'You should not use <Formik component> and <Formik render> in the same <Formik> component; <Formik render> will be ignored');
        warning_1$2(!(this.props.component &&
            this.props.children &&
            !isEmptyChildren(this.props.children)), 'You should not use <Formik component> and <Formik children> in the same <Formik> component; <Formik children> will be ignored');
        warning_1$2(!(this.props.render &&
            this.props.children &&
            !isEmptyChildren(this.props.children)), 'You should not use <Formik render> and <Formik children> in the same <Formik> component; <Formik children> will be ignored');
    };
    Formik.prototype.render = function () {
        var _a = this.props, component = _a.component, render = _a.render, children = _a.children;
        var props = this.getFormikBag();
        return component
            ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, props)
            : render
                ? render(props)
                : children
                    ? typeof children === 'function'
                        ? children(props)
                        : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children) : null
                    : null;
    };
    Formik.defaultProps = {
        validateOnChange: true,
        validateOnBlur: true,
        isInitialValid: false,
        enableReinitialize: false,
    };
    Formik.propTypes = {
        validateOnChange: index_6,
        validateOnBlur: index_6,
        isInitialValid: index_2([index_5, index_6]),
        initialValues: index_1,
        onReset: index_5,
        onSubmit: index_5.isRequired,
        validationSchema: index_2([index_5, index_1]),
        validate: index_5,
        component: index_5,
        render: index_5,
        children: index_2([index_5, index_4]),
        enableReinitialize: index_6,
    };
    Formik.childContextTypes = {
        formik: index_1,
    };
    return Formik;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function warnAboutMissingIdentifier(_a) {
    var htmlContent = _a.htmlContent, documentationAnchorLink = _a.documentationAnchorLink, handlerName = _a.handlerName;
    console.error("Warning: `" + handlerName + "` has triggered and you forgot to pass an `id` or `name` attribute to your input:\n\n    " + htmlContent + "\n\n    Formik cannot determine which value to update. For more info see https://github.com/jaredpalmer/formik#" + documentationAnchorLink + "\n  ");
}
function yupToFormErrors(yupError) {
    var errors = {};
    for (var _i = 0, _a = yupError.inner; _i < _a.length; _i++) {
        var err = _a[_i];
        if (!errors[err.path]) {
            errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
function validateYupSchema(data, schema, context) {
    if (context === void 0) { context = {}; }
    var validateData = {};
    for (var k in data) {
        if (data.hasOwnProperty(k)) {
            var key = String(k);
            validateData[key] =
                data[key] !== '' ? data[key] : undefined;
        }
    }
    return schema.validate(validateData, { abortEarly: false, context: context });
}


//# sourceMappingURL=formik.es6.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(52)))

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_yup__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_yup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Input__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_types_onboard__ = __webpack_require__(238);
var PasswordForm=function PasswordForm(_ref){var _tProp;var errors=_ref.errors,tProp=_ref.t;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__["b" /* useI18n */])(),tCtx=_useI18n.t;var t=(_tProp=tProp)!==null&&_tProp!==void 0?_tProp:tCtx;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-step"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header",{className:"gb-onboard-intro"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"gb-onboard-panel__title"},t('forms.passwordTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-onboard-panel__lede-text"},t('forms.passwordLede'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-fields"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Input__["a" /* default */],{label:t('forms.password'),type:"password",name:"password",autoComplete:"new-password",hint:t('forms.passwordHint'),error:errors===null||errors===void 0?void 0:errors.password,revealToggle:true})));};function validationSchema(_values,t){return __WEBPACK_IMPORTED_MODULE_1_yup__["object"]().shape({password:__WEBPACK_IMPORTED_MODULE_1_yup__["string"]().min(__WEBPACK_IMPORTED_MODULE_4_types_onboard__["c" /* ONBOARD_PASSWORD_MIN_LENGTH */],t('forms.valPasswordMin')).required(t('forms.valPasswordRequired'))});}var PasswordFormExport=PasswordForm;PasswordFormExport.validationSchema=validationSchema;/* harmony default export */ __webpack_exports__["a"] = (PasswordFormExport);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_yup__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_yup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_yup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Input__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__ = __webpack_require__(6);
var LocationForm=function LocationForm(_ref){var _tProp;var errors=_ref.errors,tProp=_ref.t;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__["b" /* useI18n */])(),tCtx=_useI18n.t;var t=(_tProp=tProp)!==null&&_tProp!==void 0?_tProp:tCtx;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-step"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header",{className:"gb-onboard-intro"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"gb-onboard-panel__title"},t('forms.businessTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-onboard-panel__lede-text"},t('forms.businessLede'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-fields"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Input__["a" /* default */],{label:t('forms.businessName'),type:"text",name:"locationName",autoComplete:"organization",error:errors===null||errors===void 0?void 0:errors.locationName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Input__["a" /* default */],{label:t('forms.address'),type:"text",name:"address",autoComplete:"street-address",error:errors===null||errors===void 0?void 0:errors.address}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-fields__row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Input__["a" /* default */],{label:t('forms.city'),type:"text",name:"city",autoComplete:"address-level2",error:errors===null||errors===void 0?void 0:errors.city}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Input__["a" /* default */],{label:t('forms.postalCode'),type:"text",name:"zip",autoComplete:"postal-code",hint:t('forms.postalHint'),error:errors===null||errors===void 0?void 0:errors.zip})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Input__["a" /* default */],{label:t('forms.phone'),type:"tel",name:"phone",autoComplete:"tel",inputMode:"tel",hint:t('forms.phoneHint'),error:errors===null||errors===void 0?void 0:errors.phone})));};function validationSchema(t){return __WEBPACK_IMPORTED_MODULE_1_yup__["object"]().shape({locationName:__WEBPACK_IMPORTED_MODULE_1_yup__["string"]().required(t('forms.valBusinessRequired')),address:__WEBPACK_IMPORTED_MODULE_1_yup__["string"]().required(t('forms.valAddressRequired')),city:__WEBPACK_IMPORTED_MODULE_1_yup__["string"]().required(t('forms.valCityRequired')),zip:__WEBPACK_IMPORTED_MODULE_1_yup__["string"]().test('regex',t('forms.valZipFormat'),function(zip){return!!(zip||'').match(/[0-9]{4}[ ]?[a-z]{2}/i);}).required(t('forms.valZipRequired')),phone:__WEBPACK_IMPORTED_MODULE_1_yup__["string"]().required(t('forms.valPhoneRequired')).min(8,t('forms.valPhoneMin'))});}var LocationFormExport=LocationForm;LocationFormExport.validationSchema=validationSchema;/* harmony default export */ __webpack_exports__["a"] = (LocationFormExport);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Button=function Button(_ref){var value=_ref.value,onClick=_ref.onClick,_ref$type=_ref.type,type=_ref$type===void 0?'button':_ref$type,_ref$className=_ref.className,className=_ref$className===void 0?'bg-green shadow text-white text-base font-bold p-15':_ref$className,_ref$disabled=_ref.disabled,disabled=_ref$disabled===void 0?false:_ref$disabled;var disabledCursor=disabled?'cursor-not-allowed':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:onClick,type:type,className:"".concat(className," gb-btn ").concat(disabledCursor).trim(),disabled:disabled},value);};/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = absoluteUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__site__ = __webpack_require__(370);
/**
 * Build an absolute URL for meta tags (og:image, canonical, JSON-LD).
 * @param pathOrUrl Path starting with / or full URL
 */function absoluteUrl(pathOrUrl){if(!pathOrUrl)return'';if(/^https?:\/\//i.test(pathOrUrl))return pathOrUrl;var origin=Object(__WEBPACK_IMPORTED_MODULE_0__site__["c" /* getSiteOrigin */])();var path=pathOrUrl.startsWith('/')?pathOrUrl:"/".concat(pathOrUrl);return"".concat(origin).concat(path);}

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getSiteOrigin;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_STORE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PLAY_STORE_URL; });
/** Canonical marketing site origin (no trailing slash). */function getSiteOrigin(){var u=Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SENTRY_DSN":"https://27a1e003a249b09583f1b35346a157be@o4506479248474112.ingest.us.sentry.io/4511757032161280"}).REACT_APP_URL||'';return u.replace(/\/$/,'');}var APP_STORE_URL='https://apps.apple.com/nl/app/gastrobuddy/id1339116265?mt=8';var PLAY_STORE_URL='https://play.google.com/store/apps/details?id=com.gastrobuddy&hl=en';

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(372);
module.exports = __webpack_require__(377);


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(373).enable();
  window.Promise = __webpack_require__(375);
}

// fetch() polyfill for making API calls.
__webpack_require__(376);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(153);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(239);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._l = null;
  Promise._m = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._l = function (promise) {
    if (
      promise._i === 2 && // IS REJECTED
      rejections[promise._o]
    ) {
      if (rejections[promise._o].logged) {
        onHandled(promise._o);
      } else {
        clearTimeout(rejections[promise._o].timeout);
      }
      delete rejections[promise._o];
    }
  };
  Promise._m = function (promise, err) {
    if (promise._h === 0) { // not yet handled
      promise._o = id++;
      rejections[promise._o] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._o),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(239);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._n);
  p._i = 1;
  p._j = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._i === 3) {
            val = val._j;
          }
          if (val._i === 1) return res(i, val._j);
          if (val._i === 2) reject(val._j);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_gtm_module__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_gtm_module___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_gtm_module__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sentry__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_App__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_registerServiceWorker__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_static_styles_tailwind_css__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_static_styles_tailwind_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_static_styles_tailwind_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_static_styles_micro_animations_css__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_static_styles_micro_animations_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_static_styles_micro_animations_css__);
Object(__WEBPACK_IMPORTED_MODULE_5_sentry__["b" /* initSentry */])();if(Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SENTRY_DSN":"https://27a1e003a249b09583f1b35346a157be@o4506479248474112.ingest.us.sentry.io/4511757032161280"}).REACT_APP_GT_KEY){var tagManager={gtmId:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SENTRY_DSN":"https://27a1e003a249b09583f1b35346a157be@o4506479248474112.ingest.us.sentry.io/4511757032161280"}).REACT_APP_GT_KEY};__WEBPACK_IMPORTED_MODULE_4_react_gtm_module___default.a.initialize(tagManager);}var root=document.getElementById('root');if(!root){throw new Error('Root element #root not found');}__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_sentry__["a" /* Sentry */].ErrorBoundary,{fallback:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Something went wrong. Please reload the page.")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_App__["a" /* default */],null))),root);Object(__WEBPACK_IMPORTED_MODULE_7_registerServiceWorker__["a" /* default */])();

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(379);

__webpack_require__(576);

__webpack_require__(577);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(380);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(174);
__webpack_require__(484);
__webpack_require__(259);
__webpack_require__(485);
__webpack_require__(260);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(263);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
module.exports = __webpack_require__(30);


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(5);
var has = __webpack_require__(25);
var DESCRIPTORS = __webpack_require__(11);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(20);
var META = __webpack_require__(54).KEY;
var $fails = __webpack_require__(7);
var shared = __webpack_require__(95);
var setToStringTag = __webpack_require__(79);
var uid = __webpack_require__(63);
var wks = __webpack_require__(9);
var wksExt = __webpack_require__(241);
var wksDefine = __webpack_require__(155);
var enumKeys = __webpack_require__(382);
var isArray = __webpack_require__(117);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var toObject = __webpack_require__(13);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(40);
var createDesc = __webpack_require__(62);
var _create = __webpack_require__(66);
var gOPNExt = __webpack_require__(244);
var $GOPD = __webpack_require__(27);
var $GOPS = __webpack_require__(116);
var $DP = __webpack_require__(12);
var $keys = __webpack_require__(64);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(67).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(97).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(53)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(19)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(95)('native-function-to-string', Function.toString);


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(64);
var gOPS = __webpack_require__(116);
var pIE = __webpack_require__(97);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(66) });


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(11), 'Object', { defineProperty: __webpack_require__(12).f });


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(11), 'Object', { defineProperties: __webpack_require__(243) });


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(26);
var $getOwnPropertyDescriptor = __webpack_require__(27).f;

__webpack_require__(42)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(13);
var $getPrototypeOf = __webpack_require__(28);

__webpack_require__(42)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(13);
var $keys = __webpack_require__(64);

__webpack_require__(42)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(42)('getOwnPropertyNames', function () {
  return __webpack_require__(244).f;
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(54).onFreeze;

__webpack_require__(42)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(54).onFreeze;

__webpack_require__(42)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(54).onFreeze;

__webpack_require__(42)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(8);

__webpack_require__(42)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(8);

__webpack_require__(42)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(8);

__webpack_require__(42)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(245) });


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(246) });


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(159).set });


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(80);
var test = {};
test[__webpack_require__(9)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(20)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(247) });


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(12).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(11) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(28);
var HAS_INSTANCE = __webpack_require__(9)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(12).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(249);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(250);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var has = __webpack_require__(25);
var cof = __webpack_require__(32);
var inheritIfRequired = __webpack_require__(161);
var toPrimitive = __webpack_require__(40);
var fails = __webpack_require__(7);
var gOPN = __webpack_require__(67).f;
var gOPD = __webpack_require__(27).f;
var dP = __webpack_require__(12).f;
var $trim = __webpack_require__(81).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(66)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(11) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(20)(global, NUMBER, $Number);
}


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(33);
var aNumberValue = __webpack_require__(251);
var repeat = __webpack_require__(162);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(7)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(7);
var aNumberValue = __webpack_require__(251);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(5).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(252) });


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(252);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(250);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(249);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(253);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(163);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(164);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(254) });


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(253) });


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(163) });


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(164);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(164);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(65);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(10);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(81)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(118)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(165)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(118)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(10);
var context = __webpack_require__(167);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(168)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(167);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(168)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(162)
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(10);
var context = __webpack_require__(167);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(168)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(21)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(21)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(21)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(21)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(21)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(21)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(21)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(21)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(21)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(21)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(21)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(21)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(21)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(40);

$export($export.P + $export.F * __webpack_require__(7)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(459);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(7);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(20)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(9)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(19)(proto, TO_PRIMITIVE, __webpack_require__(462));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(40);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(117) });


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(31);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(13);
var call = __webpack_require__(255);
var isArrayIter = __webpack_require__(169);
var toLength = __webpack_require__(10);
var createProperty = __webpack_require__(170);
var getIterFn = __webpack_require__(171);

$export($export.S + $export.F * !__webpack_require__(120)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(170);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(7)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(26);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(96) != Object || !__webpack_require__(34)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(158);
var cof = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(65);
var toLength = __webpack_require__(10);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(7)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(17);
var toObject = __webpack_require__(13);
var fails = __webpack_require__(7);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(34)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(43)(0);
var STRICT = __webpack_require__(34)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var isArray = __webpack_require__(117);
var SPECIES = __webpack_require__(9)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(43)(1);

$export($export.P + $export.F * !__webpack_require__(34)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(43)(2);

$export($export.P + $export.F * !__webpack_require__(34)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(43)(3);

$export($export.P + $export.F * !__webpack_require__(34)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(43)(4);

$export($export.P + $export.F * !__webpack_require__(34)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(256);

$export($export.P + $export.F * !__webpack_require__(34)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(256);

$export($export.P + $export.F * !__webpack_require__(34)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(115)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(34)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(26);
var toInteger = __webpack_require__(33);
var toLength = __webpack_require__(10);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(34)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(257) });

__webpack_require__(55)('copyWithin');


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(173) });

__webpack_require__(55)('fill');


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(43)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(55)(KEY);


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(43)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(55)(KEY);


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68)('Array');


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var inheritIfRequired = __webpack_require__(161);
var dP = __webpack_require__(12).f;
var gOPN = __webpack_require__(67).f;
var isRegExp = __webpack_require__(119);
var $flags = __webpack_require__(98);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(11) && (!CORRECT_NEW || __webpack_require__(7)(function () {
  re2[__webpack_require__(9)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(20)(global, 'RegExp', $RegExp);
}

__webpack_require__(68)('RegExp');


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(260);
var anObject = __webpack_require__(4);
var $flags = __webpack_require__(98);
var DESCRIPTORS = __webpack_require__(11);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(20)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4);
var toLength = __webpack_require__(10);
var advanceStringIndex = __webpack_require__(176);
var regExpExec = __webpack_require__(121);

// @@match logic
__webpack_require__(122)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4);
var toObject = __webpack_require__(13);
var toLength = __webpack_require__(10);
var toInteger = __webpack_require__(33);
var advanceStringIndex = __webpack_require__(176);
var regExpExec = __webpack_require__(121);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(122)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(4);
var sameValue = __webpack_require__(246);
var regExpExec = __webpack_require__(121);

// @@search logic
__webpack_require__(122)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(119);
var anObject = __webpack_require__(4);
var speciesConstructor = __webpack_require__(99);
var advanceStringIndex = __webpack_require__(176);
var toLength = __webpack_require__(10);
var callRegExpExec = __webpack_require__(121);
var regexpExec = __webpack_require__(175);
var fails = __webpack_require__(7);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(122)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(53);
var global = __webpack_require__(5);
var ctx = __webpack_require__(31);
var classof = __webpack_require__(80);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(8);
var aFunction = __webpack_require__(17);
var anInstance = __webpack_require__(69);
var forOf = __webpack_require__(70);
var speciesConstructor = __webpack_require__(99);
var task = __webpack_require__(177).set;
var microtask = __webpack_require__(178)();
var newPromiseCapabilityModule = __webpack_require__(179);
var perform = __webpack_require__(261);
var userAgent = __webpack_require__(123);
var promiseResolve = __webpack_require__(262);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(9)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(71)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(79)($Promise, PROMISE);
__webpack_require__(68)(PROMISE);
Wrapper = __webpack_require__(30)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(120)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(267);
var validate = __webpack_require__(72);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(124)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(125);
var buffer = __webpack_require__(180);
var anObject = __webpack_require__(4);
var toAbsoluteIndex = __webpack_require__(65);
var toLength = __webpack_require__(10);
var isObject = __webpack_require__(8);
var ArrayBuffer = __webpack_require__(5).ArrayBuffer;
var speciesConstructor = __webpack_require__(99);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(68)(ARRAY_BUFFER);


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(125).ABV, {
  DataView: __webpack_require__(180).DataView
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(17);
var anObject = __webpack_require__(4);
var rApply = (__webpack_require__(5).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(7)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(66);
var aFunction = __webpack_require__(17);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var bind = __webpack_require__(247);
var rConstruct = (__webpack_require__(5).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(12);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(40);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(7)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(27).f;
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(166)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(28);
var has = __webpack_require__(25);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(4);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(27);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(28);
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(269) });


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(12);
var gOPD = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(28);
var has = __webpack_require__(25);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(62);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(159);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(115)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(55)('includes');


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(270);
var toObject = __webpack_require__(13);
var toLength = __webpack_require__(10);
var aFunction = __webpack_require__(17);
var arraySpeciesCreate = __webpack_require__(172);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(55)('flatMap');


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(270);
var toObject = __webpack_require__(13);
var toLength = __webpack_require__(10);
var toInteger = __webpack_require__(33);
var arraySpeciesCreate = __webpack_require__(172);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(55)('flatten');


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(118)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(271);
var userAgent = __webpack_require__(123);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(271);
var userAgent = __webpack_require__(123);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(81)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(81)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(41);
var toLength = __webpack_require__(10);
var isRegExp = __webpack_require__(119);
var getFlags = __webpack_require__(98);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(166)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(155)('asyncIterator');


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(155)('observable');


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(269);
var toIObject = __webpack_require__(26);
var gOPD = __webpack_require__(27);
var createProperty = __webpack_require__(170);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(272)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(272)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(13);
var aFunction = __webpack_require__(17);
var $defineProperty = __webpack_require__(12);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(11) && $export($export.P + __webpack_require__(126), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(13);
var aFunction = __webpack_require__(17);
var $defineProperty = __webpack_require__(12);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(11) && $export($export.P + __webpack_require__(126), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(40);
var getPrototypeOf = __webpack_require__(28);
var getOwnPropertyDescriptor = __webpack_require__(27).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(11) && $export($export.P + __webpack_require__(126), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(40);
var getPrototypeOf = __webpack_require__(28);
var getOwnPropertyDescriptor = __webpack_require__(27).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(11) && $export($export.P + __webpack_require__(126), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(273)('Map') });


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(273)('Set') });


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(127)('Map');


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(127)('Set');


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(127)('WeakMap');


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(127)('WeakSet');


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(128)('Map');


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(128)('Set');


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(128)('WeakMap');


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(128)('WeakSet');


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(5) });


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(5) });


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(32);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(275);
var fround = __webpack_require__(254);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(275) });


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(30);
var global = __webpack_require__(5);
var speciesConstructor = __webpack_require__(99);
var promiseResolve = __webpack_require__(262);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(179);
var perform = __webpack_require__(261);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(48);
var anObject = __webpack_require__(4);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(48);
var anObject = __webpack_require__(4);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(48);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(28);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(265);
var from = __webpack_require__(274);
var metadata = __webpack_require__(48);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(28);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(48);
var anObject = __webpack_require__(4);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(48);
var anObject = __webpack_require__(4);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(48);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(28);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(48);
var anObject = __webpack_require__(4);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(48);
var anObject = __webpack_require__(4);
var aFunction = __webpack_require__(17);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(178)();
var process = __webpack_require__(5).process;
var isNode = __webpack_require__(32)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(5);
var core = __webpack_require__(30);
var microtask = __webpack_require__(178)();
var OBSERVABLE = __webpack_require__(9)('observable');
var aFunction = __webpack_require__(17);
var anObject = __webpack_require__(4);
var anInstance = __webpack_require__(69);
var redefineAll = __webpack_require__(71);
var hide = __webpack_require__(19);
var forOf = __webpack_require__(70);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(68)('Observable');


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(5);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(123);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(177);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(174);
var getKeys = __webpack_require__(64);
var redefine = __webpack_require__(20);
var global = __webpack_require__(5);
var hide = __webpack_require__(19);
var Iterators = __webpack_require__(82);
var wks = __webpack_require__(9);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(578);
module.exports = __webpack_require__(30).RegExp.escape;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(579)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.11.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(153),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.11.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(582);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.11.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(2),n=__webpack_require__(153),q=__webpack_require__(583);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),dc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},ed={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},fd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=fd[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?ed[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},xd=0;for(;xd<td.length;xd++){var yd=td[xd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===dc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<dc.length;h++)F(dc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<dc.length;d++)F(dc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;e.lastEffect=
b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=V.firstEffect),
a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){Sj();if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=d-1);d<=a.lastPingedTime&&
(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,m=k.focusNode;k=k.focusOffset;
try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=null;me={focusedElem:g,selectionRange:h};
Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,Y);break;case 4:aj(Y.alternate,
Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),l=p.textContent.length,
g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===
typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var cc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var dd=t.stateNode;if(t.effectTag&4)if(null===cc)dd.componentDidMount();else{var hk=t.elementType===t.type?cc.memoizedProps:mg(t.type,cc.memoizedProps);dd.componentDidUpdate(hk,cc.memoizedState,dd.__reactInternalSnapshotBeforeUpdate)}var Eh=
t.updateQueue;null!==Eh&&Kg(t,Eh,dd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===cc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;
case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var wd=Y.ref;if(null!==wd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof wd?wd(t):wd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(jj=null);1073741823===b?a===Ij?Hj++:(Hj=
0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};
function wk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}wk.prototype.render=function(a,b){var c=this._internalRoot;rk(a,c,null,void 0===b?null:b)};wk.prototype.unmount=function(a){var b=this._internalRoot;rk(null,b,null,void 0===a?null:a)};
function yk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}eb=bk;fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};
function zk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new wk(a,0,b?{hydrate:!0}:void 0)}
function Ak(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=zk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!yk(b))throw Error(u(200));return vk(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!yk(b))throw Error(u(200));return Ak(null,a,b,!0,c)},render:function(a,b,c){if(!yk(b))throw Error(u(200));return Ak(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!yk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return Ak(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!yk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){Ak(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.11.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(584);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.17.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout,A=window.requestAnimationFrame,B=window.cancelAnimationFrame;"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));if("object"===typeof w&&
"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var C=x.now();exports.unstable_now=function(){return x.now()-C}}var D=!1,E=null,F=-1,G=5,H=0;k=function(){return exports.unstable_now()>=H};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):G=0<a?Math.floor(1E3/a):33.33};var I=new MessageChannel,J=I.port2;I.port1.onmessage=
function(){if(null!==E){var a=exports.unstable_now();H=a+G;try{E(!0,a)?J.postMessage(null):(D=!1,E=null)}catch(b){throw J.postMessage(null),b;}}else D=!1};f=function(a){E=a;D||(D=!0,J.postMessage(null))};g=function(a,b){F=y(function(){a(exports.unstable_now())},b)};h=function(){z(F);F=-1}}function K(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<L(e,b))a[d]=b,a[c]=e,c=d;else break a}}function M(a){a=a[0];return void 0===a?null:a}
function N(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>L(n,c))void 0!==r&&0>L(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>L(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function L(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var O=[],P=[],Q=1,R=null,S=3,T=!1,U=!1,V=!1;
function W(a){for(var b=M(P);null!==b;){if(null===b.callback)N(P);else if(b.startTime<=a)N(P),b.sortIndex=b.expirationTime,K(O,b);else break;b=M(P)}}function X(a){V=!1;W(a);if(!U)if(null!==M(O))U=!0,f(Y);else{var b=M(P);null!==b&&g(X,b.startTime-a)}}
function Y(a,b){U=!1;V&&(V=!1,h());T=!0;var c=S;try{W(b);for(R=M(O);null!==R&&(!(R.expirationTime>b)||a&&!k());){var d=R.callback;if(null!==d){R.callback=null;S=R.priorityLevel;var e=d(R.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?R.callback=e:R===M(O)&&N(O);W(b)}else N(O);R=M(O)}if(null!==R)var m=!0;else{var n=M(P);null!==n&&g(X,n.startTime-b);m=!1}return m}finally{R=null,S=c,T=!1}}
function Z(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var aa=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=S;S=a;try{return b()}finally{S=c}};
exports.unstable_next=function(a){switch(S){case 1:case 2:case 3:var b=3;break;default:b=S}var c=S;S=b;try{return a()}finally{S=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Z(a)}else c=Z(a),e=d;c=e+c;a={id:Q++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,K(P,a),null===M(O)&&a===M(P)&&(V?h():V=!0,g(X,e-d))):(a.sortIndex=c,K(O,a),U||T||(U=!0,f(Y)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=S;return function(){var c=S;S=b;try{return a.apply(this,arguments)}finally{S=c}}};exports.unstable_getCurrentPriorityLevel=function(){return S};exports.unstable_shouldYield=function(){var a=exports.unstable_now();W(a);var b=M(O);return b!==R&&null!==R&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<R.expirationTime||k()};exports.unstable_requestPaint=aa;exports.unstable_continueExecution=function(){U||T||(U=!0,f(Y))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return M(O)};exports.unstable_Profiling=null;


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(181);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(587);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(181);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(595);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(182);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(276);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(599);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(601);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(280);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(603);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(182);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(605);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(183);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(280);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(183);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(609);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(278);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _TagManager = __webpack_require__(612);

var _TagManager2 = _interopRequireDefault(_TagManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _TagManager2.default;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Snippets = __webpack_require__(613);

var _Snippets2 = _interopRequireDefault(_Snippets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagManager = {
  dataScript: function dataScript(dataLayer) {
    var script = document.createElement('script');
    script.innerHTML = dataLayer;
    return script;
  },
  gtm: function gtm(args) {
    var snippets = _Snippets2.default.tags(args);

    var noScript = function noScript() {
      var noscript = document.createElement('noscript');
      noscript.innerHTML = snippets.iframe;
      return noscript;
    };

    var script = function script() {
      var script = document.createElement('script');
      script.innerHTML = snippets.script;
      return script;
    };

    var dataScript = this.dataScript(snippets.dataLayerVar);

    return {
      noScript: noScript,
      script: script,
      dataScript: dataScript
    };
  },
  initialize: function initialize(_ref) {
    var gtmId = _ref.gtmId,
        _ref$events = _ref.events,
        events = _ref$events === undefined ? {} : _ref$events,
        dataLayer = _ref.dataLayer,
        _ref$dataLayerName = _ref.dataLayerName,
        dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName,
        _ref$auth = _ref.auth,
        auth = _ref$auth === undefined ? '' : _ref$auth,
        _ref$preview = _ref.preview,
        preview = _ref$preview === undefined ? '' : _ref$preview;

    var gtm = this.gtm({
      id: gtmId,
      events: events,
      dataLayer: dataLayer || undefined,
      dataLayerName: dataLayerName,
      auth: auth,
      preview: preview
    });
    if (dataLayer) document.head.appendChild(gtm.dataScript);
    document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
    document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
  },
  dataLayer: function dataLayer(_ref2) {
    var _dataLayer = _ref2.dataLayer,
        _ref2$dataLayerName = _ref2.dataLayerName,
        dataLayerName = _ref2$dataLayerName === undefined ? 'dataLayer' : _ref2$dataLayerName;

    if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
    var snippets = _Snippets2.default.dataLayer(_dataLayer, dataLayerName);
    var dataScript = this.dataScript(snippets);
    document.head.appendChild(dataScript);
  }
};

module.exports = TagManager;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _warn = __webpack_require__(614);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://developers.google.com/tag-manager/quickstart

var Snippets = {
  tags: function tags(_ref) {
    var id = _ref.id,
        events = _ref.events,
        dataLayer = _ref.dataLayer,
        dataLayerName = _ref.dataLayerName,
        preview = _ref.preview,
        auth = _ref.auth;

    var gtm_auth = '&gtm_auth=' + auth;
    var gtm_preview = '&gtm_preview=' + preview;

    if (!id) (0, _warn2.default)('GTM Id is required');

    var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';

    var script = '\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\', ' + JSON.stringify(events).slice(1, -1) + '});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';\n        j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl+\'' + gtm_auth + gtm_preview + '&gtm_cookies_win=x\';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,\'script\',\'' + dataLayerName + '\',\'' + id + '\');';

    var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);

    return {
      iframe: iframe,
      script: script,
      dataLayerVar: dataLayerVar
    };
  },
  dataLayer: function dataLayer(_dataLayer, dataLayerName) {
    return '\n      window.' + dataLayerName + ' = window.' + dataLayerName + ' || [];\n      window.' + dataLayerName + '.push(' + JSON.stringify(_dataLayer) + ')';
  }
};

module.exports = Snippets;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var warn = function warn(s) {
  console.warn('[react-gtm]', s);
};

exports.default = warn;

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = initSentry;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_react__ = __webpack_require__(616);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_react__; });
var initialized=false;/**
 * Initialize Sentry for the marketing website. No-op when REACT_APP_SENTRY_DSN is unset.
 */function initSentry(){if(initialized)return;var dsn=("https://27a1e003a249b09583f1b35346a157be@o4506479248474112.ingest.us.sentry.io/4511757032161280"||'').trim();if(!dsn)return;__WEBPACK_IMPORTED_MODULE_0__sentry_react__["init"]({dsn:dsn,environment:"production"||'development',release:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SENTRY_DSN":"https://27a1e003a249b09583f1b35346a157be@o4506479248474112.ingest.us.sentry.io/4511757032161280"}).REACT_APP_SENTRY_RELEASE||undefined,tracesSampleRate: true?0.1:0,sendDefaultPii:false,initialScope:{tags:{surface:'website'}}});initialized=true;}

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_browser__ = __webpack_require__(74);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FunctionToString", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Hub", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "InboundFilters", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ModuleMetadata", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SDK_VERSION", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Scope", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addBreadcrumb", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addEventProcessor", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addGlobalEventProcessor", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addTracingExtensions", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "captureEvent", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "captureException", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "captureMessage", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "captureSession", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "close", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["O"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "configureScope", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "continueTrace", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "createTransport", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["S"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "endSession", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_0"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extractTraceparentData", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_5"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_7"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "functionToStringIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_9"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getActiveSpan", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_11"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getActiveTransaction", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_12"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getClient", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_13"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCurrentHub", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_14"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCurrentScope", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_15"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getHubFromCarrier", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_17"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getSpanStatusFromHttpCode", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_19"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "inboundFiltersIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_23"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isInitialized", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_26"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lastEventId", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_27"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "makeMain", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_31"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "makeMultiplexedTransport", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_32"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "metrics", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_34"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "moduleMetadataIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_35"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "parameterize", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_40"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_47"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setCurrentClient", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_48"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setExtra", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_49"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setExtras", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_50"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setHttpStatus", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_51"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setMeasurement", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_52"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setTag", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_53"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setTags", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_54"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setUser", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_55"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "spanStatusfromHttpCode", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_57"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "startInactiveSpan", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_60"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "startSession", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_61"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "startSpan", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_62"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "startSpanManual", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_63"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "startTransaction", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_64"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "trace", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_65"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withActiveSpan", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_67"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withIsolationScope", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_68"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withScope", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_69"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "WINDOW", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BrowserClient", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "makeFetchTransport", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_30"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "makeXHRTransport", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_33"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chromeStackLineParser", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaultStackLineParsers", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["Y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaultStackParser", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["Z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "geckoStackLineParser", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_10"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "opera10StackLineParser", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_38"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "opera11StackLineParser", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_39"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "winjsStackLineParser", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_66"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "eventFromException", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_1"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "eventFromMessage", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_2"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "exceptionFromError", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_3"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "createUserFeedbackEnvelope", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "captureUserFeedback", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaultIntegrations", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["W"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceLoad", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_8"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getDefaultIntegrations", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_16"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "onLoad", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_36"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "showReportDialog", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_56"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_70"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "breadcrumbsIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Dedupe", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "GlobalHandlers", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "globalHandlersIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_20"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "HttpContext", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "httpContextIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_22"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "LinkedErrors", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "linkedErrorsIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_28"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TryCatch", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "browserApiErrorsIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Replay", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getReplay", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_18"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "replayIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_42"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ReplayCanvas", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "replayCanvasIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_41"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Feedback", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "feedbackIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_6"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sendFeedback", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_45"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "captureConsoleIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "contextLinesIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "debugIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["U"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dedupeIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["V"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extraErrorDataIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_4"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "httpClientIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_21"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reportingObserverIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_43"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "rewriteFramesIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_44"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sessionTimingIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_46"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BrowserTracing", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "browserTracingIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaultRequestInstrumentationOptions", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["X"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "instrumentOutgoingRequests", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_25"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "startBrowserTracingNavigationSpan", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_58"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "startBrowserTracingPageLoadSpan", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_59"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "makeBrowserOfflineTransport", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_29"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "onProfilingStartRouteTransaction", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_37"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BrowserProfilingIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "browserProfilingIntegration", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Integrations", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sdk_js__ = __webpack_require__(698);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return __WEBPACK_IMPORTED_MODULE_1__sdk_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profiler_js__ = __webpack_require__(699);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Profiler", function() { return __WEBPACK_IMPORTED_MODULE_2__profiler_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useProfiler", function() { return __WEBPACK_IMPORTED_MODULE_2__profiler_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withProfiler", function() { return __WEBPACK_IMPORTED_MODULE_2__profiler_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errorboundary_js__ = __webpack_require__(703);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorBoundary", function() { return __WEBPACK_IMPORTED_MODULE_3__errorboundary_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withErrorBoundary", function() { return __WEBPACK_IMPORTED_MODULE_3__errorboundary_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_js__ = __webpack_require__(704);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createReduxEnhancer", function() { return __WEBPACK_IMPORTED_MODULE_4__redux_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reactrouterv3_js__ = __webpack_require__(705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactRouterV3BrowserTracingIntegration", function() { return __WEBPACK_IMPORTED_MODULE_5__reactrouterv3_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactRouterV3Instrumentation", function() { return __WEBPACK_IMPORTED_MODULE_5__reactrouterv3_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reactrouter_js__ = __webpack_require__(706);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactRouterV4BrowserTracingIntegration", function() { return __WEBPACK_IMPORTED_MODULE_6__reactrouter_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactRouterV4Instrumentation", function() { return __WEBPACK_IMPORTED_MODULE_6__reactrouter_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactRouterV5BrowserTracingIntegration", function() { return __WEBPACK_IMPORTED_MODULE_6__reactrouter_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactRouterV5Instrumentation", function() { return __WEBPACK_IMPORTED_MODULE_6__reactrouter_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withSentryRouting", function() { return __WEBPACK_IMPORTED_MODULE_6__reactrouter_js__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reactrouterv6_js__ = __webpack_require__(707);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactRouterV6BrowserTracingIntegration", function() { return __WEBPACK_IMPORTED_MODULE_7__reactrouterv6_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactRouterV6Instrumentation", function() { return __WEBPACK_IMPORTED_MODULE_7__reactrouterv6_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withSentryReactRouterV6Routing", function() { return __WEBPACK_IMPORTED_MODULE_7__reactrouterv6_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "wrapCreateBrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_7__reactrouterv6_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "wrapUseRoutes", function() { return __WEBPACK_IMPORTED_MODULE_7__reactrouterv6_js__["e"]; });


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyAggregateErrorsToEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__string_js__ = __webpack_require__(129);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */function applyAggregateErrorsToEvent(exceptionFromErrorImplementation,parser){var maxValueLimit=arguments.length>2&&arguments[2]!==undefined?arguments[2]:250;var key=arguments.length>3?arguments[3]:undefined;var limit=arguments.length>4?arguments[4]:undefined;var event=arguments.length>5?arguments[5]:undefined;var hint=arguments.length>6?arguments[6]:undefined;if(!event.exception||!event.exception.values||!hint||!Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["g" /* isInstanceOf */])(hint.originalException,Error)){return;}// Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
var originalException=event.exception.values.length>0?event.exception.values[event.exception.values.length-1]:undefined;// We only create exception grouping if there is an exception in the event.
if(originalException){event.exception.values=truncateAggregateExceptions(aggregateExceptionsFromError(exceptionFromErrorImplementation,parser,limit,hint.originalException,key,event.exception.values,originalException,0),maxValueLimit);}}function aggregateExceptionsFromError(exceptionFromErrorImplementation,parser,limit,error,key,prevExceptions,exception,exceptionId){if(prevExceptions.length>=limit+1){return prevExceptions;}var newExceptions=_toConsumableArray(prevExceptions);// Recursively call this function in order to walk down a chain of errors
if(Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["g" /* isInstanceOf */])(error[key],Error)){applyExceptionGroupFieldsForParentException(exception,exceptionId);var newException=exceptionFromErrorImplementation(parser,error[key]);var newExceptionId=newExceptions.length;applyExceptionGroupFieldsForChildException(newException,key,newExceptionId,exceptionId);newExceptions=aggregateExceptionsFromError(exceptionFromErrorImplementation,parser,limit,error[key],key,[newException].concat(_toConsumableArray(newExceptions)),newException,newExceptionId);}// This will create exception grouping for AggregateErrors
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
if(Array.isArray(error.errors)){error.errors.forEach(function(childError,i){if(Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["g" /* isInstanceOf */])(childError,Error)){applyExceptionGroupFieldsForParentException(exception,exceptionId);var _newException=exceptionFromErrorImplementation(parser,childError);var _newExceptionId=newExceptions.length;applyExceptionGroupFieldsForChildException(_newException,"errors[".concat(i,"]"),_newExceptionId,exceptionId);newExceptions=aggregateExceptionsFromError(exceptionFromErrorImplementation,parser,limit,childError,key,[_newException].concat(_toConsumableArray(newExceptions)),_newException,_newExceptionId);}});}return newExceptions;}function applyExceptionGroupFieldsForParentException(exception,exceptionId){// Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
exception.mechanism=exception.mechanism||{type:'generic',handled:true};exception.mechanism=_objectSpread({},exception.mechanism,{},exception.type==='AggregateError'&&{is_exception_group:true},{exception_id:exceptionId});}function applyExceptionGroupFieldsForChildException(exception,source,exceptionId,parentId){// Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
exception.mechanism=exception.mechanism||{type:'generic',handled:true};exception.mechanism=_objectSpread({},exception.mechanism,{type:'chained',source:source,exception_id:exceptionId,parent_id:parentId});}/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */function truncateAggregateExceptions(exceptions,maxValueLength){return exceptions.map(function(exception){if(exception.value){exception.value=Object(__WEBPACK_IMPORTED_MODULE_1__string_js__["d" /* truncate */])(exception.value,maxValueLength);}return exception;});}

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addInstrumentationHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__debug_build_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__console_js__ = __webpack_require__(184);
/* unused harmony reexport addConsoleInstrumentationHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_js__ = __webpack_require__(186);
/* unused harmony reexport addClickKeypressInstrumentationHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fetch_js__ = __webpack_require__(187);
/* unused harmony reexport addFetchInstrumentationHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globalError_js__ = __webpack_require__(188);
/* unused harmony reexport addGlobalErrorInstrumentationHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__globalUnhandledRejection_js__ = __webpack_require__(189);
/* unused harmony reexport addGlobalUnhandledRejectionInstrumentationHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__history_js__ = __webpack_require__(190);
/* unused harmony reexport addHistoryInstrumentationHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__xhr_js__ = __webpack_require__(191);
/* unused harmony reexport SENTRY_XHR_DATA_KEY */
/* unused harmony reexport addXhrInstrumentationHandler */
// TODO(v8): Consider moving this file (or at least parts of it) into the browser package. The registered handlers are mostly non-generic and we risk leaking runtime specific code into generic packages.
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 * @deprecated Use the proper function per instrumentation type instead!
 */function addInstrumentationHandler(type,callback){switch(type){case'console':return Object(__WEBPACK_IMPORTED_MODULE_2__console_js__["a" /* addConsoleInstrumentationHandler */])(callback);case'dom':return Object(__WEBPACK_IMPORTED_MODULE_3__dom_js__["a" /* addClickKeypressInstrumentationHandler */])(callback);case'xhr':return Object(__WEBPACK_IMPORTED_MODULE_8__xhr_js__["b" /* addXhrInstrumentationHandler */])(callback);case'fetch':return Object(__WEBPACK_IMPORTED_MODULE_4__fetch_js__["a" /* addFetchInstrumentationHandler */])(callback);case'history':return Object(__WEBPACK_IMPORTED_MODULE_7__history_js__["a" /* addHistoryInstrumentationHandler */])(callback);case'error':return Object(__WEBPACK_IMPORTED_MODULE_5__globalError_js__["a" /* addGlobalErrorInstrumentationHandler */])(callback);case'unhandledrejection':return Object(__WEBPACK_IMPORTED_MODULE_6__globalUnhandledRejection_js__["a" /* addGlobalUnhandledRejectionInstrumentationHandler */])(callback);default:__WEBPACK_IMPORTED_MODULE_0__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__logger_js__["c" /* logger */].warn('unknown instrumentation type:',type);}}

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isBrowser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_js__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__worldwide_js__ = __webpack_require__(18);
/**
 * Returns true if we are in the browser.
 */function isBrowser(){// eslint-disable-next-line no-restricted-globals
return typeof window!=='undefined'&&(!Object(__WEBPACK_IMPORTED_MODULE_0__node_js__["b" /* isNodeEnv */])()||isElectronNodeRenderer());}// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer(){return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
__WEBPACK_IMPORTED_MODULE_1__worldwide_js__["a" /* GLOBAL_OBJ */].process!==undefined&&__WEBPACK_IMPORTED_MODULE_1__worldwide_js__["a" /* GLOBAL_OBJ */].process.type==='renderer');}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return basename; });
/* unused harmony export dirname */
/* unused harmony export isAbsolute */
/* unused harmony export join */
/* unused harmony export normalizePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return relative; });
/* unused harmony export resolve */
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */function normalizeArray(parts,allowAboveRoot){// if the path tries to go above the root, `up` ends up > 0
var up=0;for(var i=parts.length-1;i>=0;i--){var last=parts[i];if(last==='.'){parts.splice(i,1);}else if(last==='..'){parts.splice(i,1);up++;}else if(up){parts.splice(i,1);up--;}}// if the path is allowed to go above the root, restore leading ..s
if(allowAboveRoot){for(;up--;up){parts.unshift('..');}}return parts;}// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe=/^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;/** JSDoc */function splitPath(filename){// Truncate files names greater than 1024 characters to avoid regex dos
// https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
var truncated=filename.length>1024?"<truncated>".concat(filename.slice(-1024)):filename;var parts=splitPathRe.exec(truncated);return parts?parts.slice(1):[];}// path.resolve([from ...], to)
// posix version
/** JSDoc */function resolve(){var resolvedPath='';var resolvedAbsolute=false;for(var i=arguments.length-1;i>=-1&&!resolvedAbsolute;i--){var path=i>=0?i<0||arguments.length<=i?undefined:arguments[i]:'/';// Skip empty entries
if(!path){continue;}resolvedPath="".concat(path,"/").concat(resolvedPath);resolvedAbsolute=path.charAt(0)==='/';}// At this point the path should be resolved to a full absolute path, but
// handle relative paths to be safe (might happen when process.cwd() fails)
// Normalize the path
resolvedPath=normalizeArray(resolvedPath.split('/').filter(function(p){return!!p;}),!resolvedAbsolute).join('/');return(resolvedAbsolute?'/':'')+resolvedPath||'.';}/** JSDoc */function trim(arr){var start=0;for(;start<arr.length;start++){if(arr[start]!==''){break;}}var end=arr.length-1;for(;end>=0;end--){if(arr[end]!==''){break;}}if(start>end){return[];}return arr.slice(start,end-start+1);}// path.relative(from, to)
// posix version
/** JSDoc */function relative(from,to){/* eslint-disable no-param-reassign */from=resolve(from).slice(1);to=resolve(to).slice(1);/* eslint-enable no-param-reassign */var fromParts=trim(from.split('/'));var toParts=trim(to.split('/'));var length=Math.min(fromParts.length,toParts.length);var samePartsLength=length;for(var i=0;i<length;i++){if(fromParts[i]!==toParts[i]){samePartsLength=i;break;}}var outputParts=[];for(var _i=samePartsLength;_i<fromParts.length;_i++){outputParts.push('..');}outputParts=outputParts.concat(toParts.slice(samePartsLength));return outputParts.join('/');}// path.normalize(path)
// posix version
/** JSDoc */function normalizePath(path){var isPathAbsolute=isAbsolute(path);var trailingSlash=path.slice(-1)==='/';// Normalize the path
var normalizedPath=normalizeArray(path.split('/').filter(function(p){return!!p;}),!isPathAbsolute).join('/');if(!normalizedPath&&!isPathAbsolute){normalizedPath='.';}if(normalizedPath&&trailingSlash){normalizedPath+='/';}return(isPathAbsolute?'/':'')+normalizedPath;}// posix version
/** JSDoc */function isAbsolute(path){return path.charAt(0)==='/';}// posix version
/** JSDoc */function join(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return normalizePath(args.join('/'));}/** JSDoc */function dirname(path){var result=splitPath(path);var root=result[0];var dir=result[1];if(!root&&!dir){// No dirname whatsoever
return'.';}if(dir){// It has a dirname, strip trailing slash
dir=dir.slice(0,dir.length-1);}return root+dir;}/** JSDoc */function basename(path,ext){var f=splitPath(path)[2];if(ext&&f.slice(ext.length*-1)===ext){f=f.slice(0,f.length-ext.length);}return f;}

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makePromiseBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncpromise_js__ = __webpack_require__(290);
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */function makePromiseBuffer(limit){var buffer=[];function isReady(){return limit===undefined||buffer.length<limit;}/**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */function remove(task){return buffer.splice(buffer.indexOf(task),1)[0];}/**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */function add(taskProducer){if(!isReady()){return Object(__WEBPACK_IMPORTED_MODULE_1__syncpromise_js__["b" /* rejectedSyncPromise */])(new __WEBPACK_IMPORTED_MODULE_0__error_js__["a" /* SentryError */]('Not adding Promise because buffer limit was reached.'));}// start the task and add its promise to the queue
var task=taskProducer();if(buffer.indexOf(task)===-1){buffer.push(task);}void task.then(function(){return remove(task);})// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
// rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
// have promises, so TS has to polyfill when down-compiling.)
.then(null,function(){return remove(task).then(null,function(){// We have to add another catch here because `remove()` starts a new promise chain.
});});return task;}/**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */function drain(timeout){return new __WEBPACK_IMPORTED_MODULE_1__syncpromise_js__["a" /* SyncPromise */](function(resolve,reject){var counter=buffer.length;if(!counter){return resolve(true);}// wait for `timeout` ms and then resolve to `false` (if not cancelled first)
var capturedSetTimeout=setTimeout(function(){if(timeout&&timeout>0){resolve(false);}},timeout);// if all promises resolve in time, cancel the timer and resolve to `true`
buffer.forEach(function(item){void Object(__WEBPACK_IMPORTED_MODULE_1__syncpromise_js__["c" /* resolvedSyncPromise */])(item).then(function(){if(! --counter){clearTimeout(capturedSetTimeout);resolve(true);}},reject);});});}return{$:buffer,add:add,drain:drain};}

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_USER_INCLUDES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addRequestDataToEvent; });
/* unused harmony export addRequestDataToTransaction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return extractPathForTransaction; });
/* unused harmony export extractRequestData */
/* unused harmony export winterCGHeadersToDict */
/* unused harmony export winterCGRequestToRequestData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cookie_js__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__normalize_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__url_js__ = __webpack_require__(291);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}var DEFAULT_INCLUDES={ip:false,request:true,transaction:true,user:true};var DEFAULT_REQUEST_INCLUDES=['cookies','data','headers','method','query_string','url'];var DEFAULT_USER_INCLUDES=['id','username','email'];/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request.
 *
 * @deprecated This utility will be removed in v8.
 */function addRequestDataToTransaction(transaction,req,deps){if(!transaction)return;// eslint-disable-next-line deprecation/deprecation
if(!transaction.metadata.source||transaction.metadata.source==='url'){// Attempt to grab a parameterized route off of the request
var _extractPathForTransa=extractPathForTransaction(req,{path:true,method:true}),_extractPathForTransa2=_slicedToArray(_extractPathForTransa,2),name=_extractPathForTransa2[0],source=_extractPathForTransa2[1];transaction.updateName(name);// TODO: SEMANTIC_ATTRIBUTE_SENTRY_SOURCE is in core, align this once we merge utils & core
// eslint-disable-next-line deprecation/deprecation
transaction.setMetadata({source:source});}transaction.setAttribute('url',req.originalUrl||req.url);if(req.baseUrl){transaction.setAttribute('baseUrl',req.baseUrl);}// TODO: We need to rewrite this to a flat format?
// eslint-disable-next-line deprecation/deprecation
transaction.setData('query',extractQueryParams(req,deps));}/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */function extractPathForTransaction(req){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var method=req.method&&req.method.toUpperCase();var path='';var source='url';// Check to see if there's a parameterized route we can use (as there is in Express)
if(options.customRoute||req.route){path=options.customRoute||"".concat(req.baseUrl||'').concat(req.route&&req.route.path);source='route';}// Otherwise, just take the original URL
else if(req.originalUrl||req.url){path=Object(__WEBPACK_IMPORTED_MODULE_5__url_js__["c" /* stripUrlQueryAndFragment */])(req.originalUrl||req.url||'');}var name='';if(options.method&&method){name+=method;}if(options.method&&options.path){name+=' ';}if(options.path&&path){name+=path;}return[name,source];}/** JSDoc */function extractTransaction(req,type){switch(type){case'path':{return extractPathForTransaction(req,{path:true})[0];}case'handler':{return req.route&&req.route.stack&&req.route.stack[0]&&req.route.stack[0].name||'<anonymous>';}case'methodPath':default:{// if exist _reconstructedRoute return that path instead of route.path
var customRoute=req._reconstructedRoute?req._reconstructedRoute:undefined;return extractPathForTransaction(req,{path:true,method:true,customRoute:customRoute})[0];}}}/** JSDoc */function extractUserData(user,keys){var extractedUser={};var attributes=Array.isArray(keys)?keys:DEFAULT_USER_INCLUDES;attributes.forEach(function(key){if(user&&key in user){extractedUser[key]=user[key];}});return extractedUser;}/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */function extractRequestData(req,options){var _ref=options||{},_ref$include=_ref.include,include=_ref$include===void 0?DEFAULT_REQUEST_INCLUDES:_ref$include,deps=_ref.deps;// eslint-disable-next-line @typescript-eslint/no-explicit-any
var requestData={};// headers:
//   node, express, koa, nextjs: req.headers
var headers=req.headers||{};// method:
//   node, express, koa, nextjs: req.method
var method=req.method;// host:
//   express: req.hostname in > 4 and req.host in < 4
//   koa: req.host
//   node, nextjs: req.headers.host
// Express 4 mistakenly strips off port number from req.host / req.hostname so we can't rely on them
// See: https://github.com/expressjs/express/issues/3047#issuecomment-236653223
// Also: https://github.com/getsentry/sentry-javascript/issues/1917
var host=headers.host||req.hostname||req.host||'<no host>';// protocol:
//   node, nextjs: <n/a>
//   express, koa: req.protocol
var protocol=req.protocol==='https'||req.socket&&req.socket.encrypted?'https':'http';// url (including path and query string):
//   node, express: req.originalUrl
//   koa, nextjs: req.url
var originalUrl=req.originalUrl||req.url||'';// absolute url
var absoluteUrl=originalUrl.startsWith(protocol)?originalUrl:"".concat(protocol,"://").concat(host).concat(originalUrl);include.forEach(function(key){switch(key){case'headers':{requestData.headers=headers;// Remove the Cookie header in case cookie data should not be included in the event
if(!include.includes('cookies')){delete requestData.headers.cookie;}break;}case'method':{requestData.method=method;break;}case'url':{requestData.url=absoluteUrl;break;}case'cookies':{// cookies:
//   node, express, koa: req.headers.cookie
//   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
requestData.cookies=// TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
// come off in v8
req.cookies||headers.cookie&&Object(__WEBPACK_IMPORTED_MODULE_0__cookie_js__["a" /* parseCookie */])(headers.cookie)||{};break;}case'query_string':{// query string:
//   node: req.url (raw)
//   express, koa, nextjs: req.query
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
requestData.query_string=extractQueryParams(req,deps);break;}case'data':{if(method==='GET'||method==='HEAD'){break;}// body data:
//   express, koa, nextjs: req.body
//
//   when using node by itself, you have to read the incoming stream(see
//   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
//   where they're going to store the final result, so they'll have to capture this data themselves
if(req.body!==undefined){requestData.data=Object(__WEBPACK_IMPORTED_MODULE_2__is_js__["m" /* isString */])(req.body)?req.body:JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_4__normalize_js__["a" /* normalize */])(req.body));}break;}default:{if({}.hasOwnProperty.call(req,key)){requestData[key]=req[key];}}}});return requestData;}/**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @returns The mutated `Event` object
 */function addRequestDataToEvent(event,req,options){var include=_objectSpread({},DEFAULT_INCLUDES,{},options&&options.include);if(include.request){var extractedRequestData=Array.isArray(include.request)?extractRequestData(req,{include:include.request,deps:options&&options.deps}):extractRequestData(req,{deps:options&&options.deps});event.request=_objectSpread({},event.request,{},extractedRequestData);}if(include.user){var extractedUser=req.user&&Object(__WEBPACK_IMPORTED_MODULE_2__is_js__["j" /* isPlainObject */])(req.user)?extractUserData(req.user,include.user):{};if(Object.keys(extractedUser).length){event.user=_objectSpread({},event.user,{},extractedUser);}}// client ip:
//   node, nextjs: req.socket.remoteAddress
//   express, koa: req.ip
if(include.ip){var ip=req.ip||req.socket&&req.socket.remoteAddress;if(ip){event.user=_objectSpread({},event.user,{ip_address:ip});}}if(include.transaction&&!event.transaction){// TODO do we even need this anymore?
// TODO make this work for nextjs
event.transaction=extractTransaction(req,include.transaction);}return event;}function extractQueryParams(req,deps){// url (including path and query string):
//   node, express: req.originalUrl
//   koa, nextjs: req.url
var originalUrl=req.originalUrl||req.url||'';if(!originalUrl){return;}// The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
// hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
if(originalUrl.startsWith('/')){originalUrl="http://dogs.are.great".concat(originalUrl);}try{return req.query||typeof URL!=='undefined'&&new URL(originalUrl).search.slice(1)||// In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
deps&&deps.url&&deps.url.parse(originalUrl).query||undefined;}catch(e2){return undefined;}}/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */// TODO(v8): Make this function return undefined when the extraction fails.
function winterCGHeadersToDict(winterCGHeaders){var headers={};try{winterCGHeaders.forEach(function(value,key){if(typeof value==='string'){// We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
headers[key]=value;}});}catch(e){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_3__logger_js__["c" /* logger */].warn('Sentry failed extracting headers from a request object. If you see this, please file an issue.');}return headers;}/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */function winterCGRequestToRequestData(req){var headers=winterCGHeadersToDict(req.headers);return{method:req.method,url:req.url,headers:headers};}

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseCookie; });
/**
 * This code was originally copied from the 'cookie` module at v0.5.0 and was simplified for our use case.
 * https://github.com/jshttp/cookie/blob/a0c84147aab6266bdb3996cf4062e93907c0b0fc/index.js
 * It had the following license:
 *
 * (The MIT License)
 *
 * Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
 * Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *//**
 * Parses a cookie string
 */function parseCookie(str){var obj={};var index=0;while(index<str.length){var eqIdx=str.indexOf('=',index);// no more cookie pairs
if(eqIdx===-1){break;}var endIdx=str.indexOf(';',index);if(endIdx===-1){endIdx=str.length;}else if(endIdx<eqIdx){// backtrack on prior semicolon
index=str.lastIndexOf(';',eqIdx-1)+1;continue;}var key=str.slice(index,eqIdx).trim();// only assign once
if(undefined===obj[key]){var val=str.slice(eqIdx+1,endIdx).trim();// quoted values
if(val.charCodeAt(0)===0x22){val=val.slice(1,-1);}try{obj[key]=val.indexOf('%')!==-1?decodeURIComponent(val):val;}catch(e){obj[key]=val;}}index=endIdx+1;}return obj;}

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export severityFromString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return severityLevelFromString; });
/* unused harmony export validSeverityLevels */
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
var validSeverityLevels=['fatal','error','warning','log','info','debug'];/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */function severityFromString(level){return severityLevelFromString(level);}/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */function severityLevelFromString(level){return level==='warn'?'warning':validSeverityLevels.includes(level)?level:'log';}

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TRACEPARENT_REGEXP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return extractTraceparentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateSentryTraceHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return propagationContextFromHeaders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tracingContextFromHeaders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baggage_js__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_js__ = __webpack_require__(131);
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
var TRACEPARENT_REGEXP=new RegExp('^[ \\t]*'+// whitespace
'([0-9a-f]{32})?'+// trace_id
'-?([0-9a-f]{16})?'+// span_id
'-?([01])?'+// sampled
'[ \\t]*$')// whitespace
;/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */function extractTraceparentData(traceparent){if(!traceparent){return undefined;}var matches=traceparent.match(TRACEPARENT_REGEXP);if(!matches){return undefined;}var parentSampled;if(matches[3]==='1'){parentSampled=true;}else if(matches[3]==='0'){parentSampled=false;}return{traceId:matches[1],parentSampled:parentSampled,parentSpanId:matches[2]};}/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */// TODO(v8): Remove this function
function tracingContextFromHeaders(sentryTrace,baggage){var traceparentData=extractTraceparentData(sentryTrace);var dynamicSamplingContext=Object(__WEBPACK_IMPORTED_MODULE_0__baggage_js__["b" /* baggageHeaderToDynamicSamplingContext */])(baggage);var _ref=traceparentData||{},traceId=_ref.traceId,parentSpanId=_ref.parentSpanId,parentSampled=_ref.parentSampled;if(!traceparentData){return{traceparentData:traceparentData,dynamicSamplingContext:undefined,propagationContext:{traceId:traceId||Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["g" /* uuid4 */])(),spanId:Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["g" /* uuid4 */])().substring(16)}};}else{return{traceparentData:traceparentData,dynamicSamplingContext:dynamicSamplingContext||{},// If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
propagationContext:{traceId:traceId||Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["g" /* uuid4 */])(),parentSpanId:parentSpanId||Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["g" /* uuid4 */])().substring(16),spanId:Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["g" /* uuid4 */])().substring(16),sampled:parentSampled,dsc:dynamicSamplingContext||{}// If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
}};}}/**
 * Create a propagation context from incoming headers.
 */function propagationContextFromHeaders(sentryTrace,baggage){var traceparentData=extractTraceparentData(sentryTrace);var dynamicSamplingContext=Object(__WEBPACK_IMPORTED_MODULE_0__baggage_js__["b" /* baggageHeaderToDynamicSamplingContext */])(baggage);var _ref2=traceparentData||{},traceId=_ref2.traceId,parentSpanId=_ref2.parentSpanId,parentSampled=_ref2.parentSampled;if(!traceparentData){return{traceId:traceId||Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["g" /* uuid4 */])(),spanId:Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["g" /* uuid4 */])().substring(16)};}else{return{traceId:traceId||Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["g" /* uuid4 */])(),parentSpanId:parentSpanId||Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["g" /* uuid4 */])().substring(16),spanId:Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["g" /* uuid4 */])().substring(16),sampled:parentSampled,dsc:dynamicSamplingContext||{}// If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
};}}/**
 * Create sentry-trace header from span context values.
 */function generateSentryTraceHeader(){var traceId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["g" /* uuid4 */])();var spanId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["g" /* uuid4 */])().substring(16);var sampled=arguments.length>2?arguments[2]:undefined;var sampledString='';if(sampled!==undefined){sampledString=sampled?'-1':'-0';}return"".concat(traceId,"-").concat(spanId).concat(sampledString);}

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createClientReportEnvelope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__envelope_js__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__time_js__ = __webpack_require__(292);
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */function createClientReportEnvelope(discarded_events,dsn,timestamp){var clientReportItem=[{type:'client_report'},{timestamp:timestamp||Object(__WEBPACK_IMPORTED_MODULE_1__time_js__["b" /* dateTimestampInSeconds */])(),discarded_events:discarded_events}];return Object(__WEBPACK_IMPORTED_MODULE_0__envelope_js__["c" /* createEnvelope */])(dsn?{dsn:dsn}:{},[clientReportItem]);}

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_RETRY_AFTER */
/* unused harmony export disabledUntil */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isRateLimited; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseRetryAfterHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateRateLimits; });
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
var DEFAULT_RETRY_AFTER=60*1000;// 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */function parseRetryAfterHeader(header){var now=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Date.now();var headerDelay=parseInt("".concat(header),10);if(!isNaN(headerDelay)){return headerDelay*1000;}var headerDate=Date.parse("".concat(header));if(!isNaN(headerDate)){return headerDate-now;}return DEFAULT_RETRY_AFTER;}/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */function disabledUntil(limits,dataCategory){return limits[dataCategory]||limits.all||0;}/**
 * Checks if a category is rate limited
 */function isRateLimited(limits,dataCategory){var now=arguments.length>2&&arguments[2]!==undefined?arguments[2]:Date.now();return disabledUntil(limits,dataCategory)>now;}/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */function updateRateLimits(limits,_ref){var statusCode=_ref.statusCode,headers=_ref.headers;var now=arguments.length>2&&arguments[2]!==undefined?arguments[2]:Date.now();var updatedRateLimits=_objectSpread({},limits);// "The name is case-insensitive."
// https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
var rateLimitHeader=headers&&headers['x-sentry-rate-limits'];var retryAfterHeader=headers&&headers['retry-after'];if(rateLimitHeader){/**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=rateLimitHeader.trim().split(',')[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var limit=_step.value;var _limit$split=limit.split(':',5),_limit$split2=_slicedToArray(_limit$split,5),retryAfter=_limit$split2[0],categories=_limit$split2[1],namespaces=_limit$split2[4];var headerDelay=parseInt(retryAfter,10);var delay=(!isNaN(headerDelay)?headerDelay:60)*1000;// 60sec default
if(!categories){updatedRateLimits.all=now+delay;}else{var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=categories.split(';')[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var category=_step2.value;if(category==='metric_bucket'){// namespaces will be present when category === 'metric_bucket'
if(!namespaces||namespaces.split(';').includes('custom')){updatedRateLimits[category]=now+delay;}}else{updatedRateLimits[category]=now+delay;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return!=null){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}else if(retryAfterHeader){updatedRateLimits.all=now+parseRetryAfterHeader(retryAfterHeader,now);}else if(statusCode===429){updatedRateLimits.all=now+60*1000;}return updatedRateLimits;}

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addOrUpdateIntegration */
function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj,keyPath,value){// Ex. foo.bar.zoop will extract foo and bar.zoop
var match=keyPath.match(/([a-z_]+)\.(.*)/i);// The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
if(match===null){obj[keyPath]=value;}else{// `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
var innerObj=obj[match[1]];setNestedKey(innerObj,match[2],value);}}/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 *
 * @deprecated This will be removed in v8.
 */function addOrUpdateIntegration(defaultIntegrationInstance,userIntegrations){var forcedOptions=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};return Array.isArray(userIntegrations)?addOrUpdateIntegrationInArray(defaultIntegrationInstance,userIntegrations,forcedOptions):addOrUpdateIntegrationInFunction(defaultIntegrationInstance,// Somehow TS can't figure out that not being an array makes this necessarily a function
userIntegrations,forcedOptions);}function addOrUpdateIntegrationInArray(defaultIntegrationInstance,userIntegrations,forcedOptions){var userInstance=userIntegrations.find(function(integration){return integration.name===defaultIntegrationInstance.name;});if(userInstance){for(var _i=0,_Object$entries=Object.entries(forcedOptions);_i<_Object$entries.length;_i++){var _Object$entries$_i=_slicedToArray(_Object$entries[_i],2),keyPath=_Object$entries$_i[0],value=_Object$entries$_i[1];setNestedKey(userInstance,keyPath,value);}return userIntegrations;}return[].concat(_toConsumableArray(userIntegrations),[defaultIntegrationInstance]);}function addOrUpdateIntegrationInFunction(defaultIntegrationInstance,userIntegrationsFunc,forcedOptions){var wrapper=function wrapper(defaultIntegrations){var userFinalIntegrations=userIntegrationsFunc(defaultIntegrations);// There are instances where we want the user to be able to prevent an integration from appearing at all, which they
// would do by providing a function which filters out the integration in question. If that's happened in one of
// those cases, don't add our default back in.
if(defaultIntegrationInstance.allowExclusionByUser){var userFinalInstance=userFinalIntegrations.find(function(integration){return integration.name===defaultIntegrationInstance.name;});if(!userFinalInstance){return userFinalIntegrations;}}return addOrUpdateIntegrationInArray(defaultIntegrationInstance,userFinalIntegrations,forcedOptions);};return wrapper;}

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makeFifoCache */
/**
 * Creates a cache that evicts keys in fifo order
 * @param size {Number}
 */function makeFifoCache(size){// Maintain a fifo queue of keys, we cannot rely on Object.keys as the browser may not support it.
var evictionOrder=[];var cache={};return{add:function add(key,value){while(evictionOrder.length>=size){// shift is O(n) but this is small size and only happens if we are
// exceeding the cache size so it should be fine.
var evictCandidate=evictionOrder.shift();if(evictCandidate!==undefined){// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
delete cache[evictCandidate];}}// in case we have a collision, delete the old key.
if(cache[key]){this.delete(key);}evictionOrder.push(key);cache[key]=value;},clear:function clear(){cache={};evictionOrder=[];},get:function get(key){return cache[key];},size:function size(){return evictionOrder.length;},// Delete cache key and return true if it existed, false otherwise.
delete:function _delete(key){if(!cache[key]){return false;}// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
delete cache[key];for(var i=0;i<evictionOrder.length;i++){if(evictionOrder[i]===key){evictionOrder.splice(i,1);break;}}return true;}};}

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventFromMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eventFromUnknownInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return exceptionFromError; });
/* unused harmony export parseStackFrames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__normalize_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__object_js__ = __webpack_require__(36);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Extracts stack frames from the error.stack string
 */function parseStackFrames(stackParser,error){return stackParser(error.stack||'',1);}/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */function exceptionFromError(stackParser,error){var exception={type:error.name||error.constructor.name,value:error.message};var frames=parseStackFrames(stackParser,error);if(frames.length){exception.stacktrace={frames:frames};}return exception;}function getMessageForObject(exception){if('name'in exception&&typeof exception.name==='string'){var message="'".concat(exception.name,"' captured as exception");if('message'in exception&&typeof exception.message==='string'){message+=" with message '".concat(exception.message,"'");}return message;}else if('message'in exception&&typeof exception.message==='string'){return exception.message;}else{// This will allow us to group events based on top-level keys
// which is much better than creating new group when any key/value change
return"Object captured as exception with keys: ".concat(Object(__WEBPACK_IMPORTED_MODULE_3__object_js__["d" /* extractExceptionKeysForMessage */])(exception));}}/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */function eventFromUnknownInput(// eslint-disable-next-line deprecation/deprecation
getHubOrClient,stackParser,exception,hint){var client=typeof getHubOrClient==='function'?// eslint-disable-next-line deprecation/deprecation
getHubOrClient().getClient():getHubOrClient;var ex=exception;var providedMechanism=hint&&hint.data&&hint.data.mechanism;var mechanism=providedMechanism||{handled:true,type:'generic'};var extras;if(!Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["d" /* isError */])(exception)){if(Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["j" /* isPlainObject */])(exception)){var normalizeDepth=client&&client.getOptions().normalizeDepth;extras=_defineProperty({},'__serialized__',Object(__WEBPACK_IMPORTED_MODULE_2__normalize_js__["b" /* normalizeToSize */])(exception,normalizeDepth));var message=getMessageForObject(exception);ex=hint&&hint.syntheticException||new Error(message);ex.message=message;}else{// This handles when someone does: `throw "something awesome";`
// We use synthesized Error here so we can extract a (rough) stack trace.
ex=hint&&hint.syntheticException||new Error(exception);ex.message=exception;}mechanism.synthetic=true;}var event={exception:{values:[exceptionFromError(stackParser,ex)]}};if(extras){event.extra=extras;}Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["c" /* addExceptionTypeValue */])(event,undefined,undefined);Object(__WEBPACK_IMPORTED_MODULE_1__misc_js__["b" /* addExceptionMechanism */])(event,mechanism);return _objectSpread({},event,{event_id:hint&&hint.event_id});}/**
 * Builds and Event from a Message
 * @hidden
 */function eventFromMessage(stackParser,message){var level=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'info';var hint=arguments.length>3?arguments[3]:undefined;var attachStacktrace=arguments.length>4?arguments[4]:undefined;var event={event_id:hint&&hint.event_id,level:level};if(attachStacktrace&&hint&&hint.syntheticException){var frames=parseStackFrames(stackParser,hint.syntheticException);if(frames.length){event.exception={values:[{value:message,stacktrace:{frames:frames}}]};}}if(Object(__WEBPACK_IMPORTED_MODULE_0__is_js__["i" /* isParameterizedString */])(message)){var __sentry_template_string__=message.__sentry_template_string__,__sentry_template_values__=message.__sentry_template_values__;event.logentry={message:__sentry_template_string__,params:__sentry_template_values__};return event;}event.message=message;return event;}

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export callFrameToStackFrame */
/* unused harmony export watchdogTimer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_stack_trace_js__ = __webpack_require__(130);
/**
 * A node.js watchdog timer
 * @param pollInterval The interval that we expect to get polled at
 * @param anrThreshold The threshold for when we consider ANR
 * @param callback The callback to call for ANR
 * @returns An object with `poll` and `enabled` functions {@link WatchdogReturn}
 */function watchdogTimer(createTimer,pollInterval,anrThreshold,callback){var timer=createTimer();var triggered=false;var _enabled=true;setInterval(function(){var diffMs=timer.getTimeMs();if(triggered===false&&diffMs>pollInterval+anrThreshold){triggered=true;if(_enabled){callback();}}if(diffMs<pollInterval+anrThreshold){triggered=false;}},20);return{poll:function poll(){timer.reset();},enabled:function enabled(state){_enabled=state;}};}// types copied from inspector.d.ts
/**
 * Converts Debugger.CallFrame to Sentry StackFrame
 */function callFrameToStackFrame(frame,url,getModuleFromFilename){var filename=url?url.replace(/^file:\/\//,''):undefined;// CallFrame row/col are 0 based, whereas StackFrame are 1 based
var colno=frame.location.columnNumber?frame.location.columnNumber+1:undefined;var lineno=frame.location.lineNumber?frame.location.lineNumber+1:undefined;return Object(__WEBPACK_IMPORTED_MODULE_0__object_js__["c" /* dropUndefinedKeys */])({filename:filename,module:getModuleFromFilename(filename),function:frame.functionName||'?',colno:colno,lineno:lineno,in_app:filename?Object(__WEBPACK_IMPORTED_MODULE_1__node_stack_trace_js__["a" /* filenameIsInApp */])(filename):undefined});}

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LRUMap */
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/** A simple Least Recently Used map */var LRUMap=/*#__PURE__*/function(){function LRUMap(_maxSize){_classCallCheck(this,LRUMap);this._maxSize=_maxSize;this._cache=new Map();}/** Get the current size of the cache */_createClass(LRUMap,[{key:"get",/** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */value:function get(key){var value=this._cache.get(key);if(value===undefined){return undefined;}// Remove and re-insert to update the order
this._cache.delete(key);this._cache.set(key,value);return value;}/** Insert an entry and evict an older entry if we've reached maxSize */},{key:"set",value:function set(key,value){if(this._cache.size>=this._maxSize){// keys() returns an iterator in insertion order so keys().next() gives us the oldest key
this._cache.delete(this._cache.keys().next().value);}this._cache.set(key,value);}/** Remove an entry and return the entry if it was in the cache */},{key:"remove",value:function remove(key){var value=this._cache.get(key);if(value){this._cache.delete(key);}return value;}/** Clear all entries */},{key:"clear",value:function clear(){this._cache.clear();}/** Get all the keys */},{key:"keys",value:function keys(){return Array.from(this._cache.keys());}/** Get all the values */},{key:"values",value:function values(){var values=[];this._cache.forEach(function(value){return values.push(value);});return values;}},{key:"size",get:function get(){return this._cache.size;}}]);return LRUMap;}();

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _asyncNullishCoalesce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nullishCoalesce_js__ = __webpack_require__(295);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
/**
 * Polyfill for the nullish coalescing operator (`??`), when used in situations where at least one of the values is the
 * result of an async operation.
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */function _asyncNullishCoalesce(_x,_x2){return _asyncNullishCoalesce2.apply(this,arguments);}// Sucrase version:
// async function _asyncNullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return await rhsFn();
//   }
// }
function _asyncNullishCoalesce2(){_asyncNullishCoalesce2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(lhs,rhsFn){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt("return",Object(__WEBPACK_IMPORTED_MODULE_0__nullishCoalesce_js__["a" /* _nullishCoalesce */])(lhs,rhsFn));case 1:case"end":return _context.stop();}}},_callee);}));return _asyncNullishCoalesce2.apply(this,arguments);}

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _asyncOptionalChainDelete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asyncOptionalChain_js__ = __webpack_require__(296);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions, in cases where the value of the expression is to be deleted.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase) See
 * https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The return value of the `delete` operator: `true`, unless the deletion target is an own, non-configurable
 * property (one which can't be deleted or turned into an accessor, and whose enumerability can't be changed), in which
 * case `false`.
 */function _asyncOptionalChainDelete(_x){return _asyncOptionalChainDelete2.apply(this,arguments);}// Sucrase version:
// async function asyncOptionalChainDelete(ops) {
//   const result = await ASYNC_OPTIONAL_CHAIN_NAME(ops);
//   return result == null ? true : result;
// }
function _asyncOptionalChainDelete2(){_asyncOptionalChainDelete2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(ops){var result;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_0__asyncOptionalChain_js__["a" /* _asyncOptionalChain */])(ops);case 2:result=_context.sent;return _context.abrupt("return",result==null?true:result);case 4:case"end":return _context.stop();}}},_callee);}));return _asyncOptionalChainDelete2.apply(this,arguments);}

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _optionalChainDelete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__optionalChain_js__ = __webpack_require__(297);
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions, in cases where the value of the expression is to be deleted.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase) See
 * https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The return value of the `delete` operator: `true`, unless the deletion target is an own, non-configurable
 * property (one which can't be deleted or turned into an accessor, and whose enumerability can't be changed), in which
 * case `false`.
 */function _optionalChainDelete(ops){var result=Object(__WEBPACK_IMPORTED_MODULE_0__optionalChain_js__["a" /* _optionalChain */])(ops);// If `result` is `null`, it means we didn't get to the end of the chain and so nothing was deleted (in which case,
// return `true` since that's what `delete` does when it no-ops). If it's non-null, we know the delete happened, in
// which case we return whatever the `delete` returned, which will be a boolean.
return result==null?true:result;}// Sucrase version:
// function _optionalChainDelete(ops) {
//   const result = _optionalChain(ops);
//   // by checking for loose equality to `null`, we catch both `null` and `undefined`
//   return result == null ? true : result;
// }


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export escapeStringForRegex */
// Based on https://github.com/sindresorhus/escape-string-regexp but with modifications to:
//   a) reduce the size by skipping the runtime type - checking
//   b) ensure it gets down - compiled for old versions of Node(the published package only supports Node 12+).
//
// MIT License
//
// Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
// documentation files(the "Software"), to deal in the Software without restriction, including without limitation
// the rights to use, copy, modify, merge, publish, distribute, sublicense, and / or sell copies of the Software, and
// to permit persons to whom the Software is furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of
// the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
// THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
// IN THE SOFTWARE.
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */function escapeStringForRegex(regexString){// escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
// discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
return regexString.replace(/[|\\{}()[\]^$+*?.]/g,'\\$&').replace(/-/g,'\\x2d');}

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setMeasurement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(198);
/**
 * Adds a measurement to the current active transaction.
 */function setMeasurement(name,value,unit){// eslint-disable-next-line deprecation/deprecation
var transaction=Object(__WEBPACK_IMPORTED_MODULE_0__utils_js__["b" /* getActiveTransaction */])();if(transaction){// eslint-disable-next-line deprecation/deprecation
transaction.setMeasurement(name,value,unit);}}

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createMetricEnvelope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(136);
/**
 * Create envelope from a metric aggregate.
 */function createMetricEnvelope(metricBucketItems,dsn,metadata,tunnel){var headers={sent_at:new Date().toISOString()};if(metadata&&metadata.sdk){headers.sdk={name:metadata.sdk.name,version:metadata.sdk.version};}if(!!tunnel&&dsn){headers.dsn=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["J" /* dsnToString */])(dsn);}var item=createMetricEnvelopeItem(metricBucketItems);return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* createEnvelope */])(headers,[item]);}function createMetricEnvelopeItem(metricBucketItems){var payload=Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["e" /* serializeMetricBuckets */])(metricBucketItems);var metricHeaders={type:'statsd',length:payload.length};return[metricHeaders,payload];}

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ServerRuntimeClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseclient_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkin_js__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exports_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__metrics_aggregator_js__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sessionflusher_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tracing_hubextensions_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_spanUtils_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getRootSpan_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tracing_spanstatus_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tracing_dynamicSamplingContext_js__ = __webpack_require__(84);
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _get(target,property,receiver){if(typeof Reflect!=="undefined"&&Reflect.get){_get=Reflect.get;}else{_get=function _get(target,property,receiver){var base=_superPropBase(target,property);if(!base)return;var desc=Object.getOwnPropertyDescriptor(base,property);if(desc.get){return desc.get.call(receiver);}return desc.value;};}return _get(target,property,receiver||target);}function _superPropBase(object,property){while(!Object.prototype.hasOwnProperty.call(object,property)){object=_getPrototypeOf(object);if(object===null)break;}return object;}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}/**
 * The Sentry Server Runtime Client SDK.
 */var ServerRuntimeClient=/*#__PURE__*/function(_BaseClient){_inherits(ServerRuntimeClient,_BaseClient);/**
   * Creates a new Edge SDK instance.
   * @param options Configuration options for this SDK.
   */function ServerRuntimeClient(options){var _this;_classCallCheck(this,ServerRuntimeClient);// Server clients always support tracing
Object(__WEBPACK_IMPORTED_MODULE_7__tracing_hubextensions_js__["a" /* addTracingExtensions */])();_this=_possibleConstructorReturn(this,_getPrototypeOf(ServerRuntimeClient).call(this,options));if(options._experiments&&options._experiments['metricsAggregator']){_this.metricsAggregator=new __WEBPACK_IMPORTED_MODULE_5__metrics_aggregator_js__["a" /* MetricsAggregator */](_assertThisInitialized(_this));}return _this;}/**
   * @inheritDoc
   */_createClass(ServerRuntimeClient,[{key:"eventFromException",value:function eventFromException(exception,hint){return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_38" /* resolvedSyncPromise */])(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["P" /* eventFromUnknownInput */])(Object(__WEBPACK_IMPORTED_MODULE_4__exports_js__["j" /* getClient */])(),this._options.stackParser,exception,hint));}/**
   * @inheritDoc
   */},{key:"eventFromMessage",value:function eventFromMessage(message){var level=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'info';var hint=arguments.length>2?arguments[2]:undefined;return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_38" /* resolvedSyncPromise */])(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["O" /* eventFromMessage */])(this._options.stackParser,message,level,hint,this._options.attachStacktrace));}/**
   * @inheritDoc
   */// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
},{key:"captureException",value:function captureException(exception,hint,scope){// Check if the flag `autoSessionTracking` is enabled, and if `_sessionFlusher` exists because it is initialised only
// when the `requestHandler` middleware is used, and hence the expectation is to have SessionAggregates payload
// sent to the Server only when the `requestHandler` middleware is used
if(this._options.autoSessionTracking&&this._sessionFlusher&&scope){var requestSession=scope.getRequestSession();// Necessary checks to ensure this is code block is executed only within a request
// Should override the status only if `requestSession.status` is `Ok`, which is its initial stage
if(requestSession&&requestSession.status==='ok'){requestSession.status='errored';}}return _get(_getPrototypeOf(ServerRuntimeClient.prototype),"captureException",this).call(this,exception,hint,scope);}/**
   * @inheritDoc
   */},{key:"captureEvent",value:function captureEvent(event,hint,scope){// Check if the flag `autoSessionTracking` is enabled, and if `_sessionFlusher` exists because it is initialised only
// when the `requestHandler` middleware is used, and hence the expectation is to have SessionAggregates payload
// sent to the Server only when the `requestHandler` middleware is used
if(this._options.autoSessionTracking&&this._sessionFlusher&&scope){var eventType=event.type||'exception';var isException=eventType==='exception'&&event.exception&&event.exception.values&&event.exception.values.length>0;// If the event is of type Exception, then a request session should be captured
if(isException){var requestSession=scope.getRequestSession();// Ensure that this is happening within the bounds of a request, and make sure not to override
// Session Status if Errored / Crashed
if(requestSession&&requestSession.status==='ok'){requestSession.status='errored';}}}return _get(_getPrototypeOf(ServerRuntimeClient.prototype),"captureEvent",this).call(this,event,hint,scope);}/**
   *
   * @inheritdoc
   */},{key:"close",value:function close(timeout){if(this._sessionFlusher){this._sessionFlusher.close();}return _get(_getPrototypeOf(ServerRuntimeClient.prototype),"close",this).call(this,timeout);}/** Method that initialises an instance of SessionFlusher on Client */},{key:"initSessionFlusher",value:function initSessionFlusher(){var _this$_options=this._options,release=_this$_options.release,environment=_this$_options.environment;if(!release){__WEBPACK_IMPORTED_MODULE_3__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Cannot initialise an instance of SessionFlusher if no release is provided!');}else{this._sessionFlusher=new __WEBPACK_IMPORTED_MODULE_6__sessionflusher_js__["a" /* SessionFlusher */](this,{release:release,environment:environment});}}/**
   * Create a cron monitor check in and send it to Sentry.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   */},{key:"captureCheckIn",value:function captureCheckIn(checkIn,monitorConfig,scope){var id='checkInId'in checkIn&&checkIn.checkInId?checkIn.checkInId:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])();if(!this._isEnabled()){__WEBPACK_IMPORTED_MODULE_3__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('SDK not enabled, will not capture checkin.');return id;}var options=this.getOptions();var release=options.release,environment=options.environment,tunnel=options.tunnel;var serializedCheckIn={check_in_id:id,monitor_slug:checkIn.monitorSlug,status:checkIn.status,release:release,environment:environment};if('duration'in checkIn){serializedCheckIn.duration=checkIn.duration;}if(monitorConfig){serializedCheckIn.monitor_config={schedule:monitorConfig.schedule,checkin_margin:monitorConfig.checkinMargin,max_runtime:monitorConfig.maxRuntime,timezone:monitorConfig.timezone};}var _this$_getTraceInfoFr=this._getTraceInfoFromScope(scope),_this$_getTraceInfoFr2=_slicedToArray(_this$_getTraceInfoFr,2),dynamicSamplingContext=_this$_getTraceInfoFr2[0],traceContext=_this$_getTraceInfoFr2[1];if(traceContext){serializedCheckIn.contexts={trace:traceContext};}var envelope=Object(__WEBPACK_IMPORTED_MODULE_2__checkin_js__["a" /* createCheckInEnvelope */])(serializedCheckIn,dynamicSamplingContext,this.getSdkMetadata(),tunnel,this.getDsn());__WEBPACK_IMPORTED_MODULE_3__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].info('Sending checkin:',checkIn.monitorSlug,checkIn.status);// _sendEnvelope should not throw
// eslint-disable-next-line @typescript-eslint/no-floating-promises
this._sendEnvelope(envelope);return id;}/**
   * Method responsible for capturing/ending a request session by calling `incrementSessionStatusCount` to increment
   * appropriate session aggregates bucket
   */},{key:"_captureRequestSession",value:function _captureRequestSession(){if(!this._sessionFlusher){__WEBPACK_IMPORTED_MODULE_3__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Discarded request mode session because autoSessionTracking option was disabled');}else{this._sessionFlusher.incrementSessionStatusCount();}}/**
   * @inheritDoc
   */},{key:"_prepareEvent",value:function _prepareEvent(event,hint,scope,isolationScope){if(this._options.platform){event.platform=event.platform||this._options.platform;}if(this._options.runtime){event.contexts=_objectSpread({},event.contexts,{runtime:(event.contexts||{}).runtime||this._options.runtime});}if(this._options.serverName){event.server_name=event.server_name||this._options.serverName;}return _get(_getPrototypeOf(ServerRuntimeClient.prototype),"_prepareEvent",this).call(this,event,hint,scope,isolationScope);}/** Extract trace information from scope */},{key:"_getTraceInfoFromScope",value:function _getTraceInfoFromScope(scope){if(!scope){return[undefined,undefined];}// eslint-disable-next-line deprecation/deprecation
var span=scope.getSpan();if(span){var samplingContext=Object(__WEBPACK_IMPORTED_MODULE_9__utils_getRootSpan_js__["a" /* getRootSpan */])(span)?Object(__WEBPACK_IMPORTED_MODULE_11__tracing_dynamicSamplingContext_js__["b" /* getDynamicSamplingContextFromSpan */])(span):undefined;return[samplingContext,Object(__WEBPACK_IMPORTED_MODULE_8__utils_spanUtils_js__["f" /* spanToTraceContext */])(span)];}var _scope$getPropagation=scope.getPropagationContext(),traceId=_scope$getPropagation.traceId,spanId=_scope$getPropagation.spanId,parentSpanId=_scope$getPropagation.parentSpanId,dsc=_scope$getPropagation.dsc;var traceContext={trace_id:traceId,span_id:spanId,parent_span_id:parentSpanId};if(dsc){return[dsc,traceContext];}return[Object(__WEBPACK_IMPORTED_MODULE_11__tracing_dynamicSamplingContext_js__["a" /* getDynamicSamplingContextFromClient */])(traceId,this,scope),traceContext];}}]);return ServerRuntimeClient;}(__WEBPACK_IMPORTED_MODULE_1__baseclient_js__["a" /* BaseClient */]);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MetricsAggregator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instance_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metric_summary_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_js__ = __webpack_require__(136);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/**
 * A metrics aggregator that aggregates metrics in memory and flushes them periodically.
 */var MetricsAggregator=/*#__PURE__*/function(){// TODO(@anonrig): Use FinalizationRegistry to have a proper way of flushing the buckets
// when the aggregator is garbage collected.
// Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry
// Different metrics have different weights. We use this to limit the number of metrics
// that we store in memory.
// Cast to any so that it can use Node.js timeout
// eslint-disable-next-line @typescript-eslint/no-explicit-any
// SDKs are required to shift the flush interval by random() * rollup_in_seconds.
// That shift is determined once per startup to create jittering.
// An SDK is required to perform force flushing ahead of scheduled time if the memory
// pressure is too high. There is no rule for this other than that SDKs should be tracking
// abstract aggregation complexity (eg: a counter only carries a single float, whereas a
// distribution is a float per emission).
//
// Force flush is used on either shutdown, flush() or when we exceed the max weight.
function MetricsAggregator(_client){var _this=this;_classCallCheck(this,MetricsAggregator);this._client=_client;this._buckets=new Map();this._bucketsTotalWeight=0;this._interval=setInterval(function(){return _this._flush();},__WEBPACK_IMPORTED_MODULE_1__constants_js__["c" /* DEFAULT_FLUSH_INTERVAL */]);// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
if(this._interval.unref){// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
this._interval.unref();}this._flushShift=Math.floor(Math.random()*__WEBPACK_IMPORTED_MODULE_1__constants_js__["c" /* DEFAULT_FLUSH_INTERVAL */]/1000);this._forceFlush=false;}/**
   * @inheritDoc
   */_createClass(MetricsAggregator,[{key:"add",value:function add(metricType,unsanitizedName,value){var unsanitizedUnit=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'none';var unsanitizedTags=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{};var maybeFloatTimestamp=arguments.length>5&&arguments[5]!==undefined?arguments[5]:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_48" /* timestampInSeconds */])();var timestamp=Math.floor(maybeFloatTimestamp);var name=Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["b" /* sanitizeMetricKey */])(unsanitizedName);var tags=Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["c" /* sanitizeTags */])(unsanitizedTags);var unit=Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["d" /* sanitizeUnit */])(unsanitizedUnit);var bucketKey=Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["a" /* getBucketKey */])(metricType,name,unit,tags);var bucketItem=this._buckets.get(bucketKey);// If this is a set metric, we need to calculate the delta from the previous weight.
var previousWeight=bucketItem&&metricType===__WEBPACK_IMPORTED_MODULE_1__constants_js__["g" /* SET_METRIC_TYPE */]?bucketItem.metric.weight:0;if(bucketItem){bucketItem.metric.add(value);// TODO(abhi): Do we need this check?
if(bucketItem.timestamp<timestamp){bucketItem.timestamp=timestamp;}}else{bucketItem={// @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
metric:new __WEBPACK_IMPORTED_MODULE_2__instance_js__["a" /* METRIC_MAP */][metricType](value),timestamp:timestamp,metricType:metricType,name:name,unit:unit,tags:tags};this._buckets.set(bucketKey,bucketItem);}// If value is a string, it's a set metric so calculate the delta from the previous weight.
var val=typeof value==='string'?bucketItem.metric.weight-previousWeight:value;Object(__WEBPACK_IMPORTED_MODULE_3__metric_summary_js__["b" /* updateMetricSummaryOnActiveSpan */])(metricType,name,val,unit,unsanitizedTags,bucketKey);// We need to keep track of the total weight of the buckets so that we can
// flush them when we exceed the max weight.
this._bucketsTotalWeight+=bucketItem.metric.weight;if(this._bucketsTotalWeight>=__WEBPACK_IMPORTED_MODULE_1__constants_js__["f" /* MAX_WEIGHT */]){this.flush();}}/**
   * Flushes the current metrics to the transport via the transport.
   */},{key:"flush",value:function flush(){this._forceFlush=true;this._flush();}/**
   * Shuts down metrics aggregator and clears all metrics.
   */},{key:"close",value:function close(){this._forceFlush=true;clearInterval(this._interval);this._flush();}/**
   * Flushes the buckets according to the internal state of the aggregator.
   * If it is a force flush, which happens on shutdown, it will flush all buckets.
   * Otherwise, it will only flush buckets that are older than the flush interval,
   * and according to the flush shift.
   *
   * This function mutates `_forceFlush` and `_bucketsTotalWeight` properties.
   */},{key:"_flush",value:function _flush(){// TODO(@anonrig): Add Atomics for locking to avoid having force flush and regular flush
// running at the same time.
// Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Atomics
// This path eliminates the need for checking for timestamps since we're forcing a flush.
// Remember to reset the flag, or it will always flush all metrics.
if(this._forceFlush){this._forceFlush=false;this._bucketsTotalWeight=0;this._captureMetrics(this._buckets);this._buckets.clear();return;}var cutoffSeconds=Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_48" /* timestampInSeconds */])())-__WEBPACK_IMPORTED_MODULE_1__constants_js__["c" /* DEFAULT_FLUSH_INTERVAL */]/1000-this._flushShift;// TODO(@anonrig): Optimization opportunity.
// Convert this map to an array and store key in the bucketItem.
var flushedBuckets=new Map();var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=this._buckets[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _step$value=_slicedToArray(_step.value,2),key=_step$value[0],bucket=_step$value[1];if(bucket.timestamp<=cutoffSeconds){flushedBuckets.set(key,bucket);this._bucketsTotalWeight-=bucket.metric.weight;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=flushedBuckets[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _step2$value=_slicedToArray(_step2.value,1),_key=_step2$value[0];this._buckets.delete(_key);}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return!=null){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}this._captureMetrics(flushedBuckets);}/**
   * Only captures a subset of the buckets passed to this function.
   * @param flushedBuckets
   */},{key:"_captureMetrics",value:function _captureMetrics(flushedBuckets){if(flushedBuckets.size>0&&this._client.captureAggregateMetrics){// TODO(@anonrig): Optimization opportunity.
// This copy operation can be avoided if we store the key in the bucketItem.
var buckets=Array.from(flushedBuckets).map(function(_ref){var _ref2=_slicedToArray(_ref,2),bucketItem=_ref2[1];return bucketItem;});this._client.captureAggregateMetrics(buckets);}}}]);return MetricsAggregator;}();

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initAndBind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCurrentClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exports_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hub_js__ = __webpack_require__(50);
/** A class object that can instantiate Client objects. *//**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */function initAndBind(clientClass,options){if(options.debug===true){if(__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].enable();}else{// use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["A" /* consoleSandbox */])(function(){// eslint-disable-next-line no-console
console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');});}}var scope=Object(__WEBPACK_IMPORTED_MODULE_2__exports_js__["k" /* getCurrentScope */])();scope.update(options.initialScope);var client=new clientClass(options);setCurrentClient(client);initializeClient(client);}/**
 * Make the given client the current client.
 */function setCurrentClient(client){// eslint-disable-next-line deprecation/deprecation
var hub=Object(__WEBPACK_IMPORTED_MODULE_3__hub_js__["b" /* getCurrentHub */])();// eslint-disable-next-line deprecation/deprecation
var top=hub.getStackTop();top.client=client;top.scope.setClient(client);}/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */function initializeClient(client){if(client.init){client.init();// TODO v8: Remove this fallback
// eslint-disable-next-line deprecation/deprecation
}else if(client.setupIntegrations){// eslint-disable-next-line deprecation/deprecation
client.setupIntegrations();}}

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_TRANSPORT_BUFFER_SIZE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
var DEFAULT_TRANSPORT_BUFFER_SIZE=30;/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */function createTransport(options,makeRequest){var buffer=arguments.length>2&&arguments[2]!==undefined?arguments[2]:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_28" /* makePromiseBuffer */])(options.bufferSize||DEFAULT_TRANSPORT_BUFFER_SIZE);var rateLimits={};var flush=function flush(timeout){return buffer.drain(timeout);};function send(envelope){var filteredEnvelopeItems=[];// Drop rate limited items from envelope
Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["V" /* forEachEnvelopeItem */])(envelope,function(item,type){var dataCategory=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["N" /* envelopeItemTypeToDataCategory */])(type);if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_21" /* isRateLimited */])(rateLimits,dataCategory)){var event=getEventForEnvelopeItem(item,type);options.recordDroppedEvent('ratelimit_backoff',dataCategory,event);}else{filteredEnvelopeItems.push(item);}});// Skip sending if envelope is empty after filtering out rate limited events
if(filteredEnvelopeItems.length===0){return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_38" /* resolvedSyncPromise */])();}// eslint-disable-next-line @typescript-eslint/no-explicit-any
var filteredEnvelope=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* createEnvelope */])(envelope[0],filteredEnvelopeItems);// Creates client report for each item in an envelope
var recordEnvelopeLoss=function recordEnvelopeLoss(reason){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["V" /* forEachEnvelopeItem */])(filteredEnvelope,function(item,type){var event=getEventForEnvelopeItem(item,type);options.recordDroppedEvent(reason,Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["N" /* envelopeItemTypeToDataCategory */])(type),event);});};var requestTask=function requestTask(){return makeRequest({body:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_40" /* serializeEnvelope */])(filteredEnvelope,options.textEncoder)}).then(function(response){// We don't want to throw on NOK responses, but we want to at least log them
if(response.statusCode!==undefined&&(response.statusCode<200||response.statusCode>=300)){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn("Sentry responded with status code ".concat(response.statusCode," to sent event."));}rateLimits=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_51" /* updateRateLimits */])(rateLimits,response);return response;},function(error){recordEnvelopeLoss('network_error');throw error;});};return buffer.add(requestTask).then(function(result){return result;},function(error){if(error instanceof __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* SentryError */]){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('Skipped sending event because buffer is full.');recordEnvelopeLoss('queue_overflow');return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_38" /* resolvedSyncPromise */])();}else{throw error;}});}// We use this to identifify if the transport is the base transport
// TODO (v8): Remove this again as we'll no longer need it
send.__sentry__baseTransport__=true;return{send:send,flush:flush};}function getEventForEnvelopeItem(item,type){if(type!=='event'&&type!=='transaction'){return undefined;}return Array.isArray(item)?item[1]:undefined;}

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MIN_DELAY */
/* unused harmony export START_DELAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeOfflineTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}var MIN_DELAY=100;// 100 ms
var START_DELAY=5000;// 5 seconds
var MAX_DELAY=3.6e6;// 1 hour
function log(msg,error){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].info("[Offline]: ".concat(msg),error);}/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */function makeOfflineTransport(createTransport){return function(options){var transport=createTransport(options);var store=options.createStore?options.createStore(options):undefined;var retryDelay=START_DELAY;var flushTimer;function shouldQueue(env,error,retryDelay){// We don't queue Session Replay envelopes because they are:
// - Ordered and Replay relies on the response status to know when they're successfully sent.
// - Likely to fill the queue quickly and block other events from being sent.
// We also want to drop client reports because they can be generated when we retry sending events while offline.
if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["M" /* envelopeContainsItemType */])(env,['replay_event','replay_recording','client_report'])){return false;}if(options.shouldStore){return options.shouldStore(env,error,retryDelay);}return true;}function flushIn(delay){if(!store){return;}if(flushTimer){clearTimeout(flushTimer);}flushTimer=setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var found;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:flushTimer=undefined;_context.next=3;return store.pop();case 3:found=_context.sent;if(found){log('Attempting to send previously queued event');void send(found).catch(function(e){log('Failed to retry sending',e);});}case 5:case"end":return _context.stop();}}},_callee);})),delay);// We need to unref the timer in node.js, otherwise the node process never exit.
if(typeof flushTimer!=='number'&&flushTimer.unref){flushTimer.unref();}}function flushWithBackOff(){if(flushTimer){return;}flushIn(retryDelay);retryDelay=Math.min(retryDelay*2,MAX_DELAY);}function send(_x){return _send.apply(this,arguments);}function _send(){_send=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(envelope){var result,delay;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return transport.send(envelope);case 3:result=_context2.sent;delay=MIN_DELAY;if(!result){_context2.next=12;break;}if(!(result.headers&&result.headers['retry-after'])){_context2.next=10;break;}delay=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_33" /* parseRetryAfterHeader */])(result.headers['retry-after']);_context2.next=12;break;case 10:if(!((result.statusCode||0)>=400)){_context2.next=12;break;}return _context2.abrupt("return",result);case 12:flushIn(delay);retryDelay=START_DELAY;return _context2.abrupt("return",result);case 17:_context2.prev=17;_context2.t0=_context2["catch"](0);_context2.t1=store;if(!_context2.t1){_context2.next=24;break;}_context2.next=23;return shouldQueue(envelope,_context2.t0,retryDelay);case 23:_context2.t1=_context2.sent;case 24:if(!_context2.t1){_context2.next=32;break;}_context2.next=27;return store.insert(envelope);case 27:flushWithBackOff();log('Error sending. Event queued',_context2.t0);return _context2.abrupt("return",{});case 32:throw _context2.t0;case 33:case"end":return _context2.stop();}}},_callee2,null,[[0,17]]);}));return _send.apply(this,arguments);}if(options.flushAtStartup){flushWithBackOff();}return{send:send,flush:function flush(t){return transport.flush(t);}};};}

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export eventFromEnvelope */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeMultiplexedTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_js__ = __webpack_require__(203);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */function eventFromEnvelope(env,types){var event;Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["V" /* forEachEnvelopeItem */])(env,function(item,type){if(types.includes(type)){event=Array.isArray(item)?item[1]:undefined;}// bail out if we found an event
return!!event;});return event;}/**
 * Creates a transport that overrides the release on all events.
 */function makeOverrideReleaseTransport(createTransport,release){return function(options){var transport=createTransport(options);return _objectSpread({},transport,{send:function(){var _send=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(envelope){var event;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event=eventFromEnvelope(envelope,['event','transaction','profile','replay_event']);if(event){event.release=release;}return _context.abrupt("return",transport.send(envelope));case 3:case"end":return _context.stop();}}},_callee);}));function send(_x){return _send.apply(this,arguments);}return send;}()});};}/** Overrides the DSN in the envelope header  */function overrideDsn(envelope,dsn){return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* createEnvelope */])(dsn?_objectSpread({},envelope[0],{dsn:dsn}):envelope[0],envelope[1]);}/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */function makeMultiplexedTransport(createTransport,matcher){return function(options){var fallbackTransport=createTransport(options);var otherTransports=new Map();function getTransport(dsn,release){// We create a transport for every unique dsn/release combination as there may be code from multiple releases in
// use at the same time
var key=release?"".concat(dsn,":").concat(release):dsn;var transport=otherTransports.get(key);if(!transport){var validatedDsn=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["I" /* dsnFromString */])(dsn);if(!validatedDsn){return undefined;}var url=Object(__WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* getEnvelopeEndpointWithUrlEncodedAuth */])(validatedDsn,options.tunnel);transport=release?makeOverrideReleaseTransport(createTransport,release)(_objectSpread({},options,{url:url})):createTransport(_objectSpread({},options,{url:url}));otherTransports.set(key,transport);}return[dsn,transport];}function send(_x2){return _send2.apply(this,arguments);}function _send2(){_send2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(envelope){var getEvent,transports,results;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:getEvent=function _getEvent(types){var eventTypes=types&&types.length?types:['event'];return eventFromEnvelope(envelope,eventTypes);};transports=matcher({envelope:envelope,getEvent:getEvent}).map(function(result){if(typeof result==='string'){return getTransport(result,undefined);}else{return getTransport(result.dsn,result.release);}}).filter(function(t){return!!t;});// If we have no transports to send to, use the fallback transport
if(transports.length===0){// Don't override the DSN in the header for the fallback transport. '' is falsy
transports.push(['',fallbackTransport]);}_context2.next=5;return Promise.all(transports.map(function(_ref){var _ref2=_slicedToArray(_ref,2),dsn=_ref2[0],transport=_ref2[1];return transport.send(overrideDsn(envelope,dsn));}));case 5:results=_context2.sent;return _context2.abrupt("return",results[0]);case 7:case"end":return _context2.stop();}}},_callee2);}));return _send2.apply(this,arguments);}function flush(_x3){return _flush.apply(this,arguments);}function _flush(){_flush=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(timeout){var promises,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,_step$value,transport;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return fallbackTransport.flush(timeout);case 2:_context3.t0=_context3.sent;promises=[_context3.t0];_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context3.prev=7;_iterator=otherTransports[Symbol.iterator]();case 9:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context3.next=19;break;}_step$value=_slicedToArray(_step.value,2),transport=_step$value[1];_context3.t1=promises;_context3.next=14;return transport.flush(timeout);case 14:_context3.t2=_context3.sent;_context3.t1.push.call(_context3.t1,_context3.t2);case 16:_iteratorNormalCompletion=true;_context3.next=9;break;case 19:_context3.next=25;break;case 21:_context3.prev=21;_context3.t3=_context3["catch"](7);_didIteratorError=true;_iteratorError=_context3.t3;case 25:_context3.prev=25;_context3.prev=26;if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}case 28:_context3.prev=28;if(!_didIteratorError){_context3.next=31;break;}throw _iteratorError;case 31:return _context3.finish(28);case 32:return _context3.finish(25);case 33:return _context3.abrupt("return",promises.every(function(r){return r;}));case 34:case"end":return _context3.stop();}}},_callee3,null,[[7,21,25,33],[26,,28,32]]);}));return _flush.apply(this,arguments);}return{send:send,flush:flush};};}

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSpanEnvelope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/**
 * Create envelope from Span item.
 */function createSpanEnvelope(spans,dsn){var headers={sent_at:new Date().toISOString()};if(dsn){headers.dsn=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["J" /* dsnToString */])(dsn);}var items=spans.map(createSpanItem);return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* createEnvelope */])(headers,items);}function createSpanItem(span){var spanHeaders={type:'span'};return[spanHeaders,span];}

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isSentryRequestUrl; });
/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */// eslint-disable-next-line deprecation/deprecation
function isSentryRequestUrl(url,hubOrClient){var client=hubOrClient&&isHub(hubOrClient)?// eslint-disable-next-line deprecation/deprecation
hubOrClient.getClient():hubOrClient;var dsn=client&&client.getDsn();var tunnel=client&&client.getOptions().tunnel;return checkDsn(url,dsn)||checkTunnel(url,tunnel);}function checkTunnel(url,tunnel){if(!tunnel){return false;}return removeTrailingSlash(url)===removeTrailingSlash(tunnel);}function checkDsn(url,dsn){return dsn?url.includes(dsn.host):false;}function removeTrailingSlash(str){return str[str.length-1]==='/'?str.slice(0,-1):str;}// eslint-disable-next-line deprecation/deprecation
function isHub(hubOrClient){// eslint-disable-next-line deprecation/deprecation
return hubOrClient.getClient!==undefined;}

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parameterize; });
/**
 * Tagged template function which returns paramaterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns String with template information in __sentry_template_string__ and __sentry_template_values__ properties
 */function parameterize(strings){for(var _len=arguments.length,values=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){values[_key-1]=arguments[_key];}var formatted=new String(String.raw.apply(String,[strings].concat(values)));formatted.__sentry_template_string__=strings.join('\x00').replace(/%/g,'%%').replace(/\0/g,'%s');formatted.__sentry_template_values__=values;return formatted;}

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applySdkMetadata; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version_js__ = __webpack_require__(196);
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */function applySdkMetadata(options,name){var names=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[name];var source=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'npm';var metadata=options._metadata||{};if(!metadata.sdk){metadata.sdk={name:"sentry.javascript.".concat(name),packages:names.map(function(name){return{name:"".concat(source,":@sentry/").concat(name),version:__WEBPACK_IMPORTED_MODULE_0__version_js__["a" /* SDK_VERSION */]};}),version:__WEBPACK_IMPORTED_MODULE_0__version_js__["a" /* SDK_VERSION */]};}options._metadata=metadata;}

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModuleMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moduleMetadataIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__integration_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata_js__ = __webpack_require__(651);
var INTEGRATION_NAME='ModuleMetadata';var _moduleMetadataIntegration=function _moduleMetadataIntegration(){return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
setup:function setup(client){if(typeof client.on!=='function'){return;}// We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
client.on('beforeEnvelope',function(envelope){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["V" /* forEachEnvelopeItem */])(envelope,function(item,type){if(type==='event'){var event=Array.isArray(item)?item[1]:undefined;if(event){Object(__WEBPACK_IMPORTED_MODULE_2__metadata_js__["b" /* stripMetadataFromStackFrames */])(event);item[1]=event;}}});});},processEvent:function processEvent(event,_hint,client){var stackParser=client.getOptions().stackParser;Object(__WEBPACK_IMPORTED_MODULE_2__metadata_js__["a" /* addMetadataToStackFrames */])(stackParser,event);return event;}};};var moduleMetadataIntegration=Object(__WEBPACK_IMPORTED_MODULE_1__integration_js__["d" /* defineIntegration */])(_moduleMetadataIntegration);/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 *
 * @deprecated Use `moduleMetadataIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var ModuleMetadata=Object(__WEBPACK_IMPORTED_MODULE_1__integration_js__["c" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,moduleMetadataIntegration);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addMetadataToStackFrames; });
/* unused harmony export getMetadataForUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stripMetadataFromStackFrames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/** Keys are source filename/url, values are metadata objects. */// eslint-disable-next-line @typescript-eslint/no-explicit-any
var filenameMetadataMap=new Map();/** Set of stack strings that have already been parsed. */var parsedStacks=new Set();function ensureMetadataStacksAreParsed(parser){if(!__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */]._sentryModuleMetadata){return;}for(var _i=0,_Object$keys=Object.keys(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */]._sentryModuleMetadata);_i<_Object$keys.length;_i++){var stack=_Object$keys[_i];var metadata=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */]._sentryModuleMetadata[stack];if(parsedStacks.has(stack)){continue;}// Ensure this stack doesn't get parsed again
parsedStacks.add(stack);var frames=parser(stack);// Go through the frames starting from the top of the stack and find the first one with a filename
var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=frames.reverse()[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var frame=_step.value;if(frame.filename){// Save the metadata for this filename
filenameMetadataMap.set(frame.filename,metadata);break;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getMetadataForUrl(parser,filename){ensureMetadataStacksAreParsed(parser);return filenameMetadataMap.get(filename);}/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */function addMetadataToStackFrames(parser,event){try{// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
event.exception.values.forEach(function(exception){if(!exception.stacktrace){return;}var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=(exception.stacktrace.frames||[])[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var frame=_step2.value;if(!frame.filename){continue;}var metadata=getMetadataForUrl(parser,frame.filename);if(metadata){frame.module_metadata=metadata;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return!=null){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}});}catch(_){// To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
}}/**
 * Strips metadata from stack frames.
 */function stripMetadataFromStackFrames(event){try{// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
event.exception.values.forEach(function(exception){if(!exception.stacktrace){return;}var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=(exception.stacktrace.frames||[])[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var frame=_step3.value;delete frame.module_metadata;}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return!=null){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}});}catch(_){// To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
}}

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RequestData */
/* unused harmony export requestDataIntegration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__integration_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_spanUtils_js__ = __webpack_require__(23);
function _objectWithoutProperties(source,excluded){if(source==null)return{};var target=_objectWithoutPropertiesLoose(source,excluded);var key,i;if(Object.getOwnPropertySymbols){var sourceSymbolKeys=Object.getOwnPropertySymbols(source);for(i=0;i<sourceSymbolKeys.length;i++){key=sourceSymbolKeys[i];if(excluded.indexOf(key)>=0)continue;if(!Object.prototype.propertyIsEnumerable.call(source,key))continue;target[key]=source[key];}}return target;}function _objectWithoutPropertiesLoose(source,excluded){if(source==null)return{};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var DEFAULT_OPTIONS={include:{cookies:true,data:true,headers:true,ip:false,query_string:true,url:true,user:{id:true,username:true,email:true}},transactionNamingScheme:'methodPath'};var INTEGRATION_NAME='RequestData';var _requestDataIntegration=function _requestDataIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _addRequestData=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["t" /* addRequestDataToEvent */];var _options=_objectSpread({},DEFAULT_OPTIONS,{},options,{include:_objectSpread({// @ts-expect-error It's mad because `method` isn't a known `include` key. (It's only here and not set by default in
// `addRequestDataToEvent` for legacy reasons. TODO (v8): Change that.)
method:true},DEFAULT_OPTIONS.include,{},options.include,{user:options.include&&typeof options.include.user==='boolean'?options.include.user:_objectSpread({},DEFAULT_OPTIONS.include.user,{},(options.include||{}).user)})});return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
processEvent:function processEvent(event,_hint,client){// Note: In the long run, most of the logic here should probably move into the request data utility functions. For
// the moment it lives here, though, until https://github.com/getsentry/sentry-javascript/issues/5718 is addressed.
// (TL;DR: Those functions touch many parts of the repo in many different ways, and need to be clened up. Once
// that's happened, it will be easier to add this logic in without worrying about unexpected side effects.)
var transactionNamingScheme=_options.transactionNamingScheme;var _event$sdkProcessingM=event.sdkProcessingMetadata,sdkProcessingMetadata=_event$sdkProcessingM===void 0?{}:_event$sdkProcessingM;var req=sdkProcessingMetadata.request;if(!req){return event;}// The Express request handler takes a similar `include` option to that which can be passed to this integration.
// If passed there, we store it in `sdkProcessingMetadata`. TODO(v8): Force express and GCP people to use this
// integration, so that all of this passing and conversion isn't necessary
var addRequestDataOptions=sdkProcessingMetadata.requestDataOptionsFromExpressHandler||sdkProcessingMetadata.requestDataOptionsFromGCPWrapper||convertReqDataIntegrationOptsToAddReqDataOpts(_options);var processedEvent=_addRequestData(event,req,addRequestDataOptions);// Transaction events already have the right `transaction` value
if(event.type==='transaction'||transactionNamingScheme==='handler'){return processedEvent;}// In all other cases, use the request's associated transaction (if any) to overwrite the event's `transaction`
// value with a high-quality one
var reqWithTransaction=req;var transaction=reqWithTransaction._sentryTransaction;if(transaction){var name=Object(__WEBPACK_IMPORTED_MODULE_2__utils_spanUtils_js__["e" /* spanToJSON */])(transaction).description||'';// TODO (v8): Remove the nextjs check and just base it on `transactionNamingScheme` for all SDKs. (We have to
// keep it the way it is for the moment, because changing the names of transactions in Sentry has the potential
// to break things like alert rules.)
var shouldIncludeMethodInTransactionName=getSDKName(client)==='sentry.javascript.nextjs'?name.startsWith('/api'):transactionNamingScheme!=='path';var _extractPathForTransa=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["S" /* extractPathForTransaction */])(req,{path:true,method:shouldIncludeMethodInTransactionName,customRoute:name}),_extractPathForTransa2=_slicedToArray(_extractPathForTransa,1),transactionValue=_extractPathForTransa2[0];processedEvent.transaction=transactionValue;}return processedEvent;}};};var requestDataIntegration=Object(__WEBPACK_IMPORTED_MODULE_1__integration_js__["d" /* defineIntegration */])(_requestDataIntegration);/**
 * Add data about a request to an event. Primarily for use in Node-based SDKs, but included in `@sentry/integrations`
 * so it can be used in cross-platform SDKs like `@sentry/nextjs`.
 * @deprecated Use `requestDataIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var RequestData=Object(__WEBPACK_IMPORTED_MODULE_1__integration_js__["c" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,requestDataIntegration);/** Convert this integration's options to match what `addRequestDataToEvent` expects *//** TODO: Can possibly be deleted once https://github.com/getsentry/sentry-javascript/issues/5718 is fixed */function convertReqDataIntegrationOptsToAddReqDataOpts(integrationOptions){var transactionNamingScheme=integrationOptions.transactionNamingScheme,_integrationOptions$i=integrationOptions.include,ip=_integrationOptions$i.ip,user=_integrationOptions$i.user,requestOptions=_objectWithoutProperties(_integrationOptions$i,["ip","user"]);var requestIncludeKeys=[];for(var _i2=0,_Object$entries=Object.entries(requestOptions);_i2<_Object$entries.length;_i2++){var _Object$entries$_i=_slicedToArray(_Object$entries[_i2],2),_key=_Object$entries$_i[0],_value=_Object$entries$_i[1];if(_value){requestIncludeKeys.push(_key);}}var addReqDataUserOpt;if(user===undefined){addReqDataUserOpt=true;}else if(typeof user==='boolean'){addReqDataUserOpt=user;}else{var userIncludeKeys=[];for(var _i3=0,_Object$entries2=Object.entries(user);_i3<_Object$entries2.length;_i3++){var _Object$entries2$_i=_slicedToArray(_Object$entries2[_i3],2),key=_Object$entries2$_i[0],value=_Object$entries2$_i[1];if(value){userIncludeKeys.push(key);}}addReqDataUserOpt=userIncludeKeys;}return{include:{ip:ip,user:addReqDataUserOpt,request:requestIncludeKeys.length!==0?requestIncludeKeys:undefined,transaction:transactionNamingScheme}};}function getSDKName(client){try{// For a long chain like this, it's fewer bytes to combine a try-catch with assuming everything is there than to
// write out a long chain of `a && a.b && a.b.c && ...`
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
return client.getOptions()._metadata.sdk.name;}catch(err){// In theory we should never get here
return undefined;}}

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functiontostring_js__ = __webpack_require__(307);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionToString", function() { return __WEBPACK_IMPORTED_MODULE_0__functiontostring_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inboundfilters_js__ = __webpack_require__(306);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InboundFilters", function() { return __WEBPACK_IMPORTED_MODULE_1__inboundfilters_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linkederrors_js__ = __webpack_require__(308);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedErrors", function() { return __WEBPACK_IMPORTED_MODULE_2__linkederrors_js__["a"]; });
/* eslint-disable deprecation/deprecation */

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export distribution */
/* unused harmony export gauge */
/* unused harmony export increment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return metrics; });
/* unused harmony export set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exports_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_spanUtils_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__integration_js__ = __webpack_require__(655);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function addToMetricsAggregator(metricType,name,value){var data=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var client=Object(__WEBPACK_IMPORTED_MODULE_2__exports_js__["j" /* getClient */])();var scope=Object(__WEBPACK_IMPORTED_MODULE_2__exports_js__["k" /* getCurrentScope */])();if(client){if(!client.metricsAggregator){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('No metrics aggregator enabled. Please add the MetricsAggregator integration to use metrics APIs');return;}var unit=data.unit,tags=data.tags,timestamp=data.timestamp;var _client$getOptions=client.getOptions(),release=_client$getOptions.release,environment=_client$getOptions.environment;// eslint-disable-next-line deprecation/deprecation
var transaction=scope.getTransaction();var metricTags={};if(release){metricTags.release=release;}if(environment){metricTags.environment=environment;}if(transaction){metricTags.transaction=Object(__WEBPACK_IMPORTED_MODULE_3__utils_spanUtils_js__["e" /* spanToJSON */])(transaction).description||'';}__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("Adding value of ".concat(value," to ").concat(metricType," metric ").concat(name));client.metricsAggregator.add(metricType,name,value,unit,_objectSpread({},metricTags,{},tags),timestamp);}}/**
 * Adds a value to a counter metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */function increment(name){var value=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var data=arguments.length>2?arguments[2]:undefined;addToMetricsAggregator(__WEBPACK_IMPORTED_MODULE_4__constants_js__["a" /* COUNTER_METRIC_TYPE */],name,value,data);}/**
 * Adds a value to a distribution metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */function distribution(name,value,data){addToMetricsAggregator(__WEBPACK_IMPORTED_MODULE_4__constants_js__["d" /* DISTRIBUTION_METRIC_TYPE */],name,value,data);}/**
 * Adds a value to a set metric. Value must be a string or integer.
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */function set(name,value,data){addToMetricsAggregator(__WEBPACK_IMPORTED_MODULE_4__constants_js__["g" /* SET_METRIC_TYPE */],name,value,data);}/**
 * Adds a value to a gauge metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */function gauge(name,value,data){addToMetricsAggregator(__WEBPACK_IMPORTED_MODULE_4__constants_js__["e" /* GAUGE_METRIC_TYPE */],name,value,data);}var metrics={increment:increment,distribution:distribution,set:set,gauge:gauge,/** @deprecated Use `metrics.metricsAggregratorIntegration()` instead. */// eslint-disable-next-line deprecation/deprecation
MetricsAggregator:__WEBPACK_IMPORTED_MODULE_5__integration_js__["a" /* MetricsAggregator */],metricsAggregatorIntegration:__WEBPACK_IMPORTED_MODULE_5__integration_js__["b" /* metricsAggregatorIntegration */]};

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MetricsAggregator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return metricsAggregatorIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__integration_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_aggregator_js__ = __webpack_require__(656);
var INTEGRATION_NAME='MetricsAggregator';var _metricsAggregatorIntegration=function _metricsAggregatorIntegration(){return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
setup:function setup(client){client.metricsAggregator=new __WEBPACK_IMPORTED_MODULE_1__browser_aggregator_js__["a" /* BrowserMetricsAggregator */](client);}};};var metricsAggregatorIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__integration_js__["d" /* defineIntegration */])(_metricsAggregatorIntegration);/**
 * Enables Sentry metrics monitoring.
 *
 * @experimental This API is experimental and might having breaking changes in the future.
 * @deprecated Use `metricsAggegratorIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var MetricsAggregator=Object(__WEBPACK_IMPORTED_MODULE_0__integration_js__["c" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,metricsAggregatorIntegration);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserMetricsAggregator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instance_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metric_summary_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_js__ = __webpack_require__(136);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/**
 * A simple metrics aggregator that aggregates metrics in memory and flushes them periodically.
 * Default flush interval is 5 seconds.
 *
 * @experimental This API is experimental and might change in the future.
 */var BrowserMetricsAggregator=/*#__PURE__*/function(){// TODO(@anonrig): Use FinalizationRegistry to have a proper way of flushing the buckets
// when the aggregator is garbage collected.
// Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry
function BrowserMetricsAggregator(_client){var _this=this;_classCallCheck(this,BrowserMetricsAggregator);this._client=_client;this._buckets=new Map();this._interval=setInterval(function(){return _this.flush();},__WEBPACK_IMPORTED_MODULE_1__constants_js__["b" /* DEFAULT_BROWSER_FLUSH_INTERVAL */]);}/**
   * @inheritDoc
   */_createClass(BrowserMetricsAggregator,[{key:"add",value:function add(metricType,unsanitizedName,value){var unsanitizedUnit=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'none';var unsanitizedTags=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{};var maybeFloatTimestamp=arguments.length>5&&arguments[5]!==undefined?arguments[5]:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_48" /* timestampInSeconds */])();var timestamp=Math.floor(maybeFloatTimestamp);var name=Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["b" /* sanitizeMetricKey */])(unsanitizedName);var tags=Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["c" /* sanitizeTags */])(unsanitizedTags);var unit=Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["d" /* sanitizeUnit */])(unsanitizedUnit);var bucketKey=Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["a" /* getBucketKey */])(metricType,name,unit,tags);var bucketItem=this._buckets.get(bucketKey);// If this is a set metric, we need to calculate the delta from the previous weight.
var previousWeight=bucketItem&&metricType===__WEBPACK_IMPORTED_MODULE_1__constants_js__["g" /* SET_METRIC_TYPE */]?bucketItem.metric.weight:0;if(bucketItem){bucketItem.metric.add(value);// TODO(abhi): Do we need this check?
if(bucketItem.timestamp<timestamp){bucketItem.timestamp=timestamp;}}else{bucketItem={// @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
metric:new __WEBPACK_IMPORTED_MODULE_2__instance_js__["a" /* METRIC_MAP */][metricType](value),timestamp:timestamp,metricType:metricType,name:name,unit:unit,tags:tags};this._buckets.set(bucketKey,bucketItem);}// If value is a string, it's a set metric so calculate the delta from the previous weight.
var val=typeof value==='string'?bucketItem.metric.weight-previousWeight:value;Object(__WEBPACK_IMPORTED_MODULE_3__metric_summary_js__["b" /* updateMetricSummaryOnActiveSpan */])(metricType,name,val,unit,unsanitizedTags,bucketKey);}/**
   * @inheritDoc
   */},{key:"flush",value:function flush(){// short circuit if buckets are empty.
if(this._buckets.size===0){return;}if(this._client.captureAggregateMetrics){// TODO(@anonrig): Use Object.values() when we support ES6+
var metricBuckets=Array.from(this._buckets).map(function(_ref){var _ref2=_slicedToArray(_ref,2),bucketItem=_ref2[1];return bucketItem;});this._client.captureAggregateMetrics(metricBuckets);}this._buckets.clear();}/**
   * @inheritDoc
   */},{key:"close",value:function close(){clearInterval(this._interval);this.flush();}}]);return BrowserMetricsAggregator;}();

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Express */
/* unused harmony export extractOriginalRoute */
/* unused harmony export preventDuplicateSegments */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_node_utils_js__ = __webpack_require__(75);
function _toArray(arr){return _arrayWithHoles(arr)||_iterableToArray(arr)||_nonIterableRest();}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/* eslint-disable max-lines *//**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */var Express=/*#__PURE__*/function(){_createClass(Express,null,[{key:"__initStatic",/**
   * @inheritDoc
   */value:function __initStatic(){this.id='Express';}/**
   * @inheritDoc
   *//**
   * Express App instance
   *//**
   * @inheritDoc
   */}]);function Express(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_classCallCheck(this,Express);this.name=Express.id;this._router=options.router||options.app;this._methods=(Array.isArray(options.methods)?options.methods:[]).concat('use');}/**
   * @inheritDoc
   */// eslint-disable-next-line deprecation/deprecation
_createClass(Express,[{key:"setupOnce",value:function setupOnce(_,getCurrentHub){if(!this._router){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('ExpressIntegration is missing an Express instance');return;}if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_node_utils_js__["a" /* shouldDisableAutoInstrumentation */])(getCurrentHub)){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('Express Integration is skipped because of instrumenter configuration.');return;}instrumentMiddlewares(this._router,this._methods);instrumentRouter(this._router);}}]);return Express;}();Express.__initStatic();/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */// eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function wrap(fn,method){var arity=fn.length;switch(arity){case 2:{return function(req,res){var transaction=res.__sentry_transaction;if(transaction){// eslint-disable-next-line deprecation/deprecation
var span=transaction.startChild({description:fn.name,op:"middleware.express.".concat(method),origin:'auto.middleware.express'});res.once('finish',function(){span.end();});}return fn.call(this,req,res);};}case 3:{return function(req,res,next){var transaction=res.__sentry_transaction;// eslint-disable-next-line deprecation/deprecation
var span=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([transaction,'optionalAccess',function(_2){return _2.startChild;},'call',function(_3){return _3({description:fn.name,op:"middleware.express.".concat(method),origin:'auto.middleware.express'});}]);fn.call(this,req,res,function(){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([span,'optionalAccess',function(_4){return _4.end;},'call',function(_5){return _5();}]);for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}next.call.apply(next,[this].concat(args));});};}case 4:{return function(err,req,res,next){var transaction=res.__sentry_transaction;// eslint-disable-next-line deprecation/deprecation
var span=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([transaction,'optionalAccess',function(_6){return _6.startChild;},'call',function(_7){return _7({description:fn.name,op:"middleware.express.".concat(method),origin:'auto.middleware.express'});}]);fn.call(this,err,req,res,function(){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([span,'optionalAccess',function(_8){return _8.end;},'call',function(_9){return _9();}]);for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}next.call.apply(next,[this].concat(args));});};}default:{throw new Error("Express middleware takes 2-4 arguments. Got: ".concat(arity));}}}/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */function wrapMiddlewareArgs(args,method){return args.map(function(arg){if(typeof arg==='function'){return wrap(arg,method);}if(Array.isArray(arg)){return arg.map(function(a){if(typeof a==='function'){return wrap(a,method);}return a;});}return arg;});}/**
 * Patches original router to utilize our tracing functionality
 */function patchMiddleware(router,method){var originalCallback=router[method];router[method]=function(){for(var _len3=arguments.length,args=new Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return originalCallback.call.apply(originalCallback,[this].concat(_toConsumableArray(wrapMiddlewareArgs(args,method))));};return router;}/**
 * Patches original router methods
 */function instrumentMiddlewares(router){var methods=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];methods.forEach(function(method){return patchMiddleware(router,method);});}/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */function instrumentRouter(appOrRouter){// This is how we can distinguish between app and routers
var isApp='settings'in appOrRouter;// In case the app's top-level router hasn't been initialized yet, we have to do it now
if(isApp&&appOrRouter._router===undefined&&appOrRouter.lazyrouter){appOrRouter.lazyrouter();}var router=isApp?appOrRouter._router:appOrRouter;if(!router){/*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].debug('Cannot instrument router for URL Parameterization (did not find a valid router).');__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].debug('Routing instrumentation is currently only supported in Express 4.');return;}var routerProto=Object.getPrototypeOf(router);var originalProcessParams=routerProto.process_params;routerProto.process_params=function process_params(layer,called,req,res,done){// Base case: We're in the first part of the URL (thus we start with the root '/')
if(!req._reconstructedRoute){req._reconstructedRoute='';}// If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
var _getLayerRoutePathInf=getLayerRoutePathInfo(layer),layerRoutePath=_getLayerRoutePathInf.layerRoutePath,isRegex=_getLayerRoutePathInf.isRegex,isArray=_getLayerRoutePathInf.isArray,numExtraSegments=_getLayerRoutePathInf.numExtraSegments;if(layerRoutePath||isRegex||isArray){req._hasParameters=true;}// Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
var partialRoute;if(layerRoutePath){partialRoute=layerRoutePath;}else{/**
       * prevent duplicate segment in _reconstructedRoute param if router match multiple routes before final path
       * example:
       * original url: /api/v1/1234
       * prevent: /api/api/v1/:userId
       * router structure
       * /api -> middleware
       * /api/v1 -> middleware
       * /1234 -> endpoint with param :userId
       * final _reconstructedRoute is /api/v1/:userId
       */partialRoute=preventDuplicateSegments(req.originalUrl,req._reconstructedRoute,layer.path)||'';}// Normalize the partial route so that it doesn't contain leading or trailing slashes
// and exclude empty or '*' wildcard routes.
// The exclusion of '*' routes is our best effort to not "pollute" the transaction name
// with interim handlers (e.g. ones that check authentication or do other middleware stuff).
// We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
var finalPartialRoute=partialRoute.split('/').filter(function(segment){return segment.length>0&&(isRegex||isArray||!segment.includes('*'));}).join('/');// If we found a valid partial URL, we append it to the reconstructed route
if(finalPartialRoute&&finalPartialRoute.length>0){// If the partial route is from a regex route, we append a '/' to close the regex
req._reconstructedRoute+="/".concat(finalPartialRoute).concat(isRegex?'/':'');}// Now we check if we are in the "last" part of the route. We determine this by comparing the
// number of URL segments from the original URL to that of our reconstructed parameterized URL.
// If we've reached our final destination, we update the transaction name.
var urlLength=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_3" /* getNumberOfUrlSegments */])(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_44" /* stripUrlQueryAndFragment */])(req.originalUrl||''))+numExtraSegments;var routeLength=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_3" /* getNumberOfUrlSegments */])(req._reconstructedRoute);if(urlLength===routeLength){if(!req._hasParameters){if(req._reconstructedRoute!==req.originalUrl){req._reconstructedRoute=req.originalUrl?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_44" /* stripUrlQueryAndFragment */])(req.originalUrl):req.originalUrl;}}var transaction=res.__sentry_transaction;var attributes=transaction&&Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_24" /* spanToJSON */])(transaction).data||{};if(transaction&&attributes[__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */]]!=='custom'){// If the request URL is '/' or empty, the reconstructed route will be empty.
// Therefore, we fall back to setting the final route to '/' in this case.
var finalRoute=req._reconstructedRoute||'/';var _extractPathForTransa=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["S" /* extractPathForTransaction */])(req,{path:true,method:true,customRoute:finalRoute}),_extractPathForTransa2=_slicedToArray(_extractPathForTransa,2),name=_extractPathForTransa2[0],source=_extractPathForTransa2[1];transaction.updateName(name);transaction.setAttribute(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],source);}}return originalProcessParams.call(this,layer,called,req,res,done);};}/**
 * Recreate layer.route.path from layer.regexp and layer.keys.
 * Works until express.js used package path-to-regexp@0.1.7
 * or until layer.keys contain offset attribute
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns string in layer.route.path structure 'router/:pathParam' or undefined
 */var extractOriginalRoute=function extractOriginalRoute(path,regexp,keys){if(!path||!regexp||!keys||Object.keys(keys).length===0||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([keys,'access',function(_10){return _10[0];},'optionalAccess',function(_11){return _11.offset;}])===undefined||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([keys,'access',function(_12){return _12[0];},'optionalAccess',function(_13){return _13.offset;}])===null){return undefined;}var orderedKeys=keys.sort(function(a,b){return a.offset-b.offset;});// add d flag for getting indices from regexp result
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- regexp comes from express.js
var pathRegex=new RegExp(regexp,"".concat(regexp.flags,"d"));/**
   * use custom type cause of TS error with missing indices in RegExpExecArray
   */var execResult=pathRegex.exec(path);if(!execResult||!execResult.indices){return undefined;}/**
   * remove first match from regex cause contain whole layer.path
   */var _execResult$indices=_toArray(execResult.indices),paramIndices=_execResult$indices.slice(1);if(paramIndices.length!==orderedKeys.length){return undefined;}var resultPath=path;var indexShift=0;/**
   * iterate param matches from regexp.exec
   */paramIndices.forEach(function(item,index){/** check if offsets is define because in some cases regex d flag returns undefined */if(item){var _item=_slicedToArray(item,2),startOffset=_item[0],endOffset=_item[1];/**
       * isolate part before param
       */var substr1=resultPath.substring(0,startOffset-indexShift);/**
       * define paramName as replacement in format :pathParam
       */var replacement=":".concat(orderedKeys[index].name);/**
       * isolate part after param
       */var substr2=resultPath.substring(endOffset-indexShift);/**
       * recreate original path but with param replacement
       */resultPath=substr1+replacement+substr2;/**
       * calculate new index shift after resultPath was modified
       */indexShift=indexShift+(endOffset-startOffset-replacement.length);}});return resultPath;};/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */function getLayerRoutePathInfo(layer){var lrp=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([layer,'access',function(_14){return _14.route;},'optionalAccess',function(_15){return _15.path;}]);var isRegex=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_22" /* isRegExp */])(lrp);var isArray=Array.isArray(lrp);if(!lrp){// parse node.js major version
// Next.js will complain if we directly use `proces.versions` here because of edge runtime.
var _GLOBAL_OBJ$process$v=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */].process.versions.node.split('.').map(Number),_GLOBAL_OBJ$process$v2=_slicedToArray(_GLOBAL_OBJ$process$v,1),major=_GLOBAL_OBJ$process$v2[0];// allow call extractOriginalRoute only if node version support Regex d flag, node 16+
if(major>=16){/**
       * If lrp does not exist try to recreate original layer path from route regexp
       */lrp=extractOriginalRoute(layer.path,layer.regexp,layer.keys);}}if(!lrp){return{isRegex:isRegex,isArray:isArray,numExtraSegments:0};}var numExtraSegments=isArray?Math.max(getNumberOfArrayUrlSegments(lrp)-Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_3" /* getNumberOfUrlSegments */])(layer.path||''),0):0;var layerRoutePath=getLayerRoutePathString(isArray,lrp);return{layerRoutePath:layerRoutePath,isRegex:isRegex,isArray:isArray,numExtraSegments:numExtraSegments};}/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */function getNumberOfArrayUrlSegments(routesArray){return routesArray.reduce(function(accNumSegments,currentRoute){// array members can be a RegEx -> convert them toString
return accNumSegments+Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_3" /* getNumberOfUrlSegments */])(currentRoute.toString());},0);}/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */function getLayerRoutePathString(isArray,lrp){if(isArray){return lrp.map(function(r){return r.toString();}).join(',');}return lrp&&lrp.toString();}/**
 * remove duplicate segment contain in layerPath against reconstructedRoute,
 * and return only unique segment that can be added into reconstructedRoute
 */function preventDuplicateSegments(originalUrl,reconstructedRoute,layerPath){// filter query params
var normalizeURL=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_44" /* stripUrlQueryAndFragment */])(originalUrl||'');var originalUrlSplit=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([normalizeURL,'optionalAccess',function(_16){return _16.split;},'call',function(_17){return _17('/');},'access',function(_18){return _18.filter;},'call',function(_19){return _19(function(v){return!!v;});}]);var tempCounter=0;var currentOffset=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([reconstructedRoute,'optionalAccess',function(_20){return _20.split;},'call',function(_21){return _21('/');},'access',function(_22){return _22.filter;},'call',function(_23){return _23(function(v){return!!v;});},'access',function(_24){return _24.length;}])||0;var result=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([layerPath,'optionalAccess',function(_25){return _25.split;},'call',function(_26){return _26('/');},'access',function(_27){return _27.filter;},'call',function(_28){return _28(function(segment){if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([originalUrlSplit,'optionalAccess',function(_29){return _29[currentOffset+tempCounter];}])===segment){tempCounter+=1;return true;}return false;});},'access',function(_30){return _30.join;},'call',function(_31){return _31('/');}]);return result;}

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Postgres */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_node_utils_js__ = __webpack_require__(75);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/** Tracing integration for node-postgres package */var Postgres=/*#__PURE__*/function(){_createClass(Postgres,null,[{key:"__initStatic",/**
   * @inheritDoc
   */value:function __initStatic(){this.id='Postgres';}/**
   * @inheritDoc
   */}]);function Postgres(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_classCallCheck(this,Postgres);this.name=Postgres.id;this._usePgNative=!!options.usePgNative;this._module=options.module;}/** @inheritdoc */_createClass(Postgres,[{key:"loadDependency",value:function loadDependency(){return this._module=this._module||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_25" /* loadModule */])('pg');}/**
   * @inheritDoc
   */// eslint-disable-next-line deprecation/deprecation
},{key:"setupOnce",value:function setupOnce(_,getCurrentHub){if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_node_utils_js__["a" /* shouldDisableAutoInstrumentation */])(getCurrentHub)){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('Postgres Integration is skipped because of instrumenter configuration.');return;}var pkg=this.loadDependency();if(!pkg){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('Postgres Integration was unable to require `pg` package.');return;}var Client=this._usePgNative?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([pkg,'access',function(_2){return _2.native;},'optionalAccess',function(_3){return _3.Client;}]):pkg.Client;if(!Client){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error("Postgres Integration was unable to access 'pg-native' bindings.");return;}/**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["U" /* fill */])(Client.prototype,'query',function(orig){return function(config,values,callback){// eslint-disable-next-line deprecation/deprecation
var scope=getCurrentHub().getScope();// eslint-disable-next-line deprecation/deprecation
var parentSpan=scope.getSpan();var data={'db.system':'postgresql'};try{if(this.database){data['db.name']=this.database;}if(this.host){data['server.address']=this.host;}if(this.port){data['server.port']=this.port;}if(this.user){data['db.user']=this.user;}}catch(e){// ignore
}// eslint-disable-next-line deprecation/deprecation
var span=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([parentSpan,'optionalAccess',function(_4){return _4.startChild;},'call',function(_5){return _5({description:typeof config==='string'?config:config.text,op:'db',origin:'auto.db.postgres',data:data});}]);if(typeof callback==='function'){return orig.call(this,config,values,function(err,result){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([span,'optionalAccess',function(_6){return _6.end;},'call',function(_7){return _7();}]);callback(err,result);});}if(typeof values==='function'){return orig.call(this,config,function(err,result){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([span,'optionalAccess',function(_8){return _8.end;},'call',function(_9){return _9();}]);values(err,result);});}var rv=typeof values!=='undefined'?orig.call(this,config,values):orig.call(this,config);if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_24" /* isThenable */])(rv)){return rv.then(function(res){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([span,'optionalAccess',function(_10){return _10.end;},'call',function(_11){return _11();}]);return res;});}Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([span,'optionalAccess',function(_12){return _12.end;},'call',function(_13){return _13();}]);return rv;};});}}]);return Postgres;}();Postgres.__initStatic();

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Mysql */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_node_utils_js__ = __webpack_require__(75);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/** Tracing integration for node-mysql package */var Mysql=/*#__PURE__*/function(){_createClass(Mysql,null,[{key:"__initStatic",/**
   * @inheritDoc
   */value:function __initStatic(){this.id='Mysql';}/**
   * @inheritDoc
   */}]);function Mysql(){_classCallCheck(this,Mysql);this.name=Mysql.id;}/** @inheritdoc */_createClass(Mysql,[{key:"loadDependency",value:function loadDependency(){return this._module=this._module||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_25" /* loadModule */])('mysql/lib/Connection.js');}/**
   * @inheritDoc
   */// eslint-disable-next-line deprecation/deprecation
},{key:"setupOnce",value:function setupOnce(_,getCurrentHub){if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_node_utils_js__["a" /* shouldDisableAutoInstrumentation */])(getCurrentHub)){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('Mysql Integration is skipped because of instrumenter configuration.');return;}var pkg=this.loadDependency();if(!pkg){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('Mysql Integration was unable to require `mysql` package.');return;}var mySqlConfig=undefined;try{pkg.prototype.connect=new Proxy(pkg.prototype.connect,{apply:function apply(wrappingTarget,thisArg,args){if(!mySqlConfig){mySqlConfig=thisArg.config;}return wrappingTarget.apply(thisArg,args);}});}catch(e){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('Mysql Integration was unable to instrument `mysql` config.');}function spanDataFromConfig(){if(!mySqlConfig){return{};}return{'server.address':mySqlConfig.host,'server.port':mySqlConfig.port,'db.user':mySqlConfig.user};}function finishSpan(span){if(!span){return;}var data=spanDataFromConfig();Object.keys(data).forEach(function(key){span.setAttribute(key,data[key]);});span.end();}// The original function will have one of these signatures:
//    function (callback) => void
//    function (options, callback) => void
//    function (options, values, callback) => void
Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["U" /* fill */])(pkg,'createQuery',function(orig){return function(options,values,callback){// eslint-disable-next-line deprecation/deprecation
var scope=getCurrentHub().getScope();// eslint-disable-next-line deprecation/deprecation
var parentSpan=scope.getSpan();// eslint-disable-next-line deprecation/deprecation
var span=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([parentSpan,'optionalAccess',function(_2){return _2.startChild;},'call',function(_3){return _3({description:typeof options==='string'?options:options.sql,op:'db',origin:'auto.db.mysql',data:{'db.system':'mysql'}});}]);if(typeof callback==='function'){return orig.call(this,options,values,function(err,result,fields){finishSpan(span);callback(err,result,fields);});}if(typeof values==='function'){return orig.call(this,options,function(err,result,fields){finishSpan(span);values(err,result,fields);});}// streaming, no callback!
var query=orig.call(this,options,values);query.on('end',function(){finishSpan(span);});return query;};});}}]);return Mysql;}();Mysql.__initStatic();

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Mongo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_node_utils_js__ = __webpack_require__(75);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
var OPERATIONS=['aggregate',// aggregate(pipeline, options, callback)
'bulkWrite',// bulkWrite(operations, options, callback)
'countDocuments',// countDocuments(query, options, callback)
'createIndex',// createIndex(fieldOrSpec, options, callback)
'createIndexes',// createIndexes(indexSpecs, options, callback)
'deleteMany',// deleteMany(filter, options, callback)
'deleteOne',// deleteOne(filter, options, callback)
'distinct',// distinct(key, query, options, callback)
'drop',// drop(options, callback)
'dropIndex',// dropIndex(indexName, options, callback)
'dropIndexes',// dropIndexes(options, callback)
'estimatedDocumentCount',// estimatedDocumentCount(options, callback)
'find',// find(query, options, callback)
'findOne',// findOne(query, options, callback)
'findOneAndDelete',// findOneAndDelete(filter, options, callback)
'findOneAndReplace',// findOneAndReplace(filter, replacement, options, callback)
'findOneAndUpdate',// findOneAndUpdate(filter, update, options, callback)
'indexes',// indexes(options, callback)
'indexExists',// indexExists(indexes, options, callback)
'indexInformation',// indexInformation(options, callback)
'initializeOrderedBulkOp',// initializeOrderedBulkOp(options, callback)
'insertMany',// insertMany(docs, options, callback)
'insertOne',// insertOne(doc, options, callback)
'isCapped',// isCapped(options, callback)
'mapReduce',// mapReduce(map, reduce, options, callback)
'options',// options(options, callback)
'parallelCollectionScan',// parallelCollectionScan(options, callback)
'rename',// rename(newName, options, callback)
'replaceOne',// replaceOne(filter, doc, options, callback)
'stats',// stats(options, callback)
'updateMany',// updateMany(filter, update, options, callback)
'updateOne'// updateOne(filter, update, options, callback)
];// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
var OPERATION_SIGNATURES={// aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
// see https://github.com/getsentry/sentry-javascript/pull/3102
bulkWrite:['operations'],countDocuments:['query'],createIndex:['fieldOrSpec'],createIndexes:['indexSpecs'],deleteMany:['filter'],deleteOne:['filter'],distinct:['key','query'],dropIndex:['indexName'],find:['query'],findOne:['query'],findOneAndDelete:['filter'],findOneAndReplace:['filter','replacement'],findOneAndUpdate:['filter','update'],indexExists:['indexes'],insertMany:['docs'],insertOne:['doc'],mapReduce:['map','reduce'],rename:['newName'],replaceOne:['filter','doc'],updateMany:['filter','update'],updateOne:['filter','update']};function isCursor(maybeCursor){return maybeCursor&&_typeof(maybeCursor)==='object'&&maybeCursor.once&&typeof maybeCursor.once==='function';}/** Tracing integration for mongo package */var Mongo=/*#__PURE__*/function(){_createClass(Mongo,null,[{key:"__initStatic",/**
   * @inheritDoc
   */value:function __initStatic(){this.id='Mongo';}/**
   * @inheritDoc
   *//**
   * @inheritDoc
   */}]);function Mongo(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_classCallCheck(this,Mongo);this.name=Mongo.id;this._operations=Array.isArray(options.operations)?options.operations:OPERATIONS;this._describeOperations='describeOperations'in options?options.describeOperations:true;this._useMongoose=!!options.useMongoose;}/** @inheritdoc */_createClass(Mongo,[{key:"loadDependency",value:function loadDependency(){var moduleName=this._useMongoose?'mongoose':'mongodb';return this._module=this._module||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_25" /* loadModule */])(moduleName);}/**
   * @inheritDoc
   */// eslint-disable-next-line deprecation/deprecation
},{key:"setupOnce",value:function setupOnce(_,getCurrentHub){if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_node_utils_js__["a" /* shouldDisableAutoInstrumentation */])(getCurrentHub)){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('Mongo Integration is skipped because of instrumenter configuration.');return;}var pkg=this.loadDependency();if(!pkg){var moduleName=this._useMongoose?'mongoose':'mongodb';__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error("Mongo Integration was unable to require `".concat(moduleName,"` package."));return;}this._instrumentOperations(pkg.Collection,this._operations,getCurrentHub);}/**
   * Patches original collection methods
   */// eslint-disable-next-line deprecation/deprecation
},{key:"_instrumentOperations",value:function _instrumentOperations(collection,operations,getCurrentHub){var _this=this;operations.forEach(function(operation){return _this._patchOperation(collection,operation,getCurrentHub);});}/**
   * Patches original collection to utilize our tracing functionality
   */// eslint-disable-next-line deprecation/deprecation
},{key:"_patchOperation",value:function _patchOperation(collection,operation,getCurrentHub){if(!(operation in collection.prototype))return;var getSpanContext=this._getSpanContextFromOperationArguments.bind(this);Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["U" /* fill */])(collection.prototype,operation,function(orig){return function(){var _this2=this;for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var lastArg=args[args.length-1];// eslint-disable-next-line deprecation/deprecation
var hub=getCurrentHub();// eslint-disable-next-line deprecation/deprecation
var scope=hub.getScope();// eslint-disable-next-line deprecation/deprecation
var client=hub.getClient();// eslint-disable-next-line deprecation/deprecation
var parentSpan=scope.getSpan();var sendDefaultPii=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([client,'optionalAccess',function(_2){return _2.getOptions;},'call',function(_3){return _3();},'access',function(_4){return _4.sendDefaultPii;}]);// Check if the operation was passed a callback. (mapReduce requires a different check, as
// its (non-callback) arguments can also be functions.)
if(typeof lastArg!=='function'||operation==='mapReduce'&&args.length===2){// eslint-disable-next-line deprecation/deprecation
var _span=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([parentSpan,'optionalAccess',function(_5){return _5.startChild;},'call',function(_6){return _6(getSpanContext(_this2,operation,args,sendDefaultPii));}]);var maybePromiseOrCursor=orig.call.apply(orig,[this].concat(args));if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_24" /* isThenable */])(maybePromiseOrCursor)){return maybePromiseOrCursor.then(function(res){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([_span,'optionalAccess',function(_7){return _7.end;},'call',function(_8){return _8();}]);return res;});}// If the operation returns a Cursor
// we need to attach a listener to it to finish the span when the cursor is closed.
else if(isCursor(maybePromiseOrCursor)){var cursor=maybePromiseOrCursor;try{cursor.once('close',function(){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([_span,'optionalAccess',function(_9){return _9.end;},'call',function(_10){return _10();}]);});}catch(e){// If the cursor is already closed, `once` will throw an error. In that case, we can
// finish the span immediately.
Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([_span,'optionalAccess',function(_11){return _11.end;},'call',function(_12){return _12();}]);}return cursor;}else{Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([_span,'optionalAccess',function(_13){return _13.end;},'call',function(_14){return _14();}]);return maybePromiseOrCursor;}}// eslint-disable-next-line deprecation/deprecation
var span=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([parentSpan,'optionalAccess',function(_15){return _15.startChild;},'call',function(_16){return _16(getSpanContext(_this2,operation,args.slice(0,-1)));}]);return orig.call.apply(orig,[this].concat(_toConsumableArray(args.slice(0,-1)),[function(err,result){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([span,'optionalAccess',function(_17){return _17.end;},'call',function(_18){return _18();}]);lastArg(err,result);}]));};});}/**
   * Form a SpanContext based on the user input to a given operation.
   */},{key:"_getSpanContextFromOperationArguments",value:function _getSpanContextFromOperationArguments(collection,operation,args){var sendDefaultPii=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var data={'db.system':'mongodb','db.name':collection.dbName,'db.operation':operation,'db.mongodb.collection':collection.collectionName};var spanContext={op:'db',// TODO v8: Use `${collection.collectionName}.${operation}`
origin:'auto.db.mongo',description:operation,data:data};// If the operation takes no arguments besides `options` and `callback`, or if argument
// collection is disabled for this operation, just return early.
var signature=OPERATION_SIGNATURES[operation];var shouldDescribe=Array.isArray(this._describeOperations)?this._describeOperations.includes(operation):this._describeOperations;if(!signature||!shouldDescribe||!sendDefaultPii){return spanContext;}try{// Special case for `mapReduce`, as the only one accepting functions as arguments.
if(operation==='mapReduce'){var _args=_slicedToArray(args,2),map=_args[0],reduce=_args[1];data[signature[0]]=typeof map==='string'?map:map.name||'<anonymous>';data[signature[1]]=typeof reduce==='string'?reduce:reduce.name||'<anonymous>';}else{for(var i=0;i<signature.length;i++){data["db.mongodb.".concat(signature[i])]=JSON.stringify(args[i]);}}}catch(_oO){// no-empty
}return spanContext;}}]);return Mongo;}();Mongo.__initStatic();

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Prisma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_node_utils_js__ = __webpack_require__(75);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function isValidPrismaClient(possibleClient){return!!possibleClient&&!!possibleClient['$use'];}/** Tracing integration for @prisma/client package */var Prisma=/*#__PURE__*/function(){_createClass(Prisma,null,[{key:"__initStatic",/**
   * @inheritDoc
   */value:function __initStatic(){this.id='Prisma';}/**
   * @inheritDoc
   *//**
   * @inheritDoc
   */}]);function Prisma(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_classCallCheck(this,Prisma);this.name=Prisma.id;// We instrument the PrismaClient inside the constructor and not inside `setupOnce` because in some cases of server-side
// bundling (Next.js) multiple Prisma clients can be instantiated, even though users don't intend to. When instrumenting
// in setupOnce we can only ever instrument one client.
// https://github.com/getsentry/sentry-javascript/issues/7216#issuecomment-1602375012
// In the future we might explore providing a dedicated PrismaClient middleware instead of this hack.
if(isValidPrismaClient(options.client)&&!options.client._sentryInstrumented){// eslint-disable-next-line @typescript-eslint/no-explicit-any
Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["s" /* addNonEnumerableProperty */])(options.client,'_sentryInstrumented',true);var clientData={};try{var engineConfig=options.client._engineConfig;if(engineConfig){var activeProvider=engineConfig.activeProvider,clientVersion=engineConfig.clientVersion;if(activeProvider){clientData['db.system']=activeProvider;}if(clientVersion){clientData['db.prisma.version']=clientVersion;}}}catch(e){// ignore
}options.client.$use(function(params,next){// eslint-disable-next-line deprecation/deprecation
if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_node_utils_js__["a" /* shouldDisableAutoInstrumentation */])(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["O" /* getCurrentHub */])){return next(params);}var action=params.action;var model=params.model;return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_29" /* startSpan */])({name:model?"".concat(model," ").concat(action):action,onlyIfParent:true,op:'db.prisma',attributes:_defineProperty({},__WEBPACK_IMPORTED_MODULE_0__sentry_core__["j" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */],'auto.db.prisma'),data:_objectSpread({},clientData,{'db.operation':action})},function(){return next(params);});});}else{__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('Unsupported Prisma client provided to PrismaIntegration. Provided client:',options.client);}}/**
   * @inheritDoc
   */_createClass(Prisma,[{key:"setupOnce",value:function setupOnce(){// Noop - here for backwards compatibility
}}]);return Prisma;}();Prisma.__initStatic();

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GraphQL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_node_utils_js__ = __webpack_require__(75);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/** Tracing integration for graphql package */var GraphQL=/*#__PURE__*/function(){_createClass(GraphQL,null,[{key:"__initStatic",/**
   * @inheritDoc
   */value:function __initStatic(){this.id='GraphQL';}/**
   * @inheritDoc
   */}]);function GraphQL(){_classCallCheck(this,GraphQL);this.name=GraphQL.id;}/** @inheritdoc */_createClass(GraphQL,[{key:"loadDependency",value:function loadDependency(){return this._module=this._module||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_25" /* loadModule */])('graphql/execution/execute.js');}/**
   * @inheritDoc
   */// eslint-disable-next-line deprecation/deprecation
},{key:"setupOnce",value:function setupOnce(_,getCurrentHub){if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_node_utils_js__["a" /* shouldDisableAutoInstrumentation */])(getCurrentHub)){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('GraphQL Integration is skipped because of instrumenter configuration.');return;}var pkg=this.loadDependency();if(!pkg){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('GraphQL Integration was unable to require graphql/execution package.');return;}Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["U" /* fill */])(pkg,'execute',function(orig){return function(){// eslint-disable-next-line deprecation/deprecation
var scope=getCurrentHub().getScope();// eslint-disable-next-line deprecation/deprecation
var parentSpan=scope.getSpan();// eslint-disable-next-line deprecation/deprecation
var span=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([parentSpan,'optionalAccess',function(_2){return _2.startChild;},'call',function(_3){return _3({description:'execute',op:'graphql.execute',origin:'auto.graphql.graphql'});}]);// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([scope,'optionalAccess',function(_4){return _4.setSpan;},'call',function(_5){return _5(span);}]);for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var rv=orig.call.apply(orig,[this].concat(args));if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_24" /* isThenable */])(rv)){return rv.then(function(res){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([span,'optionalAccess',function(_6){return _6.end;},'call',function(_7){return _7();}]);// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([scope,'optionalAccess',function(_8){return _8.setSpan;},'call',function(_9){return _9(parentSpan);}]);return res;});}Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([span,'optionalAccess',function(_10){return _10.end;},'call',function(_11){return _11();}]);// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([scope,'optionalAccess',function(_12){return _12.setSpan;},'call',function(_13){return _13(parentSpan);}]);return rv;};});}}]);return GraphQL;}();GraphQL.__initStatic();

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Apollo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_node_utils_js__ = __webpack_require__(75);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/** Tracing integration for Apollo */var Apollo=/*#__PURE__*/function(){_createClass(Apollo,null,[{key:"__initStatic",/**
   * @inheritDoc
   */value:function __initStatic(){this.id='Apollo';}/**
   * @inheritDoc
   *//**
   * @inheritDoc
   */}]);function Apollo(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{useNestjs:false};_classCallCheck(this,Apollo);this.name=Apollo.id;this._useNest=!!options.useNestjs;}/** @inheritdoc */_createClass(Apollo,[{key:"loadDependency",value:function loadDependency(){if(this._useNest){this._module=this._module||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_25" /* loadModule */])('@nestjs/graphql');}else{this._module=this._module||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_25" /* loadModule */])('apollo-server-core');}return this._module;}/**
   * @inheritDoc
   */// eslint-disable-next-line deprecation/deprecation
},{key:"setupOnce",value:function setupOnce(_,getCurrentHub){if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_node_utils_js__["a" /* shouldDisableAutoInstrumentation */])(getCurrentHub)){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('Apollo Integration is skipped because of instrumenter configuration.');return;}if(this._useNest){var pkg=this.loadDependency();if(!pkg){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('Apollo-NestJS Integration was unable to require @nestjs/graphql package.');return;}/**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["U" /* fill */])(pkg.GraphQLFactory.prototype,'mergeWithSchema',function(orig){return function(){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["U" /* fill */])(this.resolversExplorerService,'explore',function(orig){return function(){var resolvers=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["w" /* arrayify */])(orig.call(this));var instrumentedResolvers=instrumentResolvers(resolvers,getCurrentHub);return instrumentedResolvers;};});for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return orig.call.apply(orig,[this].concat(args));};});}else{var _pkg=this.loadDependency();if(!_pkg){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('Apollo Integration was unable to require apollo-server-core package.');return;}/**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["U" /* fill */])(_pkg.ApolloServerBase.prototype,'constructSchema',function(orig){return function(){if(!this.config.resolvers){if(__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]){if(this.config.schema){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.'+'If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.');__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn();}else if(this.config.modules){__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.');}__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('Skipping tracing as no resolvers found on the `ApolloServer` instance.');}return orig.call(this);}var resolvers=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["w" /* arrayify */])(this.config.resolvers);this.config.resolvers=instrumentResolvers(resolvers,getCurrentHub);return orig.call(this);};});}}}]);return Apollo;}();Apollo.__initStatic();// eslint-disable-next-line deprecation/deprecation
function instrumentResolvers(resolvers,getCurrentHub){return resolvers.map(function(model){Object.keys(model).forEach(function(resolverGroupName){Object.keys(model[resolverGroupName]).forEach(function(resolverName){if(typeof model[resolverGroupName][resolverName]!=='function'){return;}wrapResolver(model,resolverGroupName,resolverName,getCurrentHub);});});return model;});}/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */function wrapResolver(model,resolverGroupName,resolverName,// eslint-disable-next-line deprecation/deprecation
getCurrentHub){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["U" /* fill */])(model[resolverGroupName],resolverName,function(orig){return function(){// eslint-disable-next-line deprecation/deprecation
var scope=getCurrentHub().getScope();// eslint-disable-next-line deprecation/deprecation
var parentSpan=scope.getSpan();// eslint-disable-next-line deprecation/deprecation
var span=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([parentSpan,'optionalAccess',function(_2){return _2.startChild;},'call',function(_3){return _3({description:"".concat(resolverGroupName,".").concat(resolverName),op:'graphql.resolve',origin:'auto.graphql.apollo'});}]);for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}var rv=orig.call.apply(orig,[this].concat(args));if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_24" /* isThenable */])(rv)){return rv.then(function(res){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([span,'optionalAccess',function(_4){return _4.end;},'call',function(_5){return _5();}]);return res;});}Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([span,'optionalAccess',function(_6){return _6.end;},'call',function(_7){return _7();}]);return rv;};});}

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export lazyLoadedNodePerformanceMonitoringIntegrations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
var lazyLoadedNodePerformanceMonitoringIntegrations=[function(){var integration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["K" /* dynamicRequire */])(module,'./apollo');return new integration.Apollo();},function(){var integration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["K" /* dynamicRequire */])(module,'./apollo');return new integration.Apollo({useNestjs:true});},function(){var integration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["K" /* dynamicRequire */])(module,'./graphql');return new integration.GraphQL();},function(){var integration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["K" /* dynamicRequire */])(module,'./mongo');return new integration.Mongo();},function(){var integration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["K" /* dynamicRequire */])(module,'./mongo');return new integration.Mongo({mongoose:true});},function(){var integration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["K" /* dynamicRequire */])(module,'./mysql');return new integration.Mysql();},function(){var integration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["K" /* dynamicRequire */])(module,'./postgres');return new integration.Postgres();}];
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(192)(module)))

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BROWSER_TRACING_INTEGRATION_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserTracing; });
/* unused harmony export getMetaContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backgroundtab_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__instrument_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__metrics_index_js__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__request_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_js__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_js__ = __webpack_require__(29);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var BROWSER_TRACING_INTEGRATION_ID='BrowserTracing';/** Options for Browser Tracing integration */var DEFAULT_BROWSER_TRACING_OPTIONS=_objectSpread({},__WEBPACK_IMPORTED_MODULE_0__sentry_core__["o" /* TRACING_DEFAULTS */],{markBackgroundTransactions:true,routingInstrumentation:__WEBPACK_IMPORTED_MODULE_7__router_js__["a" /* instrumentRoutingWithDefaults */],startTransactionOnLocationChange:true,startTransactionOnPageLoad:true,enableLongTask:true,enableInp:false,interactionsSampleRate:1,_experiments:{}},__WEBPACK_IMPORTED_MODULE_6__request_js__["a" /* defaultRequestInstrumentationOptions */]);/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */var MAX_INTERACTIONS=10;/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */var BrowserTracing=/*#__PURE__*/function(){// This class currently doesn't have a static `id` field like the other integration classes, because it prevented
// @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
// TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
// integrations.
/** Browser Tracing integration options *//**
   * @inheritDoc
   */// eslint-disable-next-line deprecation/deprecation
function BrowserTracing(_options){_classCallCheck(this,BrowserTracing);this.name=BROWSER_TRACING_INTEGRATION_ID;this._hasSetTracePropagationTargets=false;Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["t" /* addTracingExtensions */])();if(__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]){this._hasSetTracePropagationTargets=!!(_options&&(// eslint-disable-next-line deprecation/deprecation
_options.tracePropagationTargets||_options.tracingOrigins));}this.options=_objectSpread({},DEFAULT_BROWSER_TRACING_OPTIONS,{},_options);// Special case: enableLongTask can be set in _experiments
// TODO (v8): Remove this in v8
if(this.options._experiments.enableLongTask!==undefined){this.options.enableLongTask=this.options._experiments.enableLongTask;}// TODO (v8): remove this block after tracingOrigins is removed
// Set tracePropagationTargets to tracingOrigins if specified by the user
// In case both are specified, tracePropagationTargets takes precedence
// eslint-disable-next-line deprecation/deprecation
if(_options&&!_options.tracePropagationTargets&&_options.tracingOrigins){// eslint-disable-next-line deprecation/deprecation
this.options.tracePropagationTargets=_options.tracingOrigins;}this._collectWebVitals=Object(__WEBPACK_IMPORTED_MODULE_5__metrics_index_js__["e" /* startTrackingWebVitals */])();/** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */this._interactionIdToRouteNameMapping={};if(this.options.enableInp){Object(__WEBPACK_IMPORTED_MODULE_5__metrics_index_js__["b" /* startTrackingINP */])(this._interactionIdToRouteNameMapping,this.options.interactionsSampleRate);}if(this.options.enableLongTask){Object(__WEBPACK_IMPORTED_MODULE_5__metrics_index_js__["d" /* startTrackingLongTasks */])();}if(this.options._experiments.enableInteractions){Object(__WEBPACK_IMPORTED_MODULE_5__metrics_index_js__["c" /* startTrackingInteractions */])();}this._latestRoute={name:undefined,context:undefined};}/**
   * @inheritDoc
   */// eslint-disable-next-line deprecation/deprecation
_createClass(BrowserTracing,[{key:"setupOnce",value:function setupOnce(_,getCurrentHub){var _this=this;this._getCurrentHub=getCurrentHub;var hub=getCurrentHub();// eslint-disable-next-line deprecation/deprecation
var client=hub.getClient();var clientOptions=client&&client.getOptions();var _this$options=this.options,instrumentRouting=_this$options.routingInstrumentation,startTransactionOnLocationChange=_this$options.startTransactionOnLocationChange,startTransactionOnPageLoad=_this$options.startTransactionOnPageLoad,markBackgroundTransactions=_this$options.markBackgroundTransactions,traceFetch=_this$options.traceFetch,traceXHR=_this$options.traceXHR,shouldCreateSpanForRequest=_this$options.shouldCreateSpanForRequest,enableHTTPTimings=_this$options.enableHTTPTimings,_experiments=_this$options._experiments;var clientOptionsTracePropagationTargets=clientOptions&&clientOptions.tracePropagationTargets;// There are three ways to configure tracePropagationTargets:
// 1. via top level client option `tracePropagationTargets`
// 2. via BrowserTracing option `tracePropagationTargets`
// 3. via BrowserTracing option `tracingOrigins` (deprecated)
//
// To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
// BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
// This is done as it minimizes bundle size (we don't have to have undefined checks).
//
// If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
// eslint-disable-next-line deprecation/deprecation
var tracePropagationTargets=clientOptionsTracePropagationTargets||this.options.tracePropagationTargets;if(__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&this._hasSetTracePropagationTargets&&clientOptionsTracePropagationTargets){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');}instrumentRouting(function(context){var transaction=_this._createRouteTransaction(context);_this.options._experiments.onStartRouteTransaction&&_this.options._experiments.onStartRouteTransaction(transaction,context,getCurrentHub);return transaction;},startTransactionOnPageLoad,startTransactionOnLocationChange);if(markBackgroundTransactions){Object(__WEBPACK_IMPORTED_MODULE_3__backgroundtab_js__["a" /* registerBackgroundTabDetection */])();}if(_experiments.enableInteractions){this._registerInteractionListener();}if(this.options.enableInp){this._registerInpInteractionListener();}Object(__WEBPACK_IMPORTED_MODULE_6__request_js__["b" /* instrumentOutgoingRequests */])({traceFetch:traceFetch,traceXHR:traceXHR,tracePropagationTargets:tracePropagationTargets,shouldCreateSpanForRequest:shouldCreateSpanForRequest,enableHTTPTimings:enableHTTPTimings});}/** Create routing idle transaction. */},{key:"_createRouteTransaction",value:function _createRouteTransaction(context){var _this2=this;if(!this._getCurrentHub){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn("[Tracing] Did not create ".concat(context.op," transaction because _getCurrentHub is invalid."));return undefined;}var hub=this._getCurrentHub();var _this$options2=this.options,beforeNavigate=_this$options2.beforeNavigate,idleTimeout=_this$options2.idleTimeout,finalTimeout=_this$options2.finalTimeout,heartbeatInterval=_this$options2.heartbeatInterval;var isPageloadTransaction=context.op==='pageload';var expandedContext;if(isPageloadTransaction){var sentryTrace=isPageloadTransaction?getMetaContent('sentry-trace'):'';var baggage=isPageloadTransaction?getMetaContent('baggage'):undefined;var _propagationContextFr=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_35" /* propagationContextFromHeaders */])(sentryTrace,baggage),traceId=_propagationContextFr.traceId,dsc=_propagationContextFr.dsc,parentSpanId=_propagationContextFr.parentSpanId,sampled=_propagationContextFr.sampled;expandedContext=_objectSpread({traceId:traceId,parentSpanId:parentSpanId,parentSampled:sampled},context,{metadata:_objectSpread({},context.metadata,{dynamicSamplingContext:dsc}),trimEnd:true});}else{expandedContext=_objectSpread({trimEnd:true},context);}var modifiedContext=typeof beforeNavigate==='function'?beforeNavigate(expandedContext):expandedContext;// For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
// from being sent to Sentry).
var finalContext=modifiedContext===undefined?_objectSpread({},expandedContext,{sampled:false}):modifiedContext;// If `beforeNavigate` set a custom name, record that fact
// eslint-disable-next-line deprecation/deprecation
finalContext.metadata=finalContext.name!==expandedContext.name?// eslint-disable-next-line deprecation/deprecation
_objectSpread({},finalContext.metadata,{source:'custom'}):// eslint-disable-next-line deprecation/deprecation
finalContext.metadata;this._latestRoute.name=finalContext.name;this._latestRoute.context=finalContext;// eslint-disable-next-line deprecation/deprecation
if(finalContext.sampled===false){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Tracing] Will not send ".concat(finalContext.op," transaction because of beforeNavigate."));}__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Tracing] Starting ".concat(finalContext.op," transaction on scope"));var location=__WEBPACK_IMPORTED_MODULE_8__types_js__["a" /* WINDOW */].location;var idleTransaction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_26" /* startIdleTransaction */])(hub,finalContext,idleTimeout,finalTimeout,true,{location:location},// for use in the tracesSampler
heartbeatInterval,isPageloadTransaction// should wait for finish signal if it's a pageload transaction
);if(isPageloadTransaction){if(__WEBPACK_IMPORTED_MODULE_8__types_js__["a" /* WINDOW */].document){__WEBPACK_IMPORTED_MODULE_8__types_js__["a" /* WINDOW */].document.addEventListener('readystatechange',function(){if(['interactive','complete'].includes(__WEBPACK_IMPORTED_MODULE_8__types_js__["a" /* WINDOW */].document.readyState)){idleTransaction.sendAutoFinishSignal();}});if(['interactive','complete'].includes(__WEBPACK_IMPORTED_MODULE_8__types_js__["a" /* WINDOW */].document.readyState)){idleTransaction.sendAutoFinishSignal();}}}idleTransaction.registerBeforeFinishCallback(function(transaction){_this2._collectWebVitals();Object(__WEBPACK_IMPORTED_MODULE_5__metrics_index_js__["a" /* addPerformanceEntries */])(transaction);});return idleTransaction;}/** Start listener for interaction transactions */},{key:"_registerInteractionListener",value:function _registerInteractionListener(){var _this3=this;var inflightInteractionTransaction;var registerInteractionTransaction=function registerInteractionTransaction(){var _this3$options=_this3.options,idleTimeout=_this3$options.idleTimeout,finalTimeout=_this3$options.finalTimeout,heartbeatInterval=_this3$options.heartbeatInterval;var op='ui.action.click';// eslint-disable-next-line deprecation/deprecation
var currentTransaction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["M" /* getActiveTransaction */])();if(currentTransaction&&currentTransaction.op&&['navigation','pageload'].includes(currentTransaction.op)){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn("[Tracing] Did not create ".concat(op," transaction because a pageload or navigation transaction is in progress."));return undefined;}if(inflightInteractionTransaction){inflightInteractionTransaction.setFinishReason('interactionInterrupted');inflightInteractionTransaction.end();inflightInteractionTransaction=undefined;}if(!_this3._getCurrentHub){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn("[Tracing] Did not create ".concat(op," transaction because _getCurrentHub is invalid."));return undefined;}if(!_this3._latestRoute.name){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn("[Tracing] Did not create ".concat(op," transaction because _latestRouteName is missing."));return undefined;}var hub=_this3._getCurrentHub();var location=__WEBPACK_IMPORTED_MODULE_8__types_js__["a" /* WINDOW */].location;var context={name:_this3._latestRoute.name,op:op,trimEnd:true,data:_defineProperty({},__WEBPACK_IMPORTED_MODULE_0__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],_this3._latestRoute.context?getSource(_this3._latestRoute.context):'url')};inflightInteractionTransaction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_26" /* startIdleTransaction */])(hub,context,idleTimeout,finalTimeout,true,{location:location},// for use in the tracesSampler
heartbeatInterval);};['click'].forEach(function(type){if(__WEBPACK_IMPORTED_MODULE_8__types_js__["a" /* WINDOW */].document){addEventListener(type,registerInteractionTransaction,{once:false,capture:true});}});}/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */},{key:"_registerInpInteractionListener",value:function _registerInpInteractionListener(){var _this4=this;var handleEntries=function handleEntries(_ref){var entries=_ref.entries;var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])();// We need to get the replay, user, and activeTransaction from the current scope
// so that we can associate replay id, profile id, and a user display to the span
var replay=client!==undefined&&client.getIntegrationByName!==undefined?client.getIntegrationByName('Replay'):undefined;var replayId=replay!==undefined?replay.getReplayId():undefined;// eslint-disable-next-line deprecation/deprecation
var activeTransaction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["M" /* getActiveTransaction */])();var currentScope=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["P" /* getCurrentScope */])();var user=currentScope!==undefined?currentScope.getUser():undefined;entries.forEach(function(entry){if(isPerformanceEventTiming(entry)){var interactionId=entry.interactionId;if(interactionId===undefined){return;}var existingInteraction=_this4._interactionIdToRouteNameMapping[interactionId];var duration=entry.duration;var startTime=entry.startTime;var keys=Object.keys(_this4._interactionIdToRouteNameMapping);var minInteractionId=keys.length>0?keys.reduce(function(a,b){return _this4._interactionIdToRouteNameMapping[a].duration<_this4._interactionIdToRouteNameMapping[b].duration?a:b;}):undefined;// For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
// This is also checked in the web-vitals library.
if(entry.entryType==='first-input'){var matchingEntry=keys.map(function(key){return _this4._interactionIdToRouteNameMapping[key];}).some(function(interaction){return interaction.duration===duration&&interaction.startTime===startTime;});if(matchingEntry){return;}}// Interactions with an id of 0 and are not first-input are not valid.
if(!interactionId){return;}// If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
if(existingInteraction){existingInteraction.duration=Math.max(existingInteraction.duration,duration);}else if(keys.length<MAX_INTERACTIONS||minInteractionId===undefined||duration>_this4._interactionIdToRouteNameMapping[minInteractionId].duration){// If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
var routeName=_this4._latestRoute.name;var parentContext=_this4._latestRoute.context;if(routeName&&parentContext){if(minInteractionId&&Object.keys(_this4._interactionIdToRouteNameMapping).length>=MAX_INTERACTIONS){// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
delete _this4._interactionIdToRouteNameMapping[minInteractionId];}_this4._interactionIdToRouteNameMapping[interactionId]={routeName:routeName,duration:duration,parentContext:parentContext,user:user,activeTransaction:activeTransaction,replayId:replayId,startTime:startTime};}}}});};Object(__WEBPACK_IMPORTED_MODULE_4__instrument_js__["e" /* addPerformanceInstrumentationHandler */])('event',handleEntries);Object(__WEBPACK_IMPORTED_MODULE_4__instrument_js__["e" /* addPerformanceInstrumentationHandler */])('first-input',handleEntries);}}]);return BrowserTracing;}();/** Returns the value of a meta tag */function getMetaContent(metaName){// Can't specify generic to `getDomElement` because tracing can be used
// in a variety of environments, have to disable `no-unsafe-member-access`
// as a result.
var metaTag=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["Y" /* getDomElement */])("meta[name=".concat(metaName,"]"));// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
return metaTag?metaTag.getAttribute('content'):undefined;}function getSource(context){var sourceFromAttributes=context.attributes&&context.attributes[__WEBPACK_IMPORTED_MODULE_0__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */]];// eslint-disable-next-line deprecation/deprecation
var sourceFromData=context.data&&context.data[__WEBPACK_IMPORTED_MODULE_0__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */]];// eslint-disable-next-line deprecation/deprecation
var sourceFromMetadata=context.metadata&&context.metadata.source;return sourceFromAttributes||sourceFromData||sourceFromMetadata;}function isPerformanceEventTiming(entry){return'duration'in entry;}

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onCLS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_bindReporter_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_initMetric_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_observe_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_onHidden_js__ = __webpack_require__(108);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */var onCLS=function onCLS(onReport){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var metric=Object(__WEBPACK_IMPORTED_MODULE_1__lib_initMetric_js__["a" /* initMetric */])('CLS',0);var report;var sessionValue=0;var sessionEntries=[];// const handleEntries = (entries: Metric['entries']) => {
var handleEntries=function handleEntries(entries){entries.forEach(function(entry){// Only count layout shifts without recent user input.
if(!entry.hadRecentInput){var firstSessionEntry=sessionEntries[0];var lastSessionEntry=sessionEntries[sessionEntries.length-1];// If the entry occurred less than 1 second after the previous entry and
// less than 5 seconds after the first entry in the session, include the
// entry in the current session. Otherwise, start a new session.
if(sessionValue&&sessionEntries.length!==0&&entry.startTime-lastSessionEntry.startTime<1000&&entry.startTime-firstSessionEntry.startTime<5000){sessionValue+=entry.value;sessionEntries.push(entry);}else{sessionValue=entry.value;sessionEntries=[entry];}// If the current session value is larger than the current CLS value,
// update CLS and the entries contributing to it.
if(sessionValue>metric.value){metric.value=sessionValue;metric.entries=sessionEntries;if(report){report();}}}});};var po=Object(__WEBPACK_IMPORTED_MODULE_2__lib_observe_js__["a" /* observe */])('layout-shift',handleEntries);if(po){report=Object(__WEBPACK_IMPORTED_MODULE_0__lib_bindReporter_js__["a" /* bindReporter */])(onReport,metric,options.reportAllChanges);var stopListening=function stopListening(){handleEntries(po.takeRecords());report(true);};Object(__WEBPACK_IMPORTED_MODULE_3__lib_onHidden_js__["a" /* onHidden */])(stopListening);return stopListening;}return;};

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateUniqueID; });
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */var generateUniqueID=function generateUniqueID(){return"v3-".concat(Date.now(),"-").concat(Math.floor(Math.random()*(9e12-1))+1e12);};

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onFID; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_bindReporter_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getVisibilityWatcher_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_initMetric_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_observe_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_onHidden_js__ = __webpack_require__(108);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */var onFID=function onFID(onReport){var visibilityWatcher=Object(__WEBPACK_IMPORTED_MODULE_1__lib_getVisibilityWatcher_js__["a" /* getVisibilityWatcher */])();var metric=Object(__WEBPACK_IMPORTED_MODULE_2__lib_initMetric_js__["a" /* initMetric */])('FID');// eslint-disable-next-line prefer-const
var report;var handleEntry=function handleEntry(entry){// Only report if the page wasn't hidden prior to the first input.
if(entry.startTime<visibilityWatcher.firstHiddenTime){metric.value=entry.processingStart-entry.startTime;metric.entries.push(entry);report(true);}};var handleEntries=function handleEntries(entries){entries.forEach(handleEntry);};var po=Object(__WEBPACK_IMPORTED_MODULE_3__lib_observe_js__["a" /* observe */])('first-input',handleEntries);report=Object(__WEBPACK_IMPORTED_MODULE_0__lib_bindReporter_js__["a" /* bindReporter */])(onReport,metric);if(po){Object(__WEBPACK_IMPORTED_MODULE_4__lib_onHidden_js__["a" /* onHidden */])(function(){handleEntries(po.takeRecords());po.disconnect();},true);}};

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onINP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_bindReporter_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_initMetric_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_observe_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_onHidden_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_polyfills_interactionCountPolyfill_js__ = __webpack_require__(670);
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */var getInteractionCountForNavigation=function getInteractionCountForNavigation(){return Object(__WEBPACK_IMPORTED_MODULE_4__lib_polyfills_interactionCountPolyfill_js__["a" /* getInteractionCount */])();};// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
var MAX_INTERACTIONS_TO_CONSIDER=10;// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
var longestInteractionList=[];// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
var longestInteractionMap={};/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */var processEntry=function processEntry(entry){// The least-long of the 10 longest interactions.
var minLongestInteraction=longestInteractionList[longestInteractionList.length-1];// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
var existingInteraction=longestInteractionMap[entry.interactionId];// Only process the entry if it's possibly one of the ten longest,
// or if it's part of an existing interaction.
if(existingInteraction||longestInteractionList.length<MAX_INTERACTIONS_TO_CONSIDER||entry.duration>minLongestInteraction.latency){// If the interaction already exists, update it. Otherwise create one.
if(existingInteraction){existingInteraction.entries.push(entry);existingInteraction.latency=Math.max(existingInteraction.latency,entry.duration);}else{var interaction={// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
id:entry.interactionId,latency:entry.duration,entries:[entry]};longestInteractionMap[interaction.id]=interaction;longestInteractionList.push(interaction);}// Sort the entries by latency (descending) and keep only the top ten.
longestInteractionList.sort(function(a,b){return b.latency-a.latency;});longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER).forEach(function(i){// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
delete longestInteractionMap[i.id];});}};/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */var estimateP98LongestInteraction=function estimateP98LongestInteraction(){var candidateInteractionIndex=Math.min(longestInteractionList.length-1,Math.floor(getInteractionCountForNavigation()/50));return longestInteractionList[candidateInteractionIndex];};/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */var onINP=function onINP(onReport,opts){// Set defaults
// eslint-disable-next-line no-param-reassign
opts=opts||{};// https://web.dev/inp/#what's-a-%22good%22-inp-value
// const thresholds = [200, 500];
// TODO(philipwalton): remove once the polyfill is no longer needed.
Object(__WEBPACK_IMPORTED_MODULE_4__lib_polyfills_interactionCountPolyfill_js__["b" /* initInteractionCountPolyfill */])();var metric=Object(__WEBPACK_IMPORTED_MODULE_1__lib_initMetric_js__["a" /* initMetric */])('INP');// eslint-disable-next-line prefer-const
var report;var handleEntries=function handleEntries(entries){entries.forEach(function(entry){if(entry.interactionId){processEntry(entry);}// Entries of type `first-input` don't currently have an `interactionId`,
// so to consider them in INP we have to first check that an existing
// entry doesn't match the `duration` and `startTime`.
// Note that this logic assumes that `event` entries are dispatched
// before `first-input` entries. This is true in Chrome but it is not
// true in Firefox; however, Firefox doesn't support interactionId, so
// it's not an issue at the moment.
// TODO(philipwalton): remove once crbug.com/1325826 is fixed.
if(entry.entryType==='first-input'){var noMatchingEntry=!longestInteractionList.some(function(interaction){return interaction.entries.some(function(prevEntry){return entry.duration===prevEntry.duration&&entry.startTime===prevEntry.startTime;});});if(noMatchingEntry){processEntry(entry);}}});var inp=estimateP98LongestInteraction();if(inp&&inp.latency!==metric.value){metric.value=inp.latency;metric.entries=inp.entries;report();}};var po=Object(__WEBPACK_IMPORTED_MODULE_2__lib_observe_js__["a" /* observe */])('event',handleEntries,{// Event Timing entries have their durations rounded to the nearest 8ms,
// so a duration of 40ms would be any event that spans 2.5 or more frames
// at 60Hz. This threshold is chosen to strike a balance between usefulness
// and performance. Running this callback for any interaction that spans
// just one or two frames is likely not worth the insight that could be
// gained.
durationThreshold:opts.durationThreshold||40});report=Object(__WEBPACK_IMPORTED_MODULE_0__lib_bindReporter_js__["a" /* bindReporter */])(onReport,metric,opts.reportAllChanges);if(po){// Also observe entries of type `first-input`. This is useful in cases
// where the first interaction is less than the `durationThreshold`.
po.observe({type:'first-input',buffered:true});Object(__WEBPACK_IMPORTED_MODULE_3__lib_onHidden_js__["a" /* onHidden */])(function(){handleEntries(po.takeRecords());// If the interaction count shows that there were interactions but
// none were captured by the PerformanceObserver, report a latency of 0.
if(metric.value<0&&getInteractionCountForNavigation()>0){metric.value=0;metric.entries=[];}report(true);});}};

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getInteractionCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initInteractionCountPolyfill; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observe_js__ = __webpack_require__(85);
var interactionCountEstimate=0;var minKnownInteractionId=Infinity;var maxKnownInteractionId=0;var updateEstimate=function updateEstimate(entries){entries.forEach(function(e){if(e.interactionId){minKnownInteractionId=Math.min(minKnownInteractionId,e.interactionId);maxKnownInteractionId=Math.max(maxKnownInteractionId,e.interactionId);interactionCountEstimate=maxKnownInteractionId?(maxKnownInteractionId-minKnownInteractionId)/7+1:0;}});};var po;/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */var getInteractionCount=function getInteractionCount(){return po?interactionCountEstimate:performance.interactionCount||0;};/**
 * Feature detects native support or initializes the polyfill if needed.
 */var initInteractionCountPolyfill=function initInteractionCountPolyfill(){if('interactionCount'in performance||po)return;po=Object(__WEBPACK_IMPORTED_MODULE_0__observe_js__["a" /* observe */])('event',updateEstimate,{type:'event',buffered:true,durationThreshold:0});};

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onLCP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_bindReporter_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getActivationStart_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_getVisibilityWatcher_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_initMetric_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_observe_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_onHidden_js__ = __webpack_require__(108);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var reportedMetricIDs={};/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */var onLCP=function onLCP(onReport){var visibilityWatcher=Object(__WEBPACK_IMPORTED_MODULE_3__lib_getVisibilityWatcher_js__["a" /* getVisibilityWatcher */])();var metric=Object(__WEBPACK_IMPORTED_MODULE_4__lib_initMetric_js__["a" /* initMetric */])('LCP');var report;var handleEntries=function handleEntries(entries){var lastEntry=entries[entries.length-1];if(lastEntry){// The startTime attribute returns the value of the renderTime if it is
// not 0, and the value of the loadTime otherwise. The activationStart
// reference is used because LCP should be relative to page activation
// rather than navigation start if the page was prerendered.
var value=Math.max(lastEntry.startTime-Object(__WEBPACK_IMPORTED_MODULE_2__lib_getActivationStart_js__["a" /* getActivationStart */])(),0);// Only report if the page wasn't hidden prior to LCP.
if(value<visibilityWatcher.firstHiddenTime){metric.value=value;metric.entries=[lastEntry];report();}}};var po=Object(__WEBPACK_IMPORTED_MODULE_5__lib_observe_js__["a" /* observe */])('largest-contentful-paint',handleEntries);if(po){report=Object(__WEBPACK_IMPORTED_MODULE_1__lib_bindReporter_js__["a" /* bindReporter */])(onReport,metric);var stopListening=function stopListening(){if(!reportedMetricIDs[metric.id]){handleEntries(po.takeRecords());po.disconnect();reportedMetricIDs[metric.id]=true;report(true);}};// Stop listening after input. Note: while scrolling is an input that
// stop LCP observation, it's unreliable since it can be programmatically
// generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
['keydown','click'].forEach(function(type){if(__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].document){addEventListener(type,stopListening,{once:true,capture:true});}});Object(__WEBPACK_IMPORTED_MODULE_6__lib_onHidden_js__["a" /* onHidden */])(stopListening,true);return stopListening;}return;};

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onTTFB; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_bindReporter_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getActivationStart_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_getNavigationEntry_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_initMetric_js__ = __webpack_require__(107);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */var whenReady=function whenReady(callback){if(!__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].document){return;}if(__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].document.prerendering){addEventListener('prerenderingchange',function(){return whenReady(callback);},true);}else if(__WEBPACK_IMPORTED_MODULE_0__types_js__["a" /* WINDOW */].document.readyState!=='complete'){addEventListener('load',function(){return whenReady(callback);},true);}else{// Queue a task so the callback runs after `loadEventEnd`.
setTimeout(callback,0);}};/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */var onTTFB=function onTTFB(onReport,opts){// Set defaults
// eslint-disable-next-line no-param-reassign
opts=opts||{};// https://web.dev/ttfb/#what-is-a-good-ttfb-score
// const thresholds = [800, 1800];
var metric=Object(__WEBPACK_IMPORTED_MODULE_4__lib_initMetric_js__["a" /* initMetric */])('TTFB');var report=Object(__WEBPACK_IMPORTED_MODULE_1__lib_bindReporter_js__["a" /* bindReporter */])(onReport,metric,opts.reportAllChanges);whenReady(function(){var navEntry=Object(__WEBPACK_IMPORTED_MODULE_3__lib_getNavigationEntry_js__["a" /* getNavigationEntry */])();if(navEntry){// The activationStart reference is used because TTFB should be
// relative to page activation rather than navigation start if the
// page was prerendered. But in cases where `activationStart` occurs
// after the first byte is received, this time should be clamped at 0.
metric.value=Math.max(navEntry.responseStart-Object(__WEBPACK_IMPORTED_MODULE_2__lib_getActivationStart_js__["a" /* getActivationStart */])(),0);// In some cases the value reported is negative or is larger
// than the current page time. Ignore these cases:
// https://github.com/GoogleChrome/web-vitals/issues/137
// https://github.com/GoogleChrome/web-vitals/issues/162
if(metric.value<0||metric.value>performance.now())return;metric.entries=[navEntry];report(true);}});};

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _startChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isMeasurementValue; });
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(source,excluded){if(source==null)return{};var target=_objectWithoutPropertiesLoose(source,excluded);var key,i;if(Object.getOwnPropertySymbols){var sourceSymbolKeys=Object.getOwnPropertySymbols(source);for(i=0;i<sourceSymbolKeys.length;i++){key=sourceSymbolKeys[i];if(excluded.indexOf(key)>=0)continue;if(!Object.prototype.propertyIsEnumerable.call(source,key))continue;target[key]=source[key];}}return target;}function _objectWithoutPropertiesLoose(source,excluded){if(source==null)return{};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}/**
 * Checks if a given value is a valid measurement value.
 */function isMeasurementValue(value){return typeof value==='number'&&isFinite(value);}/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */function _startChild(transaction,_ref){var startTimestamp=_ref.startTimestamp,ctx=_objectWithoutProperties(_ref,["startTimestamp"]);// eslint-disable-next-line deprecation/deprecation
if(startTimestamp&&transaction.startTimestamp>startTimestamp){// eslint-disable-next-line deprecation/deprecation
transaction.startTimestamp=startTimestamp;}// eslint-disable-next-line deprecation/deprecation
return transaction.startChild(_objectSpread({startTimestamp:startTimestamp},ctx));}

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instrumentRoutingWithDefaults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_js__ = __webpack_require__(29);
/**
 * Default function implementing pageload and navigation transactions
 */function instrumentRoutingWithDefaults(customStartTransaction){var startTransactionOnPageLoad=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var startTransactionOnLocationChange=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;if(!__WEBPACK_IMPORTED_MODULE_2__types_js__["a" /* WINDOW */]||!__WEBPACK_IMPORTED_MODULE_2__types_js__["a" /* WINDOW */].location){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Could not initialize routing instrumentation due to invalid location');return;}var startingUrl=__WEBPACK_IMPORTED_MODULE_2__types_js__["a" /* WINDOW */].location.href;var activeTransaction;if(startTransactionOnPageLoad){activeTransaction=customStartTransaction({name:__WEBPACK_IMPORTED_MODULE_2__types_js__["a" /* WINDOW */].location.pathname,// pageload should always start at timeOrigin (and needs to be in s, not ms)
startTimestamp:__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["y" /* browserPerformanceTimeOrigin */]?__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["y" /* browserPerformanceTimeOrigin */]/1000:undefined,op:'pageload',origin:'auto.pageload.browser',metadata:{source:'url'}});}if(startTransactionOnLocationChange){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["q" /* addHistoryInstrumentationHandler */])(function(_ref){var to=_ref.to,from=_ref.from;/**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */if(from===undefined&&startingUrl&&startingUrl.indexOf(to)!==-1){startingUrl=undefined;return;}if(from!==to){startingUrl=undefined;if(activeTransaction){__WEBPACK_IMPORTED_MODULE_1__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log("[Tracing] Finishing current transaction with op: ".concat(activeTransaction.op));// If there's an open transaction on the scope, we need to finish it before creating an new one.
activeTransaction.end();}activeTransaction=customStartTransaction({name:__WEBPACK_IMPORTED_MODULE_2__types_js__["a" /* WINDOW */].location.pathname,op:'navigation',origin:'auto.navigation.browser',metadata:{source:'url'}});}});}}

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BROWSER_TRACING_INTEGRATION_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return browserTracingIntegration; });
/* unused harmony export getMetaContent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return startBrowserTracingNavigationSpan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return startBrowserTracingPageLoadSpan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backgroundtab_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__instrument_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__metrics_index_js__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__request_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_js__ = __webpack_require__(29);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var BROWSER_TRACING_INTEGRATION_ID='BrowserTracing';/** Options for Browser Tracing integration */var DEFAULT_BROWSER_TRACING_OPTIONS=_objectSpread({},__WEBPACK_IMPORTED_MODULE_0__sentry_core__["o" /* TRACING_DEFAULTS */],{instrumentNavigation:true,instrumentPageLoad:true,markBackgroundSpan:true,enableLongTask:true,enableInp:false,interactionsSampleRate:1,_experiments:{}},__WEBPACK_IMPORTED_MODULE_6__request_js__["a" /* defaultRequestInstrumentationOptions */]);/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */var browserTracingIntegration=function browserTracingIntegration(){var _options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _hasSetTracePropagationTargets=__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]?!!(// eslint-disable-next-line deprecation/deprecation
_options.tracePropagationTargets||_options.tracingOrigins):false;Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["t" /* addTracingExtensions */])();// TODO (v8): remove this block after tracingOrigins is removed
// Set tracePropagationTargets to tracingOrigins if specified by the user
// In case both are specified, tracePropagationTargets takes precedence
// eslint-disable-next-line deprecation/deprecation
if(!_options.tracePropagationTargets&&_options.tracingOrigins){// eslint-disable-next-line deprecation/deprecation
_options.tracePropagationTargets=_options.tracingOrigins;}var options=_objectSpread({},DEFAULT_BROWSER_TRACING_OPTIONS,{},_options);var _collectWebVitals=Object(__WEBPACK_IMPORTED_MODULE_5__metrics_index_js__["e" /* startTrackingWebVitals */])();/** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */var interactionIdToRouteNameMapping={};if(options.enableInp){Object(__WEBPACK_IMPORTED_MODULE_5__metrics_index_js__["b" /* startTrackingINP */])(interactionIdToRouteNameMapping,options.interactionsSampleRate);}if(options.enableLongTask){Object(__WEBPACK_IMPORTED_MODULE_5__metrics_index_js__["d" /* startTrackingLongTasks */])();}if(options._experiments.enableInteractions){Object(__WEBPACK_IMPORTED_MODULE_5__metrics_index_js__["c" /* startTrackingInteractions */])();}var latestRoute={name:undefined,context:undefined};/** Create routing idle transaction. */function _createRouteTransaction(context){// eslint-disable-next-line deprecation/deprecation
var hub=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["O" /* getCurrentHub */])();var beforeStartSpan=options.beforeStartSpan,idleTimeout=options.idleTimeout,finalTimeout=options.finalTimeout,heartbeatInterval=options.heartbeatInterval;var isPageloadTransaction=context.op==='pageload';var expandedContext;if(isPageloadTransaction){var sentryTrace=isPageloadTransaction?getMetaContent('sentry-trace'):'';var baggage=isPageloadTransaction?getMetaContent('baggage'):undefined;var _propagationContextFr=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_35" /* propagationContextFromHeaders */])(sentryTrace,baggage),traceId=_propagationContextFr.traceId,dsc=_propagationContextFr.dsc,parentSpanId=_propagationContextFr.parentSpanId,sampled=_propagationContextFr.sampled;expandedContext=_objectSpread({traceId:traceId,parentSpanId:parentSpanId,parentSampled:sampled},context,{metadata:_objectSpread({},context.metadata,{dynamicSamplingContext:dsc}),trimEnd:true});}else{expandedContext=_objectSpread({trimEnd:true},context);}var finalContext=beforeStartSpan?beforeStartSpan(expandedContext):expandedContext;// If `beforeStartSpan` set a custom name, record that fact
// eslint-disable-next-line deprecation/deprecation
finalContext.metadata=finalContext.name!==expandedContext.name?// eslint-disable-next-line deprecation/deprecation
_objectSpread({},finalContext.metadata,{source:'custom'}):// eslint-disable-next-line deprecation/deprecation
finalContext.metadata;latestRoute.name=finalContext.name;latestRoute.context=finalContext;if(finalContext.sampled===false){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Tracing] Will not send ".concat(finalContext.op," transaction because of beforeNavigate."));}__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Tracing] Starting ".concat(finalContext.op," transaction on scope"));var location=__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].location;var idleTransaction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_26" /* startIdleTransaction */])(hub,finalContext,idleTimeout,finalTimeout,true,{location:location},// for use in the tracesSampler
heartbeatInterval,isPageloadTransaction// should wait for finish signal if it's a pageload transaction
);if(isPageloadTransaction&&__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].document){__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].document.addEventListener('readystatechange',function(){if(['interactive','complete'].includes(__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].document.readyState)){idleTransaction.sendAutoFinishSignal();}});if(['interactive','complete'].includes(__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].document.readyState)){idleTransaction.sendAutoFinishSignal();}}idleTransaction.registerBeforeFinishCallback(function(transaction){_collectWebVitals();Object(__WEBPACK_IMPORTED_MODULE_5__metrics_index_js__["a" /* addPerformanceEntries */])(transaction);});return idleTransaction;}return{name:BROWSER_TRACING_INTEGRATION_ID,// eslint-disable-next-line @typescript-eslint/no-empty-function
setupOnce:function setupOnce(){},afterAllSetup:function afterAllSetup(client){var clientOptions=client.getOptions();var markBackgroundSpan=options.markBackgroundSpan,traceFetch=options.traceFetch,traceXHR=options.traceXHR,shouldCreateSpanForRequest=options.shouldCreateSpanForRequest,enableHTTPTimings=options.enableHTTPTimings,_experiments=options._experiments;var clientOptionsTracePropagationTargets=clientOptions&&clientOptions.tracePropagationTargets;// There are three ways to configure tracePropagationTargets:
// 1. via top level client option `tracePropagationTargets`
// 2. via BrowserTracing option `tracePropagationTargets`
// 3. via BrowserTracing option `tracingOrigins` (deprecated)
//
// To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
// BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
// This is done as it minimizes bundle size (we don't have to have undefined checks).
//
// If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
// eslint-disable-next-line deprecation/deprecation
var tracePropagationTargets=clientOptionsTracePropagationTargets||options.tracePropagationTargets;if(__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&_hasSetTracePropagationTargets&&clientOptionsTracePropagationTargets){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');}var activeSpan;var startingUrl=__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].location&&__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].location.href;if(client.on){client.on('startNavigationSpan',function(context){if(activeSpan){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Tracing] Finishing current transaction with op: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_24" /* spanToJSON */])(activeSpan).op));// If there's an open transaction on the scope, we need to finish it before creating an new one.
activeSpan.end();}activeSpan=_createRouteTransaction(_objectSpread({op:'navigation'},context));});client.on('startPageLoadSpan',function(context){if(activeSpan){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Tracing] Finishing current transaction with op: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_24" /* spanToJSON */])(activeSpan).op));// If there's an open transaction on the scope, we need to finish it before creating an new one.
activeSpan.end();}activeSpan=_createRouteTransaction(_objectSpread({op:'pageload'},context));});}if(options.instrumentPageLoad&&client.emit&&__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].location){var context={name:__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].location.pathname,// pageload should always start at timeOrigin (and needs to be in s, not ms)
startTimestamp:__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]?__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["y" /* browserPerformanceTimeOrigin */]/1000:undefined,origin:'auto.pageload.browser',attributes:_defineProperty({},__WEBPACK_IMPORTED_MODULE_0__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],'url')};startBrowserTracingPageLoadSpan(client,context);}if(options.instrumentNavigation&&client.emit&&__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].location){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["q" /* addHistoryInstrumentationHandler */])(function(_ref){var to=_ref.to,from=_ref.from;/**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */if(from===undefined&&startingUrl&&startingUrl.indexOf(to)!==-1){startingUrl=undefined;return;}if(from!==to){startingUrl=undefined;var _context={name:__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].location.pathname,origin:'auto.navigation.browser',attributes:_defineProperty({},__WEBPACK_IMPORTED_MODULE_0__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],'url')};startBrowserTracingNavigationSpan(client,_context);}});}if(markBackgroundSpan){Object(__WEBPACK_IMPORTED_MODULE_3__backgroundtab_js__["a" /* registerBackgroundTabDetection */])();}if(_experiments.enableInteractions){registerInteractionListener(options,latestRoute);}if(options.enableInp){registerInpInteractionListener(interactionIdToRouteNameMapping,latestRoute);}Object(__WEBPACK_IMPORTED_MODULE_6__request_js__["b" /* instrumentOutgoingRequests */])({traceFetch:traceFetch,traceXHR:traceXHR,tracePropagationTargets:tracePropagationTargets,shouldCreateSpanForRequest:shouldCreateSpanForRequest,enableHTTPTimings:enableHTTPTimings});},// TODO v8: Remove this again
// This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
options:options};};/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */function startBrowserTracingPageLoadSpan(client,spanOptions){if(!client.emit){return;}client.emit('startPageLoadSpan',spanOptions);var span=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["L" /* getActiveSpan */])();var op=span&&Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_24" /* spanToJSON */])(span).op;return op==='pageload'?span:undefined;}/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */function startBrowserTracingNavigationSpan(client,spanOptions){if(!client.emit){return;}client.emit('startNavigationSpan',spanOptions);var span=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["L" /* getActiveSpan */])();var op=span&&Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_24" /* spanToJSON */])(span).op;return op==='navigation'?span:undefined;}/** Returns the value of a meta tag */function getMetaContent(metaName){// Can't specify generic to `getDomElement` because tracing can be used
// in a variety of environments, have to disable `no-unsafe-member-access`
// as a result.
var metaTag=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["Y" /* getDomElement */])("meta[name=".concat(metaName,"]"));// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
return metaTag?metaTag.getAttribute('content'):undefined;}/** Start listener for interaction transactions */function registerInteractionListener(options,latestRoute){var inflightInteractionTransaction;var registerInteractionTransaction=function registerInteractionTransaction(){var idleTimeout=options.idleTimeout,finalTimeout=options.finalTimeout,heartbeatInterval=options.heartbeatInterval;var op='ui.action.click';// eslint-disable-next-line deprecation/deprecation
var currentTransaction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["M" /* getActiveTransaction */])();if(currentTransaction&&currentTransaction.op&&['navigation','pageload'].includes(currentTransaction.op)){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn("[Tracing] Did not create ".concat(op," transaction because a pageload or navigation transaction is in progress."));return undefined;}if(inflightInteractionTransaction){inflightInteractionTransaction.setFinishReason('interactionInterrupted');inflightInteractionTransaction.end();inflightInteractionTransaction=undefined;}if(!latestRoute.name){__WEBPACK_IMPORTED_MODULE_2__common_debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn("[Tracing] Did not create ".concat(op," transaction because _latestRouteName is missing."));return undefined;}var location=__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].location;var context={name:latestRoute.name,op:op,trimEnd:true,data:_defineProperty({},__WEBPACK_IMPORTED_MODULE_0__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],latestRoute.context?getSource(latestRoute.context):'url')};inflightInteractionTransaction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_26" /* startIdleTransaction */])(// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["O" /* getCurrentHub */])(),context,idleTimeout,finalTimeout,true,{location:location},// for use in the tracesSampler
heartbeatInterval);};['click'].forEach(function(type){if(__WEBPACK_IMPORTED_MODULE_7__types_js__["a" /* WINDOW */].document){addEventListener(type,registerInteractionTransaction,{once:false,capture:true});}});}function isPerformanceEventTiming(entry){return'duration'in entry;}/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */var MAX_INTERACTIONS=10;/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */function registerInpInteractionListener(interactionIdToRouteNameMapping,latestRoute){var handleEntries=function handleEntries(_ref2){var entries=_ref2.entries;var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])();// We need to get the replay, user, and activeTransaction from the current scope
// so that we can associate replay id, profile id, and a user display to the span
var replay=client!==undefined&&client.getIntegrationByName!==undefined?client.getIntegrationByName('Replay'):undefined;var replayId=replay!==undefined?replay.getReplayId():undefined;// eslint-disable-next-line deprecation/deprecation
var activeTransaction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["M" /* getActiveTransaction */])();var currentScope=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["P" /* getCurrentScope */])();var user=currentScope!==undefined?currentScope.getUser():undefined;entries.forEach(function(entry){if(isPerformanceEventTiming(entry)){var interactionId=entry.interactionId;if(interactionId===undefined){return;}var existingInteraction=interactionIdToRouteNameMapping[interactionId];var duration=entry.duration;var startTime=entry.startTime;var keys=Object.keys(interactionIdToRouteNameMapping);var minInteractionId=keys.length>0?keys.reduce(function(a,b){return interactionIdToRouteNameMapping[a].duration<interactionIdToRouteNameMapping[b].duration?a:b;}):undefined;// For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
// This is also checked in the web-vitals library.
if(entry.entryType==='first-input'){var matchingEntry=keys.map(function(key){return interactionIdToRouteNameMapping[key];}).some(function(interaction){return interaction.duration===duration&&interaction.startTime===startTime;});if(matchingEntry){return;}}// Interactions with an id of 0 and are not first-input are not valid.
if(!interactionId){return;}// If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
if(existingInteraction){existingInteraction.duration=Math.max(existingInteraction.duration,duration);}else if(keys.length<MAX_INTERACTIONS||minInteractionId===undefined||duration>interactionIdToRouteNameMapping[minInteractionId].duration){// If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
var routeName=latestRoute.name;var parentContext=latestRoute.context;if(routeName&&parentContext){if(minInteractionId&&Object.keys(interactionIdToRouteNameMapping).length>=MAX_INTERACTIONS){// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
delete interactionIdToRouteNameMapping[minInteractionId];}interactionIdToRouteNameMapping[interactionId]={routeName:routeName,duration:duration,parentContext:parentContext,user:user,activeTransaction:activeTransaction,replayId:replayId,startTime:startTime};}}}});};Object(__WEBPACK_IMPORTED_MODULE_4__instrument_js__["e" /* addPerformanceInstrumentationHandler */])('event',handleEntries);Object(__WEBPACK_IMPORTED_MODULE_4__instrument_js__["e" /* addPerformanceInstrumentationHandler */])('first-input',handleEntries);}function getSource(context){var sourceFromAttributes=context.attributes&&context.attributes[__WEBPACK_IMPORTED_MODULE_0__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */]];// eslint-disable-next-line deprecation/deprecation
var sourceFromData=context.data&&context.data[__WEBPACK_IMPORTED_MODULE_0__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */]];// eslint-disable-next-line deprecation/deprecation
var sourceFromMetadata=context.metadata&&context.metadata.source;return sourceFromAttributes||sourceFromData||sourceFromMetadata;}

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export addExtensionMethods */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}/**
 * @private
 */function _autoloadDatabaseIntegrations(){var carrier=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["W" /* getMainCarrier */])();if(!carrier.__SENTRY__){return;}var packageToIntegrationMapping={mongodb:function mongodb(){var integration=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["K" /* dynamicRequire */])(module,'./node/integrations/mongo');return new integration.Mongo();},mongoose:function mongoose(){var integration=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["K" /* dynamicRequire */])(module,'./node/integrations/mongo');return new integration.Mongo();},mysql:function mysql(){var integration=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["K" /* dynamicRequire */])(module,'./node/integrations/mysql');return new integration.Mysql();},pg:function pg(){var integration=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["K" /* dynamicRequire */])(module,'./node/integrations/postgres');return new integration.Postgres();}};var mappedPackages=Object.keys(packageToIntegrationMapping).filter(function(moduleName){return!!Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_25" /* loadModule */])(moduleName);}).map(function(pkg){try{return packageToIntegrationMapping[pkg]();}catch(e){return undefined;}}).filter(function(p){return p;});if(mappedPackages.length>0){carrier.__SENTRY__.integrations=[].concat(_toConsumableArray(carrier.__SENTRY__.integrations||[]),_toConsumableArray(mappedPackages));}}/**
 * This patches the global object and injects the Tracing extensions methods
 */function addExtensionMethods(){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["t" /* addTracingExtensions */])();// Detect and automatically load specified integrations.
if(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_17" /* isNodeEnv */])()){_autoloadDatabaseIntegrations();}}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(192)(module)))

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearCachedFetchImplementation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNativeFetchImplementation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_build_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_js__ = __webpack_require__(38);
var cachedFetchImpl=undefined;/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */function getNativeFetchImplementation(){if(cachedFetchImpl){return cachedFetchImpl;}/* eslint-disable @typescript-eslint/unbound-method */// Fast path to avoid DOM I/O
if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_16" /* isNativeFetch */])(__WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* WINDOW */].fetch)){return cachedFetchImpl=__WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* WINDOW */].fetch.bind(__WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* WINDOW */]);}var document=__WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* WINDOW */].document;var fetchImpl=__WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* WINDOW */].fetch;// eslint-disable-next-line deprecation/deprecation
if(document&&typeof document.createElement==='function'){try{var sandbox=document.createElement('iframe');sandbox.hidden=true;document.head.appendChild(sandbox);var contentWindow=sandbox.contentWindow;if(contentWindow&&contentWindow.fetch){fetchImpl=contentWindow.fetch;}document.head.removeChild(sandbox);}catch(e){__WEBPACK_IMPORTED_MODULE_1__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ',e);}}return cachedFetchImpl=fetchImpl.bind(__WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* WINDOW */]);/* eslint-enable @typescript-eslint/unbound-method */}/** Clears cached fetch impl */function clearCachedFetchImplementation(){cachedFetchImpl=undefined;}

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return captureUserFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultIntegrations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return forceLoad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDefaultIntegrations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return onLoad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return showReportDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return wrap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__debug_build_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__integrations_breadcrumbs_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__integrations_dedupe_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__integrations_globalhandlers_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__integrations_httpcontext_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__integrations_linkederrors_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__integrations_trycatch_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__stack_parsers_js__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__transports_fetch_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__transports_xhr_js__ = __webpack_require__(315);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/** @deprecated Use `getDefaultIntegrations(options)` instead. */var defaultIntegrations=[Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_1" /* inboundFiltersIntegration */])(),Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["K" /* functionToStringIntegration */])(),Object(__WEBPACK_IMPORTED_MODULE_10__integrations_trycatch_js__["b" /* browserApiErrorsIntegration */])(),Object(__WEBPACK_IMPORTED_MODULE_5__integrations_breadcrumbs_js__["b" /* breadcrumbsIntegration */])(),Object(__WEBPACK_IMPORTED_MODULE_7__integrations_globalhandlers_js__["b" /* globalHandlersIntegration */])(),Object(__WEBPACK_IMPORTED_MODULE_9__integrations_linkederrors_js__["b" /* linkedErrorsIntegration */])(),Object(__WEBPACK_IMPORTED_MODULE_6__integrations_dedupe_js__["b" /* dedupeIntegration */])(),Object(__WEBPACK_IMPORTED_MODULE_8__integrations_httpcontext_js__["b" /* httpContextIntegration */])()];/** Get the default integrations for the browser SDK. */function getDefaultIntegrations(_options){// We return a copy of the defaultIntegrations here to avoid mutating this
return[].concat(defaultIntegrations);}/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 *//**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */function init(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(options.defaultIntegrations===undefined){options.defaultIntegrations=getDefaultIntegrations();}if(options.release===undefined){// This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
if(typeof __SENTRY_RELEASE__==='string'){options.release=__SENTRY_RELEASE__;}// This supports the variable that sentry-webpack-plugin injects
if(__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].SENTRY_RELEASE&&__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].SENTRY_RELEASE.id){options.release=__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].SENTRY_RELEASE.id;}}if(options.autoSessionTracking===undefined){options.autoSessionTracking=true;}if(options.sendClientReports===undefined){options.sendClientReports=true;}var clientOptions=_objectSpread({},options,{stackParser:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_42" /* stackParserFromStackParserOptions */])(options.stackParser||__WEBPACK_IMPORTED_MODULE_11__stack_parsers_js__["c" /* defaultStackParser */]),integrations:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["U" /* getIntegrationsToSetup */])(options),transport:options.transport||(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_45" /* supportsFetch */])()?__WEBPACK_IMPORTED_MODULE_12__transports_fetch_js__["a" /* makeFetchTransport */]:__WEBPACK_IMPORTED_MODULE_13__transports_xhr_js__["a" /* makeXHRTransport */])});Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_2" /* initAndBind */])(__WEBPACK_IMPORTED_MODULE_2__client_js__["a" /* BrowserClient */],clientOptions);if(options.autoSessionTracking){startSessionTracking();}}var showReportDialog=function showReportDialog(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var hub=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["O" /* getCurrentHub */])();// doesn't work without a document (React Native)
if(!__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].document){__WEBPACK_IMPORTED_MODULE_3__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].error('Global document not defined in showReportDialog call');return;}// eslint-disable-next-line deprecation/deprecation
var _hub$getStackTop=hub.getStackTop(),client=_hub$getStackTop.client,scope=_hub$getStackTop.scope;var dsn=options.dsn||client&&client.getDsn();if(!dsn){__WEBPACK_IMPORTED_MODULE_3__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].error('DSN not configured for showReportDialog call');return;}if(scope){options.user=_objectSpread({},scope.getUser(),{},options.user);}if(!options.eventId){// eslint-disable-next-line deprecation/deprecation
options.eventId=hub.lastEventId();}var script=__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].document.createElement('script');script.async=true;script.crossOrigin='anonymous';script.src=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["X" /* getReportDialogEndpoint */])(dsn,options);if(options.onLoad){script.onload=options.onLoad;}var onClose=options.onClose;if(onClose){var reportDialogClosedMessageHandler=function reportDialogClosedMessageHandler(event){if(event.data==='__sentry_reportdialog_closed__'){try{onClose();}finally{__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].removeEventListener('message',reportDialogClosedMessageHandler);}}};__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].addEventListener('message',reportDialogClosedMessageHandler);}var injectionPoint=__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].document.head||__WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].document.body;if(injectionPoint){injectionPoint.appendChild(script);}else{__WEBPACK_IMPORTED_MODULE_3__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].error('Not injecting report dialog. No injection point found in HTML');}};/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */function forceLoad(){// Noop
}/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */function onLoad(callback){callback();}/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */// TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_js__["c" /* wrap */])(fn)();}/**
 * Enable automatic Session Tracking for the initial page load.
 */function startSessionTracking(){if(typeof __WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* WINDOW */].document==='undefined'){__WEBPACK_IMPORTED_MODULE_3__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('Session tracking in non-browser environment with @sentry/browser is not supported.');return;}// The session duration for browser sessions does not track a meaningful
// concept that can be used as a metric.
// Automatically captured sessions are akin to page views, and thus we
// discard their duration.
Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_28" /* startSession */])({ignoreDuration:true});Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["y" /* captureSession */])();// We want to create a session for every navigation as well
Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["q" /* addHistoryInstrumentationHandler */])(function(_ref){var from=_ref.from,to=_ref.to;// Don't create an additional session for the initial route or if the location did not change
if(from!==undefined&&from!==to){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_28" /* startSession */])({ignoreDuration:true});Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["y" /* captureSession */])();}});}/**
 * Captures user feedback and sends it to Sentry.
 */function captureUserFeedback(feedback){var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])();if(client){client.captureUserFeedback(feedback);}}

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalhandlers_js__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalHandlers", function() { return __WEBPACK_IMPORTED_MODULE_0__globalhandlers_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trycatch_js__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TryCatch", function() { return __WEBPACK_IMPORTED_MODULE_1__trycatch_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumbs_js__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return __WEBPACK_IMPORTED_MODULE_2__breadcrumbs_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkederrors_js__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedErrors", function() { return __WEBPACK_IMPORTED_MODULE_3__linkederrors_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__httpcontext_js__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HttpContext", function() { return __WEBPACK_IMPORTED_MODULE_4__httpcontext_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dedupe_js__ = __webpack_require__(209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dedupe", function() { return __WEBPACK_IMPORTED_MODULE_5__dedupe_js__["a"]; });
/* eslint-disable deprecation/deprecation */

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Replay$1; });
/* unused harmony export Replay */
/* unused harmony export getReplay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getReplay$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return replayIntegration$1; });
/* unused harmony export replayIntegration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_internal_tracing__ = __webpack_require__(204);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf(subClass,superClass);}function _wrapNativeSuper(Class){var _cache=typeof Map==="function"?new Map():undefined;_wrapNativeSuper=function _wrapNativeSuper(Class){if(Class===null||!_isNativeFunction(Class))return Class;if(typeof Class!=="function"){throw new TypeError("Super expression must either be null or a function");}if(typeof _cache!=="undefined"){if(_cache.has(Class))return _cache.get(Class);_cache.set(Class,Wrapper);}function Wrapper(){return _construct(Class,arguments,_getPrototypeOf(this).constructor);}Wrapper.prototype=Object.create(Class.prototype,{constructor:{value:Wrapper,enumerable:false,writable:true,configurable:true}});return _setPrototypeOf(Wrapper,Class);};return _wrapNativeSuper(Class);}function isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Date.prototype.toString.call(Reflect.construct(Date,[],function(){}));return true;}catch(e){return false;}}function _construct(Parent,args,Class){if(isNativeReflectConstruct()){_construct=Reflect.construct;}else{_construct=function _construct(Parent,args,Class){var a=[null];a.push.apply(a,args);var Constructor=Function.bind.apply(Parent,a);var instance=new Constructor();if(Class)_setPrototypeOf(instance,Class.prototype);return instance;};}return _construct.apply(null,arguments);}function _isNativeFunction(fn){return Function.toString.call(fn).indexOf("[native code]")!==-1;}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
var WINDOW=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */];var REPLAY_SESSION_KEY='sentryReplaySession';var REPLAY_EVENT_NAME='replay_event';var UNABLE_TO_SEND_REPLAY='Unable to send Replay';// The idle limit for a session after which recording is paused.
var SESSION_IDLE_PAUSE_DURATION=300000;// 5 minutes in ms
// The idle limit for a session after which the session expires.
var SESSION_IDLE_EXPIRE_DURATION=900000;// 15 minutes in ms
/** Default flush delays */var DEFAULT_FLUSH_MIN_DELAY=5000;// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
var DEFAULT_FLUSH_MAX_DELAY=5500;/* How long to wait for error checkouts */var BUFFER_CHECKOUT_TIME=60000;var RETRY_BASE_INTERVAL=5000;var RETRY_MAX_COUNT=3;/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */var NETWORK_BODY_MAX_SIZE=150000;/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */var CONSOLE_ARG_MAX_SIZE=5000;/* Min. time to wait before we consider something a slow click. */var SLOW_CLICK_THRESHOLD=3000;/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */var SLOW_CLICK_SCROLL_TIMEOUT=300;/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */var REPLAY_MAX_EVENT_BUFFER_SIZE=20000000;// ~20MB
/** Replays must be min. 5s long before we send them. */var MIN_REPLAY_DURATION=4999;/* The max. allowed value that the minReplayDuration can be set to. */var MIN_REPLAY_DURATION_LIMIT=15000;/** The max. length of a replay. */var MAX_REPLAY_DURATION=3600000;// 60 minutes in ms;
function _nullishCoalesce$1(lhs,rhsFn){if(lhs!=null){return lhs;}else{return rhsFn();}}function _optionalChain$5(ops){var lastAccessLHS=undefined;var value=ops[0];var i=1;while(i<ops.length){var op=ops[i];var fn=ops[i+1];i+=2;if((op==='optionalAccess'||op==='optionalCall')&&value==null){return undefined;}if(op==='access'||op==='optionalAccess'){lastAccessLHS=value;value=fn(value);}else if(op==='call'||op==='optionalCall'){value=fn(function(){var _value2;for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return(_value2=value).call.apply(_value2,[lastAccessLHS].concat(args));});lastAccessLHS=undefined;}}return value;}var NodeType$1;(function(NodeType){NodeType[NodeType["Document"]=0]="Document";NodeType[NodeType["DocumentType"]=1]="DocumentType";NodeType[NodeType["Element"]=2]="Element";NodeType[NodeType["Text"]=3]="Text";NodeType[NodeType["CDATA"]=4]="CDATA";NodeType[NodeType["Comment"]=5]="Comment";})(NodeType$1||(NodeType$1={}));function isElement$1(n){return n.nodeType===n.ELEMENT_NODE;}function isShadowRoot(n){var host=_optionalChain$5([n,'optionalAccess',function(_){return _.host;}]);return Boolean(_optionalChain$5([host,'optionalAccess',function(_2){return _2.shadowRoot;}])===n);}function isNativeShadowDom(shadowRoot){return Object.prototype.toString.call(shadowRoot)==='[object ShadowRoot]';}function fixBrowserCompatibilityIssuesInCSS(cssText){if(cssText.includes(' background-clip: text;')&&!cssText.includes(' -webkit-background-clip: text;')){cssText=cssText.replace(' background-clip: text;',' -webkit-background-clip: text; background-clip: text;');}return cssText;}function escapeImportStatement(rule){var cssText=rule.cssText;if(cssText.split('"').length<3)return cssText;var statement=['@import',"url(".concat(JSON.stringify(rule.href),")")];if(rule.layerName===''){statement.push("layer");}else if(rule.layerName){statement.push("layer(".concat(rule.layerName,")"));}if(rule.supportsText){statement.push("supports(".concat(rule.supportsText,")"));}if(rule.media.length){statement.push(rule.media.mediaText);}return statement.join(' ')+';';}function stringifyStylesheet(s){try{var rules=s.rules||s.cssRules;return rules?fixBrowserCompatibilityIssuesInCSS(Array.from(rules,stringifyRule).join('')):null;}catch(error){return null;}}function stringifyRule(rule){var importStringified;if(isCSSImportRule(rule)){try{importStringified=stringifyStylesheet(rule.styleSheet)||escapeImportStatement(rule);}catch(error){}}else if(isCSSStyleRule(rule)&&rule.selectorText.includes(':')){return fixSafariColons(rule.cssText);}return importStringified||rule.cssText;}function fixSafariColons(cssStringified){var regex=/(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;return cssStringified.replace(regex,'$1\\$2');}function isCSSImportRule(rule){return'styleSheet'in rule;}function isCSSStyleRule(rule){return'selectorText'in rule;}var Mirror=/*#__PURE__*/function(){function Mirror(){_classCallCheck(this,Mirror);this.idNodeMap=new Map();this.nodeMetaMap=new WeakMap();}_createClass(Mirror,[{key:"getId",value:function getId(n){if(!n)return-1;var id=_optionalChain$5([this,'access',function(_3){return _3.getMeta;},'call',function(_4){return _4(n);},'optionalAccess',function(_5){return _5.id;}]);return _nullishCoalesce$1(id,function(){return-1;});}},{key:"getNode",value:function getNode(id){return this.idNodeMap.get(id)||null;}},{key:"getIds",value:function getIds(){return Array.from(this.idNodeMap.keys());}},{key:"getMeta",value:function getMeta(n){return this.nodeMetaMap.get(n)||null;}},{key:"removeNodeFromMap",value:function removeNodeFromMap(n){var _this=this;var id=this.getId(n);this.idNodeMap.delete(id);if(n.childNodes){n.childNodes.forEach(function(childNode){return _this.removeNodeFromMap(childNode);});}}},{key:"has",value:function has(id){return this.idNodeMap.has(id);}},{key:"hasNode",value:function hasNode(node){return this.nodeMetaMap.has(node);}},{key:"add",value:function add(n,meta){var id=meta.id;this.idNodeMap.set(id,n);this.nodeMetaMap.set(n,meta);}},{key:"replace",value:function replace(id,n){var oldNode=this.getNode(id);if(oldNode){var meta=this.nodeMetaMap.get(oldNode);if(meta)this.nodeMetaMap.set(n,meta);}this.idNodeMap.set(id,n);}},{key:"reset",value:function reset(){this.idNodeMap=new Map();this.nodeMetaMap=new WeakMap();}}]);return Mirror;}();function createMirror(){return new Mirror();}function shouldMaskInput(_ref){var maskInputOptions=_ref.maskInputOptions,tagName=_ref.tagName,type=_ref.type;if(tagName==='OPTION'){tagName='SELECT';}return Boolean(maskInputOptions[tagName.toLowerCase()]||type&&maskInputOptions[type]||type==='password'||tagName==='INPUT'&&!type&&maskInputOptions['text']);}function maskInputValue(_ref2){var isMasked=_ref2.isMasked,element=_ref2.element,value=_ref2.value,maskInputFn=_ref2.maskInputFn;var text=value||'';if(!isMasked){return text;}if(maskInputFn){text=maskInputFn(text,element);}return'*'.repeat(text.length);}function toLowerCase(str){return str.toLowerCase();}function toUpperCase(str){return str.toUpperCase();}var ORIGINAL_ATTRIBUTE_NAME='__rrweb_original__';function is2DCanvasBlank(canvas){var ctx=canvas.getContext('2d');if(!ctx)return true;var chunkSize=50;for(var x=0;x<canvas.width;x+=chunkSize){for(var y=0;y<canvas.height;y+=chunkSize){var getImageData=ctx.getImageData;var originalGetImageData=ORIGINAL_ATTRIBUTE_NAME in getImageData?getImageData[ORIGINAL_ATTRIBUTE_NAME]:getImageData;var pixelBuffer=new Uint32Array(originalGetImageData.call(ctx,x,y,Math.min(chunkSize,canvas.width-x),Math.min(chunkSize,canvas.height-y)).data.buffer);if(pixelBuffer.some(function(pixel){return pixel!==0;}))return false;}}return true;}function getInputType(element){var type=element.type;return element.hasAttribute('data-rr-is-password')?'password':type?toLowerCase(type):null;}function getInputValue(el,tagName,type){if(tagName==='INPUT'&&(type==='radio'||type==='checkbox')){return el.getAttribute('value')||'';}return el.value;}var _id=1;var tagNameRegex=new RegExp('[^a-z0-9-_:]');var IGNORED_NODE=-2;function genId(){return _id++;}function getValidTagName(element){if(element instanceof HTMLFormElement){return'form';}var processedTagName=toLowerCase(element.tagName);if(tagNameRegex.test(processedTagName)){return'div';}return processedTagName;}function extractOrigin(url){var origin='';if(url.indexOf('//')>-1){origin=url.split('/').slice(0,3).join('/');}else{origin=url.split('/')[0];}origin=origin.split('?')[0];return origin;}var canvasService;var canvasCtx;var URL_IN_CSS_REF=/url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;var URL_PROTOCOL_MATCH=/^(?:[a-z+]+:)?\/\//i;var URL_WWW_MATCH=/^www\..*/i;var DATA_URI=/^(data:)([^,]*),(.*)/i;function absoluteToStylesheet(cssText,href){return(cssText||'').replace(URL_IN_CSS_REF,function(origin,quote1,path1,quote2,path2,path3){var filePath=path1||path2||path3;var maybeQuote=quote1||quote2||'';if(!filePath){return origin;}if(URL_PROTOCOL_MATCH.test(filePath)||URL_WWW_MATCH.test(filePath)){return"url(".concat(maybeQuote).concat(filePath).concat(maybeQuote,")");}if(DATA_URI.test(filePath)){return"url(".concat(maybeQuote).concat(filePath).concat(maybeQuote,")");}if(filePath[0]==='/'){return"url(".concat(maybeQuote).concat(extractOrigin(href)+filePath).concat(maybeQuote,")");}var stack=href.split('/');var parts=filePath.split('/');stack.pop();var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=parts[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var part=_step.value;if(part==='.'){continue;}else if(part==='..'){stack.pop();}else{stack.push(part);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return"url(".concat(maybeQuote).concat(stack.join('/')).concat(maybeQuote,")");});}var SRCSET_NOT_SPACES=/^[^ \t\n\r\u000c]+/;var SRCSET_COMMAS_OR_SPACES=/^[, \t\n\r\u000c]+/;function getAbsoluteSrcsetString(doc,attributeValue){if(attributeValue.trim()===''){return attributeValue;}var pos=0;function collectCharacters(regEx){var chars;var match=regEx.exec(attributeValue.substring(pos));if(match){chars=match[0];pos+=chars.length;return chars;}return'';}var output=[];while(true){collectCharacters(SRCSET_COMMAS_OR_SPACES);if(pos>=attributeValue.length){break;}var url=collectCharacters(SRCSET_NOT_SPACES);if(url.slice(-1)===','){url=absoluteToDoc(doc,url.substring(0,url.length-1));output.push(url);}else{var descriptorsStr='';url=absoluteToDoc(doc,url);var inParens=false;while(true){var c=attributeValue.charAt(pos);if(c===''){output.push((url+descriptorsStr).trim());break;}else if(!inParens){if(c===','){pos+=1;output.push((url+descriptorsStr).trim());break;}else if(c==='('){inParens=true;}}else{if(c===')'){inParens=false;}}descriptorsStr+=c;pos+=1;}}}return output.join(', ');}function absoluteToDoc(doc,attributeValue){if(!attributeValue||attributeValue.trim()===''){return attributeValue;}var a=doc.createElement('a');a.href=attributeValue;return a.href;}function isSVGElement(el){return Boolean(el.tagName==='svg'||el.ownerSVGElement);}function getHref(){var a=document.createElement('a');a.href='';return a.href;}function transformAttribute(doc,tagName,name,value,element,maskAttributeFn){if(!value){return value;}if(name==='src'||name==='href'&&!(tagName==='use'&&value[0]==='#')){return absoluteToDoc(doc,value);}else if(name==='xlink:href'&&value[0]!=='#'){return absoluteToDoc(doc,value);}else if(name==='background'&&(tagName==='table'||tagName==='td'||tagName==='th')){return absoluteToDoc(doc,value);}else if(name==='srcset'){return getAbsoluteSrcsetString(doc,value);}else if(name==='style'){return absoluteToStylesheet(value,getHref());}else if(tagName==='object'&&name==='data'){return absoluteToDoc(doc,value);}if(typeof maskAttributeFn==='function'){return maskAttributeFn(name,value,element);}return value;}function ignoreAttribute(tagName,name,_value){return(tagName==='video'||tagName==='audio')&&name==='autoplay';}function _isBlockedElement(element,blockClass,blockSelector,unblockSelector){try{if(unblockSelector&&element.matches(unblockSelector)){return false;}if(typeof blockClass==='string'){if(element.classList.contains(blockClass)){return true;}}else{for(var eIndex=element.classList.length;eIndex--;){var className=element.classList[eIndex];if(blockClass.test(className)){return true;}}}if(blockSelector){return element.matches(blockSelector);}}catch(e){}return false;}function elementClassMatchesRegex(el,regex){for(var eIndex=el.classList.length;eIndex--;){var className=el.classList[eIndex];if(regex.test(className)){return true;}}return false;}function distanceToMatch(node,matchPredicate){var limit=arguments.length>2&&arguments[2]!==undefined?arguments[2]:Infinity;var distance=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;if(!node)return-1;if(node.nodeType!==node.ELEMENT_NODE)return-1;if(distance>limit)return-1;if(matchPredicate(node))return distance;return distanceToMatch(node.parentNode,matchPredicate,limit,distance+1);}function createMatchPredicate(className,selector){return function(node){var el=node;if(el===null)return false;try{if(className){if(typeof className==='string'){if(el.matches(".".concat(className)))return true;}else if(elementClassMatchesRegex(el,className)){return true;}}if(selector&&el.matches(selector))return true;return false;}catch(e2){return false;}};}function needMaskingText(node,maskTextClass,maskTextSelector,unmaskTextClass,unmaskTextSelector,maskAllText){try{var el=node.nodeType===node.ELEMENT_NODE?node:node.parentElement;if(el===null)return false;if(el.tagName==='INPUT'){var autocomplete=el.getAttribute('autocomplete');var disallowedAutocompleteValues=['current-password','new-password','cc-number','cc-exp','cc-exp-month','cc-exp-year','cc-csc'];if(disallowedAutocompleteValues.includes(autocomplete)){return true;}}var maskDistance=-1;var unmaskDistance=-1;if(maskAllText){unmaskDistance=distanceToMatch(el,createMatchPredicate(unmaskTextClass,unmaskTextSelector));if(unmaskDistance<0){return true;}maskDistance=distanceToMatch(el,createMatchPredicate(maskTextClass,maskTextSelector),unmaskDistance>=0?unmaskDistance:Infinity);}else{maskDistance=distanceToMatch(el,createMatchPredicate(maskTextClass,maskTextSelector));if(maskDistance<0){return false;}unmaskDistance=distanceToMatch(el,createMatchPredicate(unmaskTextClass,unmaskTextSelector),maskDistance>=0?maskDistance:Infinity);}return maskDistance>=0?unmaskDistance>=0?maskDistance<=unmaskDistance:true:unmaskDistance>=0?false:!!maskAllText;}catch(e){}return!!maskAllText;}function onceIframeLoaded(iframeEl,listener,iframeLoadTimeout){var win=iframeEl.contentWindow;if(!win){return;}var fired=false;var readyState;try{readyState=win.document.readyState;}catch(error){return;}if(readyState!=='complete'){var timer=setTimeout(function(){if(!fired){listener();fired=true;}},iframeLoadTimeout);iframeEl.addEventListener('load',function(){clearTimeout(timer);fired=true;listener();});return;}var blankUrl='about:blank';if(win.location.href!==blankUrl||iframeEl.src===blankUrl||iframeEl.src===''){setTimeout(listener,0);return iframeEl.addEventListener('load',listener);}iframeEl.addEventListener('load',listener);}function onceStylesheetLoaded(link,listener,styleSheetLoadTimeout){var fired=false;var styleSheetLoaded;try{styleSheetLoaded=link.sheet;}catch(error){return;}if(styleSheetLoaded)return;var timer=setTimeout(function(){if(!fired){listener();fired=true;}},styleSheetLoadTimeout);link.addEventListener('load',function(){clearTimeout(timer);fired=true;listener();});}function serializeNode(n,options){var doc=options.doc,mirror=options.mirror,blockClass=options.blockClass,blockSelector=options.blockSelector,unblockSelector=options.unblockSelector,maskAllText=options.maskAllText,maskAttributeFn=options.maskAttributeFn,maskTextClass=options.maskTextClass,unmaskTextClass=options.unmaskTextClass,maskTextSelector=options.maskTextSelector,unmaskTextSelector=options.unmaskTextSelector,inlineStylesheet=options.inlineStylesheet,_options$maskInputOpt=options.maskInputOptions,maskInputOptions=_options$maskInputOpt===void 0?{}:_options$maskInputOpt,maskTextFn=options.maskTextFn,maskInputFn=options.maskInputFn,_options$dataURLOptio=options.dataURLOptions,dataURLOptions=_options$dataURLOptio===void 0?{}:_options$dataURLOptio,inlineImages=options.inlineImages,recordCanvas=options.recordCanvas,keepIframeSrcFn=options.keepIframeSrcFn,_options$newlyAddedEl=options.newlyAddedElement,newlyAddedElement=_options$newlyAddedEl===void 0?false:_options$newlyAddedEl;var rootId=getRootId(doc,mirror);switch(n.nodeType){case n.DOCUMENT_NODE:if(n.compatMode!=='CSS1Compat'){return{type:NodeType$1.Document,childNodes:[],compatMode:n.compatMode};}else{return{type:NodeType$1.Document,childNodes:[]};}case n.DOCUMENT_TYPE_NODE:return{type:NodeType$1.DocumentType,name:n.name,publicId:n.publicId,systemId:n.systemId,rootId:rootId};case n.ELEMENT_NODE:return serializeElementNode(n,{doc:doc,blockClass:blockClass,blockSelector:blockSelector,unblockSelector:unblockSelector,inlineStylesheet:inlineStylesheet,maskAttributeFn:maskAttributeFn,maskInputOptions:maskInputOptions,maskInputFn:maskInputFn,dataURLOptions:dataURLOptions,inlineImages:inlineImages,recordCanvas:recordCanvas,keepIframeSrcFn:keepIframeSrcFn,newlyAddedElement:newlyAddedElement,rootId:rootId,maskAllText:maskAllText,maskTextClass:maskTextClass,unmaskTextClass:unmaskTextClass,maskTextSelector:maskTextSelector,unmaskTextSelector:unmaskTextSelector});case n.TEXT_NODE:return serializeTextNode(n,{maskAllText:maskAllText,maskTextClass:maskTextClass,unmaskTextClass:unmaskTextClass,maskTextSelector:maskTextSelector,unmaskTextSelector:unmaskTextSelector,maskTextFn:maskTextFn,maskInputOptions:maskInputOptions,maskInputFn:maskInputFn,rootId:rootId});case n.CDATA_SECTION_NODE:return{type:NodeType$1.CDATA,textContent:'',rootId:rootId};case n.COMMENT_NODE:return{type:NodeType$1.Comment,textContent:n.textContent||'',rootId:rootId};default:return false;}}function getRootId(doc,mirror){if(!mirror.hasNode(doc))return undefined;var docId=mirror.getId(doc);return docId===1?undefined:docId;}function serializeTextNode(n,options){var maskAllText=options.maskAllText,maskTextClass=options.maskTextClass,unmaskTextClass=options.unmaskTextClass,maskTextSelector=options.maskTextSelector,unmaskTextSelector=options.unmaskTextSelector,maskTextFn=options.maskTextFn,maskInputOptions=options.maskInputOptions,maskInputFn=options.maskInputFn,rootId=options.rootId;var parentTagName=n.parentNode&&n.parentNode.tagName;var textContent=n.textContent;var isStyle=parentTagName==='STYLE'?true:undefined;var isScript=parentTagName==='SCRIPT'?true:undefined;var isTextarea=parentTagName==='TEXTAREA'?true:undefined;if(isStyle&&textContent){try{if(n.nextSibling||n.previousSibling){}else if(_optionalChain$5([n,'access',function(_6){return _6.parentNode;},'access',function(_7){return _7.sheet;},'optionalAccess',function(_8){return _8.cssRules;}])){textContent=stringifyStylesheet(n.parentNode.sheet);}}catch(err){console.warn("Cannot get CSS styles from text's parentNode. Error: ".concat(err),n);}textContent=absoluteToStylesheet(textContent,getHref());}if(isScript){textContent='SCRIPT_PLACEHOLDER';}var forceMask=needMaskingText(n,maskTextClass,maskTextSelector,unmaskTextClass,unmaskTextSelector,maskAllText);if(!isStyle&&!isScript&&!isTextarea&&textContent&&forceMask){textContent=maskTextFn?maskTextFn(textContent,n.parentElement):textContent.replace(/[\S]/g,'*');}if(isTextarea&&textContent&&(maskInputOptions.textarea||forceMask)){textContent=maskInputFn?maskInputFn(textContent,n.parentNode):textContent.replace(/[\S]/g,'*');}if(parentTagName==='OPTION'&&textContent){var isInputMasked=shouldMaskInput({type:null,tagName:parentTagName,maskInputOptions:maskInputOptions});textContent=maskInputValue({isMasked:needMaskingText(n,maskTextClass,maskTextSelector,unmaskTextClass,unmaskTextSelector,isInputMasked),element:n,value:textContent,maskInputFn:maskInputFn});}return{type:NodeType$1.Text,textContent:textContent||'',isStyle:isStyle,rootId:rootId};}function serializeElementNode(n,options){var doc=options.doc,blockClass=options.blockClass,blockSelector=options.blockSelector,unblockSelector=options.unblockSelector,inlineStylesheet=options.inlineStylesheet,_options$maskInputOpt2=options.maskInputOptions,maskInputOptions=_options$maskInputOpt2===void 0?{}:_options$maskInputOpt2,maskAttributeFn=options.maskAttributeFn,maskInputFn=options.maskInputFn,_options$dataURLOptio2=options.dataURLOptions,dataURLOptions=_options$dataURLOptio2===void 0?{}:_options$dataURLOptio2,inlineImages=options.inlineImages,recordCanvas=options.recordCanvas,keepIframeSrcFn=options.keepIframeSrcFn,_options$newlyAddedEl2=options.newlyAddedElement,newlyAddedElement=_options$newlyAddedEl2===void 0?false:_options$newlyAddedEl2,rootId=options.rootId,maskAllText=options.maskAllText,maskTextClass=options.maskTextClass,unmaskTextClass=options.unmaskTextClass,maskTextSelector=options.maskTextSelector,unmaskTextSelector=options.unmaskTextSelector;var needBlock=_isBlockedElement(n,blockClass,blockSelector,unblockSelector);var tagName=getValidTagName(n);var attributes={};var len=n.attributes.length;for(var i=0;i<len;i++){var attr=n.attributes[i];if(attr.name&&!ignoreAttribute(tagName,attr.name,attr.value)){attributes[attr.name]=transformAttribute(doc,tagName,toLowerCase(attr.name),attr.value,n,maskAttributeFn);}}if(tagName==='link'&&inlineStylesheet){var stylesheet=Array.from(doc.styleSheets).find(function(s){return s.href===n.href;});var cssText=null;if(stylesheet){cssText=stringifyStylesheet(stylesheet);}if(cssText){delete attributes.rel;delete attributes.href;attributes._cssText=absoluteToStylesheet(cssText,stylesheet.href);}}if(tagName==='style'&&n.sheet&&!(n.innerText||n.textContent||'').trim().length){var _cssText=stringifyStylesheet(n.sheet);if(_cssText){attributes._cssText=absoluteToStylesheet(_cssText,getHref());}}if(tagName==='input'||tagName==='textarea'||tagName==='select'||tagName==='option'){var el=n;var type=getInputType(el);var value=getInputValue(el,toUpperCase(tagName),type);var checked=el.checked;if(type!=='submit'&&type!=='button'&&value){var forceMask=needMaskingText(el,maskTextClass,maskTextSelector,unmaskTextClass,unmaskTextSelector,shouldMaskInput({type:type,tagName:toUpperCase(tagName),maskInputOptions:maskInputOptions}));attributes.value=maskInputValue({isMasked:forceMask,element:el,value:value,maskInputFn:maskInputFn});}if(checked){attributes.checked=checked;}}if(tagName==='option'){if(n.selected&&!maskInputOptions['select']){attributes.selected=true;}else{delete attributes.selected;}}if(tagName==='canvas'&&recordCanvas){if(n.__context==='2d'){if(!is2DCanvasBlank(n)){attributes.rr_dataURL=n.toDataURL(dataURLOptions.type,dataURLOptions.quality);}}else if(!('__context'in n)){var canvasDataURL=n.toDataURL(dataURLOptions.type,dataURLOptions.quality);var blankCanvas=document.createElement('canvas');blankCanvas.width=n.width;blankCanvas.height=n.height;var blankCanvasDataURL=blankCanvas.toDataURL(dataURLOptions.type,dataURLOptions.quality);if(canvasDataURL!==blankCanvasDataURL){attributes.rr_dataURL=canvasDataURL;}}}if(tagName==='img'&&inlineImages){if(!canvasService){canvasService=doc.createElement('canvas');canvasCtx=canvasService.getContext('2d');}var image=n;var oldValue=image.crossOrigin;image.crossOrigin='anonymous';var recordInlineImage=function recordInlineImage(){image.removeEventListener('load',recordInlineImage);try{canvasService.width=image.naturalWidth;canvasService.height=image.naturalHeight;canvasCtx.drawImage(image,0,0);attributes.rr_dataURL=canvasService.toDataURL(dataURLOptions.type,dataURLOptions.quality);}catch(err){console.warn("Cannot inline img src=".concat(image.currentSrc,"! Error: ").concat(err));}oldValue?attributes.crossOrigin=oldValue:image.removeAttribute('crossorigin');};if(image.complete&&image.naturalWidth!==0)recordInlineImage();else image.addEventListener('load',recordInlineImage);}if(tagName==='audio'||tagName==='video'){attributes.rr_mediaState=n.paused?'paused':'played';attributes.rr_mediaCurrentTime=n.currentTime;}if(!newlyAddedElement){if(n.scrollLeft){attributes.rr_scrollLeft=n.scrollLeft;}if(n.scrollTop){attributes.rr_scrollTop=n.scrollTop;}}if(needBlock){var _n$getBoundingClientR=n.getBoundingClientRect(),width=_n$getBoundingClientR.width,height=_n$getBoundingClientR.height;attributes={class:attributes.class,rr_width:"".concat(width,"px"),rr_height:"".concat(height,"px")};}if(tagName==='iframe'&&!keepIframeSrcFn(attributes.src)){if(!n.contentDocument){attributes.rr_src=attributes.src;}delete attributes.src;}var isCustomElement;try{if(customElements.get(tagName))isCustomElement=true;}catch(e){}return{type:NodeType$1.Element,tagName:tagName,attributes:attributes,childNodes:[],isSVG:isSVGElement(n)||undefined,needBlock:needBlock,rootId:rootId,isCustom:isCustomElement};}function lowerIfExists(maybeAttr){if(maybeAttr===undefined||maybeAttr===null){return'';}else{return maybeAttr.toLowerCase();}}function slimDOMExcluded(sn,slimDOMOptions){if(slimDOMOptions.comment&&sn.type===NodeType$1.Comment){return true;}else if(sn.type===NodeType$1.Element){if(slimDOMOptions.script&&(sn.tagName==='script'||sn.tagName==='link'&&(sn.attributes.rel==='preload'||sn.attributes.rel==='modulepreload')&&sn.attributes.as==='script'||sn.tagName==='link'&&sn.attributes.rel==='prefetch'&&typeof sn.attributes.href==='string'&&sn.attributes.href.endsWith('.js'))){return true;}else if(slimDOMOptions.headFavicon&&(sn.tagName==='link'&&sn.attributes.rel==='shortcut icon'||sn.tagName==='meta'&&(lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/)||lowerIfExists(sn.attributes.name)==='application-name'||lowerIfExists(sn.attributes.rel)==='icon'||lowerIfExists(sn.attributes.rel)==='apple-touch-icon'||lowerIfExists(sn.attributes.rel)==='shortcut icon'))){return true;}else if(sn.tagName==='meta'){if(slimDOMOptions.headMetaDescKeywords&&lowerIfExists(sn.attributes.name).match(/^description|keywords$/)){return true;}else if(slimDOMOptions.headMetaSocial&&(lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/)||lowerIfExists(sn.attributes.name).match(/^(og|twitter):/)||lowerIfExists(sn.attributes.name)==='pinterest')){return true;}else if(slimDOMOptions.headMetaRobots&&(lowerIfExists(sn.attributes.name)==='robots'||lowerIfExists(sn.attributes.name)==='googlebot'||lowerIfExists(sn.attributes.name)==='bingbot')){return true;}else if(slimDOMOptions.headMetaHttpEquiv&&sn.attributes['http-equiv']!==undefined){return true;}else if(slimDOMOptions.headMetaAuthorship&&(lowerIfExists(sn.attributes.name)==='author'||lowerIfExists(sn.attributes.name)==='generator'||lowerIfExists(sn.attributes.name)==='framework'||lowerIfExists(sn.attributes.name)==='publisher'||lowerIfExists(sn.attributes.name)==='progid'||lowerIfExists(sn.attributes.property).match(/^article:/)||lowerIfExists(sn.attributes.property).match(/^product:/))){return true;}else if(slimDOMOptions.headMetaVerification&&(lowerIfExists(sn.attributes.name)==='google-site-verification'||lowerIfExists(sn.attributes.name)==='yandex-verification'||lowerIfExists(sn.attributes.name)==='csrf-token'||lowerIfExists(sn.attributes.name)==='p:domain_verify'||lowerIfExists(sn.attributes.name)==='verify-v1'||lowerIfExists(sn.attributes.name)==='verification'||lowerIfExists(sn.attributes.name)==='shopify-checkout-api-token')){return true;}}}return false;}function serializeNodeWithId(n,options){var doc=options.doc,mirror=options.mirror,blockClass=options.blockClass,blockSelector=options.blockSelector,unblockSelector=options.unblockSelector,maskAllText=options.maskAllText,maskTextClass=options.maskTextClass,unmaskTextClass=options.unmaskTextClass,maskTextSelector=options.maskTextSelector,unmaskTextSelector=options.unmaskTextSelector,_options$skipChild=options.skipChild,skipChild=_options$skipChild===void 0?false:_options$skipChild,_options$inlineStyles=options.inlineStylesheet,inlineStylesheet=_options$inlineStyles===void 0?true:_options$inlineStyles,_options$maskInputOpt3=options.maskInputOptions,maskInputOptions=_options$maskInputOpt3===void 0?{}:_options$maskInputOpt3,maskAttributeFn=options.maskAttributeFn,maskTextFn=options.maskTextFn,maskInputFn=options.maskInputFn,slimDOMOptions=options.slimDOMOptions,_options$dataURLOptio3=options.dataURLOptions,dataURLOptions=_options$dataURLOptio3===void 0?{}:_options$dataURLOptio3,_options$inlineImages=options.inlineImages,inlineImages=_options$inlineImages===void 0?false:_options$inlineImages,_options$recordCanvas=options.recordCanvas,recordCanvas=_options$recordCanvas===void 0?false:_options$recordCanvas,onSerialize=options.onSerialize,onIframeLoad=options.onIframeLoad,_options$iframeLoadTi=options.iframeLoadTimeout,iframeLoadTimeout=_options$iframeLoadTi===void 0?5000:_options$iframeLoadTi,onStylesheetLoad=options.onStylesheetLoad,_options$stylesheetLo=options.stylesheetLoadTimeout,stylesheetLoadTimeout=_options$stylesheetLo===void 0?5000:_options$stylesheetLo,_options$keepIframeSr=options.keepIframeSrcFn,keepIframeSrcFn=_options$keepIframeSr===void 0?function(){return false;}:_options$keepIframeSr,_options$newlyAddedEl3=options.newlyAddedElement,newlyAddedElement=_options$newlyAddedEl3===void 0?false:_options$newlyAddedEl3;var _options$preserveWhit=options.preserveWhiteSpace,preserveWhiteSpace=_options$preserveWhit===void 0?true:_options$preserveWhit;var _serializedNode=serializeNode(n,{doc:doc,mirror:mirror,blockClass:blockClass,blockSelector:blockSelector,maskAllText:maskAllText,unblockSelector:unblockSelector,maskTextClass:maskTextClass,unmaskTextClass:unmaskTextClass,maskTextSelector:maskTextSelector,unmaskTextSelector:unmaskTextSelector,inlineStylesheet:inlineStylesheet,maskInputOptions:maskInputOptions,maskAttributeFn:maskAttributeFn,maskTextFn:maskTextFn,maskInputFn:maskInputFn,dataURLOptions:dataURLOptions,inlineImages:inlineImages,recordCanvas:recordCanvas,keepIframeSrcFn:keepIframeSrcFn,newlyAddedElement:newlyAddedElement});if(!_serializedNode){console.warn(n,'not serialized');return null;}var id;if(mirror.hasNode(n)){id=mirror.getId(n);}else if(slimDOMExcluded(_serializedNode,slimDOMOptions)||!preserveWhiteSpace&&_serializedNode.type===NodeType$1.Text&&!_serializedNode.isStyle&&!_serializedNode.textContent.replace(/^\s+|\s+$/gm,'').length){id=IGNORED_NODE;}else{id=genId();}var serializedNode=Object.assign(_serializedNode,{id:id});mirror.add(n,serializedNode);if(id===IGNORED_NODE){return null;}if(onSerialize){onSerialize(n);}var recordChild=!skipChild;if(serializedNode.type===NodeType$1.Element){recordChild=recordChild&&!serializedNode.needBlock;delete serializedNode.needBlock;var shadowRoot=n.shadowRoot;if(shadowRoot&&isNativeShadowDom(shadowRoot))serializedNode.isShadowHost=true;}if((serializedNode.type===NodeType$1.Document||serializedNode.type===NodeType$1.Element)&&recordChild){if(slimDOMOptions.headWhitespace&&serializedNode.type===NodeType$1.Element&&serializedNode.tagName==='head'){preserveWhiteSpace=false;}var bypassOptions={doc:doc,mirror:mirror,blockClass:blockClass,blockSelector:blockSelector,maskAllText:maskAllText,unblockSelector:unblockSelector,maskTextClass:maskTextClass,unmaskTextClass:unmaskTextClass,maskTextSelector:maskTextSelector,unmaskTextSelector:unmaskTextSelector,skipChild:skipChild,inlineStylesheet:inlineStylesheet,maskInputOptions:maskInputOptions,maskAttributeFn:maskAttributeFn,maskTextFn:maskTextFn,maskInputFn:maskInputFn,slimDOMOptions:slimDOMOptions,dataURLOptions:dataURLOptions,inlineImages:inlineImages,recordCanvas:recordCanvas,preserveWhiteSpace:preserveWhiteSpace,onSerialize:onSerialize,onIframeLoad:onIframeLoad,iframeLoadTimeout:iframeLoadTimeout,onStylesheetLoad:onStylesheetLoad,stylesheetLoadTimeout:stylesheetLoadTimeout,keepIframeSrcFn:keepIframeSrcFn};for(var _i=0,_Array$from=Array.from(n.childNodes);_i<_Array$from.length;_i++){var _childN=_Array$from[_i];var _serializedChildNode=serializeNodeWithId(_childN,bypassOptions);if(_serializedChildNode){serializedNode.childNodes.push(_serializedChildNode);}}if(isElement$1(n)&&n.shadowRoot){for(var _i2=0,_Array$from2=Array.from(n.shadowRoot.childNodes);_i2<_Array$from2.length;_i2++){var childN=_Array$from2[_i2];var serializedChildNode=serializeNodeWithId(childN,bypassOptions);if(serializedChildNode){isNativeShadowDom(n.shadowRoot)&&(serializedChildNode.isShadow=true);serializedNode.childNodes.push(serializedChildNode);}}}}if(n.parentNode&&isShadowRoot(n.parentNode)&&isNativeShadowDom(n.parentNode)){serializedNode.isShadow=true;}if(serializedNode.type===NodeType$1.Element&&serializedNode.tagName==='iframe'){onceIframeLoaded(n,function(){var iframeDoc=n.contentDocument;if(iframeDoc&&onIframeLoad){var serializedIframeNode=serializeNodeWithId(iframeDoc,{doc:iframeDoc,mirror:mirror,blockClass:blockClass,blockSelector:blockSelector,unblockSelector:unblockSelector,maskAllText:maskAllText,maskTextClass:maskTextClass,unmaskTextClass:unmaskTextClass,maskTextSelector:maskTextSelector,unmaskTextSelector:unmaskTextSelector,skipChild:false,inlineStylesheet:inlineStylesheet,maskInputOptions:maskInputOptions,maskAttributeFn:maskAttributeFn,maskTextFn:maskTextFn,maskInputFn:maskInputFn,slimDOMOptions:slimDOMOptions,dataURLOptions:dataURLOptions,inlineImages:inlineImages,recordCanvas:recordCanvas,preserveWhiteSpace:preserveWhiteSpace,onSerialize:onSerialize,onIframeLoad:onIframeLoad,iframeLoadTimeout:iframeLoadTimeout,onStylesheetLoad:onStylesheetLoad,stylesheetLoadTimeout:stylesheetLoadTimeout,keepIframeSrcFn:keepIframeSrcFn});if(serializedIframeNode){onIframeLoad(n,serializedIframeNode);}}},iframeLoadTimeout);}if(serializedNode.type===NodeType$1.Element&&serializedNode.tagName==='link'&&serializedNode.attributes.rel==='stylesheet'){onceStylesheetLoaded(n,function(){if(onStylesheetLoad){var serializedLinkNode=serializeNodeWithId(n,{doc:doc,mirror:mirror,blockClass:blockClass,blockSelector:blockSelector,unblockSelector:unblockSelector,maskAllText:maskAllText,maskTextClass:maskTextClass,unmaskTextClass:unmaskTextClass,maskTextSelector:maskTextSelector,unmaskTextSelector:unmaskTextSelector,skipChild:false,inlineStylesheet:inlineStylesheet,maskInputOptions:maskInputOptions,maskAttributeFn:maskAttributeFn,maskTextFn:maskTextFn,maskInputFn:maskInputFn,slimDOMOptions:slimDOMOptions,dataURLOptions:dataURLOptions,inlineImages:inlineImages,recordCanvas:recordCanvas,preserveWhiteSpace:preserveWhiteSpace,onSerialize:onSerialize,onIframeLoad:onIframeLoad,iframeLoadTimeout:iframeLoadTimeout,onStylesheetLoad:onStylesheetLoad,stylesheetLoadTimeout:stylesheetLoadTimeout,keepIframeSrcFn:keepIframeSrcFn});if(serializedLinkNode){onStylesheetLoad(n,serializedLinkNode);}}},stylesheetLoadTimeout);}return serializedNode;}function snapshot(n,options){var _ref3=options||{},_ref3$mirror=_ref3.mirror,mirror=_ref3$mirror===void 0?new Mirror():_ref3$mirror,_ref3$blockClass=_ref3.blockClass,blockClass=_ref3$blockClass===void 0?'rr-block':_ref3$blockClass,_ref3$blockSelector=_ref3.blockSelector,blockSelector=_ref3$blockSelector===void 0?null:_ref3$blockSelector,_ref3$unblockSelector=_ref3.unblockSelector,unblockSelector=_ref3$unblockSelector===void 0?null:_ref3$unblockSelector,_ref3$maskAllText=_ref3.maskAllText,maskAllText=_ref3$maskAllText===void 0?false:_ref3$maskAllText,_ref3$maskTextClass=_ref3.maskTextClass,maskTextClass=_ref3$maskTextClass===void 0?'rr-mask':_ref3$maskTextClass,_ref3$unmaskTextClass=_ref3.unmaskTextClass,unmaskTextClass=_ref3$unmaskTextClass===void 0?null:_ref3$unmaskTextClass,_ref3$maskTextSelecto=_ref3.maskTextSelector,maskTextSelector=_ref3$maskTextSelecto===void 0?null:_ref3$maskTextSelecto,_ref3$unmaskTextSelec=_ref3.unmaskTextSelector,unmaskTextSelector=_ref3$unmaskTextSelec===void 0?null:_ref3$unmaskTextSelec,_ref3$inlineStyleshee=_ref3.inlineStylesheet,inlineStylesheet=_ref3$inlineStyleshee===void 0?true:_ref3$inlineStyleshee,_ref3$inlineImages=_ref3.inlineImages,inlineImages=_ref3$inlineImages===void 0?false:_ref3$inlineImages,_ref3$recordCanvas=_ref3.recordCanvas,recordCanvas=_ref3$recordCanvas===void 0?false:_ref3$recordCanvas,_ref3$maskAllInputs=_ref3.maskAllInputs,maskAllInputs=_ref3$maskAllInputs===void 0?false:_ref3$maskAllInputs,maskAttributeFn=_ref3.maskAttributeFn,maskTextFn=_ref3.maskTextFn,maskInputFn=_ref3.maskInputFn,_ref3$slimDOM=_ref3.slimDOM,slimDOM=_ref3$slimDOM===void 0?false:_ref3$slimDOM,dataURLOptions=_ref3.dataURLOptions,preserveWhiteSpace=_ref3.preserveWhiteSpace,onSerialize=_ref3.onSerialize,onIframeLoad=_ref3.onIframeLoad,iframeLoadTimeout=_ref3.iframeLoadTimeout,onStylesheetLoad=_ref3.onStylesheetLoad,stylesheetLoadTimeout=_ref3.stylesheetLoadTimeout,_ref3$keepIframeSrcFn=_ref3.keepIframeSrcFn,keepIframeSrcFn=_ref3$keepIframeSrcFn===void 0?function(){return false;}:_ref3$keepIframeSrcFn;var maskInputOptions=maskAllInputs===true?{color:true,date:true,'datetime-local':true,email:true,month:true,number:true,range:true,search:true,tel:true,text:true,time:true,url:true,week:true,textarea:true,select:true}:maskAllInputs===false?{}:maskAllInputs;var slimDOMOptions=slimDOM===true||slimDOM==='all'?{script:true,comment:true,headFavicon:true,headWhitespace:true,headMetaDescKeywords:slimDOM==='all',headMetaSocial:true,headMetaRobots:true,headMetaHttpEquiv:true,headMetaAuthorship:true,headMetaVerification:true}:slimDOM===false?{}:slimDOM;return serializeNodeWithId(n,{doc:n,mirror:mirror,blockClass:blockClass,blockSelector:blockSelector,unblockSelector:unblockSelector,maskAllText:maskAllText,maskTextClass:maskTextClass,unmaskTextClass:unmaskTextClass,maskTextSelector:maskTextSelector,unmaskTextSelector:unmaskTextSelector,skipChild:false,inlineStylesheet:inlineStylesheet,maskInputOptions:maskInputOptions,maskAttributeFn:maskAttributeFn,maskTextFn:maskTextFn,maskInputFn:maskInputFn,slimDOMOptions:slimDOMOptions,dataURLOptions:dataURLOptions,inlineImages:inlineImages,recordCanvas:recordCanvas,preserveWhiteSpace:preserveWhiteSpace,onSerialize:onSerialize,onIframeLoad:onIframeLoad,iframeLoadTimeout:iframeLoadTimeout,onStylesheetLoad:onStylesheetLoad,stylesheetLoadTimeout:stylesheetLoadTimeout,keepIframeSrcFn:keepIframeSrcFn,newlyAddedElement:false});}function _optionalChain$4(ops){var lastAccessLHS=undefined;var value=ops[0];var i=1;while(i<ops.length){var op=ops[i];var fn=ops[i+1];i+=2;if((op==='optionalAccess'||op==='optionalCall')&&value==null){return undefined;}if(op==='access'||op==='optionalAccess'){lastAccessLHS=value;value=fn(value);}else if(op==='call'||op==='optionalCall'){value=fn(function(){var _value3;for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return(_value3=value).call.apply(_value3,[lastAccessLHS].concat(args));});lastAccessLHS=undefined;}}return value;}function on(type,fn){var target=arguments.length>2&&arguments[2]!==undefined?arguments[2]:document;var options={capture:true,passive:true};target.addEventListener(type,fn,options);return function(){return target.removeEventListener(type,fn,options);};}var DEPARTED_MIRROR_ACCESS_WARNING='Please stop import mirror directly. Instead of that,'+'\r\n'+'now you can use replayer.getMirror() to access the mirror instance of a replayer,'+'\r\n'+'or you can use record.mirror to access the mirror instance during recording.';var _mirror={map:{},getId:function getId(){console.error(DEPARTED_MIRROR_ACCESS_WARNING);return-1;},getNode:function getNode(){console.error(DEPARTED_MIRROR_ACCESS_WARNING);return null;},removeNodeFromMap:function removeNodeFromMap(){console.error(DEPARTED_MIRROR_ACCESS_WARNING);},has:function has(){console.error(DEPARTED_MIRROR_ACCESS_WARNING);return false;},reset:function reset(){console.error(DEPARTED_MIRROR_ACCESS_WARNING);}};if(typeof window!=='undefined'&&window.Proxy&&window.Reflect){_mirror=new Proxy(_mirror,{get:function get(target,prop,receiver){if(prop==='map'){console.error(DEPARTED_MIRROR_ACCESS_WARNING);}return Reflect.get(target,prop,receiver);}});}function throttle$1(func,wait){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var timeout=null;var previous=0;return function(){for(var _len3=arguments.length,args=new Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}var now=Date.now();if(!previous&&options.leading===false){previous=now;}var remaining=wait-(now-previous);var context=this;if(remaining<=0||remaining>wait){if(timeout){clearTimeout$1(timeout);timeout=null;}previous=now;func.apply(context,args);}else if(!timeout&&options.trailing!==false){timeout=setTimeout$1(function(){previous=options.leading===false?0:Date.now();timeout=null;func.apply(context,args);},remaining);}};}function hookSetter(target,key,d,isRevoked){var win=arguments.length>4&&arguments[4]!==undefined?arguments[4]:window;var original=win.Object.getOwnPropertyDescriptor(target,key);win.Object.defineProperty(target,key,isRevoked?d:{set:function set(value){var _this2=this;setTimeout$1(function(){d.set.call(_this2,value);},0);if(original&&original.set){original.set.call(this,value);}}});return function(){return hookSetter(target,key,original||{},true);};}function patch(source,name,replacement){try{if(!(name in source)){return function(){};}var original=source[name];var wrapped=replacement(original);if(typeof wrapped==='function'){wrapped.prototype=wrapped.prototype||{};Object.defineProperties(wrapped,{__rrweb_original__:{enumerable:false,value:original}});}source[name]=wrapped;return function(){source[name]=original;};}catch(e2){return function(){};}}var nowTimestamp=Date.now;if(!/[1-9][0-9]{12}/.test(Date.now().toString())){nowTimestamp=function nowTimestamp(){return new Date().getTime();};}function getWindowScroll(win){var doc=win.document;return{left:doc.scrollingElement?doc.scrollingElement.scrollLeft:win.pageXOffset!==undefined?win.pageXOffset:_optionalChain$4([doc,'optionalAccess',function(_){return _.documentElement;},'access',function(_2){return _2.scrollLeft;}])||_optionalChain$4([doc,'optionalAccess',function(_3){return _3.body;},'optionalAccess',function(_4){return _4.parentElement;},'optionalAccess',function(_5){return _5.scrollLeft;}])||_optionalChain$4([doc,'optionalAccess',function(_6){return _6.body;},'optionalAccess',function(_7){return _7.scrollLeft;}])||0,top:doc.scrollingElement?doc.scrollingElement.scrollTop:win.pageYOffset!==undefined?win.pageYOffset:_optionalChain$4([doc,'optionalAccess',function(_8){return _8.documentElement;},'access',function(_9){return _9.scrollTop;}])||_optionalChain$4([doc,'optionalAccess',function(_10){return _10.body;},'optionalAccess',function(_11){return _11.parentElement;},'optionalAccess',function(_12){return _12.scrollTop;}])||_optionalChain$4([doc,'optionalAccess',function(_13){return _13.body;},'optionalAccess',function(_14){return _14.scrollTop;}])||0};}function getWindowHeight(){return window.innerHeight||document.documentElement&&document.documentElement.clientHeight||document.body&&document.body.clientHeight;}function getWindowWidth(){return window.innerWidth||document.documentElement&&document.documentElement.clientWidth||document.body&&document.body.clientWidth;}function closestElementOfNode(node){if(!node){return null;}var el=node.nodeType===node.ELEMENT_NODE?node:node.parentElement;return el;}function isBlocked(node,blockClass,blockSelector,unblockSelector,checkAncestors){if(!node){return false;}var el=closestElementOfNode(node);if(!el){return false;}var blockedPredicate=createMatchPredicate(blockClass,blockSelector);if(!checkAncestors){var isUnblocked=unblockSelector&&el.matches(unblockSelector);return blockedPredicate(el)&&!isUnblocked;}var blockDistance=distanceToMatch(el,blockedPredicate);var unblockDistance=-1;if(blockDistance<0){return false;}if(unblockSelector){unblockDistance=distanceToMatch(el,createMatchPredicate(null,unblockSelector));}if(blockDistance>-1&&unblockDistance<0){return true;}return blockDistance<unblockDistance;}function isSerialized(n,mirror){return mirror.getId(n)!==-1;}function isIgnored(n,mirror){return mirror.getId(n)===IGNORED_NODE;}function isAncestorRemoved(target,mirror){if(isShadowRoot(target)){return false;}var id=mirror.getId(target);if(!mirror.has(id)){return true;}if(target.parentNode&&target.parentNode.nodeType===target.DOCUMENT_NODE){return false;}if(!target.parentNode){return true;}return isAncestorRemoved(target.parentNode,mirror);}function legacy_isTouchEvent(event){return Boolean(event.changedTouches);}function polyfill(){var _this3=this;var win=arguments.length>0&&arguments[0]!==undefined?arguments[0]:window;if('NodeList'in win&&!win.NodeList.prototype.forEach){win.NodeList.prototype.forEach=Array.prototype.forEach;}if('DOMTokenList'in win&&!win.DOMTokenList.prototype.forEach){win.DOMTokenList.prototype.forEach=Array.prototype.forEach;}if(!Node.prototype.contains){Node.prototype.contains=function(){for(var _len4=arguments.length,args=new Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}var node=args[0];if(!(0 in args)){throw new TypeError('1 argument is required');}do{if(_this3===node){return true;}}while(node=node&&node.parentNode);return false;};}}function isSerializedIframe(n,mirror){return Boolean(n.nodeName==='IFRAME'&&mirror.getMeta(n));}function isSerializedStylesheet(n,mirror){return Boolean(n.nodeName==='LINK'&&n.nodeType===n.ELEMENT_NODE&&n.getAttribute&&n.getAttribute('rel')==='stylesheet'&&mirror.getMeta(n));}function hasShadowRoot(n){return Boolean(_optionalChain$4([n,'optionalAccess',function(_18){return _18.shadowRoot;}]));}var StyleSheetMirror=/*#__PURE__*/function(){function StyleSheetMirror(){_classCallCheck(this,StyleSheetMirror);this.id=1;this.styleIDMap=new WeakMap();this.idStyleMap=new Map();}_createClass(StyleSheetMirror,[{key:"getId",value:function getId(stylesheet){return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* _nullishCoalesce */])(this.styleIDMap.get(stylesheet),function(){return-1;});}},{key:"has",value:function has(stylesheet){return this.styleIDMap.has(stylesheet);}},{key:"add",value:function add(stylesheet,id){if(this.has(stylesheet))return this.getId(stylesheet);var newId;if(id===undefined){newId=this.id++;}else newId=id;this.styleIDMap.set(stylesheet,newId);this.idStyleMap.set(newId,stylesheet);return newId;}},{key:"getStyle",value:function getStyle(id){return this.idStyleMap.get(id)||null;}},{key:"reset",value:function reset(){this.styleIDMap=new WeakMap();this.idStyleMap=new Map();this.id=1;}},{key:"generateId",value:function generateId(){return this.id++;}}]);return StyleSheetMirror;}();function getShadowHost(n){var shadowHost=null;if(_optionalChain$4([n,'access',function(_19){return _19.getRootNode;},'optionalCall',function(_20){return _20();},'optionalAccess',function(_21){return _21.nodeType;}])===Node.DOCUMENT_FRAGMENT_NODE&&n.getRootNode().host)shadowHost=n.getRootNode().host;return shadowHost;}function getRootShadowHost(n){var rootShadowHost=n;var shadowHost;while(shadowHost=getShadowHost(rootShadowHost)){rootShadowHost=shadowHost;}return rootShadowHost;}function shadowHostInDom(n){var doc=n.ownerDocument;if(!doc)return false;var shadowHost=getRootShadowHost(n);return doc.contains(shadowHost);}function inDom(n){var doc=n.ownerDocument;if(!doc)return false;return doc.contains(n)||shadowHostInDom(n);}var cachedImplementations={};function getImplementation(name){var cached=cachedImplementations[name];if(cached){return cached;}var document=window.document;var impl=window[name];if(document&&typeof document.createElement==='function'){try{var sandbox=document.createElement('iframe');sandbox.hidden=true;document.head.appendChild(sandbox);var contentWindow=sandbox.contentWindow;if(contentWindow&&contentWindow[name]){impl=contentWindow[name];}document.head.removeChild(sandbox);}catch(e){}}return cachedImplementations[name]=impl.bind(window);}function onRequestAnimationFrame(){return getImplementation('requestAnimationFrame').apply(void 0,arguments);}function setTimeout$1(){return getImplementation('setTimeout').apply(void 0,arguments);}function clearTimeout$1(){return getImplementation('clearTimeout').apply(void 0,arguments);}var EventType=/* @__PURE__ */function(EventType2){EventType2[EventType2["DomContentLoaded"]=0]="DomContentLoaded";EventType2[EventType2["Load"]=1]="Load";EventType2[EventType2["FullSnapshot"]=2]="FullSnapshot";EventType2[EventType2["IncrementalSnapshot"]=3]="IncrementalSnapshot";EventType2[EventType2["Meta"]=4]="Meta";EventType2[EventType2["Custom"]=5]="Custom";EventType2[EventType2["Plugin"]=6]="Plugin";return EventType2;}(EventType||{});var IncrementalSource=/* @__PURE__ */function(IncrementalSource2){IncrementalSource2[IncrementalSource2["Mutation"]=0]="Mutation";IncrementalSource2[IncrementalSource2["MouseMove"]=1]="MouseMove";IncrementalSource2[IncrementalSource2["MouseInteraction"]=2]="MouseInteraction";IncrementalSource2[IncrementalSource2["Scroll"]=3]="Scroll";IncrementalSource2[IncrementalSource2["ViewportResize"]=4]="ViewportResize";IncrementalSource2[IncrementalSource2["Input"]=5]="Input";IncrementalSource2[IncrementalSource2["TouchMove"]=6]="TouchMove";IncrementalSource2[IncrementalSource2["MediaInteraction"]=7]="MediaInteraction";IncrementalSource2[IncrementalSource2["StyleSheetRule"]=8]="StyleSheetRule";IncrementalSource2[IncrementalSource2["CanvasMutation"]=9]="CanvasMutation";IncrementalSource2[IncrementalSource2["Font"]=10]="Font";IncrementalSource2[IncrementalSource2["Log"]=11]="Log";IncrementalSource2[IncrementalSource2["Drag"]=12]="Drag";IncrementalSource2[IncrementalSource2["StyleDeclaration"]=13]="StyleDeclaration";IncrementalSource2[IncrementalSource2["Selection"]=14]="Selection";IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"]=15]="AdoptedStyleSheet";IncrementalSource2[IncrementalSource2["CustomElement"]=16]="CustomElement";return IncrementalSource2;}(IncrementalSource||{});var MouseInteractions=/* @__PURE__ */function(MouseInteractions2){MouseInteractions2[MouseInteractions2["MouseUp"]=0]="MouseUp";MouseInteractions2[MouseInteractions2["MouseDown"]=1]="MouseDown";MouseInteractions2[MouseInteractions2["Click"]=2]="Click";MouseInteractions2[MouseInteractions2["ContextMenu"]=3]="ContextMenu";MouseInteractions2[MouseInteractions2["DblClick"]=4]="DblClick";MouseInteractions2[MouseInteractions2["Focus"]=5]="Focus";MouseInteractions2[MouseInteractions2["Blur"]=6]="Blur";MouseInteractions2[MouseInteractions2["TouchStart"]=7]="TouchStart";MouseInteractions2[MouseInteractions2["TouchMove_Departed"]=8]="TouchMove_Departed";MouseInteractions2[MouseInteractions2["TouchEnd"]=9]="TouchEnd";MouseInteractions2[MouseInteractions2["TouchCancel"]=10]="TouchCancel";return MouseInteractions2;}(MouseInteractions||{});var PointerTypes=/* @__PURE__ */function(PointerTypes2){PointerTypes2[PointerTypes2["Mouse"]=0]="Mouse";PointerTypes2[PointerTypes2["Pen"]=1]="Pen";PointerTypes2[PointerTypes2["Touch"]=2]="Touch";return PointerTypes2;}(PointerTypes||{});function _optionalChain$3(ops){var lastAccessLHS=undefined;var value=ops[0];var i=1;while(i<ops.length){var op=ops[i];var fn=ops[i+1];i+=2;if((op==='optionalAccess'||op==='optionalCall')&&value==null){return undefined;}if(op==='access'||op==='optionalAccess'){lastAccessLHS=value;value=fn(value);}else if(op==='call'||op==='optionalCall'){value=fn(function(){var _value4;for(var _len5=arguments.length,args=new Array(_len5),_key5=0;_key5<_len5;_key5++){args[_key5]=arguments[_key5];}return(_value4=value).call.apply(_value4,[lastAccessLHS].concat(args));});lastAccessLHS=undefined;}}return value;}function isNodeInLinkedList(n){return'__ln'in n;}var DoubleLinkedList=/*#__PURE__*/function(){function DoubleLinkedList(){_classCallCheck(this,DoubleLinkedList);this.length=0;this.head=null;this.tail=null;}_createClass(DoubleLinkedList,[{key:"get",value:function get(position){if(position>=this.length){throw new Error('Position outside of list range');}var current=this.head;for(var index=0;index<position;index++){current=_optionalChain$3([current,'optionalAccess',function(_){return _.next;}])||null;}return current;}},{key:"addNode",value:function addNode(n){var node={value:n,previous:null,next:null};n.__ln=node;if(n.previousSibling&&isNodeInLinkedList(n.previousSibling)){var current=n.previousSibling.__ln.next;node.next=current;node.previous=n.previousSibling.__ln;n.previousSibling.__ln.next=node;if(current){current.previous=node;}}else if(n.nextSibling&&isNodeInLinkedList(n.nextSibling)&&n.nextSibling.__ln.previous){var _current=n.nextSibling.__ln.previous;node.previous=_current;node.next=n.nextSibling.__ln;n.nextSibling.__ln.previous=node;if(_current){_current.next=node;}}else{if(this.head){this.head.previous=node;}node.next=this.head;this.head=node;}if(node.next===null){this.tail=node;}this.length++;}},{key:"removeNode",value:function removeNode(n){var current=n.__ln;if(!this.head){return;}if(!current.previous){this.head=current.next;if(this.head){this.head.previous=null;}else{this.tail=null;}}else{current.previous.next=current.next;if(current.next){current.next.previous=current.previous;}else{this.tail=current.previous;}}if(n.__ln){delete n.__ln;}this.length--;}}]);return DoubleLinkedList;}();var moveKey=function moveKey(id,parentId){return"".concat(id,"@").concat(parentId);};var MutationBuffer=/*#__PURE__*/function(){function MutationBuffer(){var _this4=this;_classCallCheck(this,MutationBuffer);this.frozen=false;this.locked=false;this.texts=[];this.attributes=[];this.attributeMap=new WeakMap();this.removes=[];this.mapRemoves=[];this.movedMap={};this.addedSet=new Set();this.movedSet=new Set();this.droppedSet=new Set();this.processMutations=function(mutations){mutations.forEach(_this4.processMutation);_this4.emit();};this.emit=function(){if(_this4.frozen||_this4.locked){return;}var adds=[];var addedIds=new Set();var addList=new DoubleLinkedList();var getNextId=function getNextId(n){var ns=n;var nextId=IGNORED_NODE;while(nextId===IGNORED_NODE){ns=ns&&ns.nextSibling;nextId=ns&&_this4.mirror.getId(ns);}return nextId;};var pushAdd=function pushAdd(n){if(!n.parentNode||!inDom(n)){return;}var parentId=isShadowRoot(n.parentNode)?_this4.mirror.getId(getShadowHost(n)):_this4.mirror.getId(n.parentNode);var nextId=getNextId(n);if(parentId===-1||nextId===-1){return addList.addNode(n);}var sn=serializeNodeWithId(n,{doc:_this4.doc,mirror:_this4.mirror,blockClass:_this4.blockClass,blockSelector:_this4.blockSelector,maskAllText:_this4.maskAllText,unblockSelector:_this4.unblockSelector,maskTextClass:_this4.maskTextClass,unmaskTextClass:_this4.unmaskTextClass,maskTextSelector:_this4.maskTextSelector,unmaskTextSelector:_this4.unmaskTextSelector,skipChild:true,newlyAddedElement:true,inlineStylesheet:_this4.inlineStylesheet,maskInputOptions:_this4.maskInputOptions,maskAttributeFn:_this4.maskAttributeFn,maskTextFn:_this4.maskTextFn,maskInputFn:_this4.maskInputFn,slimDOMOptions:_this4.slimDOMOptions,dataURLOptions:_this4.dataURLOptions,recordCanvas:_this4.recordCanvas,inlineImages:_this4.inlineImages,onSerialize:function onSerialize(currentN){if(isSerializedIframe(currentN,_this4.mirror)){_this4.iframeManager.addIframe(currentN);}if(isSerializedStylesheet(currentN,_this4.mirror)){_this4.stylesheetManager.trackLinkElement(currentN);}if(hasShadowRoot(n)){_this4.shadowDomManager.addShadowRoot(n.shadowRoot,_this4.doc);}},onIframeLoad:function onIframeLoad(iframe,childSn){_this4.iframeManager.attachIframe(iframe,childSn);_this4.shadowDomManager.observeAttachShadow(iframe);},onStylesheetLoad:function onStylesheetLoad(link,childSn){_this4.stylesheetManager.attachLinkElement(link,childSn);}});if(sn){adds.push({parentId:parentId,nextId:nextId,node:sn});addedIds.add(sn.id);}};while(_this4.mapRemoves.length){_this4.mirror.removeNodeFromMap(_this4.mapRemoves.shift());}var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=_this4.movedSet[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var n=_step2.value;if(isParentRemoved(_this4.removes,n,_this4.mirror)&&!_this4.movedSet.has(n.parentNode)){continue;}pushAdd(n);}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return!=null){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=_this4.addedSet[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var _n=_step3.value;if(!isAncestorInSet(_this4.droppedSet,_n)&&!isParentRemoved(_this4.removes,_n,_this4.mirror)){pushAdd(_n);}else if(isAncestorInSet(_this4.movedSet,_n)){pushAdd(_n);}else{_this4.droppedSet.add(_n);}}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return!=null){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}var candidate=null;while(addList.length){var node=null;if(candidate){var parentId=_this4.mirror.getId(candidate.value.parentNode);var nextId=getNextId(candidate.value);if(parentId!==-1&&nextId!==-1){node=candidate;}}if(!node){var tailNode=addList.tail;while(tailNode){var _node=tailNode;tailNode=tailNode.previous;if(_node){var _parentId=_this4.mirror.getId(_node.value.parentNode);var _nextId=getNextId(_node.value);if(_nextId===-1)continue;else if(_parentId!==-1){node=_node;break;}else{var unhandledNode=_node.value;if(unhandledNode.parentNode&&unhandledNode.parentNode.nodeType===Node.DOCUMENT_FRAGMENT_NODE){var shadowHost=unhandledNode.parentNode.host;var _parentId2=_this4.mirror.getId(shadowHost);if(_parentId2!==-1){node=_node;break;}}}}}}if(!node){while(addList.head){addList.removeNode(addList.head.value);}break;}candidate=node.previous;addList.removeNode(node.value);pushAdd(node.value);}var payload={texts:_this4.texts.map(function(text){return{id:_this4.mirror.getId(text.node),value:text.value};}).filter(function(text){return!addedIds.has(text.id);}).filter(function(text){return _this4.mirror.has(text.id);}),attributes:_this4.attributes.map(function(attribute){var attributes=attribute.attributes;if(typeof attributes.style==='string'){var diffAsStr=JSON.stringify(attribute.styleDiff);var unchangedAsStr=JSON.stringify(attribute._unchangedStyles);if(diffAsStr.length<attributes.style.length){if((diffAsStr+unchangedAsStr).split('var(').length===attributes.style.split('var(').length){attributes.style=attribute.styleDiff;}}}return{id:_this4.mirror.getId(attribute.node),attributes:attributes};}).filter(function(attribute){return!addedIds.has(attribute.id);}).filter(function(attribute){return _this4.mirror.has(attribute.id);}),removes:_this4.removes,adds:adds};if(!payload.texts.length&&!payload.attributes.length&&!payload.removes.length&&!payload.adds.length){return;}_this4.texts=[];_this4.attributes=[];_this4.attributeMap=new WeakMap();_this4.removes=[];_this4.addedSet=new Set();_this4.movedSet=new Set();_this4.droppedSet=new Set();_this4.movedMap={};_this4.mutationCb(payload);};this.processMutation=function(m){if(isIgnored(m.target,_this4.mirror)){return;}switch(m.type){case'characterData':{var value=m.target.textContent;if(!isBlocked(m.target,_this4.blockClass,_this4.blockSelector,_this4.unblockSelector,false)&&value!==m.oldValue){_this4.texts.push({value:needMaskingText(m.target,_this4.maskTextClass,_this4.maskTextSelector,_this4.unmaskTextClass,_this4.unmaskTextSelector,_this4.maskAllText)&&value?_this4.maskTextFn?_this4.maskTextFn(value,closestElementOfNode(m.target)):value.replace(/[\S]/g,'*'):value,node:m.target});}break;}case'attributes':{var target=m.target;var attributeName=m.attributeName;var _value5=m.target.getAttribute(attributeName);if(attributeName==='value'){var type=getInputType(target);var tagName=target.tagName;_value5=getInputValue(target,tagName,type);var isInputMasked=shouldMaskInput({maskInputOptions:_this4.maskInputOptions,tagName:tagName,type:type});var forceMask=needMaskingText(m.target,_this4.maskTextClass,_this4.maskTextSelector,_this4.unmaskTextClass,_this4.unmaskTextSelector,isInputMasked);_value5=maskInputValue({isMasked:forceMask,element:target,value:_value5,maskInputFn:_this4.maskInputFn});}if(isBlocked(m.target,_this4.blockClass,_this4.blockSelector,_this4.unblockSelector,false)||_value5===m.oldValue){return;}var item=_this4.attributeMap.get(m.target);if(target.tagName==='IFRAME'&&attributeName==='src'&&!_this4.keepIframeSrcFn(_value5)){if(!target.contentDocument){attributeName='rr_src';}else{return;}}if(!item){item={node:m.target,attributes:{},styleDiff:{},_unchangedStyles:{}};_this4.attributes.push(item);_this4.attributeMap.set(m.target,item);}if(attributeName==='type'&&target.tagName==='INPUT'&&(m.oldValue||'').toLowerCase()==='password'){target.setAttribute('data-rr-is-password','true');}if(!ignoreAttribute(target.tagName,attributeName)){item.attributes[attributeName]=transformAttribute(_this4.doc,toLowerCase(target.tagName),toLowerCase(attributeName),_value5,target,_this4.maskAttributeFn);if(attributeName==='style'){if(!_this4.unattachedDoc){try{_this4.unattachedDoc=document.implementation.createHTMLDocument();}catch(e){_this4.unattachedDoc=_this4.doc;}}var old=_this4.unattachedDoc.createElement('span');if(m.oldValue){old.setAttribute('style',m.oldValue);}for(var _i3=0,_Array$from3=Array.from(target.style);_i3<_Array$from3.length;_i3++){var pname=_Array$from3[_i3];var newValue=target.style.getPropertyValue(pname);var newPriority=target.style.getPropertyPriority(pname);if(newValue!==old.style.getPropertyValue(pname)||newPriority!==old.style.getPropertyPriority(pname)){if(newPriority===''){item.styleDiff[pname]=newValue;}else{item.styleDiff[pname]=[newValue,newPriority];}}else{item._unchangedStyles[pname]=[newValue,newPriority];}}for(var _i4=0,_Array$from4=Array.from(old.style);_i4<_Array$from4.length;_i4++){var _pname=_Array$from4[_i4];if(target.style.getPropertyValue(_pname)===''){item.styleDiff[_pname]=false;}}}}break;}case'childList':{if(isBlocked(m.target,_this4.blockClass,_this4.blockSelector,_this4.unblockSelector,true)){return;}m.addedNodes.forEach(function(n){return _this4.genAdds(n,m.target);});m.removedNodes.forEach(function(n){var nodeId=_this4.mirror.getId(n);var parentId=isShadowRoot(m.target)?_this4.mirror.getId(m.target.host):_this4.mirror.getId(m.target);if(isBlocked(m.target,_this4.blockClass,_this4.blockSelector,_this4.unblockSelector,false)||isIgnored(n,_this4.mirror)||!isSerialized(n,_this4.mirror)){return;}if(_this4.addedSet.has(n)){deepDelete(_this4.addedSet,n);_this4.droppedSet.add(n);}else if(_this4.addedSet.has(m.target)&&nodeId===-1);else if(isAncestorRemoved(m.target,_this4.mirror));else if(_this4.movedSet.has(n)&&_this4.movedMap[moveKey(nodeId,parentId)]){deepDelete(_this4.movedSet,n);}else{_this4.removes.push({parentId:parentId,id:nodeId,isShadow:isShadowRoot(m.target)&&isNativeShadowDom(m.target)?true:undefined});}_this4.mapRemoves.push(n);});break;}}};this.genAdds=function(n,target){if(_this4.processedNodeManager.inOtherBuffer(n,_this4))return;if(_this4.addedSet.has(n)||_this4.movedSet.has(n))return;if(_this4.mirror.hasNode(n)){if(isIgnored(n,_this4.mirror)){return;}_this4.movedSet.add(n);var targetId=null;if(target&&_this4.mirror.hasNode(target)){targetId=_this4.mirror.getId(target);}if(targetId&&targetId!==-1){_this4.movedMap[moveKey(_this4.mirror.getId(n),targetId)]=true;}}else{_this4.addedSet.add(n);_this4.droppedSet.delete(n);}if(!isBlocked(n,_this4.blockClass,_this4.blockSelector,_this4.unblockSelector,false)){n.childNodes.forEach(function(childN){return _this4.genAdds(childN);});if(hasShadowRoot(n)){n.shadowRoot.childNodes.forEach(function(childN){_this4.processedNodeManager.add(childN,_this4);_this4.genAdds(childN,n);});}}};}_createClass(MutationBuffer,[{key:"init",value:function init(options){var _this5=this;['mutationCb','blockClass','blockSelector','unblockSelector','maskAllText','maskTextClass','unmaskTextClass','maskTextSelector','unmaskTextSelector','inlineStylesheet','maskInputOptions','maskAttributeFn','maskTextFn','maskInputFn','keepIframeSrcFn','recordCanvas','inlineImages','slimDOMOptions','dataURLOptions','doc','mirror','iframeManager','stylesheetManager','shadowDomManager','canvasManager','processedNodeManager'].forEach(function(key){_this5[key]=options[key];});}},{key:"freeze",value:function freeze(){this.frozen=true;this.canvasManager.freeze();}},{key:"unfreeze",value:function unfreeze(){this.frozen=false;this.canvasManager.unfreeze();this.emit();}},{key:"isFrozen",value:function isFrozen(){return this.frozen;}},{key:"lock",value:function lock(){this.locked=true;this.canvasManager.lock();}},{key:"unlock",value:function unlock(){this.locked=false;this.canvasManager.unlock();this.emit();}},{key:"reset",value:function reset(){this.shadowDomManager.reset();this.canvasManager.reset();}}]);return MutationBuffer;}();function deepDelete(addsSet,n){addsSet.delete(n);n.childNodes.forEach(function(childN){return deepDelete(addsSet,childN);});}function isParentRemoved(removes,n,mirror){if(removes.length===0)return false;return _isParentRemoved(removes,n,mirror);}function _isParentRemoved(removes,n,mirror){var parentNode=n.parentNode;if(!parentNode){return false;}var parentId=mirror.getId(parentNode);if(removes.some(function(r){return r.id===parentId;})){return true;}return _isParentRemoved(removes,parentNode,mirror);}function isAncestorInSet(set,n){if(set.size===0)return false;return _isAncestorInSet(set,n);}function _isAncestorInSet(set,n){var parentNode=n.parentNode;if(!parentNode){return false;}if(set.has(parentNode)){return true;}return _isAncestorInSet(set,parentNode);}var errorHandler;function registerErrorHandler(handler){errorHandler=handler;}function unregisterErrorHandler(){errorHandler=undefined;}var callbackWrapper=function callbackWrapper(cb){if(!errorHandler){return cb;}var rrwebWrapped=function rrwebWrapped(){try{return cb.apply(void 0,arguments);}catch(error){if(errorHandler&&errorHandler(error)===true){return function(){};}throw error;}};return rrwebWrapped;};function _optionalChain$2(ops){var lastAccessLHS=undefined;var value=ops[0];var i=1;while(i<ops.length){var op=ops[i];var fn=ops[i+1];i+=2;if((op==='optionalAccess'||op==='optionalCall')&&value==null){return undefined;}if(op==='access'||op==='optionalAccess'){lastAccessLHS=value;value=fn(value);}else if(op==='call'||op==='optionalCall'){value=fn(function(){var _value6;for(var _len6=arguments.length,args=new Array(_len6),_key6=0;_key6<_len6;_key6++){args[_key6]=arguments[_key6];}return(_value6=value).call.apply(_value6,[lastAccessLHS].concat(args));});lastAccessLHS=undefined;}}return value;}var mutationBuffers=[];function getEventTarget(event){try{if('composedPath'in event){var path=event.composedPath();if(path.length){return path[0];}}else if('path'in event&&event.path.length){return event.path[0];}}catch(e2){}return event&&event.target;}function initMutationObserver(options,rootEl){var mutationBuffer=new MutationBuffer();mutationBuffers.push(mutationBuffer);mutationBuffer.init(options);var mutationObserverCtor=window.MutationObserver||window.__rrMutationObserver;var angularZoneSymbol=_optionalChain$2([window,'optionalAccess',function(_){return _.Zone;},'optionalAccess',function(_2){return _2.__symbol__;},'optionalCall',function(_3){return _3('MutationObserver');}]);if(angularZoneSymbol&&window[angularZoneSymbol]){mutationObserverCtor=window[angularZoneSymbol];}var observer=new mutationObserverCtor(callbackWrapper(function(mutations){if(options.onMutation&&options.onMutation(mutations)===false){return;}mutationBuffer.processMutations.bind(mutationBuffer)(mutations);}));observer.observe(rootEl,{attributes:true,attributeOldValue:true,characterData:true,characterDataOldValue:true,childList:true,subtree:true});return observer;}function initMoveObserver(_ref4){var mousemoveCb=_ref4.mousemoveCb,sampling=_ref4.sampling,doc=_ref4.doc,mirror=_ref4.mirror;if(sampling.mousemove===false){return function(){};}var threshold=typeof sampling.mousemove==='number'?sampling.mousemove:50;var callbackThreshold=typeof sampling.mousemoveCallback==='number'?sampling.mousemoveCallback:500;var positions=[];var timeBaseline;var wrappedCb=throttle$1(callbackWrapper(function(source){var totalOffset=Date.now()-timeBaseline;mousemoveCb(positions.map(function(p){p.timeOffset-=totalOffset;return p;}),source);positions=[];timeBaseline=null;}),callbackThreshold);var updatePosition=callbackWrapper(throttle$1(callbackWrapper(function(evt){var target=getEventTarget(evt);var _ref5=legacy_isTouchEvent(evt)?evt.changedTouches[0]:evt,clientX=_ref5.clientX,clientY=_ref5.clientY;if(!timeBaseline){timeBaseline=nowTimestamp();}positions.push({x:clientX,y:clientY,id:mirror.getId(target),timeOffset:nowTimestamp()-timeBaseline});wrappedCb(typeof DragEvent!=='undefined'&&evt instanceof DragEvent?IncrementalSource.Drag:evt instanceof MouseEvent?IncrementalSource.MouseMove:IncrementalSource.TouchMove);}),threshold,{trailing:false}));var handlers=[on('mousemove',updatePosition,doc),on('touchmove',updatePosition,doc),on('drag',updatePosition,doc)];return callbackWrapper(function(){handlers.forEach(function(h){return h();});});}function initMouseInteractionObserver(_ref6){var mouseInteractionCb=_ref6.mouseInteractionCb,doc=_ref6.doc,mirror=_ref6.mirror,blockClass=_ref6.blockClass,blockSelector=_ref6.blockSelector,unblockSelector=_ref6.unblockSelector,sampling=_ref6.sampling;if(sampling.mouseInteraction===false){return function(){};}var disableMap=sampling.mouseInteraction===true||sampling.mouseInteraction===undefined?{}:sampling.mouseInteraction;var handlers=[];var currentPointerType=null;var getHandler=function getHandler(eventKey){return function(event){var target=getEventTarget(event);if(isBlocked(target,blockClass,blockSelector,unblockSelector,true)){return;}var pointerType=null;var thisEventKey=eventKey;if('pointerType'in event){switch(event.pointerType){case'mouse':pointerType=PointerTypes.Mouse;break;case'touch':pointerType=PointerTypes.Touch;break;case'pen':pointerType=PointerTypes.Pen;break;}if(pointerType===PointerTypes.Touch){if(MouseInteractions[eventKey]===MouseInteractions.MouseDown){thisEventKey='TouchStart';}else if(MouseInteractions[eventKey]===MouseInteractions.MouseUp){thisEventKey='TouchEnd';}}else if(pointerType===PointerTypes.Pen);}else if(legacy_isTouchEvent(event)){pointerType=PointerTypes.Touch;}if(pointerType!==null){currentPointerType=pointerType;if(thisEventKey.startsWith('Touch')&&pointerType===PointerTypes.Touch||thisEventKey.startsWith('Mouse')&&pointerType===PointerTypes.Mouse){pointerType=null;}}else if(MouseInteractions[eventKey]===MouseInteractions.Click){pointerType=currentPointerType;currentPointerType=null;}var e=legacy_isTouchEvent(event)?event.changedTouches[0]:event;if(!e){return;}var id=mirror.getId(target);var clientX=e.clientX,clientY=e.clientY;callbackWrapper(mouseInteractionCb)(_objectSpread({type:MouseInteractions[thisEventKey],id:id,x:clientX,y:clientY},pointerType!==null&&{pointerType:pointerType}));};};Object.keys(MouseInteractions).filter(function(key){return Number.isNaN(Number(key))&&!key.endsWith('_Departed')&&disableMap[key]!==false;}).forEach(function(eventKey){var eventName=toLowerCase(eventKey);var handler=getHandler(eventKey);if(window.PointerEvent){switch(MouseInteractions[eventKey]){case MouseInteractions.MouseDown:case MouseInteractions.MouseUp:eventName=eventName.replace('mouse','pointer');break;case MouseInteractions.TouchStart:case MouseInteractions.TouchEnd:return;}}handlers.push(on(eventName,handler,doc));});return callbackWrapper(function(){handlers.forEach(function(h){return h();});});}function initScrollObserver(_ref7){var scrollCb=_ref7.scrollCb,doc=_ref7.doc,mirror=_ref7.mirror,blockClass=_ref7.blockClass,blockSelector=_ref7.blockSelector,unblockSelector=_ref7.unblockSelector,sampling=_ref7.sampling;var updatePosition=callbackWrapper(throttle$1(callbackWrapper(function(evt){var target=getEventTarget(evt);if(!target||isBlocked(target,blockClass,blockSelector,unblockSelector,true)){return;}var id=mirror.getId(target);if(target===doc&&doc.defaultView){var scrollLeftTop=getWindowScroll(doc.defaultView);scrollCb({id:id,x:scrollLeftTop.left,y:scrollLeftTop.top});}else{scrollCb({id:id,x:target.scrollLeft,y:target.scrollTop});}}),sampling.scroll||100));return on('scroll',updatePosition,doc);}function initViewportResizeObserver(_ref8,_ref9){var viewportResizeCb=_ref8.viewportResizeCb;var win=_ref9.win;var lastH=-1;var lastW=-1;var updateDimension=callbackWrapper(throttle$1(callbackWrapper(function(){var height=getWindowHeight();var width=getWindowWidth();if(lastH!==height||lastW!==width){viewportResizeCb({width:Number(width),height:Number(height)});lastH=height;lastW=width;}}),200));return on('resize',updateDimension,win);}var INPUT_TAGS=['INPUT','TEXTAREA','SELECT'];var lastInputValueMap=new WeakMap();function initInputObserver(_ref0){var inputCb=_ref0.inputCb,doc=_ref0.doc,mirror=_ref0.mirror,blockClass=_ref0.blockClass,blockSelector=_ref0.blockSelector,unblockSelector=_ref0.unblockSelector,ignoreClass=_ref0.ignoreClass,ignoreSelector=_ref0.ignoreSelector,maskInputOptions=_ref0.maskInputOptions,maskInputFn=_ref0.maskInputFn,sampling=_ref0.sampling,userTriggeredOnInput=_ref0.userTriggeredOnInput,maskTextClass=_ref0.maskTextClass,unmaskTextClass=_ref0.unmaskTextClass,maskTextSelector=_ref0.maskTextSelector,unmaskTextSelector=_ref0.unmaskTextSelector;function eventHandler(event){var target=getEventTarget(event);var userTriggered=event.isTrusted;var tagName=target&&toUpperCase(target.tagName);if(tagName==='OPTION')target=target.parentElement;if(!target||!tagName||INPUT_TAGS.indexOf(tagName)<0||isBlocked(target,blockClass,blockSelector,unblockSelector,true)){return;}var el=target;if(el.classList.contains(ignoreClass)||ignoreSelector&&el.matches(ignoreSelector)){return;}var type=getInputType(target);var text=getInputValue(el,tagName,type);var isChecked=false;var isInputMasked=shouldMaskInput({maskInputOptions:maskInputOptions,tagName:tagName,type:type});var forceMask=needMaskingText(target,maskTextClass,maskTextSelector,unmaskTextClass,unmaskTextSelector,isInputMasked);if(type==='radio'||type==='checkbox'){isChecked=target.checked;}text=maskInputValue({isMasked:forceMask,element:target,value:text,maskInputFn:maskInputFn});cbWithDedup(target,userTriggeredOnInput?{text:text,isChecked:isChecked,userTriggered:userTriggered}:{text:text,isChecked:isChecked});var name=target.name;if(type==='radio'&&name&&isChecked){doc.querySelectorAll("input[type=\"radio\"][name=\"".concat(name,"\"]")).forEach(function(el){if(el!==target){var _text=maskInputValue({isMasked:forceMask,element:el,value:getInputValue(el,tagName,type),maskInputFn:maskInputFn});cbWithDedup(el,userTriggeredOnInput?{text:_text,isChecked:!isChecked,userTriggered:false}:{text:_text,isChecked:!isChecked});}});}}function cbWithDedup(target,v){var lastInputValue=lastInputValueMap.get(target);if(!lastInputValue||lastInputValue.text!==v.text||lastInputValue.isChecked!==v.isChecked){lastInputValueMap.set(target,v);var id=mirror.getId(target);callbackWrapper(inputCb)(_objectSpread({},v,{id:id}));}}var events=sampling.input==='last'?['change']:['input','change'];var handlers=events.map(function(eventName){return on(eventName,callbackWrapper(eventHandler),doc);});var currentWindow=doc.defaultView;if(!currentWindow){return function(){handlers.forEach(function(h){return h();});};}var propertyDescriptor=currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype,'value');var hookProperties=[[currentWindow.HTMLInputElement.prototype,'value'],[currentWindow.HTMLInputElement.prototype,'checked'],[currentWindow.HTMLSelectElement.prototype,'value'],[currentWindow.HTMLTextAreaElement.prototype,'value'],[currentWindow.HTMLSelectElement.prototype,'selectedIndex'],[currentWindow.HTMLOptionElement.prototype,'selected']];if(propertyDescriptor&&propertyDescriptor.set){handlers.push.apply(handlers,_toConsumableArray(hookProperties.map(function(p){return hookSetter(p[0],p[1],{set:function set(){callbackWrapper(eventHandler)({target:this,isTrusted:false});}},false,currentWindow);})));}return callbackWrapper(function(){handlers.forEach(function(h){return h();});});}function getNestedCSSRulePositions(rule){var positions=[];function recurse(childRule,pos){if(hasNestedCSSRule('CSSGroupingRule')&&childRule.parentRule instanceof CSSGroupingRule||hasNestedCSSRule('CSSMediaRule')&&childRule.parentRule instanceof CSSMediaRule||hasNestedCSSRule('CSSSupportsRule')&&childRule.parentRule instanceof CSSSupportsRule||hasNestedCSSRule('CSSConditionRule')&&childRule.parentRule instanceof CSSConditionRule){var rules=Array.from(childRule.parentRule.cssRules);var index=rules.indexOf(childRule);pos.unshift(index);}else if(childRule.parentStyleSheet){var _rules=Array.from(childRule.parentStyleSheet.cssRules);var _index=_rules.indexOf(childRule);pos.unshift(_index);}return pos;}return recurse(rule,positions);}function getIdAndStyleId(sheet,mirror,styleMirror){var id,styleId;if(!sheet)return{};if(sheet.ownerNode)id=mirror.getId(sheet.ownerNode);else styleId=styleMirror.getId(sheet);return{styleId:styleId,id:id};}function initStyleSheetObserver(_ref1,_ref10){var styleSheetRuleCb=_ref1.styleSheetRuleCb,mirror=_ref1.mirror,stylesheetManager=_ref1.stylesheetManager;var win=_ref10.win;if(!win.CSSStyleSheet||!win.CSSStyleSheet.prototype){return function(){};}var insertRule=win.CSSStyleSheet.prototype.insertRule;win.CSSStyleSheet.prototype.insertRule=new Proxy(insertRule,{apply:callbackWrapper(function(target,thisArg,argumentsList){var _argumentsList=_slicedToArray(argumentsList,2),rule=_argumentsList[0],index=_argumentsList[1];var _getIdAndStyleId=getIdAndStyleId(thisArg,mirror,stylesheetManager.styleMirror),id=_getIdAndStyleId.id,styleId=_getIdAndStyleId.styleId;if(id&&id!==-1||styleId&&styleId!==-1){styleSheetRuleCb({id:id,styleId:styleId,adds:[{rule:rule,index:index}]});}return target.apply(thisArg,argumentsList);})});var deleteRule=win.CSSStyleSheet.prototype.deleteRule;win.CSSStyleSheet.prototype.deleteRule=new Proxy(deleteRule,{apply:callbackWrapper(function(target,thisArg,argumentsList){var _argumentsList2=_slicedToArray(argumentsList,1),index=_argumentsList2[0];var _getIdAndStyleId2=getIdAndStyleId(thisArg,mirror,stylesheetManager.styleMirror),id=_getIdAndStyleId2.id,styleId=_getIdAndStyleId2.styleId;if(id&&id!==-1||styleId&&styleId!==-1){styleSheetRuleCb({id:id,styleId:styleId,removes:[{index:index}]});}return target.apply(thisArg,argumentsList);})});var replace;if(win.CSSStyleSheet.prototype.replace){replace=win.CSSStyleSheet.prototype.replace;win.CSSStyleSheet.prototype.replace=new Proxy(replace,{apply:callbackWrapper(function(target,thisArg,argumentsList){var _argumentsList3=_slicedToArray(argumentsList,1),text=_argumentsList3[0];var _getIdAndStyleId3=getIdAndStyleId(thisArg,mirror,stylesheetManager.styleMirror),id=_getIdAndStyleId3.id,styleId=_getIdAndStyleId3.styleId;if(id&&id!==-1||styleId&&styleId!==-1){styleSheetRuleCb({id:id,styleId:styleId,replace:text});}return target.apply(thisArg,argumentsList);})});}var replaceSync;if(win.CSSStyleSheet.prototype.replaceSync){replaceSync=win.CSSStyleSheet.prototype.replaceSync;win.CSSStyleSheet.prototype.replaceSync=new Proxy(replaceSync,{apply:callbackWrapper(function(target,thisArg,argumentsList){var _argumentsList4=_slicedToArray(argumentsList,1),text=_argumentsList4[0];var _getIdAndStyleId4=getIdAndStyleId(thisArg,mirror,stylesheetManager.styleMirror),id=_getIdAndStyleId4.id,styleId=_getIdAndStyleId4.styleId;if(id&&id!==-1||styleId&&styleId!==-1){styleSheetRuleCb({id:id,styleId:styleId,replaceSync:text});}return target.apply(thisArg,argumentsList);})});}var supportedNestedCSSRuleTypes={};if(canMonkeyPatchNestedCSSRule('CSSGroupingRule')){supportedNestedCSSRuleTypes.CSSGroupingRule=win.CSSGroupingRule;}else{if(canMonkeyPatchNestedCSSRule('CSSMediaRule')){supportedNestedCSSRuleTypes.CSSMediaRule=win.CSSMediaRule;}if(canMonkeyPatchNestedCSSRule('CSSConditionRule')){supportedNestedCSSRuleTypes.CSSConditionRule=win.CSSConditionRule;}if(canMonkeyPatchNestedCSSRule('CSSSupportsRule')){supportedNestedCSSRuleTypes.CSSSupportsRule=win.CSSSupportsRule;}}var unmodifiedFunctions={};Object.entries(supportedNestedCSSRuleTypes).forEach(function(_ref11){var _ref12=_slicedToArray(_ref11,2),typeKey=_ref12[0],type=_ref12[1];unmodifiedFunctions[typeKey]={insertRule:type.prototype.insertRule,deleteRule:type.prototype.deleteRule};type.prototype.insertRule=new Proxy(unmodifiedFunctions[typeKey].insertRule,{apply:callbackWrapper(function(target,thisArg,argumentsList){var _argumentsList5=_slicedToArray(argumentsList,2),rule=_argumentsList5[0],index=_argumentsList5[1];var _getIdAndStyleId5=getIdAndStyleId(thisArg.parentStyleSheet,mirror,stylesheetManager.styleMirror),id=_getIdAndStyleId5.id,styleId=_getIdAndStyleId5.styleId;if(id&&id!==-1||styleId&&styleId!==-1){styleSheetRuleCb({id:id,styleId:styleId,adds:[{rule:rule,index:[].concat(_toConsumableArray(getNestedCSSRulePositions(thisArg)),[index||0])}]});}return target.apply(thisArg,argumentsList);})});type.prototype.deleteRule=new Proxy(unmodifiedFunctions[typeKey].deleteRule,{apply:callbackWrapper(function(target,thisArg,argumentsList){var _argumentsList6=_slicedToArray(argumentsList,1),index=_argumentsList6[0];var _getIdAndStyleId6=getIdAndStyleId(thisArg.parentStyleSheet,mirror,stylesheetManager.styleMirror),id=_getIdAndStyleId6.id,styleId=_getIdAndStyleId6.styleId;if(id&&id!==-1||styleId&&styleId!==-1){styleSheetRuleCb({id:id,styleId:styleId,removes:[{index:[].concat(_toConsumableArray(getNestedCSSRulePositions(thisArg)),[index])}]});}return target.apply(thisArg,argumentsList);})});});return callbackWrapper(function(){win.CSSStyleSheet.prototype.insertRule=insertRule;win.CSSStyleSheet.prototype.deleteRule=deleteRule;replace&&(win.CSSStyleSheet.prototype.replace=replace);replaceSync&&(win.CSSStyleSheet.prototype.replaceSync=replaceSync);Object.entries(supportedNestedCSSRuleTypes).forEach(function(_ref13){var _ref14=_slicedToArray(_ref13,2),typeKey=_ref14[0],type=_ref14[1];type.prototype.insertRule=unmodifiedFunctions[typeKey].insertRule;type.prototype.deleteRule=unmodifiedFunctions[typeKey].deleteRule;});});}function initAdoptedStyleSheetObserver(_ref15,host){var mirror=_ref15.mirror,stylesheetManager=_ref15.stylesheetManager;var hostId=null;if(host.nodeName==='#document')hostId=mirror.getId(host);else hostId=mirror.getId(host.host);var patchTarget=host.nodeName==='#document'?_optionalChain$2([host,'access',function(_4){return _4.defaultView;},'optionalAccess',function(_5){return _5.Document;}]):_optionalChain$2([host,'access',function(_6){return _6.ownerDocument;},'optionalAccess',function(_7){return _7.defaultView;},'optionalAccess',function(_8){return _8.ShadowRoot;}]);var originalPropertyDescriptor=_optionalChain$2([patchTarget,'optionalAccess',function(_9){return _9.prototype;}])?Object.getOwnPropertyDescriptor(_optionalChain$2([patchTarget,'optionalAccess',function(_10){return _10.prototype;}]),'adoptedStyleSheets'):undefined;if(hostId===null||hostId===-1||!patchTarget||!originalPropertyDescriptor)return function(){};Object.defineProperty(host,'adoptedStyleSheets',{configurable:originalPropertyDescriptor.configurable,enumerable:originalPropertyDescriptor.enumerable,get:function get(){var _this6=this;return _optionalChain$2([originalPropertyDescriptor,'access',function(_11){return _11.get;},'optionalAccess',function(_12){return _12.call;},'call',function(_13){return _13(_this6);}]);},set:function set(sheets){var _this7=this;var result=_optionalChain$2([originalPropertyDescriptor,'access',function(_14){return _14.set;},'optionalAccess',function(_15){return _15.call;},'call',function(_16){return _16(_this7,sheets);}]);if(hostId!==null&&hostId!==-1){try{stylesheetManager.adoptStyleSheets(sheets,hostId);}catch(e){}}return result;}});return callbackWrapper(function(){Object.defineProperty(host,'adoptedStyleSheets',{configurable:originalPropertyDescriptor.configurable,enumerable:originalPropertyDescriptor.enumerable,get:originalPropertyDescriptor.get,set:originalPropertyDescriptor.set});});}function initStyleDeclarationObserver(_ref16,_ref17){var styleDeclarationCb=_ref16.styleDeclarationCb,mirror=_ref16.mirror,ignoreCSSAttributes=_ref16.ignoreCSSAttributes,stylesheetManager=_ref16.stylesheetManager;var win=_ref17.win;var setProperty=win.CSSStyleDeclaration.prototype.setProperty;win.CSSStyleDeclaration.prototype.setProperty=new Proxy(setProperty,{apply:callbackWrapper(function(target,thisArg,argumentsList){var _argumentsList7=_slicedToArray(argumentsList,3),property=_argumentsList7[0],value=_argumentsList7[1],priority=_argumentsList7[2];if(ignoreCSSAttributes.has(property)){return setProperty.apply(thisArg,[property,value,priority]);}var _getIdAndStyleId7=getIdAndStyleId(_optionalChain$2([thisArg,'access',function(_17){return _17.parentRule;},'optionalAccess',function(_18){return _18.parentStyleSheet;}]),mirror,stylesheetManager.styleMirror),id=_getIdAndStyleId7.id,styleId=_getIdAndStyleId7.styleId;if(id&&id!==-1||styleId&&styleId!==-1){styleDeclarationCb({id:id,styleId:styleId,set:{property:property,value:value,priority:priority},index:getNestedCSSRulePositions(thisArg.parentRule)});}return target.apply(thisArg,argumentsList);})});var removeProperty=win.CSSStyleDeclaration.prototype.removeProperty;win.CSSStyleDeclaration.prototype.removeProperty=new Proxy(removeProperty,{apply:callbackWrapper(function(target,thisArg,argumentsList){var _argumentsList8=_slicedToArray(argumentsList,1),property=_argumentsList8[0];if(ignoreCSSAttributes.has(property)){return removeProperty.apply(thisArg,[property]);}var _getIdAndStyleId8=getIdAndStyleId(_optionalChain$2([thisArg,'access',function(_19){return _19.parentRule;},'optionalAccess',function(_20){return _20.parentStyleSheet;}]),mirror,stylesheetManager.styleMirror),id=_getIdAndStyleId8.id,styleId=_getIdAndStyleId8.styleId;if(id&&id!==-1||styleId&&styleId!==-1){styleDeclarationCb({id:id,styleId:styleId,remove:{property:property},index:getNestedCSSRulePositions(thisArg.parentRule)});}return target.apply(thisArg,argumentsList);})});return callbackWrapper(function(){win.CSSStyleDeclaration.prototype.setProperty=setProperty;win.CSSStyleDeclaration.prototype.removeProperty=removeProperty;});}function initMediaInteractionObserver(_ref18){var mediaInteractionCb=_ref18.mediaInteractionCb,blockClass=_ref18.blockClass,blockSelector=_ref18.blockSelector,unblockSelector=_ref18.unblockSelector,mirror=_ref18.mirror,sampling=_ref18.sampling,doc=_ref18.doc;var handler=callbackWrapper(function(type){return throttle$1(callbackWrapper(function(event){var target=getEventTarget(event);if(!target||isBlocked(target,blockClass,blockSelector,unblockSelector,true)){return;}var currentTime=target.currentTime,volume=target.volume,muted=target.muted,playbackRate=target.playbackRate;mediaInteractionCb({type:type,id:mirror.getId(target),currentTime:currentTime,volume:volume,muted:muted,playbackRate:playbackRate});}),sampling.media||500);});var handlers=[on('play',handler(0),doc),on('pause',handler(1),doc),on('seeked',handler(2),doc),on('volumechange',handler(3),doc),on('ratechange',handler(4),doc)];return callbackWrapper(function(){handlers.forEach(function(h){return h();});});}function initFontObserver(_ref19){var fontCb=_ref19.fontCb,doc=_ref19.doc;var win=doc.defaultView;if(!win){return function(){};}var handlers=[];var fontMap=new WeakMap();var originalFontFace=win.FontFace;win.FontFace=function FontFace(family,source,descriptors){var fontFace=new originalFontFace(family,source,descriptors);fontMap.set(fontFace,{family:family,buffer:typeof source!=='string',descriptors:descriptors,fontSource:typeof source==='string'?source:JSON.stringify(Array.from(new Uint8Array(source)))});return fontFace;};var restoreHandler=patch(doc.fonts,'add',function(original){return function(fontFace){setTimeout$1(callbackWrapper(function(){var p=fontMap.get(fontFace);if(p){fontCb(p);fontMap.delete(fontFace);}}),0);return original.apply(this,[fontFace]);};});handlers.push(function(){win.FontFace=originalFontFace;});handlers.push(restoreHandler);return callbackWrapper(function(){handlers.forEach(function(h){return h();});});}function initSelectionObserver(param){var doc=param.doc,mirror=param.mirror,blockClass=param.blockClass,blockSelector=param.blockSelector,unblockSelector=param.unblockSelector,selectionCb=param.selectionCb;var collapsed=true;var updateSelection=callbackWrapper(function(){var selection=doc.getSelection();if(!selection||collapsed&&_optionalChain$2([selection,'optionalAccess',function(_21){return _21.isCollapsed;}]))return;collapsed=selection.isCollapsed||false;var ranges=[];var count=selection.rangeCount||0;for(var i=0;i<count;i++){var range=selection.getRangeAt(i);var startContainer=range.startContainer,startOffset=range.startOffset,endContainer=range.endContainer,endOffset=range.endOffset;var blocked=isBlocked(startContainer,blockClass,blockSelector,unblockSelector,true)||isBlocked(endContainer,blockClass,blockSelector,unblockSelector,true);if(blocked)continue;ranges.push({start:mirror.getId(startContainer),startOffset:startOffset,end:mirror.getId(endContainer),endOffset:endOffset});}selectionCb({ranges:ranges});});updateSelection();return on('selectionchange',updateSelection);}function initCustomElementObserver(_ref20){var doc=_ref20.doc,customElementCb=_ref20.customElementCb;var win=doc.defaultView;if(!win||!win.customElements)return function(){};var restoreHandler=patch(win.customElements,'define',function(original){return function(name,constructor,options){try{customElementCb({define:{name:name}});}catch(e){}return original.apply(this,[name,constructor,options]);};});return restoreHandler;}function initObservers(o){var _hooks=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var currentWindow=o.doc.defaultView;if(!currentWindow){return function(){};}var mutationObserver=initMutationObserver(o,o.doc);var mousemoveHandler=initMoveObserver(o);var mouseInteractionHandler=initMouseInteractionObserver(o);var scrollHandler=initScrollObserver(o);var viewportResizeHandler=initViewportResizeObserver(o,{win:currentWindow});var inputHandler=initInputObserver(o);var mediaInteractionHandler=initMediaInteractionObserver(o);var styleSheetObserver=initStyleSheetObserver(o,{win:currentWindow});var adoptedStyleSheetObserver=initAdoptedStyleSheetObserver(o,o.doc);var styleDeclarationObserver=initStyleDeclarationObserver(o,{win:currentWindow});var fontObserver=o.collectFonts?initFontObserver(o):function(){};var selectionObserver=initSelectionObserver(o);var customElementObserver=initCustomElementObserver(o);var pluginHandlers=[];var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=o.plugins[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var plugin=_step4.value;pluginHandlers.push(plugin.observer(plugin.callback,currentWindow,plugin.options));}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return!=null){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}return callbackWrapper(function(){mutationBuffers.forEach(function(b){return b.reset();});mutationObserver.disconnect();mousemoveHandler();mouseInteractionHandler();scrollHandler();viewportResizeHandler();inputHandler();mediaInteractionHandler();styleSheetObserver();adoptedStyleSheetObserver();styleDeclarationObserver();fontObserver();selectionObserver();customElementObserver();pluginHandlers.forEach(function(h){return h();});});}function hasNestedCSSRule(prop){return typeof window[prop]!=='undefined';}function canMonkeyPatchNestedCSSRule(prop){return Boolean(typeof window[prop]!=='undefined'&&window[prop].prototype&&'insertRule'in window[prop].prototype&&'deleteRule'in window[prop].prototype);}var CrossOriginIframeMirror=/*#__PURE__*/function(){function CrossOriginIframeMirror(generateIdFn){_classCallCheck(this,CrossOriginIframeMirror);this.generateIdFn=generateIdFn;this.iframeIdToRemoteIdMap=new WeakMap();this.iframeRemoteIdToIdMap=new WeakMap();}_createClass(CrossOriginIframeMirror,[{key:"getId",value:function getId(iframe,remoteId,idToRemoteMap,remoteToIdMap){var idToRemoteIdMap=idToRemoteMap||this.getIdToRemoteIdMap(iframe);var remoteIdToIdMap=remoteToIdMap||this.getRemoteIdToIdMap(iframe);var id=idToRemoteIdMap.get(remoteId);if(!id){id=this.generateIdFn();idToRemoteIdMap.set(remoteId,id);remoteIdToIdMap.set(id,remoteId);}return id;}},{key:"getIds",value:function getIds(iframe,remoteId){var _this8=this;var idToRemoteIdMap=this.getIdToRemoteIdMap(iframe);var remoteIdToIdMap=this.getRemoteIdToIdMap(iframe);return remoteId.map(function(id){return _this8.getId(iframe,id,idToRemoteIdMap,remoteIdToIdMap);});}},{key:"getRemoteId",value:function getRemoteId(iframe,id,map){var remoteIdToIdMap=map||this.getRemoteIdToIdMap(iframe);if(typeof id!=='number')return id;var remoteId=remoteIdToIdMap.get(id);if(!remoteId)return-1;return remoteId;}},{key:"getRemoteIds",value:function getRemoteIds(iframe,ids){var _this9=this;var remoteIdToIdMap=this.getRemoteIdToIdMap(iframe);return ids.map(function(id){return _this9.getRemoteId(iframe,id,remoteIdToIdMap);});}},{key:"reset",value:function reset(iframe){if(!iframe){this.iframeIdToRemoteIdMap=new WeakMap();this.iframeRemoteIdToIdMap=new WeakMap();return;}this.iframeIdToRemoteIdMap.delete(iframe);this.iframeRemoteIdToIdMap.delete(iframe);}},{key:"getIdToRemoteIdMap",value:function getIdToRemoteIdMap(iframe){var idToRemoteIdMap=this.iframeIdToRemoteIdMap.get(iframe);if(!idToRemoteIdMap){idToRemoteIdMap=new Map();this.iframeIdToRemoteIdMap.set(iframe,idToRemoteIdMap);}return idToRemoteIdMap;}},{key:"getRemoteIdToIdMap",value:function getRemoteIdToIdMap(iframe){var remoteIdToIdMap=this.iframeRemoteIdToIdMap.get(iframe);if(!remoteIdToIdMap){remoteIdToIdMap=new Map();this.iframeRemoteIdToIdMap.set(iframe,remoteIdToIdMap);}return remoteIdToIdMap;}}]);return CrossOriginIframeMirror;}();function _optionalChain$1(ops){var lastAccessLHS=undefined;var value=ops[0];var i=1;while(i<ops.length){var op=ops[i];var fn=ops[i+1];i+=2;if((op==='optionalAccess'||op==='optionalCall')&&value==null){return undefined;}if(op==='access'||op==='optionalAccess'){lastAccessLHS=value;value=fn(value);}else if(op==='call'||op==='optionalCall'){value=fn(function(){var _value7;for(var _len7=arguments.length,args=new Array(_len7),_key7=0;_key7<_len7;_key7++){args[_key7]=arguments[_key7];}return(_value7=value).call.apply(_value7,[lastAccessLHS].concat(args));});lastAccessLHS=undefined;}}return value;}var IframeManagerNoop=/*#__PURE__*/function(){function IframeManagerNoop(){_classCallCheck(this,IframeManagerNoop);this.crossOriginIframeMirror=new CrossOriginIframeMirror(genId);this.crossOriginIframeRootIdMap=new WeakMap();}_createClass(IframeManagerNoop,[{key:"addIframe",value:function addIframe(){}},{key:"addLoadListener",value:function addLoadListener(){}},{key:"attachIframe",value:function attachIframe(){}}]);return IframeManagerNoop;}();var IframeManager=/*#__PURE__*/function(){function IframeManager(options){_classCallCheck(this,IframeManager);this.iframes=new WeakMap();this.crossOriginIframeMap=new WeakMap();this.crossOriginIframeMirror=new CrossOriginIframeMirror(genId);this.crossOriginIframeRootIdMap=new WeakMap();this.mutationCb=options.mutationCb;this.wrappedEmit=options.wrappedEmit;this.stylesheetManager=options.stylesheetManager;this.recordCrossOriginIframes=options.recordCrossOriginIframes;this.crossOriginIframeStyleMirror=new CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));this.mirror=options.mirror;if(this.recordCrossOriginIframes){window.addEventListener('message',this.handleMessage.bind(this));}}_createClass(IframeManager,[{key:"addIframe",value:function addIframe(iframeEl){this.iframes.set(iframeEl,true);if(iframeEl.contentWindow)this.crossOriginIframeMap.set(iframeEl.contentWindow,iframeEl);}},{key:"addLoadListener",value:function addLoadListener(cb){this.loadListener=cb;}},{key:"attachIframe",value:function attachIframe(iframeEl,childSn){this.mutationCb({adds:[{parentId:this.mirror.getId(iframeEl),nextId:null,node:childSn}],removes:[],texts:[],attributes:[],isAttachIframe:true});_optionalChain$1([this,'access',function(_){return _.loadListener;},'optionalCall',function(_2){return _2(iframeEl);}]);if(iframeEl.contentDocument&&iframeEl.contentDocument.adoptedStyleSheets&&iframeEl.contentDocument.adoptedStyleSheets.length>0)this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets,this.mirror.getId(iframeEl.contentDocument));}},{key:"handleMessage",value:function handleMessage(message){var crossOriginMessageEvent=message;if(crossOriginMessageEvent.data.type!=='rrweb'||crossOriginMessageEvent.origin!==crossOriginMessageEvent.data.origin)return;var iframeSourceWindow=message.source;if(!iframeSourceWindow)return;var iframeEl=this.crossOriginIframeMap.get(message.source);if(!iframeEl)return;var transformedEvent=this.transformCrossOriginEvent(iframeEl,crossOriginMessageEvent.data.event);if(transformedEvent)this.wrappedEmit(transformedEvent,crossOriginMessageEvent.data.isCheckout);}},{key:"transformCrossOriginEvent",value:function transformCrossOriginEvent(iframeEl,e){var _this0=this;switch(e.type){case EventType.FullSnapshot:{this.crossOriginIframeMirror.reset(iframeEl);this.crossOriginIframeStyleMirror.reset(iframeEl);this.replaceIdOnNode(e.data.node,iframeEl);var rootId=e.data.node.id;this.crossOriginIframeRootIdMap.set(iframeEl,rootId);this.patchRootIdOnNode(e.data.node,rootId);return{timestamp:e.timestamp,type:EventType.IncrementalSnapshot,data:{source:IncrementalSource.Mutation,adds:[{parentId:this.mirror.getId(iframeEl),nextId:null,node:e.data.node}],removes:[],texts:[],attributes:[],isAttachIframe:true}};}case EventType.Meta:case EventType.Load:case EventType.DomContentLoaded:{return false;}case EventType.Plugin:{return e;}case EventType.Custom:{this.replaceIds(e.data.payload,iframeEl,['id','parentId','previousId','nextId']);return e;}case EventType.IncrementalSnapshot:{switch(e.data.source){case IncrementalSource.Mutation:{e.data.adds.forEach(function(n){_this0.replaceIds(n,iframeEl,['parentId','nextId','previousId']);_this0.replaceIdOnNode(n.node,iframeEl);var rootId=_this0.crossOriginIframeRootIdMap.get(iframeEl);rootId&&_this0.patchRootIdOnNode(n.node,rootId);});e.data.removes.forEach(function(n){_this0.replaceIds(n,iframeEl,['parentId','id']);});e.data.attributes.forEach(function(n){_this0.replaceIds(n,iframeEl,['id']);});e.data.texts.forEach(function(n){_this0.replaceIds(n,iframeEl,['id']);});return e;}case IncrementalSource.Drag:case IncrementalSource.TouchMove:case IncrementalSource.MouseMove:{e.data.positions.forEach(function(p){_this0.replaceIds(p,iframeEl,['id']);});return e;}case IncrementalSource.ViewportResize:{return false;}case IncrementalSource.MediaInteraction:case IncrementalSource.MouseInteraction:case IncrementalSource.Scroll:case IncrementalSource.CanvasMutation:case IncrementalSource.Input:{this.replaceIds(e.data,iframeEl,['id']);return e;}case IncrementalSource.StyleSheetRule:case IncrementalSource.StyleDeclaration:{this.replaceIds(e.data,iframeEl,['id']);this.replaceStyleIds(e.data,iframeEl,['styleId']);return e;}case IncrementalSource.Font:{return e;}case IncrementalSource.Selection:{e.data.ranges.forEach(function(range){_this0.replaceIds(range,iframeEl,['start','end']);});return e;}case IncrementalSource.AdoptedStyleSheet:{this.replaceIds(e.data,iframeEl,['id']);this.replaceStyleIds(e.data,iframeEl,['styleIds']);_optionalChain$1([e,'access',function(_3){return _3.data;},'access',function(_4){return _4.styles;},'optionalAccess',function(_5){return _5.forEach;},'call',function(_6){return _6(function(style){_this0.replaceStyleIds(style,iframeEl,['styleId']);});}]);return e;}}}}return false;}},{key:"replace",value:function replace(iframeMirror,obj,iframeEl,keys){var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=keys[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var key=_step5.value;if(!Array.isArray(obj[key])&&typeof obj[key]!=='number')continue;if(Array.isArray(obj[key])){obj[key]=iframeMirror.getIds(iframeEl,obj[key]);}else{obj[key]=iframeMirror.getId(iframeEl,obj[key]);}}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return!=null){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}return obj;}},{key:"replaceIds",value:function replaceIds(obj,iframeEl,keys){return this.replace(this.crossOriginIframeMirror,obj,iframeEl,keys);}},{key:"replaceStyleIds",value:function replaceStyleIds(obj,iframeEl,keys){return this.replace(this.crossOriginIframeStyleMirror,obj,iframeEl,keys);}},{key:"replaceIdOnNode",value:function replaceIdOnNode(node,iframeEl){var _this1=this;this.replaceIds(node,iframeEl,['id','rootId']);if('childNodes'in node){node.childNodes.forEach(function(child){_this1.replaceIdOnNode(child,iframeEl);});}}},{key:"patchRootIdOnNode",value:function patchRootIdOnNode(node,rootId){var _this10=this;if(node.type!==NodeType$1.Document&&!node.rootId)node.rootId=rootId;if('childNodes'in node){node.childNodes.forEach(function(child){_this10.patchRootIdOnNode(child,rootId);});}}}]);return IframeManager;}();var ShadowDomManagerNoop=/*#__PURE__*/function(){function ShadowDomManagerNoop(){_classCallCheck(this,ShadowDomManagerNoop);}_createClass(ShadowDomManagerNoop,[{key:"init",value:function init(){}},{key:"addShadowRoot",value:function addShadowRoot(){}},{key:"observeAttachShadow",value:function observeAttachShadow(){}},{key:"reset",value:function reset(){}}]);return ShadowDomManagerNoop;}();var ShadowDomManager=/*#__PURE__*/function(){function ShadowDomManager(options){_classCallCheck(this,ShadowDomManager);this.shadowDoms=new WeakSet();this.restoreHandlers=[];this.mutationCb=options.mutationCb;this.scrollCb=options.scrollCb;this.bypassOptions=options.bypassOptions;this.mirror=options.mirror;this.init();}_createClass(ShadowDomManager,[{key:"init",value:function init(){this.reset();this.patchAttachShadow(Element,document);}},{key:"addShadowRoot",value:function addShadowRoot(shadowRoot,doc){var _this11=this;if(!isNativeShadowDom(shadowRoot))return;if(this.shadowDoms.has(shadowRoot))return;this.shadowDoms.add(shadowRoot);var observer=initMutationObserver(_objectSpread({},this.bypassOptions,{doc:doc,mutationCb:this.mutationCb,mirror:this.mirror,shadowDomManager:this}),shadowRoot);this.restoreHandlers.push(function(){return observer.disconnect();});this.restoreHandlers.push(initScrollObserver(_objectSpread({},this.bypassOptions,{scrollCb:this.scrollCb,doc:shadowRoot,mirror:this.mirror})));setTimeout$1(function(){if(shadowRoot.adoptedStyleSheets&&shadowRoot.adoptedStyleSheets.length>0)_this11.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets,_this11.mirror.getId(shadowRoot.host));_this11.restoreHandlers.push(initAdoptedStyleSheetObserver({mirror:_this11.mirror,stylesheetManager:_this11.bypassOptions.stylesheetManager},shadowRoot));},0);}},{key:"observeAttachShadow",value:function observeAttachShadow(iframeElement){if(!iframeElement.contentWindow||!iframeElement.contentDocument)return;this.patchAttachShadow(iframeElement.contentWindow.Element,iframeElement.contentDocument);}},{key:"patchAttachShadow",value:function patchAttachShadow(element,doc){var manager=this;this.restoreHandlers.push(patch(element.prototype,'attachShadow',function(original){return function(option){var shadowRoot=original.call(this,option);if(this.shadowRoot&&inDom(this))manager.addShadowRoot(this.shadowRoot,doc);return shadowRoot;};}));}},{key:"reset",value:function reset(){this.restoreHandlers.forEach(function(handler){try{handler();}catch(e){}});this.restoreHandlers=[];this.shadowDoms=new WeakSet();}}]);return ShadowDomManager;}();var CanvasManagerNoop=/*#__PURE__*/function(){function CanvasManagerNoop(){_classCallCheck(this,CanvasManagerNoop);}_createClass(CanvasManagerNoop,[{key:"reset",value:function reset(){}},{key:"freeze",value:function freeze(){}},{key:"unfreeze",value:function unfreeze(){}},{key:"lock",value:function lock(){}},{key:"unlock",value:function unlock(){}},{key:"snapshot",value:function snapshot(){}}]);return CanvasManagerNoop;}();var StylesheetManager=/*#__PURE__*/function(){function StylesheetManager(options){_classCallCheck(this,StylesheetManager);this.trackedLinkElements=new WeakSet();this.styleMirror=new StyleSheetMirror();this.mutationCb=options.mutationCb;this.adoptedStyleSheetCb=options.adoptedStyleSheetCb;}_createClass(StylesheetManager,[{key:"attachLinkElement",value:function attachLinkElement(linkEl,childSn){if('_cssText'in childSn.attributes)this.mutationCb({adds:[],removes:[],texts:[],attributes:[{id:childSn.id,attributes:childSn.attributes}]});this.trackLinkElement(linkEl);}},{key:"trackLinkElement",value:function trackLinkElement(linkEl){if(this.trackedLinkElements.has(linkEl))return;this.trackedLinkElements.add(linkEl);this.trackStylesheetInLinkElement(linkEl);}},{key:"adoptStyleSheets",value:function adoptStyleSheets(sheets,hostId){if(sheets.length===0)return;var adoptedStyleSheetData={id:hostId,styleIds:[]};var styles=[];var _iteratorNormalCompletion6=true;var _didIteratorError6=false;var _iteratorError6=undefined;try{for(var _iterator6=sheets[Symbol.iterator](),_step6;!(_iteratorNormalCompletion6=(_step6=_iterator6.next()).done);_iteratorNormalCompletion6=true){var sheet=_step6.value;var styleId=void 0;if(!this.styleMirror.has(sheet)){styleId=this.styleMirror.add(sheet);styles.push({styleId:styleId,rules:Array.from(sheet.rules||CSSRule,function(r,index){return{rule:stringifyRule(r),index:index};})});}else styleId=this.styleMirror.getId(sheet);adoptedStyleSheetData.styleIds.push(styleId);}}catch(err){_didIteratorError6=true;_iteratorError6=err;}finally{try{if(!_iteratorNormalCompletion6&&_iterator6.return!=null){_iterator6.return();}}finally{if(_didIteratorError6){throw _iteratorError6;}}}if(styles.length>0)adoptedStyleSheetData.styles=styles;this.adoptedStyleSheetCb(adoptedStyleSheetData);}},{key:"reset",value:function reset(){this.styleMirror.reset();this.trackedLinkElements=new WeakSet();}},{key:"trackStylesheetInLinkElement",value:function trackStylesheetInLinkElement(linkEl){}}]);return StylesheetManager;}();var ProcessedNodeManager=/*#__PURE__*/function(){function ProcessedNodeManager(){_classCallCheck(this,ProcessedNodeManager);this.nodeMap=new WeakMap();this.loop=true;this.periodicallyClear();}_createClass(ProcessedNodeManager,[{key:"periodicallyClear",value:function periodicallyClear(){var _this12=this;onRequestAnimationFrame(function(){_this12.clear();if(_this12.loop)_this12.periodicallyClear();});}},{key:"inOtherBuffer",value:function inOtherBuffer(node,thisBuffer){var buffers=this.nodeMap.get(node);return buffers&&Array.from(buffers).some(function(buffer){return buffer!==thisBuffer;});}},{key:"add",value:function add(node,buffer){this.nodeMap.set(node,(this.nodeMap.get(node)||new Set()).add(buffer));}},{key:"clear",value:function clear(){this.nodeMap=new WeakMap();}},{key:"destroy",value:function destroy(){this.loop=false;}}]);return ProcessedNodeManager;}();var wrappedEmit;var _takeFullSnapshot;var mirror=createMirror();function record(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var emit=options.emit,checkoutEveryNms=options.checkoutEveryNms,checkoutEveryNth=options.checkoutEveryNth,_options$blockClass=options.blockClass,blockClass=_options$blockClass===void 0?'rr-block':_options$blockClass,_options$blockSelecto=options.blockSelector,blockSelector=_options$blockSelecto===void 0?null:_options$blockSelecto,_options$unblockSelec=options.unblockSelector,unblockSelector=_options$unblockSelec===void 0?null:_options$unblockSelec,_options$ignoreClass=options.ignoreClass,ignoreClass=_options$ignoreClass===void 0?'rr-ignore':_options$ignoreClass,_options$ignoreSelect=options.ignoreSelector,ignoreSelector=_options$ignoreSelect===void 0?null:_options$ignoreSelect,_options$maskAllText=options.maskAllText,maskAllText=_options$maskAllText===void 0?false:_options$maskAllText,_options$maskTextClas=options.maskTextClass,maskTextClass=_options$maskTextClas===void 0?'rr-mask':_options$maskTextClas,_options$unmaskTextCl=options.unmaskTextClass,unmaskTextClass=_options$unmaskTextCl===void 0?null:_options$unmaskTextCl,_options$maskTextSele=options.maskTextSelector,maskTextSelector=_options$maskTextSele===void 0?null:_options$maskTextSele,_options$unmaskTextSe=options.unmaskTextSelector,unmaskTextSelector=_options$unmaskTextSe===void 0?null:_options$unmaskTextSe,_options$inlineStyles2=options.inlineStylesheet,inlineStylesheet=_options$inlineStyles2===void 0?true:_options$inlineStyles2,maskAllInputs=options.maskAllInputs,_maskInputOptions=options.maskInputOptions,_slimDOMOptions=options.slimDOMOptions,maskAttributeFn=options.maskAttributeFn,maskInputFn=options.maskInputFn,maskTextFn=options.maskTextFn,_options$maxCanvasSiz=options.maxCanvasSize,maxCanvasSize=_options$maxCanvasSiz===void 0?null:_options$maxCanvasSiz,packFn=options.packFn,_options$sampling=options.sampling,sampling=_options$sampling===void 0?{}:_options$sampling,_options$dataURLOptio4=options.dataURLOptions,dataURLOptions=_options$dataURLOptio4===void 0?{}:_options$dataURLOptio4,mousemoveWait=options.mousemoveWait,_options$recordCanvas2=options.recordCanvas,recordCanvas=_options$recordCanvas2===void 0?false:_options$recordCanvas2,_options$recordCrossO=options.recordCrossOriginIframes,recordCrossOriginIframes=_options$recordCrossO===void 0?false:_options$recordCrossO,_options$recordAfter=options.recordAfter,recordAfter=_options$recordAfter===void 0?options.recordAfter==='DOMContentLoaded'?options.recordAfter:'load':_options$recordAfter,_options$userTriggere=options.userTriggeredOnInput,userTriggeredOnInput=_options$userTriggere===void 0?false:_options$userTriggere,_options$collectFonts=options.collectFonts,collectFonts=_options$collectFonts===void 0?false:_options$collectFonts,_options$inlineImages2=options.inlineImages,inlineImages=_options$inlineImages2===void 0?false:_options$inlineImages2,plugins=options.plugins,_options$keepIframeSr2=options.keepIframeSrcFn,keepIframeSrcFn=_options$keepIframeSr2===void 0?function(){return false;}:_options$keepIframeSr2,_options$ignoreCSSAtt=options.ignoreCSSAttributes,ignoreCSSAttributes=_options$ignoreCSSAtt===void 0?new Set([]):_options$ignoreCSSAtt,errorHandler=options.errorHandler,onMutation=options.onMutation,getCanvasManager=options.getCanvasManager;registerErrorHandler(errorHandler);var inEmittingFrame=recordCrossOriginIframes?window.parent===window:true;var passEmitsToParent=false;if(!inEmittingFrame){try{if(window.parent.document){passEmitsToParent=false;}}catch(e){passEmitsToParent=true;}}if(inEmittingFrame&&!emit){throw new Error('emit function is required');}if(mousemoveWait!==undefined&&sampling.mousemove===undefined){sampling.mousemove=mousemoveWait;}mirror.reset();var maskInputOptions=maskAllInputs===true?{color:true,date:true,'datetime-local':true,email:true,month:true,number:true,range:true,search:true,tel:true,text:true,time:true,url:true,week:true,textarea:true,select:true,radio:true,checkbox:true}:_maskInputOptions!==undefined?_maskInputOptions:{};var slimDOMOptions=_slimDOMOptions===true||_slimDOMOptions==='all'?{script:true,comment:true,headFavicon:true,headWhitespace:true,headMetaSocial:true,headMetaRobots:true,headMetaHttpEquiv:true,headMetaVerification:true,headMetaAuthorship:_slimDOMOptions==='all',headMetaDescKeywords:_slimDOMOptions==='all'}:_slimDOMOptions?_slimDOMOptions:{};polyfill();var lastFullSnapshotEvent;var incrementalSnapshotCount=0;var eventProcessor=function eventProcessor(e){var _iteratorNormalCompletion7=true;var _didIteratorError7=false;var _iteratorError7=undefined;try{for(var _iterator7=(plugins||[])[Symbol.iterator](),_step7;!(_iteratorNormalCompletion7=(_step7=_iterator7.next()).done);_iteratorNormalCompletion7=true){var plugin=_step7.value;if(plugin.eventProcessor){e=plugin.eventProcessor(e);}}}catch(err){_didIteratorError7=true;_iteratorError7=err;}finally{try{if(!_iteratorNormalCompletion7&&_iterator7.return!=null){_iterator7.return();}}finally{if(_didIteratorError7){throw _iteratorError7;}}}if(packFn&&!passEmitsToParent){e=packFn(e);}return e;};wrappedEmit=function wrappedEmit(r,isCheckout){var e=r;e.timestamp=nowTimestamp();if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([mutationBuffers,'access',function(_){return _[0];},'optionalAccess',function(_2){return _2.isFrozen;},'call',function(_3){return _3();}])&&e.type!==EventType.FullSnapshot&&!(e.type===EventType.IncrementalSnapshot&&e.data.source===IncrementalSource.Mutation)){mutationBuffers.forEach(function(buf){return buf.unfreeze();});}if(inEmittingFrame){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([emit,'optionalCall',function(_4){return _4(eventProcessor(e),isCheckout);}]);}else if(passEmitsToParent){var message={type:'rrweb',event:eventProcessor(e),origin:window.location.origin,isCheckout:isCheckout};window.parent.postMessage(message,'*');}if(e.type===EventType.FullSnapshot){lastFullSnapshotEvent=e;incrementalSnapshotCount=0;}else if(e.type===EventType.IncrementalSnapshot){if(e.data.source===IncrementalSource.Mutation&&e.data.isAttachIframe){return;}incrementalSnapshotCount++;var exceedCount=checkoutEveryNth&&incrementalSnapshotCount>=checkoutEveryNth;var exceedTime=checkoutEveryNms&&lastFullSnapshotEvent&&e.timestamp-lastFullSnapshotEvent.timestamp>checkoutEveryNms;if(exceedCount||exceedTime){takeFullSnapshot(true);}}};var wrappedMutationEmit=function wrappedMutationEmit(m){wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.Mutation},m)});};var wrappedScrollEmit=function wrappedScrollEmit(p){return wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.Scroll},p)});};var wrappedCanvasMutationEmit=function wrappedCanvasMutationEmit(p){return wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.CanvasMutation},p)});};var wrappedAdoptedStyleSheetEmit=function wrappedAdoptedStyleSheetEmit(a){return wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.AdoptedStyleSheet},a)});};var stylesheetManager=new StylesheetManager({mutationCb:wrappedMutationEmit,adoptedStyleSheetCb:wrappedAdoptedStyleSheetEmit});var iframeManager=typeof __RRWEB_EXCLUDE_IFRAME__==='boolean'&&__RRWEB_EXCLUDE_IFRAME__?new IframeManagerNoop():new IframeManager({mirror:mirror,mutationCb:wrappedMutationEmit,stylesheetManager:stylesheetManager,recordCrossOriginIframes:recordCrossOriginIframes,wrappedEmit:wrappedEmit});var _iteratorNormalCompletion8=true;var _didIteratorError8=false;var _iteratorError8=undefined;try{for(var _iterator8=(plugins||[])[Symbol.iterator](),_step8;!(_iteratorNormalCompletion8=(_step8=_iterator8.next()).done);_iteratorNormalCompletion8=true){var plugin=_step8.value;if(plugin.getMirror)plugin.getMirror({nodeMirror:mirror,crossOriginIframeMirror:iframeManager.crossOriginIframeMirror,crossOriginIframeStyleMirror:iframeManager.crossOriginIframeStyleMirror});}}catch(err){_didIteratorError8=true;_iteratorError8=err;}finally{try{if(!_iteratorNormalCompletion8&&_iterator8.return!=null){_iterator8.return();}}finally{if(_didIteratorError8){throw _iteratorError8;}}}var processedNodeManager=new ProcessedNodeManager();var canvasManager=_getCanvasManager(getCanvasManager,{mirror:mirror,win:window,mutationCb:function mutationCb(p){return wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.CanvasMutation},p)});},recordCanvas:recordCanvas,blockClass:blockClass,blockSelector:blockSelector,unblockSelector:unblockSelector,maxCanvasSize:maxCanvasSize,sampling:sampling['canvas'],dataURLOptions:dataURLOptions,errorHandler:errorHandler});var shadowDomManager=typeof __RRWEB_EXCLUDE_SHADOW_DOM__==='boolean'&&__RRWEB_EXCLUDE_SHADOW_DOM__?new ShadowDomManagerNoop():new ShadowDomManager({mutationCb:wrappedMutationEmit,scrollCb:wrappedScrollEmit,bypassOptions:{onMutation:onMutation,blockClass:blockClass,blockSelector:blockSelector,unblockSelector:unblockSelector,maskAllText:maskAllText,maskTextClass:maskTextClass,unmaskTextClass:unmaskTextClass,maskTextSelector:maskTextSelector,unmaskTextSelector:unmaskTextSelector,inlineStylesheet:inlineStylesheet,maskInputOptions:maskInputOptions,dataURLOptions:dataURLOptions,maskAttributeFn:maskAttributeFn,maskTextFn:maskTextFn,maskInputFn:maskInputFn,recordCanvas:recordCanvas,inlineImages:inlineImages,sampling:sampling,slimDOMOptions:slimDOMOptions,iframeManager:iframeManager,stylesheetManager:stylesheetManager,canvasManager:canvasManager,keepIframeSrcFn:keepIframeSrcFn,processedNodeManager:processedNodeManager},mirror:mirror});var takeFullSnapshot=function takeFullSnapshot(){var isCheckout=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;wrappedEmit({type:EventType.Meta,data:{href:window.location.href,width:getWindowWidth(),height:getWindowHeight()}},isCheckout);stylesheetManager.reset();shadowDomManager.init();mutationBuffers.forEach(function(buf){return buf.lock();});var node=snapshot(document,{mirror:mirror,blockClass:blockClass,blockSelector:blockSelector,unblockSelector:unblockSelector,maskAllText:maskAllText,maskTextClass:maskTextClass,unmaskTextClass:unmaskTextClass,maskTextSelector:maskTextSelector,unmaskTextSelector:unmaskTextSelector,inlineStylesheet:inlineStylesheet,maskAllInputs:maskInputOptions,maskAttributeFn:maskAttributeFn,maskInputFn:maskInputFn,maskTextFn:maskTextFn,slimDOM:slimDOMOptions,dataURLOptions:dataURLOptions,recordCanvas:recordCanvas,inlineImages:inlineImages,onSerialize:function onSerialize(n){if(isSerializedIframe(n,mirror)){iframeManager.addIframe(n);}if(isSerializedStylesheet(n,mirror)){stylesheetManager.trackLinkElement(n);}if(hasShadowRoot(n)){shadowDomManager.addShadowRoot(n.shadowRoot,document);}},onIframeLoad:function onIframeLoad(iframe,childSn){iframeManager.attachIframe(iframe,childSn);shadowDomManager.observeAttachShadow(iframe);},onStylesheetLoad:function onStylesheetLoad(linkEl,childSn){stylesheetManager.attachLinkElement(linkEl,childSn);},keepIframeSrcFn:keepIframeSrcFn});if(!node){return console.warn('Failed to snapshot the document');}wrappedEmit({type:EventType.FullSnapshot,data:{node:node,initialOffset:getWindowScroll(window)}});mutationBuffers.forEach(function(buf){return buf.unlock();});if(document.adoptedStyleSheets&&document.adoptedStyleSheets.length>0)stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets,mirror.getId(document));};_takeFullSnapshot=takeFullSnapshot;try{var _handlers=[];var observe=function observe(doc){return callbackWrapper(initObservers)({onMutation:onMutation,mutationCb:wrappedMutationEmit,mousemoveCb:function mousemoveCb(positions,source){return wrappedEmit({type:EventType.IncrementalSnapshot,data:{source:source,positions:positions}});},mouseInteractionCb:function mouseInteractionCb(d){return wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.MouseInteraction},d)});},scrollCb:wrappedScrollEmit,viewportResizeCb:function viewportResizeCb(d){return wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.ViewportResize},d)});},inputCb:function inputCb(v){return wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.Input},v)});},mediaInteractionCb:function mediaInteractionCb(p){return wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.MediaInteraction},p)});},styleSheetRuleCb:function styleSheetRuleCb(r){return wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.StyleSheetRule},r)});},styleDeclarationCb:function styleDeclarationCb(r){return wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.StyleDeclaration},r)});},canvasMutationCb:wrappedCanvasMutationEmit,fontCb:function fontCb(p){return wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.Font},p)});},selectionCb:function selectionCb(p){wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.Selection},p)});},customElementCb:function customElementCb(c){wrappedEmit({type:EventType.IncrementalSnapshot,data:_objectSpread({source:IncrementalSource.CustomElement},c)});},blockClass:blockClass,ignoreClass:ignoreClass,ignoreSelector:ignoreSelector,maskAllText:maskAllText,maskTextClass:maskTextClass,unmaskTextClass:unmaskTextClass,maskTextSelector:maskTextSelector,unmaskTextSelector:unmaskTextSelector,maskInputOptions:maskInputOptions,inlineStylesheet:inlineStylesheet,sampling:sampling,recordCanvas:recordCanvas,inlineImages:inlineImages,userTriggeredOnInput:userTriggeredOnInput,collectFonts:collectFonts,doc:doc,maskAttributeFn:maskAttributeFn,maskInputFn:maskInputFn,maskTextFn:maskTextFn,keepIframeSrcFn:keepIframeSrcFn,blockSelector:blockSelector,unblockSelector:unblockSelector,slimDOMOptions:slimDOMOptions,dataURLOptions:dataURLOptions,mirror:mirror,iframeManager:iframeManager,stylesheetManager:stylesheetManager,shadowDomManager:shadowDomManager,processedNodeManager:processedNodeManager,canvasManager:canvasManager,ignoreCSSAttributes:ignoreCSSAttributes,plugins:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([plugins,'optionalAccess',function(_5){return _5.filter;},'call',function(_6){return _6(function(p){return p.observer;});},'optionalAccess',function(_7){return _7.map;},'call',function(_8){return _8(function(p){return{observer:p.observer,options:p.options,callback:function callback(payload){return wrappedEmit({type:EventType.Plugin,data:{plugin:p.name,payload:payload}});}};});}])||[]},{});};iframeManager.addLoadListener(function(iframeEl){try{_handlers.push(observe(iframeEl.contentDocument));}catch(error){console.warn(error);}});var init=function init(){takeFullSnapshot();_handlers.push(observe(document));};if(document.readyState==='interactive'||document.readyState==='complete'){init();}else{_handlers.push(on('DOMContentLoaded',function(){wrappedEmit({type:EventType.DomContentLoaded,data:{}});if(recordAfter==='DOMContentLoaded')init();}));_handlers.push(on('load',function(){wrappedEmit({type:EventType.Load,data:{}});if(recordAfter==='load')init();},window));}return function(){_handlers.forEach(function(h){return h();});processedNodeManager.destroy();_takeFullSnapshot=undefined;unregisterErrorHandler();};}catch(error){console.warn(error);}}function takeFullSnapshot(isCheckout){if(!_takeFullSnapshot){throw new Error('please take full snapshot after start recording');}_takeFullSnapshot(isCheckout);}record.mirror=mirror;record.takeFullSnapshot=takeFullSnapshot;function _getCanvasManager(getCanvasManagerFn,options){try{return getCanvasManagerFn?getCanvasManagerFn(options):new CanvasManagerNoop();}catch(e2){console.warn('Unable to initialize CanvasManager');return new CanvasManagerNoop();}}var ReplayEventTypeIncrementalSnapshot=3;var ReplayEventTypeCustom=5;/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */function timestampToMs(timestamp){var isMs=timestamp>9999999999;return isMs?timestamp:timestamp*1000;}/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */function timestampToS(timestamp){var isMs=timestamp>9999999999;return isMs?timestamp/1000:timestamp;}/**
 * Add a breadcrumb event to replay.
 */function addBreadcrumbEvent(replay,breadcrumb){if(breadcrumb.category==='sentry.transaction'){return;}if(['ui.click','ui.input'].includes(breadcrumb.category)){replay.triggerUserActivity();}else{replay.checkAndHandleExpiredSession();}replay.addUpdate(function(){// This should never reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
replay.throttledAddEvent({type:EventType.Custom,// TODO: We were converting from ms to seconds for breadcrumbs, spans,
// but maybe we should just keep them as milliseconds
timestamp:(breadcrumb.timestamp||0)*1000,data:{tag:'breadcrumb',// normalize to max. 10 depth and 1_000 properties per object
payload:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_30" /* normalize */])(breadcrumb,10,1000)}});// Do not flush after console log messages
return breadcrumb.category==='console';});}var INTERACTIVE_SELECTOR='button,a';/** Get the closest interactive parent element, or else return the given element. */function getClosestInteractive(element){var closestInteractive=element.closest(INTERACTIVE_SELECTOR);return closestInteractive||element;}/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */function getClickTargetNode(event){var target=getTargetNode(event);if(!target||!(target instanceof Element)){return target;}return getClosestInteractive(target);}/** Get the event target node. */function getTargetNode(event){if(isEventWithTarget(event)){return event.target;}return event;}function isEventWithTarget(event){return _typeof(event)==='object'&&!!event&&'target'in event;}var handlers;/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */function onWindowOpen(cb){// Ensure to only register this once
if(!handlers){handlers=[];monkeyPatchWindowOpen();}handlers.push(cb);return function(){var pos=handlers?handlers.indexOf(cb):-1;if(pos>-1){handlers.splice(pos,1);}};}function monkeyPatchWindowOpen(){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["U" /* fill */])(WINDOW,'open',function(originalWindowOpen){return function(){if(handlers){try{handlers.forEach(function(handler){return handler();});}catch(e){// ignore errors in here
}}for(var _len8=arguments.length,args=new Array(_len8),_key8=0;_key8<_len8;_key8++){args[_key8]=arguments[_key8];}return originalWindowOpen.apply(WINDOW,args);};});}/** Handle a click. */function handleClick(clickDetector,clickBreadcrumb,node){clickDetector.handleClick(clickBreadcrumb,node);}/** A click detector class that can be used to detect slow or rage clicks on elements. */var ClickDetector=/*#__PURE__*/function(){// protected for testing
function ClickDetector(replay,slowClickConfig){var _addBreadcrumbEvent=arguments.length>2&&arguments[2]!==undefined?arguments[2]:addBreadcrumbEvent;_classCallCheck(this,ClickDetector);this._lastMutation=0;this._lastScroll=0;this._clicks=[];// We want everything in s, but options are in ms
this._timeout=slowClickConfig.timeout/1000;this._threshold=slowClickConfig.threshold/1000;this._scollTimeout=slowClickConfig.scrollTimeout/1000;this._replay=replay;this._ignoreSelector=slowClickConfig.ignoreSelector;this._addBreadcrumbEvent=_addBreadcrumbEvent;}/** Register click detection handlers on mutation or scroll. */_createClass(ClickDetector,[{key:"addListeners",value:function addListeners(){var _this13=this;var cleanupWindowOpen=onWindowOpen(function(){// Treat window.open as mutation
_this13._lastMutation=nowInSeconds();});this._teardown=function(){cleanupWindowOpen();_this13._clicks=[];_this13._lastMutation=0;_this13._lastScroll=0;};}/** Clean up listeners. */},{key:"removeListeners",value:function removeListeners(){if(this._teardown){this._teardown();}if(this._checkClickTimeout){clearTimeout(this._checkClickTimeout);}}/** @inheritDoc */},{key:"handleClick",value:function handleClick(breadcrumb,node){if(ignoreElement(node,this._ignoreSelector)||!isClickBreadcrumb(breadcrumb)){return;}var newClick={timestamp:timestampToS(breadcrumb.timestamp),clickBreadcrumb:breadcrumb,// Set this to 0 so we know it originates from the click breadcrumb
clickCount:0,node:node};// If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
if(this._clicks.some(function(click){return click.node===newClick.node&&Math.abs(click.timestamp-newClick.timestamp)<1;})){return;}this._clicks.push(newClick);// If this is the first new click, set a timeout to check for multi clicks
if(this._clicks.length===1){this._scheduleCheckClicks();}}/** @inheritDoc */},{key:"registerMutation",value:function registerMutation(){var timestamp=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Date.now();this._lastMutation=timestampToS(timestamp);}/** @inheritDoc */},{key:"registerScroll",value:function registerScroll(){var timestamp=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Date.now();this._lastScroll=timestampToS(timestamp);}/** @inheritDoc */},{key:"registerClick",value:function registerClick(element){var node=getClosestInteractive(element);this._handleMultiClick(node);}/** Count multiple clicks on elements. */},{key:"_handleMultiClick",value:function _handleMultiClick(node){this._getClicks(node).forEach(function(click){click.clickCount++;});}/** Get all pending clicks for a given node. */},{key:"_getClicks",value:function _getClicks(node){return this._clicks.filter(function(click){return click.node===node;});}/** Check the clicks that happened. */},{key:"_checkClicks",value:function _checkClicks(){var _this14=this;var timedOutClicks=[];var now=nowInSeconds();this._clicks.forEach(function(click){if(!click.mutationAfter&&_this14._lastMutation){click.mutationAfter=click.timestamp<=_this14._lastMutation?_this14._lastMutation-click.timestamp:undefined;}if(!click.scrollAfter&&_this14._lastScroll){click.scrollAfter=click.timestamp<=_this14._lastScroll?_this14._lastScroll-click.timestamp:undefined;}// All of these are in seconds!
if(click.timestamp+_this14._timeout<=now){timedOutClicks.push(click);}});// Remove "old" clicks
for(var _i5=0,_timedOutClicks=timedOutClicks;_i5<_timedOutClicks.length;_i5++){var click=_timedOutClicks[_i5];var pos=this._clicks.indexOf(click);if(pos>-1){this._generateBreadcrumbs(click);this._clicks.splice(pos,1);}}// Trigger new check, unless no clicks left
if(this._clicks.length){this._scheduleCheckClicks();}}/** Generate matching breadcrumb(s) for the click. */},{key:"_generateBreadcrumbs",value:function _generateBreadcrumbs(click){var replay=this._replay;var hadScroll=click.scrollAfter&&click.scrollAfter<=this._scollTimeout;var hadMutation=click.mutationAfter&&click.mutationAfter<=this._threshold;var isSlowClick=!hadScroll&&!hadMutation;var clickCount=click.clickCount,clickBreadcrumb=click.clickBreadcrumb;// Slow click
if(isSlowClick){// If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
// If not, it means we just timed out without scroll & mutation
var timeAfterClickMs=Math.min(click.mutationAfter||this._timeout,this._timeout)*1000;var endReason=timeAfterClickMs<this._timeout*1000?'mutation':'timeout';var breadcrumb={type:'default',message:clickBreadcrumb.message,timestamp:clickBreadcrumb.timestamp,category:'ui.slowClickDetected',data:_objectSpread({},clickBreadcrumb.data,{url:WINDOW.location.href,route:replay.getCurrentRoute(),timeAfterClickMs:timeAfterClickMs,endReason:endReason,// If clickCount === 0, it means multiClick was not correctly captured here
// - we still want to send 1 in this case
clickCount:clickCount||1})};this._addBreadcrumbEvent(replay,breadcrumb);return;}// Multi click
if(clickCount>1){var _breadcrumb={type:'default',message:clickBreadcrumb.message,timestamp:clickBreadcrumb.timestamp,category:'ui.multiClick',data:_objectSpread({},clickBreadcrumb.data,{url:WINDOW.location.href,route:replay.getCurrentRoute(),clickCount:clickCount,metric:true})};this._addBreadcrumbEvent(replay,_breadcrumb);}}/** Schedule to check current clicks. */},{key:"_scheduleCheckClicks",value:function _scheduleCheckClicks(){var _this15=this;if(this._checkClickTimeout){clearTimeout(this._checkClickTimeout);}this._checkClickTimeout=setTimeout(function(){return _this15._checkClicks();},1000);}}]);return ClickDetector;}();var SLOW_CLICK_TAGS=['A','BUTTON','INPUT'];/** exported for tests only */function ignoreElement(node,ignoreSelector){if(!SLOW_CLICK_TAGS.includes(node.tagName)){return true;}// If <input> tag, we only want to consider input[type='submit'] & input[type='button']
if(node.tagName==='INPUT'&&!['submit','button'].includes(node.getAttribute('type')||'')){return true;}// If <a> tag, detect special variants that may not lead to an action
// If target !== _self, we may open the link somewhere else, which would lead to no action
// Also, when downloading a file, we may not leave the page, but still not trigger an action
if(node.tagName==='A'&&(node.hasAttribute('download')||node.hasAttribute('target')&&node.getAttribute('target')!=='_self')){return true;}if(ignoreSelector&&node.matches(ignoreSelector)){return true;}return false;}function isClickBreadcrumb(breadcrumb){return!!(breadcrumb.data&&typeof breadcrumb.data.nodeId==='number'&&breadcrumb.timestamp);}// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function nowInSeconds(){return Date.now()/1000;}/** Update the click detector based on a recording event of rrweb. */function updateClickDetectorForRecordingEvent(clickDetector,event){try{// note: We only consider incremental snapshots here
// This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
// E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
// in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
// Instead, by ignoring full snapshots, we have the risk that we generate a false positive
// (if a mutation _did_ happen but was "swallowed" by the full snapshot)
// But this should be more unlikely as we'd generally capture the incremental snapshot right away
if(!isIncrementalEvent(event)){return;}var source=event.data.source;if(source===IncrementalSource.Mutation){clickDetector.registerMutation(event.timestamp);}if(source===IncrementalSource.Scroll){clickDetector.registerScroll(event.timestamp);}if(isIncrementalMouseInteraction(event)){var _event$data=event.data,type=_event$data.type,id=_event$data.id;var node=record.mirror.getNode(id);if(node instanceof HTMLElement&&type===MouseInteractions.Click){clickDetector.registerClick(node);}}}catch(e){// ignore errors here, e.g. if accessing something that does not exist
}}function isIncrementalEvent(event){return event.type===ReplayEventTypeIncrementalSnapshot;}function isIncrementalMouseInteraction(event){return event.data.source===IncrementalSource.MouseInteraction;}/**
 * Create a breadcrumb for a replay.
 */function createBreadcrumb(breadcrumb){return _objectSpread({timestamp:Date.now()/1000,type:'default'},breadcrumb);}var NodeType;(function(NodeType){NodeType[NodeType["Document"]=0]="Document";NodeType[NodeType["DocumentType"]=1]="DocumentType";NodeType[NodeType["Element"]=2]="Element";NodeType[NodeType["Text"]=3]="Text";NodeType[NodeType["CDATA"]=4]="CDATA";NodeType[NodeType["Comment"]=5]="Comment";})(NodeType||(NodeType={}));// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
var ATTRIBUTES_TO_RECORD=new Set(['id','class','aria-label','role','name','alt','title','data-test-id','data-testid','disabled','aria-disabled','data-sentry-component']);/**
 * Inclusion list of attributes that we want to record from the DOM element
 */function getAttributesToRecord(attributes){var obj={};for(var key in attributes){if(ATTRIBUTES_TO_RECORD.has(key)){var normalizedKey=key;if(key==='data-testid'||key==='data-test-id'){normalizedKey='testId';}obj[normalizedKey]=attributes[key];}}return obj;}var handleDomListener=function handleDomListener(replay){return function(handlerData){if(!replay.isEnabled()){return;}var result=handleDom(handlerData);if(!result){return;}var isClick=handlerData.name==='click';var event=isClick?handlerData.event:undefined;// Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
if(isClick&&replay.clickDetector&&event&&event.target&&!event.altKey&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey){handleClick(replay.clickDetector,result,getClickTargetNode(handlerData.event));}addBreadcrumbEvent(replay,result);};};/** Get the base DOM breadcrumb. */function getBaseDomBreadcrumb(target,message){var nodeId=record.mirror.getId(target);var node=nodeId&&record.mirror.getNode(nodeId);var meta=node&&record.mirror.getMeta(node);var element=meta&&isElement(meta)?meta:null;return{message:message,data:element?{nodeId:nodeId,node:{id:nodeId,tagName:element.tagName,textContent:Array.from(element.childNodes).map(function(node){return node.type===NodeType.Text&&node.textContent;}).filter(Boolean)// filter out empty values
.map(function(text){return text.trim();}).join(''),attributes:getAttributesToRecord(element.attributes)}}:{}};}/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */function handleDom(handlerData){var _getDomTarget=getDomTarget(handlerData),target=_getDomTarget.target,message=_getDomTarget.message;return createBreadcrumb(_objectSpread({category:"ui.".concat(handlerData.name)},getBaseDomBreadcrumb(target,message)));}function getDomTarget(handlerData){var isClick=handlerData.name==='click';var message;var target=null;// Accessing event.target can throw (see getsentry/raven-js#838, #768)
try{target=isClick?getClickTargetNode(handlerData.event):getTargetNode(handlerData.event);message=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_7" /* htmlTreeAsString */])(target,{maxStringLength:200})||'<unknown>';}catch(e){message='<unknown>';}return{target:target,message:message};}function isElement(node){return node.type===NodeType.Element;}/** Handle keyboard events & create breadcrumbs. */function handleKeyboardEvent(replay,event){if(!replay.isEnabled()){return;}// Update user activity, but do not restart recording as it can create
// noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
// session with a single "keydown" breadcrumb is created)
replay.updateUserActivity();var breadcrumb=getKeyboardBreadcrumb(event);if(!breadcrumb){return;}addBreadcrumbEvent(replay,breadcrumb);}/** exported only for tests */function getKeyboardBreadcrumb(event){var metaKey=event.metaKey,shiftKey=event.shiftKey,ctrlKey=event.ctrlKey,altKey=event.altKey,key=event.key,target=event.target;// never capture for input fields
if(!target||isInputElement(target)||!key){return null;}// Note: We do not consider shift here, as that means "uppercase"
var hasModifierKey=metaKey||ctrlKey||altKey;var isCharacterKey=key.length===1;// other keys like Escape, Tab, etc have a longer length
// Do not capture breadcrumb if only a word key is pressed
// This could leak e.g. user input
if(!hasModifierKey&&isCharacterKey){return null;}var message=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_7" /* htmlTreeAsString */])(target,{maxStringLength:200})||'<unknown>';var baseBreadcrumb=getBaseDomBreadcrumb(target,message);return createBreadcrumb({category:'ui.keyDown',message:message,data:_objectSpread({},baseBreadcrumb.data,{metaKey:metaKey,shiftKey:shiftKey,ctrlKey:ctrlKey,altKey:altKey,key:key})});}function isInputElement(target){return target.tagName==='INPUT'||target.tagName==='TEXTAREA'||target.isContentEditable;}// Map entryType -> function to normalize data for event
var ENTRY_TYPES={// @ts-expect-error TODO: entry type does not fit the create* functions entry type
resource:createResourceEntry,paint:createPaintEntry,// @ts-expect-error TODO: entry type does not fit the create* functions entry type
navigation:createNavigationEntry};/**
 * Create replay performance entries from the browser performance entries.
 */function createPerformanceEntries(entries){return entries.map(createPerformanceEntry).filter(Boolean);}function createPerformanceEntry(entry){if(!ENTRY_TYPES[entry.entryType]){return null;}return ENTRY_TYPES[entry.entryType](entry);}function getAbsoluteTime(time){// browserPerformanceTimeOrigin can be undefined if `performance` or
// `performance.now` doesn't exist, but this is already checked by this integration
return((__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["y" /* browserPerformanceTimeOrigin */]||WINDOW.performance.timeOrigin)+time)/1000;}function createPaintEntry(entry){var duration=entry.duration,entryType=entry.entryType,name=entry.name,startTime=entry.startTime;var start=getAbsoluteTime(startTime);return{type:entryType,name:name,start:start,end:start+duration,data:undefined};}function createNavigationEntry(entry){var entryType=entry.entryType,name=entry.name,decodedBodySize=entry.decodedBodySize,duration=entry.duration,domComplete=entry.domComplete,encodedBodySize=entry.encodedBodySize,domContentLoadedEventStart=entry.domContentLoadedEventStart,domContentLoadedEventEnd=entry.domContentLoadedEventEnd,domInteractive=entry.domInteractive,loadEventStart=entry.loadEventStart,loadEventEnd=entry.loadEventEnd,redirectCount=entry.redirectCount,startTime=entry.startTime,transferSize=entry.transferSize,type=entry.type;// Ignore entries with no duration, they do not seem to be useful and cause dupes
if(duration===0){return null;}return{type:"".concat(entryType,".").concat(type),start:getAbsoluteTime(startTime),end:getAbsoluteTime(domComplete),name:name,data:{size:transferSize,decodedBodySize:decodedBodySize,encodedBodySize:encodedBodySize,duration:duration,domInteractive:domInteractive,domContentLoadedEventStart:domContentLoadedEventStart,domContentLoadedEventEnd:domContentLoadedEventEnd,loadEventStart:loadEventStart,loadEventEnd:loadEventEnd,domComplete:domComplete,redirectCount:redirectCount}};}function createResourceEntry(entry){var entryType=entry.entryType,initiatorType=entry.initiatorType,name=entry.name,responseEnd=entry.responseEnd,startTime=entry.startTime,decodedBodySize=entry.decodedBodySize,encodedBodySize=entry.encodedBodySize,responseStatus=entry.responseStatus,transferSize=entry.transferSize;// Core SDK handles these
if(['fetch','xmlhttprequest'].includes(initiatorType)){return null;}return{type:"".concat(entryType,".").concat(initiatorType),start:getAbsoluteTime(startTime),end:getAbsoluteTime(responseEnd),name:name,data:{size:transferSize,statusCode:responseStatus,decodedBodySize:decodedBodySize,encodedBodySize:encodedBodySize}};}/**
 * Add a LCP event to the replay based on an LCP metric.
 */function getLargestContentfulPaint(metric){var entries=metric.entries;var lastEntry=entries[entries.length-1];var element=lastEntry?lastEntry.element:undefined;var value=metric.value;var end=getAbsoluteTime(value);var data={type:'largest-contentful-paint',name:'largest-contentful-paint',start:end,end:end,data:{value:value,size:value,nodeId:element?record.mirror.getId(element):undefined}};return data;}/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */function setupPerformanceObserver(replay){function addPerformanceEntry(entry){// It is possible for entries to come up multiple times
if(!replay.performanceEntries.includes(entry)){replay.performanceEntries.push(entry);}}function onEntries(_ref21){var entries=_ref21.entries;entries.forEach(addPerformanceEntry);}var clearCallbacks=[];['navigation','paint','resource'].forEach(function(type){clearCallbacks.push(Object(__WEBPACK_IMPORTED_MODULE_2__sentry_internal_tracing__["c" /* addPerformanceInstrumentationHandler */])(type,onEntries));});clearCallbacks.push(Object(__WEBPACK_IMPORTED_MODULE_2__sentry_internal_tracing__["b" /* addLcpInstrumentationHandler */])(function(_ref22){var metric=_ref22.metric;replay.replayPerformanceEntries.push(getLargestContentfulPaint(metric));}));// A callback to cleanup all handlers
return function(){clearCallbacks.forEach(function(clearCallback){return clearCallback();});};}/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */var DEBUG_BUILD=typeof __SENTRY_DEBUG__==='undefined'||__SENTRY_DEBUG__;var r="var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=[\"unexpected EOF\",\"invalid block type\",\"invalid length/literal\",\"invalid distance\",\"stream finished\",\"no stream handler\",,\"no callback\",\"invalid UTF-8 data\",\"extra field too long\",\"date not in range 1980-2099\",\"filename too long\",\"stream finishing\",\"invalid zip data\"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if(\"function\"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G=\"undefined\"!=typeof TextEncoder&&new TextEncoder,H=\"undefined\"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error(\"Adding invalid event\");const n=this._hasEvents?\",\":\"\";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push(\"]\",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push(\"[\")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener(\"message\",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&\"function\"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:\"init\",success:!0,response:void 0});";function e(){var e=new Blob([r]);return URL.createObjectURL(e);}/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */function logInfo(message,shouldAddBreadcrumb){if(!DEBUG_BUILD){return;}__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].info(message);if(shouldAddBreadcrumb){addLogBreadcrumb(message);}}/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */function logInfoNextTick(message,shouldAddBreadcrumb){if(!DEBUG_BUILD){return;}__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].info(message);if(shouldAddBreadcrumb){// Wait a tick here to avoid race conditions for some initial logs
// which may be added before replay is initialized
setTimeout(function(){addLogBreadcrumb(message);},0);}}function addLogBreadcrumb(message){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["p" /* addBreadcrumb */])({category:'console',data:{logger:'replay'},level:'info',message:message},{level:'info'});}/** This error indicates that the event buffer size exceeded the limit.. */var EventBufferSizeExceededError=/*#__PURE__*/function(_Error){_inherits(EventBufferSizeExceededError,_Error);function EventBufferSizeExceededError(){_classCallCheck(this,EventBufferSizeExceededError);return _possibleConstructorReturn(this,_getPrototypeOf(EventBufferSizeExceededError).call(this,"Event buffer exceeded maximum size of ".concat(REPLAY_MAX_EVENT_BUFFER_SIZE,".")));}return EventBufferSizeExceededError;}(_wrapNativeSuper(Error));/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */var EventBufferArray=/*#__PURE__*/function(){/** All the events that are buffered to be sent. *//** @inheritdoc */function EventBufferArray(){_classCallCheck(this,EventBufferArray);this.events=[];this._totalSize=0;this.hasCheckout=false;}/** @inheritdoc */_createClass(EventBufferArray,[{key:"destroy",/** @inheritdoc */value:function destroy(){this.events=[];}/** @inheritdoc */},{key:"addEvent",value:function(){var _addEvent2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(event){var eventSize;return regeneratorRuntime.wrap(function _callee$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:eventSize=JSON.stringify(event).length;this._totalSize+=eventSize;if(!(this._totalSize>REPLAY_MAX_EVENT_BUFFER_SIZE)){_context2.next=4;break;}throw new EventBufferSizeExceededError();case 4:this.events.push(event);case 5:case"end":return _context2.stop();}}},_callee,this);}));function addEvent(_x){return _addEvent2.apply(this,arguments);}return addEvent;}()/** @inheritdoc */},{key:"finish",value:function finish(){var _this16=this;return new Promise(function(resolve){// Make a copy of the events array reference and immediately clear the
// events member so that we do not lose new events while uploading
// attachment.
var eventsRet=_this16.events;_this16.clear();resolve(JSON.stringify(eventsRet));});}/** @inheritdoc */},{key:"clear",value:function clear(){this.events=[];this._totalSize=0;this.hasCheckout=false;}/** @inheritdoc */},{key:"getEarliestTimestamp",value:function getEarliestTimestamp(){var timestamp=this.events.map(function(event){return event.timestamp;}).sort()[0];if(!timestamp){return null;}return timestampToMs(timestamp);}},{key:"hasEvents",get:function get(){return this.events.length>0;}/** @inheritdoc */},{key:"type",get:function get(){return'sync';}}]);return EventBufferArray;}();/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */var WorkerHandler=/*#__PURE__*/function(){function WorkerHandler(worker){_classCallCheck(this,WorkerHandler);this._worker=worker;this._id=0;}/**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */_createClass(WorkerHandler,[{key:"ensureReady",value:function ensureReady(){var _this17=this;// Ensure we only check once
if(this._ensureReadyPromise){return this._ensureReadyPromise;}this._ensureReadyPromise=new Promise(function(resolve,reject){_this17._worker.addEventListener('message',function(_ref23){var data=_ref23.data;if(data.success){resolve();}else{reject();}},{once:true});_this17._worker.addEventListener('error',function(error){reject(error);},{once:true});});return this._ensureReadyPromise;}/**
   * Destroy the worker.
   */},{key:"destroy",value:function destroy(){logInfo('[Replay] Destroying compression worker');this._worker.terminate();}/**
   * Post message to worker and wait for response before resolving promise.
   */},{key:"postMessage",value:function postMessage(method,arg){var _this18=this;var id=this._getAndIncrementId();return new Promise(function(resolve,reject){var listener=function listener(_ref24){var data=_ref24.data;var response=data;if(response.method!==method){return;}// There can be multiple listeners for a single method, the id ensures
// that the response matches the caller.
if(response.id!==id){return;}// At this point, we'll always want to remove listener regardless of result status
_this18._worker.removeEventListener('message',listener);if(!response.success){// TODO: Do some error handling, not sure what
DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('[Replay]',response.response);reject(new Error('Error in compression worker'));return;}resolve(response.response);};// Note: we can't use `once` option because it's possible it needs to
// listen to multiple messages
_this18._worker.addEventListener('message',listener);_this18._worker.postMessage({id:id,method:method,arg:arg});});}/** Get the current ID and increment it for the next call. */},{key:"_getAndIncrementId",value:function _getAndIncrementId(){return this._id++;}}]);return WorkerHandler;}();/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */var EventBufferCompressionWorker=/*#__PURE__*/function(){/** @inheritdoc */function EventBufferCompressionWorker(worker){_classCallCheck(this,EventBufferCompressionWorker);this._worker=new WorkerHandler(worker);this._earliestTimestamp=null;this._totalSize=0;this.hasCheckout=false;}/** @inheritdoc */_createClass(EventBufferCompressionWorker,[{key:"ensureReady",/**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */value:function ensureReady(){return this._worker.ensureReady();}/**
   * Destroy the event buffer.
   */},{key:"destroy",value:function destroy(){this._worker.destroy();}/**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */},{key:"addEvent",value:function addEvent(event){var timestamp=timestampToMs(event.timestamp);if(!this._earliestTimestamp||timestamp<this._earliestTimestamp){this._earliestTimestamp=timestamp;}var data=JSON.stringify(event);this._totalSize+=data.length;if(this._totalSize>REPLAY_MAX_EVENT_BUFFER_SIZE){return Promise.reject(new EventBufferSizeExceededError());}return this._sendEventToWorker(data);}/**
   * Finish the event buffer and return the compressed data.
   */},{key:"finish",value:function finish(){return this._finishRequest();}/** @inheritdoc */},{key:"clear",value:function clear(){this._earliestTimestamp=null;this._totalSize=0;this.hasCheckout=false;// We do not wait on this, as we assume the order of messages is consistent for the worker
this._worker.postMessage('clear').then(null,function(e){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('[Replay] Sending "clear" message to worker failed',e);});}/** @inheritdoc */},{key:"getEarliestTimestamp",value:function getEarliestTimestamp(){return this._earliestTimestamp;}/**
   * Send the event to the worker.
   */},{key:"_sendEventToWorker",value:function _sendEventToWorker(data){return this._worker.postMessage('addEvent',data);}/**
   * Finish the request and return the compressed data from the worker.
   */},{key:"_finishRequest",value:function(){var _finishRequest2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var response;return regeneratorRuntime.wrap(function _callee2$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return this._worker.postMessage('finish');case 2:response=_context3.sent;this._earliestTimestamp=null;this._totalSize=0;return _context3.abrupt("return",response);case 6:case"end":return _context3.stop();}}},_callee2,this);}));function _finishRequest(){return _finishRequest2.apply(this,arguments);}return _finishRequest;}()},{key:"hasEvents",get:function get(){return!!this._earliestTimestamp;}/** @inheritdoc */},{key:"type",get:function get(){return'worker';}}]);return EventBufferCompressionWorker;}();/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */var EventBufferProxy=/*#__PURE__*/function(){function EventBufferProxy(worker){_classCallCheck(this,EventBufferProxy);this._fallback=new EventBufferArray();this._compression=new EventBufferCompressionWorker(worker);this._used=this._fallback;this._ensureWorkerIsLoadedPromise=this._ensureWorkerIsLoaded();}/** @inheritdoc */_createClass(EventBufferProxy,[{key:"destroy",/** @inheritDoc */value:function destroy(){this._fallback.destroy();this._compression.destroy();}/** @inheritdoc */},{key:"clear",value:function clear(){return this._used.clear();}/** @inheritdoc */},{key:"getEarliestTimestamp",value:function getEarliestTimestamp(){return this._used.getEarliestTimestamp();}/**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */},{key:"addEvent",value:function addEvent(event){return this._used.addEvent(event);}/** @inheritDoc */},{key:"finish",value:function(){var _finish=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(){return regeneratorRuntime.wrap(function _callee3$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return this.ensureWorkerIsLoaded();case 2:return _context4.abrupt("return",this._used.finish());case 3:case"end":return _context4.stop();}}},_callee3,this);}));function finish(){return _finish.apply(this,arguments);}return finish;}()/** Ensure the worker has loaded. */},{key:"ensureWorkerIsLoaded",value:function ensureWorkerIsLoaded(){return this._ensureWorkerIsLoadedPromise;}/** Actually check if the worker has been loaded. */},{key:"_ensureWorkerIsLoaded",value:function(){var _ensureWorkerIsLoaded2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(){return regeneratorRuntime.wrap(function _callee4$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;_context5.next=3;return this._compression.ensureReady();case 3:_context5.next=9;break;case 5:_context5.prev=5;_context5.t0=_context5["catch"](0);// If the worker fails to load, we fall back to the simple buffer.
// Nothing more to do from our side here
logInfo('[Replay] Failed to load the compression worker, falling back to simple buffer');return _context5.abrupt("return");case 9:_context5.next=11;return this._switchToCompressionWorker();case 11:case"end":return _context5.stop();}}},_callee4,this,[[0,5]]);}));function _ensureWorkerIsLoaded(){return _ensureWorkerIsLoaded2.apply(this,arguments);}return _ensureWorkerIsLoaded;}()/** Switch the used buffer to the compression worker. */},{key:"_switchToCompressionWorker",value:function(){var _switchToCompressionWorker2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(){var _this$_fallback,events,hasCheckout,addEventPromises,_iteratorNormalCompletion9,_didIteratorError9,_iteratorError9,_iterator9,_step9,event;return regeneratorRuntime.wrap(function _callee5$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_this$_fallback=this._fallback,events=_this$_fallback.events,hasCheckout=_this$_fallback.hasCheckout;addEventPromises=[];_iteratorNormalCompletion9=true;_didIteratorError9=false;_iteratorError9=undefined;_context6.prev=5;for(_iterator9=events[Symbol.iterator]();!(_iteratorNormalCompletion9=(_step9=_iterator9.next()).done);_iteratorNormalCompletion9=true){event=_step9.value;addEventPromises.push(this._compression.addEvent(event));}_context6.next=13;break;case 9:_context6.prev=9;_context6.t0=_context6["catch"](5);_didIteratorError9=true;_iteratorError9=_context6.t0;case 13:_context6.prev=13;_context6.prev=14;if(!_iteratorNormalCompletion9&&_iterator9.return!=null){_iterator9.return();}case 16:_context6.prev=16;if(!_didIteratorError9){_context6.next=19;break;}throw _iteratorError9;case 19:return _context6.finish(16);case 20:return _context6.finish(13);case 21:this._compression.hasCheckout=hasCheckout;// We switch over to the new buffer immediately - any further events will be added
// after the previously buffered ones
this._used=this._compression;// Wait for original events to be re-added before resolving
_context6.prev=23;_context6.next=26;return Promise.all(addEventPromises);case 26:_context6.next=31;break;case 28:_context6.prev=28;_context6.t1=_context6["catch"](23);DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('[Replay] Failed to add events when switching buffers.',_context6.t1);case 31:case"end":return _context6.stop();}}},_callee5,this,[[5,9,13,21],[14,,16,20],[23,28]]);}));function _switchToCompressionWorker(){return _switchToCompressionWorker2.apply(this,arguments);}return _switchToCompressionWorker;}()},{key:"type",get:function get(){return this._used.type;}/** @inheritDoc */},{key:"hasEvents",get:function get(){return this._used.hasEvents;}/** @inheritdoc */},{key:"hasCheckout",get:function get(){return this._used.hasCheckout;}/** @inheritdoc */,set:function set(value){this._used.hasCheckout=value;}}]);return EventBufferProxy;}();/**
 * Create an event buffer for replays.
 */function createEventBuffer(_ref25){var useCompression=_ref25.useCompression,customWorkerUrl=_ref25.workerUrl;if(useCompression&&// eslint-disable-next-line no-restricted-globals
window.Worker){var worker=_loadWorker(customWorkerUrl);if(worker){return worker;}}logInfo('[Replay] Using simple buffer');return new EventBufferArray();}function _loadWorker(customWorkerUrl){try{var workerUrl=customWorkerUrl||_getWorkerUrl();if(!workerUrl){return;}logInfo("[Replay] Using compression worker".concat(customWorkerUrl?" from ".concat(customWorkerUrl):''));var worker=new Worker(workerUrl);return new EventBufferProxy(worker);}catch(error){logInfo('[Replay] Failed to create compression worker');// Fall back to use simple event buffer array
}}function _getWorkerUrl(){if(typeof __SENTRY_EXCLUDE_REPLAY_WORKER__==='undefined'||!__SENTRY_EXCLUDE_REPLAY_WORKER__){return e();}return'';}/** If sessionStorage is available. */function hasSessionStorage(){try{// This can throw, e.g. when being accessed in a sandboxed iframe
return'sessionStorage'in WINDOW&&!!WINDOW.sessionStorage;}catch(e){return false;}}/**
 * Removes the session from Session Storage and unsets session in replay instance
 */function clearSession(replay){deleteSession();replay.session=undefined;}/**
 * Deletes a session from storage
 */function deleteSession(){if(!hasSessionStorage()){return;}try{WINDOW.sessionStorage.removeItem(REPLAY_SESSION_KEY);}catch(e){// Ignore potential SecurityError exceptions
}}/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */function isSampled(sampleRate){if(sampleRate===undefined){return false;}// Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
return Math.random()<sampleRate;}/**
 * Get a session with defaults & applied sampling.
 */function makeSession(session){var now=Date.now();var id=session.id||Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])();// Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
var started=session.started||now;var lastActivity=session.lastActivity||now;var segmentId=session.segmentId||0;var sampled=session.sampled;var previousSessionId=session.previousSessionId;return{id:id,started:started,lastActivity:lastActivity,segmentId:segmentId,sampled:sampled,previousSessionId:previousSessionId};}/**
 * Save a session to session storage.
 */function saveSession(session){if(!hasSessionStorage()){return;}try{WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY,JSON.stringify(session));}catch(e){// Ignore potential SecurityError exceptions
}}/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */function getSessionSampleType(sessionSampleRate,allowBuffering){return isSampled(sessionSampleRate)?'session':allowBuffering?'buffer':false;}/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */function createSession(_ref26){var sessionSampleRate=_ref26.sessionSampleRate,allowBuffering=_ref26.allowBuffering,_ref26$stickySession=_ref26.stickySession,stickySession=_ref26$stickySession===void 0?false:_ref26$stickySession;var _ref27=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},previousSessionId=_ref27.previousSessionId;var sampled=getSessionSampleType(sessionSampleRate,allowBuffering);var session=makeSession({sampled:sampled,previousSessionId:previousSessionId});if(stickySession){saveSession(session);}return session;}/**
 * Fetches a session from storage
 */function fetchSession(traceInternals){if(!hasSessionStorage()){return null;}try{// This can throw if cookies are disabled
var sessionStringFromStorage=WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);if(!sessionStringFromStorage){return null;}var sessionObj=JSON.parse(sessionStringFromStorage);logInfoNextTick('[Replay] Loading existing session',traceInternals);return makeSession(sessionObj);}catch(e){return null;}}/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */function isExpired(initialTime,expiry){var targetTime=arguments.length>2&&arguments[2]!==undefined?arguments[2]:+new Date();// Always expired if < 0
if(initialTime===null||expiry===undefined||expiry<0){return true;}// Never expires if == 0
if(expiry===0){return false;}return initialTime+expiry<=targetTime;}/**
 * Checks to see if session is expired
 */function isSessionExpired(session,_ref28){var maxReplayDuration=_ref28.maxReplayDuration,sessionIdleExpire=_ref28.sessionIdleExpire,_ref28$targetTime=_ref28.targetTime,targetTime=_ref28$targetTime===void 0?Date.now():_ref28$targetTime;return(// First, check that maximum session length has not been exceeded
isExpired(session.started,maxReplayDuration,targetTime)||// check that the idle timeout has not been exceeded (i.e. user has
// performed an action within the last `sessionIdleExpire` ms)
isExpired(session.lastActivity,sessionIdleExpire,targetTime));}/** If the session should be refreshed or not. */function shouldRefreshSession(session,_ref29){var sessionIdleExpire=_ref29.sessionIdleExpire,maxReplayDuration=_ref29.maxReplayDuration;// If not expired, all good, just keep the session
if(!isSessionExpired(session,{sessionIdleExpire:sessionIdleExpire,maxReplayDuration:maxReplayDuration})){return false;}// If we are buffering & haven't ever flushed yet, always continue
if(session.sampled==='buffer'&&session.segmentId===0){return false;}return true;}/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */function loadOrCreateSession(_ref30,sessionOptions){var traceInternals=_ref30.traceInternals,sessionIdleExpire=_ref30.sessionIdleExpire,maxReplayDuration=_ref30.maxReplayDuration,previousSessionId=_ref30.previousSessionId;var existingSession=sessionOptions.stickySession&&fetchSession(traceInternals);// No session exists yet, just create a new one
if(!existingSession){logInfoNextTick('[Replay] Creating new session',traceInternals);return createSession(sessionOptions,{previousSessionId:previousSessionId});}if(!shouldRefreshSession(existingSession,{sessionIdleExpire:sessionIdleExpire,maxReplayDuration:maxReplayDuration})){return existingSession;}logInfoNextTick('[Replay] Session in sessionStorage is expired, creating new one...');return createSession(sessionOptions,{previousSessionId:existingSession.id});}function isCustomEvent(event){return event.type===EventType.Custom;}/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */function addEventSync(replay,event,isCheckout){if(!shouldAddEvent(replay,event)){return false;}// This should never reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
_addEvent(replay,event,isCheckout);return true;}/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */function addEvent(replay,event,isCheckout){if(!shouldAddEvent(replay,event)){return Promise.resolve(null);}return _addEvent(replay,event,isCheckout);}function _addEvent(_x2,_x3,_x4){return _addEvent3.apply(this,arguments);}/** Exported only for tests. */function _addEvent3(){_addEvent3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1(replay,event,isCheckout){var replayOptions,eventAfterPossibleCallback,reason,client;return regeneratorRuntime.wrap(function _callee1$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(replay.eventBuffer){_context10.next=2;break;}return _context10.abrupt("return",null);case 2:_context10.prev=2;if(isCheckout&&replay.recordingMode==='buffer'){replay.eventBuffer.clear();}if(isCheckout){replay.eventBuffer.hasCheckout=true;}replayOptions=replay.getOptions();eventAfterPossibleCallback=maybeApplyCallback(event,replayOptions.beforeAddRecordingEvent);if(eventAfterPossibleCallback){_context10.next=9;break;}return _context10.abrupt("return");case 9:_context10.next=11;return replay.eventBuffer.addEvent(eventAfterPossibleCallback);case 11:return _context10.abrupt("return",_context10.sent);case 14:_context10.prev=14;_context10.t0=_context10["catch"](2);reason=_context10.t0&&_context10.t0 instanceof EventBufferSizeExceededError?'addEventSizeExceeded':'addEvent';DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error(_context10.t0);_context10.next=20;return replay.stop({reason:reason});case 20:client=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["N" /* getClient */])();if(client){client.recordDroppedEvent('internal_sdk_error','replay');}case 22:case"end":return _context10.stop();}}},_callee1,null,[[2,14]]);}));return _addEvent3.apply(this,arguments);}function shouldAddEvent(replay,event){if(!replay.eventBuffer||replay.isPaused()||!replay.isEnabled()){return false;}var timestampInMs=timestampToMs(event.timestamp);// Throw out events that happen more than 5 minutes ago. This can happen if
// page has been left open and idle for a long period of time and user
// comes back to trigger a new session. The performance entries rely on
// `performance.timeOrigin`, which is when the page first opened.
if(timestampInMs+replay.timeouts.sessionIdlePause<Date.now()){return false;}// Throw out events that are +60min from the initial timestamp
if(timestampInMs>replay.getContext().initialTimestamp+replay.getOptions().maxReplayDuration){logInfo("[Replay] Skipping event with timestamp ".concat(timestampInMs," because it is after maxReplayDuration"),replay.getOptions()._experiments.traceInternals);return false;}return true;}function maybeApplyCallback(event,callback){try{if(typeof callback==='function'&&isCustomEvent(event)){return callback(event);}}catch(error){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...',error);return null;}return event;}/** If the event is an error event */function isErrorEvent(event){return!event.type;}/** If the event is a transaction event */function isTransactionEvent(event){return event.type==='transaction';}/** If the event is an replay event */function isReplayEvent(event){return event.type==='replay_event';}/** If the event is a feedback event */function isFeedbackEvent(event){return event.type==='feedback';}/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */function handleAfterSendEvent(replay){// Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
// TODO (v8): remove this check as it will no longer be necessary
var enforceStatusCode=isBaseTransportSend();return function(event,sendResponse){if(!replay.isEnabled()||!isErrorEvent(event)&&!isTransactionEvent(event)){return;}var statusCode=sendResponse&&sendResponse.statusCode;// We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
// If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
// If we do use the base transport, we skip if we encountered an non-OK status code
if(enforceStatusCode&&(!statusCode||statusCode<200||statusCode>=300)){return;}if(isTransactionEvent(event)){handleTransactionEvent(replay,event);return;}handleErrorEvent(replay,event);};}function handleTransactionEvent(replay,event){var replayContext=replay.getContext();// Collect traceIds in _context regardless of `recordingMode`
// In error mode, _context gets cleared on every checkout
// We limit to max. 100 transactions linked
if(event.contexts&&event.contexts.trace&&event.contexts.trace.trace_id&&replayContext.traceIds.size<100){replayContext.traceIds.add(event.contexts.trace.trace_id);}}function handleErrorEvent(replay,event){var replayContext=replay.getContext();// Add error to list of errorIds of replay. This is ok to do even if not
// sampled because context will get reset at next checkout.
// XXX: There is also a race condition where it's possible to capture an
// error to Sentry before Replay SDK has loaded, but response returns after
// it was loaded, and this gets called.
// We limit to max. 100 errors linked
if(event.event_id&&replayContext.errorIds.size<100){replayContext.errorIds.add(event.event_id);}// If error event is tagged with replay id it means it was sampled (when in buffer mode)
// Need to be very careful that this does not cause an infinite loop
if(replay.recordingMode!=='buffer'||!event.tags||!event.tags.replayId){return;}var _replay$getOptions=replay.getOptions(),beforeErrorSampling=_replay$getOptions.beforeErrorSampling;if(typeof beforeErrorSampling==='function'&&!beforeErrorSampling(event)){return;}setTimeout(function(){// Capture current event buffer as new replay
// This should never reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
replay.sendBufferedReplayOrFlush();});}function isBaseTransportSend(){var client=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["N" /* getClient */])();if(!client){return false;}var transport=client.getTransport();if(!transport){return false;}return transport.send.__sentry__baseTransport__||false;}/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */function handleBeforeSendEvent(replay){return function(event){if(!replay.isEnabled()||!isErrorEvent(event)){return;}handleHydrationError(replay,event);};}function handleHydrationError(replay,event){var exceptionValue=event.exception&&event.exception.values&&event.exception.values[0].value;if(typeof exceptionValue!=='string'){return;}if(// Only matches errors in production builds of react-dom
// Example https://reactjs.org/docs/error-decoder.html?invariant=423
exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/)||// Development builds of react-dom
// Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
// Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)){var breadcrumb=createBreadcrumb({category:'replay.hydrate-error'});addBreadcrumbEvent(replay,breadcrumb);}}/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */function isRrwebError(event,hint){if(event.type||!event.exception||!event.exception.values||!event.exception.values.length){return false;}// @ts-expect-error this may be set by rrweb when it finds errors
if(hint.originalException&&hint.originalException.__rrweb__){return true;}return false;}/**
 * Add a feedback breadcrumb event to replay.
 */function addFeedbackBreadcrumb(replay,event){replay.triggerUserActivity();replay.addUpdate(function(){if(!event.timestamp){// Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
// Return true here so that we don't flush
return true;}// This should never reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
replay.throttledAddEvent({type:EventType.Custom,timestamp:event.timestamp*1000,data:{tag:'breadcrumb',payload:{timestamp:event.timestamp,type:'default',category:'sentry.feedback',data:{feedbackId:event.event_id}}}});return false;});}/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */function shouldSampleForBufferEvent(replay,event){if(replay.recordingMode!=='buffer'){return false;}// ignore this error because otherwise we could loop indefinitely with
// trying to capture replay and failing
if(event.message===UNABLE_TO_SEND_REPLAY){return false;}// Require the event to be an error event & to have an exception
if(!event.exception||event.type){return false;}return isSampled(replay.getOptions().errorSampleRate);}/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */function handleGlobalEventListener(replay){var includeAfterSendEventHandling=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var afterSendHandler=includeAfterSendEventHandling?handleAfterSendEvent(replay):undefined;return Object.assign(function(event,hint){// Do nothing if replay has been disabled
if(!replay.isEnabled()){return event;}if(isReplayEvent(event)){// Replays have separate set of breadcrumbs, do not include breadcrumbs
// from core SDK
delete event.breadcrumbs;return event;}// We only want to handle errors, transactions, and feedbacks, nothing else
if(!isErrorEvent(event)&&!isTransactionEvent(event)&&!isFeedbackEvent(event)){return event;}// Ensure we do not add replay_id if the session is expired
var isSessionActive=replay.checkAndHandleExpiredSession();if(!isSessionActive){return event;}if(isFeedbackEvent(event)){// This should never reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
replay.flush();event.contexts.feedback.replay_id=replay.getSessionId();// Add a replay breadcrumb for this piece of feedback
addFeedbackBreadcrumb(replay,event);return event;}// Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
// As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
if(isRrwebError(event,hint)&&!replay.getOptions()._experiments.captureExceptions){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('[Replay] Ignoring error from rrweb internals',event);return null;}// When in buffer mode, we decide to sample here.
// Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
// And convert the buffer session to a full session
var isErrorEventSampled=shouldSampleForBufferEvent(replay,event);// Tag errors if it has been sampled in buffer mode, or if it is session mode
// Only tag transactions if in session mode
var shouldTagReplayId=isErrorEventSampled||replay.recordingMode==='session';if(shouldTagReplayId){event.tags=_objectSpread({},event.tags,{replayId:replay.getSessionId()});}// In cases where a custom client is used that does not support the new hooks (yet),
// we manually call this hook method here
if(afterSendHandler){// Pretend the error had a 200 response so we always capture it
afterSendHandler(event,{statusCode:200});}return event;},{id:'Replay'});}/**
 * Create a "span" for each performance entry.
 */function createPerformanceSpans(replay,entries){return entries.map(function(_ref31){var type=_ref31.type,start=_ref31.start,end=_ref31.end,name=_ref31.name,data=_ref31.data;var response=replay.throttledAddEvent({type:EventType.Custom,timestamp:start,data:{tag:'performanceSpan',payload:{op:type,description:name,startTimestamp:start,endTimestamp:end,data:data}}});// If response is a string, it means its either THROTTLED or SKIPPED
return typeof response==='string'?Promise.resolve(null):response;});}function handleHistory(handlerData){var from=handlerData.from,to=handlerData.to;var now=Date.now()/1000;return{type:'navigation.push',start:now,end:now,name:to,data:{previous:from}};}/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */function handleHistorySpanListener(replay){return function(handlerData){if(!replay.isEnabled()){return;}var result=handleHistory(handlerData);if(result===null){return;}// Need to collect visited URLs
replay.getContext().urls.push(result.name);replay.triggerUserActivity();replay.addUpdate(function(){createPerformanceSpans(replay,[result]);// Returning false to flush
return false;});};}/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */function shouldFilterRequest(replay,url){// If we enabled the `traceInternals` experiment, we want to trace everything
if(DEBUG_BUILD&&replay.getOptions()._experiments.traceInternals){return false;}return Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_4" /* isSentryRequestUrl */])(url,Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["N" /* getClient */])());}/** Add a performance entry breadcrumb */function addNetworkBreadcrumb(replay,result){if(!replay.isEnabled()){return;}if(result===null){return;}if(shouldFilterRequest(replay,result.name)){return;}replay.addUpdate(function(){createPerformanceSpans(replay,[result]);// Returning true will cause `addUpdate` to not flush
// We do not want network requests to cause a flush. This will prevent
// recurring/polling requests from keeping the replay session alive.
return true;});}/** only exported for tests */function handleFetch(handlerData){var startTimestamp=handlerData.startTimestamp,endTimestamp=handlerData.endTimestamp,fetchData=handlerData.fetchData,response=handlerData.response;if(!endTimestamp){return null;}// This is only used as a fallback, so we know the body sizes are never set here
var method=fetchData.method,url=fetchData.url;return{type:'resource.fetch',start:startTimestamp/1000,end:endTimestamp/1000,name:url,data:{method:method,statusCode:response?response.status:undefined}};}/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */function handleFetchSpanListener(replay){return function(handlerData){if(!replay.isEnabled()){return;}var result=handleFetch(handlerData);addNetworkBreadcrumb(replay,result);};}/** only exported for tests */function handleXhr(handlerData){var startTimestamp=handlerData.startTimestamp,endTimestamp=handlerData.endTimestamp,xhr=handlerData.xhr;var sentryXhrData=xhr[__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["d" /* SENTRY_XHR_DATA_KEY */]];if(!startTimestamp||!endTimestamp||!sentryXhrData){return null;}// This is only used as a fallback, so we know the body sizes are never set here
var method=sentryXhrData.method,url=sentryXhrData.url,statusCode=sentryXhrData.status_code;if(url===undefined){return null;}return{type:'resource.xhr',name:url,start:startTimestamp/1000,end:endTimestamp/1000,data:{method:method,statusCode:statusCode}};}/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */function handleXhrSpanListener(replay){return function(handlerData){if(!replay.isEnabled()){return;}var result=handleXhr(handlerData);addNetworkBreadcrumb(replay,result);};}/** Get the size of a body. */function getBodySize(body,textEncoder){if(!body){return undefined;}try{if(typeof body==='string'){return textEncoder.encode(body).length;}if(body instanceof URLSearchParams){return textEncoder.encode(body.toString()).length;}if(body instanceof FormData){var formDataStr=_serializeFormData(body);return textEncoder.encode(formDataStr).length;}if(body instanceof Blob){return body.size;}if(body instanceof ArrayBuffer){return body.byteLength;}// Currently unhandled types: ArrayBufferView, ReadableStream
}catch(e){// just return undefined
}return undefined;}/** Convert a Content-Length header to number/undefined.  */function parseContentLengthHeader(header){if(!header){return undefined;}var size=parseInt(header,10);return isNaN(size)?undefined:size;}/** Get the string representation of a body. */function getBodyString(body){try{if(typeof body==='string'){return[body];}if(body instanceof URLSearchParams){return[body.toString()];}if(body instanceof FormData){return[_serializeFormData(body)];}if(!body){return[undefined];}}catch(e2){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('[Replay] Failed to serialize body',body);return[undefined,'BODY_PARSE_ERROR'];}DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].info('[Replay] Skipping network body because of body type',body);return[undefined,'UNPARSEABLE_BODY_TYPE'];}/** Merge a warning into an existing network request/response. */function mergeWarning(info,warning){if(!info){return{headers:{},size:undefined,_meta:{warnings:[warning]}};}var newMeta=_objectSpread({},info._meta);var existingWarnings=newMeta.warnings||[];newMeta.warnings=[].concat(_toConsumableArray(existingWarnings),[warning]);info._meta=newMeta;return info;}/** Convert ReplayNetworkRequestData to a PerformanceEntry. */function makeNetworkReplayBreadcrumb(type,data){if(!data){return null;}var startTimestamp=data.startTimestamp,endTimestamp=data.endTimestamp,url=data.url,method=data.method,statusCode=data.statusCode,request=data.request,response=data.response;var result={type:type,start:startTimestamp/1000,end:endTimestamp/1000,name:url,data:Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])({method:method,statusCode:statusCode,request:request,response:response})};return result;}/** Build the request or response part of a replay network breadcrumb that was skipped. */function buildSkippedNetworkRequestOrResponse(bodySize){return{headers:{},size:bodySize,_meta:{warnings:['URL_SKIPPED']}};}/** Build the request or response part of a replay network breadcrumb. */function buildNetworkRequestOrResponse(headers,bodySize,body){if(!bodySize&&Object.keys(headers).length===0){return undefined;}if(!bodySize){return{headers:headers};}if(!body){return{headers:headers,size:bodySize};}var info={headers:headers,size:bodySize};var _normalizeNetworkBody=normalizeNetworkBody(body),normalizedBody=_normalizeNetworkBody.body,warnings=_normalizeNetworkBody.warnings;info.body=normalizedBody;if(warnings&&warnings.length>0){info._meta={warnings:warnings};}return info;}/** Filter a set of headers */function getAllowedHeaders(headers,allowedHeaders){return Object.keys(headers).reduce(function(filteredHeaders,key){var normalizedKey=key.toLowerCase();// Avoid putting empty strings into the headers
if(allowedHeaders.includes(normalizedKey)&&headers[key]){filteredHeaders[normalizedKey]=headers[key];}return filteredHeaders;},{});}function _serializeFormData(formData){// This is a bit simplified, but gives us a decent estimate
// This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
// @ts-expect-error passing FormData to URLSearchParams actually works
return new URLSearchParams(formData).toString();}function normalizeNetworkBody(body){if(!body||typeof body!=='string'){return{body:body};}var exceedsSizeLimit=body.length>NETWORK_BODY_MAX_SIZE;var isProbablyJson=_strIsProbablyJson(body);if(exceedsSizeLimit){var truncatedBody=body.slice(0,NETWORK_BODY_MAX_SIZE);if(isProbablyJson){return{body:truncatedBody,warnings:['MAYBE_JSON_TRUNCATED']};}return{body:"".concat(truncatedBody,"\u2026"),warnings:['TEXT_TRUNCATED']};}if(isProbablyJson){try{var jsonBody=JSON.parse(body);return{body:jsonBody};}catch(e3){// fall back to just send the body as string
}}return{body:body};}function _strIsProbablyJson(str){var first=str[0];var last=str[str.length-1];// Simple check: If this does not start & end with {} or [], it's not JSON
return first==='['&&last===']'||first==='{'&&last==='}';}/** Match an URL against a list of strings/Regex. */function urlMatches(url,urls){var fullUrl=getFullUrl(url);return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_43" /* stringMatchesSomePattern */])(fullUrl,urls);}/** exported for tests */function getFullUrl(url){var baseURI=arguments.length>1&&arguments[1]!==undefined?arguments[1]:WINDOW.document.baseURI;// Short circuit for common cases:
if(url.startsWith('http://')||url.startsWith('https://')||url.startsWith(WINDOW.location.origin)){return url;}var fixedUrl=new URL(url,baseURI);// If these do not match, we are not dealing with a relative URL, so just return it
if(fixedUrl.origin!==new URL(baseURI).origin){return url;}var fullUrl=fixedUrl.href;// Remove trailing slashes, if they don't match the original URL
if(!url.endsWith('/')&&fullUrl.endsWith('/')){return fullUrl.slice(0,-1);}return fullUrl;}/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */function captureFetchBreadcrumbToReplay(_x5,_x6,_x7){return _captureFetchBreadcrumbToReplay.apply(this,arguments);}/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */function _captureFetchBreadcrumbToReplay(){_captureFetchBreadcrumbToReplay=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(breadcrumb,hint,options){var data,result;return regeneratorRuntime.wrap(function _callee10$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.prev=0;_context11.next=3;return _prepareFetchData(breadcrumb,hint,options);case 3:data=_context11.sent;// Create a replay performance entry from this breadcrumb
result=makeNetworkReplayBreadcrumb('resource.fetch',data);addNetworkBreadcrumb(options.replay,result);_context11.next=11;break;case 8:_context11.prev=8;_context11.t0=_context11["catch"](0);DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('[Replay] Failed to capture fetch breadcrumb',_context11.t0);case 11:case"end":return _context11.stop();}}},_callee10,null,[[0,8]]);}));return _captureFetchBreadcrumbToReplay.apply(this,arguments);}function enrichFetchBreadcrumb(breadcrumb,hint,options){var input=hint.input,response=hint.response;var body=input?_getFetchRequestArgBody(input):undefined;var reqSize=getBodySize(body,options.textEncoder);var resSize=response?parseContentLengthHeader(response.headers.get('content-length')):undefined;if(reqSize!==undefined){breadcrumb.data.request_body_size=reqSize;}if(resSize!==undefined){breadcrumb.data.response_body_size=resSize;}}function _prepareFetchData(_x8,_x9,_x0){return _prepareFetchData2.apply(this,arguments);}function _prepareFetchData2(){_prepareFetchData2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11(breadcrumb,hint,options){var now,_hint$startTimestamp2,startTimestamp,_hint$endTimestamp2,endTimestamp,_breadcrumb$data2,url,method,_breadcrumb$data2$sta,statusCode,requestBodySize,responseBodySize,captureDetails,request,response;return regeneratorRuntime.wrap(function _callee11$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:now=Date.now();_hint$startTimestamp2=hint.startTimestamp,startTimestamp=_hint$startTimestamp2===void 0?now:_hint$startTimestamp2,_hint$endTimestamp2=hint.endTimestamp,endTimestamp=_hint$endTimestamp2===void 0?now:_hint$endTimestamp2;_breadcrumb$data2=breadcrumb.data,url=_breadcrumb$data2.url,method=_breadcrumb$data2.method,_breadcrumb$data2$sta=_breadcrumb$data2.status_code,statusCode=_breadcrumb$data2$sta===void 0?0:_breadcrumb$data2$sta,requestBodySize=_breadcrumb$data2.request_body_size,responseBodySize=_breadcrumb$data2.response_body_size;captureDetails=urlMatches(url,options.networkDetailAllowUrls)&&!urlMatches(url,options.networkDetailDenyUrls);request=captureDetails?_getRequestInfo(options,hint.input,requestBodySize):buildSkippedNetworkRequestOrResponse(requestBodySize);_context12.next=7;return _getResponseInfo(captureDetails,options,hint.response,responseBodySize);case 7:response=_context12.sent;return _context12.abrupt("return",{startTimestamp:startTimestamp,endTimestamp:endTimestamp,url:url,method:method,statusCode:statusCode,request:request,response:response});case 9:case"end":return _context12.stop();}}},_callee11);}));return _prepareFetchData2.apply(this,arguments);}function _getRequestInfo(_ref32,input,requestBodySize){var networkCaptureBodies=_ref32.networkCaptureBodies,networkRequestHeaders=_ref32.networkRequestHeaders;var headers=input?getRequestHeaders(input,networkRequestHeaders):{};if(!networkCaptureBodies){return buildNetworkRequestOrResponse(headers,requestBodySize,undefined);}// We only want to transmit string or string-like bodies
var requestBody=_getFetchRequestArgBody(input);var _getBodyString=getBodyString(requestBody),_getBodyString2=_slicedToArray(_getBodyString,2),bodyStr=_getBodyString2[0],warning=_getBodyString2[1];var data=buildNetworkRequestOrResponse(headers,requestBodySize,bodyStr);if(warning){return mergeWarning(data,warning);}return data;}/** Exported only for tests. */function _getResponseInfo(_x1,_x10,_x11,_x12){return _getResponseInfo2.apply(this,arguments);}function _getResponseInfo2(){_getResponseInfo2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(captureDetails,_ref33,response,responseBodySize){var networkCaptureBodies,textEncoder,networkResponseHeaders,headers,_yield$_parseFetchRes,_yield$_parseFetchRes2,bodyText,warning,result;return regeneratorRuntime.wrap(function _callee12$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:networkCaptureBodies=_ref33.networkCaptureBodies,textEncoder=_ref33.textEncoder,networkResponseHeaders=_ref33.networkResponseHeaders;if(!(!captureDetails&&responseBodySize!==undefined)){_context13.next=3;break;}return _context13.abrupt("return",buildSkippedNetworkRequestOrResponse(responseBodySize));case 3:headers=response?getAllHeaders(response.headers,networkResponseHeaders):{};if(!(!response||!networkCaptureBodies&&responseBodySize!==undefined)){_context13.next=6;break;}return _context13.abrupt("return",buildNetworkRequestOrResponse(headers,responseBodySize,undefined));case 6:_context13.next=8;return _parseFetchResponseBody(response);case 8:_yield$_parseFetchRes=_context13.sent;_yield$_parseFetchRes2=_slicedToArray(_yield$_parseFetchRes,2);bodyText=_yield$_parseFetchRes2[0];warning=_yield$_parseFetchRes2[1];result=getResponseData(bodyText,{networkCaptureBodies:networkCaptureBodies,textEncoder:textEncoder,responseBodySize:responseBodySize,captureDetails:captureDetails,headers:headers});if(!warning){_context13.next=15;break;}return _context13.abrupt("return",mergeWarning(result,warning));case 15:return _context13.abrupt("return",result);case 16:case"end":return _context13.stop();}}},_callee12);}));return _getResponseInfo2.apply(this,arguments);}function getResponseData(bodyText,_ref34){var networkCaptureBodies=_ref34.networkCaptureBodies,textEncoder=_ref34.textEncoder,responseBodySize=_ref34.responseBodySize,captureDetails=_ref34.captureDetails,headers=_ref34.headers;try{var size=bodyText&&bodyText.length&&responseBodySize===undefined?getBodySize(bodyText,textEncoder):responseBodySize;if(!captureDetails){return buildSkippedNetworkRequestOrResponse(size);}if(networkCaptureBodies){return buildNetworkRequestOrResponse(headers,size,bodyText);}return buildNetworkRequestOrResponse(headers,size,undefined);}catch(error){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('[Replay] Failed to serialize response body',error);// fallback
return buildNetworkRequestOrResponse(headers,responseBodySize,undefined);}}function _parseFetchResponseBody(_x13){return _parseFetchResponseBody2.apply(this,arguments);}function _parseFetchResponseBody2(){_parseFetchResponseBody2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee13(response){var res,text;return regeneratorRuntime.wrap(function _callee13$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:res=_tryCloneResponse(response);if(res){_context14.next=3;break;}return _context14.abrupt("return",[undefined,'BODY_PARSE_ERROR']);case 3:_context14.prev=3;_context14.next=6;return _tryGetResponseText(res);case 6:text=_context14.sent;return _context14.abrupt("return",[text]);case 10:_context14.prev=10;_context14.t0=_context14["catch"](3);DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('[Replay] Failed to get text body from response',_context14.t0);return _context14.abrupt("return",[undefined,'BODY_PARSE_ERROR']);case 14:case"end":return _context14.stop();}}},_callee13,null,[[3,10]]);}));return _parseFetchResponseBody2.apply(this,arguments);}function _getFetchRequestArgBody(){var fetchArgs=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];// We only support getting the body from the fetch options
if(fetchArgs.length!==2||_typeof(fetchArgs[1])!=='object'){return undefined;}return fetchArgs[1].body;}function getAllHeaders(headers,allowedHeaders){var allHeaders={};allowedHeaders.forEach(function(header){if(headers.get(header)){allHeaders[header]=headers.get(header);}});return allHeaders;}function getRequestHeaders(fetchArgs,allowedHeaders){if(fetchArgs.length===1&&typeof fetchArgs[0]!=='string'){return getHeadersFromOptions(fetchArgs[0],allowedHeaders);}if(fetchArgs.length===2){return getHeadersFromOptions(fetchArgs[1],allowedHeaders);}return{};}function getHeadersFromOptions(input,allowedHeaders){if(!input){return{};}var headers=input.headers;if(!headers){return{};}if(headers instanceof Headers){return getAllHeaders(headers,allowedHeaders);}// We do not support this, as it is not really documented (anymore?)
if(Array.isArray(headers)){return{};}return getAllowedHeaders(headers,allowedHeaders);}function _tryCloneResponse(response){try{// We have to clone this, as the body can only be read once
return response.clone();}catch(error){// this can throw if the response was already consumed before
DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('[Replay] Failed to clone response body',error);}}/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */function _tryGetResponseText(response){return new Promise(function(resolve,reject){var timeout=setTimeout(function(){return reject(new Error('Timeout while trying to read response body'));},500);_getResponseText(response).then(function(txt){return resolve(txt);},function(reason){return reject(reason);}).finally(function(){return clearTimeout(timeout);});});}function _getResponseText(_x14){return _getResponseText2.apply(this,arguments);}/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */function _getResponseText2(){_getResponseText2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee14(response){return regeneratorRuntime.wrap(function _callee14$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return response.text();case 2:return _context15.abrupt("return",_context15.sent);case 3:case"end":return _context15.stop();}}},_callee14);}));return _getResponseText2.apply(this,arguments);}function captureXhrBreadcrumbToReplay(_x15,_x16,_x17){return _captureXhrBreadcrumbToReplay.apply(this,arguments);}/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */function _captureXhrBreadcrumbToReplay(){_captureXhrBreadcrumbToReplay=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee15(breadcrumb,hint,options){var data,result;return regeneratorRuntime.wrap(function _callee15$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:try{data=_prepareXhrData(breadcrumb,hint,options);// Create a replay performance entry from this breadcrumb
result=makeNetworkReplayBreadcrumb('resource.xhr',data);addNetworkBreadcrumb(options.replay,result);}catch(error){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('[Replay] Failed to capture xhr breadcrumb',error);}case 1:case"end":return _context16.stop();}}},_callee15);}));return _captureXhrBreadcrumbToReplay.apply(this,arguments);}function enrichXhrBreadcrumb(breadcrumb,hint,options){var xhr=hint.xhr,input=hint.input;if(!xhr){return;}var reqSize=getBodySize(input,options.textEncoder);var resSize=xhr.getResponseHeader('content-length')?parseContentLengthHeader(xhr.getResponseHeader('content-length')):_getBodySize(xhr.response,xhr.responseType,options.textEncoder);if(reqSize!==undefined){breadcrumb.data.request_body_size=reqSize;}if(resSize!==undefined){breadcrumb.data.response_body_size=resSize;}}function _prepareXhrData(breadcrumb,hint,options){var now=Date.now();var _hint$startTimestamp=hint.startTimestamp,startTimestamp=_hint$startTimestamp===void 0?now:_hint$startTimestamp,_hint$endTimestamp=hint.endTimestamp,endTimestamp=_hint$endTimestamp===void 0?now:_hint$endTimestamp,input=hint.input,xhr=hint.xhr;var _breadcrumb$data=breadcrumb.data,url=_breadcrumb$data.url,method=_breadcrumb$data.method,_breadcrumb$data$stat=_breadcrumb$data.status_code,statusCode=_breadcrumb$data$stat===void 0?0:_breadcrumb$data$stat,requestBodySize=_breadcrumb$data.request_body_size,responseBodySize=_breadcrumb$data.response_body_size;if(!url){return null;}if(!xhr||!urlMatches(url,options.networkDetailAllowUrls)||urlMatches(url,options.networkDetailDenyUrls)){var _request=buildSkippedNetworkRequestOrResponse(requestBodySize);var _response=buildSkippedNetworkRequestOrResponse(responseBodySize);return{startTimestamp:startTimestamp,endTimestamp:endTimestamp,url:url,method:method,statusCode:statusCode,request:_request,response:_response};}var xhrInfo=xhr[__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["d" /* SENTRY_XHR_DATA_KEY */]];var networkRequestHeaders=xhrInfo?getAllowedHeaders(xhrInfo.request_headers,options.networkRequestHeaders):{};var networkResponseHeaders=getAllowedHeaders(getResponseHeaders(xhr),options.networkResponseHeaders);var _ref35=options.networkCaptureBodies?getBodyString(input):[undefined],_ref36=_slicedToArray(_ref35,2),requestBody=_ref36[0],requestWarning=_ref36[1];var _ref37=options.networkCaptureBodies?_getXhrResponseBody(xhr):[undefined],_ref38=_slicedToArray(_ref37,2),responseBody=_ref38[0],responseWarning=_ref38[1];var request=buildNetworkRequestOrResponse(networkRequestHeaders,requestBodySize,requestBody);var response=buildNetworkRequestOrResponse(networkResponseHeaders,responseBodySize,responseBody);return{startTimestamp:startTimestamp,endTimestamp:endTimestamp,url:url,method:method,statusCode:statusCode,request:requestWarning?mergeWarning(request,requestWarning):request,response:responseWarning?mergeWarning(response,responseWarning):response};}function getResponseHeaders(xhr){var headers=xhr.getAllResponseHeaders();if(!headers){return{};}return headers.split('\r\n').reduce(function(acc,line){var _line$split=line.split(': '),_line$split2=_slicedToArray(_line$split,2),key=_line$split2[0],value=_line$split2[1];acc[key.toLowerCase()]=value;return acc;},{});}function _getXhrResponseBody(xhr){// We collect errors that happen, but only log them if we can't get any response body
var errors=[];try{return[xhr.responseText];}catch(e){errors.push(e);}// Try to manually parse the response body, if responseText fails
try{return _parseXhrResponse(xhr.response,xhr.responseType);}catch(e){errors.push(e);}DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn.apply(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */],['[Replay] Failed to get xhr response body'].concat(errors));return[undefined];}/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */function _parseXhrResponse(body,responseType){try{if(typeof body==='string'){return[body];}if(body instanceof Document){return[body.body.outerHTML];}if(responseType==='json'&&body&&_typeof(body)==='object'){return[JSON.stringify(body)];}if(!body){return[undefined];}}catch(e2){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('[Replay] Failed to serialize body',body);return[undefined,'BODY_PARSE_ERROR'];}DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].info('[Replay] Skipping network body because of body type',body);return[undefined,'UNPARSEABLE_BODY_TYPE'];}function _getBodySize(body,responseType,textEncoder){try{var bodyStr=responseType==='json'&&body&&_typeof(body)==='object'?JSON.stringify(body):body;return getBodySize(bodyStr,textEncoder);}catch(e3){return undefined;}}/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */function handleNetworkBreadcrumbs(replay){var client=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["N" /* getClient */])();try{var textEncoder=new TextEncoder();var _replay$getOptions2=replay.getOptions(),networkDetailAllowUrls=_replay$getOptions2.networkDetailAllowUrls,networkDetailDenyUrls=_replay$getOptions2.networkDetailDenyUrls,networkCaptureBodies=_replay$getOptions2.networkCaptureBodies,networkRequestHeaders=_replay$getOptions2.networkRequestHeaders,networkResponseHeaders=_replay$getOptions2.networkResponseHeaders;var options={replay:replay,textEncoder:textEncoder,networkDetailAllowUrls:networkDetailAllowUrls,networkDetailDenyUrls:networkDetailDenyUrls,networkCaptureBodies:networkCaptureBodies,networkRequestHeaders:networkRequestHeaders,networkResponseHeaders:networkResponseHeaders};if(client&&client.on){client.on('beforeAddBreadcrumb',function(breadcrumb,hint){return beforeAddNetworkBreadcrumb(options,breadcrumb,hint);});}else{// Fallback behavior
Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["n" /* addFetchInstrumentationHandler */])(handleFetchSpanListener(replay));Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["u" /* addXhrInstrumentationHandler */])(handleXhrSpanListener(replay));}}catch(e2){// Do nothing
}}/** just exported for tests */function beforeAddNetworkBreadcrumb(options,breadcrumb,hint){if(!breadcrumb.data){return;}try{if(_isXhrBreadcrumb(breadcrumb)&&_isXhrHint(hint)){// This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
// Because the hook runs synchronously, and the breadcrumb is afterwards passed on
// So any async mutations to it will not be reflected in the final breadcrumb
enrichXhrBreadcrumb(breadcrumb,hint,options);// This call should not reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
captureXhrBreadcrumbToReplay(breadcrumb,hint,options);}if(_isFetchBreadcrumb(breadcrumb)&&_isFetchHint(hint)){// This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
// Because the hook runs synchronously, and the breadcrumb is afterwards passed on
// So any async mutations to it will not be reflected in the final breadcrumb
enrichFetchBreadcrumb(breadcrumb,hint,options);// This call should not reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
captureFetchBreadcrumbToReplay(breadcrumb,hint,options);}}catch(e){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('Error when enriching network breadcrumb');}}function _isXhrBreadcrumb(breadcrumb){return breadcrumb.category==='xhr';}function _isFetchBreadcrumb(breadcrumb){return breadcrumb.category==='fetch';}function _isXhrHint(hint){return hint&&hint.xhr;}function _isFetchHint(hint){return hint&&hint.response;}var _LAST_BREADCRUMB=null;function isBreadcrumbWithCategory(breadcrumb){return!!breadcrumb.category;}var handleScopeListener=function handleScopeListener(replay){return function(scope){if(!replay.isEnabled()){return;}var result=handleScope(scope);if(!result){return;}addBreadcrumbEvent(replay,result);};};/**
 * An event handler to handle scope changes.
 */function handleScope(scope){// TODO (v8): Remove this guard. This was put in place because we introduced
// Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
// For now, we'll just return null if the method doesn't exist but we should eventually
// get rid of this guard.
var newBreadcrumb=scope.getLastBreadcrumb&&scope.getLastBreadcrumb();// Listener can be called when breadcrumbs have not changed, so we store the
// reference to the last crumb and only return a crumb if it has changed
if(_LAST_BREADCRUMB===newBreadcrumb||!newBreadcrumb){return null;}_LAST_BREADCRUMB=newBreadcrumb;if(!isBreadcrumbWithCategory(newBreadcrumb)||['fetch','xhr','sentry.event','sentry.transaction'].includes(newBreadcrumb.category)||newBreadcrumb.category.startsWith('ui.')){return null;}if(newBreadcrumb.category==='console'){return normalizeConsoleBreadcrumb(newBreadcrumb);}return createBreadcrumb(newBreadcrumb);}/** exported for tests only */function normalizeConsoleBreadcrumb(breadcrumb){var args=breadcrumb.data&&breadcrumb.data.arguments;if(!Array.isArray(args)||args.length===0){return createBreadcrumb(breadcrumb);}var isTruncated=false;// Avoid giant args captures
var normalizedArgs=args.map(function(arg){if(!arg){return arg;}if(typeof arg==='string'){if(arg.length>CONSOLE_ARG_MAX_SIZE){isTruncated=true;return"".concat(arg.slice(0,CONSOLE_ARG_MAX_SIZE),"\u2026");}return arg;}if(_typeof(arg)==='object'){try{var normalizedArg=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_30" /* normalize */])(arg,7);var stringified=JSON.stringify(normalizedArg);if(stringified.length>CONSOLE_ARG_MAX_SIZE){isTruncated=true;// We use the pretty printed JSON string here as a base
return"".concat(JSON.stringify(normalizedArg,null,2).slice(0,CONSOLE_ARG_MAX_SIZE),"\u2026");}return normalizedArg;}catch(e){// fall back to default
}}return arg;});return createBreadcrumb(_objectSpread({},breadcrumb,{data:_objectSpread({},breadcrumb.data,{arguments:normalizedArgs},isTruncated?{_meta:{warnings:['CONSOLE_ARG_TRUNCATED']}}:{})}));}/**
 * Add global listeners that cannot be removed.
 */function addGlobalListeners(replay){// Listeners from core SDK //
var scope=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["P" /* getCurrentScope */])();var client=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["N" /* getClient */])();scope.addScopeListener(handleScopeListener(replay));Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["i" /* addClickKeypressInstrumentationHandler */])(handleDomListener(replay));Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["q" /* addHistoryInstrumentationHandler */])(handleHistorySpanListener(replay));handleNetworkBreadcrumbs(replay);// Tag all (non replay) events that get sent to Sentry with the current
// replay ID so that we can reference them later in the UI
var eventProcessor=handleGlobalEventListener(replay,!hasHooks(client));if(client&&client.addEventProcessor){client.addEventProcessor(eventProcessor);}else{Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["q" /* addEventProcessor */])(eventProcessor);}// If a custom client has no hooks yet, we continue to use the "old" implementation
if(hasHooks(client)){client.on('beforeSendEvent',handleBeforeSendEvent(replay));client.on('afterSendEvent',handleAfterSendEvent(replay));client.on('createDsc',function(dsc){var replayId=replay.getSessionId();// We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
if(replayId&&replay.isEnabled()&&replay.recordingMode==='session'){// Ensure to check that the session is still active - it could have expired in the meanwhile
var isSessionActive=replay.checkAndHandleExpiredSession();if(isSessionActive){dsc.replay_id=replayId;}}});client.on('startTransaction',function(transaction){replay.lastTransaction=transaction;});// We may be missing the initial startTransaction due to timing issues,
// so we capture it on finish again.
client.on('finishTransaction',function(transaction){replay.lastTransaction=transaction;});// We want to flush replay
client.on('beforeSendFeedback',function(feedbackEvent,options){var replayId=replay.getSessionId();if(options&&options.includeReplay&&replay.isEnabled()&&replayId){// This should never reject
if(feedbackEvent.contexts&&feedbackEvent.contexts.feedback){feedbackEvent.contexts.feedback.replay_id=replayId;}}});}}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function hasHooks(client){return!!(client&&client.on);}/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */function addMemoryEntry(_x18){return _addMemoryEntry.apply(this,arguments);}function _addMemoryEntry(){_addMemoryEntry=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee16(replay){return regeneratorRuntime.wrap(function _callee16$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.prev=0;return _context17.abrupt("return",Promise.all(createPerformanceSpans(replay,[// @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
createMemoryEntry(WINDOW.performance.memory)])));case 4:_context17.prev=4;_context17.t0=_context17["catch"](0);return _context17.abrupt("return",[]);case 7:case"end":return _context17.stop();}}},_callee16,null,[[0,4]]);}));return _addMemoryEntry.apply(this,arguments);}function createMemoryEntry(memoryEntry){var jsHeapSizeLimit=memoryEntry.jsHeapSizeLimit,totalJSHeapSize=memoryEntry.totalJSHeapSize,usedJSHeapSize=memoryEntry.usedJSHeapSize;// we don't want to use `getAbsoluteTime` because it adds the event time to the
// time origin, so we get the current timestamp instead
var time=Date.now()/1000;return{type:'memory',name:'memory',start:time,end:time,data:{memory:{jsHeapSizeLimit:jsHeapSizeLimit,totalJSHeapSize:totalJSHeapSize,usedJSHeapSize:usedJSHeapSize}}};}/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */function debounce(func,wait,options){var callbackReturnValue;var timerId;var maxTimerId;var maxWait=options&&options.maxWait?Math.max(options.maxWait,wait):0;function invokeFunc(){cancelTimers();callbackReturnValue=func();return callbackReturnValue;}function cancelTimers(){timerId!==undefined&&clearTimeout(timerId);maxTimerId!==undefined&&clearTimeout(maxTimerId);timerId=maxTimerId=undefined;}function flush(){if(timerId!==undefined||maxTimerId!==undefined){return invokeFunc();}return callbackReturnValue;}function debounced(){if(timerId){clearTimeout(timerId);}timerId=setTimeout(invokeFunc,wait);if(maxWait&&maxTimerId===undefined){maxTimerId=setTimeout(invokeFunc,maxWait);}return callbackReturnValue;}debounced.cancel=cancelTimers;debounced.flush=flush;return debounced;}/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */function getHandleRecordingEmit(replay){var hadFirstEvent=false;return function(event,_isCheckout){// If this is false, it means session is expired, create and a new session and wait for checkout
if(!replay.checkAndHandleExpiredSession()){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('[Replay] Received replay event after session expired.');return;}// `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
// We also want to treat the first event as a checkout, so we handle this specifically here
var isCheckout=_isCheckout||!hadFirstEvent;hadFirstEvent=true;if(replay.clickDetector){updateClickDetectorForRecordingEvent(replay.clickDetector,event);}// The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
replay.addUpdate(function(){// The session is always started immediately on pageload/init, but for
// error-only replays, it should reflect the most recent checkout
// when an error occurs. Clear any state that happens before this current
// checkout. This needs to happen before `addEvent()` which updates state
// dependent on this reset.
if(replay.recordingMode==='buffer'&&isCheckout){replay.setInitialState();}// If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
// Skip all further steps
if(!addEventSync(replay,event,isCheckout)){// Return true to skip scheduling a debounced flush
return true;}// Different behavior for full snapshots (type=2), ignore other event types
// See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
if(!isCheckout){return false;}// Additionally, create a meta event that will capture certain SDK settings.
// In order to handle buffer mode, this needs to either be done when we
// receive checkout events or at flush time.
//
// `isCheckout` is always true, but want to be explicit that it should
// only be added for checkouts
addSettingsEvent(replay,isCheckout);// If there is a previousSessionId after a full snapshot occurs, then
// the replay session was started due to session expiration. The new session
// is started before triggering a new checkout and contains the id
// of the previous session. Do not immediately flush in this case
// to avoid capturing only the checkout and instead the replay will
// be captured if they perform any follow-up actions.
if(replay.session&&replay.session.previousSessionId){return true;}// When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
// this should usually be the timestamp of the checkout event, but to be safe...
if(replay.recordingMode==='buffer'&&replay.session&&replay.eventBuffer){var earliestEvent=replay.eventBuffer.getEarliestTimestamp();if(earliestEvent){logInfo("[Replay] Updating session start time to earliest event in buffer to ".concat(new Date(earliestEvent)),replay.getOptions()._experiments.traceInternals);replay.session.started=earliestEvent;if(replay.getOptions().stickySession){saveSession(replay.session);}}}if(replay.recordingMode==='session'){// If the full snapshot is due to an initial load, we will not have
// a previous session ID. In this case, we want to buffer events
// for a set amount of time before flushing. This can help avoid
// capturing replays of users that immediately close the window.
// This should never reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
void replay.flush();}return true;});};}/**
 * Exported for tests
 */function createOptionsEvent(replay){var options=replay.getOptions();return{type:EventType.Custom,timestamp:Date.now(),data:{tag:'options',payload:{shouldRecordCanvas:replay.isRecordingCanvas(),sessionSampleRate:options.sessionSampleRate,errorSampleRate:options.errorSampleRate,useCompressionOption:options.useCompression,blockAllMedia:options.blockAllMedia,maskAllText:options.maskAllText,maskAllInputs:options.maskAllInputs,useCompression:replay.eventBuffer?replay.eventBuffer.type==='worker':false,networkDetailHasUrls:options.networkDetailAllowUrls.length>0,networkCaptureBodies:options.networkCaptureBodies,networkRequestHasHeaders:options.networkRequestHeaders.length>0,networkResponseHasHeaders:options.networkResponseHeaders.length>0}}};}/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */function addSettingsEvent(replay,isCheckout){// Only need to add this event when sending the first segment
if(!isCheckout||!replay.session||replay.session.segmentId!==0){return;}addEventSync(replay,createOptionsEvent(replay),false);}/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */function createReplayEnvelope(replayEvent,recordingData,dsn,tunnel){return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* createEnvelope */])(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* createEventEnvelopeHeaders */])(replayEvent,Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_6" /* getSdkMetadataForEnvelopeHeader */])(replayEvent),tunnel,dsn),[[{type:'replay_event'},replayEvent],[{type:'replay_recording',// If string then we need to encode to UTF8, otherwise will have
// wrong size. TextEncoder has similar browser support to
// MutationObserver, although it does not accept IE11.
length:typeof recordingData==='string'?new TextEncoder().encode(recordingData).length:recordingData.length},recordingData]]);}/**
 * Prepare the recording data ready to be sent.
 */function prepareRecordingData(_ref39){var recordingData=_ref39.recordingData,headers=_ref39.headers;var payloadWithSequence;// XXX: newline is needed to separate sequence id from events
var replayHeaders="".concat(JSON.stringify(headers),"\n");if(typeof recordingData==='string'){payloadWithSequence="".concat(replayHeaders).concat(recordingData);}else{var enc=new TextEncoder();// XXX: newline is needed to separate sequence id from events
var sequence=enc.encode(replayHeaders);// Merge the two Uint8Arrays
payloadWithSequence=new Uint8Array(sequence.length+recordingData.length);payloadWithSequence.set(sequence);payloadWithSequence.set(recordingData,sequence.length);}return payloadWithSequence;}/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */function prepareReplayEvent(_x19){return _prepareReplayEvent.apply(this,arguments);}/**
 * Send replay attachment using `fetch()`
 */function _prepareReplayEvent(){_prepareReplayEvent=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee17(_ref40){var client,scope,event_id,event,integrations,eventHint,preparedEvent,metadata,_ref50,name,version;return regeneratorRuntime.wrap(function _callee17$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:client=_ref40.client,scope=_ref40.scope,event_id=_ref40.replayId,event=_ref40.event;integrations=_typeof(client._integrations)==='object'&&client._integrations!==null&&!Array.isArray(client._integrations)?Object.keys(client._integrations):undefined;eventHint={event_id:event_id,integrations:integrations};if(client.emit){client.emit('preprocessEvent',event,eventHint);}_context18.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_13" /* prepareEvent */])(client.getOptions(),event,eventHint,scope,client,Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["V" /* getIsolationScope */])());case 6:preparedEvent=_context18.sent;if(preparedEvent){_context18.next=9;break;}return _context18.abrupt("return",null);case 9:// This normally happens in browser client "_prepareEvent"
// but since we do not use this private method from the client, but rather the plain import
// we need to do this manually.
preparedEvent.platform=preparedEvent.platform||'javascript';// extract the SDK name because `client._prepareEvent` doesn't add it to the event
metadata=client.getSdkMetadata&&client.getSdkMetadata();_ref50=metadata&&metadata.sdk||{},name=_ref50.name,version=_ref50.version;preparedEvent.sdk=_objectSpread({},preparedEvent.sdk,{name:name||'sentry.javascript.unknown',version:version||'0.0.0'});return _context18.abrupt("return",preparedEvent);case 14:case"end":return _context18.stop();}}},_callee17);}));return _prepareReplayEvent.apply(this,arguments);}function sendReplayRequest(_x20){return _sendReplayRequest.apply(this,arguments);}/**
 * This error indicates that the transport returned an invalid status code.
 */function _sendReplayRequest(){_sendReplayRequest=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee18(_ref41){var recordingData,replayId,segment_id,eventContext,timestamp,session,preparedRecordingData,urls,errorIds,traceIds,initialTimestamp,client,scope,transport,dsn,baseEvent,replayEvent,envelope,response,error,rateLimits;return regeneratorRuntime.wrap(function _callee18$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:recordingData=_ref41.recordingData,replayId=_ref41.replayId,segment_id=_ref41.segmentId,eventContext=_ref41.eventContext,timestamp=_ref41.timestamp,session=_ref41.session;preparedRecordingData=prepareRecordingData({recordingData:recordingData,headers:{segment_id:segment_id}});urls=eventContext.urls,errorIds=eventContext.errorIds,traceIds=eventContext.traceIds,initialTimestamp=eventContext.initialTimestamp;client=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["N" /* getClient */])();scope=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["P" /* getCurrentScope */])();transport=client&&client.getTransport();dsn=client&&client.getDsn();if(!(!client||!transport||!dsn||!session.sampled)){_context19.next=9;break;}return _context19.abrupt("return");case 9:baseEvent={type:REPLAY_EVENT_NAME,replay_start_timestamp:initialTimestamp/1000,timestamp:timestamp/1000,error_ids:errorIds,trace_ids:traceIds,urls:urls,replay_id:replayId,segment_id:segment_id,replay_type:session.sampled};_context19.next=12;return prepareReplayEvent({scope:scope,client:client,replayId:replayId,event:baseEvent});case 12:replayEvent=_context19.sent;if(replayEvent){_context19.next=17;break;}// Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
client.recordDroppedEvent('event_processor','replay',baseEvent);logInfo('An event processor returned `null`, will not send event.');return _context19.abrupt("return");case 17:/*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */// Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
// sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
// have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
// of this `delete`, lest we miss putting it back in the next time the property is in use.)
delete replayEvent.sdkProcessingMetadata;envelope=createReplayEnvelope(replayEvent,preparedRecordingData,dsn,client.getOptions().tunnel);_context19.prev=19;_context19.next=22;return transport.send(envelope);case 22:response=_context19.sent;_context19.next=30;break;case 25:_context19.prev=25;_context19.t0=_context19["catch"](19);error=new Error(UNABLE_TO_SEND_REPLAY);try{// In case browsers don't allow this property to be writable
// @ts-expect-error This needs lib es2022 and newer
error.cause=_context19.t0;}catch(e){// nothing to do
}throw error;case 30:if(response){_context19.next=32;break;}return _context19.abrupt("return",response);case 32:if(!(typeof response.statusCode==='number'&&(response.statusCode<200||response.statusCode>=300))){_context19.next=34;break;}throw new TransportStatusCodeError(response.statusCode);case 34:rateLimits=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_51" /* updateRateLimits */])({},response);if(!Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_21" /* isRateLimited */])(rateLimits,'replay')){_context19.next=37;break;}throw new RateLimitError(rateLimits);case 37:return _context19.abrupt("return",response);case 38:case"end":return _context19.stop();}}},_callee18,null,[[19,25]]);}));return _sendReplayRequest.apply(this,arguments);}var TransportStatusCodeError=/*#__PURE__*/function(_Error2){_inherits(TransportStatusCodeError,_Error2);function TransportStatusCodeError(statusCode){_classCallCheck(this,TransportStatusCodeError);return _possibleConstructorReturn(this,_getPrototypeOf(TransportStatusCodeError).call(this,"Transport returned status code ".concat(statusCode)));}return TransportStatusCodeError;}(_wrapNativeSuper(Error));/**
 * This error indicates that we hit a rate limit API error.
 */var RateLimitError=/*#__PURE__*/function(_Error3){_inherits(RateLimitError,_Error3);function RateLimitError(rateLimits){var _this19;_classCallCheck(this,RateLimitError);_this19=_possibleConstructorReturn(this,_getPrototypeOf(RateLimitError).call(this,'Rate limit hit'));_this19.rateLimits=rateLimits;return _this19;}return RateLimitError;}(_wrapNativeSuper(Error));/**
 * Finalize and send the current replay event to Sentry
 */function sendReplay(_x21){return _sendReplay.apply(this,arguments);}function _sendReplay(){_sendReplay=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee20(replayData){var retryConfig,recordingData,options,error,_args20=arguments;return regeneratorRuntime.wrap(function _callee20$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:retryConfig=_args20.length>1&&_args20[1]!==undefined?_args20[1]:{count:0,interval:RETRY_BASE_INTERVAL};recordingData=replayData.recordingData,options=replayData.options;// short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
if(recordingData.length){_context21.next=4;break;}return _context21.abrupt("return");case 4:_context21.prev=4;_context21.next=7;return sendReplayRequest(replayData);case 7:return _context21.abrupt("return",true);case 10:_context21.prev=10;_context21.t0=_context21["catch"](4);if(!(_context21.t0 instanceof TransportStatusCodeError||_context21.t0 instanceof RateLimitError)){_context21.next=14;break;}throw _context21.t0;case 14:// Capture error for every failed replay
Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_14" /* setContext */])('Replays',{_retryCount:retryConfig.count});if(DEBUG_BUILD&&options._experiments&&options._experiments.captureExceptions){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["w" /* captureException */])(_context21.t0);}// If an error happened here, it's likely that uploading the attachment
// failed, we'll can retry with the same events payload
if(!(retryConfig.count>=RETRY_MAX_COUNT)){_context21.next=20;break;}error=new Error("".concat(UNABLE_TO_SEND_REPLAY," - max retries exceeded"));try{// In case browsers don't allow this property to be writable
// @ts-expect-error This needs lib es2022 and newer
error.cause=_context21.t0;}catch(e){// nothing to do
}throw error;case 20:// will retry in intervals of 5, 10, 30
retryConfig.interval*=++retryConfig.count;return _context21.abrupt("return",new Promise(function(resolve,reject){setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee19(){return regeneratorRuntime.wrap(function _callee19$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.prev=0;_context20.next=3;return sendReplay(replayData,retryConfig);case 3:resolve(true);_context20.next=9;break;case 6:_context20.prev=6;_context20.t0=_context20["catch"](0);reject(_context20.t0);case 9:case"end":return _context20.stop();}}},_callee19,null,[[0,6]]);})),retryConfig.interval);}));case 22:case"end":return _context21.stop();}}},_callee20,null,[[4,10]]);}));return _sendReplay.apply(this,arguments);}var THROTTLED='__THROTTLED';var SKIPPED='__SKIPPED';/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */// eslint-disable-next-line @typescript-eslint/no-explicit-any
function throttle(fn,maxCount,durationSeconds){var counter=new Map();var _cleanup=function _cleanup(now){var threshold=now-durationSeconds;counter.forEach(function(_value,key){if(key<threshold){counter.delete(key);}});};var _getTotalCount=function _getTotalCount(){return _toConsumableArray(counter.values()).reduce(function(a,b){return a+b;},0);};var isThrottled=false;return function(){// Date in second-precision, which we use as basis for the throttling
var now=Math.floor(Date.now()/1000);// First, make sure to delete any old entries
_cleanup(now);// If already over limit, do nothing
if(_getTotalCount()>=maxCount){var wasThrottled=isThrottled;isThrottled=true;return wasThrottled?SKIPPED:THROTTLED;}isThrottled=false;var count=counter.get(now)||0;counter.set(now,count+1);return fn.apply(void 0,arguments);};}/* eslint-disable max-lines */// TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */var ReplayContainer=/*#__PURE__*/function(){/**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   *//**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   *//**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   *//**
   * Options to pass to `rrweb.record()`
   *//**
   * Timestamp of the last user activity. This lives across sessions.
   *//**
   * Is the integration currently active?
   *//**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   *//**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   *//**
   * Function to stop recording
   *//**
   * Internal use for canvas recording options
   */function ReplayContainer(_ref42){var _this20=this;var options=_ref42.options,recordingOptions=_ref42.recordingOptions;_classCallCheck(this,ReplayContainer);ReplayContainer.prototype.__init.call(this);ReplayContainer.prototype.__init2.call(this);ReplayContainer.prototype.__init3.call(this);ReplayContainer.prototype.__init4.call(this);ReplayContainer.prototype.__init5.call(this);ReplayContainer.prototype.__init6.call(this);this.eventBuffer=null;this.performanceEntries=[];this.replayPerformanceEntries=[];this.recordingMode='session';this.timeouts={sessionIdlePause:SESSION_IDLE_PAUSE_DURATION,sessionIdleExpire:SESSION_IDLE_EXPIRE_DURATION};this._lastActivity=Date.now();this._isEnabled=false;this._isPaused=false;this._hasInitializedCoreListeners=false;this._context={errorIds:new Set(),traceIds:new Set(),urls:[],initialTimestamp:Date.now(),initialUrl:''};this._recordingOptions=recordingOptions;this._options=options;this._debouncedFlush=debounce(function(){return _this20._flush();},this._options.flushMinDelay,{maxWait:this._options.flushMaxDelay});this._throttledAddEvent=throttle(function(event,isCheckout){return addEvent(_this20,event,isCheckout);},// Max 300 events...
300,// ... per 5s
5);var _this$getOptions=this.getOptions(),slowClickTimeout=_this$getOptions.slowClickTimeout,slowClickIgnoreSelectors=_this$getOptions.slowClickIgnoreSelectors;var slowClickConfig=slowClickTimeout?{threshold:Math.min(SLOW_CLICK_THRESHOLD,slowClickTimeout),timeout:slowClickTimeout,scrollTimeout:SLOW_CLICK_SCROLL_TIMEOUT,ignoreSelector:slowClickIgnoreSelectors?slowClickIgnoreSelectors.join(','):''}:undefined;if(slowClickConfig){this.clickDetector=new ClickDetector(this,slowClickConfig);}}/** Get the event context. */_createClass(ReplayContainer,[{key:"getContext",value:function getContext(){return this._context;}/** If recording is currently enabled. */},{key:"isEnabled",value:function isEnabled(){return this._isEnabled;}/** If recording is currently paused. */},{key:"isPaused",value:function isPaused(){return this._isPaused;}/**
   * Determine if canvas recording is enabled
   */},{key:"isRecordingCanvas",value:function isRecordingCanvas(){return Boolean(this._canvas);}/** Get the replay integration options. */},{key:"getOptions",value:function getOptions(){return this._options;}/**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */},{key:"initializeSampling",value:function initializeSampling(previousSessionId){var _this$_options=this._options,errorSampleRate=_this$_options.errorSampleRate,sessionSampleRate=_this$_options.sessionSampleRate;// If neither sample rate is > 0, then do nothing - user will need to call one of
// `start()` or `startBuffering` themselves.
if(errorSampleRate<=0&&sessionSampleRate<=0){return;}// Otherwise if there is _any_ sample rate set, try to load an existing
// session, or create a new one.
this._initializeSessionForSampling(previousSessionId);if(!this.session){// This should not happen, something wrong has occurred
this._handleException(new Error('Unable to initialize and create session'));return;}if(this.session.sampled===false){// This should only occur if `errorSampleRate` is 0 and was unsampled for
// session-based replay. In this case there is nothing to do.
return;}// If segmentId > 0, it means we've previously already captured this session
// In this case, we still want to continue in `session` recording mode
this.recordingMode=this.session.sampled==='buffer'&&this.session.segmentId===0?'buffer':'session';logInfoNextTick("[Replay] Starting replay in ".concat(this.recordingMode," mode"),this._options._experiments.traceInternals);this._initializeRecording();}/**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */},{key:"start",value:function start(){if(this._isEnabled&&this.recordingMode==='session'){throw new Error('Replay recording is already in progress');}if(this._isEnabled&&this.recordingMode==='buffer'){throw new Error('Replay buffering is in progress, call `flush()` to save the replay');}logInfoNextTick('[Replay] Starting replay in session mode',this._options._experiments.traceInternals);// Required as user activity is initially set in
// constructor, so if `start()` is called after
// session idle expiration, a replay will not be
// created due to an idle timeout.
this._updateUserActivity();var session=loadOrCreateSession({maxReplayDuration:this._options.maxReplayDuration,sessionIdleExpire:this.timeouts.sessionIdleExpire,traceInternals:this._options._experiments.traceInternals},{stickySession:this._options.stickySession,// This is intentional: create a new session-based replay when calling `start()`
sessionSampleRate:1,allowBuffering:false});this.session=session;this._initializeRecording();}/**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */},{key:"startBuffering",value:function startBuffering(){if(this._isEnabled){throw new Error('Replay recording is already in progress');}logInfoNextTick('[Replay] Starting replay in buffer mode',this._options._experiments.traceInternals);var session=loadOrCreateSession({sessionIdleExpire:this.timeouts.sessionIdleExpire,maxReplayDuration:this._options.maxReplayDuration,traceInternals:this._options._experiments.traceInternals},{stickySession:this._options.stickySession,sessionSampleRate:0,allowBuffering:true});this.session=session;this.recordingMode='buffer';this._initializeRecording();}/**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */},{key:"startRecording",value:function startRecording(){try{var canvasOptions=this._canvas;this._stopRecording=record(_objectSpread({},this._recordingOptions,{},this.recordingMode==='buffer'&&{checkoutEveryNms:BUFFER_CHECKOUT_TIME},{emit:getHandleRecordingEmit(this),onMutation:this._onMutationHandler},canvasOptions?{recordCanvas:canvasOptions.recordCanvas,getCanvasManager:canvasOptions.getCanvasManager,sampling:canvasOptions.sampling,dataURLOptions:canvasOptions.dataURLOptions}:{}));}catch(err){this._handleException(err);}}/**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */},{key:"stopRecording",value:function stopRecording(){try{if(this._stopRecording){this._stopRecording();this._stopRecording=undefined;}return true;}catch(err){this._handleException(err);return false;}}/**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */},{key:"stop",value:function(){var _stop=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(){var _ref43,_ref43$forceFlush,forceFlush,reason,_args6=arguments;return regeneratorRuntime.wrap(function _callee6$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_ref43=_args6.length>0&&_args6[0]!==undefined?_args6[0]:{},_ref43$forceFlush=_ref43.forceFlush,forceFlush=_ref43$forceFlush===void 0?false:_ref43$forceFlush,reason=_ref43.reason;if(this._isEnabled){_context7.next=3;break;}return _context7.abrupt("return");case 3:// We can't move `_isEnabled` after awaiting a flush, otherwise we can
// enter into an infinite loop when `stop()` is called while flushing.
this._isEnabled=false;_context7.prev=4;logInfo("[Replay] Stopping Replay".concat(reason?" triggered by ".concat(reason):''),this._options._experiments.traceInternals);this._removeListeners();this.stopRecording();this._debouncedFlush.cancel();// See comment above re: `_isEnabled`, we "force" a flush, ignoring the
// `_isEnabled` state of the plugin since it was disabled above.
if(!forceFlush){_context7.next=12;break;}_context7.next=12;return this._flush({force:true});case 12:// After flush, destroy event buffer
this.eventBuffer&&this.eventBuffer.destroy();this.eventBuffer=null;// Clear session from session storage, note this means if a new session
// is started after, it will not have `previousSessionId`
clearSession(this);_context7.next=20;break;case 17:_context7.prev=17;_context7.t0=_context7["catch"](4);this._handleException(_context7.t0);case 20:case"end":return _context7.stop();}}},_callee6,this,[[4,17]]);}));function stop(){return _stop.apply(this,arguments);}return stop;}()/**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */},{key:"pause",value:function pause(){if(this._isPaused){return;}this._isPaused=true;this.stopRecording();logInfo('[Replay] Pausing replay',this._options._experiments.traceInternals);}/**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */},{key:"resume",value:function resume(){if(!this._isPaused||!this._checkSession()){return;}this._isPaused=false;this.startRecording();logInfo('[Replay] Resuming replay',this._options._experiments.traceInternals);}/**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */},{key:"sendBufferedReplayOrFlush",value:function(){var _sendBufferedReplayOrFlush=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(){var _ref44,_ref44$continueRecord,continueRecording,activityTime,hasStoppedRecording,_args7=arguments;return regeneratorRuntime.wrap(function _callee7$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_ref44=_args7.length>0&&_args7[0]!==undefined?_args7[0]:{},_ref44$continueRecord=_ref44.continueRecording,continueRecording=_ref44$continueRecord===void 0?true:_ref44$continueRecord;if(!(this.recordingMode==='session')){_context8.next=3;break;}return _context8.abrupt("return",this.flushImmediate());case 3:activityTime=Date.now();logInfo('[Replay] Converting buffer to session',this._options._experiments.traceInternals);// Allow flush to complete before resuming as a session recording, otherwise
// the checkout from `startRecording` may be included in the payload.
// Prefer to keep the error replay as a separate (and smaller) segment
// than the session replay.
_context8.next=7;return this.flushImmediate();case 7:hasStoppedRecording=this.stopRecording();if(!(!continueRecording||!hasStoppedRecording)){_context8.next=10;break;}return _context8.abrupt("return");case 10:if(!(this.recordingMode==='session')){_context8.next=12;break;}return _context8.abrupt("return");case 12:// Re-start recording in session-mode
this.recordingMode='session';// Once this session ends, we do not want to refresh it
if(this.session){this._updateUserActivity(activityTime);this._updateSessionActivity(activityTime);this._maybeSaveSession();}this.startRecording();case 15:case"end":return _context8.stop();}}},_callee7,this);}));function sendBufferedReplayOrFlush(){return _sendBufferedReplayOrFlush.apply(this,arguments);}return sendBufferedReplayOrFlush;}()/**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */},{key:"addUpdate",value:function addUpdate(cb){// We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
var cbResult=cb();// If this option is turned on then we will only want to call `flush`
// explicitly
if(this.recordingMode==='buffer'){return;}// If callback is true, we do not want to continue with flushing -- the
// caller will need to handle it.
if(cbResult===true){return;}// addUpdate is called quite frequently - use _debouncedFlush so that it
// respects the flush delays and does not flush immediately
this._debouncedFlush();}/**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */},{key:"triggerUserActivity",value:function triggerUserActivity(){this._updateUserActivity();// This case means that recording was once stopped due to inactivity.
// Ensure that recording is resumed.
if(!this._stopRecording){// Create a new session, otherwise when the user action is flushed, it
// will get rejected due to an expired session.
if(!this._checkSession()){return;}// Note: This will cause a new DOM checkout
this.resume();return;}// Otherwise... recording was never suspended, continue as normalish
this.checkAndHandleExpiredSession();this._updateSessionActivity();}/**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */},{key:"updateUserActivity",value:function updateUserActivity(){this._updateUserActivity();this._updateSessionActivity();}/**
   * Only flush if `this.recordingMode === 'session'`
   */},{key:"conditionalFlush",value:function conditionalFlush(){if(this.recordingMode==='buffer'){return Promise.resolve();}return this.flushImmediate();}/**
   * Flush using debounce flush
   */},{key:"flush",value:function flush(){return this._debouncedFlush();}/**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */},{key:"flushImmediate",value:function flushImmediate(){this._debouncedFlush();// `.flush` is provided by the debounced function, analogously to lodash.debounce
return this._debouncedFlush.flush();}/**
   * Cancels queued up flushes.
   */},{key:"cancelFlush",value:function cancelFlush(){this._debouncedFlush.cancel();}/** Get the current sesion (=replay) ID */},{key:"getSessionId",value:function getSessionId(){return this.session&&this.session.id;}/**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */},{key:"checkAndHandleExpiredSession",value:function checkAndHandleExpiredSession(){// Prevent starting a new session if the last user activity is older than
// SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
// session+recording. This creates noisy replays that do not have much
// content in them.
if(this._lastActivity&&isExpired(this._lastActivity,this.timeouts.sessionIdlePause)&&this.session&&this.session.sampled==='session'){// Pause recording only for session-based replays. Otherwise, resuming
// will create a new replay and will conflict with users who only choose
// to record error-based replays only. (e.g. the resumed replay will not
// contain a reference to an error)
this.pause();return;}// --- There is recent user activity --- //
// This will create a new session if expired, based on expiry length
if(!this._checkSession()){// Check session handles the refreshing itself
return false;}return true;}/**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */},{key:"setInitialState",value:function setInitialState(){var urlPath="".concat(WINDOW.location.pathname).concat(WINDOW.location.hash).concat(WINDOW.location.search);var url="".concat(WINDOW.location.origin).concat(urlPath);this.performanceEntries=[];this.replayPerformanceEntries=[];// Reset _context as well
this._clearContext();this._context.initialUrl=url;this._context.initialTimestamp=Date.now();this._context.urls.push(url);}/**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */},{key:"throttledAddEvent",value:function throttledAddEvent(event,isCheckout){var _this21=this;var res=this._throttledAddEvent(event,isCheckout);// If this is THROTTLED, it means we have throttled the event for the first time
// In this case, we want to add a breadcrumb indicating that something was skipped
if(res===THROTTLED){var breadcrumb=createBreadcrumb({category:'replay.throttled'});this.addUpdate(function(){// Return `false` if the event _was_ added, as that means we schedule a flush
return!addEventSync(_this21,{type:ReplayEventTypeCustom,timestamp:breadcrumb.timestamp||0,data:{tag:'breadcrumb',payload:breadcrumb,metric:true}});});}return res;}/**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */},{key:"getCurrentRoute",value:function getCurrentRoute(){// eslint-disable-next-line deprecation/deprecation
var lastTransaction=this.lastTransaction||Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["P" /* getCurrentScope */])().getTransaction();var attributes=lastTransaction&&Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_24" /* spanToJSON */])(lastTransaction).data||{};var source=attributes[__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */]];if(!lastTransaction||!source||!['route','custom'].includes(source)){return undefined;}return Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_24" /* spanToJSON */])(lastTransaction).description;}/**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */},{key:"_initializeRecording",value:function _initializeRecording(){this.setInitialState();// this method is generally called on page load or manually - in both cases
// we should treat it as an activity
this._updateSessionActivity();this.eventBuffer=createEventBuffer({useCompression:this._options.useCompression,workerUrl:this._options.workerUrl});this._removeListeners();this._addListeners();// Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
this._isEnabled=true;this._isPaused=false;this.startRecording();}/** A wrapper to conditionally capture exceptions. */},{key:"_handleException",value:function _handleException(error){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('[Replay]',error);if(DEBUG_BUILD&&this._options._experiments&&this._options._experiments.captureExceptions){Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["w" /* captureException */])(error);}}/**
   * Loads (or refreshes) the current session.
   */},{key:"_initializeSessionForSampling",value:function _initializeSessionForSampling(previousSessionId){// Whenever there is _any_ error sample rate, we always allow buffering
// Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
var allowBuffering=this._options.errorSampleRate>0;var session=loadOrCreateSession({sessionIdleExpire:this.timeouts.sessionIdleExpire,maxReplayDuration:this._options.maxReplayDuration,traceInternals:this._options._experiments.traceInternals,previousSessionId:previousSessionId},{stickySession:this._options.stickySession,sessionSampleRate:this._options.sessionSampleRate,allowBuffering:allowBuffering});this.session=session;}/**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */},{key:"_checkSession",value:function _checkSession(){// If there is no session yet, we do not want to refresh anything
// This should generally not happen, but to be safe....
if(!this.session){return false;}var currentSession=this.session;if(shouldRefreshSession(currentSession,{sessionIdleExpire:this.timeouts.sessionIdleExpire,maxReplayDuration:this._options.maxReplayDuration})){// This should never reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
this._refreshSession(currentSession);return false;}return true;}/**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */},{key:"_refreshSession",value:function(){var _refreshSession2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(session){return regeneratorRuntime.wrap(function _callee8$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:if(this._isEnabled){_context9.next=2;break;}return _context9.abrupt("return");case 2:_context9.next=4;return this.stop({reason:'refresh session'});case 4:this.initializeSampling(session.id);case 5:case"end":return _context9.stop();}}},_callee8,this);}));function _refreshSession(_x22){return _refreshSession2.apply(this,arguments);}return _refreshSession;}()/**
   * Adds listeners to record events for the replay
   */},{key:"_addListeners",value:function _addListeners(){try{WINDOW.document.addEventListener('visibilitychange',this._handleVisibilityChange);WINDOW.addEventListener('blur',this._handleWindowBlur);WINDOW.addEventListener('focus',this._handleWindowFocus);WINDOW.addEventListener('keydown',this._handleKeyboardEvent);if(this.clickDetector){this.clickDetector.addListeners();}// There is no way to remove these listeners, so ensure they are only added once
if(!this._hasInitializedCoreListeners){addGlobalListeners(this);this._hasInitializedCoreListeners=true;}}catch(err){this._handleException(err);}this._performanceCleanupCallback=setupPerformanceObserver(this);}/**
   * Cleans up listeners that were created in `_addListeners`
   */},{key:"_removeListeners",value:function _removeListeners(){try{WINDOW.document.removeEventListener('visibilitychange',this._handleVisibilityChange);WINDOW.removeEventListener('blur',this._handleWindowBlur);WINDOW.removeEventListener('focus',this._handleWindowFocus);WINDOW.removeEventListener('keydown',this._handleKeyboardEvent);if(this.clickDetector){this.clickDetector.removeListeners();}if(this._performanceCleanupCallback){this._performanceCleanupCallback();}}catch(err){this._handleException(err);}}/**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */},{key:"__init",value:function __init(){var _this22=this;this._handleVisibilityChange=function(){if(WINDOW.document.visibilityState==='visible'){_this22._doChangeToForegroundTasks();}else{_this22._doChangeToBackgroundTasks();}};}/**
   * Handle when page is blurred
   */},{key:"__init2",value:function __init2(){var _this23=this;this._handleWindowBlur=function(){var breadcrumb=createBreadcrumb({category:'ui.blur'});// Do not count blur as a user action -- it's part of the process of them
// leaving the page
_this23._doChangeToBackgroundTasks(breadcrumb);};}/**
   * Handle when page is focused
   */},{key:"__init3",value:function __init3(){var _this24=this;this._handleWindowFocus=function(){var breadcrumb=createBreadcrumb({category:'ui.focus'});// Do not count focus as a user action -- instead wait until they focus and
// interactive with page
_this24._doChangeToForegroundTasks(breadcrumb);};}/** Ensure page remains active when a key is pressed. */},{key:"__init4",value:function __init4(){var _this25=this;this._handleKeyboardEvent=function(event){handleKeyboardEvent(_this25,event);};}/**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */},{key:"_doChangeToBackgroundTasks",value:function _doChangeToBackgroundTasks(breadcrumb){if(!this.session){return;}var expired=isSessionExpired(this.session,{maxReplayDuration:this._options.maxReplayDuration,sessionIdleExpire:this.timeouts.sessionIdleExpire});if(expired){return;}if(breadcrumb){this._createCustomBreadcrumb(breadcrumb);}// Send replay when the page/tab becomes hidden. There is no reason to send
// replay if it becomes visible, since no actions we care about were done
// while it was hidden
// This should never reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
void this.conditionalFlush();}/**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */},{key:"_doChangeToForegroundTasks",value:function _doChangeToForegroundTasks(breadcrumb){if(!this.session){return;}var isSessionActive=this.checkAndHandleExpiredSession();if(!isSessionActive){// If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
// ms, we will re-use the existing session, otherwise create a new
// session
logInfo('[Replay] Document has become active, but session has expired');return;}if(breadcrumb){this._createCustomBreadcrumb(breadcrumb);}}/**
   * Update user activity (across session lifespans)
   */},{key:"_updateUserActivity",value:function _updateUserActivity(){var _lastActivity=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Date.now();this._lastActivity=_lastActivity;}/**
   * Updates the session's last activity timestamp
   */},{key:"_updateSessionActivity",value:function _updateSessionActivity(){var _lastActivity=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Date.now();if(this.session){this.session.lastActivity=_lastActivity;this._maybeSaveSession();}}/**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */},{key:"_createCustomBreadcrumb",value:function _createCustomBreadcrumb(breadcrumb){var _this26=this;this.addUpdate(function(){// This should never reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
_this26.throttledAddEvent({type:EventType.Custom,timestamp:breadcrumb.timestamp||0,data:{tag:'breadcrumb',payload:breadcrumb}});});}/**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */},{key:"_addPerformanceEntries",value:function _addPerformanceEntries(){var performanceEntries=createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);this.performanceEntries=[];this.replayPerformanceEntries=[];return Promise.all(createPerformanceSpans(this,performanceEntries));}/**
   * Clear _context
   */},{key:"_clearContext",value:function _clearContext(){// XXX: `initialTimestamp` and `initialUrl` do not get cleared
this._context.errorIds.clear();this._context.traceIds.clear();this._context.urls=[];}/** Update the initial timestamp based on the buffer content. */},{key:"_updateInitialTimestampFromEventBuffer",value:function _updateInitialTimestampFromEventBuffer(){var session=this.session,eventBuffer=this.eventBuffer;if(!session||!eventBuffer){return;}// we only ever update this on the initial segment
if(session.segmentId){return;}var earliestEvent=eventBuffer.getEarliestTimestamp();if(earliestEvent&&earliestEvent<this._context.initialTimestamp){this._context.initialTimestamp=earliestEvent;}}/**
   * Return and clear _context
   */},{key:"_popEventContext",value:function _popEventContext(){var _context={initialTimestamp:this._context.initialTimestamp,initialUrl:this._context.initialUrl,errorIds:Array.from(this._context.errorIds),traceIds:Array.from(this._context.traceIds),urls:this._context.urls};this._clearContext();return _context;}/**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */},{key:"_runFlush",value:function(){var _runFlush2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(){var replayId,timestamp,eventContext,segmentId,recordingData,client;return regeneratorRuntime.wrap(function _callee9$(_context0){while(1){switch(_context0.prev=_context0.next){case 0:replayId=this.getSessionId();if(!(!this.session||!this.eventBuffer||!replayId)){_context0.next=4;break;}DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('[Replay] No session or eventBuffer found to flush.');return _context0.abrupt("return");case 4:_context0.next=6;return this._addPerformanceEntries();case 6:if(!(!this.eventBuffer||!this.eventBuffer.hasEvents)){_context0.next=8;break;}return _context0.abrupt("return");case 8:_context0.next=10;return addMemoryEntry(this);case 10:if(this.eventBuffer){_context0.next=12;break;}return _context0.abrupt("return");case 12:if(!(replayId!==this.getSessionId())){_context0.next=14;break;}return _context0.abrupt("return");case 14:_context0.prev=14;// This uses the data from the eventBuffer, so we need to call this before `finish()
this._updateInitialTimestampFromEventBuffer();timestamp=Date.now();// Check total duration again, to avoid sending outdated stuff
// We leave 30s wiggle room to accomodate late flushing etc.
// This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
if(!(timestamp-this._context.initialTimestamp>this._options.maxReplayDuration+30000)){_context0.next=19;break;}throw new Error('Session is too long, not sending replay');case 19:eventContext=this._popEventContext();// Always increment segmentId regardless of outcome of sending replay
segmentId=this.session.segmentId++;this._maybeSaveSession();// Note this empties the event buffer regardless of outcome of sending replay
_context0.next=24;return this.eventBuffer.finish();case 24:recordingData=_context0.sent;_context0.next=27;return sendReplay({replayId:replayId,recordingData:recordingData,segmentId:segmentId,eventContext:eventContext,session:this.session,options:this.getOptions(),timestamp:timestamp});case 27:_context0.next=35;break;case 29:_context0.prev=29;_context0.t0=_context0["catch"](14);this._handleException(_context0.t0);// This means we retried 3 times and all of them failed,
// or we ran into a problem we don't want to retry, like rate limiting.
// In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
// This should never reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
this.stop({reason:'sendReplay'});client=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["N" /* getClient */])();if(client){client.recordDroppedEvent('send_error','replay');}case 35:case"end":return _context0.stop();}}},_callee9,this,[[14,29]]);}));function _runFlush(){return _runFlush2.apply(this,arguments);}return _runFlush;}()/**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */},{key:"__init5",value:function __init5(){var _this27=this;this._flush=/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0(){var _ref46,_ref46$force,force,start,now,duration,tooShort,tooLong,eventBuffer,_args0=arguments;return regeneratorRuntime.wrap(function _callee0$(_context1){while(1){switch(_context1.prev=_context1.next){case 0:_ref46=_args0.length>0&&_args0[0]!==undefined?_args0[0]:{},_ref46$force=_ref46.force,force=_ref46$force===void 0?false:_ref46$force;if(!(!_this27._isEnabled&&!force)){_context1.next=3;break;}return _context1.abrupt("return");case 3:if(_this27.checkAndHandleExpiredSession()){_context1.next=6;break;}DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('[Replay] Attempting to finish replay event after session expired.');return _context1.abrupt("return");case 6:if(_this27.session){_context1.next=8;break;}return _context1.abrupt("return");case 8:start=_this27.session.started;now=Date.now();duration=now-start;// A flush is about to happen, cancel any queued flushes
_this27._debouncedFlush.cancel();// If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
// This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
tooShort=duration<_this27._options.minReplayDuration;tooLong=duration>_this27._options.maxReplayDuration+5000;if(!(tooShort||tooLong)){_context1.next=18;break;}logInfo("[Replay] Session duration (".concat(Math.floor(duration/1000),"s) is too ").concat(tooShort?'short':'long',", not sending replay."),_this27._options._experiments.traceInternals);if(tooShort){_this27._debouncedFlush();}return _context1.abrupt("return");case 18:eventBuffer=_this27.eventBuffer;if(eventBuffer&&_this27.session.segmentId===0&&!eventBuffer.hasCheckout){logInfo('[Replay] Flushing initial segment without checkout.',_this27._options._experiments.traceInternals);// TODO FN: Evaluate if we want to stop here, or remove this again?
}// this._flushLock acts as a lock so that future calls to `_flush()`
// will be blocked until this promise resolves
if(_this27._flushLock){_context1.next=26;break;}_this27._flushLock=_this27._runFlush();_context1.next=24;return _this27._flushLock;case 24:_this27._flushLock=undefined;return _context1.abrupt("return");case 26:_context1.prev=26;_context1.next=29;return _this27._flushLock;case 29:_context1.next=34;break;case 31:_context1.prev=31;_context1.t0=_context1["catch"](26);DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error(_context1.t0);case 34:_context1.prev=34;_this27._debouncedFlush();return _context1.finish(34);case 37:case"end":return _context1.stop();}}},_callee0,null,[[26,31,34,37]]);}));}/** Save the session, if it is sticky */},{key:"_maybeSaveSession",value:function _maybeSaveSession(){if(this.session&&this._options.stickySession){saveSession(this.session);}}/** Handler for rrweb.record.onMutation */},{key:"__init6",value:function __init6(){var _this28=this;this._onMutationHandler=function(mutations){var count=mutations.length;var mutationLimit=_this28._options.mutationLimit;var mutationBreadcrumbLimit=_this28._options.mutationBreadcrumbLimit;var overMutationLimit=mutationLimit&&count>mutationLimit;// Create a breadcrumb if a lot of mutations happen at the same time
// We can show this in the UI as an information with potential performance improvements
if(count>mutationBreadcrumbLimit||overMutationLimit){var breadcrumb=createBreadcrumb({category:'replay.mutations',data:{count:count,limit:overMutationLimit}});_this28._createCustomBreadcrumb(breadcrumb);}// Stop replay if over the mutation limit
if(overMutationLimit){// This should never reject
// eslint-disable-next-line @typescript-eslint/no-floating-promises
_this28.stop({reason:'mutationLimit',forceFlush:_this28.recordingMode==='session'});return false;}// `true` means we use the regular mutation handling by rrweb
return true;};}}]);return ReplayContainer;}();function getOption(selectors,defaultSelectors,deprecatedClassOption,deprecatedSelectorOption){var deprecatedSelectors=typeof deprecatedSelectorOption==='string'?deprecatedSelectorOption.split(','):[];var allSelectors=[].concat(_toConsumableArray(selectors),_toConsumableArray(deprecatedSelectors),_toConsumableArray(defaultSelectors));// @deprecated
if(typeof deprecatedClassOption!=='undefined'){// NOTE: No support for RegExp
if(typeof deprecatedClassOption==='string'){allSelectors.push(".".concat(deprecatedClassOption));}Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["A" /* consoleSandbox */])(function(){// eslint-disable-next-line no-console
console.warn('[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.');});}return allSelectors.join(',');}/**
 * Returns privacy related configuration for use in rrweb
 */function getPrivacyOptions(_ref47){var mask=_ref47.mask,unmask=_ref47.unmask,block=_ref47.block,unblock=_ref47.unblock,ignore=_ref47.ignore,blockClass=_ref47.blockClass,blockSelector=_ref47.blockSelector,maskTextClass=_ref47.maskTextClass,maskTextSelector=_ref47.maskTextSelector,ignoreClass=_ref47.ignoreClass;var defaultBlockedElements=['base[href="/"]'];var maskSelector=getOption(mask,['.sentry-mask','[data-sentry-mask]'],maskTextClass,maskTextSelector);var unmaskSelector=getOption(unmask,['.sentry-unmask','[data-sentry-unmask]']);var options={// We are making the decision to make text and input selectors the same
maskTextSelector:maskSelector,unmaskTextSelector:unmaskSelector,blockSelector:getOption(block,['.sentry-block','[data-sentry-block]'].concat(defaultBlockedElements),blockClass,blockSelector),unblockSelector:getOption(unblock,['.sentry-unblock','[data-sentry-unblock]']),ignoreSelector:getOption(ignore,['.sentry-ignore','[data-sentry-ignore]','input[type="file"]'],ignoreClass)};if(blockClass instanceof RegExp){options.blockClass=blockClass;}if(maskTextClass instanceof RegExp){options.maskTextClass=maskTextClass;}return options;}/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */function maskAttribute(_ref48){var el=_ref48.el,key=_ref48.key,maskAttributes=_ref48.maskAttributes,maskAllText=_ref48.maskAllText,privacyOptions=_ref48.privacyOptions,value=_ref48.value;// We only mask attributes if `maskAllText` is true
if(!maskAllText){return value;}// unmaskTextSelector takes precendence
if(privacyOptions.unmaskTextSelector&&el.matches(privacyOptions.unmaskTextSelector)){return value;}if(maskAttributes.includes(key)||// Need to mask `value` attribute for `<input>` if it's a button-like
// type
key==='value'&&el.tagName==='INPUT'&&['submit','button'].includes(el.getAttribute('type')||'')){return value.replace(/[\S]/g,'*');}return value;}var MEDIA_SELECTORS='img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';var DEFAULT_NETWORK_HEADERS=['content-length','content-type','accept'];var _initialized=false;var replayIntegration$1=function replayIntegration$1(options){// eslint-disable-next-line deprecation/deprecation
return new Replay$1(options);};/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */var Replay$1=/*#__PURE__*/function(){_createClass(Replay$1,null,[{key:"__initStatic",/**
   * @inheritDoc
   */value:function __initStatic(){this.id='Replay';}/**
   * @inheritDoc
   *//**
   * Options to pass to `rrweb.record()`
   *//**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */}]);function Replay$1(){var _ref49=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},_ref49$flushMinDelay=_ref49.flushMinDelay,flushMinDelay=_ref49$flushMinDelay===void 0?DEFAULT_FLUSH_MIN_DELAY:_ref49$flushMinDelay,_ref49$flushMaxDelay=_ref49.flushMaxDelay,flushMaxDelay=_ref49$flushMaxDelay===void 0?DEFAULT_FLUSH_MAX_DELAY:_ref49$flushMaxDelay,_ref49$minReplayDurat=_ref49.minReplayDuration,minReplayDuration=_ref49$minReplayDurat===void 0?MIN_REPLAY_DURATION:_ref49$minReplayDurat,_ref49$maxReplayDurat=_ref49.maxReplayDuration,maxReplayDuration=_ref49$maxReplayDurat===void 0?MAX_REPLAY_DURATION:_ref49$maxReplayDurat,_ref49$stickySession=_ref49.stickySession,stickySession=_ref49$stickySession===void 0?true:_ref49$stickySession,_ref49$useCompression=_ref49.useCompression,useCompression=_ref49$useCompression===void 0?true:_ref49$useCompression,workerUrl=_ref49.workerUrl,_ref49$_experiments=_ref49._experiments,_experiments=_ref49$_experiments===void 0?{}:_ref49$_experiments,sessionSampleRate=_ref49.sessionSampleRate,errorSampleRate=_ref49.errorSampleRate,_ref49$maskAllText=_ref49.maskAllText,maskAllText=_ref49$maskAllText===void 0?true:_ref49$maskAllText,_ref49$maskAllInputs=_ref49.maskAllInputs,maskAllInputs=_ref49$maskAllInputs===void 0?true:_ref49$maskAllInputs,_ref49$blockAllMedia=_ref49.blockAllMedia,blockAllMedia=_ref49$blockAllMedia===void 0?true:_ref49$blockAllMedia,_ref49$mutationBreadc=_ref49.mutationBreadcrumbLimit,mutationBreadcrumbLimit=_ref49$mutationBreadc===void 0?750:_ref49$mutationBreadc,_ref49$mutationLimit=_ref49.mutationLimit,mutationLimit=_ref49$mutationLimit===void 0?10000:_ref49$mutationLimit,_ref49$slowClickTimeo=_ref49.slowClickTimeout,slowClickTimeout=_ref49$slowClickTimeo===void 0?7000:_ref49$slowClickTimeo,_ref49$slowClickIgnor=_ref49.slowClickIgnoreSelectors,slowClickIgnoreSelectors=_ref49$slowClickIgnor===void 0?[]:_ref49$slowClickIgnor,_ref49$networkDetailA=_ref49.networkDetailAllowUrls,networkDetailAllowUrls=_ref49$networkDetailA===void 0?[]:_ref49$networkDetailA,_ref49$networkDetailD=_ref49.networkDetailDenyUrls,networkDetailDenyUrls=_ref49$networkDetailD===void 0?[]:_ref49$networkDetailD,_ref49$networkCapture=_ref49.networkCaptureBodies,networkCaptureBodies=_ref49$networkCapture===void 0?true:_ref49$networkCapture,_ref49$networkRequest=_ref49.networkRequestHeaders,networkRequestHeaders=_ref49$networkRequest===void 0?[]:_ref49$networkRequest,_ref49$networkRespons=_ref49.networkResponseHeaders,networkResponseHeaders=_ref49$networkRespons===void 0?[]:_ref49$networkRespons,_ref49$mask=_ref49.mask,mask=_ref49$mask===void 0?[]:_ref49$mask,_ref49$maskAttributes=_ref49.maskAttributes,maskAttributes=_ref49$maskAttributes===void 0?['title','placeholder']:_ref49$maskAttributes,_ref49$unmask=_ref49.unmask,unmask=_ref49$unmask===void 0?[]:_ref49$unmask,_ref49$block=_ref49.block,block=_ref49$block===void 0?[]:_ref49$block,_ref49$unblock=_ref49.unblock,unblock=_ref49$unblock===void 0?[]:_ref49$unblock,_ref49$ignore=_ref49.ignore,ignore=_ref49$ignore===void 0?[]:_ref49$ignore,maskFn=_ref49.maskFn,beforeAddRecordingEvent=_ref49.beforeAddRecordingEvent,beforeErrorSampling=_ref49.beforeErrorSampling,blockClass=_ref49.blockClass,blockSelector=_ref49.blockSelector,maskInputOptions=_ref49.maskInputOptions,maskTextClass=_ref49.maskTextClass,maskTextSelector=_ref49.maskTextSelector,ignoreClass=_ref49.ignoreClass;_classCallCheck(this,Replay$1);// eslint-disable-next-line deprecation/deprecation
this.name=Replay$1.id;var privacyOptions=getPrivacyOptions({mask:mask,unmask:unmask,block:block,unblock:unblock,ignore:ignore,blockClass:blockClass,blockSelector:blockSelector,maskTextClass:maskTextClass,maskTextSelector:maskTextSelector,ignoreClass:ignoreClass});this._recordingOptions=_objectSpread({maskAllInputs:maskAllInputs,maskAllText:maskAllText,maskInputOptions:_objectSpread({},maskInputOptions||{},{password:true}),maskTextFn:maskFn,maskInputFn:maskFn,maskAttributeFn:function maskAttributeFn(key,value,el){return maskAttribute({maskAttributes:maskAttributes,maskAllText:maskAllText,privacyOptions:privacyOptions,key:key,value:value,el:el});}},privacyOptions,{// Our defaults
slimDOMOptions:'all',inlineStylesheet:true,// Disable inline images as it will increase segment/replay size
inlineImages:false,// collect fonts, but be aware that `sentry.io` needs to be an allowed
// origin for playback
collectFonts:true,errorHandler:function errorHandler(err){try{err.__rrweb__=true;}catch(error){// ignore errors here
// this can happen if the error is frozen or does not allow mutation for other reasons
}}});this._initialOptions={flushMinDelay:flushMinDelay,flushMaxDelay:flushMaxDelay,minReplayDuration:Math.min(minReplayDuration,MIN_REPLAY_DURATION_LIMIT),maxReplayDuration:Math.min(maxReplayDuration,MAX_REPLAY_DURATION),stickySession:stickySession,sessionSampleRate:sessionSampleRate,errorSampleRate:errorSampleRate,useCompression:useCompression,workerUrl:workerUrl,blockAllMedia:blockAllMedia,maskAllInputs:maskAllInputs,maskAllText:maskAllText,mutationBreadcrumbLimit:mutationBreadcrumbLimit,mutationLimit:mutationLimit,slowClickTimeout:slowClickTimeout,slowClickIgnoreSelectors:slowClickIgnoreSelectors,networkDetailAllowUrls:networkDetailAllowUrls,networkDetailDenyUrls:networkDetailDenyUrls,networkCaptureBodies:networkCaptureBodies,networkRequestHeaders:_getMergedNetworkHeaders(networkRequestHeaders),networkResponseHeaders:_getMergedNetworkHeaders(networkResponseHeaders),beforeAddRecordingEvent:beforeAddRecordingEvent,beforeErrorSampling:beforeErrorSampling,_experiments:_experiments};if(typeof sessionSampleRate==='number'){// eslint-disable-next-line
console.warn("[Replay] You are passing `sessionSampleRate` to the Replay integration.\nThis option is deprecated and will be removed soon.\nInstead, configure `replaysSessionSampleRate` directly in the SDK init options, e.g.:\nSentry.init({ replaysSessionSampleRate: ".concat(sessionSampleRate," })"));this._initialOptions.sessionSampleRate=sessionSampleRate;}if(typeof errorSampleRate==='number'){// eslint-disable-next-line
console.warn("[Replay] You are passing `errorSampleRate` to the Replay integration.\nThis option is deprecated and will be removed soon.\nInstead, configure `replaysOnErrorSampleRate` directly in the SDK init options, e.g.:\nSentry.init({ replaysOnErrorSampleRate: ".concat(errorSampleRate," })"));this._initialOptions.errorSampleRate=errorSampleRate;}if(this._initialOptions.blockAllMedia){// `blockAllMedia` is a more user friendly option to configure blocking
// embedded media elements
this._recordingOptions.blockSelector=!this._recordingOptions.blockSelector?MEDIA_SELECTORS:"".concat(this._recordingOptions.blockSelector,",").concat(MEDIA_SELECTORS);}if(this._isInitialized&&Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_8" /* isBrowser */])()){throw new Error('Multiple Sentry Session Replay instances are not supported');}this._isInitialized=true;}/** If replay has already been initialized */_createClass(Replay$1,[{key:"setupOnce",/**
   * Setup and initialize replay container
   */value:function setupOnce(){var _this29=this;if(!Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_8" /* isBrowser */])()){return;}this._setup();// Once upon a time, we tried to create a transaction in `setupOnce` and it would
// potentially create a transaction before some native SDK integrations have run
// and applied their own global event processor. An example is:
// https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
//
// So we call `this._initialize()` in next event loop as a workaround to wait for other
// global event processors to finish. This is no longer needed, but keeping it
// here to avoid any future issues.
setTimeout(function(){return _this29._initialize();});}/**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */},{key:"start",value:function start(){if(!this._replay){return;}this._replay.start();}/**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */},{key:"startBuffering",value:function startBuffering(){if(!this._replay){return;}this._replay.startBuffering();}/**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */},{key:"stop",value:function stop(){if(!this._replay){return Promise.resolve();}return this._replay.stop({forceFlush:this._replay.recordingMode==='session'});}/**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */},{key:"flush",value:function flush(options){if(!this._replay||!this._replay.isEnabled()){return Promise.resolve();}return this._replay.sendBufferedReplayOrFlush(options);}/**
   * Get the current session ID.
   */},{key:"getReplayId",value:function getReplayId(){if(!this._replay||!this._replay.isEnabled()){return;}return this._replay.getSessionId();}/**
   * Initializes replay.
   */},{key:"_initialize",value:function _initialize(){if(!this._replay){return;}// We have to run this in _initialize, because this runs in setTimeout
// So when this runs all integrations have been added
// Before this, we cannot access integrations on the client,
// so we need to mutate the options here
this._maybeLoadFromReplayCanvasIntegration();this._replay.initializeSampling();}/** Setup the integration. */},{key:"_setup",value:function _setup(){// Client is not available in constructor, so we need to wait until setupOnce
var finalOptions=loadReplayOptionsFromClient(this._initialOptions);this._replay=new ReplayContainer({options:finalOptions,recordingOptions:this._recordingOptions});}/** Get canvas options from ReplayCanvas integration, if it is also added. */},{key:"_maybeLoadFromReplayCanvasIntegration",value:function _maybeLoadFromReplayCanvasIntegration(){// To save bundle size, we skip checking for stuff here
// and instead just try-catch everything - as generally this should all be defined
/* eslint-disable @typescript-eslint/no-non-null-assertion */try{var client=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["N" /* getClient */])();var canvasIntegration=client.getIntegrationByName('ReplayCanvas');if(!canvasIntegration){return;}this._replay['_canvas']=canvasIntegration.getOptions();}catch(e){// ignore errors here
}/* eslint-enable @typescript-eslint/no-non-null-assertion */}},{key:"_isInitialized",get:function get(){return _initialized;}/** Update _isInitialized */,set:function set(value){_initialized=value;}}]);return Replay$1;}();Replay$1.__initStatic();/** Parse Replay-related options from SDK options */function loadReplayOptionsFromClient(initialOptions){var client=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["N" /* getClient */])();var opt=client&&client.getOptions();var finalOptions=_objectSpread({sessionSampleRate:0,errorSampleRate:0},Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* dropUndefinedKeys */])(initialOptions));if(!opt){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["A" /* consoleSandbox */])(function(){// eslint-disable-next-line no-console
console.warn('SDK client is not available.');});return finalOptions;}if(initialOptions.sessionSampleRate==null&&// TODO remove once deprecated rates are removed
initialOptions.errorSampleRate==null&&// TODO remove once deprecated rates are removed
opt.replaysSessionSampleRate==null&&opt.replaysOnErrorSampleRate==null){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["A" /* consoleSandbox */])(function(){// eslint-disable-next-line no-console
console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');});}if(typeof opt.replaysSessionSampleRate==='number'){finalOptions.sessionSampleRate=opt.replaysSessionSampleRate;}if(typeof opt.replaysOnErrorSampleRate==='number'){finalOptions.errorSampleRate=opt.replaysOnErrorSampleRate;}return finalOptions;}function _getMergedNetworkHeaders(headers){return[].concat(DEFAULT_NETWORK_HEADERS,_toConsumableArray(headers.map(function(header){return header.toLowerCase();})));}/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */// eslint-disable-next-line deprecation/deprecation
function getReplay$1(){var client=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["N" /* getClient */])();return client&&client.getIntegrationByName&&client.getIntegrationByName('Replay');}// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */var getReplay=getReplay$1;/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */var replayIntegration=replayIntegration$1;/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */// eslint-disable-next-line deprecation/deprecation
var Replay=/*#__PURE__*/function(_Replay$){_inherits(Replay,_Replay$);function Replay(){_classCallCheck(this,Replay);return _possibleConstructorReturn(this,_getPrototypeOf(Replay).apply(this,arguments));}return Replay;}(Replay$1);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReplayCanvas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return replayCanvasIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(3);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _objectWithoutProperties(source,excluded){if(source==null)return{};var target=_objectWithoutPropertiesLoose(source,excluded);var key,i;if(Object.getOwnPropertySymbols){var sourceSymbolKeys=Object.getOwnPropertySymbols(source);for(i=0;i<sourceSymbolKeys.length;i++){key=sourceSymbolKeys[i];if(excluded.indexOf(key)>=0)continue;if(!Object.prototype.propertyIsEnumerable.call(source,key))continue;target[key]=source[key];}}return target;}function _objectWithoutPropertiesLoose(source,excluded){if(source==null)return{};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}var NodeType;(function(NodeType){NodeType[NodeType["Document"]=0]="Document";NodeType[NodeType["DocumentType"]=1]="DocumentType";NodeType[NodeType["Element"]=2]="Element";NodeType[NodeType["Text"]=3]="Text";NodeType[NodeType["CDATA"]=4]="CDATA";NodeType[NodeType["Comment"]=5]="Comment";})(NodeType||(NodeType={}));function elementClassMatchesRegex(el,regex){for(var eIndex=el.classList.length;eIndex--;){var className=el.classList[eIndex];if(regex.test(className)){return true;}}return false;}function distanceToMatch(node,matchPredicate){var limit=arguments.length>2&&arguments[2]!==undefined?arguments[2]:Infinity;var distance=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;if(!node)return-1;if(node.nodeType!==node.ELEMENT_NODE)return-1;if(distance>limit)return-1;if(matchPredicate(node))return distance;return distanceToMatch(node.parentNode,matchPredicate,limit,distance+1);}function createMatchPredicate(className,selector){return function(node){var el=node;if(el===null)return false;try{if(className){if(typeof className==='string'){if(el.matches(".".concat(className)))return true;}else if(elementClassMatchesRegex(el,className)){return true;}}if(selector&&el.matches(selector))return true;return false;}catch(e2){return false;}};}var DEPARTED_MIRROR_ACCESS_WARNING='Please stop import mirror directly. Instead of that,'+'\r\n'+'now you can use replayer.getMirror() to access the mirror instance of a replayer,'+'\r\n'+'or you can use record.mirror to access the mirror instance during recording.';var _mirror={map:{},getId:function getId(){console.error(DEPARTED_MIRROR_ACCESS_WARNING);return-1;},getNode:function getNode(){console.error(DEPARTED_MIRROR_ACCESS_WARNING);return null;},removeNodeFromMap:function removeNodeFromMap(){console.error(DEPARTED_MIRROR_ACCESS_WARNING);},has:function has(){console.error(DEPARTED_MIRROR_ACCESS_WARNING);return false;},reset:function reset(){console.error(DEPARTED_MIRROR_ACCESS_WARNING);}};if(typeof window!=='undefined'&&window.Proxy&&window.Reflect){_mirror=new Proxy(_mirror,{get:function get(target,prop,receiver){if(prop==='map'){console.error(DEPARTED_MIRROR_ACCESS_WARNING);}return Reflect.get(target,prop,receiver);}});}function hookSetter(target,key,d,isRevoked){var win=arguments.length>4&&arguments[4]!==undefined?arguments[4]:window;var original=win.Object.getOwnPropertyDescriptor(target,key);win.Object.defineProperty(target,key,isRevoked?d:{set:function set(value){var _this=this;setTimeout(function(){d.set.call(_this,value);},0);if(original&&original.set){original.set.call(this,value);}}});return function(){return hookSetter(target,key,original||{},true);};}function patch(source,name,replacement){try{if(!(name in source)){return function(){};}var original=source[name];var wrapped=replacement(original);if(typeof wrapped==='function'){wrapped.prototype=wrapped.prototype||{};Object.defineProperties(wrapped,{__rrweb_original__:{enumerable:false,value:original}});}source[name]=wrapped;return function(){source[name]=original;};}catch(e2){return function(){};}}if(!/[1-9][0-9]{12}/.test(Date.now().toString()));function closestElementOfNode(node){if(!node){return null;}var el=node.nodeType===node.ELEMENT_NODE?node:node.parentElement;return el;}function isBlocked(node,blockClass,blockSelector,unblockSelector,checkAncestors){if(!node){return false;}var el=closestElementOfNode(node);if(!el){return false;}var blockedPredicate=createMatchPredicate(blockClass,blockSelector);if(!checkAncestors){var isUnblocked=unblockSelector&&el.matches(unblockSelector);return blockedPredicate(el)&&!isUnblocked;}var blockDistance=distanceToMatch(el,blockedPredicate);var unblockDistance=-1;if(blockDistance<0){return false;}if(unblockSelector){unblockDistance=distanceToMatch(el,createMatchPredicate(null,unblockSelector));}if(blockDistance>-1&&unblockDistance<0){return true;}return blockDistance<unblockDistance;}var cachedImplementations={};function getImplementation(name){var cached=cachedImplementations[name];if(cached){return cached;}var document=window.document;var impl=window[name];if(document&&typeof document.createElement==='function'){try{var sandbox=document.createElement('iframe');sandbox.hidden=true;document.head.appendChild(sandbox);var contentWindow=sandbox.contentWindow;if(contentWindow&&contentWindow[name]){impl=contentWindow[name];}document.head.removeChild(sandbox);}catch(e){}}return cachedImplementations[name]=impl.bind(window);}function onRequestAnimationFrame(){return getImplementation('requestAnimationFrame').apply(void 0,arguments);}function setTimeout(){return getImplementation('setTimeout').apply(void 0,arguments);}var CanvasContext=/* @__PURE__ */function(CanvasContext2){CanvasContext2[CanvasContext2["2D"]=0]="2D";CanvasContext2[CanvasContext2["WebGL"]=1]="WebGL";CanvasContext2[CanvasContext2["WebGL2"]=2]="WebGL2";return CanvasContext2;}(CanvasContext||{});var errorHandler;function registerErrorHandler(handler){errorHandler=handler;}var callbackWrapper=function callbackWrapper(cb){if(!errorHandler){return cb;}var rrwebWrapped=function rrwebWrapped(){try{return cb.apply(void 0,arguments);}catch(error){if(errorHandler&&errorHandler(error)===true){return function(){};}throw error;}};return rrwebWrapped;};/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */var chars='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';// Use a lookup table to find the index.
var lookup=typeof Uint8Array==='undefined'?[]:new Uint8Array(256);for(var i=0;i<chars.length;i++){lookup[chars.charCodeAt(i)]=i;}var encode=function encode(arraybuffer){var bytes=new Uint8Array(arraybuffer),i,len=bytes.length,base64='';for(i=0;i<len;i+=3){base64+=chars[bytes[i]>>2];base64+=chars[(bytes[i]&3)<<4|bytes[i+1]>>4];base64+=chars[(bytes[i+1]&15)<<2|bytes[i+2]>>6];base64+=chars[bytes[i+2]&63];}if(len%3===2){base64=base64.substring(0,base64.length-1)+'=';}else if(len%3===1){base64=base64.substring(0,base64.length-2)+'==';}return base64;};var canvasVarMap=new Map();function variableListFor(ctx,ctor){var contextMap=canvasVarMap.get(ctx);if(!contextMap){contextMap=new Map();canvasVarMap.set(ctx,contextMap);}if(!contextMap.has(ctor)){contextMap.set(ctor,[]);}return contextMap.get(ctor);}var saveWebGLVar=function saveWebGLVar(value,win,ctx){if(!value||!(isInstanceOfWebGLObject(value,win)||_typeof(value)==='object'))return;var name=value.constructor.name;var list=variableListFor(ctx,name);var index=list.indexOf(value);if(index===-1){index=list.length;list.push(value);}return index;};function serializeArg(value,win,ctx){if(value instanceof Array){return value.map(function(arg){return serializeArg(arg,win,ctx);});}else if(value===null){return value;}else if(value instanceof Float32Array||value instanceof Float64Array||value instanceof Int32Array||value instanceof Uint32Array||value instanceof Uint8Array||value instanceof Uint16Array||value instanceof Int16Array||value instanceof Int8Array||value instanceof Uint8ClampedArray){var name=value.constructor.name;return{rr_type:name,args:[Object.values(value)]};}else if(value instanceof ArrayBuffer){var _name=value.constructor.name;var base64=encode(value);return{rr_type:_name,base64:base64};}else if(value instanceof DataView){var _name2=value.constructor.name;return{rr_type:_name2,args:[serializeArg(value.buffer,win,ctx),value.byteOffset,value.byteLength]};}else if(value instanceof HTMLImageElement){var _name3=value.constructor.name;var src=value.src;return{rr_type:_name3,src:src};}else if(value instanceof HTMLCanvasElement){var _name4='HTMLImageElement';var _src=value.toDataURL();return{rr_type:_name4,src:_src};}else if(value instanceof ImageData){var _name5=value.constructor.name;return{rr_type:_name5,args:[serializeArg(value.data,win,ctx),value.width,value.height]};}else if(isInstanceOfWebGLObject(value,win)||_typeof(value)==='object'){var _name6=value.constructor.name;var index=saveWebGLVar(value,win,ctx);return{rr_type:_name6,index:index};}return value;}var serializeArgs=function serializeArgs(args,win,ctx){return args.map(function(arg){return serializeArg(arg,win,ctx);});};var isInstanceOfWebGLObject=function isInstanceOfWebGLObject(value,win){var webGLConstructorNames=['WebGLActiveInfo','WebGLBuffer','WebGLFramebuffer','WebGLProgram','WebGLRenderbuffer','WebGLShader','WebGLShaderPrecisionFormat','WebGLTexture','WebGLUniformLocation','WebGLVertexArrayObject','WebGLVertexArrayObjectOES'];var supportedWebGLConstructorNames=webGLConstructorNames.filter(function(name){return typeof win[name]==='function';});return Boolean(supportedWebGLConstructorNames.find(function(name){return value instanceof win[name];}));};function initCanvas2DMutationObserver(cb,win,blockClass,blockSelector,unblockSelector){var handlers=[];var props2D=Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{var _loop=function _loop(){var prop=_step.value;try{if(typeof win.CanvasRenderingContext2D.prototype[prop]!=='function'){return"continue";}var restoreHandler=patch(win.CanvasRenderingContext2D.prototype,prop,function(original){return function(){var _this2=this;for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}if(!isBlocked(this.canvas,blockClass,blockSelector,unblockSelector,true)){setTimeout(function(){var recordArgs=serializeArgs(args,win,_this2);cb(_this2.canvas,{type:CanvasContext['2D'],property:prop,args:recordArgs});},0);}return original.apply(this,args);};});handlers.push(restoreHandler);}catch(e){var hookHandler=hookSetter(win.CanvasRenderingContext2D.prototype,prop,{set:function set(v){cb(this.canvas,{type:CanvasContext['2D'],property:prop,args:[v],setter:true});}});handlers.push(hookHandler);}};for(var _iterator=props2D[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _ret=_loop();if(_ret==="continue")continue;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return function(){handlers.forEach(function(h){return h();});};}function getNormalizedContextName(contextType){return contextType==='experimental-webgl'?'webgl':contextType;}function initCanvasContextObserver(win,blockClass,blockSelector,unblockSelector,setPreserveDrawingBufferToTrue){var handlers=[];try{var restoreHandler=patch(win.HTMLCanvasElement.prototype,'getContext',function(original){return function(contextType){for(var _len2=arguments.length,args=new Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){args[_key2-1]=arguments[_key2];}if(!isBlocked(this,blockClass,blockSelector,unblockSelector,true)){var ctxName=getNormalizedContextName(contextType);if(!('__context'in this))this.__context=ctxName;if(setPreserveDrawingBufferToTrue&&['webgl','webgl2'].includes(ctxName)){if(args[0]&&_typeof(args[0])==='object'){var contextAttributes=args[0];if(!contextAttributes.preserveDrawingBuffer){contextAttributes.preserveDrawingBuffer=true;}}else{args.splice(0,1,{preserveDrawingBuffer:true});}}}return original.apply(this,[contextType].concat(args));};});handlers.push(restoreHandler);}catch(e){console.error('failed to patch HTMLCanvasElement.prototype.getContext');}return function(){handlers.forEach(function(h){return h();});};}function patchGLPrototype(prototype,type,cb,blockClass,blockSelector,unblockSelector,mirror,win){var handlers=[];var props=Object.getOwnPropertyNames(prototype);var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{var _loop2=function _loop2(){var prop=_step2.value;if(['isContextLost','canvas','drawingBufferWidth','drawingBufferHeight'].includes(prop)){return"continue";}try{if(typeof prototype[prop]!=='function'){return"continue";}var restoreHandler=patch(prototype,prop,function(original){return function(){for(var _len3=arguments.length,args=new Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}var result=original.apply(this,args);saveWebGLVar(result,win,this);if('tagName'in this.canvas&&!isBlocked(this.canvas,blockClass,blockSelector,unblockSelector,true)){var recordArgs=serializeArgs(args,win,this);var mutation={type:type,property:prop,args:recordArgs};cb(this.canvas,mutation);}return result;};});handlers.push(restoreHandler);}catch(e){var hookHandler=hookSetter(prototype,prop,{set:function set(v){cb(this.canvas,{type:type,property:prop,args:[v],setter:true});}});handlers.push(hookHandler);}};for(var _iterator2=props[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _ret2=_loop2();if(_ret2==="continue")continue;}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return!=null){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return handlers;}function initCanvasWebGLMutationObserver(cb,win,blockClass,blockSelector,unblockSelector,mirror){var handlers=[];handlers.push.apply(handlers,_toConsumableArray(patchGLPrototype(win.WebGLRenderingContext.prototype,CanvasContext.WebGL,cb,blockClass,blockSelector,unblockSelector,mirror,win)));if(typeof win.WebGL2RenderingContext!=='undefined'){handlers.push.apply(handlers,_toConsumableArray(patchGLPrototype(win.WebGL2RenderingContext.prototype,CanvasContext.WebGL2,cb,blockClass,blockSelector,unblockSelector,mirror,win)));}return function(){handlers.forEach(function(h){return h();});};}var r="for(var e=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/\",t=\"undefined\"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s=\"\";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+\"=\":r%3==1&&(s=s.substring(0,s.length-2)+\"==\"),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!(\"OffscreenCanvas\"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+\"-\"+t;if(\"OffscreenCanvas\"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext(\"2d\");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return\"\"}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext(\"bitmaprenderer\"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:\"low\"});w.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};";function t(){var t=new Blob([r]);return URL.createObjectURL(t);}var CanvasManager=/*#__PURE__*/function(){_createClass(CanvasManager,[{key:"reset",value:function reset(){this.pendingCanvasMutations.clear();this.resetObservers&&this.resetObservers();}},{key:"freeze",value:function freeze(){this.frozen=true;}},{key:"unfreeze",value:function unfreeze(){this.frozen=false;}},{key:"lock",value:function lock(){this.locked=true;}},{key:"unlock",value:function unlock(){this.locked=false;}}]);function CanvasManager(options){var _this3=this;_classCallCheck(this,CanvasManager);this.pendingCanvasMutations=new Map();this.rafStamps={latestId:0,invokeId:null};this.frozen=false;this.locked=false;this.processMutation=function(target,mutation){var newFrame=_this3.rafStamps.invokeId&&_this3.rafStamps.latestId!==_this3.rafStamps.invokeId;if(newFrame||!_this3.rafStamps.invokeId)_this3.rafStamps.invokeId=_this3.rafStamps.latestId;if(!_this3.pendingCanvasMutations.has(target)){_this3.pendingCanvasMutations.set(target,[]);}_this3.pendingCanvasMutations.get(target).push(mutation);};var _options$sampling=options.sampling,sampling=_options$sampling===void 0?'all':_options$sampling,win=options.win,blockClass=options.blockClass,blockSelector=options.blockSelector,unblockSelector=options.unblockSelector,maxCanvasSize=options.maxCanvasSize,recordCanvas=options.recordCanvas,dataURLOptions=options.dataURLOptions,errorHandler=options.errorHandler;this.mutationCb=options.mutationCb;this.mirror=options.mirror;this.options=options;if(errorHandler){registerErrorHandler(errorHandler);}if(options.enableManualSnapshot){return;}callbackWrapper(function(){if(recordCanvas&&sampling==='all')_this3.initCanvasMutationObserver(win,blockClass,blockSelector,unblockSelector);if(recordCanvas&&typeof sampling==='number')_this3.initCanvasFPSObserver(sampling,win,blockClass,blockSelector,unblockSelector,maxCanvasSize,{dataURLOptions:dataURLOptions});})();}_createClass(CanvasManager,[{key:"initCanvasFPSObserver",value:function initCanvasFPSObserver(fps,win,blockClass,blockSelector,unblockSelector,maxCanvasSize,options){var canvasContextReset=initCanvasContextObserver(win,blockClass,blockSelector,unblockSelector,true);var rafId=this.takeSnapshot(false,fps,win,blockClass,blockSelector,unblockSelector,maxCanvasSize,options.dataURLOptions);this.resetObservers=function(){canvasContextReset();cancelAnimationFrame(rafId);};}},{key:"initCanvasMutationObserver",value:function initCanvasMutationObserver(win,blockClass,blockSelector,unblockSelector){this.startRAFTimestamping();this.startPendingCanvasMutationFlusher();var canvasContextReset=initCanvasContextObserver(win,blockClass,blockSelector,unblockSelector,false);var canvas2DReset=initCanvas2DMutationObserver(this.processMutation.bind(this),win,blockClass,blockSelector,unblockSelector);var canvasWebGL1and2Reset=initCanvasWebGLMutationObserver(this.processMutation.bind(this),win,blockClass,blockSelector,unblockSelector,this.mirror);this.resetObservers=function(){canvasContextReset();canvas2DReset();canvasWebGL1and2Reset();};}},{key:"snapshot",value:function snapshot(canvasElement){var options=this.options;var rafId=this.takeSnapshot(true,options.sampling==='all'?2:options.sampling||2,options.win,options.blockClass,options.blockSelector,options.unblockSelector,options.maxCanvasSize,options.dataURLOptions,canvasElement);this.resetObservers=function(){cancelAnimationFrame(rafId);};}},{key:"takeSnapshot",value:function takeSnapshot(isManualSnapshot,fps,win,blockClass,blockSelector,unblockSelector,maxCanvasSize,dataURLOptions,canvasElement){var _this4=this;var snapshotInProgressMap=new Map();var worker=new Worker(t());worker.onmessage=function(e){var data=e.data;var id=data.id;snapshotInProgressMap.set(id,false);if(!('base64'in data))return;var base64=data.base64,type=data.type,width=data.width,height=data.height;_this4.mutationCb({id:id,type:CanvasContext['2D'],commands:[{property:'clearRect',args:[0,0,width,height]},{property:'drawImage',args:[{rr_type:'ImageBitmap',args:[{rr_type:'Blob',data:[{rr_type:'ArrayBuffer',base64:base64}],type:type}]},0,0,width,height]}]});};var timeBetweenSnapshots=1000/fps;var lastSnapshotTime=0;var rafId;var getCanvas=function getCanvas(canvasElement){if(canvasElement){return[canvasElement];}var matchedCanvas=[];win.document.querySelectorAll('canvas').forEach(function(canvas){if(!isBlocked(canvas,blockClass,blockSelector,unblockSelector,true)){matchedCanvas.push(canvas);}});return matchedCanvas;};var takeCanvasSnapshots=function takeCanvasSnapshots(timestamp){if(lastSnapshotTime&&timestamp-lastSnapshotTime<timeBetweenSnapshots){rafId=onRequestAnimationFrame(takeCanvasSnapshots);return;}lastSnapshotTime=timestamp;getCanvas(canvasElement).forEach(function(canvas){var id=_this4.mirror.getId(canvas);if(snapshotInProgressMap.get(id))return;if(!canvas.width||!canvas.height)return;snapshotInProgressMap.set(id,true);if(!isManualSnapshot&&['webgl','webgl2'].includes(canvas.__context)){var context=canvas.getContext(canvas.__context);if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["h" /* _optionalChain */])([context,'optionalAccess',function(_){return _.getContextAttributes;},'call',function(_2){return _2();},'optionalAccess',function(_3){return _3.preserveDrawingBuffer;}])===false){context.clear(context.COLOR_BUFFER_BIT);}}createImageBitmap(canvas).then(function(bitmap){worker.postMessage({id:id,bitmap:bitmap,width:canvas.width,height:canvas.height,dataURLOptions:dataURLOptions,maxCanvasSize:maxCanvasSize},[bitmap]);}).catch(function(error){callbackWrapper(function(){throw error;})();});});rafId=onRequestAnimationFrame(takeCanvasSnapshots);};rafId=onRequestAnimationFrame(takeCanvasSnapshots);return rafId;}},{key:"startPendingCanvasMutationFlusher",value:function startPendingCanvasMutationFlusher(){var _this5=this;onRequestAnimationFrame(function(){return _this5.flushPendingCanvasMutations();});}},{key:"startRAFTimestamping",value:function startRAFTimestamping(){var _this6=this;var setLatestRAFTimestamp=function setLatestRAFTimestamp(timestamp){_this6.rafStamps.latestId=timestamp;onRequestAnimationFrame(setLatestRAFTimestamp);};onRequestAnimationFrame(setLatestRAFTimestamp);}},{key:"flushPendingCanvasMutations",value:function flushPendingCanvasMutations(){var _this7=this;this.pendingCanvasMutations.forEach(function(values,canvas){var id=_this7.mirror.getId(canvas);_this7.flushPendingCanvasMutationFor(canvas,id);});onRequestAnimationFrame(function(){return _this7.flushPendingCanvasMutations();});}},{key:"flushPendingCanvasMutationFor",value:function flushPendingCanvasMutationFor(canvas,id){if(this.frozen||this.locked){return;}var valuesWithType=this.pendingCanvasMutations.get(canvas);if(!valuesWithType||id===-1)return;var values=valuesWithType.map(function(value){var type=value.type,rest=_objectWithoutProperties(value,["type"]);return rest;});var type=valuesWithType[0].type;this.mutationCb({id:id,type:type,commands:values});this.pendingCanvasMutations.delete(canvas);}}]);return CanvasManager;}();var CANVAS_QUALITY={low:{sampling:{canvas:1},dataURLOptions:{type:'image/webp',quality:0.25}},medium:{sampling:{canvas:2},dataURLOptions:{type:'image/webp',quality:0.4}},high:{sampling:{canvas:4},dataURLOptions:{type:'image/webp',quality:0.5}}};var INTEGRATION_NAME='ReplayCanvas';var DEFAULT_MAX_CANVAS_SIZE=1280;/** Exported only for type safe tests. */var _replayCanvasIntegration=function _replayCanvasIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _ref=options.maxCanvasSize||[],_ref2=_slicedToArray(_ref,2),maxCanvasWidth=_ref2[0],maxCanvasHeight=_ref2[1];var _canvasOptions={quality:options.quality||'medium',enableManualSnapshot:options.enableManualSnapshot,maxCanvasSize:[maxCanvasWidth?Math.min(maxCanvasWidth,DEFAULT_MAX_CANVAS_SIZE):DEFAULT_MAX_CANVAS_SIZE,maxCanvasHeight?Math.min(maxCanvasHeight,DEFAULT_MAX_CANVAS_SIZE):DEFAULT_MAX_CANVAS_SIZE]};var canvasManagerResolve;var _canvasManager=new Promise(function(resolve){return canvasManagerResolve=resolve;});return{name:INTEGRATION_NAME,// eslint-disable-next-line @typescript-eslint/no-empty-function
setupOnce:function setupOnce(){},getOptions:function getOptions(){var quality=_canvasOptions.quality,enableManualSnapshot=_canvasOptions.enableManualSnapshot,maxCanvasSize=_canvasOptions.maxCanvasSize;return _objectSpread({enableManualSnapshot:enableManualSnapshot,recordCanvas:true,getCanvasManager:function getCanvasManager(getCanvasManagerOptions){var manager=new CanvasManager(_objectSpread({},getCanvasManagerOptions,{enableManualSnapshot:enableManualSnapshot,maxCanvasSize:maxCanvasSize,errorHandler:function errorHandler(err){try{if(_typeof(err)==='object'){err.__rrweb__=true;}}catch(error){// ignore errors here
// this can happen if the error is frozen or does not allow mutation for other reasons
}}}));canvasManagerResolve(manager);return manager;}},CANVAS_QUALITY[quality||'medium']||CANVAS_QUALITY.medium);},snapshot:function(){var _snapshot=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(canvasElement){var canvasManager;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _canvasManager;case 2:canvasManager=_context.sent;canvasManager.snapshot(canvasElement);case 4:case"end":return _context.stop();}}},_callee);}));function snapshot(_x){return _snapshot.apply(this,arguments);}return snapshot;}()};};/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */var replayCanvasIntegration=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["G" /* defineIntegration */])(_replayCanvasIntegration);/**
 * @deprecated Use `replayCanvasIntegration()` instead
 */// eslint-disable-next-line deprecation/deprecation
var ReplayCanvas=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,replayCanvasIntegration);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Feedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return feedbackIntegration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sendFeedback; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(3);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _objectWithoutProperties(source,excluded){if(source==null)return{};var target=_objectWithoutPropertiesLoose(source,excluded);var key,i;if(Object.getOwnPropertySymbols){var sourceSymbolKeys=Object.getOwnPropertySymbols(source);for(i=0;i<sourceSymbolKeys.length;i++){key=sourceSymbolKeys[i];if(excluded.indexOf(key)>=0)continue;if(!Object.prototype.propertyIsEnumerable.call(source,key))continue;target[key]=source[key];}}return target;}function _objectWithoutPropertiesLoose(source,excluded){if(source==null)return{};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and feedback packages
var WINDOW=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */];var LIGHT_BACKGROUND='#ffffff';var INHERIT='inherit';var SUBMIT_COLOR='rgba(108, 95, 199, 1)';var LIGHT_THEME={fontFamily:"system-ui, 'Helvetica Neue', Arial, sans-serif",fontSize:'14px',background:LIGHT_BACKGROUND,backgroundHover:'#f6f6f7',foreground:'#2b2233',border:'1.5px solid rgba(41, 35, 47, 0.13)',borderRadius:'25px',boxShadow:'0px 4px 24px 0px rgba(43, 34, 51, 0.12)',success:'#268d75',error:'#df3338',submitBackground:'rgba(88, 74, 192, 1)',submitBackgroundHover:SUBMIT_COLOR,submitBorder:SUBMIT_COLOR,submitOutlineFocus:'#29232f',submitForeground:LIGHT_BACKGROUND,submitForegroundHover:LIGHT_BACKGROUND,cancelBackground:'transparent',cancelBackgroundHover:'var(--background-hover)',cancelBorder:'var(--border)',cancelOutlineFocus:'var(--input-outline-focus)',cancelForeground:'var(--foreground)',cancelForegroundHover:'var(--foreground)',inputBackground:INHERIT,inputForeground:INHERIT,inputBorder:'var(--border)',inputOutlineFocus:SUBMIT_COLOR,formBorderRadius:'20px',formContentBorderRadius:'6px'};var DEFAULT_THEME={light:LIGHT_THEME,dark:_objectSpread({},LIGHT_THEME,{background:'#29232f',backgroundHover:'#352f3b',foreground:'#ebe6ef',border:'1.5px solid rgba(235, 230, 239, 0.15)',success:'#2da98c',error:'#f55459'})};var ACTOR_LABEL='Report a Bug';var CANCEL_BUTTON_LABEL='Cancel';var SUBMIT_BUTTON_LABEL='Send Bug Report';var FORM_TITLE='Report a Bug';var EMAIL_PLACEHOLDER='your.email@example.org';var EMAIL_LABEL='Email';var MESSAGE_PLACEHOLDER="What's the bug? What did you expect?";var MESSAGE_LABEL='Description';var NAME_PLACEHOLDER='Your Name';var NAME_LABEL='Name';var IS_REQUIRED_LABEL='(required)';var SUCCESS_MESSAGE_TEXT='Thank you for your report!';var FEEDBACK_WIDGET_SOURCE='widget';var FEEDBACK_API_SOURCE='api';/**
 * Prepare a feedback event & enrich it with the SDK metadata.
 */function prepareFeedbackEvent(_x){return _prepareFeedbackEvent.apply(this,arguments);}/**
 * Send feedback using transport
 */function _prepareFeedbackEvent(){_prepareFeedbackEvent=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref){var client,scope,event,eventHint,preparedEvent;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:client=_ref.client,scope=_ref.scope,event=_ref.event;eventHint={};if(client.emit){client.emit('preprocessEvent',event,eventHint);}_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_13" /* prepareEvent */])(client.getOptions(),event,eventHint,scope,client,Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["V" /* getIsolationScope */])());case 5:preparedEvent=_context2.sent;if(!(preparedEvent===null)){_context2.next=9;break;}// Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
client.recordDroppedEvent('event_processor','feedback',event);return _context2.abrupt("return",null);case 9:// This normally happens in browser client "_prepareEvent"
// but since we do not use this private method from the client, but rather the plain import
// we need to do this manually.
preparedEvent.platform=preparedEvent.platform||'javascript';return _context2.abrupt("return",preparedEvent);case 11:case"end":return _context2.stop();}}},_callee2);}));return _prepareFeedbackEvent.apply(this,arguments);}function sendFeedbackRequest(_x2){return _sendFeedbackRequest.apply(this,arguments);}/*
 * For reference, the fully built event looks something like this:
 * {
 *     "type": "feedback",
 *     "event_id": "d2132d31b39445f1938d7e21b6bf0ec4",
 *     "timestamp": 1597977777.6189718,
 *     "dist": "1.12",
 *     "platform": "javascript",
 *     "environment": "production",
 *     "release": 42,
 *     "tags": {"transaction": "/organizations/:orgId/performance/:eventSlug/"},
 *     "sdk": {"name": "name", "version": "version"},
 *     "user": {
 *         "id": "123",
 *         "username": "user",
 *         "email": "user@site.com",
 *         "ip_address": "192.168.11.12",
 *     },
 *     "request": {
 *         "url": None,
 *         "headers": {
 *             "user-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Safari/605.1.15"
 *         },
 *     },
 *     "contexts": {
 *         "feedback": {
 *             "message": "test message",
 *             "contact_email": "test@example.com",
 *             "type": "feedback",
 *         },
 *         "trace": {
 *             "trace_id": "4C79F60C11214EB38604F4AE0781BFB2",
 *             "span_id": "FA90FDEAD5F74052",
 *             "type": "trace",
 *         },
 *         "replay": {
 *             "replay_id": "e2d42047b1c5431c8cba85ee2a8ab25d",
 *         },
 *     },
 *   }
 *//**
 * Public API to send a Feedback item to Sentry
 */function _sendFeedbackRequest(){_sendFeedbackRequest=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref2){var _ref2$feedback,message,email,name,source,url,_ref17,_ref17$includeReplay,includeReplay,client,transport,dsn,baseEvent,_args4=arguments;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_ref2$feedback=_ref2.feedback,message=_ref2$feedback.message,email=_ref2$feedback.email,name=_ref2$feedback.name,source=_ref2$feedback.source,url=_ref2$feedback.url;_ref17=_args4.length>1&&_args4[1]!==undefined?_args4[1]:{},_ref17$includeReplay=_ref17.includeReplay,includeReplay=_ref17$includeReplay===void 0?true:_ref17$includeReplay;client=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["N" /* getClient */])();transport=client&&client.getTransport();dsn=client&&client.getDsn();if(!(!client||!transport||!dsn)){_context4.next=7;break;}return _context4.abrupt("return");case 7:baseEvent={contexts:{feedback:{contact_email:email,name:name,message:message,url:url,source:source}},type:'feedback'};return _context4.abrupt("return",Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_35" /* withScope */])(/*#__PURE__*/function(){var _ref18=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(scope){var feedbackEvent,envelope,response,error;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:// No use for breadcrumbs in feedback
scope.clearBreadcrumbs();if([FEEDBACK_API_SOURCE,FEEDBACK_WIDGET_SOURCE].includes(String(source))){scope.setLevel('info');}_context3.next=4;return prepareFeedbackEvent({// eslint-disable-next-line @typescript-eslint/no-explicit-any
scope:scope,client:client,event:baseEvent});case 4:feedbackEvent=_context3.sent;if(feedbackEvent){_context3.next=7;break;}return _context3.abrupt("return");case 7:if(client.emit){client.emit('beforeSendFeedback',feedbackEvent,{includeReplay:Boolean(includeReplay)});}envelope=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["D" /* createEventEnvelope */])(feedbackEvent,dsn,client.getOptions()._metadata,client.getOptions().tunnel);_context3.prev=9;_context3.next=12;return transport.send(envelope);case 12:response=_context3.sent;_context3.next=20;break;case 15:_context3.prev=15;_context3.t0=_context3["catch"](9);error=new Error('Unable to send Feedback');try{// In case browsers don't allow this property to be writable
// @ts-expect-error This needs lib es2022 and newer
error.cause=_context3.t0;}catch(e){// nothing to do
}throw error;case 20:if(response){_context3.next=22;break;}return _context3.abrupt("return");case 22:if(!(typeof response.statusCode==='number'&&(response.statusCode<200||response.statusCode>=300))){_context3.next=24;break;}throw new Error('Unable to send Feedback');case 24:return _context3.abrupt("return",response);case 25:case"end":return _context3.stop();}}},_callee3,null,[[9,15]]);}));return function(_x7){return _ref18.apply(this,arguments);};}()));case 9:case"end":return _context4.stop();}}},_callee4);}));return _sendFeedbackRequest.apply(this,arguments);}function sendFeedback(_ref3){var name=_ref3.name,email=_ref3.email,message=_ref3.message,_ref3$source=_ref3.source,source=_ref3$source===void 0?FEEDBACK_API_SOURCE:_ref3$source,_ref3$url=_ref3.url,url=_ref3$url===void 0?Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_2" /* getLocationHref */])():_ref3$url;var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!message){throw new Error('Unable to submit feedback with empty message');}return sendFeedbackRequest({feedback:{name:name,email:email,message:message,url:url,source:source}},options);}/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */var DEBUG_BUILD=typeof __SENTRY_DEBUG__==='undefined'||__SENTRY_DEBUG__;/**
 * Quick and dirty deep merge for the Feedback integration options
 */function mergeOptions(defaultOptions,optionOverrides){return _objectSpread({},defaultOptions,{},optionOverrides,{themeDark:_objectSpread({},defaultOptions.themeDark,{},optionOverrides.themeDark),themeLight:_objectSpread({},defaultOptions.themeLight,{},optionOverrides.themeLight)});}/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */function createActorStyles(d){var style=d.createElement('style');style.textContent="\n.widget__actor {\n  position: fixed;\n  left: var(--left);\n  right: var(--right);\n  bottom: var(--bottom);\n  top: var(--top);\n  z-index: var(--z-index);\n\n  line-height: 16px;\n\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: var(--font-size);\n  font-weight: 600;\n  padding: 16px;\n  text-decoration: none;\n  z-index: 9000;\n\n  color: var(--foreground);\n  background-color: var(--background);\n  border: var(--border);\n  box-shadow: var(--box-shadow);\n  opacity: 1;\n  transition: opacity 0.1s ease-in-out;\n}\n\n.widget__actor:hover {\n  background-color: var(--background-hover);\n}\n\n.widget__actor svg {\n  width: 16px;\n  height: 16px;\n}\n\n.widget__actor--hidden {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.widget__actor__text {\n}\n\n@media (max-width: 600px) {\n  .widget__actor__text {\n    display: none;\n  }\n}\n\n.feedback-icon path {\n  fill: var(--foreground);\n}\n";return style;}/**
 * Creates <style> element for widget dialog
 */function createDialogStyles(d){var style=d.createElement('style');style.textContent="\n.dialog {\n  line-height: 25px;\n  background-color: rgba(0, 0, 0, 0.05);\n  border: none;\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 1;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.dialog:not([open]) {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n.dialog:not([open]) .dialog__content {\n  transform: translate(0, -16px) scale(0.98);\n}\n\n.dialog__content {\n  position: fixed;\n  left: var(--left);\n  right: var(--right);\n  bottom: var(--bottom);\n  top: var(--top);\n\n  border: var(--border);\n  border-radius: var(--form-border-radius);\n  background-color: var(--background);\n  color: var(--foreground);\n\n  width: 320px;\n  max-width: 100%;\n  max-height: calc(100% - 2rem);\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--box-shadow);\n  transition: transform 0.2s ease-in-out;\n  transform: translate(0, 0) scale(1);\n}\n\n.dialog__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 20px;\n  font-weight: 600;\n  padding: 24px 24px 0 24px;\n  margin: 0;\n  margin-bottom: 16px;\n}\n\n.brand-link {\n  display: inline-flex;\n}\n\n.error {\n  color: var(--error);\n  margin-bottom: 16px;\n}\n\n.form {\n  display: grid;\n  overflow: auto;\n  flex-direction: column;\n  gap: 16px;\n  padding: 0 24px 24px;\n}\n\n.form__error-container {\n  color: var(--error);\n}\n\n.form__error-container--hidden {\n  display: none;\n}\n\n.form__label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0px;\n}\n\n.form__label__text {\n  display: grid;\n  gap: 4px;\n  align-items: center;\n  grid-auto-flow: column;\n  grid-auto-columns: max-content;\n}\n\n.form__label__text--required {\n  font-size: 0.85em;\n}\n\n.form__input {\n  line-height: inherit;\n  background-color: var(--input-background);\n  box-sizing: border-box;\n  border: var(--input-border);\n  border-radius: var(--form-content-border-radius);\n  color: var(--input-foreground);\n  font-family: inherit;\n  font-size: var(--font-size);\n  font-weight: 500;\n  padding: 6px 12px;\n}\n\n.form__input::placeholder {\n  color: var(--input-foreground);\n  opacity: 0.65;\n}\n\n.form__input:focus-visible {\n  outline: 1px auto var(--input-outline-focus);\n}\n\n.form__input--textarea {\n  font-family: inherit;\n  resize: vertical;\n}\n\n.btn-group {\n  display: grid;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.btn {\n  line-height: inherit;\n  border: var(--cancel-border);\n  border-radius: var(--form-content-border-radius);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: var(--font-size);\n  font-weight: 600;\n  padding: 6px 16px;\n}\n.btn[disabled] {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.btn--primary {\n  background-color: var(--submit-background);\n  border-color: var(--submit-border);\n  color: var(--submit-foreground);\n}\n.btn--primary:hover {\n  background-color: var(--submit-background-hover);\n  color: var(--submit-foreground-hover);\n}\n.btn--primary:focus-visible {\n  outline: 1px auto var(--submit-outline-focus);\n}\n\n.btn--default {\n  background-color: var(--cancel-background);\n  color: var(--cancel-foreground);\n  font-weight: 500;\n}\n.btn--default:hover {\n  background-color: var(--cancel-background-hover);\n  color: var(--cancel-foreground-hover);\n}\n.btn--default:focus-visible {\n  outline: 1px auto var(--cancel-outline-focus);\n}\n\n.success-message {\n  background-color: var(--background);\n  border: var(--border);\n  border-radius: var(--border-radius);\n  box-shadow: var(--box-shadow);\n  font-weight: 600;\n  color: var(--success);\n  padding: 12px 24px;\n  line-height: 25px;\n  display: grid;\n  align-items: center;\n  grid-auto-flow: column;\n  gap: 6px;\n  cursor: default;\n}\n\n.success-icon path {\n  fill: var(--success);\n}\n";return style;}function getThemedCssVariables(theme){return"\n  --background: ".concat(theme.background,";\n  --background-hover: ").concat(theme.backgroundHover,";\n  --foreground: ").concat(theme.foreground,";\n  --error: ").concat(theme.error,";\n  --success: ").concat(theme.success,";\n  --border: ").concat(theme.border,";\n  --border-radius: ").concat(theme.borderRadius,";\n  --box-shadow: ").concat(theme.boxShadow,";\n\n  --submit-background: ").concat(theme.submitBackground,";\n  --submit-background-hover: ").concat(theme.submitBackgroundHover,";\n  --submit-border: ").concat(theme.submitBorder,";\n  --submit-outline-focus: ").concat(theme.submitOutlineFocus,";\n  --submit-foreground: ").concat(theme.submitForeground,";\n  --submit-foreground-hover: ").concat(theme.submitForegroundHover,";\n\n  --cancel-background: ").concat(theme.cancelBackground,";\n  --cancel-background-hover: ").concat(theme.cancelBackgroundHover,";\n  --cancel-border: ").concat(theme.cancelBorder,";\n  --cancel-outline-focus: ").concat(theme.cancelOutlineFocus,";\n  --cancel-foreground: ").concat(theme.cancelForeground,";\n  --cancel-foreground-hover: ").concat(theme.cancelForegroundHover,";\n\n  --input-background: ").concat(theme.inputBackground,";\n  --input-foreground: ").concat(theme.inputForeground,";\n  --input-border: ").concat(theme.inputBorder,";\n  --input-outline-focus: ").concat(theme.inputOutlineFocus,";\n\n  --form-border-radius: ").concat(theme.formBorderRadius,";\n  --form-content-border-radius: ").concat(theme.formContentBorderRadius,";\n  ");}/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */function createMainStyles(d,colorScheme,themes){var style=d.createElement('style');style.textContent="\n:host {\n  --bottom: 1rem;\n  --right: 1rem;\n  --top: auto;\n  --left: auto;\n  --z-index: 100000;\n  --font-family: ".concat(themes.light.fontFamily,";\n  --font-size: ").concat(themes.light.fontSize,";\n\n  position: fixed;\n  left: var(--left);\n  right: var(--right);\n  bottom: var(--bottom);\n  top: var(--top);\n  z-index: var(--z-index);\n\n  font-family: var(--font-family);\n  font-size: var(--font-size);\n\n  ").concat(getThemedCssVariables(colorScheme==='dark'?themes.dark:themes.light),"\n}\n\n").concat(colorScheme==='system'?"\n@media (prefers-color-scheme: dark) {\n  :host {\n    ".concat(getThemedCssVariables(themes.dark),"\n  }\n}"):'',"\n}");return style;}/**
 * Creates shadow host
 */function createShadowHost(_ref4){var id=_ref4.id,colorScheme=_ref4.colorScheme,themeDark=_ref4.themeDark,themeLight=_ref4.themeLight;try{var _doc=WINDOW.document;// Create the host
var host=_doc.createElement('div');host.id=id;// Create the shadow root
var shadow=host.attachShadow({mode:'open'});shadow.appendChild(createMainStyles(_doc,colorScheme,{dark:themeDark,light:themeLight}));shadow.appendChild(createDialogStyles(_doc));return{shadow:shadow,host:host};}catch(e){// Shadow DOM probably not supported
__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('[Feedback] Browser does not support shadow DOM API');throw new Error('Browser does not support shadow DOM API.');}}/**
 * Handles UI behavior of dialog when feedback is submitted, calls
 * `sendFeedback` to send feedback.
 */function handleFeedbackSubmit(_x3,_x4,_x5){return _handleFeedbackSubmit2.apply(this,arguments);}/**
 * Helper function to set a dict of attributes on element (w/ specified namespace)
 */function _handleFeedbackSubmit2(){_handleFeedbackSubmit2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(dialog,feedback,options){var showFetchError,resp;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(dialog){_context5.next=2;break;}return _context5.abrupt("return");case 2:showFetchError=function showFetchError(){if(!dialog){return;}dialog.showError('There was a problem submitting feedback, please wait and try again.');};dialog.hideError();_context5.prev=4;_context5.next=7;return sendFeedback(_objectSpread({},feedback,{source:FEEDBACK_WIDGET_SOURCE}),options);case 7:resp=_context5.sent;return _context5.abrupt("return",resp);case 11:_context5.prev=11;_context5.t0=_context5["catch"](4);DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error(_context5.t0);showFetchError();case 15:case"end":return _context5.stop();}}},_callee5,null,[[4,11]]);}));return _handleFeedbackSubmit2.apply(this,arguments);}function setAttributesNS(el,attributes){Object.entries(attributes).forEach(function(_ref5){var _ref6=_slicedToArray(_ref5,2),key=_ref6[0],val=_ref6[1];el.setAttributeNS(null,key,val);});return el;}var SIZE=20;var XMLNS$2='http://www.w3.org/2000/svg';/**
 * Feedback Icon
 */function Icon(){var _setAttributesNS;var createElementNS=function createElementNS(tagName){return WINDOW.document.createElementNS(XMLNS$2,tagName);};var svg=setAttributesNS(createElementNS('svg'),{class:'feedback-icon',width:"".concat(SIZE),height:"".concat(SIZE),viewBox:"0 0 ".concat(SIZE," ").concat(SIZE),fill:'none'});var g=setAttributesNS(createElementNS('g'),{clipPath:'url(#clip0_57_80)'});var path=setAttributesNS(createElementNS('path'),(_setAttributesNS={},_defineProperty(_setAttributesNS,'fill-rule','evenodd'),_defineProperty(_setAttributesNS,'clip-rule','evenodd'),_defineProperty(_setAttributesNS,"d",'M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z'),_setAttributesNS));svg.appendChild(g).appendChild(path);var speakerDefs=createElementNS('defs');var speakerClipPathDef=setAttributesNS(createElementNS('clipPath'),{id:'clip0_57_80'});var speakerRect=setAttributesNS(createElementNS('rect'),{width:"".concat(SIZE),height:"".concat(SIZE),fill:'white'});speakerClipPathDef.appendChild(speakerRect);speakerDefs.appendChild(speakerClipPathDef);svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);return{get el(){return svg;}};}/**
 * Helper function to create an element. Could be used as a JSX factory
 * (i.e. React-like syntax).
 */function createElement(tagName,attributes){var doc=WINDOW.document;var element=doc.createElement(tagName);if(attributes){Object.entries(attributes).forEach(function(_ref7){var _ref8=_slicedToArray(_ref7,2),attribute=_ref8[0],attributeValue=_ref8[1];if(attribute==='className'&&typeof attributeValue==='string'){// JSX does not allow class as a valid name
element.setAttribute('class',attributeValue);}else if(typeof attributeValue==='boolean'&&attributeValue){element.setAttribute(attribute,'');}else if(typeof attributeValue==='string'){element.setAttribute(attribute,attributeValue);}else if(attribute.startsWith('on')&&typeof attributeValue==='function'){element.addEventListener(attribute.substring(2).toLowerCase(),attributeValue);}});}for(var _len=arguments.length,children=new Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){children[_key-2]=arguments[_key];}for(var _i2=0,_children=children;_i2<_children.length;_i2++){var child=_children[_i2];appendChild(element,child);}return element;}function appendChild(parent,child){var doc=WINDOW.document;if(typeof child==='undefined'||child===null){return;}if(Array.isArray(child)){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=child[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var value=_step.value;appendChild(parent,value);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}else if(child===false);else if(typeof child==='string'){parent.appendChild(doc.createTextNode(child));}else if(child instanceof Node){parent.appendChild(child);}else{parent.appendChild(doc.createTextNode(String(child)));}}/**
 *
 */function Actor(_ref9){var _createElement;var buttonLabel=_ref9.buttonLabel,onClick=_ref9.onClick;function _handleClick(e){onClick&&onClick(e);}var el=createElement('button',(_createElement={type:'button',className:'widget__actor'},_defineProperty(_createElement,'aria-label',buttonLabel),_defineProperty(_createElement,'aria-hidden','false'),_createElement),Icon().el,buttonLabel?createElement('span',{className:'widget__actor__text'},buttonLabel):null);el.addEventListener('click',_handleClick);return{get el(){return el;},show:function show(){el.classList.remove('widget__actor--hidden');el.setAttribute('aria-hidden','false');},hide:function hide(){el.classList.add('widget__actor--hidden');el.setAttribute('aria-hidden','true');}};}/**
 *
 */function SubmitButton(_ref0){var label=_ref0.label;var el=createElement('button',_defineProperty({type:'submit',className:'btn btn--primary'},'aria-label',label),label);return{el:el};}function retrieveStringValue(formData,key){var value=formData.get(key);if(typeof value==='string'){return value.trim();}return'';}/**
 * Creates the form element
 */function Form(_ref1){var _createElement4,_createElement5,_createElement6;var nameLabel=_ref1.nameLabel,namePlaceholder=_ref1.namePlaceholder,emailLabel=_ref1.emailLabel,emailPlaceholder=_ref1.emailPlaceholder,messageLabel=_ref1.messageLabel,messagePlaceholder=_ref1.messagePlaceholder,isRequiredLabel=_ref1.isRequiredLabel,cancelButtonLabel=_ref1.cancelButtonLabel,submitButtonLabel=_ref1.submitButtonLabel,showName=_ref1.showName,showEmail=_ref1.showEmail,isNameRequired=_ref1.isNameRequired,isEmailRequired=_ref1.isEmailRequired,defaultName=_ref1.defaultName,defaultEmail=_ref1.defaultEmail,onCancel=_ref1.onCancel,onSubmit=_ref1.onSubmit;var _SubmitButton=SubmitButton({label:submitButtonLabel}),submitEl=_SubmitButton.el;function handleSubmit(e){e.preventDefault();if(!(e.target instanceof HTMLFormElement)){return;}try{if(onSubmit){var formData=new FormData(e.target);var feedback={name:retrieveStringValue(formData,'name'),email:retrieveStringValue(formData,'email'),message:retrieveStringValue(formData,'message')};onSubmit(feedback);}}catch(e2){// pass
}}var errorEl=createElement('div',_defineProperty({className:'form__error-container form__error-container--hidden'},'aria-hidden','true'));function showError(message){errorEl.textContent=message;errorEl.classList.remove('form__error-container--hidden');errorEl.setAttribute('aria-hidden','false');}function hideError(){errorEl.textContent='';errorEl.classList.add('form__error-container--hidden');errorEl.setAttribute('aria-hidden','true');}var nameEl=createElement('input',(_createElement4={id:'name',type:showName?'text':'hidden'},_defineProperty(_createElement4,'aria-hidden',showName?'false':'true'),_defineProperty(_createElement4,"name",'name'),_defineProperty(_createElement4,"required",isNameRequired),_defineProperty(_createElement4,"className",'form__input'),_defineProperty(_createElement4,"placeholder",namePlaceholder),_defineProperty(_createElement4,"value",defaultName),_createElement4));var emailEl=createElement('input',(_createElement5={id:'email',type:showEmail?'text':'hidden'},_defineProperty(_createElement5,'aria-hidden',showEmail?'false':'true'),_defineProperty(_createElement5,"name",'email'),_defineProperty(_createElement5,"required",isEmailRequired),_defineProperty(_createElement5,"className",'form__input'),_defineProperty(_createElement5,"placeholder",emailPlaceholder),_defineProperty(_createElement5,"value",defaultEmail),_createElement5));var messageEl=createElement('textarea',{id:'message',autoFocus:'true',rows:'5',name:'message',required:true,className:'form__input form__input--textarea',placeholder:messagePlaceholder});var cancelEl=createElement('button',(_createElement6={type:'button',className:'btn btn--default'},_defineProperty(_createElement6,'aria-label',cancelButtonLabel),_defineProperty(_createElement6,"onClick",function onClick(e){onCancel&&onCancel(e);}),_createElement6),cancelButtonLabel);var formEl=createElement('form',{className:'form',onSubmit:handleSubmit},[errorEl,showName&&createElement('label',{htmlFor:'name',className:'form__label'},[createElement('span',{className:'form__label__text'},nameLabel,isNameRequired&&createElement('span',{className:'form__label__text--required'}," ".concat(isRequiredLabel))),nameEl]),!showName&&nameEl,showEmail&&createElement('label',{htmlFor:'email',className:'form__label'},[createElement('span',{className:'form__label__text'},emailLabel,isEmailRequired&&createElement('span',{className:'form__label__text--required'}," ".concat(isRequiredLabel))),emailEl]),!showEmail&&emailEl,createElement('label',{htmlFor:'message',className:'form__label'},[createElement('span',{className:'form__label__text'},messageLabel,createElement('span',{className:'form__label__text--required'}," ".concat(isRequiredLabel))),messageEl]),createElement('div',{className:'btn-group'},[submitEl,cancelEl])]);return{get el(){return formEl;},showError:showError,hideError:hideError};}var XMLNS$1='http://www.w3.org/2000/svg';/**
 * Sentry Logo
 */function Logo(_ref10){var colorScheme=_ref10.colorScheme;var createElementNS=function createElementNS(tagName){return WINDOW.document.createElementNS(XMLNS$1,tagName);};var svg=setAttributesNS(createElementNS('svg'),{class:'sentry-logo',width:'32',height:'30',viewBox:'0 0 72 66',fill:'none'});var path=setAttributesNS(createElementNS('path'),{transform:'translate(11, 11)',d:'M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z'});svg.append(path);var defs=createElementNS('defs');var style=createElementNS('style');style.textContent="\n    path {\n      fill: ".concat(colorScheme==='dark'?'#fff':'#362d59',";\n    }");if(colorScheme==='system'){style.textContent+="\n    @media (prefers-color-scheme: dark) {\n      path: {\n        fill: '#fff';\n      }\n    }\n    ";}defs.append(style);svg.append(defs);return{get el(){return svg;}};}/**
 * Feedback dialog component that has the form
 */function Dialog(_ref11){var formTitle=_ref11.formTitle,showBranding=_ref11.showBranding,showName=_ref11.showName,showEmail=_ref11.showEmail,isNameRequired=_ref11.isNameRequired,isEmailRequired=_ref11.isEmailRequired,colorScheme=_ref11.colorScheme,defaultName=_ref11.defaultName,defaultEmail=_ref11.defaultEmail,onClosed=_ref11.onClosed,onCancel=_ref11.onCancel,onSubmit=_ref11.onSubmit,textLabels=_objectWithoutProperties(_ref11,["formTitle","showBranding","showName","showEmail","isNameRequired","isEmailRequired","colorScheme","defaultName","defaultEmail","onClosed","onCancel","onSubmit"]);var el=null;/**
   * Handles when the dialog is clicked. In our case, the dialog is the
   * semi-transparent bg behind the form. We want clicks outside of the form to
   * hide the form.
   */function handleDialogClick(){close();// Only this should trigger `onClose`, we don't want the `close()` method to
// trigger it, otherwise it can cause cycles.
onClosed&&onClosed();}/**
   * Close the dialog
   */function close(){if(el){el.open=false;}}/**
   * Opens the dialog
   */function open(){if(el){el.open=true;}}/**
   * Check if dialog is currently opened
   */function checkIsOpen(){return el&&el.open===true||false;}var _Form=Form(_objectSpread({showEmail:showEmail,showName:showName,isEmailRequired:isEmailRequired,isNameRequired:isNameRequired,defaultName:defaultName,defaultEmail:defaultEmail,onSubmit:onSubmit,onCancel:onCancel},textLabels)),formEl=_Form.el,showError=_Form.showError,hideError=_Form.hideError;el=createElement('dialog',{className:'dialog',open:true,onClick:handleDialogClick},createElement('div',{className:'dialog__content',onClick:function onClick(e){// Stop event propagation so clicks on content modal do not propagate to dialog (which will close dialog)
e.stopPropagation();}},createElement('h2',{className:'dialog__header'},formTitle,showBranding&&createElement('a',{className:'brand-link',target:'_blank',href:'https://sentry.io/welcome/',title:'Powered by Sentry',rel:'noopener noreferrer'},Logo({colorScheme:colorScheme}).el)),formEl));return{get el(){return el;},showError:showError,hideError:hideError,open:open,close:close,checkIsOpen:checkIsOpen};}var WIDTH=16;var HEIGHT=17;var XMLNS='http://www.w3.org/2000/svg';/**
 * Success Icon (checkmark)
 */function SuccessIcon(){var _setAttributesNS2;var createElementNS=function createElementNS(tagName){return WINDOW.document.createElementNS(XMLNS,tagName);};var svg=setAttributesNS(createElementNS('svg'),{class:'success-icon',width:"".concat(WIDTH),height:"".concat(HEIGHT),viewBox:"0 0 ".concat(WIDTH," ").concat(HEIGHT),fill:'none'});var g=setAttributesNS(createElementNS('g'),{clipPath:'url(#clip0_57_156)'});var path2=setAttributesNS(createElementNS('path'),(_setAttributesNS2={},_defineProperty(_setAttributesNS2,'fill-rule','evenodd'),_defineProperty(_setAttributesNS2,'clip-rule','evenodd'),_defineProperty(_setAttributesNS2,"d",'M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z'),_setAttributesNS2));var path=setAttributesNS(createElementNS('path'),{d:'M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z'});svg.appendChild(g).append(path,path2);var speakerDefs=createElementNS('defs');var speakerClipPathDef=setAttributesNS(createElementNS('clipPath'),{id:'clip0_57_156'});var speakerRect=setAttributesNS(createElementNS('rect'),{width:"".concat(WIDTH),height:"".concat(WIDTH),fill:'white',transform:'translate(0 0.5)'});speakerClipPathDef.appendChild(speakerRect);speakerDefs.appendChild(speakerClipPathDef);svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);return{get el(){return svg;}};}/**
 * Feedback dialog component that has the form
 */function SuccessMessage(_ref12){var message=_ref12.message,onRemove=_ref12.onRemove;function remove(){if(!el){return;}el.remove();onRemove&&onRemove();}var el=createElement('div',{className:'success-message',onClick:remove},SuccessIcon().el,message);return{el:el,remove:remove};}/**
 * Creates a new widget. Returns public methods that control widget behavior.
 */function createWidget(_ref13){var shadow=_ref13.shadow,_ref13$options=_ref13.options,_ref13$options$should=_ref13$options.shouldCreateActor,shouldCreateActor=_ref13$options$should===void 0?true:_ref13$options$should,options=_objectWithoutProperties(_ref13$options,["shouldCreateActor"]),attachTo=_ref13.attachTo;var actor;var dialog;var isDialogOpen=false;/**
   * Show the success message for 5 seconds
   */function showSuccessMessage(){if(!shadow){return;}try{var success=SuccessMessage({message:options.successMessageText,onRemove:function onRemove(){if(timeoutId){clearTimeout(timeoutId);}showActor();}});if(!success.el){throw new Error('Unable to show success message');}shadow.appendChild(success.el);var timeoutId=setTimeout(function(){if(success){success.remove();}},5000);}catch(err){// TODO: error handling
__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error(err);}}/**
   * Handler for when the feedback form is completed by the user. This will
   * create and send the feedback message as an event.
   */function _handleFeedbackSubmit(_x6){return _handleFeedbackSubmit3.apply(this,arguments);}/**
   * Internal handler when dialog is opened
   */function _handleFeedbackSubmit3(){_handleFeedbackSubmit3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(feedback){var emptyField,result;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(dialog){_context.next=2;break;}return _context.abrupt("return");case 2:// Simple validation for now, just check for non-empty required fields
emptyField=[];if(options.isNameRequired&&!feedback.name){emptyField.push(options.nameLabel);}if(options.isEmailRequired&&!feedback.email){emptyField.push(options.emailLabel);}if(!feedback.message){emptyField.push(options.messageLabel);}if(!(emptyField.length>0)){_context.next=9;break;}dialog.showError("Please enter in the following required fields: ".concat(emptyField.join(', ')));return _context.abrupt("return");case 9:_context.next=11;return handleFeedbackSubmit(dialog,feedback);case 11:result=_context.sent;if(result){_context.next=15;break;}if(options.onSubmitError){options.onSubmitError();}return _context.abrupt("return");case 15:// Success
removeDialog();showSuccessMessage();if(options.onSubmitSuccess){options.onSubmitSuccess();}case 18:case"end":return _context.stop();}}},_callee);}));return _handleFeedbackSubmit3.apply(this,arguments);}function handleOpenDialog(){// Flush replay if integration exists
var client=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["N" /* getClient */])();var replay=client&&client.getIntegrationByName&&client.getIntegrationByName('Replay');if(!replay){return;}replay.flush().catch(function(err){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error(err);});}/**
   * Displays the default actor
   */function showActor(){actor&&actor.show();}/**
   * Hides the default actor
   */function hideActor(){actor&&actor.hide();}/**
   * Removes the default actor element
   */function removeActor(){actor&&actor.el&&actor.el.remove();}/**
   *
   */function openDialog(){try{if(dialog){dialog.open();isDialogOpen=true;if(options.onFormOpen){options.onFormOpen();}handleOpenDialog();return;}var userKey=options.useSentryUser;var scope=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["P" /* getCurrentScope */])();var user=scope&&scope.getUser();dialog=Dialog({colorScheme:options.colorScheme,showBranding:options.showBranding,showName:options.showName||options.isNameRequired,showEmail:options.showEmail||options.isEmailRequired,isNameRequired:options.isNameRequired,isEmailRequired:options.isEmailRequired,formTitle:options.formTitle,cancelButtonLabel:options.cancelButtonLabel,submitButtonLabel:options.submitButtonLabel,emailLabel:options.emailLabel,emailPlaceholder:options.emailPlaceholder,messageLabel:options.messageLabel,messagePlaceholder:options.messagePlaceholder,nameLabel:options.nameLabel,namePlaceholder:options.namePlaceholder,isRequiredLabel:options.isRequiredLabel,defaultName:userKey&&user&&user[userKey.name]||'',defaultEmail:userKey&&user&&user[userKey.email]||'',onClosed:function onClosed(){showActor();isDialogOpen=false;if(options.onFormClose){options.onFormClose();}},onCancel:function onCancel(){closeDialog();showActor();},onSubmit:_handleFeedbackSubmit});if(!dialog.el){throw new Error('Unable to open Feedback dialog');}shadow.appendChild(dialog.el);// Hides the default actor whenever dialog is opened
hideActor();if(options.onFormOpen){options.onFormOpen();}handleOpenDialog();}catch(err){// TODO: Error handling?
__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error(err);}}/**
   * Closes the dialog
   */function closeDialog(){if(dialog){dialog.close();isDialogOpen=false;if(options.onFormClose){options.onFormClose();}}}/**
   * Removes the dialog element from DOM
   */function removeDialog(){if(dialog){closeDialog();var dialogEl=dialog.el;dialogEl&&dialogEl.remove();dialog=undefined;}}/**
   *
   */function handleActorClick(){// Open dialog
if(!isDialogOpen){openDialog();}// Hide actor button
hideActor();}if(attachTo){attachTo.addEventListener('click',handleActorClick);}else if(shouldCreateActor){actor=Actor({buttonLabel:options.buttonLabel,onClick:handleActorClick});actor.el&&shadow.appendChild(actor.el);}return{get actor(){return actor;},get dialog(){return dialog;},showActor:showActor,hideActor:hideActor,removeActor:removeActor,openDialog:openDialog,closeDialog:closeDialog,removeDialog:removeDialog};}var doc=WINDOW.document;var feedbackIntegration=function feedbackIntegration(options){// eslint-disable-next-line deprecation/deprecation
return new Feedback(options);};/**
 * Feedback integration. When added as an integration to the SDK, it will
 * inject a button in the bottom-right corner of the window that opens a
 * feedback modal when clicked.
 *
 * @deprecated Use `feedbackIntegration()` instead.
 */var Feedback=/*#__PURE__*/function(){_createClass(Feedback,null,[{key:"__initStatic",/**
   * @inheritDoc
   */value:function __initStatic(){this.id='Feedback';}/**
   * @inheritDoc
   *//**
   * Feedback configuration options
   *//**
   * Reference to widget element that is created when autoInject is true
   *//**
   * List of all widgets that are created from the integration
   *//**
   * Reference to the host element where widget is inserted
   *//**
   * Refernce to Shadow DOM root
   *//**
   * Tracks if actor styles have ever been inserted into shadow DOM
   */}]);function Feedback(){var _ref14=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},_ref14$autoInject=_ref14.autoInject,autoInject=_ref14$autoInject===void 0?true:_ref14$autoInject,_ref14$id=_ref14.id,id=_ref14$id===void 0?'sentry-feedback':_ref14$id,_ref14$isEmailRequire=_ref14.isEmailRequired,isEmailRequired=_ref14$isEmailRequire===void 0?false:_ref14$isEmailRequire,_ref14$isNameRequired=_ref14.isNameRequired,isNameRequired=_ref14$isNameRequired===void 0?false:_ref14$isNameRequired,_ref14$showBranding=_ref14.showBranding,showBranding=_ref14$showBranding===void 0?true:_ref14$showBranding,_ref14$showEmail=_ref14.showEmail,showEmail=_ref14$showEmail===void 0?true:_ref14$showEmail,_ref14$showName=_ref14.showName,showName=_ref14$showName===void 0?true:_ref14$showName,_ref14$useSentryUser=_ref14.useSentryUser,useSentryUser=_ref14$useSentryUser===void 0?{email:'email',name:'username'}:_ref14$useSentryUser,themeDark=_ref14.themeDark,themeLight=_ref14.themeLight,_ref14$colorScheme=_ref14.colorScheme,colorScheme=_ref14$colorScheme===void 0?'system':_ref14$colorScheme,_ref14$buttonLabel=_ref14.buttonLabel,buttonLabel=_ref14$buttonLabel===void 0?ACTOR_LABEL:_ref14$buttonLabel,_ref14$cancelButtonLa=_ref14.cancelButtonLabel,cancelButtonLabel=_ref14$cancelButtonLa===void 0?CANCEL_BUTTON_LABEL:_ref14$cancelButtonLa,_ref14$submitButtonLa=_ref14.submitButtonLabel,submitButtonLabel=_ref14$submitButtonLa===void 0?SUBMIT_BUTTON_LABEL:_ref14$submitButtonLa,_ref14$formTitle=_ref14.formTitle,formTitle=_ref14$formTitle===void 0?FORM_TITLE:_ref14$formTitle,_ref14$emailPlacehold=_ref14.emailPlaceholder,emailPlaceholder=_ref14$emailPlacehold===void 0?EMAIL_PLACEHOLDER:_ref14$emailPlacehold,_ref14$emailLabel=_ref14.emailLabel,emailLabel=_ref14$emailLabel===void 0?EMAIL_LABEL:_ref14$emailLabel,_ref14$messagePlaceho=_ref14.messagePlaceholder,messagePlaceholder=_ref14$messagePlaceho===void 0?MESSAGE_PLACEHOLDER:_ref14$messagePlaceho,_ref14$messageLabel=_ref14.messageLabel,messageLabel=_ref14$messageLabel===void 0?MESSAGE_LABEL:_ref14$messageLabel,_ref14$namePlaceholde=_ref14.namePlaceholder,namePlaceholder=_ref14$namePlaceholde===void 0?NAME_PLACEHOLDER:_ref14$namePlaceholde,_ref14$nameLabel=_ref14.nameLabel,nameLabel=_ref14$nameLabel===void 0?NAME_LABEL:_ref14$nameLabel,_ref14$isRequiredLabe=_ref14.isRequiredLabel,isRequiredLabel=_ref14$isRequiredLabe===void 0?IS_REQUIRED_LABEL:_ref14$isRequiredLabe,_ref14$successMessage=_ref14.successMessageText,successMessageText=_ref14$successMessage===void 0?SUCCESS_MESSAGE_TEXT:_ref14$successMessage,onFormClose=_ref14.onFormClose,onFormOpen=_ref14.onFormOpen,onSubmitError=_ref14.onSubmitError,onSubmitSuccess=_ref14.onSubmitSuccess;_classCallCheck(this,Feedback);// eslint-disable-next-line deprecation/deprecation
this.name=Feedback.id;// tsc fails if these are not initialized explicitly constructor, e.g. can't call `_initialize()`
this._host=null;this._shadow=null;this._widget=null;this._widgets=new Set();this._hasInsertedActorStyles=false;this.options={autoInject:autoInject,showBranding:showBranding,id:id,isEmailRequired:isEmailRequired,isNameRequired:isNameRequired,showEmail:showEmail,showName:showName,useSentryUser:useSentryUser,colorScheme:colorScheme,themeDark:_objectSpread({},DEFAULT_THEME.dark,{},themeDark),themeLight:_objectSpread({},DEFAULT_THEME.light,{},themeLight),buttonLabel:buttonLabel,cancelButtonLabel:cancelButtonLabel,submitButtonLabel:submitButtonLabel,formTitle:formTitle,emailLabel:emailLabel,emailPlaceholder:emailPlaceholder,messageLabel:messageLabel,messagePlaceholder:messagePlaceholder,nameLabel:nameLabel,namePlaceholder:namePlaceholder,isRequiredLabel:isRequiredLabel,successMessageText:successMessageText,onFormClose:onFormClose,onFormOpen:onFormOpen,onSubmitError:onSubmitError,onSubmitSuccess:onSubmitSuccess};}/**
   * Setup and initialize feedback container
   */_createClass(Feedback,[{key:"setupOnce",value:function setupOnce(){if(!Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_8" /* isBrowser */])()){return;}try{this._cleanupWidgetIfExists();var autoInject=this.options.autoInject;if(!autoInject){// Nothing to do here
return;}this._createWidget(this.options);}catch(err){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error(err);}}/**
   * Allows user to open the dialog box. Creates a new widget if
   * `autoInject` was false, otherwise re-uses the default widget that was
   * created during initialization of the integration.
   */},{key:"openDialog",value:function openDialog(){if(!this._widget){this._createWidget(_objectSpread({},this.options,{shouldCreateActor:false}));}if(!this._widget){return;}this._widget.openDialog();}/**
   * Closes the dialog for the default widget, if it exists
   */},{key:"closeDialog",value:function closeDialog(){if(!this._widget){// Nothing to do if widget does not exist
return;}this._widget.closeDialog();}/**
   * Adds click listener to attached element to open a feedback dialog
   */},{key:"attachTo",value:function attachTo(el,optionOverrides){var _this=this;try{var options=mergeOptions(this.options,optionOverrides||{});return this._ensureShadowHost(options,function(_ref15){var shadow=_ref15.shadow;var targetEl=typeof el==='string'?doc.querySelector(el):typeof el.addEventListener==='function'?el:null;if(!targetEl){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error('[Feedback] Unable to attach to target element');return null;}var widget=createWidget({shadow:shadow,options:options,attachTo:targetEl});_this._widgets.add(widget);if(!_this._widget){_this._widget=widget;}return widget;});}catch(err){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error(err);return null;}}/**
   * Creates a new widget. Accepts partial options to override any options passed to constructor.
   */},{key:"createWidget",value:function createWidget(optionOverrides){try{return this._createWidget(mergeOptions(this.options,optionOverrides||{}));}catch(err){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error(err);return null;}}/**
   * Removes a single widget
   */},{key:"removeWidget",value:function removeWidget(widget){if(!widget){return false;}try{if(this._widgets.has(widget)){widget.removeActor();widget.removeDialog();this._widgets.delete(widget);if(this._widget===widget){// TODO: is more clean-up needed? e.g. call remove()
this._widget=null;}return true;}}catch(err){DEBUG_BUILD&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].error(err);}return false;}/**
   * Returns the default (first-created) widget
   */},{key:"getWidget",value:function getWidget(){return this._widget;}/**
   * Removes the Feedback integration (including host, shadow DOM, and all widgets)
   */},{key:"remove",value:function remove(){if(this._host){this._host.remove();}this._initialize();}/**
   * Initializes values of protected properties
   */},{key:"_initialize",value:function _initialize(){this._host=null;this._shadow=null;this._widget=null;this._widgets=new Set();this._hasInsertedActorStyles=false;}/**
   * Clean-up the widget if it already exists in the DOM. This shouldn't happen
   * in prod, but can happen in development with hot module reloading.
   */},{key:"_cleanupWidgetIfExists",value:function _cleanupWidgetIfExists(){if(this._host){this.remove();}var existingFeedback=doc.querySelector("#".concat(this.options.id));if(existingFeedback){existingFeedback.remove();}}/**
   * Creates a new widget, after ensuring shadow DOM exists
   */},{key:"_createWidget",value:function _createWidget(options){var _this2=this;return this._ensureShadowHost(options,function(_ref16){var shadow=_ref16.shadow;var widget=createWidget({shadow:shadow,options:options});if(!_this2._hasInsertedActorStyles&&widget.actor){shadow.appendChild(createActorStyles(doc));_this2._hasInsertedActorStyles=true;}_this2._widgets.add(widget);if(!_this2._widget){_this2._widget=widget;}return widget;});}/**
   * Ensures that shadow DOM exists and is added to the DOM
   */},{key:"_ensureShadowHost",value:function _ensureShadowHost(options,cb){var needsAppendHost=false;// Don't create if it already exists
if(!this._shadow||!this._host){var id=options.id,colorScheme=options.colorScheme,themeLight=options.themeLight,themeDark=options.themeDark;var _createShadowHost=createShadowHost({id:id,colorScheme:colorScheme,themeLight:themeLight,themeDark:themeDark}),shadow=_createShadowHost.shadow,host=_createShadowHost.host;this._shadow=shadow;this._host=host;needsAppendHost=true;}// set data attribute on host for different themes
this._host.dataset.sentryFeedbackColorscheme=options.colorScheme;var result=cb({shadow:this._shadow,host:this._host});if(needsAppendHost){doc.body.appendChild(this._host);}return result;}}]);return Feedback;}();Feedback.__initStatic();

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__captureconsole_js__ = __webpack_require__(684);
/* unused harmony reexport CaptureConsole */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__captureconsole_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__debug_js__ = __webpack_require__(685);
/* unused harmony reexport Debug */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__debug_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dedupe_js__ = __webpack_require__(686);
/* unused harmony reexport Dedupe */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__dedupe_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extraerrordata_js__ = __webpack_require__(687);
/* unused harmony reexport ExtraErrorData */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__extraerrordata_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__offline_js__ = __webpack_require__(688);
/* unused harmony reexport Offline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reportingobserver_js__ = __webpack_require__(690);
/* unused harmony reexport ReportingObserver */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__reportingobserver_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rewriteframes_js__ = __webpack_require__(691);
/* unused harmony reexport RewriteFrames */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__rewriteframes_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sessiontiming_js__ = __webpack_require__(692);
/* unused harmony reexport SessionTiming */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__sessiontiming_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transaction_js__ = __webpack_require__(693);
/* unused harmony reexport Transaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__httpclient_js__ = __webpack_require__(694);
/* unused harmony reexport HttpClient */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__httpclient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contextlines_js__ = __webpack_require__(695);
/* unused harmony reexport ContextLines */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_10__contextlines_js__["a"]; });


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CaptureConsole */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return captureConsoleIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
var INTEGRATION_NAME='CaptureConsole';var _captureConsoleIntegration=function _captureConsoleIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var levels=options.levels||__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* CONSOLE_LEVELS */];return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
setup:function setup(client){if(!('console'in __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* GLOBAL_OBJ */])){return;}Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* addConsoleInstrumentationHandler */])(function(_ref){var args=_ref.args,level=_ref.level;if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])()!==client||!levels.includes(level)){return;}consoleHandler(args,level);});}};};var captureConsoleIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_captureConsoleIntegration);/**
 * Send Console API calls as Sentry Events.
 * @deprecated Use `captureConsoleIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var CaptureConsole=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,captureConsoleIntegration);function consoleHandler(args,level){var captureContext={level:Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_41" /* severityLevelFromString */])(level),extra:{arguments:args}};Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_35" /* withScope */])(function(scope){scope.addEventProcessor(function(event){event.logger='console';Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* addExceptionMechanism */])(event,{handled:false,type:'console'});return event;});if(level==='assert'&&args[0]===false){var _message="Assertion failed: ".concat(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_39" /* safeJoin */])(args.slice(1),' ')||'console.assert');scope.setExtra('arguments',args.slice(1));Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["x" /* captureMessage */])(_message,captureContext);return;}var error=args.find(function(arg){return arg instanceof Error;});if(level==='error'&&error){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["w" /* captureException */])(error,captureContext);return;}var message=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_39" /* safeJoin */])(args,' ');Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["x" /* captureMessage */])(message,captureContext);});}

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Debug */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return debugIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INTEGRATION_NAME='Debug';var _debugIntegration=function _debugIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _options=_objectSpread({debugger:false,stringify:false},options);return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
setup:function setup(client){if(!client.on){return;}client.on('beforeSendEvent',function(event,hint){if(_options.debugger){// eslint-disable-next-line no-debugger
debugger;}/* eslint-disable no-console */Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["A" /* consoleSandbox */])(function(){if(_options.stringify){console.log(JSON.stringify(event,null,2));if(hint&&Object.keys(hint).length){console.log(JSON.stringify(hint,null,2));}}else{console.log(event);if(hint&&Object.keys(hint).length){console.log(hint);}}});/* eslint-enable no-console */});}};};var debugIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_debugIntegration);/**
 * Integration to debug sent Sentry events.
 * This integration should not be used in production.
 *
 * @deprecated Use `debugIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var Debug=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,debugIntegration);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Dedupe */
/* unused harmony export _shouldDropEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dedupeIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(140);
var INTEGRATION_NAME='Dedupe';var _dedupeIntegration=function _dedupeIntegration(){var previousEvent;return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
processEvent:function processEvent(currentEvent){// We want to ignore any non-error type events, e.g. transactions or replays
// These should never be deduped, and also not be compared against as _previousEvent.
if(currentEvent.type){return currentEvent;}// Juuust in case something goes wrong
try{if(_shouldDropEvent(currentEvent,previousEvent)){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('Event dropped due to being a duplicate of previously captured event.');return null;}}catch(_oO){}// eslint-disable-line no-empty
return previousEvent=currentEvent;}};};var dedupeIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_dedupeIntegration);/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var Dedupe=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,dedupeIntegration);/** only exported for tests. */function _shouldDropEvent(currentEvent,previousEvent){if(!previousEvent){return false;}if(_isSameMessageEvent(currentEvent,previousEvent)){return true;}if(_isSameExceptionEvent(currentEvent,previousEvent)){return true;}return false;}function _isSameMessageEvent(currentEvent,previousEvent){var currentMessage=currentEvent.message;var previousMessage=previousEvent.message;// If neither event has a message property, they were both exceptions, so bail out
if(!currentMessage&&!previousMessage){return false;}// If only one event has a stacktrace, but not the other one, they are not the same
if(currentMessage&&!previousMessage||!currentMessage&&previousMessage){return false;}if(currentMessage!==previousMessage){return false;}if(!_isSameFingerprint(currentEvent,previousEvent)){return false;}if(!_isSameStacktrace(currentEvent,previousEvent)){return false;}return true;}function _isSameExceptionEvent(currentEvent,previousEvent){var previousException=_getExceptionFromEvent(previousEvent);var currentException=_getExceptionFromEvent(currentEvent);if(!previousException||!currentException){return false;}if(previousException.type!==currentException.type||previousException.value!==currentException.value){return false;}if(!_isSameFingerprint(currentEvent,previousEvent)){return false;}if(!_isSameStacktrace(currentEvent,previousEvent)){return false;}return true;}function _isSameStacktrace(currentEvent,previousEvent){var currentFrames=_getFramesFromEvent(currentEvent);var previousFrames=_getFramesFromEvent(previousEvent);// If neither event has a stacktrace, they are assumed to be the same
if(!currentFrames&&!previousFrames){return true;}// If only one event has a stacktrace, but not the other one, they are not the same
if(currentFrames&&!previousFrames||!currentFrames&&previousFrames){return false;}currentFrames=currentFrames;previousFrames=previousFrames;// If number of frames differ, they are not the same
if(previousFrames.length!==currentFrames.length){return false;}// Otherwise, compare the two
for(var i=0;i<previousFrames.length;i++){var frameA=previousFrames[i];var frameB=currentFrames[i];if(frameA.filename!==frameB.filename||frameA.lineno!==frameB.lineno||frameA.colno!==frameB.colno||frameA.function!==frameB.function){return false;}}return true;}function _isSameFingerprint(currentEvent,previousEvent){var currentFingerprint=currentEvent.fingerprint;var previousFingerprint=previousEvent.fingerprint;// If neither event has a fingerprint, they are assumed to be the same
if(!currentFingerprint&&!previousFingerprint){return true;}// If only one event has a fingerprint, but not the other one, they are not the same
if(currentFingerprint&&!previousFingerprint||!currentFingerprint&&previousFingerprint){return false;}currentFingerprint=currentFingerprint;previousFingerprint=previousFingerprint;// Otherwise, compare the two
try{return!!(currentFingerprint.join('')===previousFingerprint.join(''));}catch(_oO){return false;}}function _getExceptionFromEvent(event){return event.exception&&event.exception.values&&event.exception.values[0];}function _getFramesFromEvent(event){var exception=event.exception;if(exception){try{// @ts-expect-error Object could be undefined
return exception.values[0].stacktrace.frames;}catch(_oO){return undefined;}}return undefined;}

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExtraErrorData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return extraErrorDataIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(140);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INTEGRATION_NAME='ExtraErrorData';var _extraErrorDataIntegration=function _extraErrorDataIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var depth=options.depth||3;// TODO(v8): Flip the default for this option to true
var captureErrorCause=options.captureErrorCause||false;return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
processEvent:function processEvent(event,hint){return _enhanceEventWithErrorData(event,hint,depth,captureErrorCause);}};};var extraErrorDataIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_extraErrorDataIntegration);/**
 * Extract additional data for from original exceptions.
 * @deprecated Use `extraErrorDataIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var ExtraErrorData=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,extraErrorDataIntegration);function _enhanceEventWithErrorData(event){var hint=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var depth=arguments.length>2?arguments[2]:undefined;var captureErrorCause=arguments.length>3?arguments[3]:undefined;if(!hint.originalException||!Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_11" /* isError */])(hint.originalException)){return event;}var exceptionName=hint.originalException.name||hint.originalException.constructor.name;var errorData=_extractErrorData(hint.originalException,captureErrorCause);if(errorData){var contexts=_objectSpread({},event.contexts);var normalizedErrorData=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_30" /* normalize */])(errorData,depth);if(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_19" /* isPlainObject */])(normalizedErrorData)){// We mark the error data as "already normalized" here, because we don't want other normalization procedures to
// potentially truncate the data we just already normalized, with a certain depth setting.
Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["s" /* addNonEnumerableProperty */])(normalizedErrorData,'__sentry_skip_normalization__',true);contexts[exceptionName]=normalizedErrorData;}return _objectSpread({},event,{contexts:contexts});}return event;}/**
 * Extract extra information from the Error object
 */function _extractErrorData(error,captureErrorCause){// We are trying to enhance already existing event, so no harm done if it won't succeed
try{var nativeKeys=['name','message','stack','line','column','fileName','lineNumber','columnNumber','toJSON'];var extraErrorInfo={};// We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
for(var _i=0,_Object$keys=Object.keys(error);_i<_Object$keys.length;_i++){var _key=_Object$keys[_i];if(nativeKeys.indexOf(_key)!==-1){continue;}var _value=error[_key];extraErrorInfo[_key]=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_11" /* isError */])(_value)?_value.toString():_value;}// Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
if(captureErrorCause&&error.cause!==undefined){extraErrorInfo.cause=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_11" /* isError */])(error.cause)?error.cause.toString():error.cause;}// Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
if(typeof error.toJSON==='function'){var serializedError=error.toJSON();for(var _i2=0,_Object$keys2=Object.keys(serializedError);_i2<_Object$keys2.length;_i2++){var key=_Object$keys2[_i2];var value=serializedError[key];extraErrorInfo[key]=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_11" /* isError */])(value)?value.toString():value;}}return extraErrorInfo;}catch(oO){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].error('Unable to extract extra data from the Error object:',oO);}return null;}

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Offline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(140);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}var WINDOW=__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* GLOBAL_OBJ */];/**
 * cache offline errors and send when connected
 * @deprecated The offline integration has been deprecated in favor of the offline transport wrapper.
 *
 * http://docs.sentry.io/platforms/javascript/configuration/transports/#offline-caching
 */var Offline=/*#__PURE__*/function(){_createClass(Offline,null,[{key:"__initStatic",/**
   * @inheritDoc
   */value:function __initStatic(){this.id='Offline';}/**
   * @inheritDoc
   *//**
   * the current hub instance
   *//**
   * maximum number of events to store while offline
   *//**
   * event cache
   *//**
   * @inheritDoc
   */}]);function Offline(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_classCallCheck(this,Offline);this.name=Offline.id;this.maxStoredEvents=options.maxStoredEvents||30;// set a reasonable default
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
this.offlineEventStore=__WEBPACK_IMPORTED_MODULE_1_localforage__["createInstance"]({name:'sentry/offlineEventStore'});}/**
   * @inheritDoc
   */_createClass(Offline,[{key:"setupOnce",value:function setupOnce(addGlobalEventProcessor,getCurrentHub){var _this=this;this.hub=getCurrentHub();if('addEventListener'in WINDOW){WINDOW.addEventListener('online',function(){void _this._sendEvents().catch(function(){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('could not send cached events');});});}var eventProcessor=function eventProcessor(event){// eslint-disable-next-line deprecation/deprecation
if(_this.hub&&_this.hub.getIntegration(Offline)){// cache if we are positively offline
if('navigator'in WINDOW&&'onLine'in WINDOW.navigator&&!WINDOW.navigator.onLine){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].log('Event dropped due to being a offline - caching instead');void _this._cacheEvent(event).then(function(_event){return _this._enforceMaxEvents();}).catch(function(_error){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('could not cache event while offline');});// return null on success or failure, because being offline will still result in an error
return null;}}return event;};eventProcessor.id=this.name;addGlobalEventProcessor(eventProcessor);// if online now, send any events stored in a previous offline session
if('navigator'in WINDOW&&'onLine'in WINDOW.navigator&&WINDOW.navigator.onLine){void this._sendEvents().catch(function(){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('could not send cached events');});}}/**
   * cache an event to send later
   * @param event an event
   */},{key:"_cacheEvent",value:function(){var _cacheEvent2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(event){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt("return",this.offlineEventStore.setItem(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_53" /* uuid4 */])(),Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_30" /* normalize */])(event)));case 1:case"end":return _context.stop();}}},_callee,this);}));function _cacheEvent(_x){return _cacheEvent2.apply(this,arguments);}return _cacheEvent;}()/**
   * purge excess events if necessary
   */},{key:"_enforceMaxEvents",value:function(){var _enforceMaxEvents2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var _this2=this;var events;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:events=[];return _context2.abrupt("return",this.offlineEventStore.iterate(function(event,cacheKey,_index){// aggregate events
events.push({cacheKey:cacheKey,event:event});}).then(function(){return(// this promise resolves when the iteration is finished
_this2._purgeEvents(// purge all events past maxStoredEvents in reverse chronological order
events.sort(function(a,b){return(b.event.timestamp||0)-(a.event.timestamp||0);}).slice(_this2.maxStoredEvents<events.length?_this2.maxStoredEvents:events.length).map(function(event){return event.cacheKey;})));}).catch(function(_error){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('could not enforce max events');}));case 2:case"end":return _context2.stop();}}},_callee2,this);}));function _enforceMaxEvents(){return _enforceMaxEvents2.apply(this,arguments);}return _enforceMaxEvents;}()/**
   * purge event from cache
   */},{key:"_purgeEvent",value:function(){var _purgeEvent2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(cacheKey){return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:return _context3.abrupt("return",this.offlineEventStore.removeItem(cacheKey));case 1:case"end":return _context3.stop();}}},_callee3,this);}));function _purgeEvent(_x2){return _purgeEvent2.apply(this,arguments);}return _purgeEvent;}()/**
   * purge events from cache
   */},{key:"_purgeEvents",value:function(){var _purgeEvents2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(cacheKeys){var _this3=this;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:return _context4.abrupt("return",Promise.all(cacheKeys.map(function(cacheKey){return _this3._purgeEvent(cacheKey);})).then());case 1:case"end":return _context4.stop();}}},_callee4);}));function _purgeEvents(_x3){return _purgeEvents2.apply(this,arguments);}return _purgeEvents;}()/**
   * send all events
   */},{key:"_sendEvents",value:function(){var _sendEvents2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(){var _this4=this;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:return _context5.abrupt("return",this.offlineEventStore.iterate(function(event,cacheKey,_index){if(_this4.hub){_this4.hub.captureEvent(event);void _this4._purgeEvent(cacheKey).catch(function(_error){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('could not purge event from cache');});}else{__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["_26" /* logger */].warn('no hub found - could not send cached event');}}));case 1:case"end":return _context5.stop();}}},_callee5,this);}));function _sendEvents(){return _sendEvents2.apply(this,arguments);}return _sendEvents;}()}]);return Offline;}();Offline.__initStatic();

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(1);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"1":1}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(2);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"2":2}],4:[function(_dereq_,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {
        return;
    }
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb || !idb.open) {
            return false;
        }
        // We mimic PouchDB here;
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

        // Safari <10.1 does not meet our requirements for IDB support
        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
        // Safari 10.1 shipped with fetch, we can use that to detect it.
        // Note: this creates issues with `window.fetch` polyfills and
        // overrides; see:
        // https://github.com/localForage/localForage/issues/856
        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        // See: https://github.com/mozilla/localForage/issues/128
        // See: https://github.com/mozilla/localForage/issues/272
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined') {
    // In the "nopromises" build this will just throw if you don't have
    // a global promise object, but it would throw anyway later.
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    return key;
}

function getCallback() {
    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
        return arguments[arguments.length - 1];
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs = void 0;
var dbContexts = {};
var toString = Object.prototype.toString;

// Transaction Modes
var READ_ONLY = 'readonly';
var READ_WRITE = 'readwrite';

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
//
function _checkBlobSupportWithoutCaching(idb) {
    return new Promise$1(function (resolve) {
        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve, reject) {
        deferredOperation.resolve = resolve;
        deferredOperation.reject = reject;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
        return deferredOperation.promise;
    }
}

function _rejectReadiness(dbInfo, err) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Reject its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.reject(err);
        return deferredOperation.promise;
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {
        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function (e) {
            e.preventDefault();
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            var db = openreq.result;
            db.onversionchange = function (e) {
                // Triggered when the database is modified (e.g. adding an objectStore) or
                // deleted (even when initiated by other sessions in different tabs).
                // Closing the connection here prevents those operations from being blocked.
                // If the database is accessed again later by this instance, the connection
                // will be reopened or the database recreated as needed.
                e.target.close();
            };
            resolve(db);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Try to establish a new db connection to replace the
// current one which is broken (i.e. experiencing
// InvalidStateError while creating a transaction).
function _tryReconnect(dbInfo) {
    _deferReadiness(dbInfo);

    var dbContext = dbContexts[dbInfo.name];
    var forages = dbContext.forages;

    for (var i = 0; i < forages.length; i++) {
        var forage = forages[i];
        if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
        }
    }
    dbInfo.db = null;

    return _getOriginalConnection(dbInfo).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        // store the latest db reference
        // in case the db was upgraded
        dbInfo.db = dbContext.db = db;
        for (var i = 0; i < forages.length; i++) {
            forages[i]._dbInfo.db = db;
        }
    })["catch"](function (err) {
        _rejectReadiness(dbInfo, err);
        throw err;
    });
}

// FF doesn't like Promises (micro-tasks) and IDDB store operations,
// so we have to do it with callbacks
function createTransaction(dbInfo, mode, callback, retries) {
    if (retries === undefined) {
        retries = 1;
    }

    try {
        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
        callback(null, tx);
    } catch (err) {
        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
            return Promise$1.resolve().then(function () {
                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    // increase the db version, to create the new ObjectStore
                    if (dbInfo.db) {
                        dbInfo.version = dbInfo.db.version + 1;
                    }
                    // Reopen the database for upgrading.
                    return _getUpgradedConnection(dbInfo);
                }
            }).then(function () {
                return _tryReconnect(dbInfo).then(function () {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                });
            })["catch"](callback);
        }

        callback(err);
    }
}

function createDbContext() {
    return {
        // Running localForages sharing a database.
        forages: [],
        // Shared database.
        db: null,
        // Database readiness (promise).
        dbReady: null,
        // Deferred operations on the database.
        deferredOperations: []
    };
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = createDbContext();
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.get(key);

                    req.onsuccess = function () {
                        var value = req.result;
                        if (value === undefined) {
                            value = null;
                        }
                        if (_isEncodedBlob(value)) {
                            value = _decodeBlob(value);
                        }
                        resolve(value);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (cursor) {
                            var value = cursor.value;
                            if (_isEncodedBlob(value)) {
                                value = _decodeBlob(value);
                            }
                            var result = iterator(value, cursor.key, iterationNumber++);

                            // when the iterator callback returns any
                            // (non-`undefined`) value, then we stop
                            // the iteration immediately
                            if (result !== void 0) {
                                resolve(result);
                            } else {
                                cursor["continue"]();
                            }
                        } else {
                            resolve();
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);

                    // The reason we don't _save_ null is because IE 10 does
                    // not support saving the `null` type in IndexedDB. How
                    // ironic, given the bug below!
                    // See: https://github.com/mozilla/localForage/issues/161
                    if (value === null) {
                        value = undefined;
                    }

                    var req = store.put(value, key);

                    transaction.oncomplete = function () {
                        // Cast to undefined so the value passed to
                        // callback/promise is the same as what one would get out
                        // of `getItem()` later. This leads to some weirdness
                        // (setItem('foo', undefined) will return `null`), but
                        // it's not my fault localStorage is our baseline and that
                        // it's weird.
                        if (value === undefined) {
                            value = null;
                        }

                        resolve(value);
                    };
                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    // We use a Grunt task to make this safe for IE and some
                    // versions of Android (including those used by Cordova).
                    // Normally IE won't like `.delete()` and will insist on
                    // using `['delete']()`, but we have a build step that
                    // fixes this for us now.
                    var req = store["delete"](key);
                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onerror = function () {
                        reject(req.error);
                    };

                    // The request will be also be aborted if we've exceeded our storage
                    // space.
                    transaction.onabort = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.clear();

                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.count();

                    req.onsuccess = function () {
                        resolve(req.result);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openKeyCursor();

                    req.onsuccess = function () {
                        var cursor = req.result;
                        if (!cursor) {
                            // this means there weren't enough keys
                            resolve(null);

                            return;
                        }

                        if (n === 0) {
                            // We have the first key, return it if that's what they
                            // wanted.
                            resolve(cursor.key);
                        } else {
                            if (!advanced) {
                                // Otherwise, ask the cursor to skip ahead n
                                // records.
                                advanced = true;
                                cursor.advance(n);
                            } else {
                                // When we get here, we've got the nth key.
                                resolve(cursor.key);
                            }
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openKeyCursor();
                    var keys = [];

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (!cursor) {
                            resolve(keys);
                            return;
                        }

                        keys.push(cursor.key);
                        cursor["continue"]();
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
                forages[i]._dbInfo.db = db;
            }
            return db;
        });

        if (!options.storeName) {
            promise = dbPromise.then(function (db) {
                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                }

                var dropDBPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.deleteDatabase(options.name);

                    req.onerror = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        reject(req.error);
                    };

                    req.onblocked = function () {
                        // Closing all open connections in onversionchange handler should prevent this situation, but if
                        // we do get here, it just means the request remains pending - eventually it will succeed or error
                        console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        resolve(db);
                    };
                });

                return dropDBPromise.then(function (db) {
                    dbContext.db = db;
                    for (var i = 0; i < forages.length; i++) {
                        var _forage = forages[i];
                        _advanceReadiness(_forage._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        } else {
            promise = dbPromise.then(function (db) {
                if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                }

                var newVersion = db.version + 1;

                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                }

                var dropObjectPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.open(options.name, newVersion);

                    req.onerror = function (err) {
                        var db = req.result;
                        db.close();
                        reject(err);
                    };

                    req.onupgradeneeded = function () {
                        var db = req.result;
                        db.deleteObjectStore(options.storeName);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        db.close();
                        resolve(db);
                    };
                });

                return dropObjectPromise.then(function (db) {
                    dbContext.db = db;
                    for (var j = 0; j < forages.length; j++) {
                        var _forage2 = forages[j];
                        _forage2._dbInfo.db = db;
                        _advanceReadiness(_forage2._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        }
    }

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    _support: isIndexedDBValid(),
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys,
    dropInstance: dropInstance
};

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        /*jslint bitwise: true */
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};

/*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

function createDbTable(t, dbInfo, callback, errorCallback) {
    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
}

// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            createDbTable(t, dbInfo, function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        }, reject);
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
    t.executeSql(sqlStatement, args, callback, function (t, error) {
        if (error.code === error.SYNTAX_ERR) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
                if (!results.rows.length) {
                    // if the table is missing (was deleted)
                    // re-create it table and retry
                    createDbTable(t, dbInfo, function () {
                        t.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                } else {
                    errorCallback(t, error);
                }
            }, errorCallback);
        } else {
            errorCallback(t, error);
        }
    }, errorCallback);
}

function getItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function _setItem(key, value, callback, retriesLeft) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // Try to re-run the transaction.
                            if (retriesLeft > 0) {
                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
                                return;
                            }
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    return _setItem.apply(this, [key, value, callback, 1]);
}

function removeItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// https://www.w3.org/TR/webdatabase/#databases
// > There is no way to enumerate or delete the databases available for an origin from this API.
function getAllStoreNames(db) {
    return new Promise$1(function (resolve, reject) {
        db.transaction(function (t) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
                var storeNames = [];

                for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                }

                resolve({
                    db: db,
                    storeNames: storeNames
                });
            }, function (t, error) {
                reject(error);
            });
        }, function (sqlError) {
            reject(sqlError);
        });
    });
}

function dropInstance$1(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            var db;
            if (options.name === currentConfig.name) {
                // use the db reference of the current instance
                db = self._dbInfo.db;
            } else {
                db = openDatabase(options.name, '', '', 0);
            }

            if (!options.storeName) {
                // drop all database tables
                resolve(getAllStoreNames(db));
            } else {
                resolve({
                    db: db,
                    storeNames: [options.storeName]
                });
            }
        }).then(function (operationInfo) {
            return new Promise$1(function (resolve, reject) {
                operationInfo.db.transaction(function (t) {
                    function dropTable(storeName) {
                        return new Promise$1(function (resolve, reject) {
                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
                                resolve();
                            }, function (t, error) {
                                reject(error);
                            });
                        });
                    }

                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                        operations.push(dropTable(operationInfo.storeNames[i]));
                    }

                    Promise$1.all(operations).then(function () {
                        resolve();
                    })["catch"](function (e) {
                        reject(e);
                    });
                }, function (sqlError) {
                    reject(sqlError);
                });
            });
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    _support: isWebSQLValid(),
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1,
    dropInstance: dropInstance$1
};

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
        // in IE8 typeof localStorage.setItem === 'object'
        !!localStorage.setItem;
    } catch (e) {
        return false;
    }
}

function _getKeyPrefix(options, defaultConfig) {
    var keyPrefix = options.name + '/';

    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}

// Check if localStorage throws when saving an item
function checkIfLocalStorageThrows() {
    var localStorageTestKey = '_localforage_support_test';

    try {
        localStorage.setItem(localStorageTestKey, true);
        localStorage.removeItem(localStorageTestKey);

        return false;
    } catch (e) {
        return true;
    }
}

// Check if localStorage is usable and allows to save an item
// This method checks if localStorage is usable in Safari Private Browsing
// mode, or in any other case where the available quota for localStorage
// is 0 and there wasn't any saved items yet.
function _isLocalStorageUsable() {
    return !checkIfLocalStorageThrows() || localStorage.length > 0;
}

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

    if (!_isLocalStorageUsable()) {
        return Promise$1.reject();
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance$2(options, callback) {
    callback = getCallback.apply(this, arguments);

    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        var currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            if (!options.storeName) {
                resolve(options.name + '/');
            } else {
                resolve(_getKeyPrefix(options, self._defaultConfig));
            }
        }).then(function (keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
                var key = localStorage.key(i);

                if (key.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key);
                }
            }
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    _support: isLocalStorageValid(),
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2,
    dropInstance: dropInstance$2
};

var sameValue = function sameValue(x, y) {
    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
};

var includes = function includes(array, searchElement) {
    var len = array.length;
    var i = 0;
    while (i < len) {
        if (sameValue(array[i], searchElement)) {
            return true;
        }
        i++;
    }

    return false;
};

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

// Drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var DefinedDrivers = {};

var DriverSupport = {};

var DefaultDrivers = {
    INDEXEDDB: asyncStorage,
    WEBSQL: webSQLStorage,
    LOCALSTORAGE: localStorageWrapper
};

var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

var OptionalDriverMethods = ['dropInstance'];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var _key in arg) {
                if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                        arguments[0][_key] = arg[_key].slice();
                    } else {
                        arguments[0][_key] = arg[_key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                var driver = DefaultDrivers[driverTypeKey];
                var driverName = driver._driver;
                this[driverTypeKey] = driverName;

                if (!DefinedDrivers[driverName]) {
                    // we don't need to wait for the promise,
                    // since the default drivers can be defined
                    // in a blocking manner
                    this.defineDriver(driver);
                }
            }
        }

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver)["catch"](function () {});
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                if (i === 'version' && typeof options[i] !== 'number') {
                    return new Error('Database version must be a number.');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                return this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }

                var driverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];

                    // when the property is there,
                    // it should be a method even when optional
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var configureMissingMethods = function configureMissingMethods() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                        return function () {
                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                            var promise = Promise$1.reject(error);
                            executeCallback(promise, arguments[arguments.length - 1]);
                            return promise;
                        };
                    };

                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                        var optionalDriverMethod = OptionalDriverMethods[_i];
                        if (!driverObject[optionalDriverMethod]) {
                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                        }
                    }
                };

                configureMissingMethods();

                var setDriverSupport = function setDriverSupport(support) {
                    if (DefinedDrivers[driverName]) {
                        console.info('Redefining LocalForage driver: ' + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    // don't use a then, so that we can define
                    // drivers that have simple _support methods
                    // in a blocking manner
                    resolve();
                };

                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        driverObject._support().then(setDriverSupport, reject);
                    } else {
                        setDriverSupport(!!driverObject._support);
                    }
                } else {
                    setDriverSupport(true);
                }
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function extendSelfWithDriver(driver) {
            self._extend(driver);
            setDriverToConfig();

            self._ready = self._initStorage(self._config);
            return self._ready;
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!DriverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReportingObserver */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportingObserverIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
var WINDOW=__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* GLOBAL_OBJ */];var INTEGRATION_NAME='ReportingObserver';var SETUP_CLIENTS=new WeakMap();var _reportingObserverIntegration=function _reportingObserverIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var types=options.types||['crash','deprecation','intervention'];/** Handler for the reporting observer. */function handler(reports){if(!SETUP_CLIENTS.has(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])())){return;}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{var _loop=function _loop(){var report=_step.value;Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_35" /* withScope */])(function(scope){scope.setExtra('url',report.url);var label="ReportingObserver [".concat(report.type,"]");var details='No details available';if(report.body){// Object.keys doesn't work on ReportBody, as all properties are inheirted
var plainBody={};// eslint-disable-next-line guard-for-in
for(var prop in report.body){plainBody[prop]=report.body[prop];}scope.setExtra('body',plainBody);if(report.type==='crash'){var body=report.body;// A fancy way to create a message out of crashId OR reason OR both OR fallback
details=[body.crashId||'',body.reason||''].join(' ').trim()||details;}else{var _body=report.body;details=_body.message||details;}}Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["x" /* captureMessage */])("".concat(label,": ").concat(details));});};for(var _iterator=reports[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){_loop();}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}return{name:INTEGRATION_NAME,setupOnce:function setupOnce(){if(!Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_47" /* supportsReportingObserver */])()){return;}// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
var observer=new WINDOW.ReportingObserver(handler,{buffered:true,types:types});// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
observer.observe();},setup:function setup(client){SETUP_CLIENTS.set(client,true);}};};var reportingObserverIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_reportingObserverIntegration);/**
 * Reporting API integration - https://w3c.github.io/reporting/
 * @deprecated Use `reportingObserverIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var ReportingObserver=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,reportingObserverIntegration);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RewriteFrames */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rewriteFramesIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INTEGRATION_NAME='RewriteFrames';var _rewriteFramesIntegration=function _rewriteFramesIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var root=options.root;var prefix=options.prefix||'app:///';var iteratee=options.iteratee||function(frame){if(!frame.filename){return frame;}// Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
var isWindowsFrame=/^[a-zA-Z]:\\/.test(frame.filename)||// or the presence of a backslash without a forward slash (which are not allowed on Windows)
frame.filename.includes('\\')&&!frame.filename.includes('/');// Check if the frame filename begins with `/`
var startsWithSlash=/^\//.test(frame.filename);if(isWindowsFrame||startsWithSlash){var filename=isWindowsFrame?frame.filename.replace(/^[a-zA-Z]:/,'')// remove Windows-style prefix
.replace(/\\/g,'/')// replace all `\\` instances with `/`
:frame.filename;var base=root?Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_37" /* relative */])(root,filename):Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["x" /* basename */])(filename);frame.filename="".concat(prefix).concat(base);}return frame;};/** Process an exception event. */function _processExceptionsEvent(event){try{return _objectSpread({},event,{exception:_objectSpread({},event.exception,{// The check for this is performed inside `process` call itself, safe to skip here
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
values:event.exception.values.map(function(value){return _objectSpread({},value,{},value.stacktrace&&{stacktrace:_processStacktrace(value.stacktrace)});})})});}catch(_oO){return event;}}/** Process a stack trace. */function _processStacktrace(stacktrace){return _objectSpread({},stacktrace,{frames:stacktrace&&stacktrace.frames&&stacktrace.frames.map(function(f){return iteratee(f);})});}return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
processEvent:function processEvent(originalEvent){var processedEvent=originalEvent;if(originalEvent.exception&&Array.isArray(originalEvent.exception.values)){processedEvent=_processExceptionsEvent(processedEvent);}return processedEvent;}};};var rewriteFramesIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_rewriteFramesIntegration);/**
 * Rewrite event frames paths.
 * @deprecated Use `rewriteFramesIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var RewriteFrames=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,rewriteFramesIntegration);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SessionTiming */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sessionTimingIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INTEGRATION_NAME='SessionTiming';var _sessionTimingIntegration=function _sessionTimingIntegration(){var startTime=Date.now();return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
processEvent:function processEvent(event){var _objectSpread2;var now=Date.now();return _objectSpread({},event,{extra:_objectSpread({},event.extra,(_objectSpread2={},_defineProperty(_objectSpread2,'session:start',startTime),_defineProperty(_objectSpread2,'session:duration',now-startTime),_defineProperty(_objectSpread2,'session:end',now),_objectSpread2))});}};};var sessionTimingIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_sessionTimingIntegration);/**
 * This function adds duration since Sentry was initialized till the time event was sent.
 * @deprecated Use `sessionTimingIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var SessionTiming=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,sessionTimingIntegration);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Transaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
var INTEGRATION_NAME='Transaction';var transactionIntegration=function transactionIntegration(){return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
processEvent:function processEvent(event){var frames=_getFramesFromEvent(event);// use for loop so we don't have to reverse whole frames array
for(var i=frames.length-1;i>=0;i--){var frame=frames[i];if(frame.in_app===true){event.transaction=_getTransaction(frame);break;}}return event;}};};/**
 * Add node transaction to the event.
 * @deprecated This integration will be removed in v8.
 */// eslint-disable-next-line deprecation/deprecation
var Transaction=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,transactionIntegration);function _getFramesFromEvent(event){var exception=event.exception&&event.exception.values&&event.exception.values[0];return exception&&exception.stacktrace&&exception.stacktrace.frames||[];}function _getTransaction(frame){return frame.module||frame.function?"".concat(frame.module||'?',"/").concat(frame.function||'?'):'<unknown>';}

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HttpClient */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return httpClientIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(140);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var INTEGRATION_NAME='HttpClient';var _httpClientIntegration=function _httpClientIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _options=_objectSpread({failedRequestStatusCodes:[[500,599]],failedRequestTargets:[/.*/]},options);return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
setup:function setup(client){_wrapFetch(client,_options);_wrapXHR(client,_options);}};};var httpClientIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_httpClientIntegration);/**
 * Create events for failed client side HTTP requests.
 * @deprecated Use `httpClientIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var HttpClient=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,httpClientIntegration);/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */function _fetchResponseHandler(options,requestInfo,response,requestInit){if(_shouldCaptureResponse(options,response.status,response.url)){var request=_getRequest(requestInfo,requestInit);var requestHeaders,responseHeaders,requestCookies,responseCookies;if(_shouldSendDefaultPii()){var _map=[{cookieHeader:'Cookie',obj:request},{cookieHeader:'Set-Cookie',obj:response}].map(function(_ref){var cookieHeader=_ref.cookieHeader,obj=_ref.obj;var headers=_extractFetchHeaders(obj.headers);var cookies;try{var cookieString=headers[cookieHeader]||headers[cookieHeader.toLowerCase()]||undefined;if(cookieString){cookies=_parseCookieString(cookieString);}}catch(e){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("Could not extract cookies from header ".concat(cookieHeader));}return{headers:headers,cookies:cookies};});var _map2=_slicedToArray(_map,2);var _map2$=_map2[0];requestHeaders=_map2$.headers;requestCookies=_map2$.cookies;var _map2$2=_map2[1];responseHeaders=_map2$2.headers;responseCookies=_map2$2.cookies;}var event=_createEvent({url:request.url,method:request.method,status:response.status,requestHeaders:requestHeaders,responseHeaders:responseHeaders,requestCookies:requestCookies,responseCookies:responseCookies});Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["v" /* captureEvent */])(event);}}/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */function _xhrResponseHandler(options,xhr,method,headers){if(_shouldCaptureResponse(options,xhr.status,xhr.responseURL)){var requestHeaders,responseCookies,responseHeaders;if(_shouldSendDefaultPii()){try{var cookieString=xhr.getResponseHeader('Set-Cookie')||xhr.getResponseHeader('set-cookie')||undefined;if(cookieString){responseCookies=_parseCookieString(cookieString);}}catch(e){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('Could not extract cookies from response headers');}try{responseHeaders=_getXHRResponseHeaders(xhr);}catch(e){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('Could not extract headers from response');}requestHeaders=headers;}var event=_createEvent({url:xhr.responseURL,method:method,status:xhr.status,requestHeaders:requestHeaders,// Can't access request cookies from XHR
responseHeaders:responseHeaders,responseCookies:responseCookies});Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["v" /* captureEvent */])(event);}}/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */function _getResponseSizeFromHeaders(headers){if(headers){var contentLength=headers['Content-Length']||headers['content-length'];if(contentLength){return parseInt(contentLength,10);}}return undefined;}/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */function _parseCookieString(cookieString){return cookieString.split('; ').reduce(function(acc,cookie){var _cookie$split=cookie.split('='),_cookie$split2=_slicedToArray(_cookie$split,2),key=_cookie$split2[0],value=_cookie$split2[1];acc[key]=value;return acc;},{});}/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */function _extractFetchHeaders(headers){var result={};headers.forEach(function(value,key){result[key]=value;});return result;}/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */function _getXHRResponseHeaders(xhr){var headers=xhr.getAllResponseHeaders();if(!headers){return{};}return headers.split('\r\n').reduce(function(acc,line){var _line$split=line.split(': '),_line$split2=_slicedToArray(_line$split,2),key=_line$split2[0],value=_line$split2[1];acc[key]=value;return acc;},{});}/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */function _isInGivenRequestTargets(failedRequestTargets,target){return failedRequestTargets.some(function(givenRequestTarget){if(typeof givenRequestTarget==='string'){return target.includes(givenRequestTarget);}return givenRequestTarget.test(target);});}/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */function _isInGivenStatusRanges(failedRequestStatusCodes,status){return failedRequestStatusCodes.some(function(range){if(typeof range==='number'){return range===status;}return status>=range[0]&&status<=range[1];});}/**
 * Wraps `fetch` function to capture request and response data
 */function _wrapFetch(client,options){if(!Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_46" /* supportsNativeFetch */])()){return;}Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* addFetchInstrumentationHandler */])(function(handlerData){if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])()!==client){return;}var response=handlerData.response,args=handlerData.args;var _args=_slicedToArray(args,2),requestInfo=_args[0],requestInit=_args[1];if(!response){return;}_fetchResponseHandler(options,requestInfo,response,requestInit);});}/**
 * Wraps XMLHttpRequest to capture request and response data
 */function _wrapXHR(client,options){if(!('XMLHttpRequest'in __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* GLOBAL_OBJ */])){return;}Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* addXhrInstrumentationHandler */])(function(handlerData){if(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])()!==client){return;}var xhr=handlerData.xhr;var sentryXhrData=xhr[__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SENTRY_XHR_DATA_KEY */]];if(!sentryXhrData){return;}var method=sentryXhrData.method,headers=sentryXhrData.request_headers;try{_xhrResponseHandler(options,xhr,method,headers);}catch(e){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('Error while extracting response event form XHR response',e);}});}/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */function _shouldCaptureResponse(options,status,url){return _isInGivenStatusRanges(options.failedRequestStatusCodes,status)&&_isInGivenRequestTargets(options.failedRequestTargets,url)&&!Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_4" /* isSentryRequestUrl */])(url,Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])());}/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */function _createEvent(data){var message="HTTP Client Error with status code: ".concat(data.status);var event={message:message,exception:{values:[{type:'Error',value:message}]},request:{url:data.url,method:data.method,headers:data.requestHeaders,cookies:data.requestCookies},contexts:{response:{status_code:data.status,headers:data.responseHeaders,cookies:data.responseCookies,body_size:_getResponseSizeFromHeaders(data.responseHeaders)}}};Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* addExceptionMechanism */])(event,{type:'http.client',handled:false});return event;}function _getRequest(requestInfo,requestInit){if(!requestInit&&requestInfo instanceof Request){return requestInfo;}// If both are set, we try to construct a new Request with the given arguments
// However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
// In this case, as a fallback, we just use the original request - using both is rather an edge case
if(requestInfo instanceof Request&&requestInfo.bodyUsed){return requestInfo;}return new Request(requestInfo,requestInit);}function _shouldSendDefaultPii(){var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])();return client?Boolean(client.getOptions().sendDefaultPii):false;}

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContextLines */
/* unused harmony export applySourceContextToFrame */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contextLinesIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}var WINDOW=__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* GLOBAL_OBJ */];var DEFAULT_LINES_OF_CONTEXT=7;var INTEGRATION_NAME='ContextLines';var _contextLinesIntegration=function _contextLinesIntegration(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var contextLines=options.frameContextLines!=null?options.frameContextLines:DEFAULT_LINES_OF_CONTEXT;return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
processEvent:function processEvent(event){return addSourceContext(event,contextLines);}};};var contextLinesIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_contextLinesIntegration);/**
 * Collects source context lines around the lines of stackframes pointing to JS embedded in
 * the current page's HTML.
 *
 * This integration DOES NOT work for stack frames pointing to JS files that are loaded by the browser.
 * For frames pointing to files, context lines are added during ingestion and symbolication
 * by attempting to download the JS files to the Sentry backend.
 *
 * Use this integration if you have inline JS code in HTML pages that can't be accessed
 * by our backend (e.g. due to a login-protected page).
 *
 * @deprecated Use `contextLinesIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var ContextLines=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,contextLinesIntegration);/**
 * Processes an event and adds context lines.
 */function addSourceContext(event,contextLines){var doc=WINDOW.document;var htmlFilename=WINDOW.location&&Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_44" /* stripUrlQueryAndFragment */])(WINDOW.location.href);if(!doc||!htmlFilename){return event;}var exceptions=event.exception&&event.exception.values;if(!exceptions||!exceptions.length){return event;}var html=doc.documentElement.innerHTML;if(!html){return event;}var htmlLines=['<!DOCTYPE html>','<html>'].concat(_toConsumableArray(html.split('\n')),['</html>']);exceptions.forEach(function(exception){var stacktrace=exception.stacktrace;if(stacktrace&&stacktrace.frames){stacktrace.frames=stacktrace.frames.map(function(frame){return applySourceContextToFrame(frame,htmlLines,htmlFilename,contextLines);});}});return event;}/**
 * Only exported for testing
 */function applySourceContextToFrame(frame,htmlLines,htmlFilename,linesOfContext){if(frame.filename!==htmlFilename||!frame.lineno||!htmlLines.length){return frame;}Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["k" /* addContextToFrame */])(htmlLines,frame,linesOfContext);return frame;}

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createStore */
/* unused harmony export insert */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeBrowserOfflineTransport; });
/* unused harmony export pop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original licence:
// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function promisifyRequest(request){return new Promise(function(resolve,reject){// @ts-expect-error - file size hacks
request.oncomplete=request.onsuccess=function(){return resolve(request.result);};// @ts-expect-error - file size hacks
request.onabort=request.onerror=function(){return reject(request.error);};});}/** Create or open an IndexedDb store */function createStore(dbName,storeName){var request=indexedDB.open(dbName);request.onupgradeneeded=function(){return request.result.createObjectStore(storeName);};var dbp=promisifyRequest(request);return function(callback){return dbp.then(function(db){return callback(db.transaction(storeName,'readwrite').objectStore(storeName));});};}function keys(store){return promisifyRequest(store.getAllKeys());}/** Insert into the store */function _insert(store,value,maxQueueSize){return store(function(store){return keys(store).then(function(keys){if(keys.length>=maxQueueSize){return;}// We insert with an incremented key so that the entries are popped in order
store.put(value,Math.max.apply(Math,_toConsumableArray(keys).concat([0]))+1);return promisifyRequest(store.transaction);});});}/** Pop the oldest value from the store */function _pop(store){return store(function(store){return keys(store).then(function(keys){if(keys.length===0){return undefined;}return promisifyRequest(store.get(keys[0])).then(function(value){store.delete(keys[0]);return promisifyRequest(store.transaction).then(function(){return value;});});});});}function createIndexedDbStore(options){var store;// Lazily create the store only when it's needed
function getStore(){if(store==undefined){store=createStore(options.dbName||'sentry-offline',options.storeName||'queue');}return store;}return{insert:function(){var _insert2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(env){var serialized;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_40" /* serializeEnvelope */])(env,options.textEncoder);case 3:serialized=_context.sent;_context.next=6;return _insert(getStore(),serialized,options.maxQueueSize||30);case 6:_context.next=10;break;case 8:_context.prev=8;_context.t0=_context["catch"](0);case 10:case"end":return _context.stop();}}},_callee,null,[[0,8]]);}));function insert(_x){return _insert2.apply(this,arguments);}return insert;}(),pop:function(){var _pop2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var deserialized;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return _pop(getStore());case 3:deserialized=_context2.sent;if(!deserialized){_context2.next=6;break;}return _context2.abrupt("return",Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_32" /* parseEnvelope */])(deserialized,options.textEncoder||new TextEncoder(),options.textDecoder||new TextDecoder()));case 6:_context2.next=10;break;case 8:_context2.prev=8;_context2.t0=_context2["catch"](0);case 10:return _context2.abrupt("return",undefined);case 11:case"end":return _context2.stop();}}},_callee2,null,[[0,8]]);}));function pop(){return _pop2.apply(this,arguments);}return pop;}()};}function makeIndexedDbOfflineTransport(createTransport){return function(options){return createTransport(_objectSpread({},options,{createStore:createIndexedDbStore}));};}/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */function makeBrowserOfflineTransport(createTransport){return makeIndexedDbOfflineTransport(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["_9" /* makeOfflineTransport */])(createTransport));}

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserProfilingIntegration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return browserProfilingIntegration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__debug_build_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hubextensions_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_js__ = __webpack_require__(318);
var INTEGRATION_NAME='BrowserProfiling';var _browserProfilingIntegration=function _browserProfilingIntegration(){return{name:INTEGRATION_NAME,// TODO v8: Remove this
setupOnce:function setupOnce(){},// eslint-disable-line @typescript-eslint/no-empty-function
setup:function setup(client){var scope=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["P" /* getCurrentScope */])();// eslint-disable-next-line deprecation/deprecation
var transaction=scope.getTransaction();if(transaction&&Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["g" /* isAutomatedPageLoadTransaction */])(transaction)){if(Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["h" /* shouldProfileTransaction */])(transaction)){Object(__WEBPACK_IMPORTED_MODULE_3__hubextensions_js__["b" /* startProfileForTransaction */])(transaction);}}if(typeof client.on!=='function'){__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('[Profiling] Client does not support hooks, profiling will be disabled');return;}client.on('startTransaction',function(transaction){if(Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["h" /* shouldProfileTransaction */])(transaction)){Object(__WEBPACK_IMPORTED_MODULE_3__hubextensions_js__["b" /* startProfileForTransaction */])(transaction);}});client.on('beforeEnvelope',function(envelope){// if not profiles are in queue, there is nothing to add to the envelope.
if(!Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["f" /* getActiveProfilesCount */])()){return;}var profiledTransactionEvents=Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["e" /* findProfiledTransactionsFromEnvelope */])(envelope);if(!profiledTransactionEvents.length){return;}var profilesToAddToEnvelope=[];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=profiledTransactionEvents[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var profiledTransaction=_step.value;var context=profiledTransaction&&profiledTransaction.contexts;var profile_id=context&&context['profile']&&context['profile']['profile_id'];var start_timestamp=context&&context['profile']&&context['profile']['start_timestamp'];if(typeof profile_id!=='string'){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] cannot find profile for a transaction without a profile context');continue;}if(!profile_id){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log('[Profiling] cannot find profile for a transaction without a profile context');continue;}// Remove the profile from the transaction context before sending, relay will take care of the rest.
if(context&&context['profile']){delete context.profile;}var profile=Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["j" /* takeProfileFromGlobalCache */])(profile_id);if(!profile){__WEBPACK_IMPORTED_MODULE_2__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].log("[Profiling] Could not retrieve profile for transaction: ".concat(profile_id));continue;}var profileEvent=Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["d" /* createProfilingEvent */])(profile_id,start_timestamp,profile,profiledTransaction);if(profileEvent){profilesToAddToEnvelope.push(profileEvent);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}Object(__WEBPACK_IMPORTED_MODULE_4__utils_js__["c" /* addProfilesToEnvelope */])(envelope,profilesToAddToEnvelope);});}};};var browserProfilingIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["G" /* defineIntegration */])(_browserProfilingIntegration);/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 * @deprecated Use `browserProfilingIntegration()` instead.
 */// eslint-disable-next-line deprecation/deprecation
var BrowserProfilingIntegration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["C" /* convertIntegrationFnToClass */])(INTEGRATION_NAME,browserProfilingIntegration);// eslint-disable-next-line deprecation/deprecation


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_browser__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(3);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * Inits the React SDK
 */function init(options){var opts=_objectSpread({},options);Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["u" /* applySdkMetadata */])(opts,'react');Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_24" /* init */])(opts);}

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Profiler; });
/* unused harmony export UNKNOWN_COMPONENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useProfiler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return withProfiler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_browser__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_js__ = __webpack_require__(702);
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}var _jsxFileName="/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/profiler.tsx";var UNKNOWN_COMPONENT='unknown';/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */var Profiler=/*#__PURE__*/function(_React$Component){_inherits(Profiler,_React$Component);_createClass(Profiler,null,[{key:"__initStatic",/**
   * The span of the mount activity
   * Made protected for the React Native SDK to access
   *//**
   * The span that represents the duration of time between shouldComponentUpdate and componentDidUpdate
   */// eslint-disable-next-line @typescript-eslint/member-ordering
value:function __initStatic(){this.defaultProps={disabled:false,includeRender:true,includeUpdates:true};}}]);function Profiler(props){var _this;_classCallCheck(this,Profiler);_this=_possibleConstructorReturn(this,_getPrototypeOf(Profiler).call(this,props));var _this$props=_this.props,name=_this$props.name,_this$props$disabled=_this$props.disabled,disabled=_this$props$disabled===void 0?false:_this$props$disabled;if(disabled){return _possibleConstructorReturn(_this);}_this._mountSpan=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_60" /* startInactiveSpan */])({name:"<".concat(name,">"),onlyIfParent:true,op:__WEBPACK_IMPORTED_MODULE_5__constants_js__["a" /* REACT_MOUNT_OP */],origin:'auto.ui.react.profiler',attributes:{'ui.component_name':name}});return _this;}// If a component mounted, we can finish the mount activity.
_createClass(Profiler,[{key:"componentDidMount",value:function componentDidMount(){if(this._mountSpan){this._mountSpan.end();}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(_ref){var _this2=this;var updateProps=_ref.updateProps,_ref$includeUpdates=_ref.includeUpdates,includeUpdates=_ref$includeUpdates===void 0?true:_ref$includeUpdates;// Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
// and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
// We are just trying to give baseline clues for further investigation.
if(includeUpdates&&this._mountSpan&&updateProps!==this.props.updateProps){// See what props haved changed between the previous props, and the current props. This is
// set as data on the span. We just store the prop keys as the values could be potenially very large.
var changedProps=Object.keys(updateProps).filter(function(k){return updateProps[k]!==_this2.props.updateProps[k];});if(changedProps.length>0){var now=Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["_48" /* timestampInSeconds */])();this._updateSpan=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_33" /* withActiveSpan */])(this._mountSpan,function(){return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_60" /* startInactiveSpan */])({name:"<".concat(_this2.props.name,">"),onlyIfParent:true,op:__WEBPACK_IMPORTED_MODULE_5__constants_js__["c" /* REACT_UPDATE_OP */],origin:'auto.ui.react.profiler',startTimestamp:now,attributes:{'ui.component_name':_this2.props.name,'ui.react.changed_props':changedProps}});});}}return true;}},{key:"componentDidUpdate",value:function componentDidUpdate(){if(this._updateSpan){this._updateSpan.end();this._updateSpan=undefined;}}// If a component is unmounted, we can say it is no longer on the screen.
// This means we can finish the span representing the component render.
},{key:"componentWillUnmount",value:function componentWillUnmount(){var endTimestamp=Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["_48" /* timestampInSeconds */])();var _this$props2=this.props,name=_this$props2.name,_this$props2$includeR=_this$props2.includeRender,includeRender=_this$props2$includeR===void 0?true:_this$props2$includeR;if(this._mountSpan&&includeRender){var startTimestamp=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_24" /* spanToJSON */])(this._mountSpan).timestamp;Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_33" /* withActiveSpan */])(this._mountSpan,function(){var renderSpan=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_60" /* startInactiveSpan */])({onlyIfParent:true,name:"<".concat(name,">"),op:__WEBPACK_IMPORTED_MODULE_5__constants_js__["b" /* REACT_RENDER_OP */],origin:'auto.ui.react.profiler',startTimestamp:startTimestamp,attributes:{'ui.component_name':name}});if(renderSpan){// Have to cast to Span because the type of _mountSpan is Span | undefined
// and not getting narrowed properly
renderSpan.end(endTimestamp);}});}}},{key:"render",value:function render(){return this.props.children;}}]);return Profiler;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);Profiler.__initStatic();/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withProfiler(WrappedComponent,// We do not want to have `updateProps` given in options, it is instead filled through the HOC.
options){var _this3=this;var componentDisplayName=options&&options.name||WrappedComponent.displayName||WrappedComponent.name||UNKNOWN_COMPONENT;var Wrapped=function Wrapped(props){return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](Profiler,_objectSpread({},options,{name:componentDisplayName,updateProps:props,__self:_this3,__source:{fileName:_jsxFileName,lineNumber:159}}),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](WrappedComponent,_objectSpread({},props,{__self:_this3,__source:{fileName:_jsxFileName,lineNumber:160}})));};Wrapped.displayName="profiler(".concat(componentDisplayName,")");// Copy over static methods from Wrapped component to Profiler HOC
// See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(Wrapped,WrappedComponent);return Wrapped;}/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */function useProfiler(name){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{disabled:false,hasRenderSpan:true};var _React$useState=__WEBPACK_IMPORTED_MODULE_4_react__["useState"](function(){if(options&&options.disabled){return undefined;}return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_60" /* startInactiveSpan */])({name:"<".concat(name,">"),onlyIfParent:true,op:__WEBPACK_IMPORTED_MODULE_5__constants_js__["a" /* REACT_MOUNT_OP */],origin:'auto.ui.react.profiler',attributes:{'ui.component_name':name}});}),_React$useState2=_slicedToArray(_React$useState,1),mountSpan=_React$useState2[0];__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"](function(){if(mountSpan){mountSpan.end();}return function(){if(mountSpan&&options.hasRenderSpan){var startTimestamp=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_24" /* spanToJSON */])(mountSpan).timestamp;var endTimestamp=Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["_48" /* timestampInSeconds */])();var renderSpan=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_60" /* startInactiveSpan */])({name:"<".concat(name,">"),onlyIfParent:true,op:__WEBPACK_IMPORTED_MODULE_5__constants_js__["b" /* REACT_RENDER_OP */],origin:'auto.ui.react.profiler',startTimestamp:startTimestamp,attributes:{'ui.component_name':name}});if(renderSpan){// Have to cast to Span because the type of _mountSpan is Span | undefined
// and not getting narrowed properly
renderSpan.end(endTimestamp);}}};// We only want this to run once.
// eslint-disable-next-line react-hooks/exhaustive-deps
},[]);}

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(701);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.11.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REACT_MOUNT_OP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REACT_RENDER_OP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REACT_UPDATE_OP; });
var REACT_RENDER_OP='ui.react.render';var REACT_UPDATE_OP='ui.react.update';var REACT_MOUNT_OP='ui.react.mount';

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* unused harmony export UNKNOWN_COMPONENT */
/* unused harmony export isAtLeastReact17 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return withErrorBoundary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_browser__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__debug_build_js__ = __webpack_require__(319);
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}var _jsxFileName="/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";function isAtLeastReact17(version){var major=version.match(/^([^.]+)/);return major!==null&&parseInt(major[0])>=17;}var UNKNOWN_COMPONENT='unknown';var INITIAL_STATE={componentStack:null,error:null,eventId:null};function setCause(error,cause){var seenErrors=new WeakMap();function recurse(error,cause){// If we've already seen the error, there is a recursive loop somewhere in the error's
// cause chain. Let's just bail out then to prevent a stack overflow.
if(seenErrors.has(error)){return;}if(error.cause){seenErrors.set(error,true);return recurse(error.cause,cause);}error.cause=cause;}recurse(error,cause);}/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */var ErrorBoundary=/*#__PURE__*/function(_React$Component){_inherits(ErrorBoundary,_React$Component);function ErrorBoundary(props){var _this;_classCallCheck(this,ErrorBoundary);_this=_possibleConstructorReturn(this,_getPrototypeOf(ErrorBoundary).call(this,props));ErrorBoundary.prototype.__init.call(_assertThisInitialized(_this));_this.state=INITIAL_STATE;_this._openFallbackReportDialog=true;var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_13" /* getClient */])();if(client&&client.on&&props.showDialog){_this._openFallbackReportDialog=false;client.on('afterSendEvent',function(event){if(!event.type&&event.event_id===_this._lastEventId){// eslint-disable-next-line deprecation/deprecation
Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_56" /* showReportDialog */])(_objectSpread({},props.dialogOptions,{eventId:_this._lastEventId}));}});}return _this;}_createClass(ErrorBoundary,[{key:"componentDidCatch",value:function componentDidCatch(error,_ref){var _this2=this;var componentStack=_ref.componentStack;var _this$props=this.props,beforeCapture=_this$props.beforeCapture,onError=_this$props.onError,showDialog=_this$props.showDialog,dialogOptions=_this$props.dialogOptions;Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_69" /* withScope */])(function(scope){// If on React version >= 17, create stack trace from componentStack param and links
// to to the original error using `error.cause` otherwise relies on error param for stacktrace.
// Linking errors requires the `LinkedErrors` integration be enabled.
// See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
//
// Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
// with non-error objects. This is why we need to check if the error is an error-like object.
// See: https://github.com/getsentry/sentry-javascript/issues/6167
if(isAtLeastReact17(__WEBPACK_IMPORTED_MODULE_3_react__["version"])&&Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_11" /* isError */])(error)){var errorBoundaryError=new Error(error.message);errorBoundaryError.name="React ErrorBoundary ".concat(error.name);errorBoundaryError.stack=componentStack;// Using the `LinkedErrors` integration to link the errors together.
setCause(error,errorBoundaryError);}if(beforeCapture){beforeCapture(scope,error,componentStack);}var eventId=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["J" /* captureException */])(error,{captureContext:{contexts:{react:{componentStack:componentStack}}},// If users provide a fallback component we can assume they are handling the error.
// Therefore, we set the mechanism depending on the presence of the fallback prop.
mechanism:{handled:!!_this2.props.fallback}});if(onError){onError(error,componentStack,eventId);}if(showDialog){_this2._lastEventId=eventId;if(_this2._openFallbackReportDialog){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_56" /* showReportDialog */])(_objectSpread({},dialogOptions,{eventId:eventId}));}}// componentDidCatch is used over getDerivedStateFromError
// so that componentStack is accessible through state.
_this2.setState({error:error,componentStack:componentStack,eventId:eventId});});}},{key:"componentDidMount",value:function componentDidMount(){var onMount=this.props.onMount;if(onMount){onMount();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){var _this$state=this.state,error=_this$state.error,componentStack=_this$state.componentStack,eventId=_this$state.eventId;var onUnmount=this.props.onUnmount;if(onUnmount){onUnmount(error,componentStack,eventId);}}},{key:"__init",value:function __init(){var _this3=this;this.resetErrorBoundary=function(){var onReset=_this3.props.onReset;var _this3$state=_this3.state,error=_this3$state.error,componentStack=_this3$state.componentStack,eventId=_this3$state.eventId;if(onReset){onReset(error,componentStack,eventId);}_this3.setState(INITIAL_STATE);};}},{key:"render",value:function render(){var _this$props2=this.props,fallback=_this$props2.fallback,children=_this$props2.children;var state=this.state;if(state.error){var element=undefined;if(typeof fallback==='function'){element=fallback({error:state.error,componentStack:state.componentStack,resetError:this.resetErrorBoundary,eventId:state.eventId});}else{element=fallback;}if(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"](element)){return element;}if(fallback){__WEBPACK_IMPORTED_MODULE_4__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["_26" /* logger */].warn('fallback did not produce a valid ReactElement');}// Fail gracefully if no fallback provided or is not valid
return null;}if(typeof children==='function'){return children();}return children;}}]);return ErrorBoundary;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(WrappedComponent,errorBoundaryOptions){var _this4=this;// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
var componentDisplayName=WrappedComponent.displayName||WrappedComponent.name||UNKNOWN_COMPONENT;var Wrapped=function Wrapped(props){return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ErrorBoundary,_objectSpread({},errorBoundaryOptions,{__self:_this4,__source:{fileName:_jsxFileName,lineNumber:240}}),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](WrappedComponent,_objectSpread({},props,{__self:_this4,__source:{fileName:_jsxFileName,lineNumber:241}})));};// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
Wrapped.displayName="errorBoundary(".concat(componentDisplayName,")");// Copy over static methods from Wrapped component to Profiler HOC
// See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Wrapped,WrappedComponent);return Wrapped;}

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createReduxEnhancer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(1);
function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* eslint-disable @typescript-eslint/no-explicit-any */var ACTION_BREADCRUMB_CATEGORY='redux.action';var ACTION_BREADCRUMB_TYPE='info';var defaultOptions={attachReduxState:true,actionTransformer:function actionTransformer(action){return action;},stateTransformer:function stateTransformer(state){return state||null;}};/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */function createReduxEnhancer(enhancerOptions){// Note: We return an any type as to not have type conflicts.
var options=_objectSpread({},defaultOptions,{},enhancerOptions);return function(next){return function(reducer,initialState){options.attachReduxState&&Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["S" /* getGlobalScope */])().addEventProcessor(function(event,hint){try{// @ts-expect-error try catch to reduce bundle size
if(event.type===undefined&&event.contexts.state.state.type==='redux'){hint.attachments=[].concat(_toConsumableArray(hint.attachments||[]),[// @ts-expect-error try catch to reduce bundle size
{filename:'redux_state.json',data:JSON.stringify(event.contexts.state.state.value)}]);}}catch(_){// empty
}return event;});var sentryReducer=function sentryReducer(state,action){var newState=reducer(state,action);var scope=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["P" /* getCurrentScope */])();/* Action breadcrumbs */var transformedAction=options.actionTransformer(action);if(typeof transformedAction!=='undefined'&&transformedAction!==null){scope.addBreadcrumb({category:ACTION_BREADCRUMB_CATEGORY,data:transformedAction,type:ACTION_BREADCRUMB_TYPE});}/* Set latest state to scope */var transformedState=options.stateTransformer(newState);if(typeof transformedState!=='undefined'&&transformedState!==null){var client=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["N" /* getClient */])();var _options=client&&client.getOptions();var normalizationDepth=_options&&_options.normalizeDepth||3;// default state normalization depth to 3
// Set the normalization depth of the redux state to the configured `normalizeDepth` option or a sane number as a fallback
var newStateContext={state:{type:'redux',value:transformedState}};Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["s" /* addNonEnumerableProperty */])(newStateContext,'__sentry_override_normalization_depth__',3+// 3 layers for `state.value.transformedState`
normalizationDepth// rest for the actual state
);scope.setContext('state',newStateContext);}else{scope.setContext('state',null);}/* Allow user to configure scope with latest state */var configureScopeWithState=options.configureScopeWithState;if(typeof configureScopeWithState==='function'){configureScopeWithState(scope,newState);}return newState;};return next(sentryReducer,initialState);};};}

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reactRouterV3BrowserTracingIntegration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reactRouterV3Instrumentation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_browser__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(3);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// Many of the types below had to be mocked out to prevent typescript issues
// these types are required for correct functionality.
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */function reactRouterV3BrowserTracingIntegration(options){var integration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["G" /* browserTracingIntegration */])(_objectSpread({},options,{instrumentPageLoad:false,instrumentNavigation:false}));var history=options.history,routes=options.routes,match=options.match,_options$instrumentPa=options.instrumentPageLoad,instrumentPageLoad=_options$instrumentPa===void 0?true:_options$instrumentPa,_options$instrumentNa=options.instrumentNavigation,instrumentNavigation=_options$instrumentNa===void 0?true:_options$instrumentNa;return _objectSpread({},integration,{afterAllSetup:function afterAllSetup(client){integration.afterAllSetup(client);var startPageloadCallback=function startPageloadCallback(startSpanOptions){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_59" /* startBrowserTracingPageLoadSpan */])(client,startSpanOptions);return undefined;};var startNavigationCallback=function startNavigationCallback(startSpanOptions){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_58" /* startBrowserTracingNavigationSpan */])(client,startSpanOptions);return undefined;};// eslint-disable-next-line deprecation/deprecation
var instrumentation=reactRouterV3Instrumentation(history,routes,match);// Now instrument page load & navigation with correct settings
instrumentation(startPageloadCallback,instrumentPageLoad,false);instrumentation(startNavigationCallback,false,instrumentNavigation);}});}/**
 * Creates routing instrumentation for React Router v3
 * Works for React Router >= 3.2.0 and < 4.0.0
 *
 * @param history object from the `history` library
 * @param routes a list of all routes, should be
 * @param match `Router.match` utility
 *
 * @deprecated Use `reactRouterV3BrowserTracingIntegration()` instead
 */function reactRouterV3Instrumentation(history,routes,match){return function(startTransaction){var startTransactionOnPageLoad=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var startTransactionOnLocationChange=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var activeTransaction;var prevName;// Have to use window.location because history.location might not be defined.
if(startTransactionOnPageLoad&&__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* WINDOW */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* WINDOW */].location){normalizeTransactionName(routes,__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* WINDOW */].location,match,function(localName){var _attributes;var source=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'url';prevName=localName;activeTransaction=startTransaction({name:prevName,attributes:(_attributes={},_defineProperty(_attributes,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* SEMANTIC_ATTRIBUTE_SENTRY_OP */],'pageload'),_defineProperty(_attributes,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["j" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */],'auto.pageload.react.reactrouter_v3'),_defineProperty(_attributes,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],source),_attributes)});});}if(startTransactionOnLocationChange&&history.listen){history.listen(function(location){if(location.action==='PUSH'||location.action==='POP'){if(activeTransaction){activeTransaction.end();}normalizeTransactionName(routes,location,match,function(localName){var _attributes2;var source=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'url';prevName=localName;var attributes=(_attributes2={},_defineProperty(_attributes2,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* SEMANTIC_ATTRIBUTE_SENTRY_OP */],'navigation'),_defineProperty(_attributes2,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["j" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */],'auto.navigation.react.reactrouter_v3'),_defineProperty(_attributes2,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],source),_attributes2);activeTransaction=startTransaction({name:prevName,attributes:attributes});});}});}};}/**
 * Normalize transaction names using `Router.match`
 */function normalizeTransactionName(appRoutes,location,match,callback){var name=location.pathname;match({location:location,routes:appRoutes},function(error,_redirectLocation,renderProps){if(error||!renderProps){return callback(name);}var routePath=getRouteStringFromRoutes(renderProps.routes||[]);if(routePath.length===0||routePath==='/*'){return callback(name);}name=routePath;return callback(name,'route');});}/**
 * Generate route name from array of routes
 */function getRouteStringFromRoutes(routes){if(!Array.isArray(routes)||routes.length===0){return'';}var routesWithPaths=routes.filter(function(route){return!!route.path;});var index=-1;for(var x=routesWithPaths.length-1;x>=0;x--){var route=routesWithPaths[x];if(route.path&&route.path.startsWith('/')){index=x;break;}}return routesWithPaths.slice(index).filter(function(_ref){var path=_ref.path;return!!path;}).map(function(_ref2){var path=_ref2.path;return path;}).join('');}

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reactRouterV4BrowserTracingIntegration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reactRouterV4Instrumentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reactRouterV5BrowserTracingIntegration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return reactRouterV5Instrumentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return withSentryRouting; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_browser__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var _jsxFileName="/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouter.tsx";// We need to disable eslint no-explict-any because any is required for the
// react-router typings.
var activeTransaction;/**
 * A browser tracing integration that uses React Router v4 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */function reactRouterV4BrowserTracingIntegration(options){var integration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["G" /* browserTracingIntegration */])(_objectSpread({},options,{instrumentPageLoad:false,instrumentNavigation:false}));var history=options.history,routes=options.routes,matchPath=options.matchPath,_options$instrumentPa=options.instrumentPageLoad,instrumentPageLoad=_options$instrumentPa===void 0?true:_options$instrumentPa,_options$instrumentNa=options.instrumentNavigation,instrumentNavigation=_options$instrumentNa===void 0?true:_options$instrumentNa;return _objectSpread({},integration,{afterAllSetup:function afterAllSetup(client){integration.afterAllSetup(client);var startPageloadCallback=function startPageloadCallback(startSpanOptions){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_59" /* startBrowserTracingPageLoadSpan */])(client,startSpanOptions);return undefined;};var startNavigationCallback=function startNavigationCallback(startSpanOptions){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_58" /* startBrowserTracingNavigationSpan */])(client,startSpanOptions);return undefined;};// eslint-disable-next-line deprecation/deprecation
var instrumentation=reactRouterV4Instrumentation(history,routes,matchPath);// Now instrument page load & navigation with correct settings
instrumentation(startPageloadCallback,instrumentPageLoad,false);instrumentation(startNavigationCallback,false,instrumentNavigation);}});}/**
 * A browser tracing integration that uses React Router v5 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */function reactRouterV5BrowserTracingIntegration(options){var integration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["G" /* browserTracingIntegration */])(_objectSpread({},options,{instrumentPageLoad:false,instrumentNavigation:false}));var history=options.history,routes=options.routes,matchPath=options.matchPath;return _objectSpread({},integration,{afterAllSetup:function afterAllSetup(client){integration.afterAllSetup(client);var startPageloadCallback=function startPageloadCallback(startSpanOptions){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_59" /* startBrowserTracingPageLoadSpan */])(client,startSpanOptions);return undefined;};var startNavigationCallback=function startNavigationCallback(startSpanOptions){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_58" /* startBrowserTracingNavigationSpan */])(client,startSpanOptions);return undefined;};// eslint-disable-next-line deprecation/deprecation
var instrumentation=reactRouterV5Instrumentation(history,routes,matchPath);// Now instrument page load & navigation with correct settings
instrumentation(startPageloadCallback,options.instrumentPageLoad,false);instrumentation(startNavigationCallback,false,options.instrumentNavigation);}});}/**
 * @deprecated Use `browserTracingReactRouterV4()` instead.
 */function reactRouterV4Instrumentation(history,routes,matchPath){return createReactRouterInstrumentation(history,'reactrouter_v4',routes,matchPath);}/**
 * @deprecated Use `browserTracingReactRouterV5()` instead.
 */function reactRouterV5Instrumentation(history,routes,matchPath){return createReactRouterInstrumentation(history,'reactrouter_v5',routes,matchPath);}function createReactRouterInstrumentation(history,instrumentationName){var allRoutes=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var matchPath=arguments.length>3?arguments[3]:undefined;function getInitPathName(){if(history&&history.location){return history.location.pathname;}if(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* WINDOW */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* WINDOW */].location){return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* WINDOW */].location.pathname;}return undefined;}/**
   * Normalizes a transaction name. Returns the new name as well as the
   * source of the transaction.
   *
   * @param pathname The initial pathname we normalize
   */function normalizeTransactionName(pathname){if(allRoutes.length===0||!matchPath){return[pathname,'url'];}var branches=matchRoutes(allRoutes,pathname,matchPath);// eslint-disable-next-line @typescript-eslint/prefer-for-of
for(var x=0;x<branches.length;x++){if(branches[x].match.isExact){return[branches[x].match.path,'route'];}}return[pathname,'url'];}return function(customStartTransaction){var startTransactionOnPageLoad=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var startTransactionOnLocationChange=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var initPathName=getInitPathName();if(startTransactionOnPageLoad&&initPathName){var _attributes;var _normalizeTransaction=normalizeTransactionName(initPathName),_normalizeTransaction2=_slicedToArray(_normalizeTransaction,2),name=_normalizeTransaction2[0],source=_normalizeTransaction2[1];activeTransaction=customStartTransaction({name:name,attributes:(_attributes={},_defineProperty(_attributes,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* SEMANTIC_ATTRIBUTE_SENTRY_OP */],'pageload'),_defineProperty(_attributes,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["j" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */],"auto.pageload.react.".concat(instrumentationName)),_defineProperty(_attributes,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],source),_attributes)});}if(startTransactionOnLocationChange&&history.listen){history.listen(function(location,action){if(action&&(action==='PUSH'||action==='POP')){var _attributes2;if(activeTransaction){activeTransaction.end();}var _normalizeTransaction3=normalizeTransactionName(location.pathname),_normalizeTransaction4=_slicedToArray(_normalizeTransaction3,2),_name=_normalizeTransaction4[0],_source=_normalizeTransaction4[1];activeTransaction=customStartTransaction({name:_name,attributes:(_attributes2={},_defineProperty(_attributes2,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* SEMANTIC_ATTRIBUTE_SENTRY_OP */],'navigation'),_defineProperty(_attributes2,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["j" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */],"auto.navigation.react.".concat(instrumentationName)),_defineProperty(_attributes2,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],_source),_attributes2)});}});}};}/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */function matchRoutes(routes,pathname,matchPath){var branch=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];routes.some(function(route){var match=route.path?matchPath(pathname,route):branch.length?branch[branch.length-1].match// use parent match
:computeRootMatch(pathname);// use default "root" match
if(match){branch.push({route:route,match:match});if(route.routes){matchRoutes(route.routes,pathname,matchPath,branch);}}return!!match;});return branch;}function computeRootMatch(pathname){return{path:'/',url:'/',params:{},isExact:pathname==='/'};}/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */function withSentryRouting(Route){var _this=this;var componentDisplayName=Route.displayName||Route.name;var WrappedRoute=function WrappedRoute(props){if(props&&props.computedMatch&&props.computedMatch.isExact){var route=props.computedMatch.path;var activeRootSpan=getActiveRootSpan();if(activeRootSpan){activeRootSpan.updateName(route);activeRootSpan.setAttribute(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],'route');}}// @ts-expect-error Setting more specific React Component typing for `R` generic above
// will break advanced type inference done by react router params:
// https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Route,_objectSpread({},props,{__self:_this,__source:{fileName:_jsxFileName,lineNumber:279}}));};WrappedRoute.displayName="sentryRoute(".concat(componentDisplayName,")");__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(WrappedRoute,Route);// @ts-expect-error Setting more specific React Component typing for `R` generic above
// will break advanced type inference done by react router params:
// https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
return WrappedRoute;}/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */function getActiveRootSpan(){// Legacy behavior for "old" react router instrumentation
if(activeTransaction){return activeTransaction;}var span=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["L" /* getActiveSpan */])();var rootSpan=span?Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["Y" /* getRootSpan */])(span):undefined;if(!rootSpan){return undefined;}var op=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_24" /* spanToJSON */])(rootSpan).op;// Only use this root span if it is a pageload or navigation span
return op==='navigation'||op==='pageload'?rootSpan:undefined;}

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reactRouterV6BrowserTracingIntegration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reactRouterV6Instrumentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return withSentryReactRouterV6Routing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return wrapCreateBrowserRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return wrapUseRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_browser__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__debug_build_js__ = __webpack_require__(319);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var _jsxFileName="/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx";/* eslint-disable max-lines */var activeTransaction;var _useEffect;var _useLocation;var _useNavigationType;var _createRoutesFromChildren;var _matchRoutes;var _customStartTransaction;var _startTransactionOnLocationChange;var _stripBasename=false;/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */function reactRouterV6BrowserTracingIntegration(options){var integration=Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["G" /* browserTracingIntegration */])(_objectSpread({},options,{instrumentPageLoad:false,instrumentNavigation:false}));var useEffect=options.useEffect,useLocation=options.useLocation,useNavigationType=options.useNavigationType,createRoutesFromChildren=options.createRoutesFromChildren,matchRoutes=options.matchRoutes,stripBasename=options.stripBasename,_options$instrumentPa=options.instrumentPageLoad,instrumentPageLoad=_options$instrumentPa===void 0?true:_options$instrumentPa,_options$instrumentNa=options.instrumentNavigation,instrumentNavigation=_options$instrumentNa===void 0?true:_options$instrumentNa;return _objectSpread({},integration,{afterAllSetup:function afterAllSetup(client){integration.afterAllSetup(client);var startNavigationCallback=function startNavigationCallback(startSpanOptions){Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_58" /* startBrowserTracingNavigationSpan */])(client,startSpanOptions);return undefined;};var initPathName=__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* WINDOW */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* WINDOW */].location&&__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* WINDOW */].location.pathname;if(instrumentPageLoad&&initPathName){var _attributes;Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["_59" /* startBrowserTracingPageLoadSpan */])(client,{name:initPathName,attributes:(_attributes={},_defineProperty(_attributes,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],'url'),_defineProperty(_attributes,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* SEMANTIC_ATTRIBUTE_SENTRY_OP */],'pageload'),_defineProperty(_attributes,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["j" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */],'auto.pageload.react.reactrouter_v6'),_attributes)});}_useEffect=useEffect;_useLocation=useLocation;_useNavigationType=useNavigationType;_matchRoutes=matchRoutes;_createRoutesFromChildren=createRoutesFromChildren;_stripBasename=stripBasename||false;_customStartTransaction=startNavigationCallback;_startTransactionOnLocationChange=instrumentNavigation;}});}/**
 * @deprecated Use `reactRouterV6BrowserTracingIntegration()` instead.
 */function reactRouterV6Instrumentation(useEffect,useLocation,useNavigationType,createRoutesFromChildren,matchRoutes,stripBasename){return function(customStartTransaction){var startTransactionOnPageLoad=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var startTransactionOnLocationChange=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var initPathName=__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* WINDOW */]&&__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* WINDOW */].location&&__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* WINDOW */].location.pathname;if(startTransactionOnPageLoad&&initPathName){var _attributes2;activeTransaction=customStartTransaction({name:initPathName,attributes:(_attributes2={},_defineProperty(_attributes2,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],'url'),_defineProperty(_attributes2,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* SEMANTIC_ATTRIBUTE_SENTRY_OP */],'pageload'),_defineProperty(_attributes2,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["j" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */],'auto.pageload.react.reactrouter_v6'),_attributes2)});}_useEffect=useEffect;_useLocation=useLocation;_useNavigationType=useNavigationType;_matchRoutes=matchRoutes;_createRoutesFromChildren=createRoutesFromChildren;_stripBasename=stripBasename||false;_customStartTransaction=customStartTransaction;_startTransactionOnLocationChange=startTransactionOnLocationChange;};}/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */function stripBasenameFromPathname(pathname,basename){if(!basename||basename==='/'){return pathname;}if(!pathname.toLowerCase().startsWith(basename.toLowerCase())){return pathname;}// We want to leave trailing slash behavior in the user's control, so if they
// specify a basename with a trailing slash, we should support it
var startIndex=basename.endsWith('/')?basename.length-1:basename.length;var nextChar=pathname.charAt(startIndex);if(nextChar&&nextChar!=='/'){// pathname does not start with basename/
return pathname;}return pathname.slice(startIndex)||'/';}function getNormalizedName(routes,location,branches){var basename=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';if(!routes||routes.length===0){return[_stripBasename?stripBasenameFromPathname(location.pathname,basename):location.pathname,'url'];}var pathBuilder='';if(branches){// eslint-disable-next-line @typescript-eslint/prefer-for-of
for(var x=0;x<branches.length;x++){var branch=branches[x];var route=branch.route;if(route){// Early return if index route
if(route.index){return[_stripBasename?stripBasenameFromPathname(branch.pathname,basename):branch.pathname,'route'];}var path=route.path;if(path){var newPath=path[0]==='/'||pathBuilder[pathBuilder.length-1]==='/'?path:"/".concat(path);pathBuilder+=newPath;if(basename+branch.pathname===location.pathname){if(// If the route defined on the element is something like
// <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
// We should check against the branch.pathname for the number of / seperators
Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["_3" /* getNumberOfUrlSegments */])(pathBuilder)!==Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["_3" /* getNumberOfUrlSegments */])(branch.pathname)&&// We should not count wildcard operators in the url segments calculation
pathBuilder.slice(-2)!=='/*'){return[(_stripBasename?'':basename)+newPath,'route'];}return[(_stripBasename?'':basename)+pathBuilder,'route'];}}}}}return[_stripBasename?stripBasenameFromPathname(location.pathname,basename):location.pathname,'url'];}function updatePageloadTransaction(activeRootSpan,location,routes,matches,basename){var branches=Array.isArray(matches)?matches:_matchRoutes(routes,location,basename);if(activeRootSpan&&branches){var _getNormalizedName=getNormalizedName(routes,location,branches,basename),_getNormalizedName2=_slicedToArray(_getNormalizedName,2),name=_getNormalizedName2[0],source=_getNormalizedName2[1];activeRootSpan.updateName(name);activeRootSpan.setAttribute(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],source);}}function handleNavigation(location,routes,navigationType,matches,basename){var branches=Array.isArray(matches)?matches:_matchRoutes(routes,location,basename);if(_startTransactionOnLocationChange&&(navigationType==='PUSH'||navigationType==='POP')&&branches){var _attributes3;if(activeTransaction){activeTransaction.end();}var _getNormalizedName3=getNormalizedName(routes,location,branches,basename),_getNormalizedName4=_slicedToArray(_getNormalizedName3,2),name=_getNormalizedName4[0],source=_getNormalizedName4[1];activeTransaction=_customStartTransaction({name:name,attributes:(_attributes3={},_defineProperty(_attributes3,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["l" /* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */],source),_defineProperty(_attributes3,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* SEMANTIC_ATTRIBUTE_SENTRY_OP */],'navigation'),_defineProperty(_attributes3,__WEBPACK_IMPORTED_MODULE_1__sentry_core__["j" /* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */],'auto.navigation.react.reactrouter_v6'),_attributes3)});}}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withSentryReactRouterV6Routing(Routes){var _this=this;if(!_useEffect||!_useLocation||!_useNavigationType||!_createRoutesFromChildren||!_matchRoutes||!_customStartTransaction){__WEBPACK_IMPORTED_MODULE_5__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["_26" /* logger */].warn("reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.\n      useEffect: ".concat(_useEffect,". useLocation: ").concat(_useLocation,". useNavigationType: ").concat(_useNavigationType,".\n      createRoutesFromChildren: ").concat(_createRoutesFromChildren,". matchRoutes: ").concat(_matchRoutes,". customStartTransaction: ").concat(_customStartTransaction,"."));return Routes;}var isMountRenderPass=true;var SentryRoutes=function SentryRoutes(props){var location=_useLocation();var navigationType=_useNavigationType();_useEffect(function(){var routes=_createRoutesFromChildren(props.children);if(isMountRenderPass){updatePageloadTransaction(getActiveRootSpan(),location,routes);isMountRenderPass=false;}else{handleNavigation(location,routes,navigationType);}},// `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
// when the children change. We only want to start transactions when the location or navigation type change.
[location,navigationType]);// @ts-expect-error Setting more specific React Component typing for `R` generic above
// will break advanced type inference done by react router params
return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](Routes,_objectSpread({},props,{__self:_this,__source:{fileName:_jsxFileName,lineNumber:329}}));};__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(SentryRoutes,Routes);// @ts-expect-error Setting more specific React Component typing for `R` generic above
// will break advanced type inference done by react router params
return SentryRoutes;}function wrapUseRoutes(origUseRoutes){var _this2=this;if(!_useEffect||!_useLocation||!_useNavigationType||!_matchRoutes||!_customStartTransaction){__WEBPACK_IMPORTED_MODULE_5__debug_build_js__["a" /* DEBUG_BUILD */]&&__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["_26" /* logger */].warn('reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.');return origUseRoutes;}var isMountRenderPass=true;var SentryRoutes=function SentryRoutes(props){var routes=props.routes,locationArg=props.locationArg;var Routes=origUseRoutes(routes,locationArg);var location=_useLocation();var navigationType=_useNavigationType();// A value with stable identity to either pick `locationArg` if available or `location` if not
var stableLocationParam=typeof locationArg==='string'||locationArg&&locationArg.pathname?locationArg:location;_useEffect(function(){var normalizedLocation=typeof stableLocationParam==='string'?{pathname:stableLocationParam}:stableLocationParam;if(isMountRenderPass){updatePageloadTransaction(getActiveRootSpan(),normalizedLocation,routes);isMountRenderPass=false;}else{handleNavigation(normalizedLocation,routes,navigationType);}},[navigationType,stableLocationParam]);return Routes;};// eslint-disable-next-line react/display-name
return function(routes,locationArg){return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](SentryRoutes,{routes:routes,locationArg:locationArg,__self:_this2,__source:{fileName:_jsxFileName,lineNumber:386}});};}function wrapCreateBrowserRouter(createRouterFunction){// `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
// `basename` is the only option that is relevant for us, and it is the same for all.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
return function(routes,opts){var router=createRouterFunction(routes,opts);var basename=opts&&opts.basename;var activeRootSpan=getActiveRootSpan();// The initial load ends when `createBrowserRouter` is called.
// This is the earliest convenient time to update the transaction name.
// Callbacks to `router.subscribe` are not called for the initial load.
if(router.state.historyAction==='POP'&&activeRootSpan){updatePageloadTransaction(activeRootSpan,router.state.location,routes,undefined,basename);}router.subscribe(function(state){var location=state.location;if(_startTransactionOnLocationChange&&(state.historyAction==='PUSH'||state.historyAction==='POP')){handleNavigation(location,routes,state.historyAction,undefined,basename);}});return router;};}function getActiveRootSpan(){// Legacy behavior for "old" react router instrumentation
if(activeTransaction){return activeTransaction;}var span=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["L" /* getActiveSpan */])();var rootSpan=span?Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["Y" /* getRootSpan */])(span):undefined;if(!rootSpan){return undefined;}var op=Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["_24" /* spanToJSON */])(rootSpan).op;// Only use this root span if it is a pageload or navigation span
return op==='navigation'||op==='pageload'?rootSpan:undefined;}

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_meta__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_JsonLd__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_content_marketingRoutes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_i18n_localePath__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_Index__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_Onboard__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_404__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_TermsPage__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_PrivacyPage__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_CookiesPage__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_ContactPage__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_ComparePage__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_ChecklistPage__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_PricingPage__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_pages_VerticalsIndexPage__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_pages_VerticalPage__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_pages_GuidesIndexPage__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_pages_GuidePage__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_seo_absoluteUrl__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_seo_jsonLd__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_seo_pageMeta__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_static_images_logo_2x_png__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_static_images_logo_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_static_images_logo_2x_png__);
function renderPage(strippedPath){if(strippedPath==='/for')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_pages_VerticalsIndexPage__["a" /* default */],null);if(strippedPath.startsWith('/for/')){var slug=strippedPath.slice('/for/'.length);if(Object(__WEBPACK_IMPORTED_MODULE_4_content_marketingRoutes__["d" /* isVerticalSlug */])(slug))return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_pages_VerticalPage__["a" /* default */],{slug:slug});}if(strippedPath==='/guides')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_pages_GuidesIndexPage__["a" /* default */],null);if(strippedPath.startsWith('/guides/')){var _slug=strippedPath.slice('/guides/'.length);if(Object(__WEBPACK_IMPORTED_MODULE_4_content_marketingRoutes__["c" /* isGuideSlug */])(_slug))return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_pages_GuidePage__["a" /* default */],{slug:_slug});}switch(strippedPath){case'/':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_pages_Index__["a" /* default */],null);case'/onboard':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_pages_Onboard__["a" /* default */],null);case'/terms':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_pages_TermsPage__["a" /* default */],null);case'/privacy':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_pages_PrivacyPage__["a" /* default */],null);case'/cookies':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_pages_CookiesPage__["a" /* default */],null);case'/contact':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_pages_ContactPage__["a" /* default */],null);case'/compare':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_pages_ComparePage__["a" /* default */],null);case'/checklist':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_pages_ChecklistPage__["a" /* default */],null);case'/pricing':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_pages_PricingPage__["a" /* default */],null);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_pages_404__["a" /* default */],null);}}var App=function App(_ref){var location=_ref.location,history=_ref.history;var _parseLocale=Object(__WEBPACK_IMPORTED_MODULE_6_i18n_localePath__["a" /* parseLocale */])(location.pathname),locale=_parseLocale.locale,strippedPath=_parseLocale.strippedPath;var ogImageUrl=Object(__WEBPACK_IMPORTED_MODULE_21_seo_absoluteUrl__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_24_static_images_logo_2x_png___default.a);var documentMeta=Object(__WEBPACK_IMPORTED_MODULE_23_seo_pageMeta__["a" /* default */])({pathname:strippedPath,ogImageUrl:ogImageUrl,locale:locale});var homeJsonLd=strippedPath==='/'?Object(__WEBPACK_IMPORTED_MODULE_22_seo_jsonLd__["a" /* default */])({ogImageUrl:ogImageUrl,locale:locale}):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_i18n_I18nContext__["a" /* I18nProvider */],{locale:locale,strippedPath:strippedPath,history:history},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_meta___default.a,documentMeta),homeJsonLd?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_JsonLd__["a" /* default */],{data:homeJsonLd}):null,renderPage(strippedPath));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(App));

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.render = render;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(710);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _utils = __webpack_require__(320);

var _dom = __webpack_require__(712);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function reducePropsTostate(propsList) {
  var props = {};
  var dynamicProps = {
    title: undefined,
    description: undefined,
    canonical: undefined
  };

  var extend = true;

  var _loop = function _loop() {
    extend = propsList[i].hasOwnProperty('extend');

    var _props = propsList[i];
    var _cloned = (0, _utils.clone)(propsList[i]);
    ['title', 'description', 'canonical'].forEach(function (key) {
      if (_props.hasOwnProperty(key)) {
        if (typeof _props[key] === 'function') {
          dynamicProps[key] = _props[key](dynamicProps[key]);
        } else if (dynamicProps[key] === undefined) {
          dynamicProps[key] = _props[key];
        }
      }
    });

    (0, _utils.defaults)(props, _cloned);
  };

  for (var i = propsList.length - 1; extend && i >= 0; i--) {
    _loop();
  }

  if (typeof dynamicProps.title === 'string') {
    props.title = dynamicProps.title;
  }
  if (typeof dynamicProps.description === 'string') {
    (0, _utils.defaults)(props, {
      meta: { name: { description: dynamicProps.description } }
    });
  }
  if (typeof dynamicProps.canonical === 'string') {
    (0, _utils.defaults)(props, { link: { rel: { canonical: dynamicProps.canonical } } });
  }

  if (props.auto && props.auto.ograph) {
    ograph(props);
  }

  return props;
}

function handleStateChangeOnClient(props) {
  if (_dom.canUseDOM) {
    if (typeof props.title === 'string') {
      document.title = props.title;
    }
    (0, _dom.insertDocumentMeta)(getTags(props));
  }
}

function ograph(p) {
  if (!p.meta) {
    p.meta = {};
  }
  if (!p.meta.property) {
    p.meta.property = {};
  }

  var group = p.meta.property;
  if (group) {
    if (p.title && !group['og:title']) {
      group['og:title'] = p.title;
    }
    if (p.hasOwnProperty('description') && !group['og:description']) {
      group['og:description'] = p.description;
    }
    if (p.hasOwnProperty('canonical') && !group['og:url']) {
      group['og:url'] = p.canonical;
    }
  }
  return p;
}

function parseTags(tagName) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var tags = [];
  var contentKey = tagName === 'link' ? 'href' : 'content';
  Object.keys(props).forEach(function (groupKey) {
    var group = props[groupKey];
    if (typeof group === 'string') {
      tags.push(_defineProperty({
        tagName: tagName
      }, groupKey, group));
      return;
    }
    Object.keys(group).forEach(function (key) {
      var values = Array.isArray(group[key]) ? group[key] : [group[key]];
      values.forEach(function (value) {
        if (value !== null) {
          var _tags$push2;

          tags.push((_tags$push2 = {
            tagName: tagName
          }, _defineProperty(_tags$push2, groupKey, key), _defineProperty(_tags$push2, contentKey, value), _tags$push2));
        }
      });
    });
  });
  return tags;
}

function getTags(_props) {
  return [].concat(parseTags('meta', _props.meta), parseTags('link', _props.link));
}

function render() {
  var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var i = 0;
  var tags = [];

  function renderTag(entry) {
    var tagName = entry.tagName,
        attr = _objectWithoutProperties(entry, ['tagName']);

    if (tagName === 'meta') {
      return _react2.default.createElement('meta', _extends({}, attr, { key: i++, 'data-rdm': true }));
    }
    if (tagName === 'link') {
      return _react2.default.createElement('link', _extends({}, attr, { key: i++, 'data-rdm': true }));
    }
    return null;
  }

  if (meta.title) {
    tags.push(_react2.default.createElement(
      'title',
      { key: i++ },
      meta.title
    ));
  }

  return getTags(meta).reduce(function (acc, entry) {
    acc.push(renderTag(entry));
    return acc;
  }, tags);
}

var DocumentMeta = function (_Component) {
  _inherits(DocumentMeta, _Component);

  function DocumentMeta() {
    _classCallCheck(this, DocumentMeta);

    return _possibleConstructorReturn(this, (DocumentMeta.__proto__ || Object.getPrototypeOf(DocumentMeta)).apply(this, arguments));
  }

  _createClass(DocumentMeta, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var count = _react2.default.Children.count(children);
      return count === 1 ? _react2.default.Children.only(children) : count ? _react2.default.createElement(
        'div',
        null,
        this.props.children
      ) : null;
    }
  }]);

  return DocumentMeta;
}(_react.Component);

DocumentMeta.propTypes = {
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  description: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  canonical: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  base: _propTypes2.default.string,
  meta: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]))])),
  link: _propTypes2.default.objectOf(_propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]))),
  auto: _propTypes2.default.objectOf(_propTypes2.default.bool)
};


var DocumentMetaWithSideEffect = (0, _reactSideEffect2.default)(reducePropsTostate, handleStateChangeOnClient)(DocumentMeta);

DocumentMetaWithSideEffect.renderAsReact = function rewindAsReact() {
  return render(DocumentMetaWithSideEffect.rewind());
};

exports.default = DocumentMetaWithSideEffect;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(2);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(711));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 711 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;
exports.removeDocumentMeta = removeDocumentMeta;
exports.insertDocumentMeta = insertDocumentMeta;

var _utils = __webpack_require__(320);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function removeNode(node) {
  node.parentNode.removeChild(node);
}

function removeDocumentMeta() {
  (0, _utils.forEach)(document.querySelectorAll('head [data-rdm]'), removeNode);
}

function insertDocumentMetaNode(entry) {
  var tagName = entry.tagName,
      attr = _objectWithoutProperties(entry, ['tagName']);

  var newNode = document.createElement(tagName);
  for (var prop in attr) {
    if (entry.hasOwnProperty(prop)) {
      newNode.setAttribute(prop, entry[prop]);
    }
  }
  newNode.setAttribute('data-rdm', '');
  document.getElementsByTagName('head')[0].appendChild(newNode);
}

function insertDocumentMeta(nodes) {
  removeDocumentMeta();

  (0, _utils.forEach)(nodes, insertDocumentMetaNode);
}


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var JsonLd=function JsonLd(_ref){var data=_ref.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("script",{type:"application/ld+json"// eslint-disable-next-line react/no-danger
,dangerouslySetInnerHTML:{__html:JSON.stringify(data)}});};/* harmony default export */ __webpack_exports__["a"] = (JsonLd);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = flattenMessages;
function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}/**
 * Flattens nested string objects to dot keys: { a: { b: 'x' } } -> { 'a.b': 'x' }
 */function flattenMessages(obj){var prefix=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var out={};for(var _i=0,_Object$entries=Object.entries(obj);_i<_Object$entries.length;_i++){var _Object$entries$_i=_slicedToArray(_Object$entries[_i],2),k=_Object$entries$_i[0],v=_Object$entries$_i[1];var key=prefix?"".concat(prefix,".").concat(k):k;if(typeof v==='string'){out[key]=v;}else if(v!==null&&_typeof(v)==='object'&&!Array.isArray(v)){Object.assign(out,flattenMessages(v,key));}}return out;}

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var verticals={indexTitle:'GastroBuddy for your type of venue',indexIntro:'Same product, different floor. Pick your venue type for a short, practical view of how GastroBuddy fits, then start a free month when you are ready.',pickLabel:'Pick your venue',cta:'Start my free month',ctaHint:'First month free · Setup takes minutes',seeGuides:'Browse ops guides →',seeCompare:'Compare to paper & spreadsheets →',otherVerticals:'Other venue types',restaurants:{label:'Restaurants',metaTitle:'GastroBuddy for restaurants — floor ops & free trial',metaDescription:'Checklists, cash closings, recipes, and team progress for restaurants. Start a free month of GastroBuddy.',title:'GastroBuddy for restaurants',intro:'Built for busy dining floors where open/close, HACCP-style checks, and kitchen prep cannot live only in a binder.',painsTitle:'What restaurant teams struggle with',pains:{p1:'Paper lists that nobody updates mid-service',p2:'Cash and tips tracked separately from floor tasks',p3:'Recipes and MEP lists that go out of date',p4:'New staff learning by shadowing only'},fitsTitle:'How GastroBuddy helps',fits:{f1:'Live task lists for open, close, and mid-shift routines',f2:'Cash register tracking and day closings in the same account',f3:'Recipes and mise en place with kitchen context',f4:'AI assistant for owners to draft lists and recipes from chat'}},hotels:{label:'Hotels',metaTitle:'GastroBuddy for hotels — F&B and floor routines',metaDescription:'Coordinate hotel F&B and ops checklists across shifts. GastroBuddy for hotel teams — free month available.',title:'GastroBuddy for hotels',intro:'Hotel F&B and facilities teams need consistent routines across outlets and shifts, without chasing WhatsApp threads.',painsTitle:'What hotel ops feel every week',pains:{p1:'Different outlets, same brand standards, inconsistent execution',p2:'Handover notes lost between night and morning teams',p3:'Checklists living in shared drives nobody opens on the floor',p4:'Managers spending time chasing completion instead of guests'},fitsTitle:'How GastroBuddy helps',fits:{f1:'Shared task progress managers can see without interrupting service',f2:'Location-aware setup when you run more than one outlet',f3:'Structured open/close and facility lists on phone or tablet',f4:'Web dashboard for owners and managers alongside mobile apps'}},bars:{label:'Bars',metaTitle:'GastroBuddy for bars — close-out, prep & team lists',metaDescription:'Bar open/close, stock-facing checklists, and recipes for bar teams. Try GastroBuddy free for a month.',title:'GastroBuddy for bars',intro:'Bars move fast after last call. Close-out, restock, and bar recipes need to be on the phone, not in a drawer.',painsTitle:'Typical bar friction',pains:{p1:'Close-out depends on who worked last night',p2:'Garnish and stock notes vanish in group chat',p3:'Cocktail specs differ between staff',p4:'Cash and tips reconciliation is a separate scramble'},fitsTitle:'How GastroBuddy helps',fits:{f1:'Closing checklists with clear ownership per shift',f2:'Recipes with bar context next to floor tasks',f3:'Cash tracking and day closings in one place',f4:'Faster onboarding for new bartenders with step-by-step lists'}},cafes:{label:'Cafés',metaTitle:'GastroBuddy for cafés — morning prep & daily ops',metaDescription:'Morning open routines, quality checks, and team lists for cafés. Start GastroBuddy with a free month.',title:'GastroBuddy for cafés',intro:'Café mornings are won or lost before the first espresso. Prep, cleanliness, and till readiness need a shared list.',painsTitle:'Café realities',pains:{p1:'Opening steps vary by who unlocks the door',p2:'Pastry and milk checks are easy to skip when the queue starts',p3:'Part-time teams miss tribal knowledge',p4:'Paper lists get coffee stains and disappear'},fitsTitle:'How GastroBuddy helps',fits:{f1:'Repeatable open/close plans everyone can follow',f2:'Live progress so the closer knows what is left',f3:'Recipes and prep lists when you bake or batch in-house',f4:'Invite staff when you are ready — no need to onboard everyone day one'}},catering:{label:'Catering',metaTitle:'GastroBuddy for catering — event prep & team checklists',metaDescription:'Event prep lists, mise en place, and team coordination for catering. Free month of GastroBuddy.',title:'GastroBuddy for catering',intro:'Catering runs on prep windows and load-out checklists. When the list lives in one person’s head, quality slips.',painsTitle:'Catering pain points',pains:{p1:'Event packs differ; templates get copy-pasted wrong',p2:'Load-in / load-out steps missed under time pressure',p3:'Kitchen and service teams work from different docs',p4:'Hard to see completion across a dispersed crew'},fitsTitle:'How GastroBuddy helps',fits:{f1:'Reusable task lists you can adapt per event type',f2:'MEP and recipe support for production kitchens',f3:'Shared progress when the team is not in one room',f4:'Owner tools to draft lists quickly, including via AI chat'}}};/* harmony default export */ __webpack_exports__["a"] = (verticals);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var guides={indexTitle:'Hospitality ops guides',indexIntro:'Short, practical guides for floor managers and owners. Use them on paper first if you want, then run the same routines in GastroBuddy.',pickLabel:'Browse guides',cta:'Start my free month',ctaHint:'Turn this into live task lists for your team',seeVerticals:'GastroBuddy by venue type →',seeChecklist:'Free open/close checklist →',otherGuides:'More guides',readTime:'About {minutes} min read','open-close':{metaTitle:'Open/close checklist guide for restaurants & bars',metaDescription:'How to design opening and closing routines your team will actually follow — then run them in GastroBuddy.',title:'Open and close without the binder',intro:'Strong open/close lists reduce surprises at service and at lock-up. Keep them short, owned, and visible.',minutes:'4',sections:{s1Title:'1. Split open and close',s1Body:'One giant list gets skipped. Separate opening, mid-shift, and closing so the right people see the right steps.',s2Title:'2. Name the owner',s2Body:'Every item should imply who does it (opener, closer, bar, kitchen). Ambiguous lists create gaps.',s3Title:'3. Keep it floor-length',s3Body:'If it takes longer to read than to do, cut it. Aim for the critical path, not a novel.',s4Title:'4. Make progress visible',s4Body:'Managers should see what is done without interrupting service. That is where a shared app beats paper.',s5Title:'5. Review weekly',s5Body:'Drop steps that never matter; add the ones that caused last week’s issues. Lists should evolve with the venue.'},tip:'Start from our free printable open/close checklist, then migrate the same structure into GastroBuddy.'},'staff-onboarding':{metaTitle:'Onboard hospitality staff with step-by-step plans',metaDescription:'A practical approach to onboarding new floor staff with checklists instead of tribal knowledge only.',title:'Onboard staff with plans, not only shadowing',intro:'Shadow shifts matter — but without a written path, quality depends on who trained whom.',minutes:'5',sections:{s1Title:'1. Day-one essentials only',s1Body:'Safety, guest flow, tills, and the top five station tasks. Everything else can wait for week two.',s2Title:'2. Role-based lists',s2Body:'Server, bar, kitchen, and closer paths should differ. One mega-list overwhelms new hires.',s3Title:'3. Show completion',s3Body:'Let trainers and managers see what the new hire has practiced — without hovering all shift.',s4Title:'4. Repeat until boring',s4Body:'Consistency beats cleverness. The same open/close list builds muscle memory faster than ad-hoc tips.',s5Title:'5. Hand off to the team',s5Body:'When the newbie can complete the list without a buddy, they are closer to independence.'},tip:'GastroBuddy is built for step-by-step plans your team can follow on phone or tablet.'},'haccp-checks':{metaTitle:'HACCP-style checks on the floor — practical guide',metaDescription:'How to keep food-safety style checks short, timely, and actually completed during service.',title:'HACCP-style checks that get done',intro:'Food-safety routines fail when they are buried in binders. Put critical checks where the team already works.',minutes:'5',sections:{s1Title:'1. Critical control first',s1Body:'Temps, cooling, allergen communication, cleaning of high-risk surfaces — not every nice-to-have.',s2Title:'2. Time-box the checks',s2Body:'Attach checks to open, mid-shift, and close so they happen when the workflow already pauses.',s3Title:'3. Record without theatre',s3Body:'Logging should take seconds. If staff dread the form, they will skip it under pressure.',s4Title:'4. Escalate exceptions',s4Body:'A failed temp check needs a clear next step — not just a blank line in a book.',s5Title:'5. Keep proof accessible',s5Body:'Managers and auditors need history. Digital lists beat pages that go missing.'},tip:'Use GastroBuddy task lists for recurring checks; adapt items to your own food-safety plan and legal advice.'},'cash-closing':{metaTitle:'Cash closing checklist for hospitality teams',metaDescription:'A calm close-out: floats, tips, card totals, and handoff — without a midnight scramble.',title:'Cash closing without the scramble',intro:'Day closings go wrong when cash lives in one notebook and tasks live in another. Unify the routine.',minutes:'4',sections:{s1Title:'1. Standardize the sequence',s1Body:'Count, tips, card reconciliation, variances, secure drop — same order every night.',s2Title:'2. Two-person habits where needed',s2Body:'For high-risk steps, define when a second person should verify. Clarity beats improvisation.',s3Title:'3. Capture variances early',s3Body:'Note differences the same night with a short reason. Morning archaeology is expensive.',s4Title:'4. Link close-out to floor close',s4Body:'Cash should be a chapter of closing, not a separate ritual that starts after everyone left.',s5Title:'5. Keep history',s5Body:'Owners need trends across days. Scattered papers hide patterns.'},tip:'GastroBuddy includes cash register tracking and day closings in the same account as your floor lists.'},'mise-en-place':{metaTitle:'Mise en place lists for kitchen and bar',metaDescription:'How to structure MEP and prep lists so production stays ahead of service.',title:'Mise en place that stays ahead of service',intro:'MEP lists fail when they are tribal. Write them as reusable prep plans tied to recipes and stations.',minutes:'4',sections:{s1Title:'1. Station-based batches',s1Body:'Group prep by station or event, not by random shopping thoughts.',s2Title:'2. Tie prep to recipes',s2Body:'When specs change, prep should update with them — not live in a separate sticky note.',s3Title:'3. Par levels in plain language',s3Body:'“Two Lexans of diced onion” beats vague “enough for Friday”.',s4Title:'4. Close the loop after service',s4Body:'What ran out? What was overproduced? Feed that into tomorrow’s list.',s5Title:'5. Share across kitchen and bar',s5Body:'Bar garnish prep and kitchen MEP often collide at the same fridge. One system helps.'},tip:'GastroBuddy supports recipes and mise en place lists with kitchen and bar contexts.'},'multi-location':{metaTitle:'Multi-location hospitality ops — keep standards aligned',metaDescription:'How owners with more than one venue keep open/close and quality standards consistent.',title:'Multi-location without losing the standard',intro:'Two venues means two cultures unless routines are explicit. Shared structure, local detail.',minutes:'5',sections:{s1Title:'1. One core list, local variants',s1Body:'Keep brand-critical steps identical; allow outlet-specific add-ons for layout or concept.',s2Title:'2. Compare completion, not vibes',s2Body:'Managers need to see which location finishes open/close — not rely on “it felt fine”.',s3Title:'3. Separate locations cleanly',s3Body:'Staff and modules should map to the right place so progress is not mixed.',s4Title:'4. Owner view from the browser',s4Body:'You will not be on every floor. A web dashboard matters as much as the apps.',s5Title:'5. Roll out slowly',s5Body:'Pilot one location, then invite the next team. Forced big-bang rollouts create resistance.'},tip:'GastroBuddy is built for locations, modules, and a web dashboard alongside mobile apps.'}};/* harmony default export */ __webpack_exports__["a"] = (guides);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var verticals={indexTitle:'GastroBuddy voor jouw type zaak',indexIntro:'Zelfde app, andere vloer. Kies je type zaak voor een korte uitleg, en start daarna je gratis maand.',pickLabel:'Kies je zaak',cta:'Start mijn gratis maand',ctaHint:'Eerste maand gratis · Klaar in een paar minuten',seeGuides:'Bekijk de horeca-gidsen →',seeCompare:'Vergelijk met papier en spreadsheets →',otherVerticals:'Andere typen zaken',restaurants:{label:'Restaurants',metaTitle:'GastroBuddy voor restaurants — vloer en gratis maand',metaDescription:'Checklists, kasafsluiting, recepten en teamvoortgang voor restaurants. Probeer GastroBuddy een maand gratis.',title:'GastroBuddy voor restaurants',intro:'Voor drukke restaurants waar openen, sluiten, voedselveiligheid en prep niet alleen in een ringband mogen zitten.',painsTitle:'Herkenbaar in de zaak',pains:{p1:'Papieren lijsten die tijdens de service niemand bijwerkt',p2:'Kas en fooien los van de taken op de vloer',p3:'Recepten en mise en place die verouderen',p4:'Nieuw personeel leert vooral door mee te lopen'},fitsTitle:'Wat GastroBuddy daar mee doet',fits:{f1:'Live takenlijsten voor openen, sluiten en tussendoor',f2:'Kasregistratie en dagafsluiting in hetzelfde account',f3:'Recepten en mise en place met keukencontext',f4:'AI-assistent waarmee eigenaren lijsten en recepten uit chat maken'}},hotels:{label:'Hotels',metaTitle:'GastroBuddy voor hotels — F&B en vaste routines',metaDescription:'Stem hotel F&B- en ops-checklists af over diensten. GastroBuddy voor hotelteams, met gratis maand.',title:'GastroBuddy voor hotels',intro:'Hotel F&B en facilities hebben vaste routines nodig over vestigingen en diensten. Zonder WhatsApp-achtervolgingen.',painsTitle:'Wat hotelteams elke week voelen',pains:{p1:'Verschillende vestigingen, dezelfde standaard, wisselende uitvoering',p2:'Overdracht verdwijnt tussen nacht- en ochtendteam',p3:'Checklists in drives die op de vloer niemand opent',p4:'Managers jagen op afronden in plaats van bij gasten te zijn'},fitsTitle:'Wat GastroBuddy daar mee doet',fits:{f1:'Gedeelde taakvoortgang zonder de service te onderbreken',f2:'Werken per locatie als je meerdere vestigingen hebt',f3:'Open- en sluitlijsten plus facilitair op telefoon of tablet',f4:'Webdashboard voor eigenaren en managers naast de apps'}},bars:{label:'Bars',metaTitle:'GastroBuddy voor bars — afsluiting, prep en teamlijsten',metaDescription:'Openen, sluiten, voorraadgerichte checklists en barrecepten. Probeer GastroBuddy een maand gratis.',title:'GastroBuddy voor bars',intro:'Na last call gaat het hard. Afsluiting, bijvullen en barrecepten horen op de telefoon, niet in een la.',painsTitle:'Typische bar-frictie',pains:{p1:'Afsluiten hangt af van wie er gisteren werkte',p2:'Garnish- en voorraadnotities verdwijnen in de groepschat',p3:'Cocktailrecepten verschillen per medewerker',p4:'Kas en fooien worden weer een apart gejakker'},fitsTitle:'Wat GastroBuddy daar mee doet',fits:{f1:'Sluitchecklists met duidelijke eigenaar per dienst',f2:'Recepten met barcontext naast de taken op de vloer',f3:'Kas en dagafsluiting op één plek',f4:'Sneller inwerken van nieuwe bartenders met stappenplannen'}},cafes:{label:'Cafés',metaTitle:'GastroBuddy voor cafés — ochtendprep en dagelijkse ops',metaDescription:'Ochtendroutines, kwaliteitschecks en teamlijsten voor cafés. Start GastroBuddy met een gratis maand.',title:'GastroBuddy voor cafés',intro:'Een caféochtend win of verlies je vóór de eerste espresso. Prep, schoonmaak en kassa-gereedheid horen op één lijst.',painsTitle:'Café-realiteit',pains:{p1:'Openen verschilt per persoon die de deur opent',p2:'Gebak- en melkchecks sneuvelen zodra de rij begint',p3:'Parttimers missen wat “iedereen wel weet”',p4:'Papieren lijsten verdwijnen onder koffievlekken'},fitsTitle:'Wat GastroBuddy daar mee doet',fits:{f1:'Herhaalbare open- en sluitplannen voor iedereen',f2:'Live voortgang zodat de closer ziet wat nog openstaat',f3:'Recepten en preplijsten als je zelf bakt of batcht',f4:'Nodig personeel uit wanneer jij wilt. Niet alles op dag één.'}},catering:{label:'Catering',metaTitle:'GastroBuddy voor catering — eventprep en teamchecklists',metaDescription:'Eventpreplijsten, mise en place en teamcoördinatie voor catering. Gratis maand GastroBuddy.',title:'GastroBuddy voor catering',intro:'Catering draait op prep-windows en load-out-checklists. Zit de lijst in één hoofd, glijdt kwaliteit weg.',painsTitle:'Waar cateringteams tegenaan lopen',pains:{p1:'Eventpacks verschillen. Templates worden verkeerd gekopieerd.',p2:'Load-in- en load-out-stappen sneuvelen onder tijdsdruk',p3:'Keuken en bediening werken vanuit andere documenten',p4:'Voortgang is lastig te zien bij een verspreid team'},fitsTitle:'Wat GastroBuddy daar mee doet',fits:{f1:'Herbruikbare takenlijsten per type event',f2:'Mise en place en recepten voor productiekeukens',f3:'Gedeelde voortgang als het team niet in één ruimte staat',f4:'Tools voor eigenaren om snel lijsten te maken, ook via AI-chat'}}};/* harmony default export */ __webpack_exports__["a"] = (verticals);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var guides={indexTitle:'Gidsen voor horeca-ops',indexIntro:'Korte, praktische gidsen voor managers en eigenaren. Print ze desnoods eerst. Draai dezelfde routines daarna in GastroBuddy.',pickLabel:'Kies een gids',cta:'Start mijn gratis maand',ctaHint:'Zet dit om in live takenlijsten voor je team',seeVerticals:'GastroBuddy per type zaak →',seeChecklist:'Gratis open/sluit-checklist →',otherGuides:'Meer gidsen',readTime:'Ongeveer {minutes} min lezen','open-close':{metaTitle:'Open/sluit-checklist: gids voor restaurants en bars',metaDescription:'Zo maak je open- en sluitroutines die je team echt volgt. En die je daarna in GastroBuddy draait.',title:'Openen en sluiten zonder ringband',intro:'Goede open- en sluitlijsten voorkomen verrassingen bij service en bij afsluiten. Houd ze kort, met een duidelijke eigenaar, en zichtbaar.',minutes:'4',sections:{s1Title:'1. Splits openen en sluiten',s1Body:'Eén reuzenlijst wordt overgeslagen. Scheid openen, tussendoor en sluiten. Dan ziet iedereen alleen de stappen die ertoe doen.',s2Title:'2. Benoem de eigenaar',s2Body:'Elk item moet duidelijk maken wie het doet: opener, closer, bar of keuken. Vage lijsten maken gaten.',s3Title:'3. Houd het kort voor de vloer',s3Body:'Duur het lezen langer dan het doen, snijd bij. Alleen het kritieke pad. Geen roman.',s4Title:'4. Maak voortgang zichtbaar',s4Body:'Managers moeten zien wat klaar is zonder de service te storen. Daar wint een gedeelde app van papier.',s5Title:'5. Kijk er wekelijks naar',s5Body:'Schrap stappen die nooit ertoe doen. Voeg toe wat vorige week misging. Lijsten groeien mee met de zaak.'},tip:'Begin met onze gratis printbare open/sluit-checklist. Zet dezelfde structuur daarna in GastroBuddy.'},'staff-onboarding':{metaTitle:'Personeel inwerken met stappenplannen in de horeca',metaDescription:'Praktische aanpak om nieuw vloerpersoneel in te werken met checklists. Niet alleen stille kennis.',title:'Inwerken met plannen, niet alleen meelopen',intro:'Meelopen blijft belangrijk. Zonder pad hangt kwaliteit af van wie wie opleidde.',minutes:'5',sections:{s1Title:'1. Alleen de essentials op dag één',s1Body:'Veiligheid, gastflow, kassa en de top vijf stationstaken. De rest kan week twee.',s2Title:'2. Lijsten per rol',s2Body:'Bediening, bar, keuken en closer verschillen. Eén mega-lijst overweldigt nieuwkomers.',s3Title:'3. Toon afronding',s3Body:'Trainers en managers zien wat geoefend is. Zonder de hele dienst eroverheen te hangen.',s4Title:'4. Herhaal tot het saai is',s4Body:'Consistentie wint van slimheid. Dezelfde open- en sluitlijst bouwt sneller spiergeheugen.',s5Title:'5. Draag over aan het team',s5Body:'Als de nieuweling de lijst zonder buddy afrondt, is zelfstandigheid dichterbij.'},tip:'GastroBuddy is gemaakt voor stapsgewijze plannen op telefoon of tablet.'},'haccp-checks':{metaTitle:'HACCP-achtige checks op de vloer — praktische gids',metaDescription:'Zo houd je voedselveiligheid-checks kort, op tijd, en echt afgerond tijdens service.',title:'HACCP-achtige checks die gedaan worden',intro:'Voedselveiligheid faalt in ringbanden. Zet kritieke checks waar het team al werkt.',minutes:'5',sections:{s1Title:'1. Eerst de kritieke controles',s1Body:'Temperaturen, koeling, allergenen, schoonmaak van risicovlakken. Niet elk “leuk om te hebben”.',s2Title:'2. Koppel aan momenten',s2Body:'Hang checks aan openen, midden in de dienst en sluiten. Momenten waarop de flow al even stilstaat.',s3Title:'3. Loggen zonder theater',s3Body:'Registratie moet seconden kosten. Wordt het formulier gevreesd, dan wordt het overgeslagen.',s4Title:'4. Escaleer uitzonderingen',s4Body:'Een mislukte temperatuurcheck vraagt een volgende stap. Niet alleen een lege regel.',s5Title:'5. Bewijs toegankelijk houden',s5Body:'Managers en audits hebben historie nodig. Digitale lijsten winnen van zoekgeraakte pagina’s.'},tip:'Gebruik GastroBuddy-takenlijsten voor terugkerende checks. Stem items af op jouw plan en juridisch advies.'},'cash-closing':{metaTitle:'Kasafsluiting-checklist voor horecateams',metaDescription:'Rustige dagafsluiting: wisselgeld, fooien, pin-totalen en overdracht. Zonder gejakker om middernacht.',title:'Kasafsluiting zonder gejakker',intro:'Dagafsluitingen gaan mis als kas in één schrift zit en taken elders. Maak er één routine van.',minutes:'4',sections:{s1Title:'1. Standaardiseer de volgorde',s1Body:'Tellen, fooien, pin-afstemming, verschillen, kluis. Elke nacht dezelfde volgorde.',s2Title:'2. Twee personen waar nodig',s2Body:'Bepaal bij risicostappen wanneer een tweede persoon meekijkt. Duidelijkheid wint van improvisatie.',s3Title:'3. Leg verschillen meteen vast',s3Body:'Noteer afwijkingen dezelfde nacht met een korte reden. Ochtendonderzoek is duur.',s4Title:'4. Koppel aan floorsluiting',s4Body:'Kas is een hoofdstuk van sluiten. Geen apart ritueel nadat iedereen weg is.',s5Title:'5. Bewaar historie',s5Body:'Eigenaren willen trends over dagen. Verspreid papier verbergt patronen.'},tip:'GastroBuddy heeft kasregistratie en dagafsluitingen in hetzelfde account als je vloerlijsten.'},'mise-en-place':{metaTitle:'Mise en place-lijsten voor keuken en bar',metaDescription:'Zo structureer je MEP- en preplijsten zodat productie voorloopt op service.',title:'Mise en place die voorloopt op service',intro:'Mise en place faalt als het stille kennis is. Schrijf herbruikbare prepplannen gekoppeld aan recepten en stations.',minutes:'4',sections:{s1Title:'1. Batches per station',s1Body:'Groepeer prep per station of event. Niet als willekeurige boodschappenlijst.',s2Title:'2. Koppel prep aan recepten',s2Body:'Als specs wijzigen, moet prep meeveranderen. Niet op een aparte sticky note leven.',s3Title:'3. Par levels in gewone taal',s3Body:'“Twee GN’s ui brunoise” wint van vaag “genoeg voor vrijdag”.',s4Title:'4. Sluit de lus na service',s4Body:'Wat was op? Wat was te veel? Voed dat morgen weer in.',s5Title:'5. Deel keuken en bar',s5Body:'Bargarnish en keuken-MEP delen vaak dezelfde koelkast. Eén systeem helpt.'},tip:'GastroBuddy ondersteunt recepten en mise en place met keuken- en barcontext.'},'multi-location':{metaTitle:'Multi-locatie horeca-ops — standaarden gelijk houden',metaDescription:'Zo houden eigenaren met meerdere zaken open/sluit en kwaliteit consistent.',title:'Multi-locatie zonder de standaard te verliezen',intro:'Twee zaken betekent twee culturen, tenzij routines expliciet zijn. Gedeelde structuur, lokale details.',minutes:'5',sections:{s1Title:'1. Eén kernlijst, lokale varianten',s1Body:'Merkkritieke stappen gelijk. Vestiging-specifieke toevoegingen voor layout of concept.',s2Title:'2. Vergelijk afronding, geen gevoel',s2Body:'Managers moeten zien welke locatie open/sluit afrondt. Niet “het voelde prima”.',s3Title:'3. Scheid locaties schoon',s3Body:'Personeel en modules horen bij de juiste plek, zodat voortgang niet mengt.',s4Title:'4. Owner-view in de browser',s4Body:'Je staat niet op elke vloer. Een webdashboard telt even zwaar als de apps.',s5Title:'5. Rol langzaam uit',s5Body:'Pilot één locatie. Nodig daarna het volgende team uit. Alles tegelijk creëert weerstand.'},tip:'GastroBuddy is gemaakt voor locaties, modules en een webdashboard naast mobiele apps.'}};/* harmony default export */ __webpack_exports__["a"] = (guides);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Hero__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_SiteFooter__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SiteHeader__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_StickyMobileCta__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_TrustProof__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_home_HomeModules__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_home_HomeOutcomes__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_home_HomeReady__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Video__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_static_images_background_2x_jpg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_static_images_background_2x_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_static_images_background_2x_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_static_images_screenshots_home_png__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_static_images_screenshots_home_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_static_images_screenshots_home_png__);
var IndexPage=function IndexPage(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_12_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Hero__["a" /* default */],{as:"div",background:__WEBPACK_IMPORTED_MODULE_13_static_images_background_2x_jpg___default.a,className:"gb-home-hero text-white"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_SiteHeader__["a" /* default */],{variant:"onHero"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container gb-home-hero__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-home-hero__copy gb-hero-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"gb-home-hero__title m-0"},t('home.heroTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-home-hero__subtitle m-0 gb-form-lede"},t('home.heroSubtitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-home-hero__cta",id:"gb-hero-cta-end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__["a" /* default */],{href:"/onboard",buttonLabel:t('home.ctaPrimary'),hint:t('home.ctaPrimaryHint'),onDark:true,trackProps:{source:'home_hero'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_TrustProof__["a" /* default */],{onDark:true,className:"mt-35"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-home-hero__links m-0 gb-form-lede"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"gb-home-hero__link",to:"/for"},t('home.forLink')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-home-hero__dot","aria-hidden":true},"\xB7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"gb-home-hero__link",to:"/guides"},t('home.guidesLink')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-home-hero__dot","aria-hidden":true},"\xB7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"gb-home-hero__link",to:"/checklist"},t('home.checklistLink'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-home-hero__media"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"gb-float-slow gb-home-hero__phone",src:__WEBPACK_IMPORTED_MODULE_14_static_images_screenshots_home_png___default.a,alt:t('home.heroHomeAlt')})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("main",{className:"gb-home-main"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_home_HomeOutcomes__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_home_HomeModules__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Video__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_home_HomeReady__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_SiteFooter__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_StickyMobileCta__["a" /* default */],{showAfterId:"gb-hero-cta-end",hideNearId:"gb-site-footer"}));};/* harmony default export */ __webpack_exports__["a"] = (IndexPage);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__(100);
/** Bridges react-router-dom v4 Link with @types/react 16.14 JSX checks. */var Link=__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["b" /* Link */];

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAK0AAAA+CAYAAAEuWqs4AAAABGdBTUEAALGPC/xhBQAAFfVJREFUeAHtnQnQXUWVxxPCIksgJCwBhAwIKIsIAWEGZFgVUAZrKFAopoARdBBQieKgbEPNDBRTCIiCo4CADFDjRBw1FkKBoMCENSwJm8omu0DYlxCWb37/fn065/Xr+95973vf95HkO1XnndPn/M/pvn379u3b937J2DGRBgYG1kQ9DB4/duzYaWYflCRpTg8MKqGCybi/suaJrCazx/LXY4yKM83nbOfIEezI+1MhIlUWFQK3wvzV4BwYmFfwP2pxY1HeBPABD5JOP8s3IJn76pSXAHSjgD6B1y2JKjEyWy7lTzb0tZsM0YPtLG+XDr0kN/LVKEMiOWJYs5CjgrZvRtYvpf4j8ecI2xF+mq74t/opyshwgnJXqY9zTMeyuqAEil1zT+7z+IiZVcBcqFERKA+I5hOjbBIe2+RYUNhwyQV6ONu+9Xfh28D7pftu8rrHYd9OQyclky4SqKEN7G4BZne+FSNGYm2zG94S7JkMUfGJfBD2h+BJ8kOHNsTAlRFzZsqD47jobBEJ1IPix3Hqkqo8VX1ahR8yu+uC99DX6VSR4TvhhsRP5ZfWbYDhTJYaFH0rIE8yf7RtjVwO1q3C6HhhKKRrV45oezDKdOZxvSvwiwKJDNAotV413o5+D/wNxXjCdgD8Nvw72ZG+QqvjKcyvwhtFTKnBYZkAZkn4ZXiOsEr4MBwoGBo2MzXJgv8Ys5lUgHTEKvAJVo42862Ylc1+Q7QvQdxzsO5s4YqWPRCGr8GBzGaykx3/GoY1qRinv0nxNVe2hlU1+MuGlSR2wbQTHWGW8JX4gE76SMwa4Z6kikU08E+dGon/jga6t6VRjfxtIWkeNhS9rcXJFrCmN63ltKabQyMvRo4o2XDQGFu+XUti77eDDLlPV+FxnRo65K2oW4EuMkef7hQHVle76ORO2L77G/U2fjslB/VGOzy+i2EbWn46Ow/72cqv+CjDnSuz+RjDhfV4iNOPkQKrCMxrhpMs4TC/JTvyJHHUzWaV42qQ/CKVMjnO2ZZLvkZY4zcad6D0mHQjyroFJjJ7LgEUe8sChZce5Wcs3tlSJzjbVilORkebOP2VCJrrbFLD/CzFKvMS8wOw1gLrxvhTzY9tNvxd+F34eme3A0g58Zvtf1HnwQfkj1dqyHuWpCCXYQqbb4mGezoLvWSNonIdzcpWzuSKvqGZLxU5kF1UsANyUjcabx+P7xLzZz7r1dTT8odgBYiCoWFbuWFJv6s5XzKazcvkpCGyqxxlU2OjLZ0ljzWd0A2lJ3LJU2PlxD4h+pqeKqrwlhB/Vc/uEfOmesD+RvlcbFE3f7Fnk7OgKLlRwe3zXSo/WK1x1YNXx7KFP52VdRGl53KB5G8ibG/J0QPd3JRoGAotd5u6dQ73TKB2hdkgVvyFmg3dfSQaWmwbw+GQHoaED0mPNMUKFiNjGLY6XnqnuNHbQ19oU7jpftNDjkUiJHSChh1Ho6euftBBpSRUYSvi8M6ghFnkbBz0lurcAvVl9JHXnofyKvaq05l5UCy/ncdiT2ta78O+ekWOa4Wr8HUy6yoPBPDKCvASSv4vJacF9yrJ+Xopb7S1Wz+nKsE+JnwyVChA9hMO0qPRk1IMinq3L5s9l2Bm5TiVRR5LcV9vkw5NyTCyPaPOvUVaTh7cjU4ePeFUUpe59DQUDg6hJfcM+Co4P2CZ0v6eCtCMvC5s68G7wmFj1fuxVXYuPk/am9/cYqOjab8o2l5R5z4eC03CBe/d5HAbnIaRBJO2rjN8KGbY+zBO87aSDubAmEuj8UfwZbGcOjcvKw82exSegj49Ys5Gfhk+Bg7zv68TW2XnZrhpYFvqx/Rf8PfgObBobzXknaBmP7GRxY6P0BcjRtvY7cg/EoRLNIK/6Ru9KOq6ab1QdWAsqfSKcKUKf3jQxLdKhX95Ld4hnbw71aHgNnPYpZxeqcYTURLLKsgcPgG2LWQ3m2Fy2ckP/nyHeVnxVpakeLts0OrennQcfjQFpH4SICqYVk7O9krL/kkF/KC8jlI5xoYnf/kphw0m5BdjOUB8LIZS54Z3M4YLQQMDtntWyrGNjIaPdf17jNssyia/x0rXyL0xN5bKjMAXNQzxTSz5sa0lPxSmiwqMN9/tC13o60esyS5CW6BpSdXiGTOm5Tg4tuPBTYLV9vCqqBCXTJoPfw0fniwdlNh5Gj0rANWG7frYKh95wYXLt5B2dsFWZdKNSBu+4+CpEbRplOciv4RfX1DdAGsa2xfO6RQw8zEuDe8fnfokJhH+M2JBm3BpgzkBUDjWF8DJdL23l/Q6uzavEviHyOpMXUqyid+A1cnjI09AqmHiD8OVT300Mj16g1skyTpXl/rc4TrCxaFj1ZfhEVdDPR7w3kPcwRstLh2rfmx7aTK36LLWjWMKrOXGZFjTgN66LQPrGV88D34enknn3YJc7Ek3s0R0pEax7oJ2o0i+LpS2J6uLPAs1NEwHOgI6dS/Eu/BgOlV5mk6Wci+OZDexj3Pwt/apA5ZkOtAJWqzJOrbtk0U3PbQ43aDa9Yu+UvqHdoB++KjjU7Co1p5tP+oc8Rwc7NPhkFt/fohJz+Lhu5teG0q8dWqqoddcC1VcOtpmpS8PDaT8ZHPaVKo1B4PWyS3Rtr6TASzlQA9nvqqBo8+PK0k5Kp0DAx+KftsoyqG/rQqe4RvXi05Nu+S1+XKdnBF/ucdGmx6zE2G7NNrPlUwOlGi/0GyUNf2JjjWbZMM08OOCbaeC7b4Ys+APrCKIPCcqlyWMeZM43SfrVifLjilTWTm4Ts4YunEnbMT9BWmdFj4wUlz0nV0zR92OfTnmfkT5fW6Ka8pWteb8owd3o5Pzb8Ff1ybmKFYOF7Xx5y490amDTnKO+eQ4Jdq1CSTaF5veW0mfDq8gBdK0cwT2I0Kp8aPj+wj4pk5x/qJKDttpCx9fAVqjAHwh2ACXaOdCQEcTibYtJXO2EzomcYAYt5ZM6HrhKBbpMToQ+jUyuHLYpLaySSArwboZHw6LbjOfZMNUnAqiK4kLLQ5L6f1a+AMuS5iiovIxC46VvhTtG3m71/GHnfg8kSufZnhspTNt7iRj7G7JgBJtaT/Y5c/VwxQXjTsUcmh/I1HEtZ0KwEyKOF0Ryn2HyilJw7ZdsOmnQOsZGF/+MlKXehOB2bKQw5v+0wIwhg8urNxOugSXo+tGcW+0XaA49HVjWU+OiaLtPRmiroFxNKwN9AthUegcC2qYiiO2dPO6M+a2bx/uJv778MUxT+XNK3xOC0i75yX6a9egzUsAZ7vYYVc1u9naSbDj4J/BL8P6S69H4DC3Kg59Dtw0YqL922ZHbgzfBOuyVY5H4e/k9WITtR2xMbdwoWNj+WDKf4I1ANVfP4WXtDOK3kTh9UqTpbUwFdOmreYmS1oqYbXLKADyA1vkyk3dsKAQ3nRSvGyBqWvtCussIifm0eZbZGV+wLEc7sQ6aMq3VGDama+zDgPUNFItyPztpGELMj0gRN8WPo/hZTO9IM+3mIIvmJx/rYjxx6VpStRYXhnYZMPX8quXgonw3taCqDbcnAJRgH21BPWYKt3ivB9bmPfNFjEdO9bwksTcoDizxRzhKo3+8dF2icPMjLZJEfOqyubPZdrozhzjfZmFtO66s7ytQr8LbLqxRcyUCmyv5vDU02twjDu6XTzHoLfRor0aIrwGt/2JZ+lPrRT0AHKk+XNZ1bFr50Aq2wrbHbndle8D0zRyom/QHRtHShDk/Ct4zZi7V/FUzcD8Vf7OxKnProXncbznVOWp6lh9I9BCJNoSY2nkPohvk5aAhmHQHUvuQKTTI/iNcN2OabSg9TeselrNLZYXvYVGXEf5uWizR2YPSXpXHasokmvk+tc46tQNUsZWZdAdaymp5130H1rZydIHa3Y5O1hS0zdiyVJWSlfobEFjW8pRWDUCSlQcsQYkqR5fw2Ia/RCzV8hVC/aBgq3SRF1nRKc2XP6xAPwNGD1Jaf7dPvrD05lhXQ4d22fM7uQpYOZTXhq2T5JOdf7uVJIVqbss1ehi8oEBfb7UkSpi9WGz//J6MuWr4VdgPf08Ah9rydFzmofhSjgNqhxAWZvjh1oOL7FfI7y3lXTtgGsibnoezoCPUlZHiJ+GtQGiy0ysqURzjVYR4g/CWqqJ01oYPafjGOmn5MZFqayOncQBPT+cB0Wnjh3O+kairiU4xrlU/MIwVn7NMNY1YlWlkVNn3uhDK7Xzv0wf8rzvU6TlVrw8/zKELZ61uHSq+jB1rAoc+GSEbkb/A3e884HpRFq+aLNjHLm1/l1sKE0FnY6YqWJrMLvBeqG2KWwnAXVI6WxOyleGtIbR5AtVD1QOWgap3imeBze9UhqJo2PQVrZzJNozWufI9kDLYGCwfp4mXQY33d5GtpljlmXczhvhNoxW/z7pAb8joRX8/fC675O2WTPmjg5Y64pRqR4Isymzqz40fhZ+vw1YtfEe/dQljmVHWC9C74f3qxs3ilt4eiAsDzi5M2jynoNstm7f2jjTjqSkXh/JpqfctwpSHxCqfmNdQNIl34HfgK9nlr0d2ZE4Bj0k/gLO3wcq9lTyfFvKKC0CPcDJXg3uhg5/Px02Ddefk7xZ8wD63nbq3Qe+BH4A1nfm+hxP/7yQpF76aNb/AbxlnX4DF/4AAOnp5HaxAKfAJ8O/h/8M65/k1YsrfRaoT00egvXPG30TXtFyofdEiq8RqM/C1Q7d8S6A9WDfQtj1jdHnYX3gpu8458I6n2q/Po/UJ4j6B2kPgsNyVu9rPkWmq1qylQ03MWNtW3YNr5V270qNukOUZtZ2jZnNMRQ7sF1Q7ov1X+3sD6PfCusuo33Y5eH14O1ge3aYTt2fo1wkcupup2MS2aueiY3imO2InRn1JIj5EYUvJcOYMb9Cvw1+BdYdS4N0J1jn2eiz5PoVsVeawcm/QbeB/SR6y/KM2N2J9XvNPwP3uMshVeflw/DOKkT6KbFpyUaKv8Ou9hrdjTIHfglW/pXgTWB/we+rK+ZINaAmXUSCESXauTOsWawX0gy4dz8OgDy3ugZ8sionGH0Q/YfIGtRFwr8crJnJaFeUnayA1LdkNvhTDmxPOcxRyZEpYE6ANduKj8jcqYgv/NtlSFH4piQ5ndJwp19dFEUCcWBCcd48CPv1zlc5GYL5uMPdqkH7PWfopB7rKx1OnYbtAL/eqYFt/If1s73UY38LoyrXGGxucvxSiSKl7/Aon2lG5CV5Pdh+7vzz0fV3hifC/wTrtqvB/zF4fB5bKoPr96D9BjmNHvR1YvR9OMH7vA5uBUuAfE2DVh/j1KV9fLLh0GnYJ+DwCXDdRma4fx6KdlKHZm2jyVYHhjXMWJBvGs5LcIc47BPoeiBNRPlB598/OaKCT310PjwH1nqwEx2Z57Aygb0MWk0m+gDMs+8frW+vgFexeiQpe4y2XIsE7gOw0Xytae8CWXeNtzVrEq2XikSujXFMg1+DTwf7RBFYw0gura2ugmvNEIWUJ1P/8QV7X0y0T2tGa9tHqatl7aeKwK2FsH5o+fe78WvAa+2oXRPRSbDOiSetDf8jGrTrsgb1zVWZ+LWjXeIZ7PK3ELgDMNpMrX/aalILCAO4WYip0XcBuOLnpuD8mvYK8E/FGBPKvwM8MRq0vt6VfL+PZdX1HLoN5NXxPWs+L8HpGB+LticU+BBclz7ik5lO8Gfh0hX+PPatDVdHgtf6xd82KHZFZ5XqIcNkWE/4Xyv5u7WRR0+0RrpFL1nKgf07BkL+Mcdgu9n5tabV03OJ/Xr3BssD9l4X/xWz5xLMcQ5nF1EOC4PW4fqxpj3V5Wua8LBr18XolJbGRAOA0w2EPE+N1DZNXfqgT0zQ9nBpsOb5dHvfzsfmOv6pcPiLpDy4ZvnH4Jpuq6oD22qwP7Ffz+vupUxObdXou+i6pD7QnSgR5WNdsHYf2hLY2Q7/LYEprw/rtlyXdL4qvyfB18vyoN2D2DTXsDv9AWLXP0NxnfN3Uq8FEP6t+m6exLUFEYjgazrVUPBrBm3qMMqbwZqRe6X/JnCctcsktlVgf5It/9GGGZULZw9oHVW5AC4c0lvO9jun11U16LVVpNvffrDWMNqbK66vOiSdgX9p1kH7we8alpyTYK0JtV76qNmdtLWjM42qC1UPcIK7WT+u6g+O2KXhXmZcwnom3ZJbXihgmwjfWSNruK364+hVr1HXO2CegfWm5zR4nbwubJ62yP1WBrSFB5pd0tsrdC0JHod/Ae/tY02viPPmOjn89ttbBOsBskj4psLqHyO9oKhF2j3QonytWmje8DCrPZJjyaEZ9Gq46daf4wZZ/j/id6P+1/M81H8Qtotye0W5b3+Wpt52dVyObk+4Zl4ZZQ/Y/xXrARzDZQbIckzF17TuczgN6DusDC6t37Mc54CZbziklk56FtkG9ud5D1JciS1QP3IoEXkOR6gNRgdTz0+sIAnmKMSZztaCcb5WlQT3q8E1abPWDAss5JgA314zV12Y3t3roqgk/NpMr0tHVCbq0pFVuEtVOLgbHfY0j3N2qf2Yae0VrK8m6OQ/0NWnz1ATObvUnnJYMuI3hfWiw+hc57vcjEg9nLbcfQxbJbVN82qVs2DXzFFJXFEv4dyKhgh3DWz7fZUxbRxz8O1EzrltMOaaYkoNOVR/BKetuqVc/epb9cPusO2c/Bn9X+GRopmu4g2d3o3aMQfn7B76QgN/NrwB/EXKH0JqT9YmvhvQdwDr71aYahDJ9PRdlw6tkTJBSLoy7LdQ6tSjvVRtuNcm8N2sqz9RO3EHYHYwWvNpL9U435XRW6Hp8PI+LWVPQz3TruMqa5qsnF1qu5m2Moc/LtPJdUGWW8VjzN+L1JN0y4Z3m0RdXZ1cRfpPmrYkn2ac29vklesReB3w+tdLn+mAzd3dzLTd5s7rqirvSbtXcLwceiACdLFrDboPrNmnitI6tQDwux7dz06NhP5WrP7uhbrKQQd8gUp+6yr6LjZ7u+fM9dUhHbTWDBr5EqyHNK1NbzJ7lLOQeoWnh7zHM1/dou/ITjFDtTxoV+/mzukHn8x+0jjE4XJVJ9/oXlPqSmY33b1+4PC/dnottR85alXUCURDtoHr0pOd8g23n4ZvVLfx4LTm7ht1Ua9BtcWjO08iyuvB3bxc0aeI+ZtJTF3RL1MDotJVdAPckiPPaWXgfvnmdw0M0r0kaTevT/XK8EhYa5ulu69t8BHUq29P9YR6FvweXJemD7720Qwj3QNhDcUZ16dq3x/pxgxD/foP9R4YhnpGqxjCHgjrK07k2dThN4SHsMoRS/33owN2xPq+rxU3Pa0y4+oVn16nNdn7WuPwJ3ueKvUdcK9Py8Pf4tEa2/ZA05MsJ/bnsGzfgnvdVmlb4TA69dC1C8ez6uiAHcZeH+mqmHlXgs+A9bptYaDHaORhcNPFONL9OFp/f3ugp2UAg0KfM+qFgeeJlCdEm/RlYe0uiPV6U2xlyXHw25H1gYexbNIl9dbmxcgvIDV7WjlIZtH0WSK+UVoMeuD/AZuY1qLMXTqhAAAAAElFTkSuQmCC"

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_trackEvent__ = __webpack_require__(87);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}var StickyMobileCta=function StickyMobileCta(_ref){var showAfterId=_ref.showAfterId,hideNearId=_ref.hideNearId;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_1_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t,localizePath=_useI18n.localizePath,locale=_useI18n.locale;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),pastHero=_useState2[0],setPastHero=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),nearFooter=_useState4[0],setNearFooter=_useState4[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(typeof IntersectionObserver==='undefined')return undefined;var showEl=document.getElementById(showAfterId);var hideEl=document.getElementById(hideNearId);if(!showEl||!hideEl)return undefined;var showObserver=new IntersectionObserver(function(_ref2){var _ref3=_slicedToArray(_ref2,1),entry=_ref3[0];// Visible while hero CTA is still on screen; show sticky once it has scrolled away
setPastHero(!entry.isIntersecting&&entry.boundingClientRect.top<0);},{threshold:0});var hideObserver=new IntersectionObserver(function(_ref4){var _ref5=_slicedToArray(_ref4,1),entry=_ref5[0];setNearFooter(entry.isIntersecting);},{threshold:0,rootMargin:'0px 0px -20% 0px'});showObserver.observe(showEl);hideObserver.observe(hideEl);return function(){showObserver.disconnect();hideObserver.disconnect();};},[showAfterId,hideNearId]);var visible=pastHero&&!nearFooter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-sticky-cta lg:hidden ".concat(visible?'gb-sticky-cta--visible':'').trim(),role:"region","aria-label":t('home.stickyCtaLabel'),"aria-hidden":!visible},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-sticky-cta__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-sticky-cta__hint m-0"},t('home.stickyCtaHint')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:localizePath('/onboard'),className:"gb-btn gb-sticky-cta__button text-white text-base font-bold no-underline",tabIndex:visible?0:-1,onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_2_utils_trackEvent__["a" /* default */])('cta_click',{href:'/onboard',source:'sticky',locale:locale});}},t('home.stickyCta'))));};/* harmony default export */ __webpack_exports__["a"] = (StickyMobileCta);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_static_images_icons__ = __webpack_require__(325);
var AiAssistantIcon=function AiAssistantIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{viewBox:"0 0 64 64","aria-hidden":true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{cx:"32",cy:"32",r:"30",fill:"none",stroke:"currentColor",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"currentColor",d:"M32 18c-6.5 0-11 4.2-11 10.2 0 4.5 2.4 7.8 6 9.4V42c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-4.4c3.6-1.6 6-4.9 6-9.4C43 22.2 38.5 18 32 18zm-1 26h2v2h-2v-2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",d:"M20 14l3 3M44 14l-3 3M32 12v4"}));};var FacilityIcon=function FacilityIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{viewBox:"0 0 64 64","aria-hidden":true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"10",y:"18",width:"44",height:"34",rx:"3",fill:"none",stroke:"currentColor",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M10 28h44",stroke:"currentColor",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",d:"M22 38l6 6 14-14"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",d:"M32 10v8"}));};var WebDashboardIcon=function WebDashboardIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{viewBox:"0 0 64 64","aria-hidden":true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"8",y:"12",width:"48",height:"34",rx:"3",fill:"none",stroke:"currentColor",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M8 22h48",stroke:"currentColor",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{cx:"14",cy:"17",r:"2",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{cx:"20",cy:"17",r:"2",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{cx:"26",cy:"17",r:"2",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"22",y:"50",width:"20",height:"4",rx:"1",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M14 46h36v4H14z",fill:"currentColor"}));};var HomeModules=function HomeModules(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_2_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;var modules=[{key:'ai',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AiAssistantIcon,null),title:t('home.modules.aiTitle'),body:t('home.modules.aiBody')},{key:'tasklist',icon:__WEBPACK_IMPORTED_MODULE_3_static_images_icons__["g" /* tasklistIcon */],title:t('home.modules.tasklistTitle'),body:t('home.modules.tasklistBody')},{key:'cash',icon:__WEBPACK_IMPORTED_MODULE_3_static_images_icons__["b" /* cashregisterIcon */],title:t('home.modules.cashTitle'),body:t('home.modules.cashBody')},{key:'recipes',icon:__WEBPACK_IMPORTED_MODULE_3_static_images_icons__["c" /* dishIcon */],title:t('home.modules.recipesTitle'),body:t('home.modules.recipesBody')},{key:'dashboard',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WebDashboardIcon,null),title:t('home.modules.dashboardTitle'),body:t('home.modules.dashboardBody')},{key:'mep',icon:__WEBPACK_IMPORTED_MODULE_3_static_images_icons__["a" /* MEPIcon */],title:t('home.modules.mepTitle'),body:t('home.modules.mepBody')},{key:'facility',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FacilityIcon,null),title:t('home.modules.facilityTitle'),body:t('home.modules.facilityBody')},{key:'whiteboard',icon:__WEBPACK_IMPORTED_MODULE_3_static_images_icons__["h" /* whiteboardIcon */],title:t('home.modules.whiteboardTitle'),body:t('home.modules.whiteboardBody')}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"gb-home-section gb-home-modules","aria-labelledby":"gb-modules-heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container gb-home-section__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-modules-layout"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header",{className:"gb-modules-layout__intro"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{id:"gb-modules-heading",className:"gb-home-section__title"},t('home.modulesTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-home-section__lede m-0"},t('home.modulesLede')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{to:"/for",className:"gb-modules-layout__link"},t('home.forLink'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"gb-module-list m-0 p-0"},modules.map(function(mod){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:mod.key,className:"gb-module-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-module-row__icon","aria-hidden":true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-icon-slot gb-icon-slot--sm"},mod.icon)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-module-row__copy"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"gb-module-row__title m-0"},mod.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-module-row__body m-0"},mod.body)));})))));};/* harmony default export */ __webpack_exports__["a"] = (HomeModules);

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAABJCAYAAAEf/9XsAAAABGdBTUEAALGPC/xhBQAABN5JREFUeAHtWz1MFEEUdu8n54nEkBiip9FDsCJGY2JDKBAOIwkRKbTQxlihnTYmWmuijbEw0cQYC7WxUEkshONHG4N22mEiEBQj0UKJcsgd5/fGXTKzt3M3u7fcLTCbwM6+ee/Ne9978w/GBjypVOoFve2PgYrxfD5/2l4xPz8/FSFiKBR6Ozg4aPAMnZ2d+RBPsJerUUk+jluGdHR0dFtlejPzpSDAn3sAYTsvQeWlpaVbTBLqDtkr8e1E+88GgfPVAEG9TYoh75JRDATCdpTnVilD4XWyJ0HM9uZkCogPsE8VdUQmTPT1IMg6pgnCNBCbLgYI1SG5++lNgjNUQI/eRW+Vh+JotLW1RfA8VxEweULpdLpLOfC8YkqCZR8lfY/nZ+WhoaF3VGCCyNceNF/SXPA9ggwb/tZD5mgfWa44/6oYOMsDL8vVTCbzWqUTC0ZTFxEI5oeMTtVUJ/XRPsfblUcWFxejshnUzmx+h0ip0dTUFGtoaMhImHwlY6AbiSSTyQ+ktZRL5bbMJvlQ6PbyUEUKQTyONdPTcpXb5XlnhAYNw2CZwDPYhd1805AInad4GWnW8Ex+lnWDfqLJdGlINaSuEah40ghDG0ZzjEQGTVw/XJvuLLDZThYaxBryGRiEza5dgL4xyF+FcUPDeJzqi9FcQ0rzJ2aUy/i5X0yxrK7iEzCDr729/QgsvgCrlmSWlUNHXnzFkqRvdHQ0S6cYwyAcLkehquzExMTGiNnYDUy6l1QFvfDRkg3LmZcsaWhf7EWJB5mE0C1aWlrq4/H4bg+KpCLWds1iEBqsqan5ZlX49Uaf7TX7N1MpNEgUdOjH2DMWHIV5MYDihhwRluiuO76XhnkZ3SCPhi9lDakvMPJKNKQ8Gr6UNaS+wMgr0ZDyaPhS1pD6AiOvZH1CKqyyeDj8KBcsE7GsO4HlXZcfykkHbXJ5XUKDqOxHgwd5hjLLvxcWFl7xOoQGsQDu4SudyrgL2om7oCvgPedUX4rmOkuj0eg0UOjDNu9hKeVO9a4bhJInpAjwX3NSWIrGIMXuV3nHhH3kyVJKi9TPVHwHzFK2ont8cp8yD8lAxyCdReBYTVWDOMQ4i0OMz3QBfwyWW3eWf5B8D5D1X1aTN5atsH0HbD+D700mrScC4k0Q2TfOMi5iN37XrFyVL5wovEcnv0PGk280zOQ4T8JcebUWeR9ywkzBe4R+mcSMkAZtD08PYPlTNptNob9NOtkmdRDO7UfqNpIQQv0dr49OCqpI2wv7tqL9RrIV70knW6QO2pgH/DoIs+n1/Em3khAWbiWdlHmZ6p30BJamHQxsaBQN0xFUBCqwbDqCgQ2NomE6gopABZZNRzCwoVE0TEdQEajAsukIBjY0iobpCCoCFVg2HcHAhkbRMB1BRaACy6Z0qobjuTjOSbflcjnhvq9aXoXDYfoTtbhK+8UczHIKenE5Qz8cKVBF3lbBMKmDOAelf5yl+7UtgoSHj9nZ2SzA+UuitbW1YRzUxjyoKRCZm5vLj42N/Sqo4AhSBy0eOPrTKnt5t7a21tXX179BSu0jeZySL+KSpxt/IT3gRZ9bmRUfRWOx2AHLOTIO5Shuf3rdGuqVnyIo3MZ4VSSTw3XcSHNzcyyRSBxF5OoQwTSit5L3j8Jt2Zq/AGXD/lq+wv4HalltOXJDR0gAAAAASUVORK5CYII="

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAACSCAYAAAHqa35UAAAABGdBTUEAALGPC/xhBQAACuxJREFUeAHtXWuIVUUc917XfeSLfD+KcFe00AgUBLfcrq9vQlQKUfsh8kNGJkQQfsw+6YdAy9IIjCAtUumL9CEfbUoKgVagUEYZmrbsmoim+/Cx/f63O9c5Z8+Zc+bcOWfO3P4Xds+cmf/8H7/fzJznnCmMwG/FihXvFQqFaZSO87tz584eqtQVR9gvU0TGZH9mnH2qWP6tXLlySKRVWyFXragSDirjikGoVPIYHAU4DXKZaIdyXmga3epMWKFKUREdOJSSgwcPFsKUlgtUmqMq7g0TCMqHJ2tGJLFGdULjC7Ik55Urtre3T5Ezw9KlUmmMKNOyOHLkyKZEFUUl2mpZ5IoyAoq0Q6iWh47jx49f1ugl/3XusAph+YSXsluphg2q3IATgdkq7STk/5HSxGOOX1nsfRpWdT2NrdwnSHY8B4Dly5dPLRaL3T65mndlfjwG+/r6hkaPHj1CFqjFGgKYiAAuyzoSdylZiU6aDeqgFUuWIY0Fk44QQ6qDVixZz9AmamCQ/Vqka9kODQ2N8tf3GMShuAcCoefP/spJ9hM1GjrMJD2kZX4ALhtctmzZTJwkb00CUZw64LJ46NChZ0m2gCN+L66JJsWpWKvM3bt35zZUjL2Pg+76WhWq6hPnOBj/Um40CPmUSthkWaJWWosDnn6YtKlHONADuqYKGY/BSuafEHhQCNSypQDoJ+sYBinK8zfSyB7rpodFqKtAV54N6iIWKc+QRkKkK8CQ6iIWKc+QRkKkK8CQ6iIWKc+QRkKkK5A5pMNOE+nUH6d3Ri5Ig6IfZhBC9KhhZZBwkjwEcEyu5zEY9y4iPTjp6ur6R1YUN63NIZ1Njxo16jq2N+IakeW0DeLMvL+i4EdZUdy0gNRz/q+qjCvZFlV5VFmBIIoSMlUOdHYXKw2Fbpek+oOxHUCns3qlhGv9v9CEY7/AkKp3BpQjwNUIcH+ho6NjVlNT0++Szn0oDH1CLMnlMgmSNsKx8mNSxHG9obGx8YDwFBlrEfUuse/o9i3R7xDsWO1hxrWgxbAW6LdAIrAwR5m4f7fu8OHDHwa5FMpg3PcJgpRmnYemuCnMppJBUQl98yL65gNiPw/boKeSQX6FMhgk7GIeB+gia7LPzKCMhotpZtBF1mSfmUEZDRfTzKCLrMk+M4MyGi6mmUEXWZN9ZgZlNFxMM4Musib7zAzKaLiYdpbBmzdvxnpqFOu2Ie47zszzTWD4V32I5G9loQHSG8ELFy5sHD9+/FLUj4WWX3kW+/DtMu7Z/hBmKzRAqnDy5Mlb2NT8SBuP5kpw5BvhRH9//5Rjx471iv00t5n0QTk4Cqa5uTn1B6ACtEwCrDzVPU1G8Rjgq7ivAwgna9lSE92Jv3crSujV8VSeDyKoRys2Ut3gmcUq2UB59EEfeRbNaJ9c4HoaLaUfg0+LZ3jFBICn8ep6J4K962KACKobzwo3Hzly5KLwvy4ZpEDB3nQKsoA2O4cmHIiI62WLIOn4OJmmilxDkxxbCWwABZsdDnI+YinPgaEYBgYGWmlqigiO5oQ2Oxxc2XWcUm5H4lXawRskH2dyHCxbzugfWqA8rWdy3QXox5ED9CPi2n7o1QQOHy/j8EGncbn/qc5tQ5sogns795FVHAQZ1dlufp9DA8RolNuLXH8Q9OkDf57YD22iQoC2t27dGpv0LWZZj8k0jncXoC/y7atQBmVn5M/UyPk202hgnguFMF9iBRhW2YV8DtAFllQ+MoMqdFwoYwZdYEnlIzOoQseFMmbQBZZUPjKDKnRcKGMGXWBJ5SMzqELHhTJm0AWWVD4ygyp0XChjBl1gSeUjM6hCx4UyZtAFllQ+MoMqdFwoYwZdYEnlIzOoQseFMmbQBZZUPjKDKnRcKGMGXWBJ5SMzqELHhTJm0AWWVD7GYjDuZESVIVtlsd42xCpN+/F2H021y9NvUhxnQgPEdIPq23xIluIoy6OMqokezaPDQT7RUnJB+ZQXyiDeg16DyVoLwN7EsMp5yL969WoX/AidTBYaIDmPWVzyJAvKSvybN29e45kzZwYTK0hYURlgQp3DqmGAuoTM6TNmzKAZoJgzdcjYl6eHGfNlqPqgTzTZLiZ/vY6a5alupAFNfsXSpUvnJtOmXyv1AOFSye8W3gFv9+eltZ96gJiRucnv/O3btz/z56W1n3qANFAhyBfR9+hE4Qa2CzBFoT+tgPx6Mxlk8P3dT2CY/rL4VSeJoL8XPQz6p2hn4U0KNrYJnWgtH9AU108R6Qsis562NGmL1n3rRKSZ9YmsAERMq8lWuYkiyBZk7MjKeMp2emj9YMS0n+xUrxiEUZx/tmFq3RtotjSbOdba3aIub1NDoAcNcD+ORu/gqPSbbKVKIH3OAgU03jg/01wOsN7SleGy09MD6/lAUW8EinhA5G6Q2ElH+dfQ68TXckQ5XbRdx9/zOMc6UM3kROYI0Kkl+NmDv+r3OIQT4GfDyLa2NjoBDrr99grI+0II89YOAufOnTvb2traDQKf8nuAvFlFsBh2M6p6fPRX5P3MEQjkgrjzXAlm7hYbrBkBJrBmCO0qSHyzCXep16ALPwf3x2Esrt7gsRuOW9aBHw2N9DW0z3FbZW8S77UJxLdU75swYcJJGHsYhpPY5DoVBCT8nkGH+PnKlSsL8SnXmzoAaQ+hWKFwDFrO/TpGWDYaAcKUsI2W9Epo90Bv9Xt7cICeHa/D9tq9XE75EUCvG4e8ndgGXbr5xSP3jREIS/Q1yy5cO/4dafV/LIAL84kgb8AUBNpDqCnDrMcMAkygGRytaWECrUFvxjATaAZHa1qYQGvQmzHMBJrB0ZoWJtAa9GYMM4FmcLSmhQm0Br0Zw0ygGRytaWECrUFvxjATaAZHa1qYQGvQmzHMBJrB0ZoWJtAa9GYMM4FmcLSmhQm0Br0Zw0ygGRytaWECrUFvxjATaAZHa1qYQGvQmzHMBJrB0ZoWJtAa9GYMM4FmcLSmhQm0Br0Zw0ygGRytaWECrUFvxjATaAZHa1qYQGvQmzHMBJrB0ZoWJtAa9GYMM4FmcLSmhQm0Br0Zw0ygGRytaWECrUFvxjATaAZHa1qYQGvQmzHMBJrB0ZoWJtAa9GYMM4FmcLSmhQm0Br0Zw0ygGRytaWECrUFvxjATaAZHa1qMEjgwMBD2/W1rAebNsGmMjH2tEF/gm9nS0nIFHy7NG2Z17Y92DwRJd4AIf2LZfLMYqmCrpVmbQPoe6ODgYDu+DfotLGW+bKVWdG4IDxKWhGmSb60mGkKPHj16DtiU3MCnvr1MRGBeISmVSrMbGho2wL8n8DcefxdwbP4SHxP/SPdj4nmN0e9XXRC4ZMmS6fhg+AmQ9ZAvwFbsP4mv7G/FGlG7sFjUWl+587vax8A8Rtzc3LwtgDyPqyh/Cd+rpnUu6upXFwTiJOCPKFYgQ7/zUXKuldcFgRga3wTwGxXg96AHLsLql8cVMk4W1cUxkJDH0jVbsNmyePFiXE61PILlzmlxkvPI/5XK6/VHBPYGBYcWuwD5u4LK8px34sSJPvh3Ks8+6vpW4SKoWm+ho6NjVmNj408QGrZCJGrQYh60gufpoNqclzoC88HLKlhp8lsCL9dx8f9YefUqnJ3NgeB3+DOyHIzfGO+bRQDkXcbf47hzc9az/FhlJevtIHKaWZOszQQCIK0betaLFaxJp4dA2QjWk5+J/UVYU34ZtjNAKj8qkgFKOQ2y6ArhEtaOP4Lt9ziDvhhk8l/ht6klJRJpgwAAAABJRU5ErkJggg=="

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cashregister@2x.75738447.png";

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAABrCAYAAAHShlqSAAAABGdBTUEAALGPC/xhBQAAH7pJREFUeAHtnQmYFcW1x2FYhj2ABNAIDAQBQccFFFlFxUTFGJe4xN0kokajETXx5b1nzDN5WQREjCgYRXmIS0ziFvAFFAIMmwIGQUEWwQUEBWQVhi2/f9vV1u3b3bfvNnMHp7+vblWdOnXq1KlT26nqvjVqRD9F0ckxUgcOHLjz9NNPPxADNRFFmeyMdjgRMzgWyvrkyZNrBmeJAaU6K/1ofk796QlxCNxpA4h/11SN8CQ7LTRMhrFKNBnd8Ew7HprZSoglB5uoZNevX79D69Wrt1Z0Dhw4cEbNmjVfCSRkMoL0zJQpUy6xCi4aMGBA82nTpn1qcJS2f//+Fg6OgK673soUGLQJ2Ai1FaHkRZR8jJ2QbtghRB1LozLScr8Fx2nZSP3ys0u8TDA/PKowL83NuNsD5CowcuTI4qxoibNTTz31W3GJeJ3VL4uioqIL4hJxWgrt/LqdIbI1bEQ3HKjJBs+0Enq1Hb1qbOBJPojn2EBl7NatW93u3bvXEdwQsnH8YcnkBRRrZ9++fZuZxEMPPfTy+fPn71E8TtW86qj0JUuWlBtCxqeVzqtVq9ZfFacDXvjqq68+B3fq3YcKpkI8IgLoAWEY3hCF/VyoaoLB+fN0ie8KB3m9L8A8ACcEZRLMfkSExz9s1KgBkf02YlT4tNNOOzcovTZN5ylcEIJg4kD+vn37zpcf+MDNNCuhSJnkKPlmCx4adARLhoVgHIv0T0T6r4dihyQktU4Ingc2VROAQm+i0Ae9xHwEENM6Cp3rp20YkY/IDvGnZxtPkAxMPI36XWwTDdDdmcD62ji5CicwY4jC1H/C1K+JT6fgkw08wJdy7TNwP+MGHtcPZMafWUMpE/0GwemMD9NtbjA4MP4JjDvzNWkfkXa4SUvXr6lRsXnz5t7YFFQ76YiBu3oznPht6RaWCt+RjFuAHzehQIND7btS+3f8yHYc5T4BaZWBV9eG2+GOHTsWl5SUzALveAOP1UwG2fgafJg27zdx1y9DWtIvR4dovukU1M+Ho+hvwfuFgYN3HHiziRcHMoMUNHWcZzLIRyJDqekdNixVWNJkLLrFzzi05kBLPdJTfo+WMmn+8gA5ClDrpThnko1D0ll4gDiQiXQKfqCk4hDy41BBLYA7I4XB/rSwuFe4pENbaqZzZrKwDAZOjZMGSNJGQuMWg5Ou7zED8YEoErQm19R6hnHldeLftAnS/ucxFz1vwyo7XHT33XfXywcTnmTiEEd4zyCtiwyupGjCufBTrobsQsSIYQDF/MxOy0U4kBkps5+46fomjXHCWyf7cTONJ4iZZniO2idsSIwkVIBhxIZlWnBQvgTJ+BmhKW61M9Gb7soXIyonQTKm5oYBCq5FOPZS3eTL1E9gRkRoqkFI6GWFU0nBx/wG8FspX6ZPQjOJCIr5d7wbaKIE3YlRQMsYOJEoSZIJwrYl4JdWVFoQrSiYIxkI/iMMiWZbqjQxobHFLtzkAb7Mz6RJS8d3dmtkoAxn+3GjPzP605nt31mCB40tYgJ4F3++TOKOZPbs2fN1EWUR9Ed/zan1BJYXE0855ZRu/rRMCozKU5MCrgBhnB/JFjtN9TISGgROOfCU9iLwJ4DfCdwefrom7i9X5QUqMGvcTiwV3jUZU/i1KHwahSdt7HwV+iU4d/togTL5W5I4z82BzPgyJESxczatXbu2DB9H2AkQuwDdccwugoc1qc2g8KjIOGipdWqYZafCgQ/IHUB+g0RvYqTgPbheFD4nMJMLBAeUKacbHDHoSjFhlwrez8C7N0kyzM69UeSZMOClgbyRean7a6+9tsYQTuVT6AJIHEfeVfgdbHxg36Pwv9gwhVWglDhh/gF52YYNG7ovWrRohz9D3LisaIcddthuaO2Bmd40j6Qb/dBle4a1b3TO1Knp0i2aOnVqkh0mdTH5wbAVWMuF5B1eBuXS4xrR47amm9VRUlecs2jXPukSEH7//v3b1K1bVwr7xVHGF0RiDZB2eY5kZHo0plk7MSzsWhlkQfAki6JugU5HetzKsHyp4F73lXT8A5LJTDc9n4ITuiKFq9DudNEtBi9b36uZCFHoKxA/A/9WCh9uE6fwGaQNAJYwDNg42YY9yYiQ3RUp/CkKvzTbAtLJn8BMOhnj4qJfXZHyRFw75aGSHzOaD0K3FsSlURl4eRMMAhnCFKejEOdBII8hnDOJOGcn+FlZT76gmr/fvAiGvngkQnhbbKMdrXfv3l1ev379TaYaYQOISS8EP2GQCWKIvv4B8ECTN8PtOXSJlwLyeZYkBLQUoTR1cQYhlIkB+AUHitQYhKKFVYMorsNan670H3Sl/1VeutFKBs+OUXQKLS1UMHQHGTpDtzxuhe+lwj8rtErlgp9QwRjiCGg1AnJmFAOTz7jRYfr06e/ZsEzC0Hf2D1beB9HCm6x4pQRTCsbmyre2WIa2ZGx2QCArEXjCRsoui+53HfTH2LCKDKccfG1mwsYTG0eL8jp16vSn0jqnnGan+cKR5jbyjwa/0gSTlsb4KuZFzQ7WA/gCtP6TCOlyH9iJ2loogIQv4dJNNRtW2uMIBrX+Cy2UcFlj165dLWfMmPFJHM5M5bSIQwA/tPNYaT8m7SE7rZDDRQjldiMUtRaVO1sM61hfldLgGLcC0DnRxrVvWpH2kZ1W6GFdRvoaTAcdXsly0MSuAEL7Aa0+1oaZMHRkCAocs8h3Bvn+3+AWmF+TNZfOSG7DDYDXB+A10cBJ5drCtNYup4DUF6Qu+N4qVhUC9jwZz1M4nw/mxFNZIA6hjLPgIWksxHZehwule1PxoIYHRwbUmyGTYJQNy7t169avJRUYhpxLOLasetiyLoJRne0dG0WbhlhE+v2bN29+mhuC3qVr4LpB0QtaHaGlU46roWe2Hkkkwd9L+vPs3YZjYtfVj6SHoWM3wLrgLs+LYHTHuLi4eDCMXEdBZjedxIgAMPEK3jAqOSUQwQeE+XMAveADi86nlPcY+7dRMlCbrg38HUh3NfjABxDWzSN1n7D6l4clGDqBPn2yFJo/JfES/PqBSABhajveBPz7aaW3w/DShZuZjnwJ56DSRGyRF9MFpYnHRNGFp7fh/b5NmzZNkCb6cQMFQ8V1k1yz1Wn+DL74B6jmQ+Xl5X+KO7X78mcUhb/LqPz4qMxU/BX4H8pMOw28fVG4QWmOYGiB+0m8OQBhPrBhSPU5cwM4AKdSQJbWPE3lv59rJjyNMQXRR6+hjz6e64JyTY+xwjNMa/2Va/rOsbGIonrOOoM+GrhOyXXBOaD3mxzQCCVhS9o7CURrzkdr/haaq4ISGExbMBX/iLHixxTZJqBY3dbsGwDPGmSvVA9ArQzXxz1lsoWWdUFBBKh4Fyqu64SXU/lGQTiCoc27SH/CXYNoXZP3J6HyMFobk4G5ATqQ1ng1Gw60ekXIt0NDpwNRzzoqPxrj1xhmt3VRiBWVliAYFcogvBDvWBjVHQFvDPIz1KtXr/oNGzbUbPBTWvNof7odh9Qi3HC66DMs43fZaYUaThKMGEU4m/CaxWWaSv8dN4xF3NS4eQodL1Awhml1LbRCm7j29O9JEydOfNekHex+pGByVfnBgwfX4Y5KnbVr1+4ZM2aMGcNyRT4vdPIuGBZiD8D5jWidUxZdbixj1w/yUpscEs2bYEpLSxu2atVKm8jAJx+r1cCCMgSGzjoZ0vOy2UJBS1bhfuUlVoFAXgRD97nH1B2BnEvX+SbxnxnY3r17TzLhQvXzIhiGE/Oe0waEovd1ddfTsdsgqF8X0nW7sIaJNcZg/7gK+8fjIkLFSqmsjE6hNg6zUwdXB2ZrEcrd+Mq7kLzHK1zoT6RgEMjlCOT/gipBJbdRyYRTBIOHhjgnBuBsRCiHuPDdDLgJhnWDX4h+ZFcKE4oqQoUbIzjnDCqgYs7BmiUUnTBWGaGoPqGCoTuktIpR8cDpGE1KsAayOdSxTJV6QgVDLSakqgkCmBaGgzm0LmmL2TieVdnn0GE8RsFte4yNFyUwGy807NqII3fdoZkLICFMAPs1g0TxR/qoqPSqnhY5K7G77ojhanlAJXcymDYMgKcFYvDWGdDTVqZNdL1SzKofWbBKCYZpjMMMRqUV69evb4TJQUeg9rqlgUwS2XCMUB7xCUXkmmPx+5Dp/rhsaOcib6RgVIBeicEANQrhjLALZHAttuPphBFqU4Tyo7A8zHYLwtIqCp5SMIYRhHM748q7uHEIqUU27xBhAP+9oRvmI7ySsLSKgKfVHZieO6diim4wEJyWbBRfoyt+HISPcMejFYOD0gwM4XUkvNrEK9qPHHzTYQZ5PEllL/Xl2bdz585mZWVl23xwJ8ohQjvGlNVBadu3bz9k9uzZsj1XyhO7K0VxxypZb5f4haIstRo0aLAVP7Ac8iQMsnTRyxFIA4TZpDKFIsaNxhQxS4yG0WYw93Omy5VKjPMwFjRiSnc0gi6ylu6m5f8+hHUF/jiXxlym9yQbjN/KR/6m5N8Sp9x84yR99kcFwmDo9VM/QwjgLmC/EpzKG0E7aKS9SOA7QWkOQgH/FDVr1myWnz805zLGDHWBlA9C7BKGxGLtr2FphQ4vQgg9xCQVfEEtjr9GceCNafEDetNW8YjHuyKmrmHjsVZxNMmGVZWwPSjuFtP08RKE81+mAkybc7RKNXG/D/5jBiYDOJp2KePOUfh6ecKYG4YbnKri657vCiogY7X/kaDs1e1mNKq5H0lxBHcJ2vFUUBqwHeQLvckQkqfCwNS/LfW/ngJ/iEI0o6Flm97nDJYkfkJiizjc+AdYk4cu1501yRzoeItGCnqWgi42OJn6PXv2bNK4ceMryX8T9Dtn80oQdT0SOj/B6epJYz9P8HwHPA/1ZhHUX3dvdedWF3FOxulTaN/wZ0Qw6n66S5O3p3fv3i1Z/1xL+WrJw/0FwXxsozqLyBNpsFvJcwH06vhp+ePgrUEwJV7rutcz5oAoN9SfQXd3161bp5VozoWifRGNoltTP4B5Yzz3s+DFwUlYGHoJBOjWp5M+BHeGDSduRxXWnZwxwMfQ2GvRJG1TLsO1U2IStoD5fjQ4IwhdYddqOWEm85Wt+7dPUYH7acW3YH4geSYLR13a/fTiuaTromIvX15/dAV4D7KHexwl+MyfqC4GDR0L1cBy0LBCBKMpH0HcBmPnUbinpX7miG8G53H8PyKIVQHp3j3BgLRAEO8c1Hd7Q1K6lhctW7ZU4+jyk3d7XKv/KCaTCMUFqGXB1dsckeqMED7CjWYh+AjMfxyDfmg3hs4/KU/fxXyJ4o8ivEj0PvzwQy8PmtqC7Ytmnx+TbpYSScWSNitrjaGw2gxu50JM/TpSnWFIZtIHcOPQiIz2RCw6NQY6i04EejL7uulJNQOgxakLf4lye8Fb1KwrG/fLaMowQy9tjaFfN2AboXcIbqXgo4KYsmBvUtgIKpCzu3dU4F7Kfk5lQNsZE0x5DLxdSVO3uMzA8L9D3Io6q3zdA3yW8eY+NPXNhEQ3kpgjAINLiM2ZOq9mAXcTye0DUGyQWm+Y1BnftJidnnVYGmrdLB0NQc1i5+FqhRFHmBpsH8fpJa2gsSspa5JgUMHDIKQ+eC3YLZNyWADw9ME6fcV1mgXOe9DqJoFlwdda3MPU4Ql4ez8QKQXQ6UoUdD2E/gAhZyXoVz2XRjk4z9EthnONY34KuvlOXkwBXjeGL41dI7dt2zZu7ty5sawCqRg0Y8xDfmFQ2DYyPwFcnzNRwQXzwNt98PWoGNJ6Jh+MOUTRGJ0ZFVGgrm2UUtjafBSWK5q6fN2oUSMt/mowgPbIhwZr3yNbzMvyEcohhS4U8Yk9+HP5elgqRJ42fIGV/q8RzFCTVW/dm3AV8aO2FBlXwREMh2kzDAUuKl9gwoXqs2M+1fCGto834Vz6ZvBVdzpAV5JpcwgFhBmdcll22rRY6ssU8hsynmky06ivmHAufU8wEJ2GO4WCe+SygGxooRj9WVjeBg2tXpNmH31/Ihv6UXk9wVCuxplTXGR1sf1RGfOQVhNBnC1BwMvJUfTR6n+ycBsQhZNtmt0K3p9msIg7i83UpGyJR+XXIN+6dWu9ra/NZ6jhSTQQhPZEI3hb/8mgd6Sjysk0zdMYCHgaQqvpAnNOBdOnT5/GfN3sKujG+cbCXDaIQxk/9F6m1lgV/tiCUeFa6nenBU2XypghdrqtyKzPGFyPOywFockI4l4EMTkFXoUl+wUzjJInuKVrtxq7tdj1lrDr/Ql5rsE1c2kEeaL5N1asQwv56rw9xtSw/76Gfh35zRemzqOpoGwfl+A3CJKAC9sJrSdxI9AIjRVV4kkQjDimwvuprAOnVY+iVZcIjt1Wrx3L6Hwu0VDbB2mbEMKj5B2FEWg18Sr5JAmGsaGUwfdfadTmQwTxMO5PaMT6NPIVNGqSYMQtWtMXzfC2CXYNEMAy3Egu+IzPle3Dpl8o4UDBGOYGDRqk48yzcEuZNaZMmjRJ59lfiSdSMFVJAsyKuiKrs6FO+B3R6g9wy9k2LJ41a9aGqlSXQua1yiqMVhZNmza9E+W4HQE3iSHkHSjQ79hV/L7QvhEUg/eCQfGvewuGsTBGdKrEM4458/thOCHwhuS5h6PCPqR71pwQ3GpwiAQcu2ZIWsGBMda0YzO2PkBZNHrcwbWGZjpLIfxDmE9aV2iKYjmuU8TqJ0MJVJkpSX9L2r59+zeop3f66Nb5HpTkLoXZy3VmL/caCuU3cbA23X8V25Xxbp5qL0MJ5HxKYso4nCmjP725GeuL97ixNS0Xlsi2bdvqtCRBWSjjBcy+Uhb9FZdefLk4QA5/ZuS5lE3+3oC0alCaEsh6hNE9Tr4Tra/+llL2z2m0On4eSPsI+BrgxYQXER7FqKDRIvbDdPQdRo8XfRnGY7L/K4r5LDT9yr+OUWVgVTKL+epWkNGMFUanYDSgrNaZHnKvpkF70KAb40iGkUv/8PUvFKNDKnyUcggjz32p8KrT05dApote/b/lQxSXqbKI0xLc2QrEeZhStoN3Nsqgi0yBD2lT9X54tbIEiicnwLRHGPeQYAo9vV6WHExnbfFtFEE3SmM/2lazU3qEDFebTFIipqYzOcgoM7BqPz8SSEthXBuIpgVZVLN6aOSHGQluyIaIdk4rVqwoh0ZebhJnw9vBmjetKcndaejaQdYPCvNstkRQFtlaqpUlW0GmkT+tEcbQdf+dQttZvWnS2sBj+DKw/TfGswcKZZvLqFmP9Vhv6tEHvwP81SK8mQX5AsLTuDS1Jka9vjIoGSmMLR12S3r/cjSwY214WJhGuJWpaERYekXApSSsg8TDdXHKg+eVrJGuql4j5ef1UP2v11th6xyE/xmuS2VdEoE3vZv7aBxFCcCZzy7s5Gy+rxRAs0qB0lrDxKyZXij8EbjetU8rn2wvl1aWsvBazYVZKIuq0Z0PVvwDP+oKmVXdgy+Y9ZQUJRK9SMo3GIpcG0oUaoWkMbo8hsJck21hKH1/lD7whlm2tAs9f14VJpvKcyfybBr3Blwv6PivCX8C7J803Cgabmo65UD3BGhegNOt/E64Nri0RgwW7SexnpmbTrkHC25BKYx7LqVte890BMwUOIVGvJCR7LN08jHiHI3i6Ewr0GIN3Zmk6xsh+uu+lvj6qs4dnIP5z7TSKbZK4xaMwtDzr2Nb+3CQNGmo2cDn4zQS9KTRjg/CA3YRjfnnkLQkMGWeQZmTkhJcwFd56gmTiacw9Db9Ma9M7hf6kWmwjbj/Yfgf6U/LRZyyvY/jWPR2sJXVy2PTLZgXpLFlA9IptX06vo+RpifThZQr1uN+sENnVN2g1YVMukuznrLvgU46rwnEKq+qIzkKw+7hCioyLk5lEKz+Yex6lEe9PicP5Y+F0NU2Mcq4GHtNpDUYPdMHzR7w5fs9+e60YdXh3EmgNkI/jsbR7sGjSnwX7lqG6074d9q9mLDm81k0svAf532T27L9mCxD/xbK8spXgHJLEgABEeHYfAuF+NYA1GpQjiSgb0f+DSGfa9OjIW6ml3o9t3///u3r1q2rb6Z828YzYfC3kHYn64fANYjBC/OxFn8ThXkTGo1sHOiO3bFjx4321yyU7n4ycSz45/vw1/M15NLq10psqeQ2XFNrARor6UCRxlpLUctpFL3fI4PbSvBWE9cO5he4sFc7tH64Pt0bdZjru2Cu1/WE5rigR182oviENYuN9wGRkyhXfFc/WUiAtmjNZbWOkNjBwLHQJuXMQ4wy6qnP0Bj+a442bibh0fT4O8I+Jh9EEF6uBD4SXr4WlB4A24AiDaZiLwSkVSpIC+omTZocQUdrwiJ6YYEYMHX/uR3y7Y7cdOjaC78zftMwYTFY9DZr1i8XLmCzLjlCwiez3ttpQ7gx4QScMKIR8MVclDouk9NpKnYSPJwJC/p4gox3RA98iv86lZjEDmpBRLl5T+rbt2+z4uLiLihEb/iS8GUMbIdLXJB9ycmDjIA3fRnNfci1rndihDgR6noHSx+36QBvGV94o266bO8sWzJRhlpMY3ottTmEvgEjbWg8LT7bw1gb/MOBt8BvgL+Ibe41KMtS0qrcI0Mia7djqIsEL4uzvmDaKouKyFRwDIq+MlMaTBctkH1XKanL07GSOeEwJU1ZFO2kTqjPLsymLedx++APhDUlmQe29/WG73mZTEH7GJ50cVtuuaFY1XwEr7qXIJweCNwRPr6OCsLWZnGqqHXWahDfwJ8OPY2M11oZ9fblT4j/1ILZQW1C1On0Z+vi6SSc7EMtbKR0wtDRBbMPoCGbUhkNL6V4m04sJQl8mGnUKR6yEmuhoPrs1cWZjDAWncIN6gPOLVq00Nyss6N+cHo8fgf84ky5RvbboaHPV8zFn4ng53/88cerlyxZUh5E0108Lgb3EJNOXu0of0n8SJw2EEfgMv5cH/Q+h94qfG02ZjKiv867YMszuYIBv5q29A90em3oXug2Iu48xPegbCdUWYWxh2YqpjXEMdRMvTObOn0CncW42TgpxFv0xA9dmWXkMWL8DpZ+nlFmMsHHZ3jvQEOGUinWdTjvIT32X/QgM+cLF4wWJ0JP06xGMi0nYs004D6VjXA9pvMQqInt53AWlDIq5mxoRjBroKdL7DPw52LjeTtbo2OqulOPNqyDdKEscNcHHzID6OU+TRWzy8vLF8+YMWNdEF3X/iRabU06+T8nTzf+nvU9ppLDGAW05joJp0V4N/AONbiZ+ND/iHxvwdso1jAvVYrC6LZ/SUmJVu49YEgKoaG5I/HGmVRKeaCzC28VNObhl2lo3rp16/JcvKYr+tk8bBJG0KtvsWnA70R2HoNsWFTY/WBiCXR+DV7SeV9U3rA0eNhD2nu4hbiZKNvrrOmWwteWsDx5URj1BD48fySFa/3QB8aOw28PE3XDGEkFh4Yq8Q5Of7gzi8ot2LJly/tV4VsvsmQjCy06E9Yq1KkfjTNTddeHIxmJOoGn6UJTbHfA7Qlnsx3eBo1lOC3CVc7CNWvWrHTftiCa/pORwmgxh6Y7WztVjmKPxiX9mU+a7OjeiQ425+LKENzig8lqy1pG/5k4OE2ZRKIjp23QfBt/qmRGeBEKKIu3dkZ5eYIWO7WYd9ti+NH+vg9O90+6UnqYyT4lY1RmLzRWg/gmTovJefxl1tKZM2duTpn5IEFgirwPmV6JHOKOGPuo+vu4N5HfLPw5+O+4Jo1Kk4o3wrBgOgcuXsiQkx3kW4EivC5NZ/SZz4Jyhf/QMEPaB002ZDyWylztq5DWXI9ozbVx48YVmWyHffTyGvVGGBpai9CwwjaRoPWDpotZrMoXsCqX9qsXVD8xJYDshiPjS0G313ItOW97Jp3ztpjF5QXN05CgLRsl6vPDRzMvrspL6V9BoqxlXkJpzrarzsh8I1PNKBtWqGHv/EEf3UU5HvQx2oD4nT5YdTQLCaAsI/zZgZ3qhxVq3FMYl8FH8ROMRlTmMuZema+rnxxIgE55WQCZpQGwggQlKIy7An/Yx6lOnW/2waqjaUqAqei7uHV0wGvsrMj2XRa8v7NhhRz21jCGSaySraiUDsy8E1IqtY159mhMw2sMXrWfKAFzNwZoL3aJupQkY2UJ8Vq4wAecF/nQ9PeqgvHRVCBJYZSA0vyGSv/CIMlHYYYxAt1uw75KYfcTJ6XUWX9WK4XQZfjWGcpgPJfnb8n3OVaGvEVmC1QYLLn6dKoOuZqa3AjoM5TmKEYZHUYdVA/1lXlB/7x+PPXsTWfRTb/Ia4sxBGDfjdFRRhkn3zoeyJsVNgZPWaMEKoyostAdhjfEV8JvMdcnjDy+9IKMun9u3okOoPMZ3fU4Hl+HnfUzZRga5m7MPOjoOsQbrEXeQyl2ZUqzKuQLVRgOzNrR0zTKeCfICOVT3FFMTesLqXJMoYfApy4kOcf6+Mfi2uESFvXE03l0N0bXFvUPcWX4ixhd38ev0iNEOgIIwg1VGCGzqn+AhrjJzojw7kJh7rFh+Q5riuQWWCkNqINOKYUOO1tmWi501OjvQ2cRfhnRuZxtLeEeyieZ0vyq5ItUGNf+ogNDGfDMswml6ZqrUca656HXHnTRWgrRGb+JKTBdHzq7oLGafDrW1/phHv4ypovt6dKqxk+UQKTCCBWlkV3Gfy1wNvP1t+I0AKNDIykA1xW64/ej4eR3gGax6Gf4yCq9DDpShFm4N6Lu1mZYRnW2AAmkVBjtIHgm0TgD/flpKF3QeQ0nu00RcW079c0V7wqhP0/M+AbRZCTTkX5O7tbGLLcaLYUEUiqMyc9IcxaNNwFlCLybavBi+PvBce7W4msxOaci7tbG4KsaJYYEYiuMoeWeal9JXJeBNKIkTC0o1efAVwF/A+e89sD/Lr5bfTcGaRwEz78BPIeT0So9ag8AAAAASUVORK5CYII="

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dish@2x.167984dd.png";

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MEP@2x.daf5b414.png";

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tasklist@2x.680e213e.png";

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIsAAABpCAYAAAF9kuDgAAAABGdBTUEAALGPC/xhBQAADCVJREFUeAHtnQuMHVUZx/fubmuXrRGikaQ+0sdGgcbFpMRCF2sf2witFLGWWpMiaiBg1BBADWplrV1SAxZMFF+ESFCptiYKVFPb7TbGtSqtj5VG0ZI0CJsaxUrXbYHuw993e+cyjzM7M3dm7sy9851k7sz5zjnf43++85zHLbUQVq1aNSXnGOHrLb29vUdiMCgXFUVa4zKxyjsYod3nrISo53Z7gVKptJV4P0crTB+wp7mv9+3b9xEHLRWMAO27DikRIg7TKPchjuulPExvkrMhjO/du9drdlqm1eyYbtNurpjShqbfMZhVJk1NTR0aGBi435GeimkOCREjJcmfgFYPlBJo+fG7DyzZ7WisEeGoZk+EicNvUO0WWvF9nB+sijFceFp6XGATw8RhDlqtp/XunKZ1t5D+TY+FiZuDfX0eKSEIDnNAvcwkau04mFhCPVVoJficE3G2EqrHHjXLTBiXLvLRtK7kKrb4Ubmfqqv0ijBpPQCyOpE6SsqAKjJ2hitWrLiqra3tUaFZiKH9abSfZc8X9XpiYmLx/v37f+dXzqgMBR6jgKPaaBYdfkySoue/mqiSq6mSn4jFVjXRJ04QrUl5i0cQgsZqokp+SkFHNcGwLYhZ3PSaLI0r1K+8ERmqZDUFdkshC+IkWpPFK5IyFPoZBRzVVMjWVEYg7gzCD/oodJnuPkKBD0QplEZe8ae2BQsW7EqDeVSe8+fPbym3JhY/d+Ogn47KIKn8lovkqp9RZfyq1xcZetwb/QqlRfcbDsrbB93d3d8fHh4eE+GWk8VRpKbhgNa1hynEuy1FRAFo3+BU80yP8gNBhhiRoZlf4S4I7WNuWtJxX59JWlAYfvlXZuHChTNpTXeHsSbJPEafmTNnzksipKenZ8vQ0NCoXNfamnDcF/C3c4VHUDAqA4Ov0Zo+bikiTCYnJ29qbW11TLiCmEs6inh3PHwKGpWBwSfIL0c1sIv4rWokpYv8O3BKhgeyNSKDsw7V6rCBEqfJYPQZ8i+RMosWLTrn8OHDp+Q6rnI0gI343Q7h5ReMysiAhvD1liJSOM7YRMssBSkiMozKSAIK7ZSzFXRsspDI4mxsTVkoIjKTuWeRgPY0kL52fmR0XpMAvzgsSjSQLwoyX4ZLZgu4OBakVZYK2iC19B66pLIMrge5kI3OIoYbwOHCiuEXuvvfQ7jRvUVEhUl2L3ZbwNS2qVsE4HI1FOQJcAXGpzbcfYxPtrNk1wz4FPPATlMBmmsfHVmWoP8G3WR/v+YQGpjly5e/1SXlHOIynDmejgGUlwFlhitv3aPoe/ng4OBQrYJDA4OQpxASuOBnVJtZqzJ5Kpelu+cJB48uCowHkrMEBcYHmNB9DOVlXTVp8WH5MEV/4gG2q6vrVfPmzXuYZOmc6xFkB3UTgqq6JSE0NDCMNm+yC2TkkY7YMyoByvPQO88m20ukd02FLWV4dugXV1poYKiVZxAWOCqh4Oy4SuWhvKcp5EGpPOigwPjUggLjA0zoPoYp9sL29vYn7XzoT+QRMM9osHLlys10vpmAzmj4V24E/NCuZy3XoYFhSXCE3r8qAwX+awKF0esMoITmW2WY0IWMhlTMLMB5KA7LSAbgIYGjEqNX5gvIOIBYZTNxd0t4ns8KjE/tKDA+wDj6GDqupXSwd/nkbWoyg4ljI07uK+0AkC0VqxdzlqNwQUYzK4DJn0pLlix5fWdn5z8tYtHPZ86cOa9VAXG6wYwZM05op+vEpBxzdLi0p1sNeQpBol/ZbhnqeO4jzEzWKthsZ0bf6m0fbT6G2lVQFBQDAgaSeoqCYkDAQFJPUVAMCBhIjsmbId1BYh93Ma9/v5+Jzr3MaUYciU0UCQ0K+7LbAOMzFdtvB6BL2dP9rRsLJkErob3LTa9nnAq7E3nVyVhU2aFBsQFSlsHOvzzjP88ukM3ktxDfZ6dlcU3FfBZgQtvm1jF0R8u66LSr8F9ccXkjKC+b2bHezg+N5vj4+JtZVv9LgACgF9nNlxfiHUFukeAt6/EqT5ojY4oRZL88MjLyyTgiQoNy4MCBfyPolS0qH6nci5EXsnPxUraPioHk0M0nkFMTZVBQDJWpoCgoBgQMJPUUBcWAgIEUekiWskz1P8hpA5O0/uk+VWWQ01Ck0KAAyENMjK4T61gUruXbYGsrn+RyGEy+GyGsdRBTjDCR/F6Yt3mjqBAaFAsQiznA3M+14/W9ZcuWvZ18qb9vb+kgZ+StQe6vmFw+a6fHuQ7d0VIjL7gEHXTFW/gSQvkTDW562nEqyL0uiyUytKccO3bs/Llz545SM7Loe5ZV6LVuyTSnp2lWi1DyHe60tOL0b7+k+chD0ImF0KAcPXr0JY6ZQZIB5vfkkaNhQ+jm07AW1qC4gmIATUFRUAwIGEjqKQmBErj7ZpDTUKTQQzKzxjeyR/uPinWTld3ymm8j5Bml0KAAyNM2Q+SvFX7B5vUrD/JXEpm8rWBm+05b3npelthg38aU/8U4QkODghD3xG2+W7Dc9wGQATe9nnEqT26ExWrioTta1j6b7cYRv8Yel2u+fu0Gzp2lIeKhPYWmspV+ZRd3Bt87Njb27YMHD/7HbSFu+yTNagProysBLYv+Znx0dPR2t15R4/ogYAUxfRAwwHVC9ykBfJoqWUExVKeCoqAYEDCQ1FMUFAMCBpJj8sbEaysTr8J5D5vfjommAxQAqflP+QyANwyJ9ZpDV2fMkVTcSLu8M8d65tdA4HChIkJCS5kCj0tKLPJeByg/h3BJEYFQm4MRYG2/58SJE+9r45tUh3CUi4OLaI6iIoB/dHV0dEzKGFT4braoThDFbnqXCccszl6Y6d5dPOtQyFmdHYeiXbMVKX9heZXJbt/ZLV1PXt7OMOmttJQQoAfxfRvG11lS0kXZNjAC6iwNXHn1Vl2dpd6IN7A8dZYGrrx6q67OUm/EG1ieOksDV169VVdnqTfiDSzPd1Mujk3cb5rF/aavwEP+Oa66X8Ma/jmO29jsi/1x7zj6adnaEEjcWXCUuTjKH3GS17hVgvYGjh3sEq7jafcNpAfeauCBiTsp8wXyai/Y0rId3D4FFp6v+7uxTiOeeAXgKBebHMWl/KU4lfHv3+z5cJSr4dUHLXE97XIa6PpWXgrYmJW+iVcCz7Y/ylDz8DQGTZB+M8+3/2+aPOUkeD1G3nuC8hUlHSwe5GWJzIbwxIchKk7+nus6Hn24gZfB1xG/gt7hXAx9iuNHzFeeiFC5k/CSblcODRkjkIazlE2qvCT/AyJyaGgCBBIfhpoAEzXBBwF1Fh9glOxFQJ3Fi4lSfBBQZ/EBRsleBNRZvJgoxQcBdRYfYJTsRSCVpTO7jK/lVTbZmLvSLpJ9ltPsuWxmy1ruG2loMAQSdxa28S/AIf4ADrPcWEDvgHYP2/i9bLat4TroHkcb95HkW58fdfNqwviXaERyDyy3IfFhiE9zduEUHkexI0D6Bd3d3eI40wYcRRyqCI4iOGymDb1tWkAyTkzcWdjOf5zhZts0dp0ifePw8PDYNHnKSbQ0eYflFhm+gvI2cjr2yceDr6W3/XOe7Uh8GBJjMfoOTncwd7mMuctSwJhN/Bl6lN04wIjkCRvI/1XyyqEhYwRScRbLJnoZ+by25xPbVrqeGwuBxIehxjJftY2CgDpLFLQKnledpeAOEMV8dZYoaBU8rzpLwR0givmprYZ6enpezdeCrme5vIql83ko9XfOj7BC2htFQc2bHwTScBbZot+JiddYZuIwcnk55w+TJv/Mux6naej/WrVsK9I5cWdhI06+GlR1FBOYOM199Dx7hoaGAv/SDH6b2djrg09hh0x65B/zLwCb+BeATHeyE68ADHuC43mTk1g0nGUwjKPQC63FUbYU2VEEM/BaN3v27D65zjIk7iz8pd1zbPefj8P0czjeDSL+N957Wc0W/qYwRpPvcfJtD5O3yfPsP3nyZH/WNiY+DFUMmsBhPs+1HHGC/KnTbTCQQ0PGCCTes2Rsj4pPEQF1lhTBbTbW6izNVqMp2qPOkiK4zcZanaXZajRFe9RZUgS32VirszRbjaZoj6+zsGs4nqJcZZ1TBKj3CT/VSrx+cIQMF/llULoiIAiw+97n27MoRIqAHQGcpbWV/w2/jIsD9gS9VgRcCOw6fvx4//8Bm6t5vcEQeuoAAAAASUVORK5CYII="

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_static_images_icons__ = __webpack_require__(325);
var HomeOutcomes=function HomeOutcomes(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_1_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;var items=[{key:'tablet',icon:__WEBPACK_IMPORTED_MODULE_2_static_images_icons__["f" /* tabletIcon */],title:t('home.outcomes.oneTitle'),body:t('home.outcomes.oneBody')},{key:'eye',icon:__WEBPACK_IMPORTED_MODULE_2_static_images_icons__["d" /* eyeIcon */],title:t('home.outcomes.twoTitle'),body:t('home.outcomes.twoBody')},{key:'quicker',icon:__WEBPACK_IMPORTED_MODULE_2_static_images_icons__["e" /* quickerIcon */],title:t('home.outcomes.threeTitle'),body:t('home.outcomes.threeBody')}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"gb-home-section gb-home-outcomes","aria-labelledby":"gb-outcomes-heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container gb-home-section__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header",{className:"gb-home-section__intro"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{id:"gb-outcomes-heading",className:"gb-home-section__title"},t('home.outcomesTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-home-section__lede m-0"},t('home.outcomesLede'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"gb-outcomes-grid m-0 p-0"},items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:item.key,className:"gb-outcome"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-outcome__icon","aria-hidden":true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-icon-slot"},item.icon)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-outcome__index m-0","aria-hidden":true},String(index+1).padStart(2,'0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"gb-outcome__title m-0"},item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-outcome__body m-0"},item.body));}))));};/* harmony default export */ __webpack_exports__["a"] = (HomeOutcomes);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Hero__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_TrustProof__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_static_images_appstore_png__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_static_images_appstore_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_static_images_appstore_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_static_images_appstore_2x_png__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_static_images_appstore_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_static_images_appstore_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_static_images_hero_png__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_static_images_hero_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_static_images_hero_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_static_images_playstore_png__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_static_images_playstore_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_static_images_playstore_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_static_images_playstore_2x_png__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_static_images_playstore_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_static_images_playstore_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_static_images_screenshots_tasklist_png__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_static_images_screenshots_tasklist_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_static_images_screenshots_tasklist_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_static_images_screenshots_tasklist_2x_png__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_static_images_screenshots_tasklist_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_static_images_screenshots_tasklist_2x_png__);
var HomeReady=function HomeReady(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_4_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t,locale=_useI18n.locale;var playStoreHref=locale==='nl'?'https://play.google.com/store/apps/details?id=com.gastrobuddy&hl=nl':'https://play.google.com/store/apps/details?id=com.gastrobuddy&hl=en';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Hero__["a" /* default */],{background:__WEBPACK_IMPORTED_MODULE_7_static_images_hero_png___default.a,className:"gb-home-ready",as:"section",style:{backgroundPosition:'center bottom'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container gb-home-ready__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-home-ready__copy gb-hero-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"gb-home-ready__title m-0"},t('home.sectionReadyTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-home-ready__body m-0 gb-form-lede"},t('home.sectionReadyBody')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-home-ready__cta"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__["a" /* default */],{href:"/onboard",buttonLabel:t('home.ctaSecondary'),hint:t('home.ctaSecondaryHint'),onDark:true,trackProps:{source:'home_ready'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_TrustProof__["a" /* default */],{onDark:true,className:"mt-25"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-home-ready__media"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"gb-float-slow gb-home-ready__shot",src:__WEBPACK_IMPORTED_MODULE_10_static_images_screenshots_tasklist_png___default.a,srcSet:"".concat(__WEBPACK_IMPORTED_MODULE_11_static_images_screenshots_tasklist_2x_png___default.a," 2x"),alt:t('home.heroTasklistAlt')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container gb-home-ready__apps"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-home-ready__apps-label m-0"},t('home.downloadTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-home-ready__stores"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"gb-store-badge",href:"https://itunes.apple.com/nl/app/gastrobuddy/id1339116265?mt=8",target:"_blank",rel:"noopener noreferrer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5_static_images_appstore_png___default.a,srcSet:"".concat(__WEBPACK_IMPORTED_MODULE_6_static_images_appstore_2x_png___default.a," 2x"),alt:"App Store"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"gb-store-badge",href:playStoreHref,target:"_blank",rel:"noopener noreferrer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8_static_images_playstore_png___default.a,srcSet:"".concat(__WEBPACK_IMPORTED_MODULE_9_static_images_playstore_2x_png___default.a," 2x"),alt:"Google Play"})))));};/* harmony default export */ __webpack_exports__["a"] = (HomeReady);

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/appstore@2x.1b97c6f5.png";

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero.a5faf45d.png";

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/playstore@2x.6df05bc5.png";

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tasklist.38557fc5.png";

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tasklist@2x.bda52cf6.png";

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_I18nContext__ = __webpack_require__(6);
var Video=function Video(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_1_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"gb-home-section gb-home-video","aria-labelledby":"gb-video-heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container gb-home-section__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header",{className:"gb-home-section__intro gb-home-section__intro--center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{id:"gb-video-heading",className:"gb-home-section__title"},t('home.videoHeading')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-home-section__lede m-0"},t('home.videoLede'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-home-video__frame"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe",{title:t('home.videoTitle'),src:"https://player.vimeo.com/video/249669301?color=c9ff23&byline=0&portrait=0",frameBorder:0,allow:"fullscreen; picture-in-picture",allowFullScreen:true}))));};/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/home.e68cf400.png";

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_dashboard__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_SiteFooter__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_SiteHeader__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_forms_AccountForm__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_forms_PasswordForm__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_forms_LocationForm__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_forms_WizardForm__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_i18n_localePath__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_static_images_background_2x_jpg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_static_images_background_2x_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_static_images_background_2x_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_types_onboard__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_identity__ = __webpack_require__(881);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}var API_URL=Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SENTRY_DSN":"https://27a1e003a249b09583f1b35346a157be@o4506479248474112.ingest.us.sentry.io/4511757032161280"}).REACT_APP_API_URL||'';var ONBOARD_PATH='/api/auth/onboard';var ONBOARD_COMPLETE_PATH='/api/auth/onboard-complete';function readCheckoutSessionId(search){var match=/(?:^\?|&)session_id=([^&]+)/.exec(search||'');if(!match||!match[1])return null;try{var id=decodeURIComponent(match[1]).trim();return id.startsWith('cs_')?id:null;}catch(_unused){return null;}}function readStoredTokens(){try{var raw=sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_12_types_onboard__["d" /* ONBOARD_TOKENS_STORAGE_KEY */]);if(!raw)return null;var parsed=JSON.parse(raw);return(parsed===null||parsed===void 0?void 0:parsed.access_token)?parsed:null;}catch(_unused2){return null;}}function OnboardPage(_ref){var location=_ref.location;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_9_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t,locale=_useI18n.locale;var checkoutSessionId=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function(){return readCheckoutSessionId(location.search||'');},[location.search]);var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(_objectSpread({},__WEBPACK_IMPORTED_MODULE_12_types_onboard__["a" /* DEFAULT_ONBOARD_FORM_VALUES */])),_useState2=_slicedToArray(_useState,2),formValues=_useState2[0],setFormValues=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),success=_useState4[0],setSuccess=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])('password'),_useState6=_slicedToArray(_useState5,2),authMode=_useState6[0],setAuthMode=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(0),_useState8=_slicedToArray(_useState7,2),initialPage=_useState8[0],setInitialPage=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState0=_slicedToArray(_useState9,2),googleLoading=_useState0[0],setGoogleLoading=_useState0[1];var _useState1=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState10=_slicedToArray(_useState1,2),oauthBootError=_useState10[0],setOauthBootError=_useState10[1];var googleEnabled=Object(__WEBPACK_IMPORTED_MODULE_13_utils_identity__["b" /* isIdentityConfigured */])();Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(typeof window==='undefined')return;var hash=window.location.hash||'';if(Object(__WEBPACK_IMPORTED_MODULE_13_utils_identity__["a" /* identityHashHasError */])(hash)){setOauthBootError(t('forms.googleFailed'));window.history.replaceState(null,'',window.location.pathname+window.location.search);return;}var tokens=Object(__WEBPACK_IMPORTED_MODULE_13_utils_identity__["c" /* parseIdentityHashTokens */])(hash);if(!(tokens===null||tokens===void 0?void 0:tokens.access_token)){var existing=readStoredTokens();if(existing===null||existing===void 0?void 0:existing.access_token){setAuthMode('google');setInitialPage(2);var _payload=Object(__WEBPACK_IMPORTED_MODULE_13_utils_identity__["d" /* peekJwtPayload */])(existing.access_token);setFormValues(function(prev){var _payload$user_metadat,_payload$user_metadat2;return _objectSpread({},prev,{email:(_payload===null||_payload===void 0?void 0:_payload.email)||prev.email,name:(_payload===null||_payload===void 0?void 0:(_payload$user_metadat=_payload.user_metadata)===null||_payload$user_metadat===void 0?void 0:_payload$user_metadat.full_name)||(_payload===null||_payload===void 0?void 0:(_payload$user_metadat2=_payload.user_metadata)===null||_payload$user_metadat2===void 0?void 0:_payload$user_metadat2.name)||prev.name});});}return;}try{sessionStorage.setItem(__WEBPACK_IMPORTED_MODULE_12_types_onboard__["d" /* ONBOARD_TOKENS_STORAGE_KEY */],JSON.stringify(tokens));var draftRaw=sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_12_types_onboard__["b" /* ONBOARD_OAUTH_STORAGE_KEY */]);if(draftRaw){var draft=JSON.parse(draftRaw);if(draft.checkoutSessionId&&!checkoutSessionId){var next="".concat(window.location.pathname,"?session_id=").concat(encodeURIComponent(draft.checkoutSessionId));window.history.replaceState(null,'',next);}}}catch(_unused3){/* ignore storage failures */}window.history.replaceState(null,'',window.location.pathname+window.location.search);setAuthMode('google');setInitialPage(2);var payload=Object(__WEBPACK_IMPORTED_MODULE_13_utils_identity__["d" /* peekJwtPayload */])(tokens.access_token);setFormValues(function(prev){var _payload$user_metadat3,_payload$user_metadat4;return _objectSpread({},prev,{email:(payload===null||payload===void 0?void 0:payload.email)||prev.email,name:(payload===null||payload===void 0?void 0:(_payload$user_metadat3=payload.user_metadata)===null||_payload$user_metadat3===void 0?void 0:_payload$user_metadat3.full_name)||(payload===null||payload===void 0?void 0:(_payload$user_metadat4=payload.user_metadata)===null||_payload$user_metadat4===void 0?void 0:_payload$user_metadat4.name)||prev.name});});},[checkoutSessionId,t]);var handleGoogleClick=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(){if(!googleEnabled)return;setGoogleLoading(true);setOauthBootError(null);var returnPath=Object(__WEBPACK_IMPORTED_MODULE_10_i18n_localePath__["b" /* withLocalePrefix */])(locale,'/onboard');var qs=checkoutSessionId?"?session_id=".concat(encodeURIComponent(checkoutSessionId)):'';var redirectTo="".concat(window.location.origin).concat(returnPath).concat(qs);var draft={intent:'onboard',checkoutSessionId:checkoutSessionId,returnPath:"".concat(returnPath).concat(qs)};try{sessionStorage.setItem(__WEBPACK_IMPORTED_MODULE_12_types_onboard__["b" /* ONBOARD_OAUTH_STORAGE_KEY */],JSON.stringify(draft));}catch(_unused4){/* continue */}Object(__WEBPACK_IMPORTED_MODULE_13_utils_identity__["e" /* startGoogleOAuth */])(redirectTo);},[checkoutSessionId,googleEnabled,locale]);var handleValidationErrors=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(err,setFieldError,resetPageIndex){var validation=err===null||err===void 0?void 0:err.validation;if(validation){Object.keys(validation).forEach(function(field){var messages=validation[field];if(Array.isArray(messages)&&messages[0]){setFieldError(field,messages[0]);}});var accountFields=['name','email'];var passwordFields=['password'];var keys=Object.keys(validation);if(keys.some(function(r){return accountFields.includes(r);})&&resetPageIndex){resetPageIndex();}else if(keys.some(function(r){return passwordFields.includes(r);})&&resetPageIndex){resetPageIndex();}return;}if((err===null||err===void 0?void 0:err.error)&&setFieldError){setFieldError('_form',err.error);}},[]);var submitPasswordOnboard=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(/*#__PURE__*/function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(values,bag,resetPageIndex){var setFieldError,setSubmitting,body,res,data,message;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setFieldError=bag.setFieldError,setSubmitting=bag.setSubmitting;body=_objectSpread({name:values.name,email:values.email,password:values.password,locationName:values.locationName,address:values.address||'',city:values.city||'',zip:values.zip||'',phone:values.phone||''},checkoutSessionId?{checkoutSessionId:checkoutSessionId}:{});_context.prev=2;_context.next=5;return fetch("".concat(API_URL).concat(ONBOARD_PATH),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});case 5:res=_context.sent;_context.next=8;return res.json()["catch"](function(){return{};});case 8:data=_context.sent;if(res.ok){_context.next=13;break;}handleValidationErrors({error:data.error||t('forms.requestFailed'),validation:data.validation},setFieldError,resetPageIndex);setSubmitting(false);return _context.abrupt("return");case 13:setSuccess(true);setSubmitting(false);_context.next=22;break;case 17:_context.prev=17;_context.t0=_context["catch"](2);message=_context.t0 instanceof Error?_context.t0.message:t('forms.networkError');setFieldError('_form',message);setSubmitting(false);case 22:case"end":return _context.stop();}}},_callee,null,[[2,17]]);}));return function(_x,_x2,_x3){return _ref2.apply(this,arguments);};}(),[handleValidationErrors,t,checkoutSessionId]);var submitGoogleOnboard=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(/*#__PURE__*/function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(values,bag,_resetPageIndex){var setFieldError,setSubmitting,tokens,body,res,data,message;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:setFieldError=bag.setFieldError,setSubmitting=bag.setSubmitting;tokens=readStoredTokens();if(tokens===null||tokens===void 0?void 0:tokens.access_token){_context2.next=8;break;}setFieldError('_form',t('forms.googleSessionExpired'));setSubmitting(false);setAuthMode('password');setInitialPage(0);return _context2.abrupt("return");case 8:body=_objectSpread({locationName:values.locationName,address:values.address||'',city:values.city||'',zip:values.zip||'',phone:values.phone||''},checkoutSessionId?{checkoutSessionId:checkoutSessionId}:{},{},values.name?{name:values.name}:{});_context2.prev=9;_context2.next=12;return fetch("".concat(API_URL).concat(ONBOARD_COMPLETE_PATH),{method:'POST',headers:{'Content-Type':'application/json',Authorization:"Bearer ".concat(tokens.access_token)},body:JSON.stringify(body)});case 12:res=_context2.sent;_context2.next=15;return res.json()["catch"](function(){return{};});case 15:data=_context2.sent;if(!(res.status===409)){_context2.next=20;break;}try{sessionStorage.removeItem(__WEBPACK_IMPORTED_MODULE_12_types_onboard__["d" /* ONBOARD_TOKENS_STORAGE_KEY */]);}catch(_unused5){/* ignore */}window.location.assign(Object(__WEBPACK_IMPORTED_MODULE_0_constants_dashboard__["a" /* default */])());return _context2.abrupt("return");case 20:if(res.ok){_context2.next=24;break;}setFieldError('_form',data.error||t('forms.requestFailed'));setSubmitting(false);return _context2.abrupt("return");case 24:try{sessionStorage.removeItem(__WEBPACK_IMPORTED_MODULE_12_types_onboard__["d" /* ONBOARD_TOKENS_STORAGE_KEY */]);sessionStorage.removeItem(__WEBPACK_IMPORTED_MODULE_12_types_onboard__["b" /* ONBOARD_OAUTH_STORAGE_KEY */]);}catch(_unused6){/* ignore */}setSuccess(true);setSubmitting(false);_context2.next=34;break;case 29:_context2.prev=29;_context2.t0=_context2["catch"](9);message=_context2.t0 instanceof Error?_context2.t0.message:t('forms.networkError');setFieldError('_form',message);setSubmitting(false);case 34:case"end":return _context2.stop();}}},_callee2,null,[[9,29]]);}));return function(_x4,_x5,_x6){return _ref3.apply(this,arguments);};}(),[t,checkoutSessionId]);var renderSuccess=function renderSuccess(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"gb-onboard-success"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",{className:"gb-onboard-panel__title"},t('onboard.thankYouTitle')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"gb-onboard-success__body"},t('onboard.thankYouBodyBefore')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:Object(__WEBPACK_IMPORTED_MODULE_0_constants_dashboard__["a" /* default */])(),className:"gb-onboard-success__cta gb-btn"},t('onboard.thankYouLink')));};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"gb-onboard",style:_defineProperty({},'--gb-onboard-bg-image',"url(".concat(__WEBPACK_IMPORTED_MODULE_11_static_images_background_2x_jpg___default.a,")"))},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_SiteHeader__["a" /* default */],{variant:"onHero"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("main",{className:"gb-onboard__main"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"gb-onboard-panel"},success?renderSuccess():__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,oauthBootError?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"gb-onboard-alert",role:"alert"},oauthBootError):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_forms_WizardForm__["a" /* default */],{key:"".concat(authMode,"-").concat(initialPage),initialValues:formValues,initialPage:initialPage,authMode:authMode,checkoutClaim:Boolean(checkoutSessionId),googleEnabled:googleEnabled&&authMode==='password',googleLoading:googleLoading,onGoogleClick:handleGoogleClick,onSubmit:function onSubmit(values,bag,resetPageIndex){setFormValues(values);if(authMode==='google'){submitGoogleOnboard(values,bag,resetPageIndex);}else{submitPasswordOnboard(values,bag,resetPageIndex);}}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_forms_AccountForm__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_forms_PasswordForm__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_forms_LocationForm__["a" /* default */],null))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_SiteFooter__["a" /* default */],null));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(OnboardPage));

/***/ }),
/* 752 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(90);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 754 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(756);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(757);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(221);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(759),
    ListCache = __webpack_require__(145),
    Map = __webpack_require__(223);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(760),
    hashDelete = __webpack_require__(765),
    hashGet = __webpack_require__(766),
    hashHas = __webpack_require__(767),
    hashSet = __webpack_require__(768);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(144);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(330),
    isMasked = __webpack_require__(762),
    isObject = __webpack_require__(91),
    toSource = __webpack_require__(331);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(763);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(46);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 764 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 765 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(144);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(144);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(144);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 769 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(146);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(146);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(146);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(146);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(147);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 775 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(147);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(147);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(147);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(90),
    arrayMap = __webpack_require__(332),
    isArray = __webpack_require__(45),
    isSymbol = __webpack_require__(220);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(89),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(782);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneDeepWith;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(225),
    arrayEach = __webpack_require__(788),
    assignValue = __webpack_require__(335),
    baseAssign = __webpack_require__(790),
    baseAssignIn = __webpack_require__(796),
    cloneBuffer = __webpack_require__(799),
    copyArray = __webpack_require__(340),
    copySymbols = __webpack_require__(800),
    copySymbolsIn = __webpack_require__(802),
    getAllKeys = __webpack_require__(345),
    getAllKeysIn = __webpack_require__(803),
    getTag = __webpack_require__(112),
    initCloneArray = __webpack_require__(808),
    initCloneByTag = __webpack_require__(809),
    initCloneObject = __webpack_require__(814),
    isArray = __webpack_require__(45),
    isBuffer = __webpack_require__(226),
    isMap = __webpack_require__(816),
    isObject = __webpack_require__(91),
    isSet = __webpack_require__(818),
    keys = __webpack_require__(92);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(145);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 784 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 785 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 786 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(145),
    Map = __webpack_require__(223),
    MapCache = __webpack_require__(221);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 788 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(150),
    keys = __webpack_require__(92);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 791 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 792 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(89),
    isLength = __webpack_require__(224),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(230),
    nativeKeys = __webpack_require__(795);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(338);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(150),
    keysIn = __webpack_require__(339);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(91),
    isPrototype = __webpack_require__(230),
    nativeKeysIn = __webpack_require__(798);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 798 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(46);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(227)(module)))

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(150),
    getSymbols = __webpack_require__(232);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 801 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(150),
    getSymbolsIn = __webpack_require__(342);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(346),
    getSymbolsIn = __webpack_require__(342),
    keysIn = __webpack_require__(339);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77),
    root = __webpack_require__(46);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77),
    root = __webpack_require__(46);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77),
    root = __webpack_require__(46);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(77),
    root = __webpack_require__(46);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 808 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(233),
    cloneDataView = __webpack_require__(810),
    cloneRegExp = __webpack_require__(811),
    cloneSymbol = __webpack_require__(812),
    cloneTypedArray = __webpack_require__(813);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(233);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 811 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(90);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(233);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(815),
    getPrototype = __webpack_require__(344),
    isPrototype = __webpack_require__(230);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(91);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(817),
    baseUnary = __webpack_require__(228),
    nodeUtil = __webpack_require__(229);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(112),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(819),
    baseUnary = __webpack_require__(228),
    nodeUtil = __webpack_require__(229);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(112),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(90),
    copyArray = __webpack_require__(340),
    getTag = __webpack_require__(112),
    isArrayLike = __webpack_require__(231),
    isString = __webpack_require__(821),
    iteratorToArray = __webpack_require__(822),
    mapToArray = __webpack_require__(348),
    setToArray = __webpack_require__(349),
    stringToArray = __webpack_require__(350),
    values = __webpack_require__(825);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

module.exports = toArray;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(89),
    isArray = __webpack_require__(45),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 822 */
/***/ (function(module, exports) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;


/***/ }),
/* 823 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 824 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(826),
    keys = __webpack_require__(92);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(332);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = void 0;

var _has = _interopRequireDefault(__webpack_require__(88));

var _isSchema = _interopRequireDefault(__webpack_require__(78));

function callOrConcat(schema) {
  if (typeof schema === 'function') return schema;
  return function (base) {
    return base.concat(schema);
  };
}

var Conditional =
/*#__PURE__*/
function () {
  function Conditional(refs, options) {
    var is = options.is,
        then = options.then,
        otherwise = options.otherwise;
    this.refs = [].concat(refs);
    then = callOrConcat(then);
    otherwise = callOrConcat(otherwise);
    if (typeof options === 'function') this.fn = options;else {
      if (!(0, _has.default)(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
      if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
      var isFn = typeof is === 'function' ? is : function () {
        for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
          values[_key] = arguments[_key];
        }

        return values.every(function (value) {
          return value === is;
        });
      };

      this.fn = function () {
        for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          values[_key2] = arguments[_key2];
        }

        var currentSchema = values.pop();
        var option = isFn.apply(void 0, values) ? then : otherwise;
        return option(currentSchema);
      };
    }
  }

  var _proto = Conditional.prototype;

  _proto.getValue = function getValue(parent, context) {
    var values = this.refs.map(function (r) {
      return r.getValue(parent, context);
    });
    return values;
  };

  _proto.resolve = function resolve(ctx, values) {
    var schema = this.fn.apply(ctx, values.concat(ctx));
    if (schema !== undefined && !(0, _isSchema.default)(schema)) throw new TypeError('conditions must return a schema object');
    return schema || ctx;
  };

  return Conditional;
}();

var _default = Conditional;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 828 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = merge;

var _has = _interopRequireDefault(__webpack_require__(88));

var _isSchema = _interopRequireDefault(__webpack_require__(78));

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function merge(target, source) {
  for (var key in source) {
    if ((0, _has.default)(source, key)) {
      var targetVal = target[key],
          sourceVal = source[key];
      if (sourceVal === undefined) continue;

      if ((0, _isSchema.default)(sourceVal)) {
        target[key] = (0, _isSchema.default)(targetVal) ? targetVal.concat(sourceVal) : sourceVal;
      } else if (isObject(sourceVal)) {
        target[key] = isObject(targetVal) ? merge(targetVal, sourceVal) : sourceVal;
      } else if (Array.isArray(sourceVal)) {
        target[key] = Array.isArray(targetVal) ? targetVal.concat(sourceVal) : sourceVal;
      } else target[key] = source[key];
    }
  }

  return target;
}

module.exports = exports["default"];

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = createValidation;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(235));

var _extends2 = _interopRequireDefault(__webpack_require__(110));

var _mapValues = _interopRequireDefault(__webpack_require__(353));

var _ValidationError = _interopRequireDefault(__webpack_require__(236));

var _Reference = _interopRequireDefault(__webpack_require__(114));

var _synchronousPromise = __webpack_require__(352);

var formatError = _ValidationError.default.formatError;

var thenable = function thenable(p) {
  return p && typeof p.then === 'function' && typeof p.catch === 'function';
};

function runTest(testFn, ctx, value, sync) {
  var result = testFn.call(ctx, value);
  if (!sync) return Promise.resolve(result);

  if (thenable(result)) {
    throw new Error("Validation test of type: \"" + ctx.type + "\" returned a Promise during a synchronous validate. " + "This test will finish after the validate call has returned");
  }

  return _synchronousPromise.SynchronousPromise.resolve(result);
}

function resolveParams(oldParams, newParams, resolve) {
  return (0, _mapValues.default)((0, _extends2.default)({}, oldParams, newParams), resolve);
}

function createErrorFactory(_ref) {
  var value = _ref.value,
      label = _ref.label,
      resolve = _ref.resolve,
      originalValue = _ref.originalValue,
      opts = (0, _objectWithoutProperties2.default)(_ref, ["value", "label", "resolve", "originalValue"]);
  return function createError(_temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        _ref2$path = _ref2.path,
        path = _ref2$path === void 0 ? opts.path : _ref2$path,
        _ref2$message = _ref2.message,
        message = _ref2$message === void 0 ? opts.message : _ref2$message,
        _ref2$type = _ref2.type,
        type = _ref2$type === void 0 ? opts.name : _ref2$type,
        params = _ref2.params;

    params = (0, _extends2.default)({
      path: path,
      value: value,
      originalValue: originalValue,
      label: label
    }, resolveParams(opts.params, params, resolve));
    return (0, _extends2.default)(new _ValidationError.default(formatError(message, params), value, path, type), {
      params: params
    });
  };
}

function createValidation(options) {
  var name = options.name,
      message = options.message,
      test = options.test,
      params = options.params;

  function validate(_ref3) {
    var value = _ref3.value,
        path = _ref3.path,
        label = _ref3.label,
        options = _ref3.options,
        originalValue = _ref3.originalValue,
        sync = _ref3.sync,
        rest = (0, _objectWithoutProperties2.default)(_ref3, ["value", "path", "label", "options", "originalValue", "sync"]);
    var parent = options.parent;

    var resolve = function resolve(value) {
      return _Reference.default.isRef(value) ? value.getValue(parent, options.context) : value;
    };

    var createError = createErrorFactory({
      message: message,
      path: path,
      value: value,
      originalValue: originalValue,
      params: params,
      label: label,
      resolve: resolve,
      name: name
    });
    var ctx = (0, _extends2.default)({
      path: path,
      parent: parent,
      type: name,
      createError: createError,
      resolve: resolve,
      options: options
    }, rest);
    return runTest(test, ctx, value, sync).then(function (validOrError) {
      if (_ValidationError.default.isError(validOrError)) throw validOrError;else if (!validOrError) throw createError();
    });
  }

  validate.TEST_NAME = name;
  validate.TEST_FN = test;
  validate.TEST = options;
  return validate;
}

module.exports.createErrorFactory = createErrorFactory;
module.exports = exports["default"];

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(832);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 832 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(834),
    getMatchData = __webpack_require__(843),
    matchesStrictComparable = __webpack_require__(359);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(225),
    baseIsEqual = __webpack_require__(356);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(225),
    equalArrays = __webpack_require__(357),
    equalByTag = __webpack_require__(841),
    equalObjects = __webpack_require__(842),
    getTag = __webpack_require__(112),
    isArray = __webpack_require__(45),
    isBuffer = __webpack_require__(226),
    isTypedArray = __webpack_require__(337);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(221),
    setCacheAdd = __webpack_require__(837),
    setCacheHas = __webpack_require__(838);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 837 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 838 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 839 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 840 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(90),
    Uint8Array = __webpack_require__(347),
    eq = __webpack_require__(222),
    equalArrays = __webpack_require__(357),
    mapToArray = __webpack_require__(348),
    setToArray = __webpack_require__(349);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(345);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(358),
    keys = __webpack_require__(92);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(356),
    get = __webpack_require__(845),
    hasIn = __webpack_require__(846),
    isKey = __webpack_require__(219),
    isStrictComparable = __webpack_require__(358),
    matchesStrictComparable = __webpack_require__(359),
    toKey = __webpack_require__(148);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(360);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(847),
    hasPath = __webpack_require__(327);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 847 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 848 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(850),
    basePropertyDeep = __webpack_require__(851),
    isKey = __webpack_require__(219),
    toKey = __webpack_require__(148);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 850 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(360);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = void 0;

var _inherits = _interopRequireDefault(__webpack_require__(94));

var _mixed = _interopRequireDefault(__webpack_require__(76));

var _default = BooleanSchema;
exports.default = _default;

function BooleanSchema() {
  var _this = this;

  if (!(this instanceof BooleanSchema)) return new BooleanSchema();

  _mixed.default.call(this, {
    type: 'boolean'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (!this.isType(value)) {
        if (/^(true|1)$/i.test(value)) return true;
        if (/^(false|0)$/i.test(value)) return false;
      }

      return value;
    });
  });
}

(0, _inherits.default)(BooleanSchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }
});
module.exports = exports["default"];

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = StringSchema;

var _inherits = _interopRequireDefault(__webpack_require__(94));

var _mixed = _interopRequireDefault(__webpack_require__(76));

var _locale = __webpack_require__(93);

var _isAbsent = _interopRequireDefault(__webpack_require__(113));

// eslint-disable-next-line
var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

var rUrl = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

var hasLength = function hasLength(value) {
  return (0, _isAbsent.default)(value) || value.length > 0;
};

var isTrimmed = function isTrimmed(value) {
  return (0, _isAbsent.default)(value) || value === value.trim();
};

function StringSchema() {
  var _this = this;

  if (!(this instanceof StringSchema)) return new StringSchema();

  _mixed.default.call(this, {
    type: 'string'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      return value != null && value.toString ? value.toString() : value;
    });
  });
}

(0, _inherits.default)(StringSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  },
  required: function required(message) {
    if (message === void 0) {
      message = _locale.mixed.required;
    }

    var next = _mixed.default.prototype.required.call(this, message);

    return next.test({
      message: message,
      name: 'required',
      test: hasLength
    });
  },
  length: function length(_length, message) {
    if (message === void 0) {
      message = _locale.string.length;
    }

    return this.test({
      message: message,
      name: 'length',
      exclusive: true,
      params: {
        length: _length
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length === this.resolve(_length);
      }
    });
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = _locale.string.min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = _locale.string.max;
    }

    return this.test({
      name: 'max',
      exclusive: true,
      message: message,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  matches: function matches(regex, options) {
    var excludeEmptyString = false;
    var message;

    if (options) {
      if (options.message || options.hasOwnProperty('excludeEmptyString')) {
        excludeEmptyString = options.excludeEmptyString;
        message = options.message;
      } else message = options;
    }

    return this.test({
      message: message || _locale.string.matches,
      params: {
        regex: regex
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === '' && excludeEmptyString || regex.test(value);
      }
    });
  },
  email: function email(message) {
    if (message === void 0) {
      message = _locale.string.email;
    }

    return this.matches(rEmail, {
      message: message,
      excludeEmptyString: true
    });
  },
  url: function url(message) {
    if (message === void 0) {
      message = _locale.string.url;
    }

    return this.matches(rUrl, {
      message: message,
      excludeEmptyString: true
    });
  },
  //-- transforms --
  ensure: function ensure() {
    return this.default('').transform(function (val) {
      return val === null ? '' : val;
    });
  },
  trim: function trim(message) {
    if (message === void 0) {
      message = _locale.string.trim;
    }

    return this.transform(function (val) {
      return val != null ? val.trim() : val;
    }).test({
      message: message,
      name: 'trim',
      test: isTrimmed
    });
  },
  lowercase: function lowercase(message) {
    if (message === void 0) {
      message = _locale.string.lowercase;
    }

    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value.toLowerCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === value.toLowerCase();
      }
    });
  },
  uppercase: function uppercase(message) {
    if (message === void 0) {
      message = _locale.string.uppercase;
    }

    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value.toUpperCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === value.toUpperCase();
      }
    });
  }
});
module.exports = exports["default"];

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = NumberSchema;

var _inherits = _interopRequireDefault(__webpack_require__(94));

var _mixed = _interopRequireDefault(__webpack_require__(76));

var _locale = __webpack_require__(93);

var _isAbsent = _interopRequireDefault(__webpack_require__(113));

var isNaN = function isNaN(value) {
  return value != +value;
};

var isInteger = function isInteger(val) {
  return (0, _isAbsent.default)(val) || val === (val | 0);
};

function NumberSchema() {
  var _this = this;

  if (!(this instanceof NumberSchema)) return new NumberSchema();

  _mixed.default.call(this, {
    type: 'number'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      var parsed = parseFloat(value);
      if (this.isType(parsed)) return parsed;
      return NaN;
    });
  });
}

(0, _inherits.default)(NumberSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !isNaN(value);
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = _locale.number.min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = _locale.number.max;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value <= this.resolve(_max);
      }
    });
  },
  lessThan: function lessThan(less, message) {
    if (message === void 0) {
      message = _locale.number.less;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        less: less
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value < this.resolve(less);
      }
    });
  },
  moreThan: function moreThan(more, message) {
    if (message === void 0) {
      message = _locale.number.more;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        more: more
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value > this.resolve(more);
      }
    });
  },
  positive: function positive(msg) {
    if (msg === void 0) {
      msg = _locale.number.positive;
    }

    return this.min(0, msg);
  },
  negative: function negative(msg) {
    if (msg === void 0) {
      msg = _locale.number.negative;
    }

    return this.max(0, msg);
  },
  integer: function integer(message) {
    if (message === void 0) {
      message = _locale.number.integer;
    }

    return this.test({
      name: 'integer',
      message: message,
      test: isInteger
    });
  },
  truncate: function truncate() {
    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value | 0 : value;
    });
  },
  round: function round(method) {
    var avail = ['ceil', 'floor', 'round', 'trunc'];
    method = method && method.toLowerCase() || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? Math[method](value) : value;
    });
  }
});
module.exports = exports["default"];

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = void 0;

var _mixed = _interopRequireDefault(__webpack_require__(76));

var _inherits = _interopRequireDefault(__webpack_require__(94));

var _isodate = _interopRequireDefault(__webpack_require__(856));

var _locale = __webpack_require__(93);

var _isAbsent = _interopRequireDefault(__webpack_require__(113));

var _Reference = _interopRequireDefault(__webpack_require__(114));

var invalidDate = new Date('');

var isDate = function isDate(obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};

var _default = DateSchema;
exports.default = _default;

function DateSchema() {
  var _this = this;

  if (!(this instanceof DateSchema)) return new DateSchema();

  _mixed.default.call(this, {
    type: 'date'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return isDate(value) ? new Date(value) : value;
      value = (0, _isodate.default)(value);
      return value ? new Date(value) : invalidDate;
    });
  });
}

(0, _inherits.default)(DateSchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = _locale.date.min;
    }

    var limit = _min;

    if (!_Reference.default.isRef(limit)) {
      limit = this.cast(_min);
      if (!this._typeCheck(limit)) throw new TypeError('`min` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value >= this.resolve(limit);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = _locale.date.max;
    }

    var limit = _max;

    if (!_Reference.default.isRef(limit)) {
      limit = this.cast(_max);
      if (!this._typeCheck(limit)) throw new TypeError('`max` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value <= this.resolve(limit);
      }
    });
  }
});
module.exports = exports["default"];

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = parseIsoDate;

/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;

function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) {
      struct[k] = +struct[k] || 0;
    } // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}

module.exports = exports["default"];

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(361);

var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = ObjectSchema;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(__webpack_require__(362));

var _extends2 = _interopRequireDefault(__webpack_require__(110));

var _has = _interopRequireDefault(__webpack_require__(88));

var _snakeCase2 = _interopRequireDefault(__webpack_require__(858));

var _camelCase2 = _interopRequireDefault(__webpack_require__(867));

var _mapKeys = _interopRequireDefault(__webpack_require__(873));

var _mapValues = _interopRequireDefault(__webpack_require__(353));

var _propertyExpr = __webpack_require__(152);

var _mixed = _interopRequireDefault(__webpack_require__(76));

var _locale = __webpack_require__(93);

var _sortFields = _interopRequireDefault(__webpack_require__(874));

var _sortByKeyOrder = _interopRequireDefault(__webpack_require__(876));

var _inherits = _interopRequireDefault(__webpack_require__(94));

var _makePath = _interopRequireDefault(__webpack_require__(364));

var _runValidations = _interopRequireWildcard(__webpack_require__(234));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", ".", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", ".", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}

function ObjectSchema(spec) {
  var _this2 = this;

  if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);

  _mixed.default.call(this, {
    type: 'object',
    default: function _default() {
      var _this = this;

      if (!this._nodes.length) return undefined;
      var dft = {};

      this._nodes.forEach(function (key) {
        dft[key] = _this.fields[key].default ? _this.fields[key].default() : undefined;
      });

      return dft;
    }
  });

  this.fields = Object.create(null);
  this._nodes = [];
  this._excludedEdges = [];
  this.withMutation(function () {
    _this2.transform(function coerce(value) {
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (err) {
          value = null;
        }
      }

      if (this.isType(value)) return value;
      return null;
    });

    if (spec) {
      _this2.shape(spec);
    }
  });
}

(0, _inherits.default)(ObjectSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  },
  _cast: function _cast(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _mixed.default.prototype._cast.call(this, _value, options); //should ignore nulls here


    if (value === undefined) return this.default();
    if (!this._typeCheck(value)) return value;
    var fields = this.fields;
    var strip = this._option('stripUnknown', options) === true;

    var props = this._nodes.concat(Object.keys(value).filter(function (v) {
      return _this3._nodes.indexOf(v) === -1;
    }));

    var intermediateValue = {}; // is filled during the transform below

    var innerOptions = (0, _extends2.default)({}, options, {
      parent: intermediateValue,
      __validating: false
    });
    props.forEach(function (prop) {
      var field = fields[prop];
      var exists = (0, _has.default)(value, prop);

      if (field) {
        var fieldValue;
        var strict = field._options && field._options.strict; // safe to mutate since this is fired in sequence

        innerOptions.path = (0, _makePath.default)(_templateObject(), options.path, prop);
        innerOptions.value = value[prop];
        field = field.resolve(innerOptions);
        if (field._strip === true) return;
        fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
      } else if (exists && !strip) intermediateValue[prop] = value[prop];
    });
    return intermediateValue;
  },
  _validate: function _validate(_value, opts) {
    var _this4 = this;

    if (opts === void 0) {
      opts = {};
    }

    var endEarly, recursive;
    var sync = opts.sync;
    var errors = [];
    var originalValue = opts.originalValue != null ? opts.originalValue : _value;
    endEarly = this._option('abortEarly', opts);
    recursive = this._option('recursive', opts);
    opts = (0, _extends2.default)({}, opts, {
      __validating: true,
      originalValue: originalValue
    });
    return _mixed.default.prototype._validate.call(this, _value, opts).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !isObject(value)) {
        // only iterate though actual objects
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;

      var validations = _this4._nodes.map(function (key) {
        var path = (0, _makePath.default)(_templateObject2(), opts.path, key);
        var field = _this4.fields[key];
        var innerOptions = (0, _extends2.default)({}, opts, {
          path: path,
          parent: value,
          originalValue: originalValue[key]
        });

        if (field) {
          // inner fields are always strict:
          // 1. this isn't strict so the casting will also have cast inner values
          // 2. this is strict in which case the nested values weren't cast either
          innerOptions.strict = true;
          if (field.validate) return field.validate(value[key], innerOptions);
        }

        return true;
      });

      return (0, _runValidations.default)({
        sync: sync,
        validations: validations,
        value: value,
        errors: errors,
        endEarly: endEarly,
        path: opts.path,
        sort: (0, _sortByKeyOrder.default)(_this4.fields)
      });
    });
  },
  concat: function concat(schema) {
    var next = _mixed.default.prototype.concat.call(this, schema);

    next._nodes = (0, _sortFields.default)(next.fields, next._excludedEdges);
    return next;
  },
  shape: function shape(schema, excludes) {
    if (excludes === void 0) {
      excludes = [];
    }

    var next = this.clone(),
        fields = (0, _extends2.default)(next.fields, schema);
    next.fields = fields;

    if (excludes.length) {
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      var keys = excludes.map(function (_ref) {
        var first = _ref[0],
            second = _ref[1];
        return first + "-" + second;
      });
      next._excludedEdges = next._excludedEdges.concat(keys);
    }

    next._nodes = (0, _sortFields.default)(fields, next._excludedEdges);
    return next;
  },
  from: function from(_from, to, alias) {
    var fromGetter = (0, _propertyExpr.getter)(_from, true);
    return this.transform(function (obj) {
      var newObj = obj;
      if (obj == null) return obj;

      if ((0, _has.default)(obj, _from)) {
        newObj = (0, _extends2.default)({}, obj);
        if (!alias) delete obj[_from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  },
  noUnknown: function noUnknown(noAllow, message) {
    if (noAllow === void 0) {
      noAllow = true;
    }

    if (message === void 0) {
      message = _locale.object.noUnknown;
    }

    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    var next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test: function test(value) {
        return value == null || !noAllow || unknown(this.schema, value).length === 0;
      }
    });
    if (noAllow) next._options.stripUnknown = true;
    return next;
  },
  transformKeys: function transformKeys(fn) {
    return this.transform(function (obj) {
      return obj && (0, _mapKeys.default)(obj, function (_, key) {
        return fn(key);
      });
    });
  },
  camelCase: function camelCase() {
    return this.transformKeys(_camelCase2.default);
  },
  snakeCase: function snakeCase() {
    return this.transformKeys(_snakeCase2.default);
  },
  constantCase: function constantCase() {
    return this.transformKeys(function (key) {
      return (0, _snakeCase2.default)(key).toUpperCase();
    });
  },
  describe: function describe() {
    var base = _mixed.default.prototype.describe.call(this);

    base.fields = (0, _mapValues.default)(this.fields, function (value) {
      return value.describe();
    });
    return base;
  }
});
module.exports = exports["default"];

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(363);

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;


/***/ }),
/* 859 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(861),
    toString = __webpack_require__(111);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(862);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 862 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(864),
    hasUnicodeWord = __webpack_require__(865),
    toString = __webpack_require__(111),
    unicodeWords = __webpack_require__(866);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 864 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 865 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 866 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var capitalize = __webpack_require__(868),
    createCompounder = __webpack_require__(363);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(111),
    upperFirst = __webpack_require__(869);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(870);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(871),
    hasUnicode = __webpack_require__(351),
    stringToArray = __webpack_require__(350),
    toString = __webpack_require__(111);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(872);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 872 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(149),
    baseForOwn = __webpack_require__(354),
    baseIteratee = __webpack_require__(355);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = sortFields;

var _has = _interopRequireDefault(__webpack_require__(88));

var _toposort = _interopRequireDefault(__webpack_require__(875));

var _propertyExpr = __webpack_require__(152);

var _Reference = _interopRequireDefault(__webpack_require__(114));

var _isSchema = _interopRequireDefault(__webpack_require__(78));

function sortFields(fields, excludes) {
  if (excludes === void 0) {
    excludes = [];
  }

  var edges = [],
      nodes = [];

  function addNode(depPath, key) {
    var node = (0, _propertyExpr.split)(depPath)[0];
    if (!~nodes.indexOf(node)) nodes.push(node);
    if (!~excludes.indexOf(key + "-" + node)) edges.push([key, node]);
  }

  for (var key in fields) {
    if ((0, _has.default)(fields, key)) {
      var value = fields[key];
      if (!~nodes.indexOf(key)) nodes.push(key);
      if (_Reference.default.isRef(value) && !value.isContext) addNode(value.path, key);else if ((0, _isSchema.default)(value) && value._deps) value._deps.forEach(function (path) {
        return addNode(path, key);
      });
    }
  }

  return _toposort.default.array(nodes, edges).reverse();
}

module.exports = exports["default"];

/***/ }),
/* 875 */
/***/ (function(module, exports) {


/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

module.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
}

module.exports.array = toposort

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes)

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  })

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set())
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep
      try {
        nodeRep = ", node was:" + JSON.stringify(node)
      } catch(e) {
        nodeRep = ""
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true

    var outgoing = outgoingEdges.get(node) || new Set()
    outgoing = Array.from(outgoing)

    if (i = outgoing.length) {
      predecessors.add(node)
      do {
        var child = outgoing[--i]
        visit(child, nodesHash.get(child), predecessors)
      } while (i)
      predecessors.delete(node)
    }

    sorted[--cursor] = node
  }
}

function uniqueNodes(arr){
  var res = new Set()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    res.add(edge[0])
    res.add(edge[1])
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    if (!edges.has(edge[0])) edges.set(edge[0], new Set())
    if (!edges.has(edge[1])) edges.set(edge[1], new Set())
    edges.get(edge[0]).add(edge[1])
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i)
  }
  return res
}


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = sortByKeyOrder;

function findIndex(arr, err) {
  var idx = Infinity;
  arr.some(function (key, ii) {
    if (err.path.indexOf(key) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(fields) {
  var keys = Object.keys(fields);
  return function (a, b) {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

module.exports = exports["default"];

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(361);

var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(110));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(__webpack_require__(362));

var _inherits = _interopRequireDefault(__webpack_require__(94));

var _isAbsent = _interopRequireDefault(__webpack_require__(113));

var _isSchema = _interopRequireDefault(__webpack_require__(78));

var _makePath = _interopRequireDefault(__webpack_require__(364));

var _printValue = _interopRequireDefault(__webpack_require__(151));

var _mixed = _interopRequireDefault(__webpack_require__(76));

var _locale = __webpack_require__(93);

var _runValidations = _interopRequireWildcard(__webpack_require__(234));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", "[", "]"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var hasLength = function hasLength(value) {
  return !(0, _isAbsent.default)(value) && value.length > 0;
};

var _default = ArraySchema;
exports.default = _default;

function ArraySchema(type) {
  var _this = this;

  if (!(this instanceof ArraySchema)) return new ArraySchema(type);

  _mixed.default.call(this, {
    type: 'array'
  }); // `undefined` specifically means uninitialized, as opposed to
  // "no subtype"


  this._subType = undefined;
  this.withMutation(function () {
    _this.transform(function (values) {
      if (typeof values === 'string') try {
        values = JSON.parse(values);
      } catch (err) {
        values = null;
      }
      return this.isType(values) ? values : null;
    });

    if (type) _this.of(type);
  });
}

(0, _inherits.default)(ArraySchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    return Array.isArray(v);
  },
  _cast: function _cast(_value, _opts) {
    var _this2 = this;

    var value = _mixed.default.prototype._cast.call(this, _value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this._subType) return value;
    return value.map(function (v) {
      return _this2._subType.cast(v, _opts);
    });
  },
  _validate: function _validate(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var errors = [];
    var sync = options.sync;
    var path = options.path;
    var subType = this._subType;

    var endEarly = this._option('abortEarly', options);

    var recursive = this._option('recursive', options);

    var originalValue = options.originalValue != null ? options.originalValue : _value;
    return _mixed.default.prototype._validate.call(this, _value, options).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !subType || !_this3._typeCheck(value)) {
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;
      var validations = value.map(function (item, idx) {
        var path = (0, _makePath.default)(_templateObject(), options.path, idx); // object._validate note for isStrict explanation

        var innerOptions = (0, _extends2.default)({}, options, {
          path: path,
          strict: true,
          parent: value,
          originalValue: originalValue[idx]
        });
        if (subType.validate) return subType.validate(item, innerOptions);
        return true;
      });
      return (0, _runValidations.default)({
        sync: sync,
        path: path,
        value: value,
        errors: errors,
        endEarly: endEarly,
        validations: validations
      });
    });
  },
  of: function of(schema) {
    var next = this.clone();
    if (schema !== false && !(0, _isSchema.default)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema, or `false` to negate a current sub-schema. ' + 'not: ' + (0, _printValue.default)(schema));
    next._subType = schema;
    return next;
  },
  required: function required(message) {
    if (message === void 0) {
      message = _locale.mixed.required;
    }

    var next = _mixed.default.prototype.required.call(this, message);

    return next.test({
      message: message,
      name: 'required',
      test: hasLength
    });
  },
  min: function min(_min, message) {
    message = message || _locale.array.min;
    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    message = message || _locale.array.max;
    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  ensure: function ensure() {
    return this.default(function () {
      return [];
    }).transform(function (val) {
      return val === null ? [] : [].concat(val);
    });
  },
  compact: function compact(rejector) {
    var reject = !rejector ? function (v) {
      return !!v;
    } : function (v, i, a) {
      return !rejector(v, i, a);
    };
    return this.transform(function (values) {
      return values != null ? values.filter(reject) : values;
    });
  },
  describe: function describe() {
    var base = _mixed.default.prototype.describe.call(this);

    if (this._subType) base.innerType = this._subType.describe();
    return base;
  }
});
module.exports = exports["default"];

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(235));

var _isSchema = _interopRequireDefault(__webpack_require__(78));

var Lazy =
/*#__PURE__*/
function () {
  function Lazy(mapFn) {
    this._resolve = function () {
      var schema = mapFn.apply(void 0, arguments);
      if (!(0, _isSchema.default)(schema)) throw new TypeError('lazy() functions must return a valid schema');
      return schema;
    };
  }

  var _proto = Lazy.prototype;

  _proto.resolve = function resolve(_ref) {
    var value = _ref.value,
        rest = (0, _objectWithoutProperties2.default)(_ref, ["value"]);
    return this._resolve(value, rest);
  };

  _proto.cast = function cast(value, options) {
    return this._resolve(value, options).cast(value, options);
  };

  _proto.validate = function validate(value, options) {
    return this._resolve(value, options).validate(value, options);
  };

  return Lazy;
}();

Lazy.prototype.__isYupSchema__ = true;
var _default = Lazy;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = reach;

var _propertyExpr = __webpack_require__(152);

var _has = _interopRequireDefault(__webpack_require__(88));

var trim = function trim(part) {
  return part.substr(0, part.length - 1).substr(1);
};

function reach(obj, path, value, context) {
  var parent, lastPart; // if only one "value" arg then use it for both

  context = context || value;
  (0, _propertyExpr.forEach)(path, function (_part, isBracket, isArray) {
    var part = isBracket ? trim(_part) : _part;

    if (isArray || (0, _has.default)(obj, '_subType')) {
      // we skipped an array: foo[].bar
      var idx = isArray ? parseInt(part, 10) : 0;
      obj = obj.resolve({
        context: context,
        parent: parent,
        value: value
      })._subType;

      if (value) {
        if (isArray && idx >= value.length) {
          throw new Error("Yup.reach cannot resolve an array item at index: " + _part + ", in the path: " + path + ". " + "because there is no value at that index. ");
        }

        value = value[idx];
      }
    }

    if (!isArray) {
      obj = obj.resolve({
        context: context,
        parent: parent,
        value: value
      });
      if (!(0, _has.default)(obj, 'fields') || !(0, _has.default)(obj.fields, part)) throw new Error("The schema does not contain the path: " + path + ". " + ("(failed at: " + lastPart + " which is a type: \"" + obj._type + "\") "));
      obj = obj.fields[part];
      parent = value;
      value = value && value[part];
      lastPart = isBracket ? '[' + _part + ']' : '.' + _part;
    }
  });

  if (obj) {
    obj = obj.resolve({
      context: context,
      parent: parent,
      value: value
    });
  }

  return obj;
}

module.exports = exports["default"];

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WizardForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formik__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_forms_AccountForm__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_forms_PasswordForm__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_forms_LocationForm__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Button__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_types_onboard__ = __webpack_require__(238);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _typeof(obj){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}function isYupValidationError(err){return _typeof(err)==='object'&&err!==null&&'name'in err&&err.name==='ValidationError'&&'inner'in err&&Array.isArray(err.inner);}function focusFirstInvalidField(errorKeys){if(typeof document==='undefined'||errorKeys.length===0)return;var firstKey=errorKeys.find(function(key){return key!=='_form';});if(!firstKey)return;var el=document.getElementById(firstKey);if(el&&typeof el.focus==='function'){el.focus();}}function FormErrorAlert(_ref){var message=_ref.message;var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var _ref$current;(_ref$current=ref.current)===null||_ref$current===void 0?void 0:_ref$current.focus();},[message]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-alert",role:"alert",tabIndex:-1,ref:ref},message);}function schemaForPage(page,t,authMode){if(authMode==='google'){return __WEBPACK_IMPORTED_MODULE_4_components_forms_LocationForm__["a" /* default */].validationSchema(t);}if(page===0)return __WEBPACK_IMPORTED_MODULE_2_components_forms_AccountForm__["a" /* default */].validationSchema({},t);if(page===1)return __WEBPACK_IMPORTED_MODULE_3_components_forms_PasswordForm__["a" /* default */].validationSchema({},t);return __WEBPACK_IMPORTED_MODULE_4_components_forms_LocationForm__["a" /* default */].validationSchema(t);}function WizardForm(_ref2){var _ref2$initialValues=_ref2.initialValues,initialValues=_ref2$initialValues===void 0?{}:_ref2$initialValues,children=_ref2.children,onSubmit=_ref2.onSubmit,_ref2$checkoutClaim=_ref2.checkoutClaim,checkoutClaim=_ref2$checkoutClaim===void 0?false:_ref2$checkoutClaim,_ref2$authMode=_ref2.authMode,authMode=_ref2$authMode===void 0?'password':_ref2$authMode,_ref2$initialPage=_ref2.initialPage,initialPage=_ref2$initialPage===void 0?0:_ref2$initialPage,onGoogleClick=_ref2.onGoogleClick,_ref2$googleEnabled=_ref2.googleEnabled,googleEnabled=_ref2$googleEnabled===void 0?false:_ref2$googleEnabled,_ref2$googleLoading=_ref2.googleLoading,googleLoading=_ref2$googleLoading===void 0?false:_ref2$googleLoading;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_6_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(initialPage),_useState2=_slicedToArray(_useState,2),page=_useState2[0],setPage=_useState2[1];var stepHeadingRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var stepCount=children.length;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setPage(initialPage);},[initialPage]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var _stepHeadingRef$curre;(_stepHeadingRef$curre=stepHeadingRef.current)===null||_stepHeadingRef$curre===void 0?void 0:_stepHeadingRef$curre.focus();},[page]);var validateForm=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(values,setErrors){var schema=schemaForPage(page,t,authMode);try{schema.validateSync(values,{abortEarly:false});return true;}catch(err){if(!isYupValidationError(err))throw err;var errorList=err.inner.reduce(function(carry,_ref3){var innerPath=_ref3.path,errors=_ref3.errors;return _objectSpread({},carry,{},innerPath?_defineProperty({},innerPath,errors[0]):{});},{});setErrors(errorList);window.setTimeout(function(){return focusFirstInvalidField(Object.keys(errorList));},0);return false;}},[page,t,authMode]);var handleSubmit=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(values,bag){if(!validateForm(values,bag.setErrors))return;var last=page===stepCount-1;if(!last){bag.setSubmitting(false);setPage(function(p){return Math.min(p+1,stepCount-1);});return;}var resetPageIndex=function resetPageIndex(){return setPage(authMode==='google'?stepCount-1:0);};onSubmit(values,bag,resetPageIndex);},[onSubmit,validateForm,stepCount,page,authMode]);var initialValuesMerged=_objectSpread({},__WEBPACK_IMPORTED_MODULE_7_types_onboard__["a" /* DEFAULT_ONBOARD_FORM_VALUES */],{},initialValues);var childProps={errors:undefined,t:t,onGoogleClick:onGoogleClick,googleEnabled:googleEnabled,googleLoading:googleLoading};var childrenFn=function childrenFn(props){return children.map(function(child){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child,_objectSpread({},props));});};var activeChild=function activeChild(props){return childrenFn(props)[page];};var stepLabel=t('forms.stepProgress',{current:String(page+1),total:String(stepCount)});var showBack=page>0&&!(authMode==='google'&&page===stepCount-1);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_formik__["b" /* Formik */],{initialValues:initialValuesMerged,enableReinitialize:true,onSubmit:handleSubmit,validateOnChange:false,validateOnBlur:false,render:function render(_ref5){var errors=_ref5.errors,formikSubmit=_ref5.handleSubmit,isSubmitting=_ref5.isSubmitting;var formError=errors._form;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{className:"gb-onboard-form",onSubmit:formikSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-progress",style:_defineProperty({},'--gb-onboard-steps',String(stepCount))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-progress__track","aria-hidden":"true"},Array.from({length:stepCount},function(_,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{key:index,className:"gb-onboard-progress__seg","data-active":index<=page?'true':'false'});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{ref:stepHeadingRef,className:"gb-onboard-progress__label outline-none","aria-live":"polite",tabIndex:-1},stepLabel)),checkoutClaim?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-onboard-note"},t('forms.checkoutClaimNote')):null,activeChild(_objectSpread({},childProps,{errors:errors})),formError?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormErrorAlert,{message:formError}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-onboard-actions"},showBack?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* default */],{type:"button",value:t('forms.back'),disabled:isSubmitting,className:"gb-onboard-actions__secondary bg-transparent border border-white border-opacity-50 shadow-none text-white text-base font-bold p-15",onClick:function onClick(){return setPage(function(p){return Math.max(0,p-1);});}}):null,page<stepCount-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* default */],{value:t('forms.next'),type:"submit",disabled:isSubmitting,className:"gb-onboard-actions__primary bg-green shadow text-white text-base font-bold p-15"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* default */],{value:isSubmitting?t('forms.creatingAccount'):t('forms.createAccount'),type:"submit",disabled:isSubmitting,className:"gb-onboard-actions__primary bg-green shadow text-white text-base font-bold p-15"})));}});}

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getIdentityBaseUrl */
/* harmony export (immutable) */ __webpack_exports__["b"] = isIdentityConfigured;
/* harmony export (immutable) */ __webpack_exports__["e"] = startGoogleOAuth;
/* harmony export (immutable) */ __webpack_exports__["c"] = parseIdentityHashTokens;
/* harmony export (immutable) */ __webpack_exports__["a"] = identityHashHasError;
/* harmony export (immutable) */ __webpack_exports__["d"] = peekJwtPayload;
/**
 * Netlify Identity helpers for marketing-site Google OAuth.
 * Identity is hosted on the API site: {api}/.netlify/identity
 */var API_URL=(Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SENTRY_DSN":"https://27a1e003a249b09583f1b35346a157be@o4506479248474112.ingest.us.sentry.io/4511757032161280"}).REACT_APP_API_URL||'').replace(/\/$/,'');function getIdentityBaseUrl(){var fromEnv=(Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SENTRY_DSN":"https://27a1e003a249b09583f1b35346a157be@o4506479248474112.ingest.us.sentry.io/4511757032161280"}).REACT_APP_IDENTITY_URL||'').trim().replace(/\/$/,'');if(fromEnv)return fromEnv;if(API_URL)return"".concat(API_URL,"/.netlify/identity");return'https://api.gastrobuddy.nl/.netlify/identity';}function isIdentityConfigured(){return Boolean(getIdentityBaseUrl());}/** Start Google OAuth via API-site Identity (full page navigation). */function startGoogleOAuth(redirectTo){var redirect=encodeURIComponent(redirectTo);var url="".concat(getIdentityBaseUrl(),"/authorize?provider=google&redirect_to=").concat(redirect);window.location.assign(url);}/**
 * Parse GoTrue hash tokens after OAuth redirect.
 * Hash looks like: #access_token=...&refresh_token=...&expires_in=...
 */function parseIdentityHashTokens(hash){var raw=hash.startsWith('#')?hash.slice(1):hash;if(!raw)return null;var params=new URLSearchParams(raw);var access_token=params.get('access_token');if(!access_token)return null;var refresh_token=params.get('refresh_token')||undefined;var expiresRaw=params.get('expires_in');var expires_in=expiresRaw?Number(expiresRaw):undefined;return{access_token:access_token,refresh_token:refresh_token,expires_in:expires_in};}function identityHashHasError(hash){var raw=hash.startsWith('#')?hash.slice(1):hash;if(!raw)return false;var params=new URLSearchParams(raw);return Boolean(params.get('error'));}/** Best-effort decode of JWT payload (no signature verify; server validates). */function peekJwtPayload(accessToken){try{var parts=accessToken.split('.');if(parts.length<2||!parts[1])return null;var json=atob(parts[1].replace(/-/g,'+').replace(/_/g,'/'));return JSON.parse(json);}catch(_unused){return null;}}

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Logo__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_SiteFooter__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_static_images_background_2x_jpg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_static_images_background_2x_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_static_images_background_2x_jpg__);
var NotFoundPage=function NotFoundPage(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_4_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"w-screen min-h-screen flex flex-col bg-white",style:{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_5_static_images_background_2x_jpg___default.a,")"),backgroundSize:'cover'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"w-full p-25"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Logo__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"flex-1 flex justify-center items-center py-50 px-15"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"w-500 max-w-full text-white opacity-90 text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"text-2xl font-bold"},t('notFound.title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mt-25"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{to:"/",className:"text-white no-underline font-bold border-b border-white border-opacity-50"},t('notFound.backHome'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_SiteFooter__["a" /* default */],null));};/* harmony default export */ __webpack_exports__["a"] = (NotFoundPage);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__ = __webpack_require__(6);
var TermsPage=function TermsPage(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__["a" /* default */],{title:t('terms.title')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('terms.intro')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25 opacity-75 text-xs"},t('terms.notice')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('terms.s1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('terms.s1Body')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('terms.s2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('terms.s2Body')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('terms.s3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('terms.s3Body')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('terms.s4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('terms.s4Body')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('terms.s5')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('terms.s5Before'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/privacy"},t('footer.privacy')),t('terms.s5After')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('terms.s6')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('terms.s6Body')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('terms.s7')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('terms.s7Body')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('terms.s8')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('terms.s8Before'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/contact"},t('footer.contact')),' ',t('terms.s8After')));};/* harmony default export */ __webpack_exports__["a"] = (TermsPage);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__ = __webpack_require__(6);
var PrivacyPage=function PrivacyPage(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__["a" /* default */],{title:t('privacy.title')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('privacy.intro')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25 opacity-75 text-xs"},t('privacy.notice')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('privacy.h1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('privacy.p1Before'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/contact"},t('footer.contact')),' ',t('privacy.p1After')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('privacy.h2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('privacy.p2Before'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/cookies"},t('privacy.cookieLink')),t('privacy.p2After')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('privacy.h3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('privacy.p3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('privacy.h4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('privacy.p4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('privacy.h5')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('privacy.p5')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('privacy.h6')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('privacy.p6')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('privacy.h7')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('privacy.p7')));};/* harmony default export */ __webpack_exports__["a"] = (PrivacyPage);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__ = __webpack_require__(6);
var CookiesPage=function CookiesPage(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__["a" /* default */],{title:t('cookies.title')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('cookies.intro')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('cookies.h1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('cookies.p1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('cookies.h2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('cookies.essential')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('cookies.preferences')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('cookies.analytics')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('cookies.h3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('cookies.p3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('cookies.h4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('cookies.p4Before'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/privacy"},t('footer.privacy')),t('cookies.p4After')));};/* harmony default export */ __webpack_exports__["a"] = (CookiesPage);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__ = __webpack_require__(6);
var ContactPage=function ContactPage(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__["a" /* default */],{title:t('contact.title'),lede:t('contact.intro'),variant:"marketing"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mb-15"},t('contact.customers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('contact.customersBody')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mt-40 mb-15"},t('contact.legal')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25"},t('contact.legalBefore'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/privacy"},t('footer.privacy')),' ',t('contact.legalMid'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/terms"},t('footer.terms')),t('contact.legalAfter')));};/* harmony default export */ __webpack_exports__["a"] = (ContactPage);

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_TrustProof__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_i18n_I18nContext__ = __webpack_require__(6);
var ROWS=['progress','cash','recipes','ai','team','paper'];var ComparePage=function ComparePage(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_5_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__["a" /* default */],{title:t('compare.title'),lede:t('compare.intro'),variant:"marketing",wide:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-compare-scroll mb-50"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"gb-compare-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("caption",{className:"sr-only"},t('compare.tableCaption')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col"},t('compare.colTopic')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col"},t('compare.colPaper')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col"},t('compare.colGeneric')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"col"},t('compare.colGastro')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,ROWS.map(function(row){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{scope:"row"},t("compare.rows.".concat(row,".topic"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,t("compare.rows.".concat(row,".paper"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,t("compare.rows.".concat(row,".generic"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"gb-compare-table__highlight"},t("compare.rows.".concat(row,".gastro"))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-35 gb-prose-muted"},t('compare.disclaimer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-resource-cta"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__["a" /* default */],{href:"/onboard",buttonLabel:t('compare.cta'),hint:t('compare.ctaHint')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_TrustProof__["a" /* default */],{className:"mt-25"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mt-35 mb-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/checklist"},t('compare.checklistLink')))));};/* harmony default export */ __webpack_exports__["a"] = (ComparePage);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ChecklistLeadForm__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CtaWithHint__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LegalPageLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_TrustProof__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_i18n_I18nContext__ = __webpack_require__(6);
var OPEN_ITEMS=['o1','o2','o3','o4','o5','o6'];var CLOSE_ITEMS=['c1','c2','c3','c4','c5','c6'];var ChecklistPage=function ChecklistPage(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_6_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LegalPageLayout__["a" /* default */],{title:t('checklist.title'),lede:t('checklist.intro'),variant:"marketing",wide:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-checklist-grid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"gb-checklist-panel","aria-labelledby":"checklist-open-heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{id:"checklist-open-heading",className:"gb-checklist-panel__title"},t('checklist.openTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"gb-checklist"},OPEN_ITEMS.map(function(key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:key},t("checklist.open.".concat(key)));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"gb-checklist-panel","aria-labelledby":"checklist-close-heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{id:"checklist-close-heading",className:"gb-checklist-panel__title"},t('checklist.closeTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"gb-checklist"},CLOSE_ITEMS.map(function(key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:key},t("checklist.close.".concat(key)));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-50 gb-prose-muted"},t('checklist.adaptNote')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"mb-50","aria-labelledby":"checklist-lead-heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{id:"checklist-lead-heading",className:"text-lg font-bold mb-20"},t('checklist.formTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ChecklistLeadForm__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-resource-cta"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mb-20"},t('checklist.nextTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25 gb-prose-muted"},t('checklist.nextBody')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CtaWithHint__["a" /* default */],{href:"/onboard",buttonLabel:t('checklist.cta'),hint:t('checklist.ctaHint')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_TrustProof__["a" /* default */],{className:"mt-25"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mt-35 mb-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/compare"},t('checklist.compareLink')))));};/* harmony default export */ __webpack_exports__["a"] = (ChecklistPage);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Button__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_trackEvent__ = __webpack_require__(87);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function isValidEmail(value){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);}var ChecklistLeadForm=function ChecklistLeadForm(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t,locale=_useI18n.locale;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('idle'),_useState2=_slicedToArray(_useState,2),status=_useState2[0],setStatus=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),emailError=_useState4[0],setEmailError=_useState4[1];var handleSubmit=/*#__PURE__*/function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(event){var form,data,email,business,website,emailInput,_emailInput,res,payload;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();form=event.currentTarget;data=new FormData(form);email=String(data.get('email')||'').trim();business=String(data.get('business')||'').trim();website=String(data.get('website')||'');if(email){_context.next=12;break;}setEmailError(t('checklist.formEmailRequired'));Object(__WEBPACK_IMPORTED_MODULE_4_utils_trackEvent__["a" /* default */])('checklist_lead_validation',{reason:'empty',locale:locale});emailInput=form.querySelector('#checklist-email');emailInput===null||emailInput===void 0?void 0:emailInput.focus();return _context.abrupt("return");case 12:if(isValidEmail(email)){_context.next=18;break;}setEmailError(t('checklist.formEmailInvalid'));Object(__WEBPACK_IMPORTED_MODULE_4_utils_trackEvent__["a" /* default */])('checklist_lead_validation',{reason:'invalid',locale:locale});_emailInput=form.querySelector('#checklist-email');_emailInput===null||_emailInput===void 0?void 0:_emailInput.focus();return _context.abrupt("return");case 18:setEmailError(null);setStatus('submitting');_context.prev=20;_context.next=23;return fetch('/api/email/checklist-lead',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:email,business:business,locale:locale,website:website})});case 23:res=_context.sent;_context.next=26;return res.json()["catch"](function(){return{};});case 26:payload=_context.sent;if(res.ok){_context.next=29;break;}throw new Error(payload.error||"Request failed: ".concat(res.status));case 29:setStatus('success');form.reset();Object(__WEBPACK_IMPORTED_MODULE_4_utils_trackEvent__["a" /* default */])('checklist_lead_success',{locale:locale,hasBusiness:Boolean(business)});_context.next=38;break;case 34:_context.prev=34;_context.t0=_context["catch"](20);setStatus('error');Object(__WEBPACK_IMPORTED_MODULE_4_utils_trackEvent__["a" /* default */])('checklist_lead_error',{locale:locale});case 38:case"end":return _context.stop();}}},_callee,null,[[20,34]]);}));return function handleSubmit(_x){return _ref.apply(this,arguments);};}();if(status==='success'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-lead-form gb-lead-form--success",role:"status"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"m-0 font-bold"},t('checklist.formSuccessTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mt-10 mb-0 gb-prose-muted"},t('checklist.formSuccessBody')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{className:"gb-lead-form",onSubmit:handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-honeypot","aria-hidden":"true"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"website",type:"text",tabIndex:-1,autoComplete:"off",defaultValue:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-25 gb-prose-muted"},t('checklist.formIntro')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mb-20 flex flex-col"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"checklist-email",className:"text-sm font-normal mb-5"},t('checklist.formEmail')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:"checklist-email",name:"email",type:"email",required:true,autoComplete:"email",inputMode:"email",className:"gb-lead-input",disabled:status==='submitting',"aria-invalid":emailError?true:undefined,"aria-describedby":emailError?'checklist-email-error':undefined,onChange:function onChange(){if(emailError)setEmailError(null);}}),emailError?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{id:"checklist-email-error",className:"text-red text-sm mt-10 mb-0",role:"alert"},emailError):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mb-25 flex flex-col"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"checklist-business",className:"text-sm font-normal mb-5"},t('checklist.formBusiness')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:"checklist-business",name:"business",type:"text",autoComplete:"organization",className:"gb-lead-input",disabled:status==='submitting'})),status==='error'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-red text-sm mb-20",role:"alert"},t('checklist.formError')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Button__["a" /* default */],{type:"submit",disabled:status==='submitting',value:status==='submitting'?t('checklist.formSubmitting'):t('checklist.formSubmit')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mt-15 mb-0 text-xs gb-prose-muted"},t('checklist.formPrivacyBefore'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold",to:"/privacy"},t('footer.privacy')),t('checklist.formPrivacyAfter')));};/* harmony default export */ __webpack_exports__["a"] = (ChecklistLeadForm);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18n_I18nContext__ = __webpack_require__(6);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter){if(Symbol.iterator in Object(iter)||Object.prototype.toString.call(iter)==="[object Arguments]")return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return;}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}var API_URL=(Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SENTRY_DSN":"https://27a1e003a249b09583f1b35346a157be@o4506479248474112.ingest.us.sentry.io/4511757032161280"}).REACT_APP_API_URL||'').replace(/\/$/,'');var TIERS=[{id:'starter',eur:19,staffKey:'staffStarter'},{id:'pro',eur:49,staffKey:'staffPro'},{id:'enterprise',eur:99,staffKey:'staffEnterprise'}];var MODULES=[{id:'module_cashregister',eur:15,labelKey:'modCash'},{id:'module_timesheet',eur:15,labelKey:'modTimesheet'},{id:'module_reservations',eur:15,labelKey:'modReservations'},{id:'module_mep',eur:10,labelKey:'modMep'},{id:'module_facility',eur:10,labelKey:'modFacility'}];function formatEur(amount,locale){try{return new Intl.NumberFormat(locale==='nl'?'nl-NL':'en-NL',{style:'currency',currency:'EUR',maximumFractionDigits:0}).format(amount);}catch(_unused){return"\u20AC".concat(amount);}}var PricingPage=function PricingPage(_ref){var location=_ref.location;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_4_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t,locale=_useI18n.locale;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('pro'),_useState2=_slicedToArray(_useState,2),tier=_useState2[0],setTier=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState4=_slicedToArray(_useState3,2),modules=_useState4[0],setModules=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),checkoutLoading=_useState6[0],setCheckoutLoading=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),checkoutError=_useState8[0],setCheckoutError=_useState8[1];var cancelled=/[?&]checkout=cancel(?:&|$)/.test(location.search||'');var selectedTier=TIERS.find(function(row){return row.id===tier;})||TIERS[1];var moduleTotal=modules.reduce(function(sum,id){var row=MODULES.find(function(m){return m.id===id;});return sum+(row?row.eur:0);},0);var monthlyTotal=selectedTier.eur+moduleTotal;var lineItems=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var items=[{key:"tier-".concat(tier),label:t("pricing.tiers.".concat(tier,".name")),amount:selectedTier.eur}];modules.forEach(function(id){var row=MODULES.find(function(m){return m.id===id;});if(!row)return;items.push({key:id,label:t("pricing.modules.".concat(row.labelKey)),amount:row.eur});});return items;},[tier,modules,selectedTier.eur,t]);var toggleModule=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(id){setModules(function(prev){return prev.includes(id)?prev.filter(function(m){return m!==id;}):[].concat(_toConsumableArray(prev),[id]);});setCheckoutError(null);},[]);var startCheckout=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var res,data;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(API_URL){_context.next=3;break;}setCheckoutError(t('pricing.errors.apiMissing'));return _context.abrupt("return");case 3:setCheckoutLoading(true);setCheckoutError(null);_context.prev=5;_context.next=8;return fetch("".concat(API_URL,"/api/billing/marketing-checkout"),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({tier:tier,modules:modules,locale:locale})});case 8:res=_context.sent;_context.next=11;return res.json()["catch"](function(){return{};});case 11:data=_context.sent;if(!(!res.ok||!data.url)){_context.next=16;break;}setCheckoutError(data.error||t('pricing.errors.checkoutFailed'));setCheckoutLoading(false);return _context.abrupt("return");case 16:window.location.assign(data.url);_context.next=23;break;case 19:_context.prev=19;_context.t0=_context["catch"](5);setCheckoutError(t('pricing.errors.network'));setCheckoutLoading(false);case 23:case"end":return _context.stop();}}},_callee,null,[[5,19]]);})),[tier,modules,locale,t]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__["a" /* default */],{title:t('pricing.title'),lede:t('pricing.intro'),variant:"marketing",wide:true,extraWide:true},cancelled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-pricing-banner",role:"status"},t('pricing.cancelled')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-pricing"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-pricing__config"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"gb-pricing__section","aria-labelledby":"pricing-tiers-heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{id:"pricing-tiers-heading",className:"gb-pricing__heading"},t('pricing.tiersHeading')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-pricing__hint"},t('pricing.tiersHint')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-pricing__tiers",role:"radiogroup","aria-labelledby":"pricing-tiers-heading"},TIERS.map(function(row){var selected=tier===row.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{key:row.id,type:"button",role:"radio","aria-checked":selected,className:"gb-pricing__tier".concat(selected?' is-selected':''),onClick:function onClick(){setTier(row.id);setCheckoutError(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-pricing__tier-name"},t("pricing.tiers.".concat(row.id,".name"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-pricing__tier-price"},formatEur(row.eur,locale),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-pricing__per"},t('pricing.perMonth'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-pricing__tier-staff"},t("pricing.".concat(row.staffKey))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"gb-pricing__section","aria-labelledby":"pricing-modules-heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{id:"pricing-modules-heading",className:"gb-pricing__heading"},t('pricing.modulesHeading')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-pricing__hint"},t('pricing.modulesHint')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-pricing__included"},t('pricing.included')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"gb-pricing__modules"},MODULES.map(function(row){var checked=modules.includes(row.id);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:row.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"gb-pricing__module".concat(checked?' is-selected':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",checked:checked,onChange:function onChange(){return toggleModule(row.id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-pricing__module-label"},t("pricing.modules.".concat(row.labelKey))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-pricing__module-price"},formatEur(row.eur,locale),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-pricing__per"},t('pricing.perLocationMonth')))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside",{className:"gb-pricing__summary","aria-labelledby":"pricing-summary-heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{id:"pricing-summary-heading",className:"gb-pricing__heading"},t('pricing.summaryHeading')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"gb-pricing__lines"},lineItems.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:item.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,item.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,formatEur(item.amount,locale)));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-pricing__total"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,t('pricing.total')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,formatEur(monthlyTotal,locale),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-pricing__per"},t('pricing.perMonth')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-pricing__summary-note"},t('pricing.summaryNote')),checkoutError?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-pricing__error",role:"alert"},checkoutError):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"gb-btn bg-green shadow text-white text-lg font-bold px-25 py-20 rounded-lg gb-pricing__checkout",onClick:startCheckout,disabled:checkoutLoading},checkoutLoading?t('pricing.checkoutLoading'):t('pricing.checkoutCta')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-pricing__trial"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/onboard"},t('pricing.trialCta'))),tier==='enterprise'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-pricing__contact"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/contact"},t('pricing.enterpriseContact'))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-pricing-footnote"},t('pricing.footnote')));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* withRouter */])(PricingPage));

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_TrustProof__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_content_marketingRoutes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_trackEvent__ = __webpack_require__(87);
var VerticalsIndexPage=function VerticalsIndexPage(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_6_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t,locale=_useI18n.locale;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__["a" /* default */],{title:t('verticals.indexTitle'),lede:t('verticals.indexIntro'),variant:"marketing",wide:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-venue-layout"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-venue-layout__list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-venue-layout__eyebrow m-0"},t('verticals.pickLabel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"gb-venue-list"},__WEBPACK_IMPORTED_MODULE_5_content_marketingRoutes__["b" /* VERTICAL_SLUGS */].map(function(slug,index){var n=String(index+1).padStart(2,'0');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"gb-venue-row",to:"/for/".concat(slug),onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_7_utils_trackEvent__["a" /* default */])('venue_select',{slug:slug,locale:locale,position:index+1});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-venue-row__index","aria-hidden":true},n),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-venue-row__copy"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-venue-row__label"},t("verticals.".concat(slug,".label"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-venue-row__body"},t("verticals.".concat(slug,".intro")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-venue-row__go","aria-hidden":true},"\u2192")));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside",{className:"gb-venue-layout__aside"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-venue-aside"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__["a" /* default */],{href:"/onboard",buttonLabel:t('verticals.cta'),hint:t('verticals.ctaHint'),trackProps:{source:'for_index'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_TrustProof__["a" /* default */],{className:"mt-25"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mt-35 mb-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"gb-venue-aside__link",to:"/guides"},t('verticals.seeGuides')))))));};/* harmony default export */ __webpack_exports__["a"] = (VerticalsIndexPage);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_TrustProof__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_content_marketingRoutes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_i18n_I18nContext__ = __webpack_require__(6);
var PAIN_KEYS=['p1','p2','p3','p4'];var FIT_KEYS=['f1','f2','f3','f4'];var VerticalPage=function VerticalPage(_ref){var slug=_ref.slug;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_6_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;var prefix="verticals.".concat(slug);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__["a" /* default */],{title:t("".concat(prefix,".title")),lede:t("".concat(prefix,".intro")),variant:"marketing",wide:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-vertical-split"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"gb-vertical-panel","aria-labelledby":"vertical-pains-heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{id:"vertical-pains-heading",className:"gb-vertical-panel__title"},t("".concat(prefix,".painsTitle"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"gb-vertical-points"},PAIN_KEYS.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-vertical-points__n","aria-hidden":true},String(index+1).padStart(2,'0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,t("".concat(prefix,".pains.").concat(key))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"gb-vertical-panel gb-vertical-panel--fit","aria-labelledby":"vertical-fits-heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{id:"vertical-fits-heading",className:"gb-vertical-panel__title"},t("".concat(prefix,".fitsTitle"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"gb-vertical-points"},FIT_KEYS.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-vertical-points__n","aria-hidden":true},String(index+1).padStart(2,'0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,t("".concat(prefix,".fits.").concat(key))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-resource-cta gb-vertical-cta"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__["a" /* default */],{href:"/onboard",buttonLabel:t('verticals.cta'),hint:t('verticals.ctaHint')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_TrustProof__["a" /* default */],{className:"mt-25"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav",{className:"gb-vertical-more","aria-label":t('verticals.otherVerticals')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-vertical-more__block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"gb-vertical-more__title"},t('verticals.otherVerticals')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"gb-vertical-more__list"},__WEBPACK_IMPORTED_MODULE_5_content_marketingRoutes__["b" /* VERTICAL_SLUGS */].filter(function(item){return item!==slug;}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"gb-vertical-more__link",to:"/for/".concat(item)},t("verticals.".concat(item,".label"))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-vertical-more__block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"gb-vertical-more__title"},t('guides.otherGuides')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"gb-vertical-more__list"},__WEBPACK_IMPORTED_MODULE_5_content_marketingRoutes__["a" /* GUIDE_SLUGS */].slice(0,3).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"gb-vertical-more__link",to:"/guides/".concat(item)},t("guides.".concat(item,".title"))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-vertical-more__meta"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"gb-vertical-more__link",to:"/guides"},t('verticals.seeGuides')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-vertical-more__dot","aria-hidden":true},"\xB7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"gb-vertical-more__link",to:"/compare"},t('verticals.seeCompare'))))));};/* harmony default export */ __webpack_exports__["a"] = (VerticalPage);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_TrustProof__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_content_marketingRoutes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_i18n_I18nContext__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_trackEvent__ = __webpack_require__(87);
var GuidesIndexPage=function GuidesIndexPage(){var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_6_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t,locale=_useI18n.locale;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__["a" /* default */],{title:t('guides.indexTitle'),lede:t('guides.indexIntro'),variant:"marketing",wide:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-venue-layout"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-venue-layout__list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"gb-venue-layout__eyebrow m-0"},t('guides.pickLabel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"gb-venue-list"},__WEBPACK_IMPORTED_MODULE_5_content_marketingRoutes__["a" /* GUIDE_SLUGS */].map(function(slug,index){var n=String(index+1).padStart(2,'0');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:slug},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"gb-venue-row",to:"/guides/".concat(slug),onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_7_utils_trackEvent__["a" /* default */])('guide_select',{slug:slug,locale:locale,position:index+1});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-venue-row__index","aria-hidden":true},n),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-venue-row__copy"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-venue-row__label"},t("guides.".concat(slug,".title"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-venue-row__meta"},t('guides.readTime',{minutes:t("guides.".concat(slug,".minutes"))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-venue-row__body"},t("guides.".concat(slug,".intro")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"gb-venue-row__go","aria-hidden":true},"\u2192")));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside",{className:"gb-venue-layout__aside"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-venue-aside"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__["a" /* default */],{href:"/onboard",buttonLabel:t('guides.cta'),hint:t('guides.ctaHint'),trackProps:{source:'guides_index'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_TrustProof__["a" /* default */],{className:"mt-25"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mt-35 mb-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"gb-venue-aside__link",to:"/for"},t('guides.seeVerticals')))))));};/* harmony default export */ __webpack_exports__["a"] = (GuidesIndexPage);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_TrustProof__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_content_marketingRoutes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_i18n_I18nContext__ = __webpack_require__(6);
var SECTION_NUMS=['1','2','3','4','5'];var GuidePage=function GuidePage(_ref){var slug=_ref.slug;var _useI18n=Object(__WEBPACK_IMPORTED_MODULE_6_i18n_I18nContext__["b" /* useI18n */])(),t=_useI18n.t;var prefix="guides.".concat(slug);var minutes=t("".concat(prefix,".minutes"));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_LegalPageLayout__["a" /* default */],{title:t("".concat(prefix,".title")),lede:t("".concat(prefix,".intro")),variant:"marketing",wide:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-35 text-sm gb-prose-muted"},t('guides.readTime',{minutes:minutes})),SECTION_NUMS.map(function(n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{key:n,className:"mb-35"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mb-10"},t("".concat(prefix,".sections.s").concat(n,"Title"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"m-0 gb-prose-muted"},t("".concat(prefix,".sections.s").concat(n,"Body"))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-40 gb-guide-tip"},t("".concat(prefix,".tip"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gb-resource-cta mb-50"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CtaWithHint__["a" /* default */],{href:"/onboard",buttonLabel:t('guides.cta'),hint:t('guides.ctaHint')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_TrustProof__["a" /* default */],{className:"mt-25"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-15"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/checklist"},t('guides.seeChecklist'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mb-40"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/for"},t('guides.seeVerticals'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"text-lg font-bold mb-15"},t('guides.otherGuides')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"gb-link-list"},__WEBPACK_IMPORTED_MODULE_5_content_marketingRoutes__["a" /* GUIDE_SLUGS */].filter(function(item){return item!==slug;}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_LocalizedLink__["a" /* default */],{className:"text-green font-bold no-underline",to:"/guides/".concat(item)},t("guides.".concat(item,".title"))));})));};/* harmony default export */ __webpack_exports__["a"] = (GuidePage);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildHomeJsonLd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18n_localePath__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_messages_en__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_messages_nl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__site__ = __webpack_require__(370);
var JSON_LD_COPY={en:__WEBPACK_IMPORTED_MODULE_1_i18n_messages_en__["a" /* default */].jsonLd,nl:__WEBPACK_IMPORTED_MODULE_2_i18n_messages_nl__["a" /* default */].jsonLd};/**
 * @param opts - ogImageUrl for schema.org image/screenshot
 * @returns schema.org graph for the marketing homepage
 */function buildHomeJsonLd(_ref){var ogImageUrl=_ref.ogImageUrl,locale=_ref.locale;var origin=Object(__WEBPACK_IMPORTED_MODULE_3__site__["c" /* getSiteOrigin */])();var homePath=Object(__WEBPACK_IMPORTED_MODULE_0_i18n_localePath__["b" /* withLocalePrefix */])(locale,'/');var homeUrl="".concat(origin).concat(homePath==='/'?'/':homePath);var copy=JSON_LD_COPY[locale];var orgId="".concat(origin,"/#organization");var siteId="".concat(origin,"/#website");var langTag=locale==='nl'?'nl':'en';return{'@context':'https://schema.org','@graph':[{'@type':'Organization','@id':orgId,name:'GastroBuddy',url:homeUrl,description:copy.orgDescription,logo:{'@type':'ImageObject',url:ogImageUrl},sameAs:[__WEBPACK_IMPORTED_MODULE_3__site__["a" /* APP_STORE_URL */],__WEBPACK_IMPORTED_MODULE_3__site__["b" /* PLAY_STORE_URL */]]},{'@type':'WebSite','@id':siteId,url:homeUrl,name:'GastroBuddy',description:copy.siteDescription,publisher:{'@id':orgId},inLanguage:langTag},{'@type':'SoftwareApplication',name:'GastroBuddy',applicationCategory:'BusinessApplication',operatingSystem:'iOS, Android',offers:{'@type':'Offer',price:'0',priceCurrency:'EUR',description:'Free trial period; subscription for full modules.'},downloadUrl:[__WEBPACK_IMPORTED_MODULE_3__site__["a" /* APP_STORE_URL */],__WEBPACK_IMPORTED_MODULE_3__site__["b" /* PLAY_STORE_URL */]],screenshot:ogImageUrl}]};}

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildDocumentMetaProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_content_marketingRoutes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_localePath__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_messages_en__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_messages_nl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__absoluteUrl__ = __webpack_require__(369);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var META={en:__WEBPACK_IMPORTED_MODULE_2_i18n_messages_en__["a" /* default */].meta,nl:__WEBPACK_IMPORTED_MODULE_3_i18n_messages_nl__["a" /* default */].meta};var MESSAGES={en:__WEBPACK_IMPORTED_MODULE_2_i18n_messages_en__["a" /* default */],nl:__WEBPACK_IMPORTED_MODULE_3_i18n_messages_nl__["a" /* default */]};function normalizePath(pathname){var p=pathname||'/';var q=p.indexOf('?');if(q!==-1)p=p.substring(0,q);if(p.length>1&&p.endsWith('/'))p=p.slice(0,-1);return p||'/';}function getRouteMeta(locale,path){var m=META[locale];var messages=MESSAGES[locale];var map={'/':m.home,'/onboard':m.onboard,'/terms':m.terms,'/privacy':m.privacy,'/cookies':m.cookies,'/contact':m.contact,'/compare':m.compare,'/checklist':m.checklist,'/pricing':m.pricing,'/for':m.forIndex,'/guides':m.guidesIndex};if(map[path])return map[path];if(path.startsWith('/for/')){var slug=path.slice('/for/'.length);if(Object(__WEBPACK_IMPORTED_MODULE_0_content_marketingRoutes__["d" /* isVerticalSlug */])(slug)){var vertical=messages.verticals[slug];return{title:vertical.metaTitle,description:vertical.metaDescription};}}if(path.startsWith('/guides/')){var _slug=path.slice('/guides/'.length);if(Object(__WEBPACK_IMPORTED_MODULE_0_content_marketingRoutes__["c" /* isGuideSlug */])(_slug)){var guide=messages.guides[_slug];return{title:guide.metaTitle,description:guide.metaDescription};}}return undefined;}function buildDocumentMetaProps(_ref){var pathname=_ref.pathname,ogImageUrl=_ref.ogImageUrl,locale=_ref.locale;var path=normalizePath(pathname);var canonicalPath=Object(__WEBPACK_IMPORTED_MODULE_1_i18n_localePath__["b" /* withLocalePrefix */])(locale,path);var canonical=Object(__WEBPACK_IMPORTED_MODULE_4__absoluteUrl__["a" /* default */])(canonicalPath==='/'?'/':canonicalPath);var route=getRouteMeta(locale,path);var notFound=META[locale].notFound;if(!route){return{title:notFound.title,description:notFound.description,canonical:canonical,meta:{name:{robots:'noindex, nofollow',description:notFound.description}},auto:{}};}var title=route.title,description=route.description;var ogLocale=locale==='nl'?'nl_NL':'en_NL';return{title:title,description:description,canonical:canonical,meta:{name:_objectSpread({description:description,keywords:'GastroBuddy, restaurant app, hospitality software, AI assistant, checklists, HACCP, cash register, recipes, mise en place, staff scheduling, Netherlands','twitter:card':'summary_large_image','twitter:title':title,'twitter:description':description},ogImageUrl?{'twitter:image':ogImageUrl}:{}),property:_objectSpread({'og:type':'website','og:site_name':'GastroBuddy','og:title':title,'og:description':description,'og:url':canonical,'og:locale':ogLocale},ogImageUrl?{'og:image':ogImageUrl,'og:image:alt':'GastroBuddy — hospitality operations for restaurants and bars'}:{})},auto:{ograph:true}};}

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
/* eslint-disable */// In production, we register a service worker to serve assets from local cache.
var isLocalhost=Boolean(window.location.hostname==='localhost'||window.location.hostname==='[::1]'||window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){var publicUrl=new URL(""||'',window.location.href);if(publicUrl.origin!==window.location.origin){return;}window.addEventListener('load',function(){var swUrl="".concat("","/service-worker.js");if(isLocalhost){checkValidServiceWorker(swUrl);navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;if(!installingWorker)return;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){console.log('New content is available; please refresh.');}else{console.log('Content is cached for offline use.');}}};};})["catch"](function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){fetch(swUrl).then(function(response){var contentType=response.headers.get('content-type');var isJs=contentType!=null&&contentType.indexOf('javascript')!==-1;if(response.status===404||!isJs){navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{registerValidSW(swUrl);}})["catch"](function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.0b3e69f8.js